// tslint:disable
/**
 * Milk Service API
 * Milk Service API 
 *
 * The version of the OpenAPI document: 1.4.0
 * Contact: digital@levno.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * 
     * @type {number}
     * @memberof Address
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof Address
     */
    ownerId?: number;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    ownerType?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    line1?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    line2?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    region?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    postCode?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    fullAdr?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    rawAddress?: string;
}
/**
 * 
 * @export
 * @interface AddressesInData
 */
export interface AddressesInData {
    /**
     * 
     * @type {Array<Address>}
     * @memberof AddressesInData
     */
    data?: Array<Address>;
}
/**
 * 
 * @export
 * @interface Alert
 */
export interface Alert {
    /**
     * 
     * @type {number}
     * @memberof Alert
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof Alert
     */
    productId?: number;
    /**
     * 
     * @type {string}
     * @memberof Alert
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof Alert
     */
    orgId?: number;
    /**
     * 
     * @type {string}
     * @memberof Alert
     */
    channel?: string;
    /**
     * 
     * @type {number}
     * @memberof Alert
     */
    tankId?: number;
    /**
     * 
     * @type {Array<AlertSubscriber>}
     * @memberof Alert
     */
    subscribers?: Array<AlertSubscriber>;
}
/**
 * 
 * @export
 * @interface AlertInData
 */
export interface AlertInData {
    /**
     * 
     * @type {Alert}
     * @memberof AlertInData
     */
    data?: Alert;
}
/**
 * 
 * @export
 * @interface AlertSubscriber
 */
export interface AlertSubscriber {
    /**
     * 
     * @type {number}
     * @memberof AlertSubscriber
     */
    userId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AlertSubscriber
     */
    sms?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AlertSubscriber
     */
    email?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AlertSubscriber
     */
    parameters?: string;
}
/**
 * 
 * @export
 * @interface AlertSummaryUserPreferencesFeed
 */
export interface AlertSummaryUserPreferencesFeed {
    /**
     * 
     * @type {number}
     * @memberof AlertSummaryUserPreferencesFeed
     */
    partnerId?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AlertSummaryUserPreferencesFeed
     */
    fixedSchedule?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof AlertSummaryUserPreferencesFeed
     */
    periodSchedule?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AlertSummaryUserPreferencesFeed
     */
    lastRunTs?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof AlertSummaryUserPreferencesFeed
     */
    onlySendNew?: boolean;
    /**
     * 
     * @type {AlertSummaryUserPreferencesFeedCustomFilter}
     * @memberof AlertSummaryUserPreferencesFeed
     */
    customFilter?: AlertSummaryUserPreferencesFeedCustomFilter;
    /**
     * 
     * @type {AlertSummaryUserPreferencesFeedCustomFields}
     * @memberof AlertSummaryUserPreferencesFeed
     */
    customFields?: AlertSummaryUserPreferencesFeedCustomFields;
}
/**
 * 
 * @export
 * @interface AlertSummaryUserPreferencesFeedCustomFields
 */
export interface AlertSummaryUserPreferencesFeedCustomFields {
    /**
     * 
     * @type {Array<string>}
     * @memberof AlertSummaryUserPreferencesFeedCustomFields
     */
    feed_tanks?: Array<string>;
}
/**
 * 
 * @export
 * @interface AlertSummaryUserPreferencesFeedCustomFilter
 */
export interface AlertSummaryUserPreferencesFeedCustomFilter {
    /**
     * 
     * @type {Array<string>}
     * @memberof AlertSummaryUserPreferencesFeedCustomFilter
     */
    type?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AlertSummaryUserPreferencesFeedCustomFilter
     */
    volumeRange?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AlertSummaryUserPreferencesFeedCustomFilter
     */
    capacityRange?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AlertSummaryUserPreferencesFeedCustomFilter
     */
    ullageRange?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AlertSummaryUserPreferencesFeedCustomFilter
     */
    weightRange?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AlertSummaryUserPreferencesFeedCustomFilter
     */
    weightCapacityRange?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AlertSummaryUserPreferencesFeedCustomFilter
     */
    customSiteFilters?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AlertSummaryUserPreferencesFeedCustomFilter
     */
    customFeedTankFilters?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof AlertSummaryUserPreferencesFeedCustomFilter
     */
    onlyFaults?: boolean;
}
/**
 * 
 * @export
 * @interface AlertSummaryUserPreferencesFuel
 */
export interface AlertSummaryUserPreferencesFuel {
    /**
     * 
     * @type {number}
     * @memberof AlertSummaryUserPreferencesFuel
     */
    partnerId?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AlertSummaryUserPreferencesFuel
     */
    fixedSchedule?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof AlertSummaryUserPreferencesFuel
     */
    periodSchedule?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AlertSummaryUserPreferencesFuel
     */
    lastRunTs?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof AlertSummaryUserPreferencesFuel
     */
    onlySendNew?: boolean;
    /**
     * 
     * @type {AlertSummaryUserPreferencesFuelCustomFilter}
     * @memberof AlertSummaryUserPreferencesFuel
     */
    customFilter?: AlertSummaryUserPreferencesFuelCustomFilter;
    /**
     * 
     * @type {AlertSummaryUserPreferencesFuelCustomFields}
     * @memberof AlertSummaryUserPreferencesFuel
     */
    customFields?: AlertSummaryUserPreferencesFuelCustomFields;
}
/**
 * 
 * @export
 * @interface AlertSummaryUserPreferencesFuelCustomFields
 */
export interface AlertSummaryUserPreferencesFuelCustomFields {
    /**
     * 
     * @type {Array<string>}
     * @memberof AlertSummaryUserPreferencesFuelCustomFields
     */
    tanks?: Array<string>;
}
/**
 * 
 * @export
 * @interface AlertSummaryUserPreferencesFuelCustomFilter
 */
export interface AlertSummaryUserPreferencesFuelCustomFilter {
    /**
     * 
     * @type {Array<string>}
     * @memberof AlertSummaryUserPreferencesFuelCustomFilter
     */
    type?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AlertSummaryUserPreferencesFuelCustomFilter
     */
    volumeRange?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AlertSummaryUserPreferencesFuelCustomFilter
     */
    capacityRange?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AlertSummaryUserPreferencesFuelCustomFilter
     */
    ullageRange?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AlertSummaryUserPreferencesFuelCustomFilter
     */
    customSiteFilters?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AlertSummaryUserPreferencesFuelCustomFilter
     */
    customTankFilters?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof AlertSummaryUserPreferencesFuelCustomFilter
     */
    onlyFaults?: boolean;
}
/**
 * 
 * @export
 * @interface AlertSummaryUserPreferencesMilk
 */
export interface AlertSummaryUserPreferencesMilk {
    /**
     * 
     * @type {number}
     * @memberof AlertSummaryUserPreferencesMilk
     */
    partnerId?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AlertSummaryUserPreferencesMilk
     */
    fixedSchedule?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof AlertSummaryUserPreferencesMilk
     */
    periodSchedule?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AlertSummaryUserPreferencesMilk
     */
    lastRunTs?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof AlertSummaryUserPreferencesMilk
     */
    onlySendNew?: boolean;
    /**
     * 
     * @type {AlertSummaryUserPreferencesMilkCustomFilter}
     * @memberof AlertSummaryUserPreferencesMilk
     */
    customFilter?: AlertSummaryUserPreferencesMilkCustomFilter;
    /**
     * 
     * @type {AlertSummaryUserPreferencesMilkCustomFields}
     * @memberof AlertSummaryUserPreferencesMilk
     */
    customFields?: AlertSummaryUserPreferencesMilkCustomFields;
}
/**
 * 
 * @export
 * @interface AlertSummaryUserPreferencesMilkCustomFields
 */
export interface AlertSummaryUserPreferencesMilkCustomFields {
    /**
     * 
     * @type {Array<string>}
     * @memberof AlertSummaryUserPreferencesMilkCustomFields
     */
    vats?: Array<string>;
}
/**
 * 
 * @export
 * @interface AlertSummaryUserPreferencesMilkCustomFilter
 */
export interface AlertSummaryUserPreferencesMilkCustomFilter {
    /**
     * 
     * @type {number}
     * @memberof AlertSummaryUserPreferencesMilkCustomFilter
     */
    age?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof AlertSummaryUserPreferencesMilkCustomFilter
     */
    volumePercent?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AlertSummaryUserPreferencesMilkCustomFilter
     */
    customSiteFilters?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AlertSummaryUserPreferencesMilkCustomFilter
     */
    customVatFilters?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof AlertSummaryUserPreferencesMilkCustomFilter
     */
    risk?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AlertSummaryUserPreferencesMilkCustomFilter
     */
    onlySupply?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AlertSummaryUserPreferencesMilkCustomFilter
     */
    temperature?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AlertSummaryUserPreferencesMilkCustomFilter
     */
    hideRepair?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof AlertSummaryUserPreferencesMilkCustomFilter
     */
    score?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AlertSummaryUserPreferencesMilkCustomFilter
     */
    complianceMethod?: Array<string>;
}
/**
 * 
 * @export
 * @interface AlertsInData
 */
export interface AlertsInData {
    /**
     * 
     * @type {Array<Alert>}
     * @memberof AlertsInData
     */
    data?: Array<Alert>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum AllEntities {
    Products = 'products',
    Vats = 'vats',
    Tanks = 'tanks',
    WaterMonitors = 'water_monitors',
    WaterMeters = 'water_meters',
    WaterTanks = 'water_tanks',
    FeedTanks = 'feed_tanks',
    Sensors = 'sensors',
    Transceivers = 'transceivers'
}

/**
 * 
 * @export
 * @interface ApiResponse
 */
export interface ApiResponse {
    /**
     * 
     * @type {number}
     * @memberof ApiResponse
     */
    code?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiResponse
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponse
     */
    message?: string;
}
/**
 * 
 * @export
 * @interface Audit
 */
export interface Audit {
    /**
     * 
     * @type {number}
     * @memberof Audit
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Audit
     */
    user_type?: string;
    /**
     * 
     * @type {number}
     * @memberof Audit
     */
    user_id?: number;
    /**
     * 
     * @type {string}
     * @memberof Audit
     */
    event?: string;
    /**
     * 
     * @type {string}
     * @memberof Audit
     */
    auditable_type?: string;
    /**
     * 
     * @type {string}
     * @memberof Audit
     */
    old_values?: string;
    /**
     * 
     * @type {string}
     * @memberof Audit
     */
    new_values?: string;
    /**
     * 
     * @type {string}
     * @memberof Audit
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof Audit
     */
    ip_address?: string;
    /**
     * 
     * @type {string}
     * @memberof Audit
     */
    user_agent?: string;
    /**
     * 
     * @type {string}
     * @memberof Audit
     */
    tags?: string;
    /**
     * 
     * @type {string}
     * @memberof Audit
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof Audit
     */
    updated_at?: string;
    /**
     * 
     * @type {number}
     * @memberof Audit
     */
    pivot_id?: number;
    /**
     * 
     * @type {string}
     * @memberof Audit
     */
    from?: string;
    /**
     * 
     * @type {string}
     * @memberof Audit
     */
    to?: string;
    /**
     * 
     * @type {string}
     * @memberof Audit
     */
    fields?: string;
}
/**
 * 
 * @export
 * @interface AuditsInData
 */
export interface AuditsInData {
    /**
     * 
     * @type {Array<Audit>}
     * @memberof AuditsInData
     */
    data?: Array<Audit>;
}
/**
 * 
 * @export
 * @interface BoundingBox
 */
export interface BoundingBox {
    /**
     * 
     * @type {BoundingBoxBoundingBox}
     * @memberof BoundingBox
     */
    boundingBox?: BoundingBoxBoundingBox;
}
/**
 * 
 * @export
 * @interface BoundingBoxBoundingBox
 */
export interface BoundingBoxBoundingBox {
    /**
     * 
     * @type {LatLong}
     * @memberof BoundingBoxBoundingBox
     */
    southWest?: LatLong;
    /**
     * 
     * @type {LatLong}
     * @memberof BoundingBoxBoundingBox
     */
    northEast?: LatLong;
}
/**
 * 
 * @export
 * @interface CancelEntity
 */
export interface CancelEntity {
    /**
     * 
     * @type {string}
     * @memberof CancelEntity
     */
    actionReason?: string;
}
/**
 * 
 * @export
 * @interface Collection
 */
export interface Collection {
    /**
     * 
     * @type {string}
     * @memberof Collection
     */
    supplierNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof Collection
     */
    collectionDateTime?: string;
    /**
     * 
     * @type {string}
     * @memberof Collection
     */
    collectionType?: CollectionCollectionTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof Collection
     */
    collectionVolume?: number;
    /**
     * 
     * @type {number}
     * @memberof Collection
     */
    ageAtCollection?: number;
    /**
     * 
     * @type {number}
     * @memberof Collection
     */
    scoreAtCollection?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum CollectionCollectionTypeEnum {
    Unknown = 'unknown',
    Partial = 'partial',
    Full = 'full'
}

/**
 * 
 * @export
 * @interface Consent
 */
export interface Consent {
    /**
     * 
     * @type {number}
     * @memberof Consent
     */
    productId?: number;
    /**
     * 
     * @type {number}
     * @memberof Consent
     */
    councilId?: number;
    /**
     * 
     * @type {string}
     * @memberof Consent
     */
    startDate?: string;
    /**
     * 
     * @type {string}
     * @memberof Consent
     */
    endDate?: string;
    /**
     * 
     * @type {string}
     * @memberof Consent
     */
    consentIdentifier?: string;
}
/**
 * 
 * @export
 * @interface ConsentCondition
 */
export interface ConsentCondition {
    /**
     * 
     * @type {number}
     * @memberof ConsentCondition
     */
    id?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConsentCondition
     */
    consentId?: number;
    /**
     * 
     * @type {number}
     * @memberof ConsentCondition
     */
    consentConditionTypeId?: number;
    /**
     * 
     * @type {object}
     * @memberof ConsentCondition
     */
    parameters?: object;
    /**
     * 
     * @type {ConsentConditionType}
     * @memberof ConsentCondition
     */
    consentconditiontype?: ConsentConditionType | null;
}
/**
 * 
 * @export
 * @interface ConsentConditionType
 */
export interface ConsentConditionType {
    /**
     * 
     * @type {number}
     * @memberof ConsentConditionType
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ConsentConditionType
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ConsentConditionType
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ConsentConditionType
     */
    description?: string;
}
/**
 * 
 * @export
 * @interface ConsentConditionWithId
 */
export interface ConsentConditionWithId {
    /**
     * 
     * @type {ConsentCondition}
     * @memberof ConsentConditionWithId
     */
    data?: ConsentCondition;
}
/**
 * 
 * @export
 * @interface ConsentInData
 */
export interface ConsentInData {
    /**
     * 
     * @type {Consent}
     * @memberof ConsentInData
     */
    data?: Consent;
}
/**
 * 
 * @export
 * @interface ConsentWithId
 */
export interface ConsentWithId {
    /**
     * 
     * @type {number}
     * @memberof ConsentWithId
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ConsentWithId
     */
    productId?: number;
    /**
     * 
     * @type {number}
     * @memberof ConsentWithId
     */
    councilId?: number;
    /**
     * 
     * @type {string}
     * @memberof ConsentWithId
     */
    startDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ConsentWithId
     */
    endDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ConsentWithId
     */
    consentIdentifier?: string;
}
/**
 * 
 * @export
 * @interface ConsentWithIdInData
 */
export interface ConsentWithIdInData {
    /**
     * 
     * @type {ConsentWithId}
     * @memberof ConsentWithIdInData
     */
    data?: ConsentWithId;
}
/**
 * 
 * @export
 * @interface ContributionTierInData
 */
export interface ContributionTierInData {
    /**
     * 
     * @type {ContributionTierInDataData}
     * @memberof ContributionTierInData
     */
    data?: ContributionTierInDataData;
}
/**
 * 
 * @export
 * @interface ContributionTierInDataData
 */
export interface ContributionTierInDataData {
    /**
     * 
     * @type {string}
     * @memberof ContributionTierInDataData
     */
    contributionTier?: string | null;
}
/**
 * 
 * @export
 * @interface Correction
 */
export interface Correction {
    /**
     * 
     * @type {string}
     * @memberof Correction
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Correction
     */
    fuelType?: string;
    /**
     * 
     * @type {string}
     * @memberof Correction
     */
    correctionType?: string;
    /**
     * 
     * @type {number}
     * @memberof Correction
     */
    capacitance?: number;
    /**
     * 
     * @type {number}
     * @memberof Correction
     */
    endCapacitance?: number;
    /**
     * 
     * @type {number}
     * @memberof Correction
     */
    levnoAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof Correction
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof Correction
     */
    startHeight?: number;
    /**
     * 
     * @type {number}
     * @memberof Correction
     */
    endHeight?: number;
    /**
     * 
     * @type {string}
     * @memberof Correction
     */
    readingTime?: string;
    /**
     * 
     * @type {number}
     * @memberof Correction
     */
    tankId?: number;
}
/**
 * 
 * @export
 * @interface CreateVat
 */
export interface CreateVat {
    /**
     * 
     * @type {number}
     * @memberof CreateVat
     */
    productId?: number;
}
/**
 * 
 * @export
 * @interface CreateVatInData
 */
export interface CreateVatInData {
    /**
     * 
     * @type {CreateVat}
     * @memberof CreateVatInData
     */
    data?: CreateVat;
}
/**
 * 
 * @export
 * @interface CurrentReading
 */
export interface CurrentReading {
    /**
     * 
     * @type {string}
     * @memberof CurrentReading
     */
    value?: string;
    /**
     * 
     * @type {string}
     * @memberof CurrentReading
     */
    date?: string;
    /**
     * 
     * @type {string}
     * @memberof CurrentReading
     */
    outOfSpec?: string;
}
/**
 * 
 * @export
 * @interface CurrentState
 */
export interface CurrentState {
    /**
     * 
     * @type {string}
     * @memberof CurrentState
     */
    supplyNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof CurrentState
     */
    currentVolume?: number;
    /**
     * 
     * @type {number}
     * @memberof CurrentState
     */
    lastMilking?: number;
    /**
     * 
     * @type {number}
     * @memberof CurrentState
     */
    vatTemperature?: number;
    /**
     * 
     * @type {number}
     * @memberof CurrentState
     */
    milkScore?: number;
}
/**
 * 
 * @export
 * @interface CurrentStateByVat
 */
export interface CurrentStateByVat {
    /**
     * 
     * @type {string}
     * @memberof CurrentStateByVat
     */
    supplyNumber: string;
    /**
     * 
     * @type {string}
     * @memberof CurrentStateByVat
     */
    vatNumber: string;
    /**
     * 
     * @type {string}
     * @memberof CurrentStateByVat
     */
    address: string;
    /**
     * 
     * @type {boolean}
     * @memberof CurrentStateByVat
     */
    containsMilk: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CurrentStateByVat
     */
    milkingInProgress: boolean;
    /**
     * 
     * @type {number}
     * @memberof CurrentStateByVat
     */
    capacity: number;
    /**
     * 
     * @type {number}
     * @memberof CurrentStateByVat
     */
    currentVolume: number;
    /**
     * 
     * @type {number}
     * @memberof CurrentStateByVat
     */
    milkAge: number;
    /**
     * 
     * @type {number}
     * @memberof CurrentStateByVat
     */
    milkScore: number;
    /**
     * 
     * @type {number}
     * @memberof CurrentStateByVat
     */
    lastCollection: number;
    /**
     * 
     * @type {number}
     * @memberof CurrentStateByVat
     */
    lastMilking: number;
    /**
     * 
     * @type {number}
     * @memberof CurrentStateByVat
     */
    secondLastMilking: number;
    /**
     * 
     * @type {number}
     * @memberof CurrentStateByVat
     */
    vatTemperature?: number;
    /**
     * 
     * @type {string}
     * @memberof CurrentStateByVat
     */
    vatAgitator?: CurrentStateByVatVatAgitatorEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum CurrentStateByVatVatAgitatorEnum {
    Init = 'Init',
    True = 'true',
    False = 'false'
}

/**
 * 
 * @export
 * @interface CustomField
 */
export interface CustomField {
    /**
     * 
     * @type {string}
     * @memberof CustomField
     */
    name?: string;
    /**
     * 
     * @type {string | number}
     * @memberof CustomField
     */
    value?: string | number;
}
/**
 * 
 * @export
 * @interface CustomFieldDefinition
 */
export interface CustomFieldDefinition {
    /**
     * 
     * @type {string}
     * @memberof CustomFieldDefinition
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomFieldDefinition
     */
    type?: string;
}
/**
 * 
 * @export
 * @interface CustomFieldDefinitionByEntityInData
 */
export interface CustomFieldDefinitionByEntityInData {
    /**
     * 
     * @type {Array<object>}
     * @memberof CustomFieldDefinitionByEntityInData
     */
    data?: Array<object>;
}
/**
 * 
 * @export
 * @interface CustomFieldDefinitionInData
 */
export interface CustomFieldDefinitionInData {
    /**
     * 
     * @type {CustomFieldDefinition}
     * @memberof CustomFieldDefinitionInData
     */
    data?: CustomFieldDefinition;
}
/**
 * 
 * @export
 * @interface CustomFieldsInData
 */
export interface CustomFieldsInData {
    /**
     * 
     * @type {Array<CustomField>}
     * @memberof CustomFieldsInData
     */
    data?: Array<CustomField>;
}
/**
 * 
 * @export
 * @interface CustomSettingInData
 */
export interface CustomSettingInData {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CustomSettingInData
     */
    data?: { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface CustomSettingsByEntityInData
 */
export interface CustomSettingsByEntityInData {
    /**
     * 
     * @type {Array<object>}
     * @memberof CustomSettingsByEntityInData
     */
    data?: Array<object>;
}
/**
 * 
 * @export
 * @interface DeactivateEntity
 */
export interface DeactivateEntity {
    /**
     * 
     * @type {string}
     * @memberof DeactivateEntity
     */
    actionReason?: string;
}
/**
 * 
 * @export
 * @interface DirectPlan
 */
export interface DirectPlan {
    /**
     * 
     * @type {string}
     * @memberof DirectPlan
     */
    directPlanId?: string;
    /**
     * 
     * @type {string}
     * @memberof DirectPlan
     */
    directPlanName?: string;
}
/**
 * 
 * @export
 * @interface DirectPlans
 */
export interface DirectPlans {
    /**
     * 
     * @type {DirectPlan}
     * @memberof DirectPlans
     */
    milk?: DirectPlan;
    /**
     * 
     * @type {DirectPlan}
     * @memberof DirectPlans
     */
    fuel?: DirectPlan;
    /**
     * 
     * @type {DirectPlan}
     * @memberof DirectPlans
     */
    water?: DirectPlan;
    /**
     * 
     * @type {DirectPlan}
     * @memberof DirectPlans
     */
    feed?: DirectPlan;
}
/**
 * 
 * @export
 * @interface DirectPlansInData
 */
export interface DirectPlansInData {
    /**
     * 
     * @type {DirectPlans}
     * @memberof DirectPlansInData
     */
    data?: DirectPlans;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum Entities {
    Products = 'products',
    Vats = 'vats',
    Tanks = 'tanks',
    WaterMonitors = 'water_monitors',
    WaterMeters = 'water_meters',
    WaterTanks = 'water_tanks',
    FeedTanks = 'feed_tanks'
}

/**
 * 
 * @export
 * @interface EntityCurrentState
 */
export interface EntityCurrentState {
    /**
     * 
     * @type {number}
     * @memberof EntityCurrentState
     */
    partnerId?: number;
    /**
     * 
     * @type {number}
     * @memberof EntityCurrentState
     */
    productId?: number;
    /**
     * 
     * @type {Array<object>}
     * @memberof EntityCurrentState
     */
    customFieldData?: Array<object>;
    /**
     * 
     * @type {Array<object>}
     * @memberof EntityCurrentState
     */
    customSettingsData?: Array<object>;
    /**
     * 
     * @type {object}
     * @memberof EntityCurrentState
     */
    comments?: object;
    /**
     * 
     * @type {string}
     * @memberof EntityCurrentState
     */
    partnerDefinedId?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityCurrentState
     */
    partnerDefinedName?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityCurrentState
     */
    contributionTier?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityCurrentState
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityCurrentState
     */
    supplier?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityCurrentState
     */
    supplierNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityCurrentState
     */
    faultStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityCurrentState
     */
    liveAt?: string;
    /**
     * 
     * @type {ProductStatus}
     * @memberof EntityCurrentState
     */
    status?: ProductStatus;
    /**
     * 
     * @type {string}
     * @memberof EntityCurrentState
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityCurrentState
     */
    siteName?: string;
    /**
     * 
     * @type {number}
     * @memberof EntityCurrentState
     */
    latitude?: number;
    /**
     * 
     * @type {number}
     * @memberof EntityCurrentState
     */
    longitude?: number;
    /**
     * 
     * @type {number}
     * @memberof EntityCurrentState
     */
    entityId?: number;
    /**
     * 
     * @type {string}
     * @memberof EntityCurrentState
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof EntityCurrentState
     */
    capacity?: number;
    /**
     * 
     * @type {number}
     * @memberof EntityCurrentState
     */
    safeFillVolume?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EntityCurrentState
     */
    state?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityCurrentState
     */
    type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityCurrentState
     */
    feedType?: string | null;
    /**
     * 
     * @type {EntityStatus}
     * @memberof EntityCurrentState
     */
    entityStatus?: EntityStatus;
    /**
     * 
     * @type {object}
     * @memberof EntityCurrentState
     */
    metrics?: object;
    /**
     * 
     * @type {Array<object>}
     * @memberof EntityCurrentState
     */
    entityCustomFieldData?: Array<object>;
    /**
     * 
     * @type {Array<object>}
     * @memberof EntityCurrentState
     */
    entityCustomSettingsData?: Array<object>;
    /**
     * 
     * @type {object}
     * @memberof EntityCurrentState
     */
    entityComments?: object;
    /**
     * 
     * @type {string}
     * @memberof EntityCurrentState
     */
    partnerDefinedEntityId?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityCurrentState
     */
    partnerDefinedEntityName?: string;
}
/**
 * 
 * @export
 * @interface EntityCurrentStateInData
 */
export interface EntityCurrentStateInData {
    /**
     * 
     * @type {EntityCurrentState}
     * @memberof EntityCurrentStateInData
     */
    data?: EntityCurrentState;
}
/**
 * 
 * @export
 * @interface EntityLocation
 */
export interface EntityLocation {
    /**
     * 
     * @type {number}
     * @memberof EntityLocation
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof EntityLocation
     */
    entityType?: string;
    /**
     * 
     * @type {number}
     * @memberof EntityLocation
     */
    entityId?: number;
    /**
     * 
     * @type {string}
     * @memberof EntityLocation
     */
    notes?: string;
    /**
     * 
     * @type {number}
     * @memberof EntityLocation
     */
    siteId?: number;
    /**
     * 
     * @type {number}
     * @memberof EntityLocation
     */
    latitude?: number;
    /**
     * 
     * @type {number}
     * @memberof EntityLocation
     */
    longitude?: number;
}
/**
 * 
 * @export
 * @interface EntityLocationInData
 */
export interface EntityLocationInData {
    /**
     * 
     * @type {EntityLocation}
     * @memberof EntityLocationInData
     */
    data?: EntityLocation;
}
/**
 * 
 * @export
 * @interface EntityLocationsInData
 */
export interface EntityLocationsInData {
    /**
     * 
     * @type {Array<EntityLocation>}
     * @memberof EntityLocationsInData
     */
    data?: Array<EntityLocation>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum EntityStatus {
    Pending = 'pending',
    Install = 'install',
    SignOff = 'sign-off',
    Live = 'live',
    Removed = 'removed',
    Cancelled = 'cancelled',
    Draft = 'draft'
}

/**
 * 
 * @export
 * @interface EntityStatusChange
 */
export interface EntityStatusChange {
    /**
     * 
     * @type {number}
     * @memberof EntityStatusChange
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof EntityStatusChange
     */
    entityType?: string;
    /**
     * 
     * @type {number}
     * @memberof EntityStatusChange
     */
    entityId?: number;
    /**
     * 
     * @type {string}
     * @memberof EntityStatusChange
     */
    oldStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityStatusChange
     */
    newStatus?: string;
    /**
     * 
     * @type {number}
     * @memberof EntityStatusChange
     */
    userId?: number;
    /**
     * 
     * @type {string}
     * @memberof EntityStatusChange
     */
    reason?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityStatusChange
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityStatusChange
     */
    updated_at?: string;
}
/**
 * 
 * @export
 * @interface EventNotificationsNotifySupportData
 */
export interface EventNotificationsNotifySupportData {
    /**
     * 
     * @type {string}
     * @memberof EventNotificationsNotifySupportData
     */
    eventType?: string;
    /**
     * 
     * @type {string}
     * @memberof EventNotificationsNotifySupportData
     */
    eventData?: string;
    /**
     * 
     * @type {string}
     * @memberof EventNotificationsNotifySupportData
     */
    entityType?: string;
    /**
     * 
     * @type {number}
     * @memberof EventNotificationsNotifySupportData
     */
    entityId?: number;
    /**
     * 
     * @type {number}
     * @memberof EventNotificationsNotifySupportData
     */
    productId?: number;
    /**
     * 
     * @type {string}
     * @memberof EventNotificationsNotifySupportData
     */
    email?: string | null;
}
/**
 * 
 * @export
 * @interface EventSubscription
 */
export interface EventSubscription {
    /**
     * 
     * @type {number}
     * @memberof EventSubscription
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof EventSubscription
     */
    eventTypeId?: number;
    /**
     * 
     * @type {number}
     * @memberof EventSubscription
     */
    productId?: number;
    /**
     * 
     * @type {number}
     * @memberof EventSubscription
     */
    userId?: number;
    /**
     * 
     * @type {string}
     * @memberof EventSubscription
     */
    entityType?: EventSubscriptionEntityTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof EventSubscription
     */
    entityId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EventSubscription
     */
    channel?: EventSubscriptionChannelEnum;
    /**
     * 
     * @type {object}
     * @memberof EventSubscription
     */
    parameters?: object | null;
    /**
     * 
     * @type {boolean}
     * @memberof EventSubscription
     */
    validOnProductTier?: boolean | null;
}

/**
    * @export
    * @enum {string}
    */
export enum EventSubscriptionEntityTypeEnum {
    Vats = 'vats',
    Tanks = 'tanks'
}
/**
    * @export
    * @enum {string}
    */
export enum EventSubscriptionChannelEnum {
    Mail = 'mail',
    Sms = 'sms'
}

/**
 * 
 * @export
 * @interface EventSubscriptionAllOf
 */
export interface EventSubscriptionAllOf {
    /**
     * 
     * @type {number}
     * @memberof EventSubscriptionAllOf
     */
    id?: number;
}
/**
 * 
 * @export
 * @interface EventSubscriptionDeletedAudits
 */
export interface EventSubscriptionDeletedAudits {
    /**
     * 
     * @type {string}
     * @memberof EventSubscriptionDeletedAudits
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof EventSubscriptionDeletedAudits
     */
    eventSubscriptionId?: number;
    /**
     * 
     * @type {string}
     * @memberof EventSubscriptionDeletedAudits
     */
    oldValues?: string;
    /**
     * 
     * @type {number}
     * @memberof EventSubscriptionDeletedAudits
     */
    userId?: number;
    /**
     * 
     * @type {string}
     * @memberof EventSubscriptionDeletedAudits
     */
    userName?: string;
    /**
     * 
     * @type {string}
     * @memberof EventSubscriptionDeletedAudits
     */
    userEmail?: string;
}
/**
 * 
 * @export
 * @interface EventSubscriptionDeletedAuditsInData
 */
export interface EventSubscriptionDeletedAuditsInData {
    /**
     * 
     * @type {Array<EventSubscriptionDeletedAudits>}
     * @memberof EventSubscriptionDeletedAuditsInData
     */
    data?: Array<EventSubscriptionDeletedAudits>;
}
/**
 * 
 * @export
 * @interface EventSubscriptionProperties
 */
export interface EventSubscriptionProperties {
    /**
     * 
     * @type {number}
     * @memberof EventSubscriptionProperties
     */
    eventTypeId?: number;
    /**
     * 
     * @type {number}
     * @memberof EventSubscriptionProperties
     */
    productId?: number;
    /**
     * 
     * @type {number}
     * @memberof EventSubscriptionProperties
     */
    userId?: number;
    /**
     * 
     * @type {string}
     * @memberof EventSubscriptionProperties
     */
    entityType?: EventSubscriptionPropertiesEntityTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof EventSubscriptionProperties
     */
    entityId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EventSubscriptionProperties
     */
    channel?: EventSubscriptionPropertiesChannelEnum;
    /**
     * 
     * @type {object}
     * @memberof EventSubscriptionProperties
     */
    parameters?: object | null;
    /**
     * 
     * @type {boolean}
     * @memberof EventSubscriptionProperties
     */
    validOnProductTier?: boolean | null;
}

/**
    * @export
    * @enum {string}
    */
export enum EventSubscriptionPropertiesEntityTypeEnum {
    Vats = 'vats',
    Tanks = 'tanks'
}
/**
    * @export
    * @enum {string}
    */
export enum EventSubscriptionPropertiesChannelEnum {
    Mail = 'mail',
    Sms = 'sms'
}

/**
 * 
 * @export
 * @interface EventType
 */
export interface EventType {
    /**
     * 
     * @type {number}
     * @memberof EventType
     */
    id?: number;
    /**
     * 
     * @type {ProductType}
     * @memberof EventType
     */
    productType?: ProductType;
    /**
     * 
     * @type {string}
     * @memberof EventType
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof EventType
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof EventType
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof EventType
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof EventType
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof EventType
     */
    deletedAt?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EventType
     */
    isDefault?: boolean;
    /**
     * 
     * @type {object}
     * @memberof EventType
     */
    defaultParameters?: object | null;
    /**
     * 
     * @type {ProductTier}
     * @memberof EventType
     */
    tier?: ProductTier;
    /**
     * 
     * @type {Array<ProductTier>}
     * @memberof EventType
     */
    tierList?: Array<ProductTier>;
}
/**
 * raw events for a vat
 * @export
 * @interface EventsData
 */
export interface EventsData {
    /**
     * vatId
     * @type {string}
     * @memberof EventsData
     */
    id?: string;
    /**
     * 
     * @type {Array<EventsDataMilkingFinish>}
     * @memberof EventsData
     */
    milkingFinish?: Array<EventsDataMilkingFinish>;
    /**
     * 
     * @type {Array<EventsDataPickupFinish>}
     * @memberof EventsData
     */
    pickupFinish?: Array<EventsDataPickupFinish>;
    /**
     * 
     * @type {Array<EventsDataWash>}
     * @memberof EventsData
     */
    vatWashFinish?: Array<EventsDataWash>;
    /**
     * 
     * @type {Array<EventsDataWash>}
     * @memberof EventsData
     */
    plantWashFinish?: Array<EventsDataWash>;
    /**
     * 
     * @type {Array<EventsDataPower>}
     * @memberof EventsData
     */
    power?: Array<EventsDataPower>;
}
/**
 * a milking or pickup start or finish event
 * @export
 * @interface EventsDataItem
 */
export interface EventsDataItem {
    /**
     * volume in litres
     * @type {string}
     * @memberof EventsDataItem
     */
    volume?: string;
    /**
     * degrees
     * @type {number}
     * @memberof EventsDataItem
     */
    temperature?: number;
    /**
     * from top of tank measured by lidar
     * @type {number}
     * @memberof EventsDataItem
     */
    distance?: number;
    /**
     * unixtime in UTC
     * @type {number}
     * @memberof EventsDataItem
     */
    timestamp?: number;
}
/**
 * 
 * @export
 * @interface EventsDataMilkingFinish
 */
export interface EventsDataMilkingFinish {
    /**
     * 
     * @type {EventsDataItem}
     * @memberof EventsDataMilkingFinish
     */
    start?: EventsDataItem;
    /**
     * 
     * @type {EventsDataItem}
     * @memberof EventsDataMilkingFinish
     */
    finish?: EventsDataItem;
    /**
     * clean | dirty
     * @type {string}
     * @memberof EventsDataMilkingFinish
     */
    plantStatus?: string;
    /**
     * what is this for?
     * @type {string}
     * @memberof EventsDataMilkingFinish
     */
    type?: string;
}
/**
 * 
 * @export
 * @interface EventsDataPickupFinish
 */
export interface EventsDataPickupFinish {
    /**
     * 
     * @type {EventsDataItem}
     * @memberof EventsDataPickupFinish
     */
    start?: EventsDataItem;
    /**
     * 
     * @type {EventsDataItem}
     * @memberof EventsDataPickupFinish
     */
    finish?: EventsDataItem;
    /**
     * 0 for false, non zero for true
     * @type {number}
     * @memberof EventsDataPickupFinish
     */
    milkingInProgress?: number;
    /**
     * full | partial
     * @type {string}
     * @memberof EventsDataPickupFinish
     */
    type?: string;
}
/**
 * a power state change
 * @export
 * @interface EventsDataPower
 */
export interface EventsDataPower {
    /**
     * 
     * @type {number}
     * @memberof EventsDataPower
     */
    battery?: number;
    /**
     * 
     * @type {number}
     * @memberof EventsDataPower
     */
    mains?: number;
    /**
     * 0 = power off, 1 = power on
     * @type {number}
     * @memberof EventsDataPower
     */
    state?: number;
    /**
     * unixtime in UTC
     * @type {number}
     * @memberof EventsDataPower
     */
    timestamp?: number;
}
/**
 * the result of a vat or plant wash
 * @export
 * @interface EventsDataWash
 */
export interface EventsDataWash {
    /**
     * degrees
     * @type {number}
     * @memberof EventsDataWash
     */
    maxTemperature?: number;
    /**
     * 
     * @type {EventsDataWashStart}
     * @memberof EventsDataWash
     */
    start?: EventsDataWashStart;
    /**
     * 
     * @type {EventsDataWashStart}
     * @memberof EventsDataWash
     */
    finish?: EventsDataWashStart;
    /**
     * unixtime in UTC
     * @type {number}
     * @memberof EventsDataWash
     */
    maxTimestamp?: number;
    /**
     * vat or plant
     * @type {string}
     * @memberof EventsDataWash
     */
    type?: string;
}
/**
 * 
 * @export
 * @interface EventsDataWashStart
 */
export interface EventsDataWashStart {
    /**
     * unixtime in UTC
     * @type {number}
     * @memberof EventsDataWashStart
     */
    timestamp?: number;
}
/**
 * 
 * @export
 * @interface Fault
 */
export interface Fault {
    /**
     * 
     * @type {string}
     * @memberof Fault
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Fault
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Fault
     */
    message?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Fault
     */
    ownerType?: FaultOwnerTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof Fault
     */
    ownerId?: number;
    /**
     * 
     * @type {string}
     * @memberof Fault
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof Fault
     */
    type?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum FaultOwnerTypeEnum {
    Transceivers = 'transceivers',
    Products = 'products'
}

/**
 * 
 * @export
 * @interface FaultInData
 */
export interface FaultInData {
    /**
     * 
     * @type {Fault}
     * @memberof FaultInData
     */
    data?: Fault;
}
/**
 * 
 * @export
 * @interface FaultSymptoms
 */
export interface FaultSymptoms {
    /**
     * 
     * @type {number}
     * @memberof FaultSymptoms
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof FaultSymptoms
     */
    serialNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof FaultSymptoms
     */
    uniqueId?: string;
    /**
     * 
     * @type {string}
     * @memberof FaultSymptoms
     */
    accessoryType?: string;
    /**
     * 
     * @type {AllEntities}
     * @memberof FaultSymptoms
     */
    entityType?: AllEntities;
    /**
     * 
     * @type {string}
     * @memberof FaultSymptoms
     */
    customerImpact?: string;
}
/**
 * 
 * @export
 * @interface FaultSymptomsInData
 */
export interface FaultSymptomsInData {
    /**
     * 
     * @type {Array<FaultSymptoms>}
     * @memberof FaultSymptomsInData
     */
    data?: Array<FaultSymptoms>;
}
/**
 * 
 * @export
 * @interface FaultTypesInData
 */
export interface FaultTypesInData {
    /**
     * 
     * @type {Array<string>}
     * @memberof FaultTypesInData
     */
    data?: Array<string>;
}
/**
 * 
 * @export
 * @interface FaultsInData
 */
export interface FaultsInData {
    /**
     * 
     * @type {Array<Fault>}
     * @memberof FaultsInData
     */
    data?: Array<Fault>;
}
/**
 * 
 * @export
 * @interface FeedCorrection
 */
export interface FeedCorrection {
    /**
     * 
     * @type {number}
     * @memberof FeedCorrection
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof FeedCorrection
     */
    userId?: number;
    /**
     * 
     * @type {number}
     * @memberof FeedCorrection
     */
    feedTankId?: number;
    /**
     * 
     * @type {number}
     * @memberof FeedCorrection
     */
    feedTypeId?: number;
    /**
     * 
     * @type {FeedCorrectionType}
     * @memberof FeedCorrection
     */
    correctionType?: FeedCorrectionType;
    /**
     * 
     * @type {number}
     * @memberof FeedCorrection
     */
    volume?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FeedCorrection
     */
    weight?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FeedCorrection
     */
    originalVolume?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FeedCorrection
     */
    originalWeight?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FeedCorrection
     */
    startReading?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FeedCorrection
     */
    endReading?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FeedCorrection
     */
    eventTimestamp?: number;
    /**
     * 
     * @type {string}
     * @memberof FeedCorrection
     */
    notes?: string;
    /**
     * 
     * @type {string}
     * @memberof FeedCorrection
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof FeedCorrection
     */
    updated_at?: string;
    /**
     * 
     * @type {string}
     * @memberof FeedCorrection
     */
    deleted_at?: string | null;
    /**
     * 
     * @type {object}
     * @memberof FeedCorrection
     */
    additionalParameters?: object | null;
}
/**
 * 
 * @export
 * @interface FeedCorrectionInData
 */
export interface FeedCorrectionInData {
    /**
     * 
     * @type {FeedCorrection}
     * @memberof FeedCorrectionInData
     */
    data?: FeedCorrection;
}
/**
 * 
 * @export
 * @interface FeedCorrectionInput
 */
export interface FeedCorrectionInput {
    /**
     * 
     * @type {number}
     * @memberof FeedCorrectionInput
     */
    feedTypeId: number;
    /**
     * 
     * @type {FeedCorrectionType}
     * @memberof FeedCorrectionInput
     */
    correctionType: FeedCorrectionType;
    /**
     * 
     * @type {number}
     * @memberof FeedCorrectionInput
     */
    volume?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FeedCorrectionInput
     */
    weight?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FeedCorrectionInput
     */
    originalVolume?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FeedCorrectionInput
     */
    originalWeight?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FeedCorrectionInput
     */
    startReading?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FeedCorrectionInput
     */
    endReading?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FeedCorrectionInput
     */
    eventTimestamp: number;
    /**
     * 
     * @type {string}
     * @memberof FeedCorrectionInput
     */
    notes?: string | null;
    /**
     * 
     * @type {object}
     * @memberof FeedCorrectionInput
     */
    additionalParameters?: object | null;
}
/**
 * 
 * @export
 * @interface FeedCorrectionListInData
 */
export interface FeedCorrectionListInData {
    /**
     * 
     * @type {Array<FeedCorrection>}
     * @memberof FeedCorrectionListInData
     */
    data?: Array<FeedCorrection>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum FeedCorrectionType {
    Refill = 'refill',
    Empty = 'empty'
}

/**
 * 
 * @export
 * @interface FeedTank
 */
export interface FeedTank {
    /**
     * 
     * @type {number}
     * @memberof FeedTank
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof FeedTank
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof FeedTank
     */
    productId?: number;
    /**
     * 
     * @type {EntityStatus}
     * @memberof FeedTank
     */
    status?: EntityStatus;
    /**
     * 
     * @type {FeedTankType}
     * @memberof FeedTank
     */
    type?: FeedTankType | null;
    /**
     * 
     * @type {number}
     * @memberof FeedTank
     */
    nominalVolume?: number;
    /**
     * 
     * @type {number}
     * @memberof FeedTank
     */
    nominalWeight?: number;
    /**
     * 
     * @type {number}
     * @memberof FeedTank
     */
    slopeOffset?: number;
    /**
     * 
     * @type {number}
     * @memberof FeedTank
     */
    feedTypeId?: number;
    /**
     * 
     * @type {string}
     * @memberof FeedTank
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof FeedTank
     */
    updatedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof FeedTank
     */
    numTanks?: number;
    /**
     * 
     * @type {EntityLocation}
     * @memberof FeedTank
     */
    entitylocation?: EntityLocation;
    /**
     * 
     * @type {Array<EntityStatusChange>}
     * @memberof FeedTank
     */
    entitystatuschanges?: Array<EntityStatusChange>;
    /**
     * 
     * @type {string}
     * @memberof FeedTank
     */
    liveAt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FeedTank
     */
    liveAtDate?: string | null;
    /**
     * 
     * @type {Sensor}
     * @memberof FeedTank
     */
    sensor?: Sensor;
    /**
     * 
     * @type {number}
     * @memberof FeedTank
     */
    formulaId?: number | null;
    /**
     * 
     * @type {object}
     * @memberof FeedTank
     */
    formulaParameters?: object | null;
    /**
     * 
     * @type {object}
     * @memberof FeedTank
     */
    formula?: object | null;
    /**
     * 
     * @type {number}
     * @memberof FeedTank
     */
    weight?: number;
    /**
     * 
     * @type {number}
     * @memberof FeedTank
     */
    tonnage?: number;
    /**
     * 
     * @type {FeedType}
     * @memberof FeedTank
     */
    feedtype?: FeedType;
    /**
     * 
     * @type {object}
     * @memberof FeedTank
     */
    formulaCorrection?: object;
    /**
     * 
     * @type {Transceiver}
     * @memberof FeedTank
     */
    transceiver?: Transceiver;
}
/**
 * 
 * @export
 * @interface FeedTankAdd
 */
export interface FeedTankAdd {
    /**
     * 
     * @type {string}
     * @memberof FeedTankAdd
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof FeedTankAdd
     */
    productId: number;
    /**
     * 
     * @type {number}
     * @memberof FeedTankAdd
     */
    nominalVolume?: number | null;
}
/**
 * 
 * @export
 * @interface FeedTankGraphItem
 */
export interface FeedTankGraphItem {
    /**
     * 
     * @type {string}
     * @memberof FeedTankGraphItem
     */
    date?: string;
    /**
     * 
     * @type {number}
     * @memberof FeedTankGraphItem
     */
    value?: number;
    /**
     * 
     * @type {number}
     * @memberof FeedTankGraphItem
     */
    percent?: number;
    /**
     * 
     * @type {number}
     * @memberof FeedTankGraphItem
     */
    volume?: number;
    /**
     * 
     * @type {number}
     * @memberof FeedTankGraphItem
     */
    volumeWeight?: number;
    /**
     * 
     * @type {number}
     * @memberof FeedTankGraphItem
     */
    weight?: number;
}
/**
 * 
 * @export
 * @interface FeedTankGraphItemsInData
 */
export interface FeedTankGraphItemsInData {
    /**
     * 
     * @type {FeedTankGraphItemsInDataData}
     * @memberof FeedTankGraphItemsInData
     */
    data?: FeedTankGraphItemsInDataData;
}
/**
 * 
 * @export
 * @interface FeedTankGraphItemsInDataData
 */
export interface FeedTankGraphItemsInDataData {
    /**
     * 
     * @type {Array<FeedTankGraphItem>}
     * @memberof FeedTankGraphItemsInDataData
     */
    level?: Array<FeedTankGraphItem>;
    /**
     * 
     * @type {Array<FeedTankGraphRefillItem>}
     * @memberof FeedTankGraphItemsInDataData
     */
    logical_refill?: Array<FeedTankGraphRefillItem>;
}
/**
 * 
 * @export
 * @interface FeedTankGraphRefillItem
 */
export interface FeedTankGraphRefillItem {
    /**
     * 
     * @type {string}
     * @memberof FeedTankGraphRefillItem
     */
    date?: string;
    /**
     * 
     * @type {number}
     * @memberof FeedTankGraphRefillItem
     */
    value?: number;
    /**
     * 
     * @type {number}
     * @memberof FeedTankGraphRefillItem
     */
    volume?: number;
    /**
     * 
     * @type {number}
     * @memberof FeedTankGraphRefillItem
     */
    volumeWeight?: number;
    /**
     * 
     * @type {number}
     * @memberof FeedTankGraphRefillItem
     */
    weight?: number;
}
/**
 * 
 * @export
 * @interface FeedTankInData
 */
export interface FeedTankInData {
    /**
     * 
     * @type {FeedTank}
     * @memberof FeedTankInData
     */
    data?: FeedTank;
}
/**
 * 
 * @export
 * @interface FeedTankInstall
 */
export interface FeedTankInstall {
    /**
     * 
     * @type {FeedTankInstallData}
     * @memberof FeedTankInstall
     */
    data?: FeedTankInstallData;
}
/**
 * 
 * @export
 * @interface FeedTankInstallData
 */
export interface FeedTankInstallData {
    /**
     * 
     * @type {number}
     * @memberof FeedTankInstallData
     */
    transceiverId: number;
    /**
     * 
     * @type {number}
     * @memberof FeedTankInstallData
     */
    sensorId: number;
    /**
     * 
     * @type {string}
     * @memberof FeedTankInstallData
     */
    entityType: FeedTankInstallDataEntityTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof FeedTankInstallData
     */
    nodeId?: number | null;
}

/**
    * @export
    * @enum {string}
    */
export enum FeedTankInstallDataEntityTypeEnum {
    FeedTanks = 'feed_tanks'
}

/**
 * 
 * @export
 * @interface FeedTankProvision
 */
export interface FeedTankProvision {
    /**
     * 
     * @type {FeedTankProvisionData}
     * @memberof FeedTankProvision
     */
    data?: FeedTankProvisionData;
}
/**
 * 
 * @export
 * @interface FeedTankProvisionData
 */
export interface FeedTankProvisionData {
    /**
     * 
     * @type {string}
     * @memberof FeedTankProvisionData
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof FeedTankProvisionData
     */
    nominalVolume?: number;
    /**
     * 
     * @type {number}
     * @memberof FeedTankProvisionData
     */
    nominalWeight?: number;
    /**
     * 
     * @type {number}
     * @memberof FeedTankProvisionData
     */
    numTanks?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FeedTankProvisionData
     */
    feedTypeId: number;
    /**
     * 
     * @type {FeedTankType}
     * @memberof FeedTankProvisionData
     */
    type?: FeedTankType | null;
    /**
     * 
     * @type {number}
     * @memberof FeedTankProvisionData
     */
    formulaId?: number | null;
    /**
     * 
     * @type {object}
     * @memberof FeedTankProvisionData
     */
    formulaParameters?: object | null;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum FeedTankType {
    Silo = 'silo',
    Tank = 'tank',
    Vat = 'vat',
    Bin = 'bin',
    Null = 'null'
}

/**
 * 
 * @export
 * @interface FeedType
 */
export interface FeedType {
    /**
     * 
     * @type {number}
     * @memberof FeedType
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof FeedType
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof FeedType
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof FeedType
     */
    density?: number;
    /**
     * 
     * @type {string}
     * @memberof FeedType
     */
    levelMetric?: FeedTypeLevelMetricEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum FeedTypeLevelMetricEnum {
    Weight = 'weight',
    Volume = 'volume'
}

/**
 * 
 * @export
 * @interface FeedTypesInData
 */
export interface FeedTypesInData {
    /**
     * 
     * @type {Array<FeedType>}
     * @memberof FeedTypesInData
     */
    data?: Array<FeedType>;
}
/**
 * 
 * @export
 * @interface FilterData
 */
export interface FilterData {
    /**
     * 
     * @type {BoundingBox}
     * @memberof FilterData
     */
    data?: BoundingBox;
}
/**
 * 
 * @export
 * @interface FlowChartLayout
 */
export interface FlowChartLayout {
    /**
     * 
     * @type {number}
     * @memberof FlowChartLayout
     */
    ownerId: number;
    /**
     * 
     * @type {string}
     * @memberof FlowChartLayout
     */
    ownerType: string;
    /**
     * 
     * @type {string}
     * @memberof FlowChartLayout
     */
    layout: string;
}
/**
 * 
 * @export
 * @interface FlowChartLayoutInData
 */
export interface FlowChartLayoutInData {
    /**
     * 
     * @type {FlowChartLayout}
     * @memberof FlowChartLayoutInData
     */
    data?: FlowChartLayout;
}
/**
 * 
 * @export
 * @interface FlowChartLayoutsInData
 */
export interface FlowChartLayoutsInData {
    /**
     * 
     * @type {Array<FlowChartLayout>}
     * @memberof FlowChartLayoutsInData
     */
    data?: Array<FlowChartLayout>;
}
/**
 * 
 * @export
 * @interface FonterraPickups
 */
export interface FonterraPickups {
    /**
     * 
     * @type {string}
     * @memberof FonterraPickups
     */
    supplierNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof FonterraPickups
     */
    message?: string;
    /**
     * 
     * @type {Array<FonterraPickupsPickup>}
     * @memberof FonterraPickups
     */
    pickup?: Array<FonterraPickupsPickup>;
}
/**
 * 
 * @export
 * @interface FonterraPickupsPickup
 */
export interface FonterraPickupsPickup {
    /**
     * 
     * @type {number}
     * @memberof FonterraPickupsPickup
     */
    startTime?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FonterraPickupsPickup
     */
    finishTime?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FonterraPickupsPickup
     */
    volume?: number | null;
    /**
     * 
     * @type {Array<FonterraPickupsVat>}
     * @memberof FonterraPickupsPickup
     */
    vat?: Array<FonterraPickupsVat>;
}
/**
 * 
 * @export
 * @interface FonterraPickupsVat
 */
export interface FonterraPickupsVat {
    /**
     * 
     * @type {number}
     * @memberof FonterraPickupsVat
     */
    id?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FonterraPickupsVat
     */
    volume?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FonterraPickupsVat
     */
    temperature?: number | null;
}
/**
 * 
 * @export
 * @interface ForgotPassword
 */
export interface ForgotPassword {
    /**
     * 
     * @type {string}
     * @memberof ForgotPassword
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof ForgotPassword
     */
    app?: ForgotPasswordAppEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum ForgotPasswordAppEnum {
    Admin = 'admin',
    Farmer = 'farmer',
    Partner = 'partner'
}

/**
 * 
 * @export
 * @interface Formula
 */
export interface Formula {
    /**
     * 
     * @type {number}
     * @memberof Formula
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof Formula
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Formula
     */
    formula: string;
    /**
     * 
     * @type {string}
     * @memberof Formula
     */
    inputs: string;
    /**
     * 
     * @type {boolean}
     * @memberof Formula
     */
    archived: boolean;
    /**
     * 
     * @type {string}
     * @memberof Formula
     */
    entityType: string;
    /**
     * 
     * @type {string}
     * @memberof Formula
     */
    sensorType: string | null;
    /**
     * 
     * @type {number}
     * @memberof Formula
     */
    usedBy?: number | null;
}
/**
 * 
 * @export
 * @interface FormulaInData
 */
export interface FormulaInData {
    /**
     * 
     * @type {Formula}
     * @memberof FormulaInData
     */
    data?: Formula;
}
/**
 * 
 * @export
 * @interface FormulaInput
 */
export interface FormulaInput {
    /**
     * 
     * @type {string}
     * @memberof FormulaInput
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof FormulaInput
     */
    formula: string;
    /**
     * 
     * @type {string}
     * @memberof FormulaInput
     */
    inputs: string;
    /**
     * 
     * @type {string}
     * @memberof FormulaInput
     */
    entityType?: string;
    /**
     * 
     * @type {string}
     * @memberof FormulaInput
     */
    sensorType?: string;
}
/**
 * 
 * @export
 * @interface FormulaInputInData
 */
export interface FormulaInputInData {
    /**
     * 
     * @type {FormulaInput}
     * @memberof FormulaInputInData
     */
    data?: FormulaInput;
}
/**
 * 
 * @export
 * @interface FormulasInData
 */
export interface FormulasInData {
    /**
     * 
     * @type {Array<Formula>}
     * @memberof FormulasInData
     */
    data?: Array<Formula>;
}
/**
 * 
 * @export
 * @interface FuelDash
 */
export interface FuelDash {
    /**
     * 
     * @type {Array<TankObject>}
     * @memberof FuelDash
     */
    data?: Array<TankObject>;
}
/**
 * 
 * @export
 * @interface FuelGraphData
 */
export interface FuelGraphData {
    /**
     * 
     * @type {Array<TimeSeriesValue>}
     * @memberof FuelGraphData
     */
    volume?: Array<TimeSeriesValue>;
    /**
     * 
     * @type {Array<TimeSeriesValue>}
     * @memberof FuelGraphData
     */
    height?: Array<TimeSeriesValue>;
}
/**
 * 
 * @export
 * @interface FuelGraphDataInData
 */
export interface FuelGraphDataInData {
    /**
     * 
     * @type {FuelGraphData}
     * @memberof FuelGraphDataInData
     */
    data?: FuelGraphData;
}
/**
 * 
 * @export
 * @interface FuelSensorMetaData
 */
export interface FuelSensorMetaData {
    /**
     * 
     * @type {string}
     * @memberof FuelSensorMetaData
     */
    date?: string;
    /**
     * 
     * @type {FuelSensorMetaDataData}
     * @memberof FuelSensorMetaData
     */
    data?: FuelSensorMetaDataData;
}
/**
 * 
 * @export
 * @interface FuelSensorMetaDataData
 */
export interface FuelSensorMetaDataData {
    /**
     * 
     * @type {number}
     * @memberof FuelSensorMetaDataData
     */
    length?: number;
    /**
     * 
     * @type {number}
     * @memberof FuelSensorMetaDataData
     */
    dimension?: number;
    /**
     * 
     * @type {number}
     * @memberof FuelSensorMetaDataData
     */
    emptyCapacitance?: number;
}
/**
 * 
 * @export
 * @interface FuelSensorMetaDataInData
 */
export interface FuelSensorMetaDataInData {
    /**
     * 
     * @type {Array<FuelSensorMetaData>}
     * @memberof FuelSensorMetaDataInData
     */
    data?: Array<FuelSensorMetaData>;
}
/**
 * 
 * @export
 * @interface FuelSensorsAssign
 */
export interface FuelSensorsAssign {
    /**
     * 
     * @type {number}
     * @memberof FuelSensorsAssign
     */
    transceiverId?: number;
    /**
     * 
     * @type {number}
     * @memberof FuelSensorsAssign
     */
    sensorId?: number;
    /**
     * 
     * @type {Tank}
     * @memberof FuelSensorsAssign
     */
    tank?: Tank;
    /**
     * 
     * @type {TankSensor}
     * @memberof FuelSensorsAssign
     */
    tankSensor?: TankSensor;
}
/**
 * 
 * @export
 * @interface FuelTankMetaData
 */
export interface FuelTankMetaData {
    /**
     * 
     * @type {string}
     * @memberof FuelTankMetaData
     */
    date?: string;
    /**
     * 
     * @type {FuelTankMetaDataData}
     * @memberof FuelTankMetaData
     */
    data?: FuelTankMetaDataData;
}
/**
 * 
 * @export
 * @interface FuelTankMetaDataData
 */
export interface FuelTankMetaDataData {
    /**
     * 
     * @type {number}
     * @memberof FuelTankMetaDataData
     */
    minVolume?: number;
    /**
     * 
     * @type {number}
     * @memberof FuelTankMetaDataData
     */
    maxVolume?: number;
}
/**
 * 
 * @export
 * @interface FuelTypesInData
 */
export interface FuelTypesInData {
    /**
     * 
     * @type {Array<FuelTypesInDataData>}
     * @memberof FuelTypesInData
     */
    data?: Array<FuelTypesInDataData>;
}
/**
 * 
 * @export
 * @interface FuelTypesInDataData
 */
export interface FuelTypesInDataData {
    /**
     * 
     * @type {string}
     * @memberof FuelTypesInDataData
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof FuelTypesInDataData
     */
    label?: string;
    /**
     * 
     * @type {number}
     * @memberof FuelTypesInDataData
     */
    fluidDielectric?: number;
    /**
     * 
     * @type {number}
     * @memberof FuelTypesInDataData
     */
    dielectric?: number;
}
/**
 * 
 * @export
 * @interface Gateway
 */
export interface Gateway {
    /**
     * 
     * @type {number}
     * @memberof Gateway
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Gateway
     */
    serialNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof Gateway
     */
    uniqueId?: string;
    /**
     * 
     * @type {string}
     * @memberof Gateway
     */
    status?: string;
    /**
     * 
     * @type {number}
     * @memberof Gateway
     */
    siteId?: number;
    /**
     * 
     * @type {number}
     * @memberof Gateway
     */
    transceiverId?: number;
    /**
     * 
     * @type {string}
     * @memberof Gateway
     */
    hardwareVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof Gateway
     */
    firmwareVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof Gateway
     */
    modbusAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof Gateway
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof Gateway
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof Gateway
     */
    deletedAt?: string;
}
/**
 * 
 * @export
 * @interface GatewayInData
 */
export interface GatewayInData {
    /**
     * 
     * @type {Gateway}
     * @memberof GatewayInData
     */
    data?: Gateway;
}
/**
 * 
 * @export
 * @interface GatewaysInData
 */
export interface GatewaysInData {
    /**
     * 
     * @type {Array<Gateway>}
     * @memberof GatewaysInData
     */
    data?: Array<Gateway>;
}
/**
 * 
 * @export
 * @interface GraphData
 */
export interface GraphData {
    /**
     * 
     * @type {Array<TimeSeriesValue>}
     * @memberof GraphData
     */
    volume?: Array<TimeSeriesValue>;
    /**
     * 
     * @type {Array<TimeSeriesValue>}
     * @memberof GraphData
     */
    temp?: Array<TimeSeriesValue>;
    /**
     * 
     * @type {Array<TimeSeriesValue>}
     * @memberof GraphData
     */
    inlet?: Array<TimeSeriesValue>;
    /**
     * 
     * @type {Array<TimeSeriesValue>}
     * @memberof GraphData
     */
    stirrer?: Array<TimeSeriesValue>;
}
/**
 * 
 * @export
 * @interface GraphDataInData
 */
export interface GraphDataInData {
    /**
     * 
     * @type {GraphData}
     * @memberof GraphDataInData
     */
    data?: GraphData;
}
/**
 * 
 * @export
 * @interface GraphTimeSeriesInData
 */
export interface GraphTimeSeriesInData {
    /**
     * 
     * @type {Array<{ [key: string]: Array<TimeSeriesData>; }>}
     * @memberof GraphTimeSeriesInData
     */
    data?: Array<{ [key: string]: Array<TimeSeriesData>; }>;
}
/**
 * 
 * @export
 * @interface InlineObject
 */
export interface InlineObject {
    /**
     * 
     * @type {Address}
     * @memberof InlineObject
     */
    data?: Address;
}
/**
 * 
 * @export
 * @interface InlineObject1
 */
export interface InlineObject1 {
    /**
     * 
     * @type {Address}
     * @memberof InlineObject1
     */
    data?: Address;
}
/**
 * 
 * @export
 * @interface InlineObject10
 */
export interface InlineObject10 {
    /**
     * 
     * @type {object}
     * @memberof InlineObject10
     */
    formulaCorrection?: object;
}
/**
 * 
 * @export
 * @interface InlineObject11
 */
export interface InlineObject11 {
    /**
     * 
     * @type {SensorsAssign}
     * @memberof InlineObject11
     */
    data?: SensorsAssign;
}
/**
 * 
 * @export
 * @interface InlineObject12
 */
export interface InlineObject12 {
    /**
     * 
     * @type {NotificationData}
     * @memberof InlineObject12
     */
    data?: NotificationData;
}
/**
 * 
 * @export
 * @interface InlineObject13
 */
export interface InlineObject13 {
    /**
     * 
     * @type {NotificationsProductIdGetNotificationsSentBetweenData}
     * @memberof InlineObject13
     */
    data?: NotificationsProductIdGetNotificationsSentBetweenData;
}
/**
 * 
 * @export
 * @interface InlineObject14
 */
export interface InlineObject14 {
    /**
     * 
     * @type {Org}
     * @memberof InlineObject14
     */
    data?: Org;
}
/**
 * 
 * @export
 * @interface InlineObject15
 */
export interface InlineObject15 {
    /**
     * 
     * @type {Org}
     * @memberof InlineObject15
     */
    data?: Org;
}
/**
 * 
 * @export
 * @interface InlineObject16
 */
export interface InlineObject16 {
    /**
     * 
     * @type {Role}
     * @memberof InlineObject16
     */
    data?: Role;
}
/**
 * 
 * @export
 * @interface InlineObject17
 */
export interface InlineObject17 {
    /**
     * 
     * @type {PartnerPartnerIdAddProductData}
     * @memberof InlineObject17
     */
    data?: PartnerPartnerIdAddProductData;
}
/**
 * 
 * @export
 * @interface InlineObject18
 */
export interface InlineObject18 {
    /**
     * 
     * @type {PartnerPartnerIdAddProductData}
     * @memberof InlineObject18
     */
    data?: PartnerPartnerIdAddProductData;
}
/**
 * 
 * @export
 * @interface InlineObject19
 */
export interface InlineObject19 {
    /**
     * 
     * @type {CustomFieldDefinition}
     * @memberof InlineObject19
     */
    data?: CustomFieldDefinition;
}
/**
 * 
 * @export
 * @interface InlineObject2
 */
export interface InlineObject2 {
    /**
     * 
     * @type {Correction}
     * @memberof InlineObject2
     */
    data?: Correction;
}
/**
 * 
 * @export
 * @interface InlineObject20
 */
export interface InlineObject20 {
    /**
     * 
     * @type {CustomFieldDefinition}
     * @memberof InlineObject20
     */
    data?: CustomFieldDefinition;
}
/**
 * 
 * @export
 * @interface InlineObject21
 */
export interface InlineObject21 {
    /**
     * 
     * @type {CustomFieldDefinition}
     * @memberof InlineObject21
     */
    data?: CustomFieldDefinition;
}
/**
 * 
 * @export
 * @interface InlineObject22
 */
export interface InlineObject22 {
    /**
     * 
     * @type {string}
     * @memberof InlineObject22
     */
    data?: string;
}
/**
 * 
 * @export
 * @interface InlineObject23
 */
export interface InlineObject23 {
    /**
     * 
     * @type {string}
     * @memberof InlineObject23
     */
    data?: string;
}
/**
 * 
 * @export
 * @interface InlineObject24
 */
export interface InlineObject24 {
    /**
     * 
     * @type {PartnerCustomSettingsFuel}
     * @memberof InlineObject24
     */
    data?: PartnerCustomSettingsFuel;
}
/**
 * 
 * @export
 * @interface InlineObject25
 */
export interface InlineObject25 {
    /**
     * 
     * @type {OrgProduct}
     * @memberof InlineObject25
     */
    data?: OrgProduct;
}
/**
 * 
 * @export
 * @interface InlineObject26
 */
export interface InlineObject26 {
    /**
     * 
     * @type {SensorsAssign}
     * @memberof InlineObject26
     */
    data?: SensorsAssign;
}
/**
 * 
 * @export
 * @interface InlineObject27
 */
export interface InlineObject27 {
    /**
     * 
     * @type {FuelSensorsAssign}
     * @memberof InlineObject27
     */
    data?: FuelSensorsAssign;
}
/**
 * 
 * @export
 * @interface InlineObject28
 */
export interface InlineObject28 {
    /**
     * 
     * @type {SensorsAssign}
     * @memberof InlineObject28
     */
    data?: SensorsAssign;
}
/**
 * 
 * @export
 * @interface InlineObject29
 */
export interface InlineObject29 {
    /**
     * 
     * @type {Array<Vat>}
     * @memberof InlineObject29
     */
    data?: Array<Vat>;
}
/**
 * 
 * @export
 * @interface InlineObject3
 */
export interface InlineObject3 {
    /**
     * 
     * @type {Correction}
     * @memberof InlineObject3
     */
    data?: Correction;
}
/**
 * 
 * @export
 * @interface InlineObject30
 */
export interface InlineObject30 {
    /**
     * 
     * @type {ProductFault}
     * @memberof InlineObject30
     */
    data?: ProductFault;
}
/**
 * 
 * @export
 * @interface InlineObject31
 */
export interface InlineObject31 {
    /**
     * 
     * @type {ProductFault}
     * @memberof InlineObject31
     */
    data?: ProductFault;
}
/**
 * 
 * @export
 * @interface InlineObject32
 */
export interface InlineObject32 {
    /**
     * 
     * @type {ProductsProductIdJobData}
     * @memberof InlineObject32
     */
    data?: ProductsProductIdJobData;
}
/**
 * 
 * @export
 * @interface InlineObject33
 */
export interface InlineObject33 {
    /**
     * 
     * @type {number}
     * @memberof InlineObject33
     */
    productId?: number;
    /**
     * 
     * @type {string}
     * @memberof InlineObject33
     */
    entityType?: string;
    /**
     * 
     * @type {number}
     * @memberof InlineObject33
     */
    entityId?: number;
}
/**
 * 
 * @export
 * @interface InlineObject34
 */
export interface InlineObject34 {
    /**
     * 
     * @type {Pickup}
     * @memberof InlineObject34
     */
    data?: Pickup;
}
/**
 * 
 * @export
 * @interface InlineObject35
 */
export interface InlineObject35 {
    /**
     * Additional data to pass to server
     * @type {string}
     * @memberof InlineObject35
     */
    additionalMetadata?: string;
    /**
     * file to upload
     * @type {any}
     * @memberof InlineObject35
     */
    file?: any;
}
/**
 * 
 * @export
 * @interface InlineObject36
 */
export interface InlineObject36 {
    /**
     * 
     * @type {VatsVatIdSetEmptyDistanceData}
     * @memberof InlineObject36
     */
    data?: VatsVatIdSetEmptyDistanceData;
}
/**
 * 
 * @export
 * @interface InlineObject37
 */
export interface InlineObject37 {
    /**
     * 
     * @type {UsersUserIdRolesData}
     * @memberof InlineObject37
     */
    data?: UsersUserIdRolesData;
}
/**
 * 
 * @export
 * @interface InlineObject38
 */
export interface InlineObject38 {
    /**
     * 
     * @type {Permission}
     * @memberof InlineObject38
     */
    data?: Permission;
}
/**
 * 
 * @export
 * @interface InlineObject39
 */
export interface InlineObject39 {
    /**
     * 
     * @type {Permission}
     * @memberof InlineObject39
     */
    data?: Permission;
}
/**
 * 
 * @export
 * @interface InlineObject4
 */
export interface InlineObject4 {
    /**
     * 
     * @type {number}
     * @memberof InlineObject4
     */
    eventSubscriptionId: number;
    /**
     * 
     * @type {object}
     * @memberof InlineObject4
     */
    eventData?: object | null;
}
/**
 * 
 * @export
 * @interface InlineObject40
 */
export interface InlineObject40 {
    /**
     * 
     * @type {TankInput}
     * @memberof InlineObject40
     */
    data?: TankInput;
}
/**
 * 
 * @export
 * @interface InlineObject41
 */
export interface InlineObject41 {
    /**
     * 
     * @type {TankInput}
     * @memberof InlineObject41
     */
    data?: TankInput;
}
/**
 * 
 * @export
 * @interface InlineObject42
 */
export interface InlineObject42 {
    /**
     * 
     * @type {FuelSensorsAssign}
     * @memberof InlineObject42
     */
    data?: FuelSensorsAssign;
}
/**
 * 
 * @export
 * @interface InlineObject43
 */
export interface InlineObject43 {
    /**
     * Additional data to pass to server
     * @type {string}
     * @memberof InlineObject43
     */
    additionalMetadata?: string;
    /**
     * file to upload
     * @type {any}
     * @memberof InlineObject43
     */
    file?: any;
}
/**
 * 
 * @export
 * @interface InlineObject5
 */
export interface InlineObject5 {
    /**
     * 
     * @type {string}
     * @memberof InlineObject5
     */
    eventType?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineObject5
     */
    eventData?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineObject5
     */
    entityType?: string;
    /**
     * 
     * @type {number}
     * @memberof InlineObject5
     */
    entityId?: number;
    /**
     * 
     * @type {number}
     * @memberof InlineObject5
     */
    productId?: number;
    /**
     * 
     * @type {string}
     * @memberof InlineObject5
     */
    email?: string | null;
}
/**
 * 
 * @export
 * @interface InlineObject6
 */
export interface InlineObject6 {
    /**
     * 
     * @type {EventNotificationsNotifySupportData}
     * @memberof InlineObject6
     */
    data?: EventNotificationsNotifySupportData;
}
/**
 * 
 * @export
 * @interface InlineObject7
 */
export interface InlineObject7 {
    /**
     * 
     * @type {EventSubscriptionProperties}
     * @memberof InlineObject7
     */
    data?: EventSubscriptionProperties;
}
/**
 * 
 * @export
 * @interface InlineObject8
 */
export interface InlineObject8 {
    /**
     * 
     * @type {EventSubscriptionProperties}
     * @memberof InlineObject8
     */
    data?: EventSubscriptionProperties;
}
/**
 * 
 * @export
 * @interface InlineObject9
 */
export interface InlineObject9 {
    /**
     * 
     * @type {FeedTankAdd}
     * @memberof InlineObject9
     */
    data?: FeedTankAdd;
}
/**
 * 
 * @export
 * @interface InlineResponse200
 */
export interface InlineResponse200 {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse200
     */
    msg?: InlineResponse200MsgEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum InlineResponse200MsgEnum {
    SuccessfullyLoggedOut = 'Successfully logged out'
}

/**
 * 
 * @export
 * @interface InlineResponse2001
 */
export interface InlineResponse2001 {
    /**
     * 
     * @type {User}
     * @memberof InlineResponse2001
     */
    data?: User;
}
/**
 * 
 * @export
 * @interface InlineResponse20010
 */
export interface InlineResponse20010 {
    /**
     * 
     * @type {Array<RawData>}
     * @memberof InlineResponse20010
     */
    data?: Array<RawData>;
    /**
     * 
     * @type {Array<Pagination>}
     * @memberof InlineResponse20010
     */
    links?: Array<Pagination>;
}
/**
 * 
 * @export
 * @interface InlineResponse20011
 */
export interface InlineResponse20011 {
    /**
     * 
     * @type {Array<Formula>}
     * @memberof InlineResponse20011
     */
    data?: Array<Formula>;
}
/**
 * 
 * @export
 * @interface InlineResponse20012
 */
export interface InlineResponse20012 {
    /**
     * 
     * @type {Array<Notification>}
     * @memberof InlineResponse20012
     */
    data?: Array<Notification>;
}
/**
 * 
 * @export
 * @interface InlineResponse20013
 */
export interface InlineResponse20013 {
    /**
     * 
     * @type {Array<PaymentMethod>}
     * @memberof InlineResponse20013
     */
    data?: Array<PaymentMethod>;
}
/**
 * 
 * @export
 * @interface InlineResponse20014
 */
export interface InlineResponse20014 {
    /**
     * 
     * @type {Array<InlineResponse20014Data>}
     * @memberof InlineResponse20014
     */
    data?: Array<InlineResponse20014Data>;
}
/**
 * 
 * @export
 * @interface InlineResponse20014Data
 */
export interface InlineResponse20014Data {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20014Data
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20014Data
     */
    billtoOrgId?: number | null;
}
/**
 * 
 * @export
 * @interface InlineResponse20015
 */
export interface InlineResponse20015 {
    /**
     * 
     * @type {Array<Org>}
     * @memberof InlineResponse20015
     */
    data?: Array<Org>;
}
/**
 * 
 * @export
 * @interface InlineResponse20016
 */
export interface InlineResponse20016 {
    /**
     * 
     * @type {InlineResponse20016Data}
     * @memberof InlineResponse20016
     */
    data?: InlineResponse20016Data;
}
/**
 * 
 * @export
 * @interface InlineResponse20016Data
 */
export interface InlineResponse20016Data {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20016Data
     */
    message?: InlineResponse20016DataMessageEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum InlineResponse20016DataMessageEnum {
    Success = 'success'
}

/**
 * 
 * @export
 * @interface InlineResponse20017
 */
export interface InlineResponse20017 {
    /**
     * 
     * @type {PartnerUser}
     * @memberof InlineResponse20017
     */
    data?: PartnerUser;
}
/**
 * 
 * @export
 * @interface InlineResponse20018
 */
export interface InlineResponse20018 {
    /**
     * 
     * @type {PartnerCustomSettingsFuel}
     * @memberof InlineResponse20018
     */
    data?: PartnerCustomSettingsFuel;
}
/**
 * 
 * @export
 * @interface InlineResponse20019
 */
export interface InlineResponse20019 {
    /**
     * 
     * @type {Array<number>}
     * @memberof InlineResponse20019
     */
    data?: Array<number>;
}
/**
 * 
 * @export
 * @interface InlineResponse2002
 */
export interface InlineResponse2002 {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse2002
     */
    message?: InlineResponse2002MessageEnum;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse2002
     */
    data?: InlineResponse2002DataEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum InlineResponse2002MessageEnum {
    PasswordResetEmailSent = 'Password reset email sent.'
}
/**
    * @export
    * @enum {string}
    */
export enum InlineResponse2002DataEnum {
    PasswordsSent = 'passwords.sent'
}

/**
 * 
 * @export
 * @interface InlineResponse20020
 */
export interface InlineResponse20020 {
    /**
     * 
     * @type {InlineResponse20020Data}
     * @memberof InlineResponse20020
     */
    data?: InlineResponse20020Data;
}
/**
 * 
 * @export
 * @interface InlineResponse20020Data
 */
export interface InlineResponse20020Data {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20020Data
     */
    numUsersAllowed?: number;
}
/**
 * 
 * @export
 * @interface InlineResponse20021
 */
export interface InlineResponse20021 {
    /**
     * 
     * @type {Array<Pickup>}
     * @memberof InlineResponse20021
     */
    data?: Array<Pickup>;
}
/**
 * 
 * @export
 * @interface InlineResponse20022
 */
export interface InlineResponse20022 {
    /**
     * 
     * @type {Transceiver}
     * @memberof InlineResponse20022
     */
    data?: Transceiver;
}
/**
 * 
 * @export
 * @interface InlineResponse20023
 */
export interface InlineResponse20023 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20023
     */
    data?: boolean;
}
/**
 * 
 * @export
 * @interface InlineResponse20024
 */
export interface InlineResponse20024 {
    /**
     * 
     * @type {Array<Tank>}
     * @memberof InlineResponse20024
     */
    data?: Array<Tank>;
}
/**
 * 
 * @export
 * @interface InlineResponse20025
 */
export interface InlineResponse20025 {
    /**
     * 
     * @type {Tank}
     * @memberof InlineResponse20025
     */
    data?: Tank;
}
/**
 * 
 * @export
 * @interface InlineResponse20026
 */
export interface InlineResponse20026 {
    /**
     * 
     * @type {Array<TankReading>}
     * @memberof InlineResponse20026
     */
    data?: Array<TankReading>;
}
/**
 * 
 * @export
 * @interface InlineResponse20027
 */
export interface InlineResponse20027 {
    /**
     * 
     * @type {Array<FuelSensorMetaData>}
     * @memberof InlineResponse20027
     */
    data?: Array<FuelSensorMetaData>;
}
/**
 * 
 * @export
 * @interface InlineResponse20028
 */
export interface InlineResponse20028 {
    /**
     * 
     * @type {Array<FuelTankMetaData>}
     * @memberof InlineResponse20028
     */
    data?: Array<FuelTankMetaData>;
}
/**
 * 
 * @export
 * @interface InlineResponse2003
 */
export interface InlineResponse2003 {
    /**
     * 
     * @type {Array<ConsentWithId>}
     * @memberof InlineResponse2003
     */
    data?: Array<ConsentWithId>;
}
/**
 * 
 * @export
 * @interface InlineResponse2004
 */
export interface InlineResponse2004 {
    /**
     * 
     * @type {Array<ConsentConditionWithId>}
     * @memberof InlineResponse2004
     */
    data?: Array<ConsentConditionWithId>;
}
/**
 * 
 * @export
 * @interface InlineResponse2005
 */
export interface InlineResponse2005 {
    /**
     * 
     * @type {Array<ConsentConditionType>}
     * @memberof InlineResponse2005
     */
    data?: Array<ConsentConditionType>;
}
/**
 * 
 * @export
 * @interface InlineResponse2006
 */
export interface InlineResponse2006 {
    /**
     * 
     * @type {Array<Correction>}
     * @memberof InlineResponse2006
     */
    data?: Array<Correction>;
}
/**
 * 
 * @export
 * @interface InlineResponse2007
 */
export interface InlineResponse2007 {
    /**
     * 
     * @type {Array<EventType>}
     * @memberof InlineResponse2007
     */
    data?: Array<EventType>;
}
/**
 * 
 * @export
 * @interface InlineResponse2008
 */
export interface InlineResponse2008 {
    /**
     * 
     * @type {object}
     * @memberof InlineResponse2008
     */
    data?: object;
}
/**
 * 
 * @export
 * @interface InlineResponse2009
 */
export interface InlineResponse2009 {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse2009
     */
    success?: InlineResponse2009SuccessEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum InlineResponse2009SuccessEnum {
    CorrectionDeleted = 'Correction deleted'
}

/**
 * 
 * @export
 * @interface InlineResponse201
 */
export interface InlineResponse201 {
    /**
     * 
     * @type {EventSubscription}
     * @memberof InlineResponse201
     */
    data?: EventSubscription;
}
/**
 * 
 * @export
 * @interface InlineResponse2011
 */
export interface InlineResponse2011 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2011
     */
    orgId?: number;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2011
     */
    productId?: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse2011
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse2011
     */
    updatedAt?: string;
}
/**
 * 
 * @export
 * @interface InlineResponse2012
 */
export interface InlineResponse2012 {
    /**
     * 
     * @type {Array<CustomFieldDefinition>}
     * @memberof InlineResponse2012
     */
    data?: Array<CustomFieldDefinition>;
}
/**
 * 
 * @export
 * @interface InlineResponse2013
 */
export interface InlineResponse2013 {
    /**
     * 
     * @type {InlineResponse2013Data}
     * @memberof InlineResponse2013
     */
    data?: InlineResponse2013Data;
}
/**
 * 
 * @export
 * @interface InlineResponse2013Data
 */
export interface InlineResponse2013Data {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2013Data
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2013Data
     */
    productId?: number;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2013Data
     */
    orgId?: number;
    /**
     * 
     * @type {Array<object>}
     * @memberof InlineResponse2013Data
     */
    customFieldData?: Array<object>;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse2013Data
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse2013Data
     */
    updatedAt?: string;
}
/**
 * 
 * @export
 * @interface InlineResponse2014
 */
export interface InlineResponse2014 {
    /**
     * 
     * @type {PartnerOrgEntity}
     * @memberof InlineResponse2014
     */
    data?: PartnerOrgEntity;
}
/**
 * 
 * @export
 * @interface InlineResponse400
 */
export interface InlineResponse400 {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse400
     */
    errors?: string;
}
/**
 * 
 * @export
 * @interface InlineResponse401
 */
export interface InlineResponse401 {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse401
     */
    status?: InlineResponse401StatusEnum;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse401
     */
    error?: InlineResponse401ErrorEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum InlineResponse401StatusEnum {
    Error = 'error'
}
/**
    * @export
    * @enum {string}
    */
export enum InlineResponse401ErrorEnum {
    InvalidCredentials = 'Invalid credentials.'
}

/**
 * 
 * @export
 * @interface InlineResponse403
 */
export interface InlineResponse403 {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse403
     */
    status?: InlineResponse403StatusEnum;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse403
     */
    error?: InlineResponse403ErrorEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum InlineResponse403StatusEnum {
    Error = 'error'
}
/**
    * @export
    * @enum {string}
    */
export enum InlineResponse403ErrorEnum {
    NotAPartner = 'Not a partner.'
}

/**
 * 
 * @export
 * @interface InlineResponse404
 */
export interface InlineResponse404 {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse404
     */
    errors?: InlineResponse404ErrorsEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum InlineResponse404ErrorsEnum {
    CorrectionNotFound = 'Correction not found'
}

/**
 * 
 * @export
 * @interface InlineResponse4041
 */
export interface InlineResponse4041 {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse4041
     */
    errors?: InlineResponse4041ErrorsEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum InlineResponse4041ErrorsEnum {
    GatewayNotFound = 'Gateway not found'
}

/**
 * 
 * @export
 * @interface InlineResponse4042
 */
export interface InlineResponse4042 {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse4042
     */
    errors?: InlineResponse4042ErrorsEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum InlineResponse4042ErrorsEnum {
    NodeNotFound = 'Node not found'
}

/**
 * 
 * @export
 * @interface InlineResponse4043
 */
export interface InlineResponse4043 {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse4043
     */
    errors?: InlineResponse4043ErrorsEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum InlineResponse4043ErrorsEnum {
    ResourceNotFound = 'Resource not found'
}

/**
 * 
 * @export
 * @interface InlineResponse4044
 */
export interface InlineResponse4044 {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse4044
     */
    errors?: InlineResponse4044ErrorsEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum InlineResponse4044ErrorsEnum {
    ProductAccessoryNotFound = 'Product Accessory not found'
}

/**
 * 
 * @export
 * @interface InlineResponse4045
 */
export interface InlineResponse4045 {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse4045
     */
    errors?: InlineResponse4045ErrorsEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum InlineResponse4045ErrorsEnum {
    TransceiverNotFound = 'Transceiver not found'
}

/**
 * 
 * @export
 * @interface InlineResponse4046
 */
export interface InlineResponse4046 {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse4046
     */
    errors?: InlineResponse4046ErrorsEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum InlineResponse4046ErrorsEnum {
    SensorNotFound = 'Sensor not found'
}

/**
 * 
 * @export
 * @interface InstallVat
 */
export interface InstallVat {
    /**
     * 
     * @type {number}
     * @memberof InstallVat
     */
    transceiverId?: number;
    /**
     * 
     * @type {string}
     * @memberof InstallVat
     */
    entityType?: string;
    /**
     * 
     * @type {Array<InstallVatSensors>}
     * @memberof InstallVat
     */
    sensors?: Array<InstallVatSensors>;
}
/**
 * 
 * @export
 * @interface InstallVatInData
 */
export interface InstallVatInData {
    /**
     * 
     * @type {InstallVat}
     * @memberof InstallVatInData
     */
    data?: InstallVat;
}
/**
 * 
 * @export
 * @interface InstallVatSensors
 */
export interface InstallVatSensors {
    /**
     * 
     * @type {number}
     * @memberof InstallVatSensors
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof InstallVatSensors
     */
    type?: string;
}
/**
 * 
 * @export
 * @interface Job
 */
export interface Job {
    /**
     * 
     * @type {number}
     * @memberof Job
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof Job
     */
    productId?: number;
    /**
     * 
     * @type {number}
     * @memberof Job
     */
    userId?: number;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    notes?: string;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    status?: string;
}
/**
 * 
 * @export
 * @interface JobInData
 */
export interface JobInData {
    /**
     * 
     * @type {Job}
     * @memberof JobInData
     */
    data?: Job;
}
/**
 * 
 * @export
 * @interface JobsInData
 */
export interface JobsInData {
    /**
     * 
     * @type {Array<Job>}
     * @memberof JobsInData
     */
    data?: Array<Job>;
}
/**
 * 
 * @export
 * @interface LastCheckInTime
 */
export interface LastCheckInTime {
    /**
     * 
     * @type {number}
     * @memberof LastCheckInTime
     */
    lastCheckInTimestamp?: number;
}
/**
 * 
 * @export
 * @interface LastCheckInTimeInData
 */
export interface LastCheckInTimeInData {
    /**
     * 
     * @type {LastCheckInTime}
     * @memberof LastCheckInTimeInData
     */
    data?: LastCheckInTime;
}
/**
 * 
 * @export
 * @interface LatLong
 */
export interface LatLong {
    /**
     * 
     * @type {number}
     * @memberof LatLong
     */
    lat?: number;
    /**
     * 
     * @type {number}
     * @memberof LatLong
     */
    lon?: number;
}
/**
 * 
 * @export
 * @interface ListOfProductIds
 */
export interface ListOfProductIds {
    /**
     * 
     * @type {Array<number>}
     * @memberof ListOfProductIds
     */
    productIds?: Array<number>;
}
/**
 * 
 * @export
 * @interface Login
 */
export interface Login {
    /**
     * 
     * @type {string}
     * @memberof Login
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof Login
     */
    password?: string;
}
/**
 * 
 * @export
 * @interface MilkScoreHistoryInData
 */
export interface MilkScoreHistoryInData {
    /**
     * 
     * @type {Array<object>}
     * @memberof MilkScoreHistoryInData
     */
    data?: Array<object>;
}
/**
 * 
 * @export
 * @interface Milkings
 */
export interface Milkings {
    /**
     * 
     * @type {string}
     * @memberof Milkings
     */
    supplyNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof Milkings
     */
    vatNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof Milkings
     */
    milkingType?: MilkingsMilkingTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Milkings
     */
    milkingStartDateTime?: string;
    /**
     * 
     * @type {string}
     * @memberof Milkings
     */
    milkingFinishDateTime?: string;
    /**
     * 
     * @type {number}
     * @memberof Milkings
     */
    milkingStartTemp?: number;
    /**
     * 
     * @type {number}
     * @memberof Milkings
     */
    milkingStartVolume?: number;
    /**
     * 
     * @type {number}
     * @memberof Milkings
     */
    milkingFinishTemp?: number;
    /**
     * 
     * @type {number}
     * @memberof Milkings
     */
    milkingFinishVolume?: number;
    /**
     * 
     * @type {number}
     * @memberof Milkings
     */
    milkingTempSixHoursAfterStart?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof Milkings
     */
    milkingContainsMilkSixHoursAfterStart?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Milkings
     */
    milkingTempTwoHoursAfterFinish?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof Milkings
     */
    milkingContainsMilkTwoHoursAfterFinish?: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum MilkingsMilkingTypeEnum {
    First = 'first',
    Subsequent = 'subsequent'
}

/**
 * 
 * @export
 * @interface Node
 */
export interface Node {
    /**
     * 
     * @type {number}
     * @memberof Node
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Node
     */
    serialNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof Node
     */
    uniqueId?: string;
    /**
     * 
     * @type {string}
     * @memberof Node
     */
    status?: string;
    /**
     * 
     * @type {number}
     * @memberof Node
     */
    siteId?: number;
    /**
     * 
     * @type {number}
     * @memberof Node
     */
    gatewayId?: number;
    /**
     * 
     * @type {string}
     * @memberof Node
     */
    hardwareVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof Node
     */
    firmwareVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof Node
     */
    modbusAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof Node
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof Node
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof Node
     */
    deletedAt?: string;
    /**
     * 
     * @type {Array<Sensor>}
     * @memberof Node
     */
    sensors?: Array<Sensor> | null;
}
/**
 * 
 * @export
 * @interface NodeInData
 */
export interface NodeInData {
    /**
     * 
     * @type {Node}
     * @memberof NodeInData
     */
    data?: Node;
}
/**
 * 
 * @export
 * @interface NodesInData
 */
export interface NodesInData {
    /**
     * 
     * @type {Array<Node>}
     * @memberof NodesInData
     */
    data?: Array<Node>;
}
/**
 * 
 * @export
 * @interface Notification
 */
export interface Notification {
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    id?: string;
    /**
     * userId
     * @type {number}
     * @memberof Notification
     */
    notifiable_id?: number;
    /**
     * users
     * @type {string}
     * @memberof Notification
     */
    notifiable_type?: string;
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    data?: string;
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    read_at?: string;
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    created_at?: string;
    /**
     * 
     * @type {number}
     * @memberof Notification
     */
    productId?: number;
}
/**
 * 
 * @export
 * @interface NotificationData
 */
export interface NotificationData {
    /**
     * 
     * @type {number}
     * @memberof NotificationData
     */
    alertId?: number;
    /**
     * 
     * @type {number}
     * @memberof NotificationData
     */
    userId?: number | null;
    /**
     * 
     * @type {object}
     * @memberof NotificationData
     */
    data?: object | null;
}
/**
 * 
 * @export
 * @interface NotificationsProductIdGetNotificationsSentBetweenData
 */
export interface NotificationsProductIdGetNotificationsSentBetweenData {
    /**
     * 
     * @type {number}
     * @memberof NotificationsProductIdGetNotificationsSentBetweenData
     */
    startTs?: number;
    /**
     * 
     * @type {number}
     * @memberof NotificationsProductIdGetNotificationsSentBetweenData
     */
    endTs?: number;
}
/**
 * 
 * @export
 * @interface NotificationsSent
 */
export interface NotificationsSent {
    /**
     * 
     * @type {string}
     * @memberof NotificationsSent
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationsSent
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationsSent
     */
    data?: string;
    /**
     * 
     * @type {number}
     * @memberof NotificationsSent
     */
    userId?: number;
    /**
     * 
     * @type {number}
     * @memberof NotificationsSent
     */
    productId?: number;
    /**
     * 
     * @type {string}
     * @memberof NotificationsSent
     */
    userName?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationsSent
     */
    userEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationsSent
     */
    userPhone?: string;
}
/**
 * 
 * @export
 * @interface NotificationsSentInData
 */
export interface NotificationsSentInData {
    /**
     * 
     * @type {Array<NotificationsSent>}
     * @memberof NotificationsSentInData
     */
    data?: Array<NotificationsSent>;
}
/**
 * 
 * @export
 * @interface NumNotificationsInData
 */
export interface NumNotificationsInData {
    /**
     * 
     * @type {NumNotificationsInDataData}
     * @memberof NumNotificationsInData
     */
    data?: NumNotificationsInDataData;
}
/**
 * 
 * @export
 * @interface NumNotificationsInDataData
 */
export interface NumNotificationsInDataData {
    /**
     * 
     * @type {number}
     * @memberof NumNotificationsInDataData
     */
    sms?: number;
    /**
     * 
     * @type {number}
     * @memberof NumNotificationsInDataData
     */
    mail?: number;
}
/**
 * 
 * @export
 * @interface OrdwayPlans
 */
export interface OrdwayPlans {
    /**
     * 
     * @type {number}
     * @memberof OrdwayPlans
     */
    productId?: number;
    /**
     * 
     * @type {string}
     * @memberof OrdwayPlans
     */
    ordwayDirectPlanId?: string;
    /**
     * 
     * @type {string}
     * @memberof OrdwayPlans
     */
    ordwayDirectPlanName?: string;
    /**
     * 
     * @type {string}
     * @memberof OrdwayPlans
     */
    ordwayDirectPlanProductTier?: string;
    /**
     * 
     * @type {number}
     * @memberof OrdwayPlans
     */
    partnerId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof OrdwayPlans
     */
    ordwayPartnerPlanId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrdwayPlans
     */
    ordwayPartnerPlanName?: string | null;
}
/**
 * 
 * @export
 * @interface Org
 */
export interface Org {
    /**
     * 
     * @type {number}
     * @memberof Org
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Org
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Org
     */
    web?: string;
    /**
     * 
     * @type {string}
     * @memberof Org
     */
    phone?: string;
    /**
     * 
     * @type {number}
     * @memberof Org
     */
    parentId?: number;
    /**
     * 
     * @type {number}
     * @memberof Org
     */
    adminId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Org
     */
    terms?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Org
     */
    farmSourceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof Org
     */
    farmSourceName?: string;
    /**
     * 
     * @type {string}
     * @memberof Org
     */
    paymentMethod?: string;
    /**
     * 
     * @type {string}
     * @memberof Org
     */
    accountName?: string;
    /**
     * 
     * @type {string}
     * @memberof Org
     */
    accountNumber?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Org
     */
    accountApproved?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Org
     */
    directDebitDate?: string;
    /**
     * how many total users this subscription allows including me
     * @type {number}
     * @memberof Org
     */
    maxUsers?: number;
    /**
     * how many days worth of event history is visible in the subscription
     * @type {number}
     * @memberof Org
     */
    maxActivityDays?: number;
    /**
     * 
     * @type {string}
     * @memberof Org
     */
    supplierCode?: string | null;
    /**
     * 
     * @type {Address}
     * @memberof Org
     */
    address?: Address;
    /**
     * 
     * @type {string}
     * @memberof Org
     */
    annualBillingStartDate?: string;
    /**
     * 
     * @type {string}
     * @memberof Org
     */
    orgType?: string;
}
/**
 * 
 * @export
 * @interface OrgInData
 */
export interface OrgInData {
    /**
     * 
     * @type {Org}
     * @memberof OrgInData
     */
    data?: Org;
}
/**
 * 
 * @export
 * @interface OrgProduct
 */
export interface OrgProduct {
    /**
     * 
     * @type {Org}
     * @memberof OrgProduct
     */
    org?: Org;
    /**
     * 
     * @type {Site}
     * @memberof OrgProduct
     */
    site?: Site;
    /**
     * 
     * @type {Product}
     * @memberof OrgProduct
     */
    product?: Product;
    /**
     * 
     * @type {User}
     * @memberof OrgProduct
     */
    user?: User;
}
/**
 * 
 * @export
 * @interface OrgRole
 */
export interface OrgRole {
    /**
     * 
     * @type {number}
     * @memberof OrgRole
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof OrgRole
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof OrgRole
     */
    supplierNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof OrgRole
     */
    role?: string;
}
/**
 * 
 * @export
 * @interface OrgRoleInData
 */
export interface OrgRoleInData {
    /**
     * 
     * @type {OrgRole}
     * @memberof OrgRoleInData
     */
    data?: OrgRole;
}
/**
 * 
 * @export
 * @interface OrgRolesInData
 */
export interface OrgRolesInData {
    /**
     * 
     * @type {Array<OrgRole>}
     * @memberof OrgRolesInData
     */
    data?: Array<OrgRole>;
}
/**
 * 
 * @export
 * @interface OrgsInData
 */
export interface OrgsInData {
    /**
     * 
     * @type {Array<Org>}
     * @memberof OrgsInData
     */
    data?: Array<Org>;
}
/**
 * 
 * @export
 * @interface Pagination
 */
export interface Pagination {
    /**
     * 
     * @type {string}
     * @memberof Pagination
     */
    nextKey?: string;
    /**
     * 
     * @type {string}
     * @memberof Pagination
     */
    nextSort?: string;
    /**
     * 
     * @type {string}
     * @memberof Pagination
     */
    currentKey?: string;
    /**
     * 
     * @type {string}
     * @memberof Pagination
     */
    currentSortKey?: string;
}
/**
 * 
 * @export
 * @interface PartnerContributionTiers
 */
export interface PartnerContributionTiers {
    /**
     * 
     * @type {Array<string>}
     * @memberof PartnerContributionTiers
     */
    contributionTiers?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PartnerContributionTiers
     */
    contributionTierDefault?: string;
}
/**
 * 
 * @export
 * @interface PartnerContributionTiersInData
 */
export interface PartnerContributionTiersInData {
    /**
     * 
     * @type {PartnerContributionTiers}
     * @memberof PartnerContributionTiersInData
     */
    data?: PartnerContributionTiers;
}
/**
 * 
 * @export
 * @interface PartnerCustomSettingsFuel
 */
export interface PartnerCustomSettingsFuel {
    /**
     * 
     * @type {number}
     * @memberof PartnerCustomSettingsFuel
     */
    lowLevelThreshold?: number;
    /**
     * 
     * @type {number}
     * @memberof PartnerCustomSettingsFuel
     */
    criticalLevelThreshold?: number;
}
/**
 * 
 * @export
 * @interface PartnerNewSite
 */
export interface PartnerNewSite {
    /**
     * 
     * @type {number}
     * @memberof PartnerNewSite
     */
    partnerId?: number;
    /**
     * 
     * @type {number}
     * @memberof PartnerNewSite
     */
    productId?: number;
    /**
     * 
     * @type {Array<object>}
     * @memberof PartnerNewSite
     */
    customFieldData?: Array<object>;
    /**
     * 
     * @type {Array<object>}
     * @memberof PartnerNewSite
     */
    customSettingsData?: Array<object>;
    /**
     * 
     * @type {string}
     * @memberof PartnerNewSite
     */
    comments?: string;
    /**
     * 
     * @type {number}
     * @memberof PartnerNewSite
     */
    partnerDefinedId?: number;
    /**
     * 
     * @type {string}
     * @memberof PartnerNewSite
     */
    partnerDefinedName?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerNewSite
     */
    contributionTier?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerNewSite
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerNewSite
     */
    supplier?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerNewSite
     */
    supplierNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerNewSite
     */
    productLiveAt?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerNewSite
     */
    productStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerNewSite
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerNewSite
     */
    siteName?: string;
    /**
     * 
     * @type {number}
     * @memberof PartnerNewSite
     */
    latitude?: number;
    /**
     * 
     * @type {number}
     * @memberof PartnerNewSite
     */
    longitude?: number;
    /**
     * 
     * @type {number}
     * @memberof PartnerNewSite
     */
    entityId?: number;
    /**
     * 
     * @type {string}
     * @memberof PartnerNewSite
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof PartnerNewSite
     */
    capacity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PartnerNewSite
     */
    safeFillVolume?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PartnerNewSite
     */
    fuelType?: string | null;
    /**
     * 
     * @type {VatState}
     * @memberof PartnerNewSite
     */
    state?: VatState | null;
    /**
     * 
     * @type {string}
     * @memberof PartnerNewSite
     */
    entityStatus?: string;
    /**
     * 
     * @type {Array<object>}
     * @memberof PartnerNewSite
     */
    entityCustomFieldData?: Array<object>;
    /**
     * 
     * @type {Array<object>}
     * @memberof PartnerNewSite
     */
    entityCustomSettingsData?: Array<object>;
    /**
     * 
     * @type {string}
     * @memberof PartnerNewSite
     */
    entityComments?: string;
    /**
     * 
     * @type {number}
     * @memberof PartnerNewSite
     */
    partnerDefinedEntityId?: number;
    /**
     * 
     * @type {string}
     * @memberof PartnerNewSite
     */
    partnerDefinedEntityName?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerNewSite
     */
    siteContactName?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerNewSite
     */
    siteContactEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerNewSite
     */
    siteContactPhone?: string | null;
}
/**
 * 
 * @export
 * @interface PartnerNewSitesInData
 */
export interface PartnerNewSitesInData {
    /**
     * 
     * @type {Array<PartnerNewSite>}
     * @memberof PartnerNewSitesInData
     */
    data?: Array<PartnerNewSite>;
}
/**
 * 
 * @export
 * @interface PartnerOrgEntity
 */
export interface PartnerOrgEntity {
    /**
     * 
     * @type {number}
     * @memberof PartnerOrgEntity
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof PartnerOrgEntity
     */
    entityId?: number;
    /**
     * 
     * @type {string}
     * @memberof PartnerOrgEntity
     */
    entityType?: string;
    /**
     * 
     * @type {number}
     * @memberof PartnerOrgEntity
     */
    partnerId?: number;
    /**
     * 
     * @type {Array<object>}
     * @memberof PartnerOrgEntity
     */
    customFieldData?: Array<object>;
    /**
     * 
     * @type {Array<object>}
     * @memberof PartnerOrgEntity
     */
    customSettingsData?: Array<object>;
    /**
     * 
     * @type {object}
     * @memberof PartnerOrgEntity
     */
    comments?: object;
    /**
     * 
     * @type {string}
     * @memberof PartnerOrgEntity
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerOrgEntity
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerOrgEntity
     */
    partnerDefinedId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PartnerOrgEntity
     */
    partnerDefinedName?: string | null;
}
/**
 * 
 * @export
 * @interface PartnerPartnerIdAddProductData
 */
export interface PartnerPartnerIdAddProductData {
    /**
     * 
     * @type {number}
     * @memberof PartnerPartnerIdAddProductData
     */
    productId?: number;
}
/**
 * 
 * @export
 * @interface PartnerPendingSite
 */
export interface PartnerPendingSite {
    /**
     * 
     * @type {number}
     * @memberof PartnerPendingSite
     */
    partnerId?: number;
    /**
     * 
     * @type {number}
     * @memberof PartnerPendingSite
     */
    productId?: number;
    /**
     * 
     * @type {Array<object>}
     * @memberof PartnerPendingSite
     */
    customFieldData?: Array<object>;
    /**
     * 
     * @type {Array<object>}
     * @memberof PartnerPendingSite
     */
    customSettingsData?: Array<object>;
    /**
     * 
     * @type {string}
     * @memberof PartnerPendingSite
     */
    comments?: string;
    /**
     * 
     * @type {number}
     * @memberof PartnerPendingSite
     */
    partnerDefinedId?: number;
    /**
     * 
     * @type {string}
     * @memberof PartnerPendingSite
     */
    partnerDefinedName?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerPendingSite
     */
    contributionTier?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerPendingSite
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerPendingSite
     */
    supplier?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerPendingSite
     */
    supplierNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerPendingSite
     */
    productCreatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerPendingSite
     */
    productStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerPendingSite
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerPendingSite
     */
    siteName?: string;
    /**
     * 
     * @type {number}
     * @memberof PartnerPendingSite
     */
    latitude?: number;
    /**
     * 
     * @type {number}
     * @memberof PartnerPendingSite
     */
    longitude?: number;
    /**
     * 
     * @type {number}
     * @memberof PartnerPendingSite
     */
    entityId?: number;
    /**
     * 
     * @type {string}
     * @memberof PartnerPendingSite
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof PartnerPendingSite
     */
    capacity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PartnerPendingSite
     */
    safeFillVolume?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PartnerPendingSite
     */
    fuelType?: string | null;
    /**
     * 
     * @type {VatState}
     * @memberof PartnerPendingSite
     */
    state?: VatState | null;
    /**
     * 
     * @type {string}
     * @memberof PartnerPendingSite
     */
    entityStatus?: string;
    /**
     * 
     * @type {Array<object>}
     * @memberof PartnerPendingSite
     */
    entityCustomFieldData?: Array<object>;
    /**
     * 
     * @type {Array<object>}
     * @memberof PartnerPendingSite
     */
    entityCustomSettingsData?: Array<object>;
    /**
     * 
     * @type {string}
     * @memberof PartnerPendingSite
     */
    entityComments?: string;
    /**
     * 
     * @type {number}
     * @memberof PartnerPendingSite
     */
    partnerDefinedEntityId?: number;
    /**
     * 
     * @type {string}
     * @memberof PartnerPendingSite
     */
    partnerDefinedEntityName?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerPendingSite
     */
    siteContactName?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerPendingSite
     */
    siteContactEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerPendingSite
     */
    siteContactPhone?: string | null;
}
/**
 * 
 * @export
 * @interface PartnerPendingSitesInData
 */
export interface PartnerPendingSitesInData {
    /**
     * 
     * @type {Array<PartnerPendingSite>}
     * @memberof PartnerPendingSitesInData
     */
    data?: Array<PartnerPendingSite>;
}
/**
 * 
 * @export
 * @interface PartnerUser
 */
export interface PartnerUser {
    /**
     * 
     * @type {number}
     * @memberof PartnerUser
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PartnerUser
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerUser
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerUser
     */
    phone?: string;
    /**
     * 
     * @type {number}
     * @memberof PartnerUser
     */
    partnerId?: number;
    /**
     * 
     * @type {string}
     * @memberof PartnerUser
     */
    role?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerUser
     */
    password?: string;
}
/**
 * 
 * @export
 * @interface PartnerUserInData
 */
export interface PartnerUserInData {
    /**
     * 
     * @type {PartnerUser}
     * @memberof PartnerUserInData
     */
    data?: PartnerUser;
}
/**
 * 
 * @export
 * @interface PartnerUsersInData
 */
export interface PartnerUsersInData {
    /**
     * 
     * @type {Array<PartnerUser>}
     * @memberof PartnerUsersInData
     */
    data?: Array<PartnerUser>;
}
/**
 * 
 * @export
 * @interface PaymentMethod
 */
export interface PaymentMethod {
    /**
     * 
     * @type {number}
     * @memberof PaymentMethod
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentMethod
     */
    orgId?: number;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethod
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethod
     */
    accountName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethod
     */
    accountNumber?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentMethod
     */
    approved?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentMethod
     */
    active?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PaymentMethod
     */
    billToOrgId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethod
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethod
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethod
     */
    deletedAt?: string;
}
/**
 * 
 * @export
 * @interface Permission
 */
export interface Permission {
    /**
     * 
     * @type {number}
     * @memberof Permission
     */
    productId?: number;
    /**
     * 
     * @type {string}
     * @memberof Permission
     */
    permission?: string;
    /**
     * 
     * @type {string}
     * @memberof Permission
     */
    action?: string;
}
/**
 * 
 * @export
 * @interface Pickup
 */
export interface Pickup {
    /**
     * 
     * @type {number}
     * @memberof Pickup
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof Pickup
     */
    vatId?: number;
    /**
     * 
     * @type {number}
     * @memberof Pickup
     */
    volume?: number;
    /**
     * 
     * @type {string}
     * @memberof Pickup
     */
    timestamp?: string;
    /**
     * 
     * @type {string}
     * @memberof Pickup
     */
    type?: string;
}
/**
 * 
 * @export
 * @interface Product
 */
export interface Product {
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    orgId?: number;
    /**
     * 
     * @type {ProductType}
     * @memberof Product
     */
    type?: ProductType;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    description?: string;
    /**
     * 
     * @type {ProductStatus}
     * @memberof Product
     */
    status?: ProductStatus;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    supplierNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    supplier?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    fonterraCaseId?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    plan?: string;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    numberTrialMonths?: number;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    trialPlan?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    fssRegion?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    faultStatus?: ProductFaultStatusEnum;
    /**
     * 
     * @type {Array<Vat>}
     * @memberof Product
     */
    vats?: Array<Vat>;
    /**
     * 
     * @type {Array<Tank>}
     * @memberof Product
     */
    tanks?: Array<Tank>;
    /**
     * 
     * @type {Array<WaterMeter>}
     * @memberof Product
     */
    watermeters?: Array<WaterMeter>;
    /**
     * 
     * @type {Array<WaterTank>}
     * @memberof Product
     */
    watertanks?: Array<WaterTank>;
    /**
     * 
     * @type {Array<WaterMonitor>}
     * @memberof Product
     */
    watermonitors?: Array<WaterMonitor>;
    /**
     * 
     * @type {Array<FeedTank>}
     * @memberof Product
     */
    feedtanks?: Array<FeedTank>;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    notes?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    termsState?: string;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    siteId?: number;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    order_status?: ProductOrderStatusEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum ProductFaultStatusEnum {
    New = 'new',
    Monitor = 'monitor',
    Contact = 'contact',
    Repair = 'repair',
    Rebooting = 'rebooting',
    Null = 'null',
    Resolved = 'resolved'
}
/**
    * @export
    * @enum {string}
    */
export enum ProductOrderStatusEnum {
    InProgress = 'in_progress',
    Confirmed = 'confirmed',
    Cancelled = 'cancelled',
    NoOrder = 'no_order'
}

/**
 * 
 * @export
 * @interface ProductAccessoriesInData
 */
export interface ProductAccessoriesInData {
    /**
     * 
     * @type {Array<ProductAccessory>}
     * @memberof ProductAccessoriesInData
     */
    data?: Array<ProductAccessory>;
}
/**
 * 
 * @export
 * @interface ProductAccessory
 */
export interface ProductAccessory {
    /**
     * 
     * @type {number}
     * @memberof ProductAccessory
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductAccessory
     */
    serialNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductAccessory
     */
    uniqueId?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductAccessory
     */
    accessoryType?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductAccessory
     */
    entityType?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductAccessory
     */
    entityId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProductAccessory
     */
    transceiverId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProductAccessory
     */
    productId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProductAccessory
     */
    modbusAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductAccessory
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductAccessory
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductAccessory
     */
    deletedAt?: string | null;
}
/**
 * 
 * @export
 * @interface ProductAccessoryInData
 */
export interface ProductAccessoryInData {
    /**
     * 
     * @type {ProductAccessory}
     * @memberof ProductAccessoryInData
     */
    data?: ProductAccessory;
}
/**
 * 
 * @export
 * @interface ProductCurrentStateInData
 */
export interface ProductCurrentStateInData {
    /**
     * 
     * @type {ProductCurrentStateInDataData}
     * @memberof ProductCurrentStateInData
     */
    data?: ProductCurrentStateInDataData;
}
/**
 * 
 * @export
 * @interface ProductCurrentStateInDataData
 */
export interface ProductCurrentStateInDataData {
    /**
     * 
     * @type {number}
     * @memberof ProductCurrentStateInDataData
     */
    partnerId?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductCurrentStateInDataData
     */
    productId?: number;
    /**
     * 
     * @type {Array<object>}
     * @memberof ProductCurrentStateInDataData
     */
    customFieldData?: Array<object>;
    /**
     * 
     * @type {Array<object>}
     * @memberof ProductCurrentStateInDataData
     */
    customSettingsData?: Array<object>;
    /**
     * 
     * @type {object}
     * @memberof ProductCurrentStateInDataData
     */
    comments?: object;
    /**
     * 
     * @type {string}
     * @memberof ProductCurrentStateInDataData
     */
    partnerDefinedId?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCurrentStateInDataData
     */
    partnerDefinedName?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCurrentStateInDataData
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCurrentStateInDataData
     */
    supplier?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCurrentStateInDataData
     */
    supplierNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCurrentStateInDataData
     */
    faultStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCurrentStateInDataData
     */
    address?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductCurrentStateInDataData
     */
    latitude?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductCurrentStateInDataData
     */
    longitude?: number;
    /**
     * 
     * @type {object}
     * @memberof ProductCurrentStateInDataData
     */
    metrics?: object;
}
/**
 * 
 * @export
 * @interface ProductDash
 */
export interface ProductDash {
    /**
     * 
     * @type {Array<VatData>}
     * @memberof ProductDash
     */
    data?: Array<VatData>;
}
/**
 * 
 * @export
 * @interface ProductEvents
 */
export interface ProductEvents {
    /**
     * 
     * @type {Array<EventsData>}
     * @memberof ProductEvents
     */
    data?: Array<EventsData>;
}
/**
 * 
 * @export
 * @interface ProductEventsInData
 */
export interface ProductEventsInData {
    /**
     * 
     * @type {ProductEvents}
     * @memberof ProductEventsInData
     */
    data?: ProductEvents;
}
/**
 * 
 * @export
 * @interface ProductFault
 */
export interface ProductFault {
    /**
     * 
     * @type {string}
     * @memberof ProductFault
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductFault
     */
    action?: string;
}
/**
 * 
 * @export
 * @interface ProductFaultStatus
 */
export interface ProductFaultStatus {
    /**
     * 
     * @type {number}
     * @memberof ProductFaultStatus
     */
    productId?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductFaultStatus
     */
    productName?: string;
    /**
     * 
     * @type {ProductType}
     * @memberof ProductFaultStatus
     */
    productType?: ProductType;
    /**
     * 
     * @type {string}
     * @memberof ProductFaultStatus
     */
    supplierNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductFaultStatus
     */
    faultTypes?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductFaultStatus
     */
    faultStatusUpdateDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductFaultStatus
     */
    faultDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductFaultStatus
     */
    faultFirstDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductFaultStatus
     */
    earliestFaultDate?: string;
}
/**
 * 
 * @export
 * @interface ProductFaultStatusInData
 */
export interface ProductFaultStatusInData {
    /**
     * 
     * @type {Array<ProductFaultStatus>}
     * @memberof ProductFaultStatusInData
     */
    data?: Array<ProductFaultStatus>;
}
/**
 * 
 * @export
 * @interface ProductInData
 */
export interface ProductInData {
    /**
     * 
     * @type {Product}
     * @memberof ProductInData
     */
    data?: Product;
}
/**
 * the milk dashboard result which includes current vat status
 * @export
 * @interface ProductMilkDash
 */
export interface ProductMilkDash {
    /**
     * 
     * @type {Array<VatData>}
     * @memberof ProductMilkDash
     */
    vats?: Array<VatData>;
    /**
     * a set of events for each vat
     * @type {Array<EventsData>}
     * @memberof ProductMilkDash
     */
    events?: Array<EventsData>;
    /**
     * alert notifications sent for the current product
     * @type {Array<Notification>}
     * @memberof ProductMilkDash
     */
    notifications?: Array<Notification>;
}
/**
 * 
 * @export
 * @interface ProductMilkDashInData
 */
export interface ProductMilkDashInData {
    /**
     * 
     * @type {ProductMilkDash}
     * @memberof ProductMilkDashInData
     */
    data?: ProductMilkDash;
}
/**
 * 
 * @export
 * @interface ProductSimProJob
 */
export interface ProductSimProJob {
    /**
     * 
     * @type {number}
     * @memberof ProductSimProJob
     */
    productId?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductSimProJob
     */
    status?: ProductSimProJobStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ProductSimProJob
     */
    type?: ProductSimProJobTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ProductSimProJob
     */
    zone?: number;
    /**
     * 
     * @type {Array<SimproJobEntityGroup>}
     * @memberof ProductSimProJob
     */
    entities?: Array<SimproJobEntityGroup>;
    /**
     * 
     * @type {string}
     * @memberof ProductSimProJob
     */
    notes?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductSimProJob
     */
    contactUserId?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProductSimProJob
     */
    otherFaultSymptoms?: Array<number> | null;
}

/**
    * @export
    * @enum {string}
    */
export enum ProductSimProJobStatusEnum {
    NUMBER_7 = 7,
    NUMBER_11 = 11,
    NUMBER_27 = 27,
    NUMBER_28 = 28,
    NUMBER_60 = 60,
    NUMBER_61 = 61
}
/**
    * @export
    * @enum {string}
    */
export enum ProductSimProJobTypeEnum {
    Install = 'install',
    Repair = 'repair',
    Remove = 'remove'
}

/**
 * 
 * @export
 * @interface ProductSimProJobInData
 */
export interface ProductSimProJobInData {
    /**
     * 
     * @type {ProductSimProJob}
     * @memberof ProductSimProJobInData
     */
    data?: ProductSimProJob;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ProductStatus {
    Pending = 'pending',
    Install = 'install',
    SignOff = 'sign-off',
    Live = 'live',
    Removed = 'removed',
    Cancelled = 'cancelled',
    Draft = 'draft'
}

/**
 * 
 * @export
 * @interface ProductStatusChange
 */
export interface ProductStatusChange {
    /**
     * 
     * @type {number}
     * @memberof ProductStatusChange
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductStatusChange
     */
    entityType?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductStatusChange
     */
    entityId?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductStatusChange
     */
    oldStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductStatusChange
     */
    newStatus?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductStatusChange
     */
    userId?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductStatusChange
     */
    reason?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductStatusChange
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductStatusChange
     */
    updated_at?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ProductTier {
    Trim = 'trim',
    BlueTop = 'blueTop',
    FullCream = 'fullCream',
    Lite = 'lite',
    Regular = 'regular',
    Super = 'super',
    Premium = 'premium',
    HalfLoad = 'halfLoad',
    FullLoad = 'fullLoad',
    Standard = 'standard'
}

/**
 * 
 * @export
 * @interface ProductTrial
 */
export interface ProductTrial {
    /**
     * 
     * @type {string}
     * @memberof ProductTrial
     */
    trialTier?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductTrial
     */
    trialEndDateTs?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductTrial
     */
    trialStartDateTs?: number;
}
/**
 * 
 * @export
 * @interface ProductTrialInData
 */
export interface ProductTrialInData {
    /**
     * 
     * @type {ProductTrial}
     * @memberof ProductTrialInData
     */
    data?: ProductTrial;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ProductType {
    Milk = 'milk',
    Fuel = 'fuel',
    Water = 'water',
    Feed = 'feed',
    Effluent = 'effluent'
}

/**
 * Data to be displayed on the Water Dashboard
 * @export
 * @interface ProductWaterDash
 */
export interface ProductWaterDash {
    /**
     * 
     * @type {ProductWaterDashWater}
     * @memberof ProductWaterDash
     */
    water?: ProductWaterDashWater;
}
/**
 * 
 * @export
 * @interface ProductWaterDashInData
 */
export interface ProductWaterDashInData {
    /**
     * 
     * @type {ProductWaterDash}
     * @memberof ProductWaterDashInData
     */
    data?: ProductWaterDash;
}
/**
 * 
 * @export
 * @interface ProductWaterDashWater
 */
export interface ProductWaterDashWater {
    /**
     * 
     * @type {Array<WaterMeterObject>}
     * @memberof ProductWaterDashWater
     */
    meters?: Array<WaterMeterObject>;
    /**
     * 
     * @type {Array<WaterTankObject>}
     * @memberof ProductWaterDashWater
     */
    tanks?: Array<WaterTankObject>;
    /**
     * 
     * @type {Array<WaterMonitorObject>}
     * @memberof ProductWaterDashWater
     */
    monitors?: Array<WaterMonitorObject>;
}
/**
 * 
 * @export
 * @interface ProductsInData
 */
export interface ProductsInData {
    /**
     * 
     * @type {Array<Product>}
     * @memberof ProductsInData
     */
    data?: Array<Product>;
}
/**
 * 
 * @export
 * @interface ProductsProductIdJobData
 */
export interface ProductsProductIdJobData {
    /**
     * 
     * @type {string}
     * @memberof ProductsProductIdJobData
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductsProductIdJobData
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductsProductIdJobData
     */
    notes?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductsProductIdJobData
     */
    zone?: string;
}
/**
 * 
 * @export
 * @interface ProvisionVat
 */
export interface ProvisionVat {
    /**
     * 
     * @type {VatState}
     * @memberof ProvisionVat
     */
    state: VatState | null;
    /**
     * 
     * @type {VatFormula}
     * @memberof ProvisionVat
     */
    formula: VatFormula | null;
    /**
     * 
     * @type {string}
     * @memberof ProvisionVat
     */
    sizeString: string;
    /**
     * 
     * @type {number}
     * @memberof ProvisionVat
     */
    vatOffset: number;
    /**
     * 
     * @type {number}
     * @memberof ProvisionVat
     */
    emptyDistance?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProvisionVat
     */
    stirrerThresh?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProvisionVat
     */
    formulaId?: number | null;
    /**
     * 
     * @type {object}
     * @memberof ProvisionVat
     */
    formulaParameters?: object | null;
}
/**
 * 
 * @export
 * @interface ProvisionVatInData
 */
export interface ProvisionVatInData {
    /**
     * 
     * @type {ProvisionVat}
     * @memberof ProvisionVatInData
     */
    data?: ProvisionVat;
}
/**
 * 
 * @export
 * @interface RawData
 */
export interface RawData {
    /**
     * 
     * @type {string}
     * @memberof RawData
     */
    sortKey?: string;
    /**
     * 
     * @type {string}
     * @memberof RawData
     */
    date?: string;
    /**
     * 
     * @type {object}
     * @memberof RawData
     */
    data?: object;
}
/**
 * 
 * @export
 * @interface RawDataInData
 */
export interface RawDataInData {
    /**
     * 
     * @type {Array<RawData>}
     * @memberof RawDataInData
     */
    data?: Array<RawData>;
    /**
     * 
     * @type {Pagination}
     * @memberof RawDataInData
     */
    links?: Pagination;
}
/**
 * 
 * @export
 * @interface ResetPassword
 */
export interface ResetPassword {
    /**
     * 
     * @type {string}
     * @memberof ResetPassword
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof ResetPassword
     */
    password?: string;
    /**
     * 
     * @type {string}
     * @memberof ResetPassword
     */
    password_confirmation?: string;
    /**
     * 
     * @type {string}
     * @memberof ResetPassword
     */
    token?: string;
}
/**
 * 
 * @export
 * @interface Role
 */
export interface Role {
    /**
     * role id
     * @type {number}
     * @memberof Role
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Role
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof Role
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof Role
     */
    orgId?: number;
    /**
     * 
     * @type {string}
     * @memberof Role
     */
    action?: string;
}
/**
 * 
 * @export
 * @interface SearchResults
 */
export interface SearchResults {
    /**
     * 
     * @type {Array<Org>}
     * @memberof SearchResults
     */
    orgs?: Array<Org>;
    /**
     * 
     * @type {Array<Site>}
     * @memberof SearchResults
     */
    sites?: Array<Site>;
    /**
     * 
     * @type {Array<User>}
     * @memberof SearchResults
     */
    users?: Array<User>;
    /**
     * 
     * @type {Array<Product>}
     * @memberof SearchResults
     */
    products?: Array<Product>;
    /**
     * 
     * @type {Array<Transceiver>}
     * @memberof SearchResults
     */
    transceivers?: Array<Transceiver>;
    /**
     * 
     * @type {Array<Sensor>}
     * @memberof SearchResults
     */
    sensors?: Array<Sensor>;
    /**
     * 
     * @type {Array<Gateway>}
     * @memberof SearchResults
     */
    gateways?: Array<Gateway>;
    /**
     * 
     * @type {Array<Node>}
     * @memberof SearchResults
     */
    nodes?: Array<Node>;
    /**
     * 
     * @type {Array<ProductAccessory>}
     * @memberof SearchResults
     */
    productAccessories?: Array<ProductAccessory>;
}
/**
 * 
 * @export
 * @interface Sensor
 */
export interface Sensor {
    /**
     * 
     * @type {number}
     * @memberof Sensor
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Sensor
     */
    serialNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof Sensor
     */
    uniqueId?: string;
    /**
     * 
     * @type {string}
     * @memberof Sensor
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof Sensor
     */
    physicalType?: string;
    /**
     * 
     * @type {string}
     * @memberof Sensor
     */
    status?: string;
    /**
     * 
     * @type {number}
     * @memberof Sensor
     */
    vatId?: number;
    /**
     * 
     * @type {number}
     * @memberof Sensor
     */
    transceiverId?: number;
    /**
     * 
     * @type {string}
     * @memberof Sensor
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof Sensor
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof Sensor
     */
    deletedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof Sensor
     */
    emptyCapacitance?: number;
    /**
     * 
     * @type {number}
     * @memberof Sensor
     */
    probeLength?: number;
    /**
     * 
     * @type {number}
     * @memberof Sensor
     */
    dimension?: number;
    /**
     * 
     * @type {number}
     * @memberof Sensor
     */
    tankId?: number;
    /**
     * 
     * @type {number}
     * @memberof Sensor
     */
    ownerId?: number;
    /**
     * 
     * @type {string}
     * @memberof Sensor
     */
    ownerType?: string;
    /**
     * 
     * @type {string}
     * @memberof Sensor
     */
    batch?: string;
    /**
     * 
     * @type {string}
     * @memberof Sensor
     */
    generation?: string;
    /**
     * 
     * @type {string}
     * @memberof Sensor
     */
    communication?: string;
    /**
     * 
     * @type {number}
     * @memberof Sensor
     */
    nodeId?: number;
    /**
     * 
     * @type {Node}
     * @memberof Sensor
     */
    node?: Node;
    /**
     * 
     * @type {number}
     * @memberof Sensor
     */
    lastCheckIn?: number | null;
}
/**
 * 
 * @export
 * @interface SensorDash
 */
export interface SensorDash {
    /**
     * 
     * @type {Array<SensorDashData>}
     * @memberof SensorDash
     */
    data?: Array<SensorDashData>;
}
/**
 * 
 * @export
 * @interface SensorDashData
 */
export interface SensorDashData {
    /**
     * 
     * @type {number}
     * @memberof SensorDashData
     */
    id: number;
    /**
     * 
     * @type {CurrentReading}
     * @memberof SensorDashData
     */
    batteryVoltage?: CurrentReading;
    /**
     * 
     * @type {CurrentReading}
     * @memberof SensorDashData
     */
    cellStrength?: CurrentReading;
}
/**
 * 
 * @export
 * @interface SensorGraphData
 */
export interface SensorGraphData {
    /**
     * 
     * @type {Array<TimeSeriesValue>}
     * @memberof SensorGraphData
     */
    battery_voltage?: Array<TimeSeriesValue>;
    /**
     * 
     * @type {Array<TimeSeriesValue>}
     * @memberof SensorGraphData
     */
    rssi?: Array<TimeSeriesValue>;
    /**
     * 
     * @type {Array<TimeSeriesValue>}
     * @memberof SensorGraphData
     */
    reboots?: Array<TimeSeriesValue>;
    /**
     * 
     * @type {Array<TimeSeriesValue>}
     * @memberof SensorGraphData
     */
    readcount?: Array<TimeSeriesValue>;
    /**
     * 
     * @type {Array<TimeSeriesValue>}
     * @memberof SensorGraphData
     */
    temperature?: Array<TimeSeriesValue>;
}
/**
 * 
 * @export
 * @interface SensorGraphDataInData
 */
export interface SensorGraphDataInData {
    /**
     * 
     * @type {SensorGraphData}
     * @memberof SensorGraphDataInData
     */
    data?: SensorGraphData;
}
/**
 * 
 * @export
 * @interface SensorInData
 */
export interface SensorInData {
    /**
     * 
     * @type {Sensor}
     * @memberof SensorInData
     */
    data?: Sensor;
}
/**
 * 
 * @export
 * @interface SensorsAssign
 */
export interface SensorsAssign {
    /**
     * 
     * @type {Array<Transceiver>}
     * @memberof SensorsAssign
     */
    transceivers?: Array<Transceiver>;
    /**
     * 
     * @type {number}
     * @memberof SensorsAssign
     */
    transceiverId?: number;
    /**
     * 
     * @type {Array<Vat>}
     * @memberof SensorsAssign
     */
    vats?: Array<Vat>;
    /**
     * 
     * @type {Array<VatSensor>}
     * @memberof SensorsAssign
     */
    vatSensors?: Array<VatSensor>;
}
/**
 * 
 * @export
 * @interface SensorsInData
 */
export interface SensorsInData {
    /**
     * 
     * @type {Array<Sensor>}
     * @memberof SensorsInData
     */
    data?: Array<Sensor>;
}
/**
 * 
 * @export
 * @interface SignedUrl
 */
export interface SignedUrl {
    /**
     * 
     * @type {string}
     * @memberof SignedUrl
     */
    url?: string;
}
/**
 * 
 * @export
 * @interface SimproJob
 */
export interface SimproJob {
    /**
     * 
     * @type {number}
     * @memberof SimproJob
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof SimproJob
     */
    description?: string;
}
/**
 * 
 * @export
 * @interface SimproJobDescription
 */
export interface SimproJobDescription {
    /**
     * 
     * @type {string}
     * @memberof SimproJobDescription
     */
    description?: string;
}
/**
 * 
 * @export
 * @interface SimproJobDescriptionInData
 */
export interface SimproJobDescriptionInData {
    /**
     * 
     * @type {SimproJobDescription}
     * @memberof SimproJobDescriptionInData
     */
    data?: SimproJobDescription;
}
/**
 * 
 * @export
 * @interface SimproJobDetails
 */
export interface SimproJobDetails {
    /**
     * 
     * @type {number}
     * @memberof SimproJobDetails
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof SimproJobDetails
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof SimproJobDetails
     */
    technician?: string;
    /**
     * 
     * @type {string}
     * @memberof SimproJobDetails
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof SimproJobDetails
     */
    jobType?: SimproJobDetailsJobTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SimproJobDetails
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof SimproJobDetails
     */
    stage?: string;
    /**
     * 
     * @type {string}
     * @memberof SimproJobDetails
     */
    dueDate?: string;
    /**
     * 
     * @type {string}
     * @memberof SimproJobDetails
     */
    dueTime?: string;
    /**
     * 
     * @type {string}
     * @memberof SimproJobDetails
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof SimproJobDetails
     */
    completedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof SimproJobDetails
     */
    reason?: string;
    /**
     * 
     * @type {number}
     * @memberof SimproJobDetails
     */
    productId?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum SimproJobDetailsJobTypeEnum {
    Install = 'install',
    Repair = 'repair',
    Remove = 'remove'
}

/**
 * 
 * @export
 * @interface SimproJobDetailsInData
 */
export interface SimproJobDetailsInData {
    /**
     * 
     * @type {SimproJobDetails}
     * @memberof SimproJobDetailsInData
     */
    data?: SimproJobDetails;
}
/**
 * 
 * @export
 * @interface SimproJobEntityGroup
 */
export interface SimproJobEntityGroup {
    /**
     * 
     * @type {string}
     * @memberof SimproJobEntityGroup
     */
    entityType?: SimproJobEntityGroupEntityTypeEnum;
    /**
     * 
     * @type {Array<number>}
     * @memberof SimproJobEntityGroup
     */
    entityIds?: Array<number>;
    /**
     * 
     * @type {Array<Vat | Tank | WaterMeter | WaterTank | WaterMonitor | FeedTank>}
     * @memberof SimproJobEntityGroup
     */
    entities?: Array<Vat | Tank | WaterMeter | WaterTank | WaterMonitor | FeedTank>;
}

/**
    * @export
    * @enum {string}
    */
export enum SimproJobEntityGroupEntityTypeEnum {
    WaterTanks = 'water_tanks',
    WaterMonitors = 'water_monitors',
    WaterMeters = 'water_meters',
    Tanks = 'tanks',
    Vats = 'vats',
    FeedTanks = 'feed_tanks'
}

/**
 * 
 * @export
 * @interface SimproJobInData
 */
export interface SimproJobInData {
    /**
     * 
     * @type {SimproJob}
     * @memberof SimproJobInData
     */
    data?: SimproJob;
}
/**
 * 
 * @export
 * @interface SimproJobStatusData
 */
export interface SimproJobStatusData {
    /**
     * 
     * @type {string}
     * @memberof SimproJobStatusData
     */
    notes?: string;
}
/**
 * 
 * @export
 * @interface SimproJobStatusDataInData
 */
export interface SimproJobStatusDataInData {
    /**
     * 
     * @type {SimproJobStatusData}
     * @memberof SimproJobStatusDataInData
     */
    data?: SimproJobStatusData;
}
/**
 * 
 * @export
 * @interface SimproJobStory
 */
export interface SimproJobStory {
    /**
     * 
     * @type {string}
     * @memberof SimproJobStory
     */
    storyText?: string;
}
/**
 * 
 * @export
 * @interface SimproJobStoryParameterEntity
 */
export interface SimproJobStoryParameterEntity {
    /**
     * 
     * @type {number}
     * @memberof SimproJobStoryParameterEntity
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof SimproJobStoryParameterEntity
     */
    simproJobId?: number;
    /**
     * 
     * @type {number}
     * @memberof SimproJobStoryParameterEntity
     */
    ownerId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SimproJobStoryParameterEntity
     */
    ownerType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SimproJobStoryParameterEntity
     */
    data?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SimproJobStoryParameterEntity
     */
    entityId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SimproJobStoryParameterEntity
     */
    entityType?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SimproJobStoryParameterEntity
     */
    faultSymptomId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SimproJobStoryParameterEntity
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof SimproJobStoryParameterEntity
     */
    updatedAt?: string;
}
/**
 * 
 * @export
 * @interface SimproJobStoryParameters
 */
export interface SimproJobStoryParameters {
    /**
     * 
     * @type {number}
     * @memberof SimproJobStoryParameters
     */
    simproJobId?: number;
    /**
     * 
     * @type {Array<SimproJobStoryParameterEntity>}
     * @memberof SimproJobStoryParameters
     */
    entities?: Array<SimproJobStoryParameterEntity>;
    /**
     * 
     * @type {string}
     * @memberof SimproJobStoryParameters
     */
    statusChangeReason?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SimproJobStoryParameters
     */
    notes?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SimproJobStoryParameters
     */
    zone?: number;
    /**
     * 
     * @type {User}
     * @memberof SimproJobStoryParameters
     */
    contactUser?: User;
}
/**
 * 
 * @export
 * @interface SimproJobStoryParametersInData
 */
export interface SimproJobStoryParametersInData {
    /**
     * 
     * @type {SimproJobStoryParameters}
     * @memberof SimproJobStoryParametersInData
     */
    data?: SimproJobStoryParameters;
}
/**
 * 
 * @export
 * @interface SimproJobWorkNote
 */
export interface SimproJobWorkNote {
    /**
     * 
     * @type {string}
     * @memberof SimproJobWorkNote
     */
    Message?: string;
    /**
     * 
     * @type {SimproStaffDetails}
     * @memberof SimproJobWorkNote
     */
    Staff?: SimproStaffDetails;
    /**
     * 
     * @type {string}
     * @memberof SimproJobWorkNote
     */
    Date?: string;
}
/**
 * 
 * @export
 * @interface SimproJobsInData
 */
export interface SimproJobsInData {
    /**
     * 
     * @type {Array<SimproJob>}
     * @memberof SimproJobsInData
     */
    data?: Array<SimproJob>;
}
/**
 * 
 * @export
 * @interface SimproStaffDetails
 */
export interface SimproStaffDetails {
    /**
     * 
     * @type {number}
     * @memberof SimproStaffDetails
     */
    ID?: number;
    /**
     * 
     * @type {string}
     * @memberof SimproStaffDetails
     */
    Name?: string;
}
/**
 * 
 * @export
 * @interface SimproUpdatedJobStory
 */
export interface SimproUpdatedJobStory {
    /**
     * 
     * @type {string}
     * @memberof SimproUpdatedJobStory
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof SimproUpdatedJobStory
     */
    data?: string;
}
/**
 * 
 * @export
 * @interface Site
 */
export interface Site {
    /**
     * 
     * @type {number}
     * @memberof Site
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof Site
     */
    orgId?: number;
    /**
     * 
     * @type {string}
     * @memberof Site
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Site
     */
    latitude?: string;
    /**
     * 
     * @type {string}
     * @memberof Site
     */
    longitude?: string;
    /**
     * 
     * @type {Org}
     * @memberof Site
     */
    org?: Org;
    /**
     * 
     * @type {Address}
     * @memberof Site
     */
    address?: Address;
}
/**
 * 
 * @export
 * @interface SiteInData
 */
export interface SiteInData {
    /**
     * 
     * @type {Site}
     * @memberof SiteInData
     */
    data?: Site;
}
/**
 * 
 * @export
 * @interface SiteThingGroup
 */
export interface SiteThingGroup {
    /**
     * 
     * @type {number}
     * @memberof SiteThingGroup
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof SiteThingGroup
     */
    thingGroupName?: string;
}
/**
 * 
 * @export
 * @interface SiteThingGroupsInData
 */
export interface SiteThingGroupsInData {
    /**
     * 
     * @type {Array<SiteThingGroup>}
     * @memberof SiteThingGroupsInData
     */
    data?: Array<SiteThingGroup>;
}
/**
 * 
 * @export
 * @interface SitesInData
 */
export interface SitesInData {
    /**
     * 
     * @type {Array<Site>}
     * @memberof SitesInData
     */
    data?: Array<Site>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum SmsChargeStatus {
    Pending = 'pending',
    Charged = 'charged',
    NotCharged = 'not charged'
}

/**
 * 
 * @export
 * @interface SmsDeliveryLog
 */
export interface SmsDeliveryLog {
    /**
     * 
     * @type {number}
     * @memberof SmsDeliveryLog
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof SmsDeliveryLog
     */
    product_id?: number;
    /**
     * 
     * @type {ProductTier}
     * @memberof SmsDeliveryLog
     */
    product_tier?: ProductTier;
    /**
     * 
     * @type {string}
     * @memberof SmsDeliveryLog
     */
    product_fault_status?: string;
    /**
     * 
     * @type {Entities}
     * @memberof SmsDeliveryLog
     */
    entity_type?: Entities;
    /**
     * 
     * @type {number}
     * @memberof SmsDeliveryLog
     */
    entity_id?: number;
    /**
     * 
     * @type {SmsDeliveryStatus}
     * @memberof SmsDeliveryLog
     */
    delivery_status?: SmsDeliveryStatus;
    /**
     * 
     * @type {string}
     * @memberof SmsDeliveryLog
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof SmsDeliveryLog
     */
    updated_at?: string;
    /**
     * 
     * @type {number}
     * @memberof SmsDeliveryLog
     */
    sms_product_charges_id?: number;
}
/**
 * 
 * @export
 * @interface SmsDeliveryLogsInData
 */
export interface SmsDeliveryLogsInData {
    /**
     * 
     * @type {Array<SmsDeliveryLog>}
     * @memberof SmsDeliveryLogsInData
     */
    data?: Array<SmsDeliveryLog>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum SmsDeliveryStatus {
    Pending = 'pending',
    Success = 'success',
    Failed = 'failed'
}

/**
 * 
 * @export
 * @interface SmsProductCharge
 */
export interface SmsProductCharge {
    /**
     * 
     * @type {number}
     * @memberof SmsProductCharge
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof SmsProductCharge
     */
    product_id?: number;
    /**
     * 
     * @type {number}
     * @memberof SmsProductCharge
     */
    num_sent_success?: number;
    /**
     * 
     * @type {number}
     * @memberof SmsProductCharge
     */
    num_sent_failed?: number;
    /**
     * 
     * @type {number}
     * @memberof SmsProductCharge
     */
    num_sent_fault_status?: number;
    /**
     * 
     * @type {number}
     * @memberof SmsProductCharge
     */
    num_sent_chargeable?: number;
    /**
     * 
     * @type {SmsChargeStatus}
     * @memberof SmsProductCharge
     */
    status?: SmsChargeStatus;
    /**
     * 
     * @type {string}
     * @memberof SmsProductCharge
     */
    ordway_order_id?: string;
    /**
     * 
     * @type {string}
     * @memberof SmsProductCharge
     */
    ordway_order_created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof SmsProductCharge
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof SmsProductCharge
     */
    updated_at?: string;
}
/**
 * 
 * @export
 * @interface SmsProductChargesDetailInData
 */
export interface SmsProductChargesDetailInData {
    /**
     * 
     * @type {Array<SmsDeliveryLog>}
     * @memberof SmsProductChargesDetailInData
     */
    data?: Array<SmsDeliveryLog>;
}
/**
 * 
 * @export
 * @interface SmsProductChargesInData
 */
export interface SmsProductChargesInData {
    /**
     * 
     * @type {Array<SmsProductCharge>}
     * @memberof SmsProductChargesInData
     */
    data?: Array<SmsProductCharge>;
}
/**
 * 
 * @export
 * @interface SmsStatus
 */
export interface SmsStatus {
    /**
     * 
     * @type {SmsStatusData}
     * @memberof SmsStatus
     */
    data?: SmsStatusData;
}
/**
 * 
 * @export
 * @interface SmsStatusData
 */
export interface SmsStatusData {
    /**
     * 
     * @type {string}
     * @memberof SmsStatusData
     */
    tier?: string;
    /**
     * 
     * @type {number}
     * @memberof SmsStatusData
     */
    tierLimit?: number;
    /**
     * 
     * @type {number}
     * @memberof SmsStatusData
     */
    numSent?: number;
}
/**
 * 
 * @export
 * @interface StoreProduct
 */
export interface StoreProduct {
    /**
     * 
     * @type {string}
     * @memberof StoreProduct
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof StoreProduct
     */
    orgId?: number;
    /**
     * 
     * @type {number}
     * @memberof StoreProduct
     */
    siteId?: number;
    /**
     * 
     * @type {string}
     * @memberof StoreProduct
     */
    plan?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreProduct
     */
    trialPlan?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StoreProduct
     */
    numberTrialMonths?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StoreProduct
     */
    supplier?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StoreProduct
     */
    supplierNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StoreProduct
     */
    fonterraCaseId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StoreProduct
     */
    fssRegion?: string | null;
}
/**
 * 
 * @export
 * @interface StoreProductInData
 */
export interface StoreProductInData {
    /**
     * 
     * @type {StoreProduct}
     * @memberof StoreProductInData
     */
    data?: StoreProduct;
}
/**
 * 
 * @export
 * @interface SubscriptionItem
 */
export interface SubscriptionItem {
    /**
     * 
     * @type {number}
     * @memberof SubscriptionItem
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionItem
     */
    productId?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionItem
     */
    subscriptionId?: number;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionItem
     */
    plan?: string;
    /**
     * 
     * @type {ProductType}
     * @memberof SubscriptionItem
     */
    productType?: ProductType;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionItem
     */
    trialEndsAt?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionItem
     */
    trialPlan?: string;
}
/**
 * 
 * @export
 * @interface SubscriptionItemInData
 */
export interface SubscriptionItemInData {
    /**
     * 
     * @type {SubscriptionItem}
     * @memberof SubscriptionItemInData
     */
    data?: SubscriptionItem;
}
/**
 * 
 * @export
 * @interface Tank
 */
export interface Tank {
    /**
     * 
     * @type {number}
     * @memberof Tank
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof Tank
     */
    productId?: number;
    /**
     * 
     * @type {number}
     * @memberof Tank
     */
    fuelTankId?: number;
    /**
     * 
     * @type {string}
     * @memberof Tank
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof Tank
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof Tank
     */
    deletedAt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Tank
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Tank
     */
    fuelType?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Tank
     */
    outletHeight?: number;
    /**
     * 
     * @type {number}
     * @memberof Tank
     */
    totalHeight?: number;
    /**
     * 
     * @type {number}
     * @memberof Tank
     */
    nominalVolume?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Tank
     */
    safeFillVolume?: number;
    /**
     * 
     * @type {number}
     * @memberof Tank
     */
    fluctuation?: number | null;
    /**
     * 
     * @type {object}
     * @memberof Tank
     */
    parameters?: object | null;
    /**
     * 
     * @type {object}
     * @memberof Tank
     */
    correction?: object | null;
    /**
     * 
     * @type {number}
     * @memberof Tank
     */
    transceiverId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Tank
     */
    formulaId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Tank
     */
    distributorId?: number;
    /**
     * 
     * @type {EntityStatus}
     * @memberof Tank
     */
    status?: EntityStatus;
    /**
     * 
     * @type {string}
     * @memberof Tank
     */
    notes?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Tank
     */
    siteId?: number;
    /**
     * 
     * @type {string}
     * @memberof Tank
     */
    tankType?: TankTankTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Tank
     */
    liveAt?: string;
    /**
     * 
     * @type {EntityLocation}
     * @memberof Tank
     */
    entitylocation?: EntityLocation;
    /**
     * 
     * @type {Array<EntityStatusChange>}
     * @memberof Tank
     */
    entitystatuschanges?: Array<EntityStatusChange>;
    /**
     * 
     * @type {string}
     * @memberof Tank
     */
    liveAtDate?: string | null;
    /**
     * 
     * @type {Sensor}
     * @memberof Tank
     */
    sensor?: Sensor;
}

/**
    * @export
    * @enum {string}
    */
export enum TankTankTypeEnum {
    Classic = 'classic',
    Aws = 'aws',
    Null = 'null'
}

/**
 * 
 * @export
 * @interface TankInData
 */
export interface TankInData {
    /**
     * 
     * @type {Tank}
     * @memberof TankInData
     */
    data?: Tank;
}
/**
 * 
 * @export
 * @interface TankInfo
 */
export interface TankInfo {
    /**
     * 
     * @type {number}
     * @memberof TankInfo
     */
    tank_id?: number;
    /**
     * A user-set name for the tank
     * @type {string}
     * @memberof TankInfo
     */
    description?: string;
    /**
     * Petrol | Diesel
     * @type {string}
     * @memberof TankInfo
     */
    fluid_type?: string;
    /**
     * eg L The units the data is reported in
     * @type {string}
     * @memberof TankInfo
     */
    units?: string;
    /**
     * Maximum volume the tank can hold
     * @type {number}
     * @memberof TankInfo
     */
    max_volume?: number;
    /**
     * The stated volume of the tank
     * @type {number}
     * @memberof TankInfo
     */
    nominal_volume?: number;
    /**
     * The stated safe fill volume for the tank
     * @type {number}
     * @memberof TankInfo
     */
    safe_fill_volume?: number;
    /**
     * The smallest amount of fluid that we can measure in this tank
     * @type {number}
     * @memberof TankInfo
     */
    minimum_level?: number;
    /**
     * The largest amount of fluid that we can measure in this tank
     * @type {number}
     * @memberof TankInfo
     */
    maximum_level?: number;
    /**
     * Zulu Date
     * @type {string}
     * @memberof TankInfo
     */
    last_updated?: string;
    /**
     * the current volume of fluid at the last_updated date time
     * @type {number}
     * @memberof TankInfo
     */
    last_reading?: number;
    /**
     * 
     * @type {string}
     * @memberof TankInfo
     */
    customer_note?: string;
    /**
     * 0 = no, 1 = yes, 2 = most favourite
     * @type {number}
     * @memberof TankInfo
     */
    favourite?: number;
    /**
     * Date it was first installed on the tank
     * @type {string}
     * @memberof TankInfo
     */
    installation_date?: string;
}
/**
 * 
 * @export
 * @interface TankInput
 */
export interface TankInput {
    /**
     * 
     * @type {number}
     * @memberof TankInput
     */
    productId?: number;
    /**
     * 
     * @type {number}
     * @memberof TankInput
     */
    fuelTankId?: number;
    /**
     * 
     * @type {string}
     * @memberof TankInput
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof TankInput
     */
    fuelType?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TankInput
     */
    outletHeight?: number;
    /**
     * 
     * @type {number}
     * @memberof TankInput
     */
    totalHeight?: number;
    /**
     * 
     * @type {number}
     * @memberof TankInput
     */
    nominalVolume?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TankInput
     */
    safeFillVolume?: number;
    /**
     * 
     * @type {number}
     * @memberof TankInput
     */
    fluctuation?: number | null;
    /**
     * 
     * @type {object}
     * @memberof TankInput
     */
    parameters?: object;
    /**
     * 
     * @type {object}
     * @memberof TankInput
     */
    correction?: object;
    /**
     * 
     * @type {number}
     * @memberof TankInput
     */
    transceiverId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TankInput
     */
    formulaId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TankInput
     */
    distributorId?: number;
    /**
     * 
     * @type {EntityStatus}
     * @memberof TankInput
     */
    status?: EntityStatus;
    /**
     * 
     * @type {string}
     * @memberof TankInput
     */
    notes?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TankInput
     */
    siteId?: number;
    /**
     * 
     * @type {string}
     * @memberof TankInput
     */
    tankType?: TankInputTankTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum TankInputTankTypeEnum {
    Classic = 'classic',
    Aws = 'aws',
    Null = 'null'
}

/**
 * 
 * @export
 * @interface TankInputInData
 */
export interface TankInputInData {
    /**
     * 
     * @type {TankInput}
     * @memberof TankInputInData
     */
    data?: TankInput;
}
/**
 * returned from a fuelDash with everything we know about a tank
 * @export
 * @interface TankObject
 */
export interface TankObject {
    /**
     * unique id for the tank
     * @type {number}
     * @memberof TankObject
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof TankObject
     */
    name?: string;
    /**
     * tank id on old system
     * @type {number}
     * @memberof TankObject
     */
    fuelTankId?: number;
    /**
     * the product.id this tank belongs to
     * @type {number}
     * @memberof TankObject
     */
    productId?: number;
    /**
     * 
     * @type {TankInfo}
     * @memberof TankObject
     */
    tankInfo?: TankInfo;
    /**
     * Daily level readings
     * @type {Array<TankReading>}
     * @memberof TankObject
     */
    tankData?: Array<TankReading>;
    /**
     * activity within the last nDays
     * @type {Array<TankReading>}
     * @memberof TankObject
     */
    tankChanges?: Array<TankReading>;
}
/**
 * A daily volume reading, withdrawal or refill
 * @export
 * @interface TankReading
 */
export interface TankReading {
    /**
     * the volume in litres
     * @type {number}
     * @memberof TankReading
     */
    reading?: number;
    /**
     * Daily | Withdrawal | Refill | Periodic reading
     * @type {string}
     * @memberof TankReading
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof TankReading
     */
    utcTime?: string;
}
/**
 * 
 * @export
 * @interface TankSensor
 */
export interface TankSensor {
    /**
     * 
     * @type {number}
     * @memberof TankSensor
     */
    sensorId?: number;
    /**
     * 
     * @type {string}
     * @memberof TankSensor
     */
    sensorType?: string;
    /**
     * 
     * @type {number}
     * @memberof TankSensor
     */
    tankId?: number;
}
/**
 * 
 * @export
 * @interface ThingGroup
 */
export interface ThingGroup {
    /**
     * 
     * @type {string}
     * @memberof ThingGroup
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ThingGroup
     */
    firmwareVersion?: string;
}
/**
 * 
 * @export
 * @interface ThingGroupInData
 */
export interface ThingGroupInData {
    /**
     * 
     * @type {ThingGroup}
     * @memberof ThingGroupInData
     */
    data?: ThingGroup;
}
/**
 * 
 * @export
 * @interface ThingGroupsInData
 */
export interface ThingGroupsInData {
    /**
     * 
     * @type {Array<ThingGroup>}
     * @memberof ThingGroupsInData
     */
    data?: Array<ThingGroup>;
}
/**
 * 
 * @export
 * @interface TiersInData
 */
export interface TiersInData {
    /**
     * 
     * @type {Array<string>}
     * @memberof TiersInData
     */
    data?: Array<string>;
}
/**
 * 
 * @export
 * @interface TimeSeries
 */
export interface TimeSeries {
    /**
     * 
     * @type {number}
     * @memberof TimeSeries
     */
    id: number;
    /**
     * 
     * @type {Array<TimeSeriesValue>}
     * @memberof TimeSeries
     */
    power?: Array<TimeSeriesValue>;
}
/**
 * 
 * @export
 * @interface TimeSeriesData
 */
export interface TimeSeriesData {
    /**
     * 
     * @type {number}
     * @memberof TimeSeriesData
     */
    timestamp?: number;
    /**
     * 
     * @type {number}
     * @memberof TimeSeriesData
     */
    value?: number;
}
/**
 * 
 * @export
 * @interface TimeSeriesInData
 */
export interface TimeSeriesInData {
    /**
     * 
     * @type {TimeSeries}
     * @memberof TimeSeriesInData
     */
    data?: TimeSeries;
}
/**
 * 
 * @export
 * @interface TimeSeriesObject
 */
export interface TimeSeriesObject {
    /**
     * 
     * @type {object}
     * @memberof TimeSeriesObject
     */
    value?: object;
}
/**
 * 
 * @export
 * @interface TimeSeriesValue
 */
export interface TimeSeriesValue {
    /**
     * 
     * @type {number}
     * @memberof TimeSeriesValue
     */
    value?: number;
    /**
     * 
     * @type {string}
     * @memberof TimeSeriesValue
     */
    date?: string;
}
/**
 * 
 * @export
 * @interface TokenResponse
 */
export interface TokenResponse {
    /**
     * 
     * @type {string}
     * @memberof TokenResponse
     */
    token?: string;
    /**
     * 
     * @type {string}
     * @memberof TokenResponse
     */
    authType?: string;
    /**
     * 
     * @type {number}
     * @memberof TokenResponse
     */
    expiresIn?: number;
}
/**
 * 
 * @export
 * @interface TokenResponsePartner
 */
export interface TokenResponsePartner {
    /**
     * 
     * @type {string}
     * @memberof TokenResponsePartner
     */
    token?: string;
    /**
     * 
     * @type {string}
     * @memberof TokenResponsePartner
     */
    authType?: string;
    /**
     * 
     * @type {number}
     * @memberof TokenResponsePartner
     */
    expiresIn?: number;
    /**
     * 
     * @type {Array<TokenResponsePartnerOrgs>}
     * @memberof TokenResponsePartner
     */
    orgs?: Array<TokenResponsePartnerOrgs>;
}
/**
 * 
 * @export
 * @interface TokenResponsePartnerOrgs
 */
export interface TokenResponsePartnerOrgs {
    /**
     * 
     * @type {number}
     * @memberof TokenResponsePartnerOrgs
     */
    orgId?: number;
    /**
     * 
     * @type {string}
     * @memberof TokenResponsePartnerOrgs
     */
    orgName?: string;
    /**
     * 
     * @type {Array<ProductType>}
     * @memberof TokenResponsePartnerOrgs
     */
    productTypes?: Array<ProductType>;
}
/**
 * 
 * @export
 * @interface Transceiver
 */
export interface Transceiver {
    /**
     * 
     * @type {number}
     * @memberof Transceiver
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Transceiver
     */
    serialNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof Transceiver
     */
    imei?: string;
    /**
     * 
     * @type {string}
     * @memberof Transceiver
     */
    status?: string;
    /**
     * 
     * @type {number}
     * @memberof Transceiver
     */
    siteId?: number;
    /**
     * 
     * @type {string}
     * @memberof Transceiver
     */
    thingId?: string;
    /**
     * 
     * @type {number}
     * @memberof Transceiver
     */
    principalId?: number;
    /**
     * 
     * @type {string}
     * @memberof Transceiver
     */
    batch?: string;
    /**
     * 
     * @type {number}
     * @memberof Transceiver
     */
    batchNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof Transceiver
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof Transceiver
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof Transceiver
     */
    deletedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof Transceiver
     */
    thingGroupName?: string;
    /**
     * 
     * @type {string}
     * @memberof Transceiver
     */
    awsThingGroups?: string;
    /**
     * 
     * @type {string}
     * @memberof Transceiver
     */
    firmwareVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof Transceiver
     */
    simIccid?: string;
    /**
     * 
     * @type {string}
     * @memberof Transceiver
     */
    mbVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof Transceiver
     */
    ebVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof Transceiver
     */
    bootloaderVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof Transceiver
     */
    poNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof Transceiver
     */
    type?: string;
    /**
     * 
     * @type {object}
     * @memberof Transceiver
     */
    bridgeConfig?: object;
    /**
     * 
     * @type {string}
     * @memberof Transceiver
     */
    internalConf?: string;
    /**
     * 
     * @type {string}
     * @memberof Transceiver
     */
    externalConf?: string;
    /**
     * 
     * @type {string}
     * @memberof Transceiver
     */
    modemType?: string;
    /**
     * 
     * @type {number}
     * @memberof Transceiver
     */
    gatewayId?: number;
    /**
     * 
     * @type {Array<Sensor>}
     * @memberof Transceiver
     */
    sensors?: Array<Sensor> | null;
    /**
     * 
     * @type {Array<Node>}
     * @memberof Transceiver
     */
    nodes?: Array<Node> | null;
    /**
     * 
     * @type {Gateway}
     * @memberof Transceiver
     */
    gateway?: Gateway;
    /**
     * 
     * @type {boolean}
     * @memberof Transceiver
     */
    isClassic?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Transceiver
     */
    isChimeraV2?: boolean;
}
/**
 * 
 * @export
 * @interface TransceiverDash
 */
export interface TransceiverDash {
    /**
     * 
     * @type {Array<TransceiverDashData>}
     * @memberof TransceiverDash
     */
    data?: Array<TransceiverDashData>;
}
/**
 * 
 * @export
 * @interface TransceiverDashData
 */
export interface TransceiverDashData {
    /**
     * 
     * @type {number}
     * @memberof TransceiverDashData
     */
    id: number;
    /**
     * 
     * @type {CurrentReading}
     * @memberof TransceiverDashData
     */
    batteryVoltage?: CurrentReading;
    /**
     * 
     * @type {CurrentReading}
     * @memberof TransceiverDashData
     */
    localRssi?: CurrentReading;
    /**
     * 
     * @type {CurrentReading}
     * @memberof TransceiverDashData
     */
    remoteRssi?: CurrentReading;
}
/**
 * 
 * @export
 * @interface TransceiverGraphData
 */
export interface TransceiverGraphData {
    /**
     * 
     * @type {Array<TimeSeriesValue>}
     * @memberof TransceiverGraphData
     */
    battery_voltage?: Array<TimeSeriesValue>;
    /**
     * 
     * @type {Array<TimeSeriesValue>}
     * @memberof TransceiverGraphData
     */
    solar_voltage?: Array<TimeSeriesValue>;
    /**
     * 
     * @type {Array<TimeSeriesValue>}
     * @memberof TransceiverGraphData
     */
    mains_voltage?: Array<TimeSeriesValue>;
    /**
     * 
     * @type {Array<TimeSeriesValue>}
     * @memberof TransceiverGraphData
     */
    location?: Array<TimeSeriesValue>;
    /**
     * 
     * @type {Array<TimeSeriesValue>}
     * @memberof TransceiverGraphData
     */
    cell_strength?: Array<TimeSeriesValue>;
    /**
     * 
     * @type {Array<TimeSeriesValue>}
     * @memberof TransceiverGraphData
     */
    temperature?: Array<TimeSeriesValue>;
}
/**
 * 
 * @export
 * @interface TransceiverGraphDataInData
 */
export interface TransceiverGraphDataInData {
    /**
     * 
     * @type {TransceiverGraphData}
     * @memberof TransceiverGraphDataInData
     */
    data?: TransceiverGraphData;
}
/**
 * 
 * @export
 * @interface TransceiverInData
 */
export interface TransceiverInData {
    /**
     * 
     * @type {Transceiver}
     * @memberof TransceiverInData
     */
    data?: Transceiver;
}
/**
 * 
 * @export
 * @interface TransceiverSensor
 */
export interface TransceiverSensor {
    /**
     * 
     * @type {number}
     * @memberof TransceiverSensor
     */
    transceiverId?: number;
    /**
     * 
     * @type {number}
     * @memberof TransceiverSensor
     */
    sensorId?: number | null;
}
/**
 * 
 * @export
 * @interface TransceiverSensorInData
 */
export interface TransceiverSensorInData {
    /**
     * 
     * @type {TransceiverSensor}
     * @memberof TransceiverSensorInData
     */
    data?: TransceiverSensor;
}
/**
 * 
 * @export
 * @interface TransceiverThingGroup
 */
export interface TransceiverThingGroup {
    /**
     * 
     * @type {number}
     * @memberof TransceiverThingGroup
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof TransceiverThingGroup
     */
    thingGroupName?: string;
}
/**
 * 
 * @export
 * @interface TransceiverThingGroupsInData
 */
export interface TransceiverThingGroupsInData {
    /**
     * 
     * @type {Array<TransceiverThingGroup>}
     * @memberof TransceiverThingGroupsInData
     */
    data?: Array<TransceiverThingGroup>;
}
/**
 * 
 * @export
 * @interface TransceiversInData
 */
export interface TransceiversInData {
    /**
     * 
     * @type {Array<Transceiver>}
     * @memberof TransceiversInData
     */
    data?: Array<Transceiver>;
}
/**
 * 
 * @export
 * @interface UpdateBilling
 */
export interface UpdateBilling {
    /**
     * 
     * @type {number}
     * @memberof UpdateBilling
     */
    productId: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateBilling
     */
    orgId: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateBilling
     */
    directTier: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateBilling
     */
    partnerId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateBilling
     */
    partnerContributionTier?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateBillingInData
 */
export interface UpdateBillingInData {
    /**
     * 
     * @type {UpdateBilling}
     * @memberof UpdateBillingInData
     */
    data?: UpdateBilling;
}
/**
 * 
 * @export
 * @interface UrlInData
 */
export interface UrlInData {
    /**
     * 
     * @type {SignedUrl}
     * @memberof UrlInData
     */
    data?: SignedUrl;
}
/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {number}
     * @memberof User
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    lastName: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    phone?: string | null;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    orgId?: number;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    role?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    password?: string;
    /**
     * 
     * @type {UserPreferences}
     * @memberof User
     */
    preferences?: UserPreferences;
}
/**
 * 
 * @export
 * @interface UserInData
 */
export interface UserInData {
    /**
     * 
     * @type {User}
     * @memberof UserInData
     */
    data?: User;
}
/**
 * 
 * @export
 * @interface UserPreferences
 */
export interface UserPreferences {
    /**
     * 
     * @type {UserPreferencesWater}
     * @memberof UserPreferences
     */
    water?: UserPreferencesWater;
    /**
     * 
     * @type {string}
     * @memberof UserPreferences
     */
    country?: UserPreferencesCountryEnum;
    /**
     * 
     * @type {string}
     * @memberof UserPreferences
     */
    language?: UserPreferencesLanguageEnum;
    /**
     * 
     * @type {UserPreferencesPartner}
     * @memberof UserPreferences
     */
    partner?: UserPreferencesPartner;
}

/**
    * @export
    * @enum {string}
    */
export enum UserPreferencesCountryEnum {
    Nz = 'nz',
    Ie = 'ie',
    Uk = 'uk'
}
/**
    * @export
    * @enum {string}
    */
export enum UserPreferencesLanguageEnum {
    En = 'en'
}

/**
 * 
 * @export
 * @interface UserPreferencesPartner
 */
export interface UserPreferencesPartner {
    /**
     * 
     * @type {UserPreferencesPartnerMilk}
     * @memberof UserPreferencesPartner
     */
    milk?: UserPreferencesPartnerMilk;
    /**
     * 
     * @type {UserPreferencesPartnerFuel}
     * @memberof UserPreferencesPartner
     */
    fuel?: UserPreferencesPartnerFuel;
    /**
     * 
     * @type {UserPreferencesPartnerFeed}
     * @memberof UserPreferencesPartner
     */
    feed?: UserPreferencesPartnerFeed;
}
/**
 * 
 * @export
 * @interface UserPreferencesPartnerFeed
 */
export interface UserPreferencesPartnerFeed {
    /**
     * 
     * @type {AlertSummaryUserPreferencesFeed}
     * @memberof UserPreferencesPartnerFeed
     */
    alertSummaryEmail?: AlertSummaryUserPreferencesFeed;
}
/**
 * 
 * @export
 * @interface UserPreferencesPartnerFuel
 */
export interface UserPreferencesPartnerFuel {
    /**
     * 
     * @type {AlertSummaryUserPreferencesFuel}
     * @memberof UserPreferencesPartnerFuel
     */
    alertSummaryEmail?: AlertSummaryUserPreferencesFuel;
}
/**
 * 
 * @export
 * @interface UserPreferencesPartnerMilk
 */
export interface UserPreferencesPartnerMilk {
    /**
     * 
     * @type {AlertSummaryUserPreferencesMilk}
     * @memberof UserPreferencesPartnerMilk
     */
    alertSummaryEmail?: AlertSummaryUserPreferencesMilk;
}
/**
 * 
 * @export
 * @interface UserPreferencesWater
 */
export interface UserPreferencesWater {
    /**
     * 
     * @type {string}
     * @memberof UserPreferencesWater
     */
    waterFlowRatePreference?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserPreferencesWater
     */
    waterVolumePreference?: string | null;
}
/**
 * 
 * @export
 * @interface UsersInData
 */
export interface UsersInData {
    /**
     * 
     * @type {Array<User>}
     * @memberof UsersInData
     */
    data?: Array<User>;
}
/**
 * 
 * @export
 * @interface UsersUserIdRolesData
 */
export interface UsersUserIdRolesData {
    /**
     * 
     * @type {number}
     * @memberof UsersUserIdRolesData
     */
    orgId?: number;
    /**
     * 
     * @type {string}
     * @memberof UsersUserIdRolesData
     */
    role?: UsersUserIdRolesDataRoleEnum;
    /**
     * 
     * @type {number}
     * @memberof UsersUserIdRolesData
     */
    roleId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UsersUserIdRolesData
     */
    action?: UsersUserIdRolesDataActionEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum UsersUserIdRolesDataRoleEnum {
    OrgAdmin = 'org.admin'
}
/**
    * @export
    * @enum {string}
    */
export enum UsersUserIdRolesDataActionEnum {
    Attach = 'attach',
    Detach = 'detach'
}

/**
 * 
 * @export
 * @interface Vat
 */
export interface Vat {
    /**
     * 
     * @type {number}
     * @memberof Vat
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof Vat
     */
    productId?: number;
    /**
     * 
     * @type {number}
     * @memberof Vat
     */
    siteId?: number;
    /**
     * 
     * @type {number}
     * @memberof Vat
     */
    transceiverId?: number | null;
    /**
     * 
     * @type {VatFormula}
     * @memberof Vat
     */
    formula?: VatFormula | null;
    /**
     * 
     * @type {string}
     * @memberof Vat
     */
    model?: string;
    /**
     * 
     * @type {string}
     * @memberof Vat
     */
    offset?: string;
    /**
     * 
     * @type {number}
     * @memberof Vat
     */
    ventDistance?: number;
    /**
     * 
     * @type {number}
     * @memberof Vat
     */
    height?: number;
    /**
     * 
     * @type {string}
     * @memberof Vat
     */
    label?: string;
    /**
     * 
     * @type {EntityStatus}
     * @memberof Vat
     */
    status?: EntityStatus;
    /**
     * 
     * @type {number}
     * @memberof Vat
     */
    emptyDistance?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Vat
     */
    vatOffset?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Vat
     */
    alertHcpOffset?: number;
    /**
     * 
     * @type {number}
     * @memberof Vat
     */
    alertMilkTooCold?: number;
    /**
     * 
     * @type {number}
     * @memberof Vat
     */
    alertInletTooWarm?: number;
    /**
     * 
     * @type {number}
     * @memberof Vat
     */
    stirrerThresh?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Vat
     */
    dryOff?: number;
    /**
     * 
     * @type {string}
     * @memberof Vat
     */
    calibratedAt?: string;
    /**
     * 
     * @type {VatState}
     * @memberof Vat
     */
    state?: VatState | null;
    /**
     * 
     * @type {string}
     * @memberof Vat
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof Vat
     */
    sizeString?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Vat
     */
    vatNumber?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Vat
     */
    temperatureOffset?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Vat
     */
    formulaId?: number | null;
    /**
     * 
     * @type {object}
     * @memberof Vat
     */
    formulaParameters?: object | null;
    /**
     * 
     * @type {EntityLocation}
     * @memberof Vat
     */
    entitylocation?: EntityLocation;
    /**
     * 
     * @type {string}
     * @memberof Vat
     */
    liveAt?: string;
    /**
     * 
     * @type {Array<EntityStatusChange>}
     * @memberof Vat
     */
    entitystatuschanges?: Array<EntityStatusChange>;
    /**
     * 
     * @type {string}
     * @memberof Vat
     */
    liveAtDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Vat
     */
    complianceMethod?: string;
}
/**
 * 
 * @export
 * @interface VatCollection
 */
export interface VatCollection {
    /**
     * 
     * @type {string}
     * @memberof VatCollection
     */
    vatNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof VatCollection
     */
    supplierNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof VatCollection
     */
    collectionDateTime?: string;
    /**
     * 
     * @type {string}
     * @memberof VatCollection
     */
    collectionType?: VatCollectionCollectionTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof VatCollection
     */
    collectionVolume?: number;
    /**
     * 
     * @type {number}
     * @memberof VatCollection
     */
    ageAtCollection?: number;
    /**
     * 
     * @type {number}
     * @memberof VatCollection
     */
    scoreAtCollection?: number;
    /**
     * 
     * @type {number}
     * @memberof VatCollection
     */
    temperatureAtCollection?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum VatCollectionCollectionTypeEnum {
    Unknown = 'unknown',
    Partial = 'partial',
    Full = 'full'
}

/**
 * 
 * @export
 * @interface VatCollectionAllOf
 */
export interface VatCollectionAllOf {
    /**
     * 
     * @type {string}
     * @memberof VatCollectionAllOf
     */
    vatNumber?: string;
}
/**
 * 
 * @export
 * @interface VatCollectionAllOf1
 */
export interface VatCollectionAllOf1 {
    /**
     * 
     * @type {number}
     * @memberof VatCollectionAllOf1
     */
    temperatureAtCollection?: number;
}
/**
 * 
 * @export
 * @interface VatData
 */
export interface VatData {
    /**
     * 
     * @type {number}
     * @memberof VatData
     */
    id: number;
    /**
     * 
     * @type {CurrentReading}
     * @memberof VatData
     */
    vatTemp?: CurrentReading;
    /**
     * 
     * @type {CurrentReading}
     * @memberof VatData
     */
    inletTemp?: CurrentReading;
    /**
     * 
     * @type {CurrentReading}
     * @memberof VatData
     */
    volume?: CurrentReading;
    /**
     * 
     * @type {CurrentReading}
     * @memberof VatData
     */
    stirrer?: CurrentReading;
    /**
     * 
     * @type {CurrentReading}
     * @memberof VatData
     */
    milkScore?: CurrentReading;
    /**
     * 
     * @type {CurrentReading}
     * @memberof VatData
     */
    vatWashFinish?: CurrentReading;
    /**
     * 
     * @type {CurrentReading}
     * @memberof VatData
     */
    milkingStart?: CurrentReading;
    /**
     * 
     * @type {CurrentReading}
     * @memberof VatData
     */
    milkingFinish?: CurrentReading;
    /**
     * 
     * @type {CurrentReading}
     * @memberof VatData
     */
    power?: CurrentReading;
}
/**
 * 
 * @export
 * @interface VatDataInData
 */
export interface VatDataInData {
    /**
     * 
     * @type {VatData}
     * @memberof VatDataInData
     */
    data?: VatData;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum VatFormula {
    FonterraVatII = 'FonterraVatII',
    Longveld = 'Longveld',
    Butterfly = 'Butterfly',
    Spherical = 'Spherical',
    Crown = 'Crown',
    Custom = 'Custom',
    Null = 'null'
}

/**
 * 
 * @export
 * @interface VatInData
 */
export interface VatInData {
    /**
     * 
     * @type {Vat}
     * @memberof VatInData
     */
    data?: Vat;
}
/**
 * 
 * @export
 * @interface VatLabels
 */
export interface VatLabels {
    /**
     * 
     * @type {Array<VatLabelsVats>}
     * @memberof VatLabels
     */
    vats?: Array<VatLabelsVats>;
}
/**
 * 
 * @export
 * @interface VatLabelsInData
 */
export interface VatLabelsInData {
    /**
     * 
     * @type {VatLabels}
     * @memberof VatLabelsInData
     */
    data?: VatLabels;
}
/**
 * 
 * @export
 * @interface VatLabelsVats
 */
export interface VatLabelsVats {
    /**
     * 
     * @type {number}
     * @memberof VatLabelsVats
     */
    vatId?: number;
    /**
     * 
     * @type {number}
     * @memberof VatLabelsVats
     */
    vatNumber?: number;
}
/**
 * 
 * @export
 * @interface VatSensor
 */
export interface VatSensor {
    /**
     * 
     * @type {number}
     * @memberof VatSensor
     */
    sensorId?: number;
    /**
     * 
     * @type {string}
     * @memberof VatSensor
     */
    sensorType?: string;
    /**
     * 
     * @type {number}
     * @memberof VatSensor
     */
    vatId?: number;
    /**
     * 
     * @type {number}
     * @memberof VatSensor
     */
    transceiverId?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum VatState {
    Supply = 'supply',
    NonSupply = 'nonSupply',
    NotUsed = 'notUsed',
    Null = 'null'
}

/**
 * 
 * @export
 * @interface VatTemperatureOffset
 */
export interface VatTemperatureOffset {
    /**
     * 
     * @type {number}
     * @memberof VatTemperatureOffset
     */
    temperatureOffset: number;
}
/**
 * 
 * @export
 * @interface VatsInData
 */
export interface VatsInData {
    /**
     * 
     * @type {Array<Vat>}
     * @memberof VatsInData
     */
    data?: Array<Vat>;
}
/**
 * 
 * @export
 * @interface VatsVatIdSetEmptyDistanceData
 */
export interface VatsVatIdSetEmptyDistanceData {
    /**
     * 
     * @type {number}
     * @memberof VatsVatIdSetEmptyDistanceData
     */
    emptyDistance?: number;
}
/**
 * 
 * @export
 * @interface WaterEntityInput
 */
export interface WaterEntityInput {
    /**
     * 
     * @type {string}
     * @memberof WaterEntityInput
     */
    position?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WaterEntityInput
     */
    locationLat?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WaterEntityInput
     */
    locationLng?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WaterEntityInput
     */
    nominal?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WaterEntityInput
     */
    height?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WaterEntityInput
     */
    offset?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WaterEntityInput
     */
    litresPerPulse?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof WaterEntityInput
     */
    main?: boolean | null;
}
/**
 * 
 * @export
 * @interface WaterEntityInputInData
 */
export interface WaterEntityInputInData {
    /**
     * 
     * @type {WaterEntityInput}
     * @memberof WaterEntityInputInData
     */
    data?: WaterEntityInput;
}
/**
 * 
 * @export
 * @interface WaterExport
 */
export interface WaterExport {
    /**
     * 
     * @type {number}
     * @memberof WaterExport
     */
    id?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WaterExport
     */
    targetOrgId?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterExport
     */
    productId?: number;
    /**
     * 
     * @type {string}
     * @memberof WaterExport
     */
    consentIdentifier?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterExport
     */
    status?: WaterExportStatusEnum;
    /**
     * 
     * @type {Array<number>}
     * @memberof WaterExport
     */
    waterMeterIds?: Array<number>;
    /**
     * 
     * @type {Array<Audit>}
     * @memberof WaterExport
     */
    audits?: Array<Audit>;
}

/**
    * @export
    * @enum {string}
    */
export enum WaterExportStatusEnum {
    Enabled = 'enabled',
    Disabled = 'disabled',
    InternalOnly = 'internalOnly'
}

/**
 * 
 * @export
 * @interface WaterExportInData
 */
export interface WaterExportInData {
    /**
     * 
     * @type {Array<WaterExport>}
     * @memberof WaterExportInData
     */
    data?: Array<WaterExport>;
}
/**
 * 
 * @export
 * @interface WaterLink
 */
export interface WaterLink {
    /**
     * 
     * @type {number}
     * @memberof WaterLink
     */
    inObject_id: number;
    /**
     * 
     * @type {string}
     * @memberof WaterLink
     */
    inObject_type: string;
    /**
     * 
     * @type {number}
     * @memberof WaterLink
     */
    outObject_id: number;
    /**
     * 
     * @type {string}
     * @memberof WaterLink
     */
    outObject_type: string;
}
/**
 * 
 * @export
 * @interface WaterLinkInData
 */
export interface WaterLinkInData {
    /**
     * 
     * @type {WaterLink}
     * @memberof WaterLinkInData
     */
    data?: WaterLink;
}
/**
 * 
 * @export
 * @interface WaterLinksInData
 */
export interface WaterLinksInData {
    /**
     * 
     * @type {Array<WaterLink>}
     * @memberof WaterLinksInData
     */
    data?: Array<WaterLink>;
}
/**
 * 
 * @export
 * @interface WaterMeter
 */
export interface WaterMeter {
    /**
     * 
     * @type {number}
     * @memberof WaterMeter
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WaterMeter
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof WaterMeter
     */
    litresPerPulse?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterMeter
     */
    locationLat?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WaterMeter
     */
    locationLng?: number | null;
    /**
     * 
     * @type {EntityLocation}
     * @memberof WaterMeter
     */
    entitylocation?: EntityLocation;
    /**
     * 
     * @type {number}
     * @memberof WaterMeter
     */
    productId?: number | null;
    /**
     * 
     * @type {Array<EntityStatusChange>}
     * @memberof WaterMeter
     */
    entitystatuschanges?: Array<EntityStatusChange>;
    /**
     * 
     * @type {EntityStatus}
     * @memberof WaterMeter
     */
    status?: EntityStatus;
    /**
     * 
     * @type {string}
     * @memberof WaterMeter
     */
    liveAtDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WaterMeter
     */
    liveAt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WaterMeter
     */
    createdAt?: string | null;
    /**
     * 
     * @type {Sensor}
     * @memberof WaterMeter
     */
    sensor?: Sensor;
    /**
     * 
     * @type {Transceiver}
     * @memberof WaterMeter
     */
    transceiver?: Transceiver;
}
/**
 * 
 * @export
 * @interface WaterMeterGraphData
 */
export interface WaterMeterGraphData {
    /**
     * 
     * @type {Array<TimeSeriesValue>}
     * @memberof WaterMeterGraphData
     */
    supplied?: Array<TimeSeriesValue>;
}
/**
 * 
 * @export
 * @interface WaterMeterGraphDataInData
 */
export interface WaterMeterGraphDataInData {
    /**
     * 
     * @type {WaterMeterGraphData}
     * @memberof WaterMeterGraphDataInData
     */
    data?: WaterMeterGraphData;
}
/**
 * 
 * @export
 * @interface WaterMeterInfo
 */
export interface WaterMeterInfo {
    /**
     * 
     * @type {number}
     * @memberof WaterMeterInfo
     */
    id?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WaterMeterInfo
     */
    productId?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterMeterInfo
     */
    siteId?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterMeterInfo
     */
    transceiverId?: number;
    /**
     * 
     * @type {string}
     * @memberof WaterMeterInfo
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof WaterMeterInfo
     */
    locationLat?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WaterMeterInfo
     */
    locationLng?: number | null;
    /**
     * 
     * @type {EntityStatus}
     * @memberof WaterMeterInfo
     */
    status?: EntityStatus;
    /**
     * 
     * @type {string}
     * @memberof WaterMeterInfo
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterMeterInfo
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterMeterInfo
     */
    deletedAt?: string;
}
/**
 * 
 * @export
 * @interface WaterMeterInfoInData
 */
export interface WaterMeterInfoInData {
    /**
     * 
     * @type {WaterMeterInfo}
     * @memberof WaterMeterInfoInData
     */
    data?: WaterMeterInfo;
}
/**
 * 
 * @export
 * @interface WaterMeterInfosInData
 */
export interface WaterMeterInfosInData {
    /**
     * 
     * @type {Array<WaterMeterInfo>}
     * @memberof WaterMeterInfosInData
     */
    data?: Array<WaterMeterInfo>;
}
/**
 * 
 * @export
 * @interface WaterMeterObject
 */
export interface WaterMeterObject {
    /**
     * 
     * @type {number}
     * @memberof WaterMeterObject
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterMeterObject
     */
    productId?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterMeterObject
     */
    waterMeterId?: number;
    /**
     * 
     * @type {WaterMeterInfo}
     * @memberof WaterMeterObject
     */
    waterMeterInfo?: WaterMeterInfo;
    /**
     * 
     * @type {WaterMeterReading}
     * @memberof WaterMeterObject
     */
    currentUsage?: WaterMeterReading;
    /**
     * 
     * @type {WaterMeterReading}
     * @memberof WaterMeterObject
     */
    suppliedToday?: WaterMeterReading;
    /**
     * 
     * @type {WaterMeterReading}
     * @memberof WaterMeterObject
     */
    suppliedYesterday?: WaterMeterReading;
    /**
     * 
     * @type {WaterMeterReading}
     * @memberof WaterMeterObject
     */
    suppliedDaysAgo?: WaterMeterReading;
}
/**
 * 
 * @export
 * @interface WaterMeterReading
 */
export interface WaterMeterReading {
    /**
     * 
     * @type {string}
     * @memberof WaterMeterReading
     */
    value?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterMeterReading
     */
    utcTime?: string;
    /**
     * 
     * @type {boolean}
     * @memberof WaterMeterReading
     */
    outOfSpec?: boolean;
}
/**
 * 
 * @export
 * @interface WaterMeterSensorsAssign
 */
export interface WaterMeterSensorsAssign {
    /**
     * 
     * @type {number}
     * @memberof WaterMeterSensorsAssign
     */
    transceiverId?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterMeterSensorsAssign
     */
    sensorId?: number;
    /**
     * 
     * @type {Array<WaterMeterInfo>}
     * @memberof WaterMeterSensorsAssign
     */
    waterMeter?: Array<WaterMeterInfo>;
    /**
     * 
     * @type {Array<WaterSensor>}
     * @memberof WaterMeterSensorsAssign
     */
    waterSensor?: Array<WaterSensor>;
}
/**
 * 
 * @export
 * @interface WaterMeterSensorsAssignInData
 */
export interface WaterMeterSensorsAssignInData {
    /**
     * 
     * @type {WaterMeterSensorsAssign}
     * @memberof WaterMeterSensorsAssignInData
     */
    data?: WaterMeterSensorsAssign;
}
/**
 * 
 * @export
 * @interface WaterMonitor
 */
export interface WaterMonitor {
    /**
     * 
     * @type {number}
     * @memberof WaterMonitor
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WaterMonitor
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof WaterMonitor
     */
    locationLat?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WaterMonitor
     */
    locationLng?: number | null;
    /**
     * 
     * @type {EntityLocation}
     * @memberof WaterMonitor
     */
    entitylocation?: EntityLocation;
    /**
     * 
     * @type {number}
     * @memberof WaterMonitor
     */
    productId?: number | null;
    /**
     * 
     * @type {Array<EntityStatusChange>}
     * @memberof WaterMonitor
     */
    entitystatuschanges?: Array<EntityStatusChange>;
    /**
     * 
     * @type {EntityStatus}
     * @memberof WaterMonitor
     */
    status?: EntityStatus;
    /**
     * 
     * @type {string}
     * @memberof WaterMonitor
     */
    liveAtDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WaterMonitor
     */
    liveAt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WaterMonitor
     */
    createdAt?: string | null;
    /**
     * 
     * @type {Sensor}
     * @memberof WaterMonitor
     */
    sensor?: Sensor;
    /**
     * 
     * @type {Transceiver}
     * @memberof WaterMonitor
     */
    transceiver?: Transceiver;
}
/**
 * 
 * @export
 * @interface WaterMonitorGraphData
 */
export interface WaterMonitorGraphData {
    /**
     * 
     * @type {Array<TimeSeriesValue>}
     * @memberof WaterMonitorGraphData
     */
    usage?: Array<TimeSeriesValue>;
}
/**
 * 
 * @export
 * @interface WaterMonitorGraphDataInData
 */
export interface WaterMonitorGraphDataInData {
    /**
     * 
     * @type {WaterMonitorGraphData}
     * @memberof WaterMonitorGraphDataInData
     */
    data?: WaterMonitorGraphData;
}
/**
 * 
 * @export
 * @interface WaterMonitorInfo
 */
export interface WaterMonitorInfo {
    /**
     * 
     * @type {number}
     * @memberof WaterMonitorInfo
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof WaterMonitorInfo
     */
    productId?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterMonitorInfo
     */
    siteId?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterMonitorInfo
     */
    transceiverId?: number;
    /**
     * 
     * @type {string}
     * @memberof WaterMonitorInfo
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof WaterMonitorInfo
     */
    locationLat?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WaterMonitorInfo
     */
    locationLng?: number | null;
    /**
     * 
     * @type {EntityStatus}
     * @memberof WaterMonitorInfo
     */
    status?: EntityStatus;
    /**
     * 
     * @type {string}
     * @memberof WaterMonitorInfo
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterMonitorInfo
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterMonitorInfo
     */
    deletedAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof WaterMonitorInfo
     */
    main?: boolean;
}
/**
 * 
 * @export
 * @interface WaterMonitorInfoInData
 */
export interface WaterMonitorInfoInData {
    /**
     * 
     * @type {WaterMonitorInfo}
     * @memberof WaterMonitorInfoInData
     */
    data?: WaterMonitorInfo;
}
/**
 * 
 * @export
 * @interface WaterMonitorInfosInData
 */
export interface WaterMonitorInfosInData {
    /**
     * 
     * @type {Array<WaterMonitorInfo>}
     * @memberof WaterMonitorInfosInData
     */
    data?: Array<WaterMonitorInfo>;
}
/**
 * 
 * @export
 * @interface WaterMonitorObject
 */
export interface WaterMonitorObject {
    /**
     * 
     * @type {number}
     * @memberof WaterMonitorObject
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterMonitorObject
     */
    productId?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterMonitorObject
     */
    waterMonitorId?: number;
    /**
     * 
     * @type {WaterMonitorInfo}
     * @memberof WaterMonitorObject
     */
    waterMonitorInfo?: WaterMonitorInfo;
    /**
     * 
     * @type {WaterMonitorReading}
     * @memberof WaterMonitorObject
     */
    overnightLow?: WaterMonitorReading;
    /**
     * 
     * @type {WaterMonitorReading}
     * @memberof WaterMonitorObject
     */
    currentUsage?: WaterMonitorReading;
    /**
     * 
     * @type {WaterMonitorReading}
     * @memberof WaterMonitorObject
     */
    flowRate?: WaterMonitorReading;
    /**
     * 
     * @type {WaterMonitorReading}
     * @memberof WaterMonitorObject
     */
    status?: WaterMonitorReading;
}
/**
 * 
 * @export
 * @interface WaterMonitorReading
 */
export interface WaterMonitorReading {
    /**
     * 
     * @type {string}
     * @memberof WaterMonitorReading
     */
    value?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterMonitorReading
     */
    utcTime?: string;
    /**
     * 
     * @type {boolean}
     * @memberof WaterMonitorReading
     */
    outOfSpec?: boolean;
}
/**
 * 
 * @export
 * @interface WaterMonitorSensorsAssign
 */
export interface WaterMonitorSensorsAssign {
    /**
     * 
     * @type {number}
     * @memberof WaterMonitorSensorsAssign
     */
    transceiverId?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterMonitorSensorsAssign
     */
    sensorId?: number;
    /**
     * 
     * @type {Array<WaterMonitorInfo>}
     * @memberof WaterMonitorSensorsAssign
     */
    waterMonitor?: Array<WaterMonitorInfo>;
    /**
     * 
     * @type {Array<WaterSensor>}
     * @memberof WaterMonitorSensorsAssign
     */
    waterSensor?: Array<WaterSensor>;
}
/**
 * 
 * @export
 * @interface WaterMonitorSensorsAssignInData
 */
export interface WaterMonitorSensorsAssignInData {
    /**
     * 
     * @type {WaterMonitorSensorsAssign}
     * @memberof WaterMonitorSensorsAssignInData
     */
    data?: WaterMonitorSensorsAssign;
}
/**
 * 
 * @export
 * @interface WaterSensor
 */
export interface WaterSensor {
    /**
     * 
     * @type {number}
     * @memberof WaterSensor
     */
    sensorId?: number;
    /**
     * 
     * @type {string}
     * @memberof WaterSensor
     */
    sensorType?: string;
    /**
     * 
     * @type {number}
     * @memberof WaterSensor
     */
    ownerId?: number;
    /**
     * 
     * @type {string}
     * @memberof WaterSensor
     */
    ownerType?: string;
}
/**
 * 
 * @export
 * @interface WaterTank
 */
export interface WaterTank {
    /**
     * 
     * @type {number}
     * @memberof WaterTank
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WaterTank
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof WaterTank
     */
    locationLat?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WaterTank
     */
    locationLng?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WaterTank
     */
    nominal?: number | null;
    /**
     * 
     * @type {EntityLocation}
     * @memberof WaterTank
     */
    entitylocation?: EntityLocation;
    /**
     * 
     * @type {number}
     * @memberof WaterTank
     */
    productId?: number | null;
    /**
     * 
     * @type {Array<EntityStatusChange>}
     * @memberof WaterTank
     */
    entitystatuschanges?: Array<EntityStatusChange>;
    /**
     * 
     * @type {EntityStatus}
     * @memberof WaterTank
     */
    status?: EntityStatus;
    /**
     * 
     * @type {string}
     * @memberof WaterTank
     */
    liveAtDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WaterTank
     */
    liveAt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WaterTank
     */
    createdAt?: string | null;
    /**
     * 
     * @type {Sensor}
     * @memberof WaterTank
     */
    sensor?: Sensor;
    /**
     * 
     * @type {Transceiver}
     * @memberof WaterTank
     */
    transceiver?: Transceiver;
}
/**
 * 
 * @export
 * @interface WaterTankGraphData
 */
export interface WaterTankGraphData {
    /**
     * 
     * @type {Array<TimeSeriesValue>}
     * @memberof WaterTankGraphData
     */
    volume?: Array<TimeSeriesValue>;
    /**
     * 
     * @type {Array<TimeSeriesValue>}
     * @memberof WaterTankGraphData
     */
    usage?: Array<TimeSeriesValue>;
}
/**
 * 
 * @export
 * @interface WaterTankGraphDataInData
 */
export interface WaterTankGraphDataInData {
    /**
     * 
     * @type {WaterTankGraphData}
     * @memberof WaterTankGraphDataInData
     */
    data?: WaterTankGraphData;
}
/**
 * 
 * @export
 * @interface WaterTankInfo
 */
export interface WaterTankInfo {
    /**
     * 
     * @type {number}
     * @memberof WaterTankInfo
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof WaterTankInfo
     */
    productId?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterTankInfo
     */
    siteId?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterTankInfo
     */
    transceiverId?: number;
    /**
     * 
     * @type {string}
     * @memberof WaterTankInfo
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof WaterTankInfo
     */
    offset?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterTankInfo
     */
    height?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterTankInfo
     */
    locationLat?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WaterTankInfo
     */
    locationLng?: number | null;
    /**
     * 
     * @type {EntityStatus}
     * @memberof WaterTankInfo
     */
    status?: EntityStatus;
    /**
     * 
     * @type {string}
     * @memberof WaterTankInfo
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterTankInfo
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterTankInfo
     */
    deletedAt?: string;
}
/**
 * 
 * @export
 * @interface WaterTankInfoInData
 */
export interface WaterTankInfoInData {
    /**
     * 
     * @type {WaterTankInfo}
     * @memberof WaterTankInfoInData
     */
    data?: WaterTankInfo;
}
/**
 * 
 * @export
 * @interface WaterTankInfosInData
 */
export interface WaterTankInfosInData {
    /**
     * 
     * @type {Array<WaterTankInfo>}
     * @memberof WaterTankInfosInData
     */
    data?: Array<WaterTankInfo>;
}
/**
 * 
 * @export
 * @interface WaterTankObject
 */
export interface WaterTankObject {
    /**
     * 
     * @type {number}
     * @memberof WaterTankObject
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterTankObject
     */
    productId?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterTankObject
     */
    waterTankId?: number;
    /**
     * 
     * @type {WaterTankInfo}
     * @memberof WaterTankObject
     */
    waterTankInfo?: WaterTankInfo;
    /**
     * 
     * @type {WaterTankReading}
     * @memberof WaterTankObject
     */
    volume?: WaterTankReading;
    /**
     * 
     * @type {WaterTankReading}
     * @memberof WaterTankObject
     */
    currentUsage?: WaterTankReading;
    /**
     * 
     * @type {WaterTankReading}
     * @memberof WaterTankObject
     */
    avgDailyUsage?: WaterTankReading;
    /**
     * 
     * @type {WaterTankReading}
     * @memberof WaterTankObject
     */
    usageLastHour?: WaterTankReading;
    /**
     * 
     * @type {WaterTankReading}
     * @memberof WaterTankObject
     */
    usageToday?: WaterTankReading;
    /**
     * 
     * @type {WaterTankReading}
     * @memberof WaterTankObject
     */
    usageYesterday?: WaterTankReading;
    /**
     * 
     * @type {WaterTankReading}
     * @memberof WaterTankObject
     */
    usageDaysAgo?: WaterTankReading;
}
/**
 * 
 * @export
 * @interface WaterTankReading
 */
export interface WaterTankReading {
    /**
     * 
     * @type {string}
     * @memberof WaterTankReading
     */
    value?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterTankReading
     */
    utcTime?: string;
    /**
     * 
     * @type {boolean}
     * @memberof WaterTankReading
     */
    outOfSpec?: boolean;
}
/**
 * 
 * @export
 * @interface WaterTankSensorsAssign
 */
export interface WaterTankSensorsAssign {
    /**
     * 
     * @type {number}
     * @memberof WaterTankSensorsAssign
     */
    transceiverId?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterTankSensorsAssign
     */
    sensorId?: number;
    /**
     * 
     * @type {Array<WaterTankInfo>}
     * @memberof WaterTankSensorsAssign
     */
    waterTank?: Array<WaterTankInfo>;
    /**
     * 
     * @type {Array<WaterSensor>}
     * @memberof WaterTankSensorsAssign
     */
    waterSensor?: Array<WaterSensor>;
}
/**
 * 
 * @export
 * @interface WaterTankSensorsAssignInData
 */
export interface WaterTankSensorsAssignInData {
    /**
     * 
     * @type {WaterTankSensorsAssign}
     * @memberof WaterTankSensorsAssignInData
     */
    data?: WaterTankSensorsAssign;
}
/**
 * 
 * @export
 * @interface WaterTotalizerCorrection
 */
export interface WaterTotalizerCorrection {
    /**
     * 
     * @type {number}
     * @memberof WaterTotalizerCorrection
     */
    correctionTs?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterTotalizerCorrection
     */
    processedTs?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterTotalizerCorrection
     */
    totalizerReading?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterTotalizerCorrection
     */
    uncorrectedReading?: number | null;
}
/**
 * 
 * @export
 * @interface WaterTotalizerCorrectionDynamoItem
 */
export interface WaterTotalizerCorrectionDynamoItem {
    /**
     * 
     * @type {WaterTotalizerCorrection}
     * @memberof WaterTotalizerCorrectionDynamoItem
     */
    data: WaterTotalizerCorrection;
}
/**
 * 
 * @export
 * @interface WaterTotalizerReading
 */
export interface WaterTotalizerReading {
    /**
     * 
     * @type {number}
     * @memberof WaterTotalizerReading
     */
    timestamp: number;
    /**
     * 
     * @type {number}
     * @memberof WaterTotalizerReading
     */
    usageDelta: number;
    /**
     * 
     * @type {number}
     * @memberof WaterTotalizerReading
     */
    totalUsage: number;
}
/**
 * 
 * @export
 * @interface WaterTotalizerReadingDynamoItem
 */
export interface WaterTotalizerReadingDynamoItem {
    /**
     * 
     * @type {WaterTotalizerReading}
     * @memberof WaterTotalizerReadingDynamoItem
     */
    data: WaterTotalizerReading;
}

/**
 * AddressApi - axios parameter creator
 * @export
 */
export const AddressApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a new address
         * @param {InlineObject} [inlineObject] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAddress: async (inlineObject?: InlineObject, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/address`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof inlineObject !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(inlineObject !== undefined ? inlineObject : {}) : (inlineObject || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes an address
         * @param {number} addressId ID of address to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAddress: async (addressId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'addressId' is not null or undefined
            if (addressId === null || addressId === undefined) {
                throw new RequiredError('addressId','Required parameter addressId was null or undefined when calling deleteAddress.');
            }
            const localVarPath = `/address/{addressId}`
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find address by addressId
         * @param {number} addressId ID of address to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressById: async (addressId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'addressId' is not null or undefined
            if (addressId === null || addressId === undefined) {
                throw new RequiredError('addressId','Required parameter addressId was null or undefined when calling getAddressById.');
            }
            const localVarPath = `/address/{addressId}`
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all the stored addresses
         * @summary List Addresses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddresses: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/address`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates an address
         * @param {number} addressId ID of address to return
         * @param {InlineObject1} [inlineObject1] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAddress: async (addressId: number, inlineObject1?: InlineObject1, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'addressId' is not null or undefined
            if (addressId === null || addressId === undefined) {
                throw new RequiredError('addressId','Required parameter addressId was null or undefined when calling updateAddress.');
            }
            const localVarPath = `/address/{addressId}`
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof inlineObject1 !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(inlineObject1 !== undefined ? inlineObject1 : {}) : (inlineObject1 || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AddressApi - functional programming interface
 * @export
 */
export const AddressApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a new address
         * @param {InlineObject} [inlineObject] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addAddress(inlineObject?: InlineObject, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Address>> {
            const localVarAxiosArgs = await AddressApiAxiosParamCreator(configuration).addAddress(inlineObject, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Deletes an address
         * @param {number} addressId ID of address to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAddress(addressId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await AddressApiAxiosParamCreator(configuration).deleteAddress(addressId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Find address by addressId
         * @param {number} addressId ID of address to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAddressById(addressId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Address>> {
            const localVarAxiosArgs = await AddressApiAxiosParamCreator(configuration).getAddressById(addressId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * List all the stored addresses
         * @summary List Addresses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAddresses(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddressesInData>> {
            const localVarAxiosArgs = await AddressApiAxiosParamCreator(configuration).getAddresses(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Updates an address
         * @param {number} addressId ID of address to return
         * @param {InlineObject1} [inlineObject1] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAddress(addressId: number, inlineObject1?: InlineObject1, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await AddressApiAxiosParamCreator(configuration).updateAddress(addressId, inlineObject1, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * AddressApi - factory interface
 * @export
 */
export const AddressApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Add a new address
         * @param {InlineObject} [inlineObject] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAddress(inlineObject?: InlineObject, options?: any): AxiosPromise<Address> {
            return AddressApiFp(configuration).addAddress(inlineObject, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes an address
         * @param {number} addressId ID of address to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAddress(addressId: number, options?: any): AxiosPromise<void> {
            return AddressApiFp(configuration).deleteAddress(addressId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Find address by addressId
         * @param {number} addressId ID of address to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressById(addressId: number, options?: any): AxiosPromise<Address> {
            return AddressApiFp(configuration).getAddressById(addressId, options).then((request) => request(axios, basePath));
        },
        /**
         * List all the stored addresses
         * @summary List Addresses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddresses(options?: any): AxiosPromise<AddressesInData> {
            return AddressApiFp(configuration).getAddresses(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates an address
         * @param {number} addressId ID of address to return
         * @param {InlineObject1} [inlineObject1] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAddress(addressId: number, inlineObject1?: InlineObject1, options?: any): AxiosPromise<void> {
            return AddressApiFp(configuration).updateAddress(addressId, inlineObject1, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AddressApi - object-oriented interface
 * @export
 * @class AddressApi
 * @extends {BaseAPI}
 */
export class AddressApi extends BaseAPI {
    /**
     * 
     * @summary Add a new address
     * @param {InlineObject} [inlineObject] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressApi
     */
    public addAddress(inlineObject?: InlineObject, options?: any) {
        return AddressApiFp(this.configuration).addAddress(inlineObject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes an address
     * @param {number} addressId ID of address to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressApi
     */
    public deleteAddress(addressId: number, options?: any) {
        return AddressApiFp(this.configuration).deleteAddress(addressId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Find address by addressId
     * @param {number} addressId ID of address to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressApi
     */
    public getAddressById(addressId: number, options?: any) {
        return AddressApiFp(this.configuration).getAddressById(addressId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all the stored addresses
     * @summary List Addresses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressApi
     */
    public getAddresses(options?: any) {
        return AddressApiFp(this.configuration).getAddresses(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates an address
     * @param {number} addressId ID of address to return
     * @param {InlineObject1} [inlineObject1] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressApi
     */
    public updateAddress(addressId: number, inlineObject1?: InlineObject1, options?: any) {
        return AddressApiFp(this.configuration).updateAddress(addressId, inlineObject1, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * AlertsApi - axios parameter creator
 * @export
 */
export const AlertsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a new alert
         * @param {AlertInData} alertInData Alert object to be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAlert: async (alertInData: AlertInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'alertInData' is not null or undefined
            if (alertInData === null || alertInData === undefined) {
                throw new RequiredError('alertInData','Required parameter alertInData was null or undefined when calling addAlert.');
            }
            const localVarPath = `/alerts`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof alertInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(alertInData !== undefined ? alertInData : {}) : (alertInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes an alert
         * @param {number} alertId ID of alert to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAlert: async (alertId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'alertId' is not null or undefined
            if (alertId === null || alertId === undefined) {
                throw new RequiredError('alertId','Required parameter alertId was null or undefined when calling deleteAlert.');
            }
            const localVarPath = `/alerts/{alertId}`
                .replace(`{${"alertId"}}`, encodeURIComponent(String(alertId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a alerts
         * @summary Find alert by ID
         * @param {number} alertId ID of alert to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlertById: async (alertId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'alertId' is not null or undefined
            if (alertId === null || alertId === undefined) {
                throw new RequiredError('alertId','Required parameter alertId was null or undefined when calling getAlertById.');
            }
            const localVarPath = `/alerts/{alertId}`
                .replace(`{${"alertId"}}`, encodeURIComponent(String(alertId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Alerts are subscription settings so we know what types of message to send to each user via sms or email
         * @summary List all the alerts for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVatAlerts: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/alerts`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates a alert
         * @param {number} alertId ID of alert to return
         * @param {AlertInData} alertInData Alert object to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAlert: async (alertId: number, alertInData: AlertInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'alertId' is not null or undefined
            if (alertId === null || alertId === undefined) {
                throw new RequiredError('alertId','Required parameter alertId was null or undefined when calling updateAlert.');
            }
            // verify required parameter 'alertInData' is not null or undefined
            if (alertInData === null || alertInData === undefined) {
                throw new RequiredError('alertInData','Required parameter alertInData was null or undefined when calling updateAlert.');
            }
            const localVarPath = `/alerts/{alertId}`
                .replace(`{${"alertId"}}`, encodeURIComponent(String(alertId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof alertInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(alertInData !== undefined ? alertInData : {}) : (alertInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AlertsApi - functional programming interface
 * @export
 */
export const AlertsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a new alert
         * @param {AlertInData} alertInData Alert object to be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addAlert(alertInData: AlertInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await AlertsApiAxiosParamCreator(configuration).addAlert(alertInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Deletes an alert
         * @param {number} alertId ID of alert to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAlert(alertId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await AlertsApiAxiosParamCreator(configuration).deleteAlert(alertId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns a alerts
         * @summary Find alert by ID
         * @param {number} alertId ID of alert to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAlertById(alertId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AlertInData>> {
            const localVarAxiosArgs = await AlertsApiAxiosParamCreator(configuration).getAlertById(alertId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Alerts are subscription settings so we know what types of message to send to each user via sms or email
         * @summary List all the alerts for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVatAlerts(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AlertsInData>> {
            const localVarAxiosArgs = await AlertsApiAxiosParamCreator(configuration).getVatAlerts(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Updates a alert
         * @param {number} alertId ID of alert to return
         * @param {AlertInData} alertInData Alert object to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAlert(alertId: number, alertInData: AlertInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await AlertsApiAxiosParamCreator(configuration).updateAlert(alertId, alertInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * AlertsApi - factory interface
 * @export
 */
export const AlertsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Add a new alert
         * @param {AlertInData} alertInData Alert object to be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAlert(alertInData: AlertInData, options?: any): AxiosPromise<void> {
            return AlertsApiFp(configuration).addAlert(alertInData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes an alert
         * @param {number} alertId ID of alert to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAlert(alertId: number, options?: any): AxiosPromise<void> {
            return AlertsApiFp(configuration).deleteAlert(alertId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a alerts
         * @summary Find alert by ID
         * @param {number} alertId ID of alert to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlertById(alertId: number, options?: any): AxiosPromise<AlertInData> {
            return AlertsApiFp(configuration).getAlertById(alertId, options).then((request) => request(axios, basePath));
        },
        /**
         * Alerts are subscription settings so we know what types of message to send to each user via sms or email
         * @summary List all the alerts for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVatAlerts(options?: any): AxiosPromise<AlertsInData> {
            return AlertsApiFp(configuration).getVatAlerts(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates a alert
         * @param {number} alertId ID of alert to return
         * @param {AlertInData} alertInData Alert object to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAlert(alertId: number, alertInData: AlertInData, options?: any): AxiosPromise<void> {
            return AlertsApiFp(configuration).updateAlert(alertId, alertInData, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AlertsApi - object-oriented interface
 * @export
 * @class AlertsApi
 * @extends {BaseAPI}
 */
export class AlertsApi extends BaseAPI {
    /**
     * 
     * @summary Add a new alert
     * @param {AlertInData} alertInData Alert object to be added
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertsApi
     */
    public addAlert(alertInData: AlertInData, options?: any) {
        return AlertsApiFp(this.configuration).addAlert(alertInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes an alert
     * @param {number} alertId ID of alert to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertsApi
     */
    public deleteAlert(alertId: number, options?: any) {
        return AlertsApiFp(this.configuration).deleteAlert(alertId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a alerts
     * @summary Find alert by ID
     * @param {number} alertId ID of alert to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertsApi
     */
    public getAlertById(alertId: number, options?: any) {
        return AlertsApiFp(this.configuration).getAlertById(alertId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Alerts are subscription settings so we know what types of message to send to each user via sms or email
     * @summary List all the alerts for the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertsApi
     */
    public getVatAlerts(options?: any) {
        return AlertsApiFp(this.configuration).getVatAlerts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates a alert
     * @param {number} alertId ID of alert to return
     * @param {AlertInData} alertInData Alert object to be updated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertsApi
     */
    public updateAlert(alertId: number, alertInData: AlertInData, options?: any) {
        return AlertsApiFp(this.configuration).updateAlert(alertId, alertInData, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Logged in User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authUser: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/user`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get logged in user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authUserOrgs: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/orgs`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary verify pending email address change
         * @param {string} userId user id
         * @param {string} expires Life of link
         * @param {string} signature Signature
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeEmail: async (userId: string, expires: string, signature: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling changeEmail.');
            }
            // verify required parameter 'expires' is not null or undefined
            if (expires === null || expires === undefined) {
                throw new RequiredError('expires','Required parameter expires was null or undefined when calling changeEmail.');
            }
            // verify required parameter 'signature' is not null or undefined
            if (signature === null || signature === undefined) {
                throw new RequiredError('signature','Required parameter signature was null or undefined when calling changeEmail.');
            }
            const localVarPath = `/auth/changeEmail/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (expires !== undefined) {
                localVarQueryParameter['expires'] = expires;
            }

            if (signature !== undefined) {
                localVarQueryParameter['signature'] = signature;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verify pending email address change
         * @param {string} userId user id
         * @param {string} expires Life of link
         * @param {string} signature Signature
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePartnerEmail: async (userId: string, expires: string, signature: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling changePartnerEmail.');
            }
            // verify required parameter 'expires' is not null or undefined
            if (expires === null || expires === undefined) {
                throw new RequiredError('expires','Required parameter expires was null or undefined when calling changePartnerEmail.');
            }
            // verify required parameter 'signature' is not null or undefined
            if (signature === null || signature === undefined) {
                throw new RequiredError('signature','Required parameter signature was null or undefined when calling changePartnerEmail.');
            }
            const localVarPath = `/partner/email-change/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (expires !== undefined) {
                localVarQueryParameter['expires'] = expires;
            }

            if (signature !== undefined) {
                localVarQueryParameter['signature'] = signature;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Forgot Password
         * @param {ForgotPassword} forgotPassword Email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword: async (forgotPassword: ForgotPassword, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'forgotPassword' is not null or undefined
            if (forgotPassword === null || forgotPassword === undefined) {
                throw new RequiredError('forgotPassword','Required parameter forgotPassword was null or undefined when calling forgotPassword.');
            }
            const localVarPath = `/auth/forgot`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof forgotPassword !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(forgotPassword !== undefined ? forgotPassword : {}) : (forgotPassword || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Login as another user. Uses url generated by /auth/loginAsUrl/{id}
         * @param {number} userId userId
         * @param {string} expires timestamp when this link expires
         * @param {string} signature signature that validates the url
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAs: async (userId: number, expires: string, signature: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling loginAs.');
            }
            // verify required parameter 'expires' is not null or undefined
            if (expires === null || expires === undefined) {
                throw new RequiredError('expires','Required parameter expires was null or undefined when calling loginAs.');
            }
            // verify required parameter 'signature' is not null or undefined
            if (signature === null || signature === undefined) {
                throw new RequiredError('signature','Required parameter signature was null or undefined when calling loginAs.');
            }
            const localVarPath = `/auth/loginAs/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (expires !== undefined) {
                localVarQueryParameter['expires'] = expires;
            }

            if (signature !== undefined) {
                localVarQueryParameter['signature'] = signature;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generates url for /auth/loginAsUrl/{id}. Must be logged in as admin to use this
         * @param {number} userId userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAsUrl: async (userId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling loginAsUrl.');
            }
            const localVarPath = `/auth/loginAsUrl/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Logs a partner into the system
         * @param {Login} [login] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginPartner: async (login?: Login, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/partner/login`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof login !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(login !== undefined ? login : {}) : (login || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Logs user into the system
         * @param {Login} [login] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginUser: async (login?: Login, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/login`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof login !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(login !== undefined ? login : {}) : (login || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Logs out the current logged in partner session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutPartner: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/partner/logout`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Logs out current logged in user session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutUser: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/logout`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Refresh Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshToken: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/refresh`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resend User Activation
         * @param {string} userId activation id
         * @param {string} [email] email for user to resend activation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendActivation: async (userId: string, email?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling resendActivation.');
            }
            const localVarPath = `/auth/resend/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reset User Password post
         * @param {ResetPassword} resetPassword Created user object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword: async (resetPassword: ResetPassword, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'resetPassword' is not null or undefined
            if (resetPassword === null || resetPassword === undefined) {
                throw new RequiredError('resetPassword','Required parameter resetPassword was null or undefined when calling resetPassword.');
            }
            const localVarPath = `/auth/reset`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof resetPassword !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(resetPassword !== undefined ? resetPassword : {}) : (resetPassword || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update current user
         * @param {User} user User Object to Update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCurrentUser: async (user: User, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'user' is not null or undefined
            if (user === null || user === undefined) {
                throw new RequiredError('user','Required parameter user was null or undefined when calling updateCurrentUser.');
            }
            const localVarPath = `/auth/user`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof user !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(user !== undefined ? user : {}) : (user || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Signed Verification of User Email Address
         * @param {number} userId userId
         * @param {string} expires Activation code
         * @param {string} signature Signature
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyEmail: async (userId: number, expires: string, signature: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling verifyEmail.');
            }
            // verify required parameter 'expires' is not null or undefined
            if (expires === null || expires === undefined) {
                throw new RequiredError('expires','Required parameter expires was null or undefined when calling verifyEmail.');
            }
            // verify required parameter 'signature' is not null or undefined
            if (signature === null || signature === undefined) {
                throw new RequiredError('signature','Required parameter signature was null or undefined when calling verifyEmail.');
            }
            const localVarPath = `/auth/verify/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (expires !== undefined) {
                localVarQueryParameter['expires'] = expires;
            }

            if (signature !== undefined) {
                localVarQueryParameter['signature'] = signature;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Signed Verification of User Email Address
         * @param {number} userId userId
         * @param {string} expires Activation code
         * @param {string} signature Signature
         * @param {PartnerUser} [partnerUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyPartnerEmail: async (userId: number, expires: string, signature: string, partnerUser?: PartnerUser, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling verifyPartnerEmail.');
            }
            // verify required parameter 'expires' is not null or undefined
            if (expires === null || expires === undefined) {
                throw new RequiredError('expires','Required parameter expires was null or undefined when calling verifyPartnerEmail.');
            }
            // verify required parameter 'signature' is not null or undefined
            if (signature === null || signature === undefined) {
                throw new RequiredError('signature','Required parameter signature was null or undefined when calling verifyPartnerEmail.');
            }
            const localVarPath = `/partner/setup-account/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (expires !== undefined) {
                localVarQueryParameter['expires'] = expires;
            }

            if (signature !== undefined) {
                localVarQueryParameter['signature'] = signature;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof partnerUser !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(partnerUser !== undefined ? partnerUser : {}) : (partnerUser || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Logged in User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authUser(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserInData>> {
            const localVarAxiosArgs = await AuthApiAxiosParamCreator(configuration).authUser(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get logged in user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authUserOrgs(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrgRolesInData>> {
            const localVarAxiosArgs = await AuthApiAxiosParamCreator(configuration).authUserOrgs(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary verify pending email address change
         * @param {string} userId user id
         * @param {string} expires Life of link
         * @param {string} signature Signature
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeEmail(userId: string, expires: string, signature: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2001>> {
            const localVarAxiosArgs = await AuthApiAxiosParamCreator(configuration).changeEmail(userId, expires, signature, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Verify pending email address change
         * @param {string} userId user id
         * @param {string} expires Life of link
         * @param {string} signature Signature
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changePartnerEmail(userId: string, expires: string, signature: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20017>> {
            const localVarAxiosArgs = await AuthApiAxiosParamCreator(configuration).changePartnerEmail(userId, expires, signature, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Forgot Password
         * @param {ForgotPassword} forgotPassword Email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forgotPassword(forgotPassword: ForgotPassword, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2002>> {
            const localVarAxiosArgs = await AuthApiAxiosParamCreator(configuration).forgotPassword(forgotPassword, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Login as another user. Uses url generated by /auth/loginAsUrl/{id}
         * @param {number} userId userId
         * @param {string} expires timestamp when this link expires
         * @param {string} signature signature that validates the url
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginAs(userId: number, expires: string, signature: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenResponse>> {
            const localVarAxiosArgs = await AuthApiAxiosParamCreator(configuration).loginAs(userId, expires, signature, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Generates url for /auth/loginAsUrl/{id}. Must be logged in as admin to use this
         * @param {number} userId userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginAsUrl(userId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await AuthApiAxiosParamCreator(configuration).loginAsUrl(userId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Logs a partner into the system
         * @param {Login} [login] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginPartner(login?: Login, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenResponsePartner>> {
            const localVarAxiosArgs = await AuthApiAxiosParamCreator(configuration).loginPartner(login, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Logs user into the system
         * @param {Login} [login] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginUser(login?: Login, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenResponse>> {
            const localVarAxiosArgs = await AuthApiAxiosParamCreator(configuration).loginUser(login, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Logs out the current logged in partner session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logoutPartner(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await AuthApiAxiosParamCreator(configuration).logoutPartner(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Logs out current logged in user session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logoutUser(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await AuthApiAxiosParamCreator(configuration).logoutUser(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Refresh Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshToken(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenResponse>> {
            const localVarAxiosArgs = await AuthApiAxiosParamCreator(configuration).refreshToken(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Resend User Activation
         * @param {string} userId activation id
         * @param {string} [email] email for user to resend activation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendActivation(userId: string, email?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await AuthApiAxiosParamCreator(configuration).resendActivation(userId, email, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Reset User Password post
         * @param {ResetPassword} resetPassword Created user object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetPassword(resetPassword: ResetPassword, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await AuthApiAxiosParamCreator(configuration).resetPassword(resetPassword, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update current user
         * @param {User} user User Object to Update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCurrentUser(user: User, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await AuthApiAxiosParamCreator(configuration).updateCurrentUser(user, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Signed Verification of User Email Address
         * @param {number} userId userId
         * @param {string} expires Activation code
         * @param {string} signature Signature
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyEmail(userId: number, expires: string, signature: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenResponse>> {
            const localVarAxiosArgs = await AuthApiAxiosParamCreator(configuration).verifyEmail(userId, expires, signature, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Signed Verification of User Email Address
         * @param {number} userId userId
         * @param {string} expires Activation code
         * @param {string} signature Signature
         * @param {PartnerUser} [partnerUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyPartnerEmail(userId: number, expires: string, signature: string, partnerUser?: PartnerUser, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenResponsePartner>> {
            const localVarAxiosArgs = await AuthApiAxiosParamCreator(configuration).verifyPartnerEmail(userId, expires, signature, partnerUser, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get Logged in User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authUser(options?: any): AxiosPromise<UserInData> {
            return AuthApiFp(configuration).authUser(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get logged in user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authUserOrgs(options?: any): AxiosPromise<OrgRolesInData> {
            return AuthApiFp(configuration).authUserOrgs(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary verify pending email address change
         * @param {string} userId user id
         * @param {string} expires Life of link
         * @param {string} signature Signature
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeEmail(userId: string, expires: string, signature: string, options?: any): AxiosPromise<InlineResponse2001> {
            return AuthApiFp(configuration).changeEmail(userId, expires, signature, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verify pending email address change
         * @param {string} userId user id
         * @param {string} expires Life of link
         * @param {string} signature Signature
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePartnerEmail(userId: string, expires: string, signature: string, options?: any): AxiosPromise<InlineResponse20017> {
            return AuthApiFp(configuration).changePartnerEmail(userId, expires, signature, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Forgot Password
         * @param {ForgotPassword} forgotPassword Email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword(forgotPassword: ForgotPassword, options?: any): AxiosPromise<InlineResponse2002> {
            return AuthApiFp(configuration).forgotPassword(forgotPassword, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Login as another user. Uses url generated by /auth/loginAsUrl/{id}
         * @param {number} userId userId
         * @param {string} expires timestamp when this link expires
         * @param {string} signature signature that validates the url
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAs(userId: number, expires: string, signature: string, options?: any): AxiosPromise<TokenResponse> {
            return AuthApiFp(configuration).loginAs(userId, expires, signature, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generates url for /auth/loginAsUrl/{id}. Must be logged in as admin to use this
         * @param {number} userId userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAsUrl(userId: number, options?: any): AxiosPromise<string> {
            return AuthApiFp(configuration).loginAsUrl(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Logs a partner into the system
         * @param {Login} [login] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginPartner(login?: Login, options?: any): AxiosPromise<TokenResponsePartner> {
            return AuthApiFp(configuration).loginPartner(login, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Logs user into the system
         * @param {Login} [login] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginUser(login?: Login, options?: any): AxiosPromise<TokenResponse> {
            return AuthApiFp(configuration).loginUser(login, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Logs out the current logged in partner session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutPartner(options?: any): AxiosPromise<InlineResponse200> {
            return AuthApiFp(configuration).logoutPartner(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Logs out current logged in user session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutUser(options?: any): AxiosPromise<InlineResponse200> {
            return AuthApiFp(configuration).logoutUser(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Refresh Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshToken(options?: any): AxiosPromise<TokenResponse> {
            return AuthApiFp(configuration).refreshToken(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resend User Activation
         * @param {string} userId activation id
         * @param {string} [email] email for user to resend activation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendActivation(userId: string, email?: string, options?: any): AxiosPromise<string> {
            return AuthApiFp(configuration).resendActivation(userId, email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reset User Password post
         * @param {ResetPassword} resetPassword Created user object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(resetPassword: ResetPassword, options?: any): AxiosPromise<string> {
            return AuthApiFp(configuration).resetPassword(resetPassword, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update current user
         * @param {User} user User Object to Update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCurrentUser(user: User, options?: any): AxiosPromise<string> {
            return AuthApiFp(configuration).updateCurrentUser(user, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Signed Verification of User Email Address
         * @param {number} userId userId
         * @param {string} expires Activation code
         * @param {string} signature Signature
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyEmail(userId: number, expires: string, signature: string, options?: any): AxiosPromise<TokenResponse> {
            return AuthApiFp(configuration).verifyEmail(userId, expires, signature, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Signed Verification of User Email Address
         * @param {number} userId userId
         * @param {string} expires Activation code
         * @param {string} signature Signature
         * @param {PartnerUser} [partnerUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyPartnerEmail(userId: number, expires: string, signature: string, partnerUser?: PartnerUser, options?: any): AxiosPromise<TokenResponsePartner> {
            return AuthApiFp(configuration).verifyPartnerEmail(userId, expires, signature, partnerUser, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
    /**
     * 
     * @summary Get Logged in User
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authUser(options?: any) {
        return AuthApiFp(this.configuration).authUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get logged in user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authUserOrgs(options?: any) {
        return AuthApiFp(this.configuration).authUserOrgs(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary verify pending email address change
     * @param {string} userId user id
     * @param {string} expires Life of link
     * @param {string} signature Signature
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public changeEmail(userId: string, expires: string, signature: string, options?: any) {
        return AuthApiFp(this.configuration).changeEmail(userId, expires, signature, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verify pending email address change
     * @param {string} userId user id
     * @param {string} expires Life of link
     * @param {string} signature Signature
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public changePartnerEmail(userId: string, expires: string, signature: string, options?: any) {
        return AuthApiFp(this.configuration).changePartnerEmail(userId, expires, signature, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Forgot Password
     * @param {ForgotPassword} forgotPassword Email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public forgotPassword(forgotPassword: ForgotPassword, options?: any) {
        return AuthApiFp(this.configuration).forgotPassword(forgotPassword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Login as another user. Uses url generated by /auth/loginAsUrl/{id}
     * @param {number} userId userId
     * @param {string} expires timestamp when this link expires
     * @param {string} signature signature that validates the url
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public loginAs(userId: number, expires: string, signature: string, options?: any) {
        return AuthApiFp(this.configuration).loginAs(userId, expires, signature, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generates url for /auth/loginAsUrl/{id}. Must be logged in as admin to use this
     * @param {number} userId userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public loginAsUrl(userId: number, options?: any) {
        return AuthApiFp(this.configuration).loginAsUrl(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Logs a partner into the system
     * @param {Login} [login] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public loginPartner(login?: Login, options?: any) {
        return AuthApiFp(this.configuration).loginPartner(login, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Logs user into the system
     * @param {Login} [login] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public loginUser(login?: Login, options?: any) {
        return AuthApiFp(this.configuration).loginUser(login, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Logs out the current logged in partner session
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public logoutPartner(options?: any) {
        return AuthApiFp(this.configuration).logoutPartner(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Logs out current logged in user session
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public logoutUser(options?: any) {
        return AuthApiFp(this.configuration).logoutUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Refresh Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public refreshToken(options?: any) {
        return AuthApiFp(this.configuration).refreshToken(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resend User Activation
     * @param {string} userId activation id
     * @param {string} [email] email for user to resend activation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public resendActivation(userId: string, email?: string, options?: any) {
        return AuthApiFp(this.configuration).resendActivation(userId, email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reset User Password post
     * @param {ResetPassword} resetPassword Created user object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public resetPassword(resetPassword: ResetPassword, options?: any) {
        return AuthApiFp(this.configuration).resetPassword(resetPassword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update current user
     * @param {User} user User Object to Update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public updateCurrentUser(user: User, options?: any) {
        return AuthApiFp(this.configuration).updateCurrentUser(user, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Signed Verification of User Email Address
     * @param {number} userId userId
     * @param {string} expires Activation code
     * @param {string} signature Signature
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public verifyEmail(userId: number, expires: string, signature: string, options?: any) {
        return AuthApiFp(this.configuration).verifyEmail(userId, expires, signature, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Signed Verification of User Email Address
     * @param {number} userId userId
     * @param {string} expires Activation code
     * @param {string} signature Signature
     * @param {PartnerUser} [partnerUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public verifyPartnerEmail(userId: number, expires: string, signature: string, partnerUser?: PartnerUser, options?: any) {
        return AuthApiFp(this.configuration).verifyPartnerEmail(userId, expires, signature, partnerUser, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * BillingApi - axios parameter creator
 * @export
 */
export const BillingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Gets the current billing setup
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        currentBilling: async (productId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            if (productId === null || productId === undefined) {
                throw new RequiredError('productId','Required parameter productId was null or undefined when calling currentBilling.');
            }
            const localVarPath = `/products/{productId}/currentBilling`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets the available tiers for direct customer tpye based on partner contribution tier
         * @param {ProductType} productType Type of product to return
         * @param {ContributionTierInData} [contributionTierInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableTiers: async (productType: ProductType, contributionTierInData?: ContributionTierInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productType' is not null or undefined
            if (productType === null || productType === undefined) {
                throw new RequiredError('productType','Required parameter productType was null or undefined when calling getAvailableTiers.');
            }
            const localVarPath = `/products/{productType}/availableTiers`
                .replace(`{${"productType"}}`, encodeURIComponent(String(productType)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof contributionTierInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(contributionTierInData !== undefined ? contributionTierInData : {}) : (contributionTierInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the list of direct plans to be used for billing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductDirectPlans: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/products/directPlans`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the payment methods not currently assigned to the org
         * @param {number} orgId ID of org to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgAdditionalPaymentMethods: async (orgId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId','Required parameter orgId was null or undefined when calling orgAdditionalPaymentMethods.');
            }
            const localVarPath = `/orgs/{orgId}/additionalPaymentMethods`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a payment method
         * @param {number} orgId ID of org to return
         * @param {number} paymentMethodId ID of payment method to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgDeletePaymentMethod: async (orgId: number, paymentMethodId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId','Required parameter orgId was null or undefined when calling orgDeletePaymentMethod.');
            }
            // verify required parameter 'paymentMethodId' is not null or undefined
            if (paymentMethodId === null || paymentMethodId === undefined) {
                throw new RequiredError('paymentMethodId','Required parameter paymentMethodId was null or undefined when calling orgDeletePaymentMethod.');
            }
            const localVarPath = `/orgs/{orgId}/paymentMethods/{paymentMethodId}`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"paymentMethodId"}}`, encodeURIComponent(String(paymentMethodId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all billing partner orgs by product type
         * @param {ProductType} productType Type of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgGetBillingPartnersByProductType: async (productType: ProductType, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productType' is not null or undefined
            if (productType === null || productType === undefined) {
                throw new RequiredError('productType','Required parameter productType was null or undefined when calling orgGetBillingPartnersByProductType.');
            }
            const localVarPath = `/orgs/partners/billing/{productType}`
                .replace(`{${"productType"}}`, encodeURIComponent(String(productType)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all partner orgs by product type
         * @param {ProductType} productType Type of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgGetPartnersByProductType: async (productType: ProductType, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productType' is not null or undefined
            if (productType === null || productType === undefined) {
                throw new RequiredError('productType','Required parameter productType was null or undefined when calling orgGetPartnersByProductType.');
            }
            const localVarPath = `/orgs/partners/{productType}`
                .replace(`{${"productType"}}`, encodeURIComponent(String(productType)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all the orgs registered payment methods
         * @param {number} orgId ID of org to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgPaymentMethods: async (orgId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId','Required parameter orgId was null or undefined when calling orgPaymentMethods.');
            }
            const localVarPath = `/orgs/{orgId}/paymentMethods`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set or update the current Ordway subscription plans
         * @param {UpdateBilling} [updateBilling] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBilling: async (updateBilling?: UpdateBilling, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/products/updateBilling`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof updateBilling !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateBilling !== undefined ? updateBilling : {}) : (updateBilling || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set or update the current Ordway subscription plans
         * @param {number} productId ID of product to return
         * @param {OrdwayPlans} [ordwayPlans] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrdwayPlans: async (productId: number, ordwayPlans?: OrdwayPlans, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            if (productId === null || productId === undefined) {
                throw new RequiredError('productId','Required parameter productId was null or undefined when calling updateOrdwayPlans.');
            }
            const localVarPath = `/products/{productId}/updateOrdwayPlans`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof ordwayPlans !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(ordwayPlans !== undefined ? ordwayPlans : {}) : (ordwayPlans || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BillingApi - functional programming interface
 * @export
 */
export const BillingApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Gets the current billing setup
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async currentBilling(productId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateBillingInData>> {
            const localVarAxiosArgs = await BillingApiAxiosParamCreator(configuration).currentBilling(productId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Gets the available tiers for direct customer tpye based on partner contribution tier
         * @param {ProductType} productType Type of product to return
         * @param {ContributionTierInData} [contributionTierInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableTiers(productType: ProductType, contributionTierInData?: ContributionTierInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TiersInData>> {
            const localVarAxiosArgs = await BillingApiAxiosParamCreator(configuration).getAvailableTiers(productType, contributionTierInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get the list of direct plans to be used for billing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductDirectPlans(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DirectPlansInData>> {
            const localVarAxiosArgs = await BillingApiAxiosParamCreator(configuration).getProductDirectPlans(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get the payment methods not currently assigned to the org
         * @param {number} orgId ID of org to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgAdditionalPaymentMethods(orgId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20014>> {
            const localVarAxiosArgs = await BillingApiAxiosParamCreator(configuration).orgAdditionalPaymentMethods(orgId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Delete a payment method
         * @param {number} orgId ID of org to return
         * @param {number} paymentMethodId ID of payment method to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgDeletePaymentMethod(orgId: number, paymentMethodId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await BillingApiAxiosParamCreator(configuration).orgDeletePaymentMethod(orgId, paymentMethodId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get all billing partner orgs by product type
         * @param {ProductType} productType Type of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgGetBillingPartnersByProductType(productType: ProductType, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20015>> {
            const localVarAxiosArgs = await BillingApiAxiosParamCreator(configuration).orgGetBillingPartnersByProductType(productType, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get all partner orgs by product type
         * @param {ProductType} productType Type of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgGetPartnersByProductType(productType: ProductType, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20015>> {
            const localVarAxiosArgs = await BillingApiAxiosParamCreator(configuration).orgGetPartnersByProductType(productType, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get all the orgs registered payment methods
         * @param {number} orgId ID of org to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgPaymentMethods(orgId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20013>> {
            const localVarAxiosArgs = await BillingApiAxiosParamCreator(configuration).orgPaymentMethods(orgId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Set or update the current Ordway subscription plans
         * @param {UpdateBilling} [updateBilling] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBilling(updateBilling?: UpdateBilling, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await BillingApiAxiosParamCreator(configuration).updateBilling(updateBilling, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Set or update the current Ordway subscription plans
         * @param {number} productId ID of product to return
         * @param {OrdwayPlans} [ordwayPlans] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrdwayPlans(productId: number, ordwayPlans?: OrdwayPlans, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await BillingApiAxiosParamCreator(configuration).updateOrdwayPlans(productId, ordwayPlans, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * BillingApi - factory interface
 * @export
 */
export const BillingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Gets the current billing setup
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        currentBilling(productId: number, options?: any): AxiosPromise<UpdateBillingInData> {
            return BillingApiFp(configuration).currentBilling(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the available tiers for direct customer tpye based on partner contribution tier
         * @param {ProductType} productType Type of product to return
         * @param {ContributionTierInData} [contributionTierInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableTiers(productType: ProductType, contributionTierInData?: ContributionTierInData, options?: any): AxiosPromise<TiersInData> {
            return BillingApiFp(configuration).getAvailableTiers(productType, contributionTierInData, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the list of direct plans to be used for billing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductDirectPlans(options?: any): AxiosPromise<DirectPlansInData> {
            return BillingApiFp(configuration).getProductDirectPlans(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the payment methods not currently assigned to the org
         * @param {number} orgId ID of org to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgAdditionalPaymentMethods(orgId: number, options?: any): AxiosPromise<InlineResponse20014> {
            return BillingApiFp(configuration).orgAdditionalPaymentMethods(orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a payment method
         * @param {number} orgId ID of org to return
         * @param {number} paymentMethodId ID of payment method to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgDeletePaymentMethod(orgId: number, paymentMethodId: number, options?: any): AxiosPromise<void> {
            return BillingApiFp(configuration).orgDeletePaymentMethod(orgId, paymentMethodId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all billing partner orgs by product type
         * @param {ProductType} productType Type of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgGetBillingPartnersByProductType(productType: ProductType, options?: any): AxiosPromise<InlineResponse20015> {
            return BillingApiFp(configuration).orgGetBillingPartnersByProductType(productType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all partner orgs by product type
         * @param {ProductType} productType Type of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgGetPartnersByProductType(productType: ProductType, options?: any): AxiosPromise<InlineResponse20015> {
            return BillingApiFp(configuration).orgGetPartnersByProductType(productType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all the orgs registered payment methods
         * @param {number} orgId ID of org to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgPaymentMethods(orgId: number, options?: any): AxiosPromise<InlineResponse20013> {
            return BillingApiFp(configuration).orgPaymentMethods(orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * Set or update the current Ordway subscription plans
         * @param {UpdateBilling} [updateBilling] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBilling(updateBilling?: UpdateBilling, options?: any): AxiosPromise<void> {
            return BillingApiFp(configuration).updateBilling(updateBilling, options).then((request) => request(axios, basePath));
        },
        /**
         * Set or update the current Ordway subscription plans
         * @param {number} productId ID of product to return
         * @param {OrdwayPlans} [ordwayPlans] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrdwayPlans(productId: number, ordwayPlans?: OrdwayPlans, options?: any): AxiosPromise<void> {
            return BillingApiFp(configuration).updateOrdwayPlans(productId, ordwayPlans, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BillingApi - object-oriented interface
 * @export
 * @class BillingApi
 * @extends {BaseAPI}
 */
export class BillingApi extends BaseAPI {
    /**
     * Gets the current billing setup
     * @param {number} productId ID of product to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    public currentBilling(productId: number, options?: any) {
        return BillingApiFp(this.configuration).currentBilling(productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets the available tiers for direct customer tpye based on partner contribution tier
     * @param {ProductType} productType Type of product to return
     * @param {ContributionTierInData} [contributionTierInData] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    public getAvailableTiers(productType: ProductType, contributionTierInData?: ContributionTierInData, options?: any) {
        return BillingApiFp(this.configuration).getAvailableTiers(productType, contributionTierInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the list of direct plans to be used for billing
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    public getProductDirectPlans(options?: any) {
        return BillingApiFp(this.configuration).getProductDirectPlans(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the payment methods not currently assigned to the org
     * @param {number} orgId ID of org to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    public orgAdditionalPaymentMethods(orgId: number, options?: any) {
        return BillingApiFp(this.configuration).orgAdditionalPaymentMethods(orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a payment method
     * @param {number} orgId ID of org to return
     * @param {number} paymentMethodId ID of payment method to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    public orgDeletePaymentMethod(orgId: number, paymentMethodId: number, options?: any) {
        return BillingApiFp(this.configuration).orgDeletePaymentMethod(orgId, paymentMethodId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all billing partner orgs by product type
     * @param {ProductType} productType Type of product to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    public orgGetBillingPartnersByProductType(productType: ProductType, options?: any) {
        return BillingApiFp(this.configuration).orgGetBillingPartnersByProductType(productType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all partner orgs by product type
     * @param {ProductType} productType Type of product to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    public orgGetPartnersByProductType(productType: ProductType, options?: any) {
        return BillingApiFp(this.configuration).orgGetPartnersByProductType(productType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all the orgs registered payment methods
     * @param {number} orgId ID of org to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    public orgPaymentMethods(orgId: number, options?: any) {
        return BillingApiFp(this.configuration).orgPaymentMethods(orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set or update the current Ordway subscription plans
     * @param {UpdateBilling} [updateBilling] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    public updateBilling(updateBilling?: UpdateBilling, options?: any) {
        return BillingApiFp(this.configuration).updateBilling(updateBilling, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set or update the current Ordway subscription plans
     * @param {number} productId ID of product to return
     * @param {OrdwayPlans} [ordwayPlans] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    public updateOrdwayPlans(productId: number, ordwayPlans?: OrdwayPlans, options?: any) {
        return BillingApiFp(this.configuration).updateOrdwayPlans(productId, ordwayPlans, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * ConsentConditionTypesApi - axios parameter creator
 * @export
 */
export const ConsentConditionTypesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get all consent condition types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsentConditionTypes: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/consentConditionTypes`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConsentConditionTypesApi - functional programming interface
 * @export
 */
export const ConsentConditionTypesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get all consent condition types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConsentConditionTypes(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2005>> {
            const localVarAxiosArgs = await ConsentConditionTypesApiAxiosParamCreator(configuration).getConsentConditionTypes(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ConsentConditionTypesApi - factory interface
 * @export
 */
export const ConsentConditionTypesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get all consent condition types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsentConditionTypes(options?: any): AxiosPromise<InlineResponse2005> {
            return ConsentConditionTypesApiFp(configuration).getConsentConditionTypes(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ConsentConditionTypesApi - object-oriented interface
 * @export
 * @class ConsentConditionTypesApi
 * @extends {BaseAPI}
 */
export class ConsentConditionTypesApi extends BaseAPI {
    /**
     * 
     * @summary Get all consent condition types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsentConditionTypesApi
     */
    public getConsentConditionTypes(options?: any) {
        return ConsentConditionTypesApiFp(this.configuration).getConsentConditionTypes(options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * ConsentConditionsApi - axios parameter creator
 * @export
 */
export const ConsentConditionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete selected consent condition
         * @param {number} consentConditionId Consent condition to return/update/create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteConsentCondtion: async (consentConditionId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'consentConditionId' is not null or undefined
            if (consentConditionId === null || consentConditionId === undefined) {
                throw new RequiredError('consentConditionId','Required parameter consentConditionId was null or undefined when calling deleteConsentCondtion.');
            }
            const localVarPath = `/consentConditions/{consentConditionId}`
                .replace(`{${"consentConditionId"}}`, encodeURIComponent(String(consentConditionId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get consent condition by Id
         * @param {number} consentConditionId Consent condition to return/update/create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsentConditionById: async (consentConditionId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'consentConditionId' is not null or undefined
            if (consentConditionId === null || consentConditionId === undefined) {
                throw new RequiredError('consentConditionId','Required parameter consentConditionId was null or undefined when calling getConsentConditionById.');
            }
            const localVarPath = `/consentConditions/{consentConditionId}`
                .replace(`{${"consentConditionId"}}`, encodeURIComponent(String(consentConditionId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a consent
         * @param {number} consentConditionId Consent condition to return/update/create
         * @param {ConsentConditionWithId} [consentConditionWithId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchConsentCondition: async (consentConditionId: number, consentConditionWithId?: ConsentConditionWithId, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'consentConditionId' is not null or undefined
            if (consentConditionId === null || consentConditionId === undefined) {
                throw new RequiredError('consentConditionId','Required parameter consentConditionId was null or undefined when calling patchConsentCondition.');
            }
            const localVarPath = `/consentConditions/{consentConditionId}`
                .replace(`{${"consentConditionId"}}`, encodeURIComponent(String(consentConditionId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof consentConditionWithId !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(consentConditionWithId !== undefined ? consentConditionWithId : {}) : (consentConditionWithId || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a consent condition
         * @param {ConsentCondition} [consentCondition] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postConsentCondition: async (consentCondition?: ConsentCondition, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/consentConditions`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof consentCondition !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(consentCondition !== undefined ? consentCondition : {}) : (consentCondition || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConsentConditionsApi - functional programming interface
 * @export
 */
export const ConsentConditionsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete selected consent condition
         * @param {number} consentConditionId Consent condition to return/update/create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteConsentCondtion(consentConditionId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ConsentConditionsApiAxiosParamCreator(configuration).deleteConsentCondtion(consentConditionId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get consent condition by Id
         * @param {number} consentConditionId Consent condition to return/update/create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConsentConditionById(consentConditionId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConsentWithIdInData>> {
            const localVarAxiosArgs = await ConsentConditionsApiAxiosParamCreator(configuration).getConsentConditionById(consentConditionId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update a consent
         * @param {number} consentConditionId Consent condition to return/update/create
         * @param {ConsentConditionWithId} [consentConditionWithId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchConsentCondition(consentConditionId: number, consentConditionWithId?: ConsentConditionWithId, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConsentConditionWithId>> {
            const localVarAxiosArgs = await ConsentConditionsApiAxiosParamCreator(configuration).patchConsentCondition(consentConditionId, consentConditionWithId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Create a consent condition
         * @param {ConsentCondition} [consentCondition] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postConsentCondition(consentCondition?: ConsentCondition, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConsentConditionWithId>> {
            const localVarAxiosArgs = await ConsentConditionsApiAxiosParamCreator(configuration).postConsentCondition(consentCondition, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ConsentConditionsApi - factory interface
 * @export
 */
export const ConsentConditionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Delete selected consent condition
         * @param {number} consentConditionId Consent condition to return/update/create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteConsentCondtion(consentConditionId: number, options?: any): AxiosPromise<void> {
            return ConsentConditionsApiFp(configuration).deleteConsentCondtion(consentConditionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get consent condition by Id
         * @param {number} consentConditionId Consent condition to return/update/create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsentConditionById(consentConditionId: number, options?: any): AxiosPromise<ConsentWithIdInData> {
            return ConsentConditionsApiFp(configuration).getConsentConditionById(consentConditionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a consent
         * @param {number} consentConditionId Consent condition to return/update/create
         * @param {ConsentConditionWithId} [consentConditionWithId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchConsentCondition(consentConditionId: number, consentConditionWithId?: ConsentConditionWithId, options?: any): AxiosPromise<ConsentConditionWithId> {
            return ConsentConditionsApiFp(configuration).patchConsentCondition(consentConditionId, consentConditionWithId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a consent condition
         * @param {ConsentCondition} [consentCondition] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postConsentCondition(consentCondition?: ConsentCondition, options?: any): AxiosPromise<ConsentConditionWithId> {
            return ConsentConditionsApiFp(configuration).postConsentCondition(consentCondition, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ConsentConditionsApi - object-oriented interface
 * @export
 * @class ConsentConditionsApi
 * @extends {BaseAPI}
 */
export class ConsentConditionsApi extends BaseAPI {
    /**
     * 
     * @summary Delete selected consent condition
     * @param {number} consentConditionId Consent condition to return/update/create
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsentConditionsApi
     */
    public deleteConsentCondtion(consentConditionId: number, options?: any) {
        return ConsentConditionsApiFp(this.configuration).deleteConsentCondtion(consentConditionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get consent condition by Id
     * @param {number} consentConditionId Consent condition to return/update/create
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsentConditionsApi
     */
    public getConsentConditionById(consentConditionId: number, options?: any) {
        return ConsentConditionsApiFp(this.configuration).getConsentConditionById(consentConditionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a consent
     * @param {number} consentConditionId Consent condition to return/update/create
     * @param {ConsentConditionWithId} [consentConditionWithId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsentConditionsApi
     */
    public patchConsentCondition(consentConditionId: number, consentConditionWithId?: ConsentConditionWithId, options?: any) {
        return ConsentConditionsApiFp(this.configuration).patchConsentCondition(consentConditionId, consentConditionWithId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a consent condition
     * @param {ConsentCondition} [consentCondition] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsentConditionsApi
     */
    public postConsentCondition(consentCondition?: ConsentCondition, options?: any) {
        return ConsentConditionsApiFp(this.configuration).postConsentCondition(consentCondition, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * ConsentsApi - axios parameter creator
 * @export
 */
export const ConsentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get a consent
         * @param {number} consentId Consent to return/update/create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsent: async (consentId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'consentId' is not null or undefined
            if (consentId === null || consentId === undefined) {
                throw new RequiredError('consentId','Required parameter consentId was null or undefined when calling getConsent.');
            }
            const localVarPath = `/consents/{consentId}`
                .replace(`{${"consentId"}}`, encodeURIComponent(String(consentId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a list of consent conditions
         * @param {number} consentId Consent to return/update/create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsentConditions: async (consentId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'consentId' is not null or undefined
            if (consentId === null || consentId === undefined) {
                throw new RequiredError('consentId','Required parameter consentId was null or undefined when calling getConsentConditions.');
            }
            const localVarPath = `/consents/{consentId}/consentConditions/`
                .replace(`{${"consentId"}}`, encodeURIComponent(String(consentId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a list of consents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsents: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/consents`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a consent
         * @param {number} consentId Consent to return/update/create
         * @param {ConsentInData} [consentInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchConsent: async (consentId: number, consentInData?: ConsentInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'consentId' is not null or undefined
            if (consentId === null || consentId === undefined) {
                throw new RequiredError('consentId','Required parameter consentId was null or undefined when calling patchConsent.');
            }
            const localVarPath = `/consents/{consentId}`
                .replace(`{${"consentId"}}`, encodeURIComponent(String(consentId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof consentInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(consentInData !== undefined ? consentInData : {}) : (consentInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a consent
         * @param {ConsentInData} [consentInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postConsent: async (consentInData?: ConsentInData, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/consents`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof consentInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(consentInData !== undefined ? consentInData : {}) : (consentInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConsentsApi - functional programming interface
 * @export
 */
export const ConsentsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get a consent
         * @param {number} consentId Consent to return/update/create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConsent(consentId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConsentWithIdInData>> {
            const localVarAxiosArgs = await ConsentsApiAxiosParamCreator(configuration).getConsent(consentId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get a list of consent conditions
         * @param {number} consentId Consent to return/update/create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConsentConditions(consentId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2004>> {
            const localVarAxiosArgs = await ConsentsApiAxiosParamCreator(configuration).getConsentConditions(consentId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get a list of consents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConsents(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2003>> {
            const localVarAxiosArgs = await ConsentsApiAxiosParamCreator(configuration).getConsents(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update a consent
         * @param {number} consentId Consent to return/update/create
         * @param {ConsentInData} [consentInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchConsent(consentId: number, consentInData?: ConsentInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ConsentsApiAxiosParamCreator(configuration).patchConsent(consentId, consentInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Create a consent
         * @param {ConsentInData} [consentInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postConsent(consentInData?: ConsentInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ConsentsApiAxiosParamCreator(configuration).postConsent(consentInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ConsentsApi - factory interface
 * @export
 */
export const ConsentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get a consent
         * @param {number} consentId Consent to return/update/create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsent(consentId: number, options?: any): AxiosPromise<ConsentWithIdInData> {
            return ConsentsApiFp(configuration).getConsent(consentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a list of consent conditions
         * @param {number} consentId Consent to return/update/create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsentConditions(consentId: number, options?: any): AxiosPromise<InlineResponse2004> {
            return ConsentsApiFp(configuration).getConsentConditions(consentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a list of consents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsents(options?: any): AxiosPromise<InlineResponse2003> {
            return ConsentsApiFp(configuration).getConsents(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a consent
         * @param {number} consentId Consent to return/update/create
         * @param {ConsentInData} [consentInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchConsent(consentId: number, consentInData?: ConsentInData, options?: any): AxiosPromise<void> {
            return ConsentsApiFp(configuration).patchConsent(consentId, consentInData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a consent
         * @param {ConsentInData} [consentInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postConsent(consentInData?: ConsentInData, options?: any): AxiosPromise<void> {
            return ConsentsApiFp(configuration).postConsent(consentInData, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ConsentsApi - object-oriented interface
 * @export
 * @class ConsentsApi
 * @extends {BaseAPI}
 */
export class ConsentsApi extends BaseAPI {
    /**
     * 
     * @summary Get a consent
     * @param {number} consentId Consent to return/update/create
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsentsApi
     */
    public getConsent(consentId: number, options?: any) {
        return ConsentsApiFp(this.configuration).getConsent(consentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a list of consent conditions
     * @param {number} consentId Consent to return/update/create
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsentsApi
     */
    public getConsentConditions(consentId: number, options?: any) {
        return ConsentsApiFp(this.configuration).getConsentConditions(consentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a list of consents
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsentsApi
     */
    public getConsents(options?: any) {
        return ConsentsApiFp(this.configuration).getConsents(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a consent
     * @param {number} consentId Consent to return/update/create
     * @param {ConsentInData} [consentInData] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsentsApi
     */
    public patchConsent(consentId: number, consentInData?: ConsentInData, options?: any) {
        return ConsentsApiFp(this.configuration).patchConsent(consentId, consentInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a consent
     * @param {ConsentInData} [consentInData] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsentsApi
     */
    public postConsent(consentInData?: ConsentInData, options?: any) {
        return ConsentsApiFp(this.configuration).postConsent(consentInData, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * CorrectionsApi - axios parameter creator
 * @export
 */
export const CorrectionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a new correction  to the service
         * @param {InlineObject2} inlineObject2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCorrection: async (inlineObject2: InlineObject2, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'inlineObject2' is not null or undefined
            if (inlineObject2 === null || inlineObject2 === undefined) {
                throw new RequiredError('inlineObject2','Required parameter inlineObject2 was null or undefined when calling addCorrection.');
            }
            const localVarPath = `/corrections`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof inlineObject2 !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(inlineObject2 !== undefined ? inlineObject2 : {}) : (inlineObject2 || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a correction
         * @param {number} correctionId ID of correction to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCorrection: async (correctionId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'correctionId' is not null or undefined
            if (correctionId === null || correctionId === undefined) {
                throw new RequiredError('correctionId','Required parameter correctionId was null or undefined when calling deleteCorrection.');
            }
            const localVarPath = `/corrections/{correctionId}`
                .replace(`{${"correctionId"}}`, encodeURIComponent(String(correctionId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all corrections
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCorrections: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/corrections`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates a correction
         * @param {number} correctionId ID of correction to return
         * @param {InlineObject3} inlineObject3 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCorrection: async (correctionId: number, inlineObject3: InlineObject3, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'correctionId' is not null or undefined
            if (correctionId === null || correctionId === undefined) {
                throw new RequiredError('correctionId','Required parameter correctionId was null or undefined when calling updateCorrection.');
            }
            // verify required parameter 'inlineObject3' is not null or undefined
            if (inlineObject3 === null || inlineObject3 === undefined) {
                throw new RequiredError('inlineObject3','Required parameter inlineObject3 was null or undefined when calling updateCorrection.');
            }
            const localVarPath = `/corrections/{correctionId}`
                .replace(`{${"correctionId"}}`, encodeURIComponent(String(correctionId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof inlineObject3 !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(inlineObject3 !== undefined ? inlineObject3 : {}) : (inlineObject3 || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CorrectionsApi - functional programming interface
 * @export
 */
export const CorrectionsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a new correction  to the service
         * @param {InlineObject2} inlineObject2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCorrection(inlineObject2: InlineObject2, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await CorrectionsApiAxiosParamCreator(configuration).addCorrection(inlineObject2, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Delete a correction
         * @param {number} correctionId ID of correction to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCorrection(correctionId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await CorrectionsApiAxiosParamCreator(configuration).deleteCorrection(correctionId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns all corrections
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCorrections(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2006>> {
            const localVarAxiosArgs = await CorrectionsApiAxiosParamCreator(configuration).getCorrections(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Updates a correction
         * @param {number} correctionId ID of correction to return
         * @param {InlineObject3} inlineObject3 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCorrection(correctionId: number, inlineObject3: InlineObject3, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await CorrectionsApiAxiosParamCreator(configuration).updateCorrection(correctionId, inlineObject3, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CorrectionsApi - factory interface
 * @export
 */
export const CorrectionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Add a new correction  to the service
         * @param {InlineObject2} inlineObject2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCorrection(inlineObject2: InlineObject2, options?: any): AxiosPromise<void> {
            return CorrectionsApiFp(configuration).addCorrection(inlineObject2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a correction
         * @param {number} correctionId ID of correction to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCorrection(correctionId: number, options?: any): AxiosPromise<void> {
            return CorrectionsApiFp(configuration).deleteCorrection(correctionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all corrections
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCorrections(options?: any): AxiosPromise<InlineResponse2006> {
            return CorrectionsApiFp(configuration).getCorrections(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates a correction
         * @param {number} correctionId ID of correction to return
         * @param {InlineObject3} inlineObject3 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCorrection(correctionId: number, inlineObject3: InlineObject3, options?: any): AxiosPromise<void> {
            return CorrectionsApiFp(configuration).updateCorrection(correctionId, inlineObject3, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CorrectionsApi - object-oriented interface
 * @export
 * @class CorrectionsApi
 * @extends {BaseAPI}
 */
export class CorrectionsApi extends BaseAPI {
    /**
     * 
     * @summary Add a new correction  to the service
     * @param {InlineObject2} inlineObject2 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CorrectionsApi
     */
    public addCorrection(inlineObject2: InlineObject2, options?: any) {
        return CorrectionsApiFp(this.configuration).addCorrection(inlineObject2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a correction
     * @param {number} correctionId ID of correction to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CorrectionsApi
     */
    public deleteCorrection(correctionId: number, options?: any) {
        return CorrectionsApiFp(this.configuration).deleteCorrection(correctionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all corrections
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CorrectionsApi
     */
    public getCorrections(options?: any) {
        return CorrectionsApiFp(this.configuration).getCorrections(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates a correction
     * @param {number} correctionId ID of correction to return
     * @param {InlineObject3} inlineObject3 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CorrectionsApi
     */
    public updateCorrection(correctionId: number, inlineObject3: InlineObject3, options?: any) {
        return CorrectionsApiFp(this.configuration).updateCorrection(correctionId, inlineObject3, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets Fonterra collection data for the supplier via the Fonterra API
         * @param {string} supplierNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFonterraPickup: async (supplierNumber: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'supplierNumber' is not null or undefined
            if (supplierNumber === null || supplierNumber === undefined) {
                throw new RequiredError('supplierNumber','Required parameter supplierNumber was null or undefined when calling getFonterraPickup.');
            }
            const localVarPath = `/fonterra/{supplierNumber}/pickup`
                .replace(`{${"supplierNumber"}}`, encodeURIComponent(String(supplierNumber)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets Fonterra collection data for the supplier via the Fonterra API
         * @param {string} supplierNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFonterraPickup(supplierNumber: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FonterraPickups>>> {
            const localVarAxiosArgs = await DefaultApiAxiosParamCreator(configuration).getFonterraPickup(supplierNumber, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Gets Fonterra collection data for the supplier via the Fonterra API
         * @param {string} supplierNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFonterraPickup(supplierNumber: string, options?: any): AxiosPromise<Array<FonterraPickups>> {
            return DefaultApiFp(configuration).getFonterraPickup(supplierNumber, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * 
     * @summary Gets Fonterra collection data for the supplier via the Fonterra API
     * @param {string} supplierNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getFonterraPickup(supplierNumber: string, options?: any) {
        return DefaultApiFp(this.configuration).getFonterraPickup(supplierNumber, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * EntityLocationsApi - axios parameter creator
 * @export
 */
export const EntityLocationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create an entity location
         * @param {EntityLocationInData} entityLocationInData Entity Location object to be created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityLocation: async (entityLocationInData: EntityLocationInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityLocationInData' is not null or undefined
            if (entityLocationInData === null || entityLocationInData === undefined) {
                throw new RequiredError('entityLocationInData','Required parameter entityLocationInData was null or undefined when calling createEntityLocation.');
            }
            const localVarPath = `/entityLocations`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof entityLocationInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(entityLocationInData !== undefined ? entityLocationInData : {}) : (entityLocationInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes an entity location
         * @param {number} entityLocationId Entity location to return/update/create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityLocation: async (entityLocationId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityLocationId' is not null or undefined
            if (entityLocationId === null || entityLocationId === undefined) {
                throw new RequiredError('entityLocationId','Required parameter entityLocationId was null or undefined when calling deleteEntityLocation.');
            }
            const localVarPath = `/entityLocations/{entityLocationId}`
                .replace(`{${"entityLocationId"}}`, encodeURIComponent(String(entityLocationId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns an entity location
         * @summary Find entity location by ID
         * @param {number} entityLocationId Entity location to return/update/create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityLocationById: async (entityLocationId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityLocationId' is not null or undefined
            if (entityLocationId === null || entityLocationId === undefined) {
                throw new RequiredError('entityLocationId','Required parameter entityLocationId was null or undefined when calling getEntityLocationById.');
            }
            const localVarPath = `/entityLocations/{entityLocationId}`
                .replace(`{${"entityLocationId"}}`, encodeURIComponent(String(entityLocationId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all entity locations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityLocations: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/entityLocations`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates an entity location
         * @param {number} entityLocationId Entity location to return/update/create
         * @param {EntityLocationInData} entityLocationInData Entity Location object to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityLocation: async (entityLocationId: number, entityLocationInData: EntityLocationInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityLocationId' is not null or undefined
            if (entityLocationId === null || entityLocationId === undefined) {
                throw new RequiredError('entityLocationId','Required parameter entityLocationId was null or undefined when calling updateEntityLocation.');
            }
            // verify required parameter 'entityLocationInData' is not null or undefined
            if (entityLocationInData === null || entityLocationInData === undefined) {
                throw new RequiredError('entityLocationInData','Required parameter entityLocationInData was null or undefined when calling updateEntityLocation.');
            }
            const localVarPath = `/entityLocations/{entityLocationId}`
                .replace(`{${"entityLocationId"}}`, encodeURIComponent(String(entityLocationId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof entityLocationInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(entityLocationInData !== undefined ? entityLocationInData : {}) : (entityLocationInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EntityLocationsApi - functional programming interface
 * @export
 */
export const EntityLocationsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create an entity location
         * @param {EntityLocationInData} entityLocationInData Entity Location object to be created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityLocation(entityLocationInData: EntityLocationInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityLocationInData>> {
            const localVarAxiosArgs = await EntityLocationsApiAxiosParamCreator(configuration).createEntityLocation(entityLocationInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Deletes an entity location
         * @param {number} entityLocationId Entity location to return/update/create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityLocation(entityLocationId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await EntityLocationsApiAxiosParamCreator(configuration).deleteEntityLocation(entityLocationId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns an entity location
         * @summary Find entity location by ID
         * @param {number} entityLocationId Entity location to return/update/create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityLocationById(entityLocationId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityLocationInData>> {
            const localVarAxiosArgs = await EntityLocationsApiAxiosParamCreator(configuration).getEntityLocationById(entityLocationId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns all entity locations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityLocations(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityLocationsInData>> {
            const localVarAxiosArgs = await EntityLocationsApiAxiosParamCreator(configuration).getEntityLocations(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Updates an entity location
         * @param {number} entityLocationId Entity location to return/update/create
         * @param {EntityLocationInData} entityLocationInData Entity Location object to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityLocation(entityLocationId: number, entityLocationInData: EntityLocationInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await EntityLocationsApiAxiosParamCreator(configuration).updateEntityLocation(entityLocationId, entityLocationInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * EntityLocationsApi - factory interface
 * @export
 */
export const EntityLocationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Create an entity location
         * @param {EntityLocationInData} entityLocationInData Entity Location object to be created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityLocation(entityLocationInData: EntityLocationInData, options?: any): AxiosPromise<EntityLocationInData> {
            return EntityLocationsApiFp(configuration).createEntityLocation(entityLocationInData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes an entity location
         * @param {number} entityLocationId Entity location to return/update/create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityLocation(entityLocationId: number, options?: any): AxiosPromise<void> {
            return EntityLocationsApiFp(configuration).deleteEntityLocation(entityLocationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns an entity location
         * @summary Find entity location by ID
         * @param {number} entityLocationId Entity location to return/update/create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityLocationById(entityLocationId: number, options?: any): AxiosPromise<EntityLocationInData> {
            return EntityLocationsApiFp(configuration).getEntityLocationById(entityLocationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all entity locations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityLocations(options?: any): AxiosPromise<EntityLocationsInData> {
            return EntityLocationsApiFp(configuration).getEntityLocations(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates an entity location
         * @param {number} entityLocationId Entity location to return/update/create
         * @param {EntityLocationInData} entityLocationInData Entity Location object to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityLocation(entityLocationId: number, entityLocationInData: EntityLocationInData, options?: any): AxiosPromise<void> {
            return EntityLocationsApiFp(configuration).updateEntityLocation(entityLocationId, entityLocationInData, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EntityLocationsApi - object-oriented interface
 * @export
 * @class EntityLocationsApi
 * @extends {BaseAPI}
 */
export class EntityLocationsApi extends BaseAPI {
    /**
     * 
     * @summary Create an entity location
     * @param {EntityLocationInData} entityLocationInData Entity Location object to be created
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityLocationsApi
     */
    public createEntityLocation(entityLocationInData: EntityLocationInData, options?: any) {
        return EntityLocationsApiFp(this.configuration).createEntityLocation(entityLocationInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes an entity location
     * @param {number} entityLocationId Entity location to return/update/create
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityLocationsApi
     */
    public deleteEntityLocation(entityLocationId: number, options?: any) {
        return EntityLocationsApiFp(this.configuration).deleteEntityLocation(entityLocationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns an entity location
     * @summary Find entity location by ID
     * @param {number} entityLocationId Entity location to return/update/create
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityLocationsApi
     */
    public getEntityLocationById(entityLocationId: number, options?: any) {
        return EntityLocationsApiFp(this.configuration).getEntityLocationById(entityLocationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all entity locations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityLocationsApi
     */
    public getEntityLocations(options?: any) {
        return EntityLocationsApiFp(this.configuration).getEntityLocations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates an entity location
     * @param {number} entityLocationId Entity location to return/update/create
     * @param {EntityLocationInData} entityLocationInData Entity Location object to be updated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityLocationsApi
     */
    public updateEntityLocation(entityLocationId: number, entityLocationInData: EntityLocationInData, options?: any) {
        return EntityLocationsApiFp(this.configuration).updateEntityLocation(entityLocationId, entityLocationInData, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * EventNotificationsApi - axios parameter creator
 * @export
 */
export const EventNotificationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Notify a user when an event occurs
         * @param {InlineObject4} [inlineObject4] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifyEvent: async (inlineObject4?: InlineObject4, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/eventNotifications`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof inlineObject4 !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(inlineObject4 !== undefined ? inlineObject4 : {}) : (inlineObject4 || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Notify support of event that occurred with no event subscribers
         * @param {InlineObject5} [inlineObject5] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifyNoSubscription: async (inlineObject5?: InlineObject5, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/eventNotifications/notifyNoSubscription`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'applications/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof inlineObject5 !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(inlineObject5 !== undefined ? inlineObject5 : {}) : (inlineObject5 || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Log to the database and create a Zendesk ticket for a special event
         * @param {InlineObject6} [inlineObject6] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifySupport: async (inlineObject6?: InlineObject6, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/eventNotifications/notifySupport`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'applications/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof inlineObject6 !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(inlineObject6 !== undefined ? inlineObject6 : {}) : (inlineObject6 || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EventNotificationsApi - functional programming interface
 * @export
 */
export const EventNotificationsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Notify a user when an event occurs
         * @param {InlineObject4} [inlineObject4] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notifyEvent(inlineObject4?: InlineObject4, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await EventNotificationsApiAxiosParamCreator(configuration).notifyEvent(inlineObject4, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Notify support of event that occurred with no event subscribers
         * @param {InlineObject5} [inlineObject5] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notifyNoSubscription(inlineObject5?: InlineObject5, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await EventNotificationsApiAxiosParamCreator(configuration).notifyNoSubscription(inlineObject5, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Log to the database and create a Zendesk ticket for a special event
         * @param {InlineObject6} [inlineObject6] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notifySupport(inlineObject6?: InlineObject6, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await EventNotificationsApiAxiosParamCreator(configuration).notifySupport(inlineObject6, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * EventNotificationsApi - factory interface
 * @export
 */
export const EventNotificationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Notify a user when an event occurs
         * @param {InlineObject4} [inlineObject4] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifyEvent(inlineObject4?: InlineObject4, options?: any): AxiosPromise<void> {
            return EventNotificationsApiFp(configuration).notifyEvent(inlineObject4, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Notify support of event that occurred with no event subscribers
         * @param {InlineObject5} [inlineObject5] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifyNoSubscription(inlineObject5?: InlineObject5, options?: any): AxiosPromise<void> {
            return EventNotificationsApiFp(configuration).notifyNoSubscription(inlineObject5, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Log to the database and create a Zendesk ticket for a special event
         * @param {InlineObject6} [inlineObject6] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifySupport(inlineObject6?: InlineObject6, options?: any): AxiosPromise<void> {
            return EventNotificationsApiFp(configuration).notifySupport(inlineObject6, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EventNotificationsApi - object-oriented interface
 * @export
 * @class EventNotificationsApi
 * @extends {BaseAPI}
 */
export class EventNotificationsApi extends BaseAPI {
    /**
     * 
     * @summary Notify a user when an event occurs
     * @param {InlineObject4} [inlineObject4] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventNotificationsApi
     */
    public notifyEvent(inlineObject4?: InlineObject4, options?: any) {
        return EventNotificationsApiFp(this.configuration).notifyEvent(inlineObject4, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Notify support of event that occurred with no event subscribers
     * @param {InlineObject5} [inlineObject5] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventNotificationsApi
     */
    public notifyNoSubscription(inlineObject5?: InlineObject5, options?: any) {
        return EventNotificationsApiFp(this.configuration).notifyNoSubscription(inlineObject5, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Log to the database and create a Zendesk ticket for a special event
     * @param {InlineObject6} [inlineObject6] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventNotificationsApi
     */
    public notifySupport(inlineObject6?: InlineObject6, options?: any) {
        return EventNotificationsApiFp(this.configuration).notifySupport(inlineObject6, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * EventSubscriptionsApi - axios parameter creator
 * @export
 */
export const EventSubscriptionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete an existing event subscription
         * @param {number} eventSubscriptionId ID of event subscription to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEventSubscription: async (eventSubscriptionId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventSubscriptionId' is not null or undefined
            if (eventSubscriptionId === null || eventSubscriptionId === undefined) {
                throw new RequiredError('eventSubscriptionId','Required parameter eventSubscriptionId was null or undefined when calling deleteEventSubscription.');
            }
            const localVarPath = `/eventSubscriptions/{eventSubscriptionId}`
                .replace(`{${"eventSubscriptionId"}}`, encodeURIComponent(String(eventSubscriptionId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns audit records of deleted event subscriptions for a given product
         * @param {number} productId ID of product to return
         * @param {number} startTs Start epoch timestamp to consider
         * @param {number} endTs End epoch timestamp to consider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeletedEventSubscriptionAudits: async (productId: number, startTs: number, endTs: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            if (productId === null || productId === undefined) {
                throw new RequiredError('productId','Required parameter productId was null or undefined when calling getDeletedEventSubscriptionAudits.');
            }
            // verify required parameter 'startTs' is not null or undefined
            if (startTs === null || startTs === undefined) {
                throw new RequiredError('startTs','Required parameter startTs was null or undefined when calling getDeletedEventSubscriptionAudits.');
            }
            // verify required parameter 'endTs' is not null or undefined
            if (endTs === null || endTs === undefined) {
                throw new RequiredError('endTs','Required parameter endTs was null or undefined when calling getDeletedEventSubscriptionAudits.');
            }
            const localVarPath = `/eventSubscriptions/deletedAudits/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (startTs !== undefined) {
                localVarQueryParameter['startTs'] = startTs;
            }

            if (endTs !== undefined) {
                localVarQueryParameter['endTs'] = endTs;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get an existing event subscription
         * @param {number} eventSubscriptionId ID of event subscription to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventSubscription: async (eventSubscriptionId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventSubscriptionId' is not null or undefined
            if (eventSubscriptionId === null || eventSubscriptionId === undefined) {
                throw new RequiredError('eventSubscriptionId','Required parameter eventSubscriptionId was null or undefined when calling getEventSubscription.');
            }
            const localVarPath = `/eventSubscriptions/{eventSubscriptionId}`
                .replace(`{${"eventSubscriptionId"}}`, encodeURIComponent(String(eventSubscriptionId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an existing event subscription
         * @param {number} eventSubscriptionId ID of event subscription to return
         * @param {InlineObject8} [inlineObject8] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEventSubscription: async (eventSubscriptionId: number, inlineObject8?: InlineObject8, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventSubscriptionId' is not null or undefined
            if (eventSubscriptionId === null || eventSubscriptionId === undefined) {
                throw new RequiredError('eventSubscriptionId','Required parameter eventSubscriptionId was null or undefined when calling patchEventSubscription.');
            }
            const localVarPath = `/eventSubscriptions/{eventSubscriptionId}`
                .replace(`{${"eventSubscriptionId"}}`, encodeURIComponent(String(eventSubscriptionId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof inlineObject8 !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(inlineObject8 !== undefined ? inlineObject8 : {}) : (inlineObject8 || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create an event subscription
         * @param {InlineObject7} [inlineObject7] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postEventSubscription: async (inlineObject7?: InlineObject7, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/eventSubscriptions`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof inlineObject7 !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(inlineObject7 !== undefined ? inlineObject7 : {}) : (inlineObject7 || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EventSubscriptionsApi - functional programming interface
 * @export
 */
export const EventSubscriptionsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete an existing event subscription
         * @param {number} eventSubscriptionId ID of event subscription to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEventSubscription(eventSubscriptionId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await EventSubscriptionsApiAxiosParamCreator(configuration).deleteEventSubscription(eventSubscriptionId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns audit records of deleted event subscriptions for a given product
         * @param {number} productId ID of product to return
         * @param {number} startTs Start epoch timestamp to consider
         * @param {number} endTs End epoch timestamp to consider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDeletedEventSubscriptionAudits(productId: number, startTs: number, endTs: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventSubscriptionDeletedAuditsInData>> {
            const localVarAxiosArgs = await EventSubscriptionsApiAxiosParamCreator(configuration).getDeletedEventSubscriptionAudits(productId, startTs, endTs, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get an existing event subscription
         * @param {number} eventSubscriptionId ID of event subscription to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventSubscription(eventSubscriptionId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventSubscription>> {
            const localVarAxiosArgs = await EventSubscriptionsApiAxiosParamCreator(configuration).getEventSubscription(eventSubscriptionId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update an existing event subscription
         * @param {number} eventSubscriptionId ID of event subscription to return
         * @param {InlineObject8} [inlineObject8] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEventSubscription(eventSubscriptionId: number, inlineObject8?: InlineObject8, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse201>> {
            const localVarAxiosArgs = await EventSubscriptionsApiAxiosParamCreator(configuration).patchEventSubscription(eventSubscriptionId, inlineObject8, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Create an event subscription
         * @param {InlineObject7} [inlineObject7] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postEventSubscription(inlineObject7?: InlineObject7, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse201>> {
            const localVarAxiosArgs = await EventSubscriptionsApiAxiosParamCreator(configuration).postEventSubscription(inlineObject7, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * EventSubscriptionsApi - factory interface
 * @export
 */
export const EventSubscriptionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Delete an existing event subscription
         * @param {number} eventSubscriptionId ID of event subscription to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEventSubscription(eventSubscriptionId: number, options?: any): AxiosPromise<void> {
            return EventSubscriptionsApiFp(configuration).deleteEventSubscription(eventSubscriptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns audit records of deleted event subscriptions for a given product
         * @param {number} productId ID of product to return
         * @param {number} startTs Start epoch timestamp to consider
         * @param {number} endTs End epoch timestamp to consider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeletedEventSubscriptionAudits(productId: number, startTs: number, endTs: number, options?: any): AxiosPromise<EventSubscriptionDeletedAuditsInData> {
            return EventSubscriptionsApiFp(configuration).getDeletedEventSubscriptionAudits(productId, startTs, endTs, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get an existing event subscription
         * @param {number} eventSubscriptionId ID of event subscription to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventSubscription(eventSubscriptionId: number, options?: any): AxiosPromise<EventSubscription> {
            return EventSubscriptionsApiFp(configuration).getEventSubscription(eventSubscriptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an existing event subscription
         * @param {number} eventSubscriptionId ID of event subscription to return
         * @param {InlineObject8} [inlineObject8] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEventSubscription(eventSubscriptionId: number, inlineObject8?: InlineObject8, options?: any): AxiosPromise<InlineResponse201> {
            return EventSubscriptionsApiFp(configuration).patchEventSubscription(eventSubscriptionId, inlineObject8, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create an event subscription
         * @param {InlineObject7} [inlineObject7] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postEventSubscription(inlineObject7?: InlineObject7, options?: any): AxiosPromise<InlineResponse201> {
            return EventSubscriptionsApiFp(configuration).postEventSubscription(inlineObject7, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EventSubscriptionsApi - object-oriented interface
 * @export
 * @class EventSubscriptionsApi
 * @extends {BaseAPI}
 */
export class EventSubscriptionsApi extends BaseAPI {
    /**
     * 
     * @summary Delete an existing event subscription
     * @param {number} eventSubscriptionId ID of event subscription to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventSubscriptionsApi
     */
    public deleteEventSubscription(eventSubscriptionId: number, options?: any) {
        return EventSubscriptionsApiFp(this.configuration).deleteEventSubscription(eventSubscriptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns audit records of deleted event subscriptions for a given product
     * @param {number} productId ID of product to return
     * @param {number} startTs Start epoch timestamp to consider
     * @param {number} endTs End epoch timestamp to consider
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventSubscriptionsApi
     */
    public getDeletedEventSubscriptionAudits(productId: number, startTs: number, endTs: number, options?: any) {
        return EventSubscriptionsApiFp(this.configuration).getDeletedEventSubscriptionAudits(productId, startTs, endTs, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get an existing event subscription
     * @param {number} eventSubscriptionId ID of event subscription to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventSubscriptionsApi
     */
    public getEventSubscription(eventSubscriptionId: number, options?: any) {
        return EventSubscriptionsApiFp(this.configuration).getEventSubscription(eventSubscriptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an existing event subscription
     * @param {number} eventSubscriptionId ID of event subscription to return
     * @param {InlineObject8} [inlineObject8] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventSubscriptionsApi
     */
    public patchEventSubscription(eventSubscriptionId: number, inlineObject8?: InlineObject8, options?: any) {
        return EventSubscriptionsApiFp(this.configuration).patchEventSubscription(eventSubscriptionId, inlineObject8, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create an event subscription
     * @param {InlineObject7} [inlineObject7] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventSubscriptionsApi
     */
    public postEventSubscription(inlineObject7?: InlineObject7, options?: any) {
        return EventSubscriptionsApiFp(this.configuration).postEventSubscription(inlineObject7, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * EventTypesApi - axios parameter creator
 * @export
 */
export const EventTypesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns all event types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventTypes: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/eventTypes`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns event types by product type
         * @param {ProductType} productType Type of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventTypesByProductType: async (productType: ProductType, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productType' is not null or undefined
            if (productType === null || productType === undefined) {
                throw new RequiredError('productType','Required parameter productType was null or undefined when calling getEventTypesByProductType.');
            }
            const localVarPath = `/eventTypes/productType/{productType}`
                .replace(`{${"productType"}}`, encodeURIComponent(String(productType)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EventTypesApi - functional programming interface
 * @export
 */
export const EventTypesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns all event types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventTypes(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2007>> {
            const localVarAxiosArgs = await EventTypesApiAxiosParamCreator(configuration).getEventTypes(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns event types by product type
         * @param {ProductType} productType Type of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventTypesByProductType(productType: ProductType, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2007>> {
            const localVarAxiosArgs = await EventTypesApiAxiosParamCreator(configuration).getEventTypesByProductType(productType, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * EventTypesApi - factory interface
 * @export
 */
export const EventTypesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Returns all event types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventTypes(options?: any): AxiosPromise<InlineResponse2007> {
            return EventTypesApiFp(configuration).getEventTypes(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns event types by product type
         * @param {ProductType} productType Type of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventTypesByProductType(productType: ProductType, options?: any): AxiosPromise<InlineResponse2007> {
            return EventTypesApiFp(configuration).getEventTypesByProductType(productType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EventTypesApi - object-oriented interface
 * @export
 * @class EventTypesApi
 * @extends {BaseAPI}
 */
export class EventTypesApi extends BaseAPI {
    /**
     * 
     * @summary Returns all event types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventTypesApi
     */
    public getEventTypes(options?: any) {
        return EventTypesApiFp(this.configuration).getEventTypes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns event types by product type
     * @param {ProductType} productType Type of product to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventTypesApi
     */
    public getEventTypesByProductType(productType: ProductType, options?: any) {
        return EventTypesApiFp(this.configuration).getEventTypesByProductType(productType, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * ExportsApi - axios parameter creator
 * @export
 */
export const ExportsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary CSV export
         * @param {'kpi' | 'notifications' | 'orgs' | 'payments' | 'products' | 'sites' | 'transceivers' | 'transceiversBasic' | 'users' | 'vats'} type CSV export to return
         * @param {string} [startDate] Start date
         * @param {string} [endDate] End date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        csvExport: async (type: 'kpi' | 'notifications' | 'orgs' | 'payments' | 'products' | 'sites' | 'transceivers' | 'transceiversBasic' | 'users' | 'vats', startDate?: string, endDate?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            if (type === null || type === undefined) {
                throw new RequiredError('type','Required parameter type was null or undefined when calling csvExport.');
            }
            const localVarPath = `/exports/get/{type}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substr(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substr(0,10) :
                    endDate;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExportsApi - functional programming interface
 * @export
 */
export const ExportsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary CSV export
         * @param {'kpi' | 'notifications' | 'orgs' | 'payments' | 'products' | 'sites' | 'transceivers' | 'transceiversBasic' | 'users' | 'vats'} type CSV export to return
         * @param {string} [startDate] Start date
         * @param {string} [endDate] End date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async csvExport(type: 'kpi' | 'notifications' | 'orgs' | 'payments' | 'products' | 'sites' | 'transceivers' | 'transceiversBasic' | 'users' | 'vats', startDate?: string, endDate?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await ExportsApiAxiosParamCreator(configuration).csvExport(type, startDate, endDate, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ExportsApi - factory interface
 * @export
 */
export const ExportsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary CSV export
         * @param {'kpi' | 'notifications' | 'orgs' | 'payments' | 'products' | 'sites' | 'transceivers' | 'transceiversBasic' | 'users' | 'vats'} type CSV export to return
         * @param {string} [startDate] Start date
         * @param {string} [endDate] End date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        csvExport(type: 'kpi' | 'notifications' | 'orgs' | 'payments' | 'products' | 'sites' | 'transceivers' | 'transceiversBasic' | 'users' | 'vats', startDate?: string, endDate?: string, options?: any): AxiosPromise<string> {
            return ExportsApiFp(configuration).csvExport(type, startDate, endDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExportsApi - object-oriented interface
 * @export
 * @class ExportsApi
 * @extends {BaseAPI}
 */
export class ExportsApi extends BaseAPI {
    /**
     * 
     * @summary CSV export
     * @param {'kpi' | 'notifications' | 'orgs' | 'payments' | 'products' | 'sites' | 'transceivers' | 'transceiversBasic' | 'users' | 'vats'} type CSV export to return
     * @param {string} [startDate] Start date
     * @param {string} [endDate] End date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportsApi
     */
    public csvExport(type: 'kpi' | 'notifications' | 'orgs' | 'payments' | 'products' | 'sites' | 'transceivers' | 'transceiversBasic' | 'users' | 'vats', startDate?: string, endDate?: string, options?: any) {
        return ExportsApiFp(this.configuration).csvExport(type, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * FaultSymptomsApi - axios parameter creator
 * @export
 */
export const FaultSymptomsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all fault symptoms
         * @summary Get fault symptoms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFaultSymptoms: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/faultSymptoms`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FaultSymptomsApi - functional programming interface
 * @export
 */
export const FaultSymptomsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Get all fault symptoms
         * @summary Get fault symptoms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFaultSymptoms(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FaultSymptomsInData>> {
            const localVarAxiosArgs = await FaultSymptomsApiAxiosParamCreator(configuration).getFaultSymptoms(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * FaultSymptomsApi - factory interface
 * @export
 */
export const FaultSymptomsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Get all fault symptoms
         * @summary Get fault symptoms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFaultSymptoms(options?: any): AxiosPromise<FaultSymptomsInData> {
            return FaultSymptomsApiFp(configuration).getFaultSymptoms(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FaultSymptomsApi - object-oriented interface
 * @export
 * @class FaultSymptomsApi
 * @extends {BaseAPI}
 */
export class FaultSymptomsApi extends BaseAPI {
    /**
     * Get all fault symptoms
     * @summary Get fault symptoms
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FaultSymptomsApi
     */
    public getFaultSymptoms(options?: any) {
        return FaultSymptomsApiFp(this.configuration).getFaultSymptoms(options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * FaultsApi - axios parameter creator
 * @export
 */
export const FaultsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a fault to the service
         * @param {FaultInData} faultInData Fault object to be added to service
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFault: async (faultInData: FaultInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'faultInData' is not null or undefined
            if (faultInData === null || faultInData === undefined) {
                throw new RequiredError('faultInData','Required parameter faultInData was null or undefined when calling addFault.');
            }
            const localVarPath = `/faults`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof faultInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(faultInData !== undefined ? faultInData : {}) : (faultInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes a fault
         * @param {number} faultId ID of fault to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFault: async (faultId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'faultId' is not null or undefined
            if (faultId === null || faultId === undefined) {
                throw new RequiredError('faultId','Required parameter faultId was null or undefined when calling deleteFault.');
            }
            const localVarPath = `/faults/{faultId}`
                .replace(`{${"faultId"}}`, encodeURIComponent(String(faultId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a fault
         * @summary Find fault by ID
         * @param {number} faultId ID of fault to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFaultById: async (faultId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'faultId' is not null or undefined
            if (faultId === null || faultId === undefined) {
                throw new RequiredError('faultId','Required parameter faultId was null or undefined when calling getFaultById.');
            }
            const localVarPath = `/faults/{faultId}`
                .replace(`{${"faultId"}}`, encodeURIComponent(String(faultId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets the list of fault types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFaultTypes: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/faults/types`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all faults
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFaults: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/faults`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates a fault
         * @param {number} faultId ID of fault to return
         * @param {FaultInData} faultInData Fault object to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFault: async (faultId: number, faultInData: FaultInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'faultId' is not null or undefined
            if (faultId === null || faultId === undefined) {
                throw new RequiredError('faultId','Required parameter faultId was null or undefined when calling updateFault.');
            }
            // verify required parameter 'faultInData' is not null or undefined
            if (faultInData === null || faultInData === undefined) {
                throw new RequiredError('faultInData','Required parameter faultInData was null or undefined when calling updateFault.');
            }
            const localVarPath = `/faults/{faultId}`
                .replace(`{${"faultId"}}`, encodeURIComponent(String(faultId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof faultInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(faultInData !== undefined ? faultInData : {}) : (faultInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FaultsApi - functional programming interface
 * @export
 */
export const FaultsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a fault to the service
         * @param {FaultInData} faultInData Fault object to be added to service
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addFault(faultInData: FaultInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await FaultsApiAxiosParamCreator(configuration).addFault(faultInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Deletes a fault
         * @param {number} faultId ID of fault to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFault(faultId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await FaultsApiAxiosParamCreator(configuration).deleteFault(faultId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns a fault
         * @summary Find fault by ID
         * @param {number} faultId ID of fault to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFaultById(faultId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FaultInData>> {
            const localVarAxiosArgs = await FaultsApiAxiosParamCreator(configuration).getFaultById(faultId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Gets the list of fault types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFaultTypes(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FaultTypesInData>> {
            const localVarAxiosArgs = await FaultsApiAxiosParamCreator(configuration).getFaultTypes(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns all faults
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFaults(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FaultsInData>> {
            const localVarAxiosArgs = await FaultsApiAxiosParamCreator(configuration).getFaults(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Updates a fault
         * @param {number} faultId ID of fault to return
         * @param {FaultInData} faultInData Fault object to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFault(faultId: number, faultInData: FaultInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await FaultsApiAxiosParamCreator(configuration).updateFault(faultId, faultInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * FaultsApi - factory interface
 * @export
 */
export const FaultsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Add a fault to the service
         * @param {FaultInData} faultInData Fault object to be added to service
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFault(faultInData: FaultInData, options?: any): AxiosPromise<void> {
            return FaultsApiFp(configuration).addFault(faultInData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes a fault
         * @param {number} faultId ID of fault to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFault(faultId: number, options?: any): AxiosPromise<void> {
            return FaultsApiFp(configuration).deleteFault(faultId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a fault
         * @summary Find fault by ID
         * @param {number} faultId ID of fault to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFaultById(faultId: number, options?: any): AxiosPromise<FaultInData> {
            return FaultsApiFp(configuration).getFaultById(faultId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets the list of fault types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFaultTypes(options?: any): AxiosPromise<FaultTypesInData> {
            return FaultsApiFp(configuration).getFaultTypes(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all faults
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFaults(options?: any): AxiosPromise<FaultsInData> {
            return FaultsApiFp(configuration).getFaults(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates a fault
         * @param {number} faultId ID of fault to return
         * @param {FaultInData} faultInData Fault object to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFault(faultId: number, faultInData: FaultInData, options?: any): AxiosPromise<void> {
            return FaultsApiFp(configuration).updateFault(faultId, faultInData, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FaultsApi - object-oriented interface
 * @export
 * @class FaultsApi
 * @extends {BaseAPI}
 */
export class FaultsApi extends BaseAPI {
    /**
     * 
     * @summary Add a fault to the service
     * @param {FaultInData} faultInData Fault object to be added to service
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FaultsApi
     */
    public addFault(faultInData: FaultInData, options?: any) {
        return FaultsApiFp(this.configuration).addFault(faultInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes a fault
     * @param {number} faultId ID of fault to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FaultsApi
     */
    public deleteFault(faultId: number, options?: any) {
        return FaultsApiFp(this.configuration).deleteFault(faultId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a fault
     * @summary Find fault by ID
     * @param {number} faultId ID of fault to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FaultsApi
     */
    public getFaultById(faultId: number, options?: any) {
        return FaultsApiFp(this.configuration).getFaultById(faultId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets the list of fault types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FaultsApi
     */
    public getFaultTypes(options?: any) {
        return FaultsApiFp(this.configuration).getFaultTypes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all faults
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FaultsApi
     */
    public getFaults(options?: any) {
        return FaultsApiFp(this.configuration).getFaults(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates a fault
     * @param {number} faultId ID of fault to return
     * @param {FaultInData} faultInData Fault object to be updated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FaultsApi
     */
    public updateFault(faultId: number, faultInData: FaultInData, options?: any) {
        return FaultsApiFp(this.configuration).updateFault(faultId, faultInData, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * FeedApi - axios parameter creator
 * @export
 */
export const FeedApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new feed tank correction entry
         * @param {number} id ID of entity to return
         * @param {FeedCorrectionInput} [feedCorrectionInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFeedTankCorrection: async (id: number, feedCorrectionInput?: FeedCorrectionInput, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling addFeedTankCorrection.');
            }
            const localVarPath = `/feed/tanks/{id}/correction`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof feedCorrectionInput !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(feedCorrectionInput !== undefined ? feedCorrectionInput : {}) : (feedCorrectionInput || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Move a feed tank from draft to pending
         * @summary Move a feed tank from draft to pending
         * @param {number} tankId ID of tank to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmDraftFeedTank: async (tankId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'tankId' is not null or undefined
            if (tankId === null || tankId === undefined) {
                throw new RequiredError('tankId','Required parameter tankId was null or undefined when calling confirmDraftFeedTank.');
            }
            const localVarPath = `/feed/tanks/{tankId}/confirmDraft`
                .replace(`{${"tankId"}}`, encodeURIComponent(String(tankId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a feed correction
         * @param {number} id ID of entity to return
         * @param {number} correctionId ID of correction to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFeedTankCorrection: async (id: number, correctionId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteFeedTankCorrection.');
            }
            // verify required parameter 'correctionId' is not null or undefined
            if (correctionId === null || correctionId === undefined) {
                throw new RequiredError('correctionId','Required parameter correctionId was null or undefined when calling deleteFeedTankCorrection.');
            }
            const localVarPath = `/feed/tanks/{id}/correction/{correctionId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"correctionId"}}`, encodeURIComponent(String(correctionId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add a feed tank to a feed product
         * @param {InlineObject9} [inlineObject9] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feedTankAdd: async (inlineObject9?: InlineObject9, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/feed/tanks`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof inlineObject9 !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(inlineObject9 !== undefined ? inlineObject9 : {}) : (inlineObject9 || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove transceiver and sensor from feed tank, set to removed
         * @param {number} id ID of entity to return
         * @param {DeactivateEntity} [deactivateEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feedTankDeactivate: async (id: number, deactivateEntity?: DeactivateEntity, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling feedTankDeactivate.');
            }
            const localVarPath = `/feed/tanks/{id}/deactivate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof deactivateEntity !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(deactivateEntity !== undefined ? deactivateEntity : {}) : (deactivateEntity || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Allocate transceiver and sensor to a feed tank
         * @param {number} id ID of entity to return
         * @param {FeedTankInstall} [feedTankInstall] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feedTankInstall: async (id: number, feedTankInstall?: FeedTankInstall, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling feedTankInstall.');
            }
            const localVarPath = `/feed/tanks/{id}/install`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof feedTankInstall !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(feedTankInstall !== undefined ? feedTankInstall : {}) : (feedTankInstall || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set the feed tank properties
         * @param {number} id ID of entity to return
         * @param {FeedTankProvision} [feedTankProvision] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feedTankProvision: async (id: number, feedTankProvision?: FeedTankProvision, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling feedTankProvision.');
            }
            const localVarPath = `/feed/tanks/{id}/provision`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof feedTankProvision !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(feedTankProvision !== undefined ? feedTankProvision : {}) : (feedTankProvision || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Confirm correct operation of transceiver, sensor and feed tank provisioning
         * @param {number} id ID of entity to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feedTankSignOff: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling feedTankSignOff.');
            }
            const localVarPath = `/feed/tanks/{id}/signOff`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve the current state metrics for the feed tank
         * @param {number} id ID of entity to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feedTanksIdCurrentStateGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling feedTanksIdCurrentStateGet.');
            }
            const localVarPath = `/feed/tanks/{id}/currentState`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve the current state metrics for the feed tank
         * @param {number} id ID of entity to return
         * @param {number} [nDays] return only this many days worth of data. Default &#x3D; 2 usually
         * @param {string} [series] return one series
         * @param {string} [offset] go back X days
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feedTanksIdGraphDataGet: async (id: number, nDays?: number, series?: string, offset?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling feedTanksIdGraphDataGet.');
            }
            const localVarPath = `/feed/tanks/{id}/graphData`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (nDays !== undefined) {
                localVarQueryParameter['nDays'] = nDays;
            }

            if (series !== undefined) {
                localVarQueryParameter['series'] = series;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a feed tank
         * @param {number} id ID of entity to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeedTank: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getFeedTank.');
            }
            const localVarPath = `/feed/tanks/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve the list of corrections applied to the feed tank
         * @param {number} id ID of entity to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeedTankCorrections: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getFeedTankCorrections.');
            }
            const localVarPath = `/feed/tanks/{id}/correction/list`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns sensor raw data
         * @summary Get Feed Tank Volume Data with Dynamo Paginatiion
         * @param {number} id ID of entity to return
         * @param {string} [series] Return one series
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeedTankRawData: async (id: number, series?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getFeedTankRawData.');
            }
            const localVarPath = `/feed/tanks/{id}/readingData`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (series !== undefined) {
                localVarQueryParameter['series'] = series;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the list of available feed types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeedTypes: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/feed/feedTypes`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create or update a feed tank formula correction
         * @param {number} id ID of entity to return
         * @param {InlineObject10} [inlineObject10] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFeedTankFormulaCorrection: async (id: number, inlineObject10?: InlineObject10, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateFeedTankFormulaCorrection.');
            }
            const localVarPath = `/feed/tanks/{id}/formula/correction`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof inlineObject10 !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(inlineObject10 !== undefined ? inlineObject10 : {}) : (inlineObject10 || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FeedApi - functional programming interface
 * @export
 */
export const FeedApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new feed tank correction entry
         * @param {number} id ID of entity to return
         * @param {FeedCorrectionInput} [feedCorrectionInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addFeedTankCorrection(id: number, feedCorrectionInput?: FeedCorrectionInput, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeedCorrectionInData>> {
            const localVarAxiosArgs = await FeedApiAxiosParamCreator(configuration).addFeedTankCorrection(id, feedCorrectionInput, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Move a feed tank from draft to pending
         * @summary Move a feed tank from draft to pending
         * @param {number} tankId ID of tank to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmDraftFeedTank(tankId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeedTankInData>> {
            const localVarAxiosArgs = await FeedApiAxiosParamCreator(configuration).confirmDraftFeedTank(tankId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Delete a feed correction
         * @param {number} id ID of entity to return
         * @param {number} correctionId ID of correction to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFeedTankCorrection(id: number, correctionId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2009>> {
            const localVarAxiosArgs = await FeedApiAxiosParamCreator(configuration).deleteFeedTankCorrection(id, correctionId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Add a feed tank to a feed product
         * @param {InlineObject9} [inlineObject9] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async feedTankAdd(inlineObject9?: InlineObject9, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeedTank>> {
            const localVarAxiosArgs = await FeedApiAxiosParamCreator(configuration).feedTankAdd(inlineObject9, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Remove transceiver and sensor from feed tank, set to removed
         * @param {number} id ID of entity to return
         * @param {DeactivateEntity} [deactivateEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async feedTankDeactivate(id: number, deactivateEntity?: DeactivateEntity, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeedTank>> {
            const localVarAxiosArgs = await FeedApiAxiosParamCreator(configuration).feedTankDeactivate(id, deactivateEntity, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Allocate transceiver and sensor to a feed tank
         * @param {number} id ID of entity to return
         * @param {FeedTankInstall} [feedTankInstall] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async feedTankInstall(id: number, feedTankInstall?: FeedTankInstall, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeedTank>> {
            const localVarAxiosArgs = await FeedApiAxiosParamCreator(configuration).feedTankInstall(id, feedTankInstall, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Set the feed tank properties
         * @param {number} id ID of entity to return
         * @param {FeedTankProvision} [feedTankProvision] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async feedTankProvision(id: number, feedTankProvision?: FeedTankProvision, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeedTank>> {
            const localVarAxiosArgs = await FeedApiAxiosParamCreator(configuration).feedTankProvision(id, feedTankProvision, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Confirm correct operation of transceiver, sensor and feed tank provisioning
         * @param {number} id ID of entity to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async feedTankSignOff(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeedTank>> {
            const localVarAxiosArgs = await FeedApiAxiosParamCreator(configuration).feedTankSignOff(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Retrieve the current state metrics for the feed tank
         * @param {number} id ID of entity to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async feedTanksIdCurrentStateGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2008>> {
            const localVarAxiosArgs = await FeedApiAxiosParamCreator(configuration).feedTanksIdCurrentStateGet(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Retrieve the current state metrics for the feed tank
         * @param {number} id ID of entity to return
         * @param {number} [nDays] return only this many days worth of data. Default &#x3D; 2 usually
         * @param {string} [series] return one series
         * @param {string} [offset] go back X days
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async feedTanksIdGraphDataGet(id: number, nDays?: number, series?: string, offset?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeedTankGraphItemsInData>> {
            const localVarAxiosArgs = await FeedApiAxiosParamCreator(configuration).feedTanksIdGraphDataGet(id, nDays, series, offset, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get a feed tank
         * @param {number} id ID of entity to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeedTank(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeedTank>> {
            const localVarAxiosArgs = await FeedApiAxiosParamCreator(configuration).getFeedTank(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Retrieve the list of corrections applied to the feed tank
         * @param {number} id ID of entity to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeedTankCorrections(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeedCorrectionListInData>> {
            const localVarAxiosArgs = await FeedApiAxiosParamCreator(configuration).getFeedTankCorrections(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns sensor raw data
         * @summary Get Feed Tank Volume Data with Dynamo Paginatiion
         * @param {number} id ID of entity to return
         * @param {string} [series] Return one series
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeedTankRawData(id: number, series?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20010>> {
            const localVarAxiosArgs = await FeedApiAxiosParamCreator(configuration).getFeedTankRawData(id, series, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get the list of available feed types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeedTypes(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeedTypesInData>> {
            const localVarAxiosArgs = await FeedApiAxiosParamCreator(configuration).getFeedTypes(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Create or update a feed tank formula correction
         * @param {number} id ID of entity to return
         * @param {InlineObject10} [inlineObject10] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFeedTankFormulaCorrection(id: number, inlineObject10?: InlineObject10, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeedTankInData>> {
            const localVarAxiosArgs = await FeedApiAxiosParamCreator(configuration).updateFeedTankFormulaCorrection(id, inlineObject10, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * FeedApi - factory interface
 * @export
 */
export const FeedApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Create a new feed tank correction entry
         * @param {number} id ID of entity to return
         * @param {FeedCorrectionInput} [feedCorrectionInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFeedTankCorrection(id: number, feedCorrectionInput?: FeedCorrectionInput, options?: any): AxiosPromise<FeedCorrectionInData> {
            return FeedApiFp(configuration).addFeedTankCorrection(id, feedCorrectionInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Move a feed tank from draft to pending
         * @summary Move a feed tank from draft to pending
         * @param {number} tankId ID of tank to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmDraftFeedTank(tankId: number, options?: any): AxiosPromise<FeedTankInData> {
            return FeedApiFp(configuration).confirmDraftFeedTank(tankId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a feed correction
         * @param {number} id ID of entity to return
         * @param {number} correctionId ID of correction to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFeedTankCorrection(id: number, correctionId: number, options?: any): AxiosPromise<InlineResponse2009> {
            return FeedApiFp(configuration).deleteFeedTankCorrection(id, correctionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add a feed tank to a feed product
         * @param {InlineObject9} [inlineObject9] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feedTankAdd(inlineObject9?: InlineObject9, options?: any): AxiosPromise<FeedTank> {
            return FeedApiFp(configuration).feedTankAdd(inlineObject9, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove transceiver and sensor from feed tank, set to removed
         * @param {number} id ID of entity to return
         * @param {DeactivateEntity} [deactivateEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feedTankDeactivate(id: number, deactivateEntity?: DeactivateEntity, options?: any): AxiosPromise<FeedTank> {
            return FeedApiFp(configuration).feedTankDeactivate(id, deactivateEntity, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Allocate transceiver and sensor to a feed tank
         * @param {number} id ID of entity to return
         * @param {FeedTankInstall} [feedTankInstall] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feedTankInstall(id: number, feedTankInstall?: FeedTankInstall, options?: any): AxiosPromise<FeedTank> {
            return FeedApiFp(configuration).feedTankInstall(id, feedTankInstall, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set the feed tank properties
         * @param {number} id ID of entity to return
         * @param {FeedTankProvision} [feedTankProvision] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feedTankProvision(id: number, feedTankProvision?: FeedTankProvision, options?: any): AxiosPromise<FeedTank> {
            return FeedApiFp(configuration).feedTankProvision(id, feedTankProvision, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Confirm correct operation of transceiver, sensor and feed tank provisioning
         * @param {number} id ID of entity to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feedTankSignOff(id: number, options?: any): AxiosPromise<FeedTank> {
            return FeedApiFp(configuration).feedTankSignOff(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve the current state metrics for the feed tank
         * @param {number} id ID of entity to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feedTanksIdCurrentStateGet(id: number, options?: any): AxiosPromise<InlineResponse2008> {
            return FeedApiFp(configuration).feedTanksIdCurrentStateGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve the current state metrics for the feed tank
         * @param {number} id ID of entity to return
         * @param {number} [nDays] return only this many days worth of data. Default &#x3D; 2 usually
         * @param {string} [series] return one series
         * @param {string} [offset] go back X days
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feedTanksIdGraphDataGet(id: number, nDays?: number, series?: string, offset?: string, options?: any): AxiosPromise<FeedTankGraphItemsInData> {
            return FeedApiFp(configuration).feedTanksIdGraphDataGet(id, nDays, series, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a feed tank
         * @param {number} id ID of entity to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeedTank(id: number, options?: any): AxiosPromise<FeedTank> {
            return FeedApiFp(configuration).getFeedTank(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve the list of corrections applied to the feed tank
         * @param {number} id ID of entity to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeedTankCorrections(id: number, options?: any): AxiosPromise<FeedCorrectionListInData> {
            return FeedApiFp(configuration).getFeedTankCorrections(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns sensor raw data
         * @summary Get Feed Tank Volume Data with Dynamo Paginatiion
         * @param {number} id ID of entity to return
         * @param {string} [series] Return one series
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeedTankRawData(id: number, series?: string, options?: any): AxiosPromise<InlineResponse20010> {
            return FeedApiFp(configuration).getFeedTankRawData(id, series, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the list of available feed types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeedTypes(options?: any): AxiosPromise<FeedTypesInData> {
            return FeedApiFp(configuration).getFeedTypes(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create or update a feed tank formula correction
         * @param {number} id ID of entity to return
         * @param {InlineObject10} [inlineObject10] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFeedTankFormulaCorrection(id: number, inlineObject10?: InlineObject10, options?: any): AxiosPromise<FeedTankInData> {
            return FeedApiFp(configuration).updateFeedTankFormulaCorrection(id, inlineObject10, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FeedApi - object-oriented interface
 * @export
 * @class FeedApi
 * @extends {BaseAPI}
 */
export class FeedApi extends BaseAPI {
    /**
     * 
     * @summary Create a new feed tank correction entry
     * @param {number} id ID of entity to return
     * @param {FeedCorrectionInput} [feedCorrectionInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeedApi
     */
    public addFeedTankCorrection(id: number, feedCorrectionInput?: FeedCorrectionInput, options?: any) {
        return FeedApiFp(this.configuration).addFeedTankCorrection(id, feedCorrectionInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Move a feed tank from draft to pending
     * @summary Move a feed tank from draft to pending
     * @param {number} tankId ID of tank to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeedApi
     */
    public confirmDraftFeedTank(tankId: number, options?: any) {
        return FeedApiFp(this.configuration).confirmDraftFeedTank(tankId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a feed correction
     * @param {number} id ID of entity to return
     * @param {number} correctionId ID of correction to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeedApi
     */
    public deleteFeedTankCorrection(id: number, correctionId: number, options?: any) {
        return FeedApiFp(this.configuration).deleteFeedTankCorrection(id, correctionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add a feed tank to a feed product
     * @param {InlineObject9} [inlineObject9] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeedApi
     */
    public feedTankAdd(inlineObject9?: InlineObject9, options?: any) {
        return FeedApiFp(this.configuration).feedTankAdd(inlineObject9, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove transceiver and sensor from feed tank, set to removed
     * @param {number} id ID of entity to return
     * @param {DeactivateEntity} [deactivateEntity] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeedApi
     */
    public feedTankDeactivate(id: number, deactivateEntity?: DeactivateEntity, options?: any) {
        return FeedApiFp(this.configuration).feedTankDeactivate(id, deactivateEntity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Allocate transceiver and sensor to a feed tank
     * @param {number} id ID of entity to return
     * @param {FeedTankInstall} [feedTankInstall] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeedApi
     */
    public feedTankInstall(id: number, feedTankInstall?: FeedTankInstall, options?: any) {
        return FeedApiFp(this.configuration).feedTankInstall(id, feedTankInstall, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set the feed tank properties
     * @param {number} id ID of entity to return
     * @param {FeedTankProvision} [feedTankProvision] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeedApi
     */
    public feedTankProvision(id: number, feedTankProvision?: FeedTankProvision, options?: any) {
        return FeedApiFp(this.configuration).feedTankProvision(id, feedTankProvision, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Confirm correct operation of transceiver, sensor and feed tank provisioning
     * @param {number} id ID of entity to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeedApi
     */
    public feedTankSignOff(id: number, options?: any) {
        return FeedApiFp(this.configuration).feedTankSignOff(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve the current state metrics for the feed tank
     * @param {number} id ID of entity to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeedApi
     */
    public feedTanksIdCurrentStateGet(id: number, options?: any) {
        return FeedApiFp(this.configuration).feedTanksIdCurrentStateGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve the current state metrics for the feed tank
     * @param {number} id ID of entity to return
     * @param {number} [nDays] return only this many days worth of data. Default &#x3D; 2 usually
     * @param {string} [series] return one series
     * @param {string} [offset] go back X days
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeedApi
     */
    public feedTanksIdGraphDataGet(id: number, nDays?: number, series?: string, offset?: string, options?: any) {
        return FeedApiFp(this.configuration).feedTanksIdGraphDataGet(id, nDays, series, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a feed tank
     * @param {number} id ID of entity to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeedApi
     */
    public getFeedTank(id: number, options?: any) {
        return FeedApiFp(this.configuration).getFeedTank(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve the list of corrections applied to the feed tank
     * @param {number} id ID of entity to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeedApi
     */
    public getFeedTankCorrections(id: number, options?: any) {
        return FeedApiFp(this.configuration).getFeedTankCorrections(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns sensor raw data
     * @summary Get Feed Tank Volume Data with Dynamo Paginatiion
     * @param {number} id ID of entity to return
     * @param {string} [series] Return one series
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeedApi
     */
    public getFeedTankRawData(id: number, series?: string, options?: any) {
        return FeedApiFp(this.configuration).getFeedTankRawData(id, series, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the list of available feed types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeedApi
     */
    public getFeedTypes(options?: any) {
        return FeedApiFp(this.configuration).getFeedTypes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create or update a feed tank formula correction
     * @param {number} id ID of entity to return
     * @param {InlineObject10} [inlineObject10] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeedApi
     */
    public updateFeedTankFormulaCorrection(id: number, inlineObject10?: InlineObject10, options?: any) {
        return FeedApiFp(this.configuration).updateFeedTankFormulaCorrection(id, inlineObject10, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * FlowChartsApi - axios parameter creator
 * @export
 */
export const FlowChartsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete a flow chart layout
         * @param {number} ownerId ID of the owner
         * @param {string} ownerType Type of the owner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFlowChartLayout: async (ownerId: number, ownerType: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'ownerId' is not null or undefined
            if (ownerId === null || ownerId === undefined) {
                throw new RequiredError('ownerId','Required parameter ownerId was null or undefined when calling deleteFlowChartLayout.');
            }
            // verify required parameter 'ownerType' is not null or undefined
            if (ownerType === null || ownerType === undefined) {
                throw new RequiredError('ownerType','Required parameter ownerType was null or undefined when calling deleteFlowChartLayout.');
            }
            const localVarPath = `/flowchart/layouts/{ownerType}/{ownerId}`
                .replace(`{${"ownerId"}}`, encodeURIComponent(String(ownerId)))
                .replace(`{${"ownerType"}}`, encodeURIComponent(String(ownerType)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get flowchart layout for a specific type
         * @summary Get a flowchart
         * @param {number} ownerId ID of the owner
         * @param {string} ownerType Type of the owner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlowChartLayout: async (ownerId: number, ownerType: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'ownerId' is not null or undefined
            if (ownerId === null || ownerId === undefined) {
                throw new RequiredError('ownerId','Required parameter ownerId was null or undefined when calling getFlowChartLayout.');
            }
            // verify required parameter 'ownerType' is not null or undefined
            if (ownerType === null || ownerType === undefined) {
                throw new RequiredError('ownerType','Required parameter ownerType was null or undefined when calling getFlowChartLayout.');
            }
            const localVarPath = `/flowchart/layouts/{ownerType}/{ownerId}`
                .replace(`{${"ownerId"}}`, encodeURIComponent(String(ownerId)))
                .replace(`{${"ownerType"}}`, encodeURIComponent(String(ownerType)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a flow chart layout
         * @param {number} ownerId ID of the owner
         * @param {string} ownerType Type of the owner
         * @param {FlowChartLayoutInData} flowChartLayoutInData Flowchart layout to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFlowChartLayout: async (ownerId: number, ownerType: string, flowChartLayoutInData: FlowChartLayoutInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'ownerId' is not null or undefined
            if (ownerId === null || ownerId === undefined) {
                throw new RequiredError('ownerId','Required parameter ownerId was null or undefined when calling updateFlowChartLayout.');
            }
            // verify required parameter 'ownerType' is not null or undefined
            if (ownerType === null || ownerType === undefined) {
                throw new RequiredError('ownerType','Required parameter ownerType was null or undefined when calling updateFlowChartLayout.');
            }
            // verify required parameter 'flowChartLayoutInData' is not null or undefined
            if (flowChartLayoutInData === null || flowChartLayoutInData === undefined) {
                throw new RequiredError('flowChartLayoutInData','Required parameter flowChartLayoutInData was null or undefined when calling updateFlowChartLayout.');
            }
            const localVarPath = `/flowchart/layouts/{ownerType}/{ownerId}`
                .replace(`{${"ownerId"}}`, encodeURIComponent(String(ownerId)))
                .replace(`{${"ownerType"}}`, encodeURIComponent(String(ownerType)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof flowChartLayoutInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(flowChartLayoutInData !== undefined ? flowChartLayoutInData : {}) : (flowChartLayoutInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FlowChartsApi - functional programming interface
 * @export
 */
export const FlowChartsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete a flow chart layout
         * @param {number} ownerId ID of the owner
         * @param {string} ownerType Type of the owner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFlowChartLayout(ownerId: number, ownerType: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await FlowChartsApiAxiosParamCreator(configuration).deleteFlowChartLayout(ownerId, ownerType, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get flowchart layout for a specific type
         * @summary Get a flowchart
         * @param {number} ownerId ID of the owner
         * @param {string} ownerType Type of the owner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFlowChartLayout(ownerId: number, ownerType: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlowChartLayoutsInData>> {
            const localVarAxiosArgs = await FlowChartsApiAxiosParamCreator(configuration).getFlowChartLayout(ownerId, ownerType, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update a flow chart layout
         * @param {number} ownerId ID of the owner
         * @param {string} ownerType Type of the owner
         * @param {FlowChartLayoutInData} flowChartLayoutInData Flowchart layout to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFlowChartLayout(ownerId: number, ownerType: string, flowChartLayoutInData: FlowChartLayoutInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await FlowChartsApiAxiosParamCreator(configuration).updateFlowChartLayout(ownerId, ownerType, flowChartLayoutInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * FlowChartsApi - factory interface
 * @export
 */
export const FlowChartsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Delete a flow chart layout
         * @param {number} ownerId ID of the owner
         * @param {string} ownerType Type of the owner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFlowChartLayout(ownerId: number, ownerType: string, options?: any): AxiosPromise<void> {
            return FlowChartsApiFp(configuration).deleteFlowChartLayout(ownerId, ownerType, options).then((request) => request(axios, basePath));
        },
        /**
         * Get flowchart layout for a specific type
         * @summary Get a flowchart
         * @param {number} ownerId ID of the owner
         * @param {string} ownerType Type of the owner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlowChartLayout(ownerId: number, ownerType: string, options?: any): AxiosPromise<FlowChartLayoutsInData> {
            return FlowChartsApiFp(configuration).getFlowChartLayout(ownerId, ownerType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a flow chart layout
         * @param {number} ownerId ID of the owner
         * @param {string} ownerType Type of the owner
         * @param {FlowChartLayoutInData} flowChartLayoutInData Flowchart layout to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFlowChartLayout(ownerId: number, ownerType: string, flowChartLayoutInData: FlowChartLayoutInData, options?: any): AxiosPromise<void> {
            return FlowChartsApiFp(configuration).updateFlowChartLayout(ownerId, ownerType, flowChartLayoutInData, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FlowChartsApi - object-oriented interface
 * @export
 * @class FlowChartsApi
 * @extends {BaseAPI}
 */
export class FlowChartsApi extends BaseAPI {
    /**
     * 
     * @summary Delete a flow chart layout
     * @param {number} ownerId ID of the owner
     * @param {string} ownerType Type of the owner
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowChartsApi
     */
    public deleteFlowChartLayout(ownerId: number, ownerType: string, options?: any) {
        return FlowChartsApiFp(this.configuration).deleteFlowChartLayout(ownerId, ownerType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get flowchart layout for a specific type
     * @summary Get a flowchart
     * @param {number} ownerId ID of the owner
     * @param {string} ownerType Type of the owner
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowChartsApi
     */
    public getFlowChartLayout(ownerId: number, ownerType: string, options?: any) {
        return FlowChartsApiFp(this.configuration).getFlowChartLayout(ownerId, ownerType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a flow chart layout
     * @param {number} ownerId ID of the owner
     * @param {string} ownerType Type of the owner
     * @param {FlowChartLayoutInData} flowChartLayoutInData Flowchart layout to be updated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowChartsApi
     */
    public updateFlowChartLayout(ownerId: number, ownerType: string, flowChartLayoutInData: FlowChartLayoutInData, options?: any) {
        return FlowChartsApiFp(this.configuration).updateFlowChartLayout(ownerId, ownerType, flowChartLayoutInData, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * FormulasApi - axios parameter creator
 * @export
 */
export const FormulasApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a new formula to the service
         * @param {FormulaInputInData} formulaInputInData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFormula: async (formulaInputInData: FormulaInputInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'formulaInputInData' is not null or undefined
            if (formulaInputInData === null || formulaInputInData === undefined) {
                throw new RequiredError('formulaInputInData','Required parameter formulaInputInData was null or undefined when calling addFormula.');
            }
            const localVarPath = `/formulas`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof formulaInputInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(formulaInputInData !== undefined ? formulaInputInData : {}) : (formulaInputInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a formula
         * @summary Find formula by ID
         * @param {number} formulaId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFormulaById: async (formulaId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'formulaId' is not null or undefined
            if (formulaId === null || formulaId === undefined) {
                throw new RequiredError('formulaId','Required parameter formulaId was null or undefined when calling getFormulaById.');
            }
            const localVarPath = `/formulas/{formulaId}`
                .replace(`{${"formulaId"}}`, encodeURIComponent(String(formulaId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all formulas
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFormulas: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/formulas`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all formulas for the entity type
         * @param {Entities} entityType Type of entity to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFormulasForEntity: async (entityType: Entities, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityType' is not null or undefined
            if (entityType === null || entityType === undefined) {
                throw new RequiredError('entityType','Required parameter entityType was null or undefined when calling getFormulasForEntity.');
            }
            const localVarPath = `/formulas/entity/{entityType}`
                .replace(`{${"entityType"}}`, encodeURIComponent(String(entityType)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the 10 most used formulas for the entity type
         * @param {Entities} entityType Type of entity to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFormulasForEntityMostUsed: async (entityType: Entities, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityType' is not null or undefined
            if (entityType === null || entityType === undefined) {
                throw new RequiredError('entityType','Required parameter entityType was null or undefined when calling getFormulasForEntityMostUsed.');
            }
            const localVarPath = `/formulas/entity/{entityType}/mostUsed`
                .replace(`{${"entityType"}}`, encodeURIComponent(String(entityType)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates a formula
         * @param {number} formulaId 
         * @param {FormulaInData} formulaInData Formula object to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFormula: async (formulaId: number, formulaInData: FormulaInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'formulaId' is not null or undefined
            if (formulaId === null || formulaId === undefined) {
                throw new RequiredError('formulaId','Required parameter formulaId was null or undefined when calling updateFormula.');
            }
            // verify required parameter 'formulaInData' is not null or undefined
            if (formulaInData === null || formulaInData === undefined) {
                throw new RequiredError('formulaInData','Required parameter formulaInData was null or undefined when calling updateFormula.');
            }
            const localVarPath = `/formulas/{formulaId}`
                .replace(`{${"formulaId"}}`, encodeURIComponent(String(formulaId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof formulaInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(formulaInData !== undefined ? formulaInData : {}) : (formulaInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FormulasApi - functional programming interface
 * @export
 */
export const FormulasApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a new formula to the service
         * @param {FormulaInputInData} formulaInputInData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addFormula(formulaInputInData: FormulaInputInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormulaInData>> {
            const localVarAxiosArgs = await FormulasApiAxiosParamCreator(configuration).addFormula(formulaInputInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns a formula
         * @summary Find formula by ID
         * @param {number} formulaId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFormulaById(formulaId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Formula>> {
            const localVarAxiosArgs = await FormulasApiAxiosParamCreator(configuration).getFormulaById(formulaId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns all formulas
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFormulas(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormulaInData>> {
            const localVarAxiosArgs = await FormulasApiAxiosParamCreator(configuration).getFormulas(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns all formulas for the entity type
         * @param {Entities} entityType Type of entity to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFormulasForEntity(entityType: Entities, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20011>> {
            const localVarAxiosArgs = await FormulasApiAxiosParamCreator(configuration).getFormulasForEntity(entityType, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns the 10 most used formulas for the entity type
         * @param {Entities} entityType Type of entity to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFormulasForEntityMostUsed(entityType: Entities, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20011>> {
            const localVarAxiosArgs = await FormulasApiAxiosParamCreator(configuration).getFormulasForEntityMostUsed(entityType, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Updates a formula
         * @param {number} formulaId 
         * @param {FormulaInData} formulaInData Formula object to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFormula(formulaId: number, formulaInData: FormulaInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Formula>> {
            const localVarAxiosArgs = await FormulasApiAxiosParamCreator(configuration).updateFormula(formulaId, formulaInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * FormulasApi - factory interface
 * @export
 */
export const FormulasApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Add a new formula to the service
         * @param {FormulaInputInData} formulaInputInData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFormula(formulaInputInData: FormulaInputInData, options?: any): AxiosPromise<FormulaInData> {
            return FormulasApiFp(configuration).addFormula(formulaInputInData, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a formula
         * @summary Find formula by ID
         * @param {number} formulaId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFormulaById(formulaId: number, options?: any): AxiosPromise<Formula> {
            return FormulasApiFp(configuration).getFormulaById(formulaId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all formulas
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFormulas(options?: any): AxiosPromise<FormulaInData> {
            return FormulasApiFp(configuration).getFormulas(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all formulas for the entity type
         * @param {Entities} entityType Type of entity to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFormulasForEntity(entityType: Entities, options?: any): AxiosPromise<InlineResponse20011> {
            return FormulasApiFp(configuration).getFormulasForEntity(entityType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the 10 most used formulas for the entity type
         * @param {Entities} entityType Type of entity to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFormulasForEntityMostUsed(entityType: Entities, options?: any): AxiosPromise<InlineResponse20011> {
            return FormulasApiFp(configuration).getFormulasForEntityMostUsed(entityType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates a formula
         * @param {number} formulaId 
         * @param {FormulaInData} formulaInData Formula object to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFormula(formulaId: number, formulaInData: FormulaInData, options?: any): AxiosPromise<Formula> {
            return FormulasApiFp(configuration).updateFormula(formulaId, formulaInData, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FormulasApi - object-oriented interface
 * @export
 * @class FormulasApi
 * @extends {BaseAPI}
 */
export class FormulasApi extends BaseAPI {
    /**
     * 
     * @summary Add a new formula to the service
     * @param {FormulaInputInData} formulaInputInData 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormulasApi
     */
    public addFormula(formulaInputInData: FormulaInputInData, options?: any) {
        return FormulasApiFp(this.configuration).addFormula(formulaInputInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a formula
     * @summary Find formula by ID
     * @param {number} formulaId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormulasApi
     */
    public getFormulaById(formulaId: number, options?: any) {
        return FormulasApiFp(this.configuration).getFormulaById(formulaId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all formulas
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormulasApi
     */
    public getFormulas(options?: any) {
        return FormulasApiFp(this.configuration).getFormulas(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all formulas for the entity type
     * @param {Entities} entityType Type of entity to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormulasApi
     */
    public getFormulasForEntity(entityType: Entities, options?: any) {
        return FormulasApiFp(this.configuration).getFormulasForEntity(entityType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the 10 most used formulas for the entity type
     * @param {Entities} entityType Type of entity to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormulasApi
     */
    public getFormulasForEntityMostUsed(entityType: Entities, options?: any) {
        return FormulasApiFp(this.configuration).getFormulasForEntityMostUsed(entityType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates a formula
     * @param {number} formulaId 
     * @param {FormulaInData} formulaInData Formula object to be updated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormulasApi
     */
    public updateFormula(formulaId: number, formulaInData: FormulaInData, options?: any) {
        return FormulasApiFp(this.configuration).updateFormula(formulaId, formulaInData, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * GatewaysApi - axios parameter creator
 * @export
 */
export const GatewaysApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a gateway
         * @param {GatewayInData} gatewayInData Gateway object to be created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGateway: async (gatewayInData: GatewayInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'gatewayInData' is not null or undefined
            if (gatewayInData === null || gatewayInData === undefined) {
                throw new RequiredError('gatewayInData','Required parameter gatewayInData was null or undefined when calling createGateway.');
            }
            const localVarPath = `/gateways`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof gatewayInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(gatewayInData !== undefined ? gatewayInData : {}) : (gatewayInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deallocate a gateway
         * @param {number} gatewayId Gateway to return/update/create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deallocateGateway: async (gatewayId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'gatewayId' is not null or undefined
            if (gatewayId === null || gatewayId === undefined) {
                throw new RequiredError('gatewayId','Required parameter gatewayId was null or undefined when calling deallocateGateway.');
            }
            const localVarPath = `/gateways/{gatewayId}/deallocate`
                .replace(`{${"gatewayId"}}`, encodeURIComponent(String(gatewayId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Decommission a gateway
         * @param {number} gatewayId Gateway to return/update/create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        decommissionGateway: async (gatewayId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'gatewayId' is not null or undefined
            if (gatewayId === null || gatewayId === undefined) {
                throw new RequiredError('gatewayId','Required parameter gatewayId was null or undefined when calling decommissionGateway.');
            }
            const localVarPath = `/gateways/{gatewayId}/decommission`
                .replace(`{${"gatewayId"}}`, encodeURIComponent(String(gatewayId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes a gateway
         * @param {number} gatewayId Gateway to return/update/create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGateway: async (gatewayId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'gatewayId' is not null or undefined
            if (gatewayId === null || gatewayId === undefined) {
                throw new RequiredError('gatewayId','Required parameter gatewayId was null or undefined when calling deleteGateway.');
            }
            const localVarPath = `/gateways/{gatewayId}`
                .replace(`{${"gatewayId"}}`, encodeURIComponent(String(gatewayId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a gateway
         * @summary Find gateway by ID
         * @param {number} gatewayId Gateway to return/update/create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGatewayById: async (gatewayId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'gatewayId' is not null or undefined
            if (gatewayId === null || gatewayId === undefined) {
                throw new RequiredError('gatewayId','Required parameter gatewayId was null or undefined when calling getGatewayById.');
            }
            const localVarPath = `/gateways/{gatewayId}`
                .replace(`{${"gatewayId"}}`, encodeURIComponent(String(gatewayId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get last check in time for a gateway
         * @param {number} gatewayId Gateway to return/update/create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGatewayLastCheckInTime: async (gatewayId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'gatewayId' is not null or undefined
            if (gatewayId === null || gatewayId === undefined) {
                throw new RequiredError('gatewayId','Required parameter gatewayId was null or undefined when calling getGatewayLastCheckInTime.');
            }
            const localVarPath = `/gateways/{gatewayId}/lastCheckIn`
                .replace(`{${"gatewayId"}}`, encodeURIComponent(String(gatewayId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all gateways
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGateways: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/gateways`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates a gateway
         * @param {number} gatewayId Gateway to return/update/create
         * @param {GatewayInData} gatewayInData Gateway object to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGateway: async (gatewayId: number, gatewayInData: GatewayInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'gatewayId' is not null or undefined
            if (gatewayId === null || gatewayId === undefined) {
                throw new RequiredError('gatewayId','Required parameter gatewayId was null or undefined when calling updateGateway.');
            }
            // verify required parameter 'gatewayInData' is not null or undefined
            if (gatewayInData === null || gatewayInData === undefined) {
                throw new RequiredError('gatewayInData','Required parameter gatewayInData was null or undefined when calling updateGateway.');
            }
            const localVarPath = `/gateways/{gatewayId}`
                .replace(`{${"gatewayId"}}`, encodeURIComponent(String(gatewayId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof gatewayInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(gatewayInData !== undefined ? gatewayInData : {}) : (gatewayInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GatewaysApi - functional programming interface
 * @export
 */
export const GatewaysApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a gateway
         * @param {GatewayInData} gatewayInData Gateway object to be created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createGateway(gatewayInData: GatewayInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GatewayInData>> {
            const localVarAxiosArgs = await GatewaysApiAxiosParamCreator(configuration).createGateway(gatewayInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Deallocate a gateway
         * @param {number} gatewayId Gateway to return/update/create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deallocateGateway(gatewayId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Gateway>> {
            const localVarAxiosArgs = await GatewaysApiAxiosParamCreator(configuration).deallocateGateway(gatewayId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Decommission a gateway
         * @param {number} gatewayId Gateway to return/update/create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async decommissionGateway(gatewayId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GatewayInData>> {
            const localVarAxiosArgs = await GatewaysApiAxiosParamCreator(configuration).decommissionGateway(gatewayId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Deletes a gateway
         * @param {number} gatewayId Gateway to return/update/create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteGateway(gatewayId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await GatewaysApiAxiosParamCreator(configuration).deleteGateway(gatewayId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns a gateway
         * @summary Find gateway by ID
         * @param {number} gatewayId Gateway to return/update/create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGatewayById(gatewayId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GatewayInData>> {
            const localVarAxiosArgs = await GatewaysApiAxiosParamCreator(configuration).getGatewayById(gatewayId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get last check in time for a gateway
         * @param {number} gatewayId Gateway to return/update/create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGatewayLastCheckInTime(gatewayId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LastCheckInTimeInData>> {
            const localVarAxiosArgs = await GatewaysApiAxiosParamCreator(configuration).getGatewayLastCheckInTime(gatewayId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns all gateways
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGateways(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GatewaysInData>> {
            const localVarAxiosArgs = await GatewaysApiAxiosParamCreator(configuration).getGateways(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Updates a gateway
         * @param {number} gatewayId Gateway to return/update/create
         * @param {GatewayInData} gatewayInData Gateway object to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateGateway(gatewayId: number, gatewayInData: GatewayInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await GatewaysApiAxiosParamCreator(configuration).updateGateway(gatewayId, gatewayInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * GatewaysApi - factory interface
 * @export
 */
export const GatewaysApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Create a gateway
         * @param {GatewayInData} gatewayInData Gateway object to be created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGateway(gatewayInData: GatewayInData, options?: any): AxiosPromise<GatewayInData> {
            return GatewaysApiFp(configuration).createGateway(gatewayInData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deallocate a gateway
         * @param {number} gatewayId Gateway to return/update/create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deallocateGateway(gatewayId: number, options?: any): AxiosPromise<Gateway> {
            return GatewaysApiFp(configuration).deallocateGateway(gatewayId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Decommission a gateway
         * @param {number} gatewayId Gateway to return/update/create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        decommissionGateway(gatewayId: number, options?: any): AxiosPromise<GatewayInData> {
            return GatewaysApiFp(configuration).decommissionGateway(gatewayId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes a gateway
         * @param {number} gatewayId Gateway to return/update/create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGateway(gatewayId: number, options?: any): AxiosPromise<void> {
            return GatewaysApiFp(configuration).deleteGateway(gatewayId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a gateway
         * @summary Find gateway by ID
         * @param {number} gatewayId Gateway to return/update/create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGatewayById(gatewayId: number, options?: any): AxiosPromise<GatewayInData> {
            return GatewaysApiFp(configuration).getGatewayById(gatewayId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get last check in time for a gateway
         * @param {number} gatewayId Gateway to return/update/create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGatewayLastCheckInTime(gatewayId: number, options?: any): AxiosPromise<LastCheckInTimeInData> {
            return GatewaysApiFp(configuration).getGatewayLastCheckInTime(gatewayId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all gateways
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGateways(options?: any): AxiosPromise<GatewaysInData> {
            return GatewaysApiFp(configuration).getGateways(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates a gateway
         * @param {number} gatewayId Gateway to return/update/create
         * @param {GatewayInData} gatewayInData Gateway object to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGateway(gatewayId: number, gatewayInData: GatewayInData, options?: any): AxiosPromise<void> {
            return GatewaysApiFp(configuration).updateGateway(gatewayId, gatewayInData, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GatewaysApi - object-oriented interface
 * @export
 * @class GatewaysApi
 * @extends {BaseAPI}
 */
export class GatewaysApi extends BaseAPI {
    /**
     * 
     * @summary Create a gateway
     * @param {GatewayInData} gatewayInData Gateway object to be created
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GatewaysApi
     */
    public createGateway(gatewayInData: GatewayInData, options?: any) {
        return GatewaysApiFp(this.configuration).createGateway(gatewayInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deallocate a gateway
     * @param {number} gatewayId Gateway to return/update/create
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GatewaysApi
     */
    public deallocateGateway(gatewayId: number, options?: any) {
        return GatewaysApiFp(this.configuration).deallocateGateway(gatewayId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Decommission a gateway
     * @param {number} gatewayId Gateway to return/update/create
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GatewaysApi
     */
    public decommissionGateway(gatewayId: number, options?: any) {
        return GatewaysApiFp(this.configuration).decommissionGateway(gatewayId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes a gateway
     * @param {number} gatewayId Gateway to return/update/create
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GatewaysApi
     */
    public deleteGateway(gatewayId: number, options?: any) {
        return GatewaysApiFp(this.configuration).deleteGateway(gatewayId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a gateway
     * @summary Find gateway by ID
     * @param {number} gatewayId Gateway to return/update/create
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GatewaysApi
     */
    public getGatewayById(gatewayId: number, options?: any) {
        return GatewaysApiFp(this.configuration).getGatewayById(gatewayId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get last check in time for a gateway
     * @param {number} gatewayId Gateway to return/update/create
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GatewaysApi
     */
    public getGatewayLastCheckInTime(gatewayId: number, options?: any) {
        return GatewaysApiFp(this.configuration).getGatewayLastCheckInTime(gatewayId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all gateways
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GatewaysApi
     */
    public getGateways(options?: any) {
        return GatewaysApiFp(this.configuration).getGateways(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates a gateway
     * @param {number} gatewayId Gateway to return/update/create
     * @param {GatewayInData} gatewayInData Gateway object to be updated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GatewaysApi
     */
    public updateGateway(gatewayId: number, gatewayInData: GatewayInData, options?: any) {
        return GatewaysApiFp(this.configuration).updateGateway(gatewayId, gatewayInData, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * GraphsApi - axios parameter creator
 * @export
 */
export const GraphsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Graph data for an entity
         * @param {'sensor' | 'transceiver' | 'vat'} entity entity to return
         * @param {number} id ID of entity to return
         * @param {number} startTs Start epoch timestamp to consider
         * @param {number} endTs End epoch timestamp to consider
         * @param {string} [series] Return one series
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graph: async (entity: 'sensor' | 'transceiver' | 'vat', id: number, startTs: number, endTs: number, series?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'entity' is not null or undefined
            if (entity === null || entity === undefined) {
                throw new RequiredError('entity','Required parameter entity was null or undefined when calling graph.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling graph.');
            }
            // verify required parameter 'startTs' is not null or undefined
            if (startTs === null || startTs === undefined) {
                throw new RequiredError('startTs','Required parameter startTs was null or undefined when calling graph.');
            }
            // verify required parameter 'endTs' is not null or undefined
            if (endTs === null || endTs === undefined) {
                throw new RequiredError('endTs','Required parameter endTs was null or undefined when calling graph.');
            }
            const localVarPath = `/graphs/{entity}/{id}`
                .replace(`{${"entity"}}`, encodeURIComponent(String(entity)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (startTs !== undefined) {
                localVarQueryParameter['startTs'] = startTs;
            }

            if (endTs !== undefined) {
                localVarQueryParameter['endTs'] = endTs;
            }

            if (series !== undefined) {
                localVarQueryParameter['series'] = series;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GraphsApi - functional programming interface
 * @export
 */
export const GraphsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Graph data for an entity
         * @param {'sensor' | 'transceiver' | 'vat'} entity entity to return
         * @param {number} id ID of entity to return
         * @param {number} startTs Start epoch timestamp to consider
         * @param {number} endTs End epoch timestamp to consider
         * @param {string} [series] Return one series
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async graph(entity: 'sensor' | 'transceiver' | 'vat', id: number, startTs: number, endTs: number, series?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GraphTimeSeriesInData>> {
            const localVarAxiosArgs = await GraphsApiAxiosParamCreator(configuration).graph(entity, id, startTs, endTs, series, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * GraphsApi - factory interface
 * @export
 */
export const GraphsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Graph data for an entity
         * @param {'sensor' | 'transceiver' | 'vat'} entity entity to return
         * @param {number} id ID of entity to return
         * @param {number} startTs Start epoch timestamp to consider
         * @param {number} endTs End epoch timestamp to consider
         * @param {string} [series] Return one series
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graph(entity: 'sensor' | 'transceiver' | 'vat', id: number, startTs: number, endTs: number, series?: string, options?: any): AxiosPromise<GraphTimeSeriesInData> {
            return GraphsApiFp(configuration).graph(entity, id, startTs, endTs, series, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GraphsApi - object-oriented interface
 * @export
 * @class GraphsApi
 * @extends {BaseAPI}
 */
export class GraphsApi extends BaseAPI {
    /**
     * 
     * @summary Graph data for an entity
     * @param {'sensor' | 'transceiver' | 'vat'} entity entity to return
     * @param {number} id ID of entity to return
     * @param {number} startTs Start epoch timestamp to consider
     * @param {number} endTs End epoch timestamp to consider
     * @param {string} [series] Return one series
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GraphsApi
     */
    public graph(entity: 'sensor' | 'transceiver' | 'vat', id: number, startTs: number, endTs: number, series?: string, options?: any) {
        return GraphsApiFp(this.configuration).graph(entity, id, startTs, endTs, series, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * JobsApi - axios parameter creator
 * @export
 */
export const JobsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a Job
         * @param {JobInData} jobInData Job object to be added to service
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addJob: async (jobInData: JobInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobInData' is not null or undefined
            if (jobInData === null || jobInData === undefined) {
                throw new RequiredError('jobInData','Required parameter jobInData was null or undefined when calling addJob.');
            }
            const localVarPath = `/jobs`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof jobInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(jobInData !== undefined ? jobInData : {}) : (jobInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes a job
         * @param {number} jobId ID of job to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteJob: async (jobId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            if (jobId === null || jobId === undefined) {
                throw new RequiredError('jobId','Required parameter jobId was null or undefined when calling deleteJob.');
            }
            const localVarPath = `/jobs/{jobId}`
                .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a Job
         * @summary Find job by ID
         * @param {number} jobId ID of job to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobById: async (jobId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            if (jobId === null || jobId === undefined) {
                throw new RequiredError('jobId','Required parameter jobId was null or undefined when calling getJobById.');
            }
            const localVarPath = `/jobs/{jobId}`
                .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all jobs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobs: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/jobs`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Process a job - sensor to vat allocations
         * @param {number} jobId ID of job to return
         * @param {InlineObject11} inlineObject11 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processJob: async (jobId: number, inlineObject11: InlineObject11, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            if (jobId === null || jobId === undefined) {
                throw new RequiredError('jobId','Required parameter jobId was null or undefined when calling processJob.');
            }
            // verify required parameter 'inlineObject11' is not null or undefined
            if (inlineObject11 === null || inlineObject11 === undefined) {
                throw new RequiredError('inlineObject11','Required parameter inlineObject11 was null or undefined when calling processJob.');
            }
            const localVarPath = `/jobs/{jobId}/assignSensors`
                .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof inlineObject11 !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(inlineObject11 !== undefined ? inlineObject11 : {}) : (inlineObject11 || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates an job
         * @param {number} jobId ID of job to return
         * @param {JobInData} jobInData Job object to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateJob: async (jobId: number, jobInData: JobInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            if (jobId === null || jobId === undefined) {
                throw new RequiredError('jobId','Required parameter jobId was null or undefined when calling updateJob.');
            }
            // verify required parameter 'jobInData' is not null or undefined
            if (jobInData === null || jobInData === undefined) {
                throw new RequiredError('jobInData','Required parameter jobInData was null or undefined when calling updateJob.');
            }
            const localVarPath = `/jobs/{jobId}`
                .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof jobInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(jobInData !== undefined ? jobInData : {}) : (jobInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * JobsApi - functional programming interface
 * @export
 */
export const JobsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a Job
         * @param {JobInData} jobInData Job object to be added to service
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addJob(jobInData: JobInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await JobsApiAxiosParamCreator(configuration).addJob(jobInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Deletes a job
         * @param {number} jobId ID of job to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteJob(jobId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await JobsApiAxiosParamCreator(configuration).deleteJob(jobId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns a Job
         * @summary Find job by ID
         * @param {number} jobId ID of job to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJobById(jobId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobInData>> {
            const localVarAxiosArgs = await JobsApiAxiosParamCreator(configuration).getJobById(jobId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns all jobs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJobs(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobsInData>> {
            const localVarAxiosArgs = await JobsApiAxiosParamCreator(configuration).getJobs(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Process a job - sensor to vat allocations
         * @param {number} jobId ID of job to return
         * @param {InlineObject11} inlineObject11 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processJob(jobId: number, inlineObject11: InlineObject11, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await JobsApiAxiosParamCreator(configuration).processJob(jobId, inlineObject11, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Updates an job
         * @param {number} jobId ID of job to return
         * @param {JobInData} jobInData Job object to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateJob(jobId: number, jobInData: JobInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await JobsApiAxiosParamCreator(configuration).updateJob(jobId, jobInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * JobsApi - factory interface
 * @export
 */
export const JobsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Add a Job
         * @param {JobInData} jobInData Job object to be added to service
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addJob(jobInData: JobInData, options?: any): AxiosPromise<void> {
            return JobsApiFp(configuration).addJob(jobInData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes a job
         * @param {number} jobId ID of job to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteJob(jobId: number, options?: any): AxiosPromise<void> {
            return JobsApiFp(configuration).deleteJob(jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a Job
         * @summary Find job by ID
         * @param {number} jobId ID of job to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobById(jobId: number, options?: any): AxiosPromise<JobInData> {
            return JobsApiFp(configuration).getJobById(jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all jobs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobs(options?: any): AxiosPromise<JobsInData> {
            return JobsApiFp(configuration).getJobs(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Process a job - sensor to vat allocations
         * @param {number} jobId ID of job to return
         * @param {InlineObject11} inlineObject11 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processJob(jobId: number, inlineObject11: InlineObject11, options?: any): AxiosPromise<void> {
            return JobsApiFp(configuration).processJob(jobId, inlineObject11, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates an job
         * @param {number} jobId ID of job to return
         * @param {JobInData} jobInData Job object to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateJob(jobId: number, jobInData: JobInData, options?: any): AxiosPromise<void> {
            return JobsApiFp(configuration).updateJob(jobId, jobInData, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * JobsApi - object-oriented interface
 * @export
 * @class JobsApi
 * @extends {BaseAPI}
 */
export class JobsApi extends BaseAPI {
    /**
     * 
     * @summary Add a Job
     * @param {JobInData} jobInData Job object to be added to service
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    public addJob(jobInData: JobInData, options?: any) {
        return JobsApiFp(this.configuration).addJob(jobInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes a job
     * @param {number} jobId ID of job to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    public deleteJob(jobId: number, options?: any) {
        return JobsApiFp(this.configuration).deleteJob(jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a Job
     * @summary Find job by ID
     * @param {number} jobId ID of job to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    public getJobById(jobId: number, options?: any) {
        return JobsApiFp(this.configuration).getJobById(jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all jobs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    public getJobs(options?: any) {
        return JobsApiFp(this.configuration).getJobs(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Process a job - sensor to vat allocations
     * @param {number} jobId ID of job to return
     * @param {InlineObject11} inlineObject11 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    public processJob(jobId: number, inlineObject11: InlineObject11, options?: any) {
        return JobsApiFp(this.configuration).processJob(jobId, inlineObject11, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates an job
     * @param {number} jobId ID of job to return
     * @param {JobInData} jobInData Job object to be updated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    public updateJob(jobId: number, jobInData: JobInData, options?: any) {
        return JobsApiFp(this.configuration).updateJob(jobId, jobInData, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * NodesApi - axios parameter creator
 * @export
 */
export const NodesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a node
         * @param {NodeInData} nodeInData Node object to be created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNode: async (nodeInData: NodeInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'nodeInData' is not null or undefined
            if (nodeInData === null || nodeInData === undefined) {
                throw new RequiredError('nodeInData','Required parameter nodeInData was null or undefined when calling createNode.');
            }
            const localVarPath = `/nodes`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof nodeInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(nodeInData !== undefined ? nodeInData : {}) : (nodeInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deallocate a node
         * @param {number} nodeId Node to return/update/create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deallocateNode: async (nodeId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'nodeId' is not null or undefined
            if (nodeId === null || nodeId === undefined) {
                throw new RequiredError('nodeId','Required parameter nodeId was null or undefined when calling deallocateNode.');
            }
            const localVarPath = `/nodes/{nodeId}/deallocate`
                .replace(`{${"nodeId"}}`, encodeURIComponent(String(nodeId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Decommission a node
         * @param {number} nodeId Node to return/update/create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        decommissionNode: async (nodeId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'nodeId' is not null or undefined
            if (nodeId === null || nodeId === undefined) {
                throw new RequiredError('nodeId','Required parameter nodeId was null or undefined when calling decommissionNode.');
            }
            const localVarPath = `/nodes/{nodeId}/decommission`
                .replace(`{${"nodeId"}}`, encodeURIComponent(String(nodeId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes a node
         * @param {number} nodeId Node to return/update/create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNode: async (nodeId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'nodeId' is not null or undefined
            if (nodeId === null || nodeId === undefined) {
                throw new RequiredError('nodeId','Required parameter nodeId was null or undefined when calling deleteNode.');
            }
            const localVarPath = `/nodes/{nodeId}`
                .replace(`{${"nodeId"}}`, encodeURIComponent(String(nodeId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a node
         * @summary Find node by ID
         * @param {number} nodeId Node to return/update/create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNodeById: async (nodeId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'nodeId' is not null or undefined
            if (nodeId === null || nodeId === undefined) {
                throw new RequiredError('nodeId','Required parameter nodeId was null or undefined when calling getNodeById.');
            }
            const localVarPath = `/nodes/{nodeId}`
                .replace(`{${"nodeId"}}`, encodeURIComponent(String(nodeId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get last check in time for a node
         * @param {number} nodeId Node to return/update/create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNodeLastCheckInTime: async (nodeId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'nodeId' is not null or undefined
            if (nodeId === null || nodeId === undefined) {
                throw new RequiredError('nodeId','Required parameter nodeId was null or undefined when calling getNodeLastCheckInTime.');
            }
            const localVarPath = `/nodes/{nodeId}/lastCheckIn`
                .replace(`{${"nodeId"}}`, encodeURIComponent(String(nodeId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all nodes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNodes: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/nodes`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates a node
         * @param {number} nodeId Node to return/update/create
         * @param {NodeInData} nodeInData Node object to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNode: async (nodeId: number, nodeInData: NodeInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'nodeId' is not null or undefined
            if (nodeId === null || nodeId === undefined) {
                throw new RequiredError('nodeId','Required parameter nodeId was null or undefined when calling updateNode.');
            }
            // verify required parameter 'nodeInData' is not null or undefined
            if (nodeInData === null || nodeInData === undefined) {
                throw new RequiredError('nodeInData','Required parameter nodeInData was null or undefined when calling updateNode.');
            }
            const localVarPath = `/nodes/{nodeId}`
                .replace(`{${"nodeId"}}`, encodeURIComponent(String(nodeId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof nodeInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(nodeInData !== undefined ? nodeInData : {}) : (nodeInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NodesApi - functional programming interface
 * @export
 */
export const NodesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a node
         * @param {NodeInData} nodeInData Node object to be created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNode(nodeInData: NodeInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NodeInData>> {
            const localVarAxiosArgs = await NodesApiAxiosParamCreator(configuration).createNode(nodeInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Deallocate a node
         * @param {number} nodeId Node to return/update/create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deallocateNode(nodeId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Node>> {
            const localVarAxiosArgs = await NodesApiAxiosParamCreator(configuration).deallocateNode(nodeId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Decommission a node
         * @param {number} nodeId Node to return/update/create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async decommissionNode(nodeId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NodeInData>> {
            const localVarAxiosArgs = await NodesApiAxiosParamCreator(configuration).decommissionNode(nodeId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Deletes a node
         * @param {number} nodeId Node to return/update/create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteNode(nodeId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await NodesApiAxiosParamCreator(configuration).deleteNode(nodeId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns a node
         * @summary Find node by ID
         * @param {number} nodeId Node to return/update/create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNodeById(nodeId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NodeInData>> {
            const localVarAxiosArgs = await NodesApiAxiosParamCreator(configuration).getNodeById(nodeId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get last check in time for a node
         * @param {number} nodeId Node to return/update/create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNodeLastCheckInTime(nodeId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LastCheckInTimeInData>> {
            const localVarAxiosArgs = await NodesApiAxiosParamCreator(configuration).getNodeLastCheckInTime(nodeId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns all nodes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNodes(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NodesInData>> {
            const localVarAxiosArgs = await NodesApiAxiosParamCreator(configuration).getNodes(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Updates a node
         * @param {number} nodeId Node to return/update/create
         * @param {NodeInData} nodeInData Node object to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateNode(nodeId: number, nodeInData: NodeInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await NodesApiAxiosParamCreator(configuration).updateNode(nodeId, nodeInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * NodesApi - factory interface
 * @export
 */
export const NodesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Create a node
         * @param {NodeInData} nodeInData Node object to be created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNode(nodeInData: NodeInData, options?: any): AxiosPromise<NodeInData> {
            return NodesApiFp(configuration).createNode(nodeInData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deallocate a node
         * @param {number} nodeId Node to return/update/create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deallocateNode(nodeId: number, options?: any): AxiosPromise<Node> {
            return NodesApiFp(configuration).deallocateNode(nodeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Decommission a node
         * @param {number} nodeId Node to return/update/create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        decommissionNode(nodeId: number, options?: any): AxiosPromise<NodeInData> {
            return NodesApiFp(configuration).decommissionNode(nodeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes a node
         * @param {number} nodeId Node to return/update/create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNode(nodeId: number, options?: any): AxiosPromise<void> {
            return NodesApiFp(configuration).deleteNode(nodeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a node
         * @summary Find node by ID
         * @param {number} nodeId Node to return/update/create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNodeById(nodeId: number, options?: any): AxiosPromise<NodeInData> {
            return NodesApiFp(configuration).getNodeById(nodeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get last check in time for a node
         * @param {number} nodeId Node to return/update/create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNodeLastCheckInTime(nodeId: number, options?: any): AxiosPromise<LastCheckInTimeInData> {
            return NodesApiFp(configuration).getNodeLastCheckInTime(nodeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all nodes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNodes(options?: any): AxiosPromise<NodesInData> {
            return NodesApiFp(configuration).getNodes(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates a node
         * @param {number} nodeId Node to return/update/create
         * @param {NodeInData} nodeInData Node object to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNode(nodeId: number, nodeInData: NodeInData, options?: any): AxiosPromise<void> {
            return NodesApiFp(configuration).updateNode(nodeId, nodeInData, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NodesApi - object-oriented interface
 * @export
 * @class NodesApi
 * @extends {BaseAPI}
 */
export class NodesApi extends BaseAPI {
    /**
     * 
     * @summary Create a node
     * @param {NodeInData} nodeInData Node object to be created
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    public createNode(nodeInData: NodeInData, options?: any) {
        return NodesApiFp(this.configuration).createNode(nodeInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deallocate a node
     * @param {number} nodeId Node to return/update/create
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    public deallocateNode(nodeId: number, options?: any) {
        return NodesApiFp(this.configuration).deallocateNode(nodeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Decommission a node
     * @param {number} nodeId Node to return/update/create
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    public decommissionNode(nodeId: number, options?: any) {
        return NodesApiFp(this.configuration).decommissionNode(nodeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes a node
     * @param {number} nodeId Node to return/update/create
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    public deleteNode(nodeId: number, options?: any) {
        return NodesApiFp(this.configuration).deleteNode(nodeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a node
     * @summary Find node by ID
     * @param {number} nodeId Node to return/update/create
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    public getNodeById(nodeId: number, options?: any) {
        return NodesApiFp(this.configuration).getNodeById(nodeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get last check in time for a node
     * @param {number} nodeId Node to return/update/create
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    public getNodeLastCheckInTime(nodeId: number, options?: any) {
        return NodesApiFp(this.configuration).getNodeLastCheckInTime(nodeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all nodes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    public getNodes(options?: any) {
        return NodesApiFp(this.configuration).getNodes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates a node
     * @param {number} nodeId Node to return/update/create
     * @param {NodeInData} nodeInData Node object to be updated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    public updateNode(nodeId: number, nodeInData: NodeInData, options?: any) {
        return NodesApiFp(this.configuration).updateNode(nodeId, nodeInData, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * NotificationsApi - axios parameter creator
 * @export
 */
export const NotificationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new notification
         * @param {InlineObject12} inlineObject12 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotification: async (inlineObject12: InlineObject12, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'inlineObject12' is not null or undefined
            if (inlineObject12 === null || inlineObject12 === undefined) {
                throw new RequiredError('inlineObject12','Required parameter inlineObject12 was null or undefined when calling createNotification.');
            }
            const localVarPath = `/notifications`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof inlineObject12 !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(inlineObject12 !== undefined ? inlineObject12 : {}) : (inlineObject12 || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Users subscribe to message types by setting up alerts. Notifications are the messages actually sent to users by date and type eg sms/email.
         * @summary Return list of messages sent to customers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotifications: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/notifications`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all the sent notifications between the start and end timestamp
         * @param {number} productId ID of product to return
         * @param {InlineObject13} [inlineObject13] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationsSentBetween: async (productId: number, inlineObject13?: InlineObject13, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            if (productId === null || productId === undefined) {
                throw new RequiredError('productId','Required parameter productId was null or undefined when calling getNotificationsSentBetween.');
            }
            const localVarPath = `/notifications/{productId}/getNotificationsSentBetween`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof inlineObject13 !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(inlineObject13 !== undefined ? inlineObject13 : {}) : (inlineObject13 || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationsApi - functional programming interface
 * @export
 */
export const NotificationsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new notification
         * @param {InlineObject12} inlineObject12 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNotification(inlineObject12: InlineObject12, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await NotificationsApiAxiosParamCreator(configuration).createNotification(inlineObject12, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Users subscribe to message types by setting up alerts. Notifications are the messages actually sent to users by date and type eg sms/email.
         * @summary Return list of messages sent to customers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotifications(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20012>> {
            const localVarAxiosArgs = await NotificationsApiAxiosParamCreator(configuration).getNotifications(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns all the sent notifications between the start and end timestamp
         * @param {number} productId ID of product to return
         * @param {InlineObject13} [inlineObject13] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotificationsSentBetween(productId: number, inlineObject13?: InlineObject13, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationsSent>> {
            const localVarAxiosArgs = await NotificationsApiAxiosParamCreator(configuration).getNotificationsSentBetween(productId, inlineObject13, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * NotificationsApi - factory interface
 * @export
 */
export const NotificationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Create a new notification
         * @param {InlineObject12} inlineObject12 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotification(inlineObject12: InlineObject12, options?: any): AxiosPromise<void> {
            return NotificationsApiFp(configuration).createNotification(inlineObject12, options).then((request) => request(axios, basePath));
        },
        /**
         * Users subscribe to message types by setting up alerts. Notifications are the messages actually sent to users by date and type eg sms/email.
         * @summary Return list of messages sent to customers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotifications(options?: any): AxiosPromise<InlineResponse20012> {
            return NotificationsApiFp(configuration).getNotifications(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all the sent notifications between the start and end timestamp
         * @param {number} productId ID of product to return
         * @param {InlineObject13} [inlineObject13] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationsSentBetween(productId: number, inlineObject13?: InlineObject13, options?: any): AxiosPromise<NotificationsSent> {
            return NotificationsApiFp(configuration).getNotificationsSentBetween(productId, inlineObject13, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationsApi - object-oriented interface
 * @export
 * @class NotificationsApi
 * @extends {BaseAPI}
 */
export class NotificationsApi extends BaseAPI {
    /**
     * 
     * @summary Create a new notification
     * @param {InlineObject12} inlineObject12 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public createNotification(inlineObject12: InlineObject12, options?: any) {
        return NotificationsApiFp(this.configuration).createNotification(inlineObject12, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Users subscribe to message types by setting up alerts. Notifications are the messages actually sent to users by date and type eg sms/email.
     * @summary Return list of messages sent to customers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public getNotifications(options?: any) {
        return NotificationsApiFp(this.configuration).getNotifications(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all the sent notifications between the start and end timestamp
     * @param {number} productId ID of product to return
     * @param {InlineObject13} [inlineObject13] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public getNotificationsSentBetween(productId: number, inlineObject13?: InlineObject13, options?: any) {
        return NotificationsApiFp(this.configuration).getNotificationsSentBetween(productId, inlineObject13, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * OrgsApi - axios parameter creator
 * @export
 */
export const OrgsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Accepts the terms and conditions
         * @param {number} orgId ID of org to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptTerms: async (orgId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId','Required parameter orgId was null or undefined when calling acceptTerms.');
            }
            const localVarPath = `/orgs/{orgId}/terms`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sends an activation email to the org owner
         * @param {number} orgId ID of org to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateOrg: async (orgId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId','Required parameter orgId was null or undefined when calling activateOrg.');
            }
            const localVarPath = `/orgs/{orgId}/activate`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add a new org and admin / user roles
         * @param {InlineObject14} [inlineObject14] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrg: async (inlineObject14?: InlineObject14, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/orgs`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof inlineObject14 !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(inlineObject14 !== undefined ? inlineObject14 : {}) : (inlineObject14 || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create an org user
         * @param {number} orgId ID of org to return
         * @param {UserInData} userInData User object to be created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrgUser: async (orgId: number, userInData: UserInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId','Required parameter orgId was null or undefined when calling createOrgUser.');
            }
            // verify required parameter 'userInData' is not null or undefined
            if (userInData === null || userInData === undefined) {
                throw new RequiredError('userInData','Required parameter userInData was null or undefined when calling createOrgUser.');
            }
            const localVarPath = `/orgs/{orgId}/users`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof userInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(userInData !== undefined ? userInData : {}) : (userInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes an org
         * @param {number} orgId ID of org to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrg: async (orgId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId','Required parameter orgId was null or undefined when calling deleteOrg.');
            }
            const localVarPath = `/orgs/{orgId}`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get org alerts
         * @param {number} orgId ID of org to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgAlerts: async (orgId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId','Required parameter orgId was null or undefined when calling getOrgAlerts.');
            }
            const localVarPath = `/orgs/{orgId}/alerts`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find org by orgId
         * @param {number} orgId ID of org to return
         * @param {Array<string>} [include] comma separated list of additional related objects to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgById: async (orgId: number, include?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId','Required parameter orgId was null or undefined when calling getOrgById.');
            }
            const localVarPath = `/orgs/{orgId}`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (include) {
                localVarQueryParameter['include'] = include.join(COLLECTION_FORMATS.csv);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all products with a partner relationship to org
         * @param {number} orgId ID of org to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgPartnerProducts: async (orgId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId','Required parameter orgId was null or undefined when calling getOrgPartnerProducts.');
            }
            const localVarPath = `/orgs/{orgId}/partnerProducts`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all users for a given org
         * @param {number} orgId ID of org to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgUsers: async (orgId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId','Required parameter orgId was null or undefined when calling getOrgUsers.');
            }
            const localVarPath = `/orgs/{orgId}/users`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all orgs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgs: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/orgs`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the payment methods not currently assigned to the org
         * @param {number} orgId ID of org to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgAdditionalPaymentMethods: async (orgId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId','Required parameter orgId was null or undefined when calling orgAdditionalPaymentMethods.');
            }
            const localVarPath = `/orgs/{orgId}/additionalPaymentMethods`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create or update an org alert and alert subscribers
         * @param {number} orgId ID of org to return
         * @param {AlertInData} alertInData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgAlertSubscribers: async (orgId: number, alertInData: AlertInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId','Required parameter orgId was null or undefined when calling orgAlertSubscribers.');
            }
            // verify required parameter 'alertInData' is not null or undefined
            if (alertInData === null || alertInData === undefined) {
                throw new RequiredError('alertInData','Required parameter alertInData was null or undefined when calling orgAlertSubscribers.');
            }
            const localVarPath = `/orgs/{orgId}/alerts`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof alertInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(alertInData !== undefined ? alertInData : {}) : (alertInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a payment method
         * @param {number} orgId ID of org to return
         * @param {number} paymentMethodId ID of payment method to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgDeletePaymentMethod: async (orgId: number, paymentMethodId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId','Required parameter orgId was null or undefined when calling orgDeletePaymentMethod.');
            }
            // verify required parameter 'paymentMethodId' is not null or undefined
            if (paymentMethodId === null || paymentMethodId === undefined) {
                throw new RequiredError('paymentMethodId','Required parameter paymentMethodId was null or undefined when calling orgDeletePaymentMethod.');
            }
            const localVarPath = `/orgs/{orgId}/paymentMethods/{paymentMethodId}`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"paymentMethodId"}}`, encodeURIComponent(String(paymentMethodId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all billing partner orgs by product type
         * @param {ProductType} productType Type of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgGetBillingPartnersByProductType: async (productType: ProductType, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productType' is not null or undefined
            if (productType === null || productType === undefined) {
                throw new RequiredError('productType','Required parameter productType was null or undefined when calling orgGetBillingPartnersByProductType.');
            }
            const localVarPath = `/orgs/partners/billing/{productType}`
                .replace(`{${"productType"}}`, encodeURIComponent(String(productType)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all partner orgs FTP targets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgGetFtpTargets: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/orgs/ftpTargets`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all partner orgs by product type
         * @param {ProductType} productType Type of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgGetPartnersByProductType: async (productType: ProductType, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productType' is not null or undefined
            if (productType === null || productType === undefined) {
                throw new RequiredError('productType','Required parameter productType was null or undefined when calling orgGetPartnersByProductType.');
            }
            const localVarPath = `/orgs/partners/{productType}`
                .replace(`{${"productType"}}`, encodeURIComponent(String(productType)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all partner orgs that are regional councils
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgGetRegionalCouncils: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/orgs/regionalCouncils`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary DEPRECATED Creates an install job
         * @param {number} orgId ID of org to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgInstallJob: async (orgId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId','Required parameter orgId was null or undefined when calling orgInstallJob.');
            }
            const localVarPath = `/orgs/{orgId}/job`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all the orgs registered payment methods
         * @param {number} orgId ID of org to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgPaymentMethods: async (orgId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId','Required parameter orgId was null or undefined when calling orgPaymentMethods.');
            }
            const localVarPath = `/orgs/{orgId}/paymentMethods`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add org access by setting action = attach. Remove org access by setting action = detach.
         * @summary Allocate or deallocate an org role aka org access
         * @param {number} userId ID of user to return
         * @param {number} orgId ID of org to return
         * @param {InlineObject16} inlineObject16 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgUserRoles: async (userId: number, orgId: number, inlineObject16: InlineObject16, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling orgUserRoles.');
            }
            // verify required parameter 'orgId' is not null or undefined
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId','Required parameter orgId was null or undefined when calling orgUserRoles.');
            }
            // verify required parameter 'inlineObject16' is not null or undefined
            if (inlineObject16 === null || inlineObject16 === undefined) {
                throw new RequiredError('inlineObject16','Required parameter inlineObject16 was null or undefined when calling orgUserRoles.');
            }
            const localVarPath = `/orgs/{orgId}/users/{userId}/roles`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof inlineObject16 !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(inlineObject16 !== undefined ? inlineObject16 : {}) : (inlineObject16 || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates an org
         * @param {number} orgId ID of org to return
         * @param {InlineObject15} [inlineObject15] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrg: async (orgId: number, inlineObject15?: InlineObject15, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId','Required parameter orgId was null or undefined when calling updateOrg.');
            }
            const localVarPath = `/orgs/{orgId}`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof inlineObject15 !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(inlineObject15 !== undefined ? inlineObject15 : {}) : (inlineObject15 || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an org user
         * @param {number} orgId ID of org to return
         * @param {number} userId ID of user to return
         * @param {UserInData} userInData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrgUser: async (orgId: number, userId: number, userInData: UserInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId','Required parameter orgId was null or undefined when calling updateOrgUser.');
            }
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling updateOrgUser.');
            }
            // verify required parameter 'userInData' is not null or undefined
            if (userInData === null || userInData === undefined) {
                throw new RequiredError('userInData','Required parameter userInData was null or undefined when calling updateOrgUser.');
            }
            const localVarPath = `/orgs/{orgId}/users/{userId}`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof userInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(userInData !== undefined ? userInData : {}) : (userInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrgsApi - functional programming interface
 * @export
 */
export const OrgsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Accepts the terms and conditions
         * @param {number} orgId ID of org to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptTerms(orgId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await OrgsApiAxiosParamCreator(configuration).acceptTerms(orgId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Sends an activation email to the org owner
         * @param {number} orgId ID of org to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activateOrg(orgId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await OrgsApiAxiosParamCreator(configuration).activateOrg(orgId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Add a new org and admin / user roles
         * @param {InlineObject14} [inlineObject14] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addOrg(inlineObject14?: InlineObject14, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await OrgsApiAxiosParamCreator(configuration).addOrg(inlineObject14, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Create an org user
         * @param {number} orgId ID of org to return
         * @param {UserInData} userInData User object to be created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrgUser(orgId: number, userInData: UserInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await OrgsApiAxiosParamCreator(configuration).createOrgUser(orgId, userInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Deletes an org
         * @param {number} orgId ID of org to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrg(orgId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await OrgsApiAxiosParamCreator(configuration).deleteOrg(orgId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get org alerts
         * @param {number} orgId ID of org to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrgAlerts(orgId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AlertsInData>> {
            const localVarAxiosArgs = await OrgsApiAxiosParamCreator(configuration).getOrgAlerts(orgId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Find org by orgId
         * @param {number} orgId ID of org to return
         * @param {Array<string>} [include] comma separated list of additional related objects to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrgById(orgId: number, include?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Org>> {
            const localVarAxiosArgs = await OrgsApiAxiosParamCreator(configuration).getOrgById(orgId, include, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns all products with a partner relationship to org
         * @param {number} orgId ID of org to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrgPartnerProducts(orgId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductsInData>> {
            const localVarAxiosArgs = await OrgsApiAxiosParamCreator(configuration).getOrgPartnerProducts(orgId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get all users for a given org
         * @param {number} orgId ID of org to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrgUsers(orgId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsersInData>> {
            const localVarAxiosArgs = await OrgsApiAxiosParamCreator(configuration).getOrgUsers(orgId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns all orgs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrgs(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrgsInData>> {
            const localVarAxiosArgs = await OrgsApiAxiosParamCreator(configuration).getOrgs(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get the payment methods not currently assigned to the org
         * @param {number} orgId ID of org to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgAdditionalPaymentMethods(orgId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20014>> {
            const localVarAxiosArgs = await OrgsApiAxiosParamCreator(configuration).orgAdditionalPaymentMethods(orgId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Create or update an org alert and alert subscribers
         * @param {number} orgId ID of org to return
         * @param {AlertInData} alertInData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgAlertSubscribers(orgId: number, alertInData: AlertInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await OrgsApiAxiosParamCreator(configuration).orgAlertSubscribers(orgId, alertInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Delete a payment method
         * @param {number} orgId ID of org to return
         * @param {number} paymentMethodId ID of payment method to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgDeletePaymentMethod(orgId: number, paymentMethodId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await OrgsApiAxiosParamCreator(configuration).orgDeletePaymentMethod(orgId, paymentMethodId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get all billing partner orgs by product type
         * @param {ProductType} productType Type of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgGetBillingPartnersByProductType(productType: ProductType, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20015>> {
            const localVarAxiosArgs = await OrgsApiAxiosParamCreator(configuration).orgGetBillingPartnersByProductType(productType, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get all partner orgs FTP targets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgGetFtpTargets(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Org>>> {
            const localVarAxiosArgs = await OrgsApiAxiosParamCreator(configuration).orgGetFtpTargets(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get all partner orgs by product type
         * @param {ProductType} productType Type of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgGetPartnersByProductType(productType: ProductType, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20015>> {
            const localVarAxiosArgs = await OrgsApiAxiosParamCreator(configuration).orgGetPartnersByProductType(productType, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get all partner orgs that are regional councils
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgGetRegionalCouncils(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Org>>> {
            const localVarAxiosArgs = await OrgsApiAxiosParamCreator(configuration).orgGetRegionalCouncils(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary DEPRECATED Creates an install job
         * @param {number} orgId ID of org to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgInstallJob(orgId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await OrgsApiAxiosParamCreator(configuration).orgInstallJob(orgId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get all the orgs registered payment methods
         * @param {number} orgId ID of org to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgPaymentMethods(orgId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20013>> {
            const localVarAxiosArgs = await OrgsApiAxiosParamCreator(configuration).orgPaymentMethods(orgId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Add org access by setting action = attach. Remove org access by setting action = detach.
         * @summary Allocate or deallocate an org role aka org access
         * @param {number} userId ID of user to return
         * @param {number} orgId ID of org to return
         * @param {InlineObject16} inlineObject16 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgUserRoles(userId: number, orgId: number, inlineObject16: InlineObject16, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await OrgsApiAxiosParamCreator(configuration).orgUserRoles(userId, orgId, inlineObject16, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Updates an org
         * @param {number} orgId ID of org to return
         * @param {InlineObject15} [inlineObject15] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrg(orgId: number, inlineObject15?: InlineObject15, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await OrgsApiAxiosParamCreator(configuration).updateOrg(orgId, inlineObject15, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update an org user
         * @param {number} orgId ID of org to return
         * @param {number} userId ID of user to return
         * @param {UserInData} userInData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrgUser(orgId: number, userId: number, userInData: UserInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await OrgsApiAxiosParamCreator(configuration).updateOrgUser(orgId, userId, userInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * OrgsApi - factory interface
 * @export
 */
export const OrgsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Accepts the terms and conditions
         * @param {number} orgId ID of org to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptTerms(orgId: number, options?: any): AxiosPromise<void> {
            return OrgsApiFp(configuration).acceptTerms(orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sends an activation email to the org owner
         * @param {number} orgId ID of org to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateOrg(orgId: number, options?: any): AxiosPromise<void> {
            return OrgsApiFp(configuration).activateOrg(orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add a new org and admin / user roles
         * @param {InlineObject14} [inlineObject14] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrg(inlineObject14?: InlineObject14, options?: any): AxiosPromise<void> {
            return OrgsApiFp(configuration).addOrg(inlineObject14, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create an org user
         * @param {number} orgId ID of org to return
         * @param {UserInData} userInData User object to be created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrgUser(orgId: number, userInData: UserInData, options?: any): AxiosPromise<void> {
            return OrgsApiFp(configuration).createOrgUser(orgId, userInData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes an org
         * @param {number} orgId ID of org to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrg(orgId: number, options?: any): AxiosPromise<void> {
            return OrgsApiFp(configuration).deleteOrg(orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get org alerts
         * @param {number} orgId ID of org to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgAlerts(orgId: number, options?: any): AxiosPromise<AlertsInData> {
            return OrgsApiFp(configuration).getOrgAlerts(orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Find org by orgId
         * @param {number} orgId ID of org to return
         * @param {Array<string>} [include] comma separated list of additional related objects to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgById(orgId: number, include?: Array<string>, options?: any): AxiosPromise<Org> {
            return OrgsApiFp(configuration).getOrgById(orgId, include, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all products with a partner relationship to org
         * @param {number} orgId ID of org to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgPartnerProducts(orgId: number, options?: any): AxiosPromise<ProductsInData> {
            return OrgsApiFp(configuration).getOrgPartnerProducts(orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all users for a given org
         * @param {number} orgId ID of org to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgUsers(orgId: number, options?: any): AxiosPromise<UsersInData> {
            return OrgsApiFp(configuration).getOrgUsers(orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all orgs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgs(options?: any): AxiosPromise<OrgsInData> {
            return OrgsApiFp(configuration).getOrgs(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the payment methods not currently assigned to the org
         * @param {number} orgId ID of org to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgAdditionalPaymentMethods(orgId: number, options?: any): AxiosPromise<InlineResponse20014> {
            return OrgsApiFp(configuration).orgAdditionalPaymentMethods(orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create or update an org alert and alert subscribers
         * @param {number} orgId ID of org to return
         * @param {AlertInData} alertInData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgAlertSubscribers(orgId: number, alertInData: AlertInData, options?: any): AxiosPromise<void> {
            return OrgsApiFp(configuration).orgAlertSubscribers(orgId, alertInData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a payment method
         * @param {number} orgId ID of org to return
         * @param {number} paymentMethodId ID of payment method to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgDeletePaymentMethod(orgId: number, paymentMethodId: number, options?: any): AxiosPromise<void> {
            return OrgsApiFp(configuration).orgDeletePaymentMethod(orgId, paymentMethodId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all billing partner orgs by product type
         * @param {ProductType} productType Type of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgGetBillingPartnersByProductType(productType: ProductType, options?: any): AxiosPromise<InlineResponse20015> {
            return OrgsApiFp(configuration).orgGetBillingPartnersByProductType(productType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all partner orgs FTP targets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgGetFtpTargets(options?: any): AxiosPromise<Array<Org>> {
            return OrgsApiFp(configuration).orgGetFtpTargets(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all partner orgs by product type
         * @param {ProductType} productType Type of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgGetPartnersByProductType(productType: ProductType, options?: any): AxiosPromise<InlineResponse20015> {
            return OrgsApiFp(configuration).orgGetPartnersByProductType(productType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all partner orgs that are regional councils
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgGetRegionalCouncils(options?: any): AxiosPromise<Array<Org>> {
            return OrgsApiFp(configuration).orgGetRegionalCouncils(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary DEPRECATED Creates an install job
         * @param {number} orgId ID of org to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgInstallJob(orgId: number, options?: any): AxiosPromise<void> {
            return OrgsApiFp(configuration).orgInstallJob(orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all the orgs registered payment methods
         * @param {number} orgId ID of org to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgPaymentMethods(orgId: number, options?: any): AxiosPromise<InlineResponse20013> {
            return OrgsApiFp(configuration).orgPaymentMethods(orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add org access by setting action = attach. Remove org access by setting action = detach.
         * @summary Allocate or deallocate an org role aka org access
         * @param {number} userId ID of user to return
         * @param {number} orgId ID of org to return
         * @param {InlineObject16} inlineObject16 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgUserRoles(userId: number, orgId: number, inlineObject16: InlineObject16, options?: any): AxiosPromise<void> {
            return OrgsApiFp(configuration).orgUserRoles(userId, orgId, inlineObject16, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates an org
         * @param {number} orgId ID of org to return
         * @param {InlineObject15} [inlineObject15] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrg(orgId: number, inlineObject15?: InlineObject15, options?: any): AxiosPromise<void> {
            return OrgsApiFp(configuration).updateOrg(orgId, inlineObject15, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an org user
         * @param {number} orgId ID of org to return
         * @param {number} userId ID of user to return
         * @param {UserInData} userInData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrgUser(orgId: number, userId: number, userInData: UserInData, options?: any): AxiosPromise<void> {
            return OrgsApiFp(configuration).updateOrgUser(orgId, userId, userInData, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrgsApi - object-oriented interface
 * @export
 * @class OrgsApi
 * @extends {BaseAPI}
 */
export class OrgsApi extends BaseAPI {
    /**
     * 
     * @summary Accepts the terms and conditions
     * @param {number} orgId ID of org to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    public acceptTerms(orgId: number, options?: any) {
        return OrgsApiFp(this.configuration).acceptTerms(orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sends an activation email to the org owner
     * @param {number} orgId ID of org to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    public activateOrg(orgId: number, options?: any) {
        return OrgsApiFp(this.configuration).activateOrg(orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add a new org and admin / user roles
     * @param {InlineObject14} [inlineObject14] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    public addOrg(inlineObject14?: InlineObject14, options?: any) {
        return OrgsApiFp(this.configuration).addOrg(inlineObject14, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create an org user
     * @param {number} orgId ID of org to return
     * @param {UserInData} userInData User object to be created
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    public createOrgUser(orgId: number, userInData: UserInData, options?: any) {
        return OrgsApiFp(this.configuration).createOrgUser(orgId, userInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes an org
     * @param {number} orgId ID of org to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    public deleteOrg(orgId: number, options?: any) {
        return OrgsApiFp(this.configuration).deleteOrg(orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get org alerts
     * @param {number} orgId ID of org to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    public getOrgAlerts(orgId: number, options?: any) {
        return OrgsApiFp(this.configuration).getOrgAlerts(orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Find org by orgId
     * @param {number} orgId ID of org to return
     * @param {Array<string>} [include] comma separated list of additional related objects to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    public getOrgById(orgId: number, include?: Array<string>, options?: any) {
        return OrgsApiFp(this.configuration).getOrgById(orgId, include, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all products with a partner relationship to org
     * @param {number} orgId ID of org to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    public getOrgPartnerProducts(orgId: number, options?: any) {
        return OrgsApiFp(this.configuration).getOrgPartnerProducts(orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all users for a given org
     * @param {number} orgId ID of org to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    public getOrgUsers(orgId: number, options?: any) {
        return OrgsApiFp(this.configuration).getOrgUsers(orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all orgs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    public getOrgs(options?: any) {
        return OrgsApiFp(this.configuration).getOrgs(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the payment methods not currently assigned to the org
     * @param {number} orgId ID of org to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    public orgAdditionalPaymentMethods(orgId: number, options?: any) {
        return OrgsApiFp(this.configuration).orgAdditionalPaymentMethods(orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create or update an org alert and alert subscribers
     * @param {number} orgId ID of org to return
     * @param {AlertInData} alertInData 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    public orgAlertSubscribers(orgId: number, alertInData: AlertInData, options?: any) {
        return OrgsApiFp(this.configuration).orgAlertSubscribers(orgId, alertInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a payment method
     * @param {number} orgId ID of org to return
     * @param {number} paymentMethodId ID of payment method to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    public orgDeletePaymentMethod(orgId: number, paymentMethodId: number, options?: any) {
        return OrgsApiFp(this.configuration).orgDeletePaymentMethod(orgId, paymentMethodId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all billing partner orgs by product type
     * @param {ProductType} productType Type of product to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    public orgGetBillingPartnersByProductType(productType: ProductType, options?: any) {
        return OrgsApiFp(this.configuration).orgGetBillingPartnersByProductType(productType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all partner orgs FTP targets
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    public orgGetFtpTargets(options?: any) {
        return OrgsApiFp(this.configuration).orgGetFtpTargets(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all partner orgs by product type
     * @param {ProductType} productType Type of product to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    public orgGetPartnersByProductType(productType: ProductType, options?: any) {
        return OrgsApiFp(this.configuration).orgGetPartnersByProductType(productType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all partner orgs that are regional councils
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    public orgGetRegionalCouncils(options?: any) {
        return OrgsApiFp(this.configuration).orgGetRegionalCouncils(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary DEPRECATED Creates an install job
     * @param {number} orgId ID of org to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    public orgInstallJob(orgId: number, options?: any) {
        return OrgsApiFp(this.configuration).orgInstallJob(orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all the orgs registered payment methods
     * @param {number} orgId ID of org to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    public orgPaymentMethods(orgId: number, options?: any) {
        return OrgsApiFp(this.configuration).orgPaymentMethods(orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add org access by setting action = attach. Remove org access by setting action = detach.
     * @summary Allocate or deallocate an org role aka org access
     * @param {number} userId ID of user to return
     * @param {number} orgId ID of org to return
     * @param {InlineObject16} inlineObject16 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    public orgUserRoles(userId: number, orgId: number, inlineObject16: InlineObject16, options?: any) {
        return OrgsApiFp(this.configuration).orgUserRoles(userId, orgId, inlineObject16, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates an org
     * @param {number} orgId ID of org to return
     * @param {InlineObject15} [inlineObject15] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    public updateOrg(orgId: number, inlineObject15?: InlineObject15, options?: any) {
        return OrgsApiFp(this.configuration).updateOrg(orgId, inlineObject15, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an org user
     * @param {number} orgId ID of org to return
     * @param {number} userId ID of user to return
     * @param {UserInData} userInData 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    public updateOrgUser(orgId: number, userId: number, userInData: UserInData, options?: any) {
        return OrgsApiFp(this.configuration).updateOrgUser(orgId, userId, userInData, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * PartnerApi - axios parameter creator
 * @export
 */
export const PartnerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Verify pending email address change
         * @param {string} userId user id
         * @param {string} expires Life of link
         * @param {string} signature Signature
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePartnerEmail: async (userId: string, expires: string, signature: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling changePartnerEmail.');
            }
            // verify required parameter 'expires' is not null or undefined
            if (expires === null || expires === undefined) {
                throw new RequiredError('expires','Required parameter expires was null or undefined when calling changePartnerEmail.');
            }
            // verify required parameter 'signature' is not null or undefined
            if (signature === null || signature === undefined) {
                throw new RequiredError('signature','Required parameter signature was null or undefined when calling changePartnerEmail.');
            }
            const localVarPath = `/partner/email-change/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (expires !== undefined) {
                localVarQueryParameter['expires'] = expires;
            }

            if (signature !== undefined) {
                localVarQueryParameter['signature'] = signature;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a partner org user
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {PartnerUserInData} partnerUserInData User object to be created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPartnerUser: async (partnerId: number, partnerUserInData: PartnerUserInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            if (partnerId === null || partnerId === undefined) {
                throw new RequiredError('partnerId','Required parameter partnerId was null or undefined when calling createPartnerUser.');
            }
            // verify required parameter 'partnerUserInData' is not null or undefined
            if (partnerUserInData === null || partnerUserInData === undefined) {
                throw new RequiredError('partnerUserInData','Required parameter partnerUserInData was null or undefined when calling createPartnerUser.');
            }
            const localVarPath = `/partner/{partnerId}/user`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof partnerUserInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(partnerUserInData !== undefined ? partnerUserInData : {}) : (partnerUserInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return pickups for the time period and given list of products
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {number} startTs Start epoch timestamp to consider
         * @param {number} endTs End epoch timestamp to consider
         * @param {ListOfProductIds} [listOfProductIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPartnerCollections: async (partnerId: number, startTs: number, endTs: number, listOfProductIds?: ListOfProductIds, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            if (partnerId === null || partnerId === undefined) {
                throw new RequiredError('partnerId','Required parameter partnerId was null or undefined when calling exportPartnerCollections.');
            }
            // verify required parameter 'startTs' is not null or undefined
            if (startTs === null || startTs === undefined) {
                throw new RequiredError('startTs','Required parameter startTs was null or undefined when calling exportPartnerCollections.');
            }
            // verify required parameter 'endTs' is not null or undefined
            if (endTs === null || endTs === undefined) {
                throw new RequiredError('endTs','Required parameter endTs was null or undefined when calling exportPartnerCollections.');
            }
            const localVarPath = `/partner/{partnerId}/export/collections`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (startTs !== undefined) {
                localVarQueryParameter['startTs'] = startTs;
            }

            if (endTs !== undefined) {
                localVarQueryParameter['endTs'] = endTs;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof listOfProductIds !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(listOfProductIds !== undefined ? listOfProductIds : {}) : (listOfProductIds || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return pickups for the time period and given list of products, grouped by vat
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {number} startTs Start epoch timestamp to consider
         * @param {number} endTs End epoch timestamp to consider
         * @param {ListOfProductIds} [listOfProductIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPartnerCollectionsByVat: async (partnerId: number, startTs: number, endTs: number, listOfProductIds?: ListOfProductIds, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            if (partnerId === null || partnerId === undefined) {
                throw new RequiredError('partnerId','Required parameter partnerId was null or undefined when calling exportPartnerCollectionsByVat.');
            }
            // verify required parameter 'startTs' is not null or undefined
            if (startTs === null || startTs === undefined) {
                throw new RequiredError('startTs','Required parameter startTs was null or undefined when calling exportPartnerCollectionsByVat.');
            }
            // verify required parameter 'endTs' is not null or undefined
            if (endTs === null || endTs === undefined) {
                throw new RequiredError('endTs','Required parameter endTs was null or undefined when calling exportPartnerCollectionsByVat.');
            }
            const localVarPath = `/partner/{partnerId}/export/collectionsByVat`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (startTs !== undefined) {
                localVarQueryParameter['startTs'] = startTs;
            }

            if (endTs !== undefined) {
                localVarQueryParameter['endTs'] = endTs;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof listOfProductIds !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(listOfProductIds !== undefined ? listOfProductIds : {}) : (listOfProductIds || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return current state for the given list of products
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {ListOfProductIds} [listOfProductIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPartnerCurrentState: async (partnerId: number, listOfProductIds?: ListOfProductIds, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            if (partnerId === null || partnerId === undefined) {
                throw new RequiredError('partnerId','Required parameter partnerId was null or undefined when calling exportPartnerCurrentState.');
            }
            const localVarPath = `/partner/{partnerId}/export/currentState`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof listOfProductIds !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(listOfProductIds !== undefined ? listOfProductIds : {}) : (listOfProductIds || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return current vat state for the given list of products
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {ListOfProductIds} [listOfProductIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPartnerCurrentStateByVat: async (partnerId: number, listOfProductIds?: ListOfProductIds, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            if (partnerId === null || partnerId === undefined) {
                throw new RequiredError('partnerId','Required parameter partnerId was null or undefined when calling exportPartnerCurrentStateByVat.');
            }
            const localVarPath = `/partner/{partnerId}/export/currentStateByVat`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof listOfProductIds !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(listOfProductIds !== undefined ? listOfProductIds : {}) : (listOfProductIds || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return milkings the given list of products
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {number} startTs Start epoch timestamp to consider
         * @param {number} endTs End epoch timestamp to consider
         * @param {ListOfProductIds} [listOfProductIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPartnerMilkings: async (partnerId: number, startTs: number, endTs: number, listOfProductIds?: ListOfProductIds, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            if (partnerId === null || partnerId === undefined) {
                throw new RequiredError('partnerId','Required parameter partnerId was null or undefined when calling exportPartnerMilkings.');
            }
            // verify required parameter 'startTs' is not null or undefined
            if (startTs === null || startTs === undefined) {
                throw new RequiredError('startTs','Required parameter startTs was null or undefined when calling exportPartnerMilkings.');
            }
            // verify required parameter 'endTs' is not null or undefined
            if (endTs === null || endTs === undefined) {
                throw new RequiredError('endTs','Required parameter endTs was null or undefined when calling exportPartnerMilkings.');
            }
            const localVarPath = `/partner/{partnerId}/export/milkings`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (startTs !== undefined) {
                localVarQueryParameter['startTs'] = startTs;
            }

            if (endTs !== undefined) {
                localVarQueryParameter['endTs'] = endTs;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof listOfProductIds !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(listOfProductIds !== undefined ? listOfProductIds : {}) : (listOfProductIds || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of partners entities (e.g. vats, tanks) current state data, filtered by body content
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {FilterData} [filterData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterPartnerEntities: async (partnerId: number, filterData?: FilterData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            if (partnerId === null || partnerId === undefined) {
                throw new RequiredError('partnerId','Required parameter partnerId was null or undefined when calling filterPartnerEntities.');
            }
            const localVarPath = `/partner/{partnerId}/entities`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof filterData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(filterData !== undefined ? filterData : {}) : (filterData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of partners products current state data, filtered by body content
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {FilterData} [filterData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterPartnerProducts: async (partnerId: number, filterData?: FilterData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            if (partnerId === null || partnerId === undefined) {
                throw new RequiredError('partnerId','Required parameter partnerId was null or undefined when calling filterPartnerProducts.');
            }
            const localVarPath = `/partner/{partnerId}/products`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof filterData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(filterData !== undefined ? filterData : {}) : (filterData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the partner custom settings definition for a given product and entity type
         * @param {ProductType} productType Type of product to return
         * @param {Entities} entityType Type of entity to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomSettingsDefinitions: async (productType: ProductType, entityType: Entities, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productType' is not null or undefined
            if (productType === null || productType === undefined) {
                throw new RequiredError('productType','Required parameter productType was null or undefined when calling getCustomSettingsDefinitions.');
            }
            // verify required parameter 'entityType' is not null or undefined
            if (entityType === null || entityType === undefined) {
                throw new RequiredError('entityType','Required parameter entityType was null or undefined when calling getCustomSettingsDefinitions.');
            }
            const localVarPath = `/partner/customSettingsDefinition/{productType}/{entityType}`
                .replace(`{${"productType"}}`, encodeURIComponent(String(productType)))
                .replace(`{${"entityType"}}`, encodeURIComponent(String(entityType)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the partner custom settings for a given entity
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {Entities} entityType Type of entity to return
         * @param {number} entityId Id of entity to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityCustomSettings: async (partnerId: number, entityType: Entities, entityId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            if (partnerId === null || partnerId === undefined) {
                throw new RequiredError('partnerId','Required parameter partnerId was null or undefined when calling getEntityCustomSettings.');
            }
            // verify required parameter 'entityType' is not null or undefined
            if (entityType === null || entityType === undefined) {
                throw new RequiredError('entityType','Required parameter entityType was null or undefined when calling getEntityCustomSettings.');
            }
            // verify required parameter 'entityId' is not null or undefined
            if (entityId === null || entityId === undefined) {
                throw new RequiredError('entityId','Required parameter entityId was null or undefined when calling getEntityCustomSettings.');
            }
            const localVarPath = `/partner/{partnerId}/customSettings/{entityType}/{entityId}`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)))
                .replace(`{${"entityType"}}`, encodeURIComponent(String(entityType)))
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the billing contribution tiers agreed by the partner
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {ProductType} productType Type of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerContributionTiers: async (partnerId: number, productType: ProductType, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            if (partnerId === null || partnerId === undefined) {
                throw new RequiredError('partnerId','Required parameter partnerId was null or undefined when calling getPartnerContributionTiers.');
            }
            // verify required parameter 'productType' is not null or undefined
            if (productType === null || productType === undefined) {
                throw new RequiredError('productType','Required parameter productType was null or undefined when calling getPartnerContributionTiers.');
            }
            const localVarPath = `/partner/{partnerId}/contributionTiers/{productType}`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)))
                .replace(`{${"productType"}}`, encodeURIComponent(String(productType)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of partners entities (e.g. vats, tanks) current state data
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerEntities: async (partnerId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            if (partnerId === null || partnerId === undefined) {
                throw new RequiredError('partnerId','Required parameter partnerId was null or undefined when calling getPartnerEntities.');
            }
            const localVarPath = `/partner/{partnerId}/entities`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the list of products recently live
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {ProductType} productType Type of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerNewSites: async (partnerId: number, productType: ProductType, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            if (partnerId === null || partnerId === undefined) {
                throw new RequiredError('partnerId','Required parameter partnerId was null or undefined when calling getPartnerNewSites.');
            }
            // verify required parameter 'productType' is not null or undefined
            if (productType === null || productType === undefined) {
                throw new RequiredError('productType','Required parameter productType was null or undefined when calling getPartnerNewSites.');
            }
            const localVarPath = `/partner/{partnerId}/newSites/{productType}`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)))
                .replace(`{${"productType"}}`, encodeURIComponent(String(productType)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the list of products in pending, install and sign-off status
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {ProductType} productType Type of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerPendingSites: async (partnerId: number, productType: ProductType, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            if (partnerId === null || partnerId === undefined) {
                throw new RequiredError('partnerId','Required parameter partnerId was null or undefined when calling getPartnerPendingSites.');
            }
            // verify required parameter 'productType' is not null or undefined
            if (productType === null || productType === undefined) {
                throw new RequiredError('productType','Required parameter productType was null or undefined when calling getPartnerPendingSites.');
            }
            const localVarPath = `/partner/{partnerId}/pendingSites/{productType}`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)))
                .replace(`{${"productType"}}`, encodeURIComponent(String(productType)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a single product and entities
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerProduct: async (partnerId: number, productId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            if (partnerId === null || partnerId === undefined) {
                throw new RequiredError('partnerId','Required parameter partnerId was null or undefined when calling getPartnerProduct.');
            }
            // verify required parameter 'productId' is not null or undefined
            if (productId === null || productId === undefined) {
                throw new RequiredError('productId','Required parameter productId was null or undefined when calling getPartnerProduct.');
            }
            const localVarPath = `/partner/{partnerId}/product/{productId}`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of partners products current state data
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerProducts: async (partnerId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            if (partnerId === null || partnerId === undefined) {
                throw new RequiredError('partnerId','Required parameter partnerId was null or undefined when calling getPartnerProducts.');
            }
            const localVarPath = `/partner/{partnerId}/products`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all users for a given partner org
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerUsers: async (partnerId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            if (partnerId === null || partnerId === undefined) {
                throw new RequiredError('partnerId','Required parameter partnerId was null or undefined when calling getPartnerUsers.');
            }
            const localVarPath = `/partner/{partnerId}/users`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Logs a partner into the system
         * @param {Login} [login] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginPartner: async (login?: Login, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/partner/login`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof login !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(login !== undefined ? login : {}) : (login || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Logs out the current logged in partner session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutPartner: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/partner/logout`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add a new custom field definition
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {InlineObject19} [inlineObject19] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerAddCustomFieldDefinition: async (partnerId: number, inlineObject19?: InlineObject19, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            if (partnerId === null || partnerId === undefined) {
                throw new RequiredError('partnerId','Required parameter partnerId was null or undefined when calling partnerAddCustomFieldDefinition.');
            }
            const localVarPath = `/partner/{partnerId}/addCustomFieldDefinition`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof inlineObject19 !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(inlineObject19 !== undefined ? inlineObject19 : {}) : (inlineObject19 || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add a new custom field definition for entity
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {Entities} entityType Type of entity to return
         * @param {CustomFieldDefinitionInData} [customFieldDefinitionInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerAddCustomFieldDefinitionForEntity: async (partnerId: number, entityType: Entities, customFieldDefinitionInData?: CustomFieldDefinitionInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            if (partnerId === null || partnerId === undefined) {
                throw new RequiredError('partnerId','Required parameter partnerId was null or undefined when calling partnerAddCustomFieldDefinitionForEntity.');
            }
            // verify required parameter 'entityType' is not null or undefined
            if (entityType === null || entityType === undefined) {
                throw new RequiredError('entityType','Required parameter entityType was null or undefined when calling partnerAddCustomFieldDefinitionForEntity.');
            }
            const localVarPath = `/partner/{partnerId}/addCustomFieldDefinition/{entityType}`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)))
                .replace(`{${"entityType"}}`, encodeURIComponent(String(entityType)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof customFieldDefinitionInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(customFieldDefinitionInData !== undefined ? customFieldDefinitionInData : {}) : (customFieldDefinitionInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add a product to a partner org
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {InlineObject17} [inlineObject17] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerAddProduct: async (partnerId: number, inlineObject17?: InlineObject17, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            if (partnerId === null || partnerId === undefined) {
                throw new RequiredError('partnerId','Required parameter partnerId was null or undefined when calling partnerAddProduct.');
            }
            const localVarPath = `/partner/{partnerId}/addProduct`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof inlineObject17 !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(inlineObject17 !== undefined ? inlineObject17 : {}) : (inlineObject17 || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve the partner orgs customer field definitions
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerCustomFieldDefinitions: async (partnerId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            if (partnerId === null || partnerId === undefined) {
                throw new RequiredError('partnerId','Required parameter partnerId was null or undefined when calling partnerCustomFieldDefinitions.');
            }
            const localVarPath = `/partner/{partnerId}/customFieldDefinitions`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve the partner orgs customer settings
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerCustomSettings: async (partnerId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            if (partnerId === null || partnerId === undefined) {
                throw new RequiredError('partnerId','Required parameter partnerId was null or undefined when calling partnerCustomSettings.');
            }
            const localVarPath = `/partner/{partnerId}/customSettings`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an existing custom field definition
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {InlineObject21} [inlineObject21] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerDeleteCustomFieldDefinition: async (partnerId: number, inlineObject21?: InlineObject21, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            if (partnerId === null || partnerId === undefined) {
                throw new RequiredError('partnerId','Required parameter partnerId was null or undefined when calling partnerDeleteCustomFieldDefinition.');
            }
            const localVarPath = `/partner/{partnerId}/deleteCustomFieldDefinition`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof inlineObject21 !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(inlineObject21 !== undefined ? inlineObject21 : {}) : (inlineObject21 || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an existing custom field definition for entity
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {Entities} entityType Type of entity to return
         * @param {CustomFieldDefinitionInData} [customFieldDefinitionInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerDeleteCustomFieldDefinitionForEntity: async (partnerId: number, entityType: Entities, customFieldDefinitionInData?: CustomFieldDefinitionInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            if (partnerId === null || partnerId === undefined) {
                throw new RequiredError('partnerId','Required parameter partnerId was null or undefined when calling partnerDeleteCustomFieldDefinitionForEntity.');
            }
            // verify required parameter 'entityType' is not null or undefined
            if (entityType === null || entityType === undefined) {
                throw new RequiredError('entityType','Required parameter entityType was null or undefined when calling partnerDeleteCustomFieldDefinitionForEntity.');
            }
            const localVarPath = `/partner/{partnerId}/deleteCustomFieldDefinition/{entityType}`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)))
                .replace(`{${"entityType"}}`, encodeURIComponent(String(entityType)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof customFieldDefinitionInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(customFieldDefinitionInData !== undefined ? customFieldDefinitionInData : {}) : (customFieldDefinitionInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set the comments for an entity
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {Entities} entityType Type of entity to return
         * @param {number} entityId Id of entity to return
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerEntitySetComments: async (partnerId: number, entityType: Entities, entityId: number, body?: object, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            if (partnerId === null || partnerId === undefined) {
                throw new RequiredError('partnerId','Required parameter partnerId was null or undefined when calling partnerEntitySetComments.');
            }
            // verify required parameter 'entityType' is not null or undefined
            if (entityType === null || entityType === undefined) {
                throw new RequiredError('entityType','Required parameter entityType was null or undefined when calling partnerEntitySetComments.');
            }
            // verify required parameter 'entityId' is not null or undefined
            if (entityId === null || entityId === undefined) {
                throw new RequiredError('entityId','Required parameter entityId was null or undefined when calling partnerEntitySetComments.');
            }
            const localVarPath = `/partner/{partnerId}/comments/{entityType}/{entityId}`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)))
                .replace(`{${"entityType"}}`, encodeURIComponent(String(entityType)))
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set the custom field data for an entity
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {Entities} entityType Type of entity to return
         * @param {number} entityId Id of entity to return
         * @param {CustomFieldsInData} [customFieldsInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerEntitySetCustomFieldData: async (partnerId: number, entityType: Entities, entityId: number, customFieldsInData?: CustomFieldsInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            if (partnerId === null || partnerId === undefined) {
                throw new RequiredError('partnerId','Required parameter partnerId was null or undefined when calling partnerEntitySetCustomFieldData.');
            }
            // verify required parameter 'entityType' is not null or undefined
            if (entityType === null || entityType === undefined) {
                throw new RequiredError('entityType','Required parameter entityType was null or undefined when calling partnerEntitySetCustomFieldData.');
            }
            // verify required parameter 'entityId' is not null or undefined
            if (entityId === null || entityId === undefined) {
                throw new RequiredError('entityId','Required parameter entityId was null or undefined when calling partnerEntitySetCustomFieldData.');
            }
            const localVarPath = `/partner/{partnerId}/customFieldData/{entityType}/{entityId}`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)))
                .replace(`{${"entityType"}}`, encodeURIComponent(String(entityType)))
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof customFieldsInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(customFieldsInData !== undefined ? customFieldsInData : {}) : (customFieldsInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set the custom settings data for an entity
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {Entities} entityType Type of entity to return
         * @param {number} entityId Id of entity to return
         * @param {CustomSettingInData} [customSettingInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerEntitySetCustomSettingsData: async (partnerId: number, entityType: Entities, entityId: number, customSettingInData?: CustomSettingInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            if (partnerId === null || partnerId === undefined) {
                throw new RequiredError('partnerId','Required parameter partnerId was null or undefined when calling partnerEntitySetCustomSettingsData.');
            }
            // verify required parameter 'entityType' is not null or undefined
            if (entityType === null || entityType === undefined) {
                throw new RequiredError('entityType','Required parameter entityType was null or undefined when calling partnerEntitySetCustomSettingsData.');
            }
            // verify required parameter 'entityId' is not null or undefined
            if (entityId === null || entityId === undefined) {
                throw new RequiredError('entityId','Required parameter entityId was null or undefined when calling partnerEntitySetCustomSettingsData.');
            }
            const localVarPath = `/partner/{partnerId}/customSettingsData/{entityType}/{entityId}`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)))
                .replace(`{${"entityType"}}`, encodeURIComponent(String(entityType)))
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof customSettingInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(customSettingInData !== undefined ? customSettingInData : {}) : (customSettingInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set the custom field data for a product
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {number} productId ID of product to return
         * @param {CustomFieldsInData} [customFieldsInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerProductSetCustomFieldData: async (partnerId: number, productId: number, customFieldsInData?: CustomFieldsInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            if (partnerId === null || partnerId === undefined) {
                throw new RequiredError('partnerId','Required parameter partnerId was null or undefined when calling partnerProductSetCustomFieldData.');
            }
            // verify required parameter 'productId' is not null or undefined
            if (productId === null || productId === undefined) {
                throw new RequiredError('productId','Required parameter productId was null or undefined when calling partnerProductSetCustomFieldData.');
            }
            const localVarPath = `/partner/{partnerId}/customFieldData/{productId}`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof customFieldsInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(customFieldsInData !== undefined ? customFieldsInData : {}) : (customFieldsInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove a product from a partner org
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {InlineObject18} [inlineObject18] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerRemoveProduct: async (partnerId: number, inlineObject18?: InlineObject18, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            if (partnerId === null || partnerId === undefined) {
                throw new RequiredError('partnerId','Required parameter partnerId was null or undefined when calling partnerRemoveProduct.');
            }
            const localVarPath = `/partner/{partnerId}/removeProduct`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof inlineObject18 !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(inlineObject18 !== undefined ? inlineObject18 : {}) : (inlineObject18 || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an existing custom field definition
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {InlineObject20} [inlineObject20] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerUpdateCustomFieldDefinition: async (partnerId: number, inlineObject20?: InlineObject20, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            if (partnerId === null || partnerId === undefined) {
                throw new RequiredError('partnerId','Required parameter partnerId was null or undefined when calling partnerUpdateCustomFieldDefinition.');
            }
            const localVarPath = `/partner/{partnerId}/updateCustomFieldDefinition`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof inlineObject20 !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(inlineObject20 !== undefined ? inlineObject20 : {}) : (inlineObject20 || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an existing custom field definition for entity
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {Entities} entityType Type of entity to return
         * @param {CustomFieldDefinitionInData} [customFieldDefinitionInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerUpdateCustomFieldDefinitionForEntity: async (partnerId: number, entityType: Entities, customFieldDefinitionInData?: CustomFieldDefinitionInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            if (partnerId === null || partnerId === undefined) {
                throw new RequiredError('partnerId','Required parameter partnerId was null or undefined when calling partnerUpdateCustomFieldDefinitionForEntity.');
            }
            // verify required parameter 'entityType' is not null or undefined
            if (entityType === null || entityType === undefined) {
                throw new RequiredError('entityType','Required parameter entityType was null or undefined when calling partnerUpdateCustomFieldDefinitionForEntity.');
            }
            const localVarPath = `/partner/{partnerId}/updateCustomFieldDefinition/{entityType}`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)))
                .replace(`{${"entityType"}}`, encodeURIComponent(String(entityType)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof customFieldDefinitionInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(customFieldDefinitionInData !== undefined ? customFieldDefinitionInData : {}) : (customFieldDefinitionInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an custom setting for entity
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {Entities} entityType Type of entity to return
         * @param {CustomSettingInData} [customSettingInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerUpdateCustomSettingForEntity: async (partnerId: number, entityType: Entities, customSettingInData?: CustomSettingInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            if (partnerId === null || partnerId === undefined) {
                throw new RequiredError('partnerId','Required parameter partnerId was null or undefined when calling partnerUpdateCustomSettingForEntity.');
            }
            // verify required parameter 'entityType' is not null or undefined
            if (entityType === null || entityType === undefined) {
                throw new RequiredError('entityType','Required parameter entityType was null or undefined when calling partnerUpdateCustomSettingForEntity.');
            }
            const localVarPath = `/partner/{partnerId}/updateCustomSetting/{entityType}`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)))
                .replace(`{${"entityType"}}`, encodeURIComponent(String(entityType)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof customSettingInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(customSettingInData !== undefined ? customSettingInData : {}) : (customSettingInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set the partner custom settings for a given entity
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {Entities} entityType Type of entity to return
         * @param {number} entityId Id of entity to return
         * @param {InlineObject24} [inlineObject24] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setEntityCustomSettings: async (partnerId: number, entityType: Entities, entityId: number, inlineObject24?: InlineObject24, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            if (partnerId === null || partnerId === undefined) {
                throw new RequiredError('partnerId','Required parameter partnerId was null or undefined when calling setEntityCustomSettings.');
            }
            // verify required parameter 'entityType' is not null or undefined
            if (entityType === null || entityType === undefined) {
                throw new RequiredError('entityType','Required parameter entityType was null or undefined when calling setEntityCustomSettings.');
            }
            // verify required parameter 'entityId' is not null or undefined
            if (entityId === null || entityId === undefined) {
                throw new RequiredError('entityId','Required parameter entityId was null or undefined when calling setEntityCustomSettings.');
            }
            const localVarPath = `/partner/{partnerId}/customSettings/{entityType}/{entityId}`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)))
                .replace(`{${"entityType"}}`, encodeURIComponent(String(entityType)))
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof inlineObject24 !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(inlineObject24 !== undefined ? inlineObject24 : {}) : (inlineObject24 || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set the id of the entity as defined by the partner
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {Entities} entityType Type of entity to return
         * @param {number} entityId Id of entity to return
         * @param {InlineObject22} [inlineObject22] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPartnerDefinedId: async (partnerId: number, entityType: Entities, entityId: number, inlineObject22?: InlineObject22, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            if (partnerId === null || partnerId === undefined) {
                throw new RequiredError('partnerId','Required parameter partnerId was null or undefined when calling setPartnerDefinedId.');
            }
            // verify required parameter 'entityType' is not null or undefined
            if (entityType === null || entityType === undefined) {
                throw new RequiredError('entityType','Required parameter entityType was null or undefined when calling setPartnerDefinedId.');
            }
            // verify required parameter 'entityId' is not null or undefined
            if (entityId === null || entityId === undefined) {
                throw new RequiredError('entityId','Required parameter entityId was null or undefined when calling setPartnerDefinedId.');
            }
            const localVarPath = `/partner/{partnerId}/id/{entityType}/{entityId}`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)))
                .replace(`{${"entityType"}}`, encodeURIComponent(String(entityType)))
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof inlineObject22 !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(inlineObject22 !== undefined ? inlineObject22 : {}) : (inlineObject22 || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set the name of the entity as defined by the partner
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {Entities} entityType Type of entity to return
         * @param {number} entityId Id of entity to return
         * @param {InlineObject23} [inlineObject23] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPartnerDefinedName: async (partnerId: number, entityType: Entities, entityId: number, inlineObject23?: InlineObject23, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            if (partnerId === null || partnerId === undefined) {
                throw new RequiredError('partnerId','Required parameter partnerId was null or undefined when calling setPartnerDefinedName.');
            }
            // verify required parameter 'entityType' is not null or undefined
            if (entityType === null || entityType === undefined) {
                throw new RequiredError('entityType','Required parameter entityType was null or undefined when calling setPartnerDefinedName.');
            }
            // verify required parameter 'entityId' is not null or undefined
            if (entityId === null || entityId === undefined) {
                throw new RequiredError('entityId','Required parameter entityId was null or undefined when calling setPartnerDefinedName.');
            }
            const localVarPath = `/partner/{partnerId}/name/{entityType}/{entityId}`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)))
                .replace(`{${"entityType"}}`, encodeURIComponent(String(entityType)))
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof inlineObject23 !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(inlineObject23 !== undefined ? inlineObject23 : {}) : (inlineObject23 || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a partner org user
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {number} userId ID of user to return
         * @param {PartnerUserInData} partnerUserInData User object to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePartnerUser: async (partnerId: number, userId: number, partnerUserInData: PartnerUserInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            if (partnerId === null || partnerId === undefined) {
                throw new RequiredError('partnerId','Required parameter partnerId was null or undefined when calling updatePartnerUser.');
            }
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling updatePartnerUser.');
            }
            // verify required parameter 'partnerUserInData' is not null or undefined
            if (partnerUserInData === null || partnerUserInData === undefined) {
                throw new RequiredError('partnerUserInData','Required parameter partnerUserInData was null or undefined when calling updatePartnerUser.');
            }
            const localVarPath = `/partner/{partnerId}/user/{userId}`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof partnerUserInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(partnerUserInData !== undefined ? partnerUserInData : {}) : (partnerUserInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Signed Verification of User Email Address
         * @param {number} userId userId
         * @param {string} expires Activation code
         * @param {string} signature Signature
         * @param {PartnerUser} [partnerUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyPartnerEmail: async (userId: number, expires: string, signature: string, partnerUser?: PartnerUser, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling verifyPartnerEmail.');
            }
            // verify required parameter 'expires' is not null or undefined
            if (expires === null || expires === undefined) {
                throw new RequiredError('expires','Required parameter expires was null or undefined when calling verifyPartnerEmail.');
            }
            // verify required parameter 'signature' is not null or undefined
            if (signature === null || signature === undefined) {
                throw new RequiredError('signature','Required parameter signature was null or undefined when calling verifyPartnerEmail.');
            }
            const localVarPath = `/partner/setup-account/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (expires !== undefined) {
                localVarQueryParameter['expires'] = expires;
            }

            if (signature !== undefined) {
                localVarQueryParameter['signature'] = signature;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof partnerUser !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(partnerUser !== undefined ? partnerUser : {}) : (partnerUser || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PartnerApi - functional programming interface
 * @export
 */
export const PartnerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Verify pending email address change
         * @param {string} userId user id
         * @param {string} expires Life of link
         * @param {string} signature Signature
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changePartnerEmail(userId: string, expires: string, signature: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20017>> {
            const localVarAxiosArgs = await PartnerApiAxiosParamCreator(configuration).changePartnerEmail(userId, expires, signature, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Create a partner org user
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {PartnerUserInData} partnerUserInData User object to be created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPartnerUser(partnerId: number, partnerUserInData: PartnerUserInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserInData>> {
            const localVarAxiosArgs = await PartnerApiAxiosParamCreator(configuration).createPartnerUser(partnerId, partnerUserInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return pickups for the time period and given list of products
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {number} startTs Start epoch timestamp to consider
         * @param {number} endTs End epoch timestamp to consider
         * @param {ListOfProductIds} [listOfProductIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportPartnerCollections(partnerId: number, startTs: number, endTs: number, listOfProductIds?: ListOfProductIds, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Collection>>> {
            const localVarAxiosArgs = await PartnerApiAxiosParamCreator(configuration).exportPartnerCollections(partnerId, startTs, endTs, listOfProductIds, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return pickups for the time period and given list of products, grouped by vat
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {number} startTs Start epoch timestamp to consider
         * @param {number} endTs End epoch timestamp to consider
         * @param {ListOfProductIds} [listOfProductIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportPartnerCollectionsByVat(partnerId: number, startTs: number, endTs: number, listOfProductIds?: ListOfProductIds, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VatCollection>>> {
            const localVarAxiosArgs = await PartnerApiAxiosParamCreator(configuration).exportPartnerCollectionsByVat(partnerId, startTs, endTs, listOfProductIds, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return current state for the given list of products
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {ListOfProductIds} [listOfProductIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportPartnerCurrentState(partnerId: number, listOfProductIds?: ListOfProductIds, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CurrentState>>> {
            const localVarAxiosArgs = await PartnerApiAxiosParamCreator(configuration).exportPartnerCurrentState(partnerId, listOfProductIds, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return current vat state for the given list of products
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {ListOfProductIds} [listOfProductIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportPartnerCurrentStateByVat(partnerId: number, listOfProductIds?: ListOfProductIds, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CurrentStateByVat>>> {
            const localVarAxiosArgs = await PartnerApiAxiosParamCreator(configuration).exportPartnerCurrentStateByVat(partnerId, listOfProductIds, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return milkings the given list of products
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {number} startTs Start epoch timestamp to consider
         * @param {number} endTs End epoch timestamp to consider
         * @param {ListOfProductIds} [listOfProductIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportPartnerMilkings(partnerId: number, startTs: number, endTs: number, listOfProductIds?: ListOfProductIds, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Milkings>>> {
            const localVarAxiosArgs = await PartnerApiAxiosParamCreator(configuration).exportPartnerMilkings(partnerId, startTs, endTs, listOfProductIds, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get list of partners entities (e.g. vats, tanks) current state data, filtered by body content
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {FilterData} [filterData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filterPartnerEntities(partnerId: number, filterData?: FilterData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityCurrentStateInData>> {
            const localVarAxiosArgs = await PartnerApiAxiosParamCreator(configuration).filterPartnerEntities(partnerId, filterData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get list of partners products current state data, filtered by body content
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {FilterData} [filterData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filterPartnerProducts(partnerId: number, filterData?: FilterData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductCurrentStateInData>> {
            const localVarAxiosArgs = await PartnerApiAxiosParamCreator(configuration).filterPartnerProducts(partnerId, filterData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get the partner custom settings definition for a given product and entity type
         * @param {ProductType} productType Type of product to return
         * @param {Entities} entityType Type of entity to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomSettingsDefinitions(productType: ProductType, entityType: Entities, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20018>> {
            const localVarAxiosArgs = await PartnerApiAxiosParamCreator(configuration).getCustomSettingsDefinitions(productType, entityType, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get the partner custom settings for a given entity
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {Entities} entityType Type of entity to return
         * @param {number} entityId Id of entity to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityCustomSettings(partnerId: number, entityType: Entities, entityId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20018>> {
            const localVarAxiosArgs = await PartnerApiAxiosParamCreator(configuration).getEntityCustomSettings(partnerId, entityType, entityId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get the billing contribution tiers agreed by the partner
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {ProductType} productType Type of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPartnerContributionTiers(partnerId: number, productType: ProductType, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnerContributionTiersInData>> {
            const localVarAxiosArgs = await PartnerApiAxiosParamCreator(configuration).getPartnerContributionTiers(partnerId, productType, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get list of partners entities (e.g. vats, tanks) current state data
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPartnerEntities(partnerId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityCurrentStateInData>> {
            const localVarAxiosArgs = await PartnerApiAxiosParamCreator(configuration).getPartnerEntities(partnerId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get the list of products recently live
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {ProductType} productType Type of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPartnerNewSites(partnerId: number, productType: ProductType, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnerNewSitesInData>> {
            const localVarAxiosArgs = await PartnerApiAxiosParamCreator(configuration).getPartnerNewSites(partnerId, productType, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get the list of products in pending, install and sign-off status
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {ProductType} productType Type of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPartnerPendingSites(partnerId: number, productType: ProductType, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnerPendingSitesInData>> {
            const localVarAxiosArgs = await PartnerApiAxiosParamCreator(configuration).getPartnerPendingSites(partnerId, productType, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get a single product and entities
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPartnerProduct(partnerId: number, productId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntityCurrentState>>> {
            const localVarAxiosArgs = await PartnerApiAxiosParamCreator(configuration).getPartnerProduct(partnerId, productId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get list of partners products current state data
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPartnerProducts(partnerId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductCurrentStateInData>> {
            const localVarAxiosArgs = await PartnerApiAxiosParamCreator(configuration).getPartnerProducts(partnerId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get all users for a given partner org
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPartnerUsers(partnerId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsersInData>> {
            const localVarAxiosArgs = await PartnerApiAxiosParamCreator(configuration).getPartnerUsers(partnerId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Logs a partner into the system
         * @param {Login} [login] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginPartner(login?: Login, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenResponsePartner>> {
            const localVarAxiosArgs = await PartnerApiAxiosParamCreator(configuration).loginPartner(login, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Logs out the current logged in partner session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logoutPartner(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await PartnerApiAxiosParamCreator(configuration).logoutPartner(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Add a new custom field definition
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {InlineObject19} [inlineObject19] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnerAddCustomFieldDefinition(partnerId: number, inlineObject19?: InlineObject19, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2012>> {
            const localVarAxiosArgs = await PartnerApiAxiosParamCreator(configuration).partnerAddCustomFieldDefinition(partnerId, inlineObject19, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Add a new custom field definition for entity
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {Entities} entityType Type of entity to return
         * @param {CustomFieldDefinitionInData} [customFieldDefinitionInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnerAddCustomFieldDefinitionForEntity(partnerId: number, entityType: Entities, customFieldDefinitionInData?: CustomFieldDefinitionInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomFieldDefinitionByEntityInData>> {
            const localVarAxiosArgs = await PartnerApiAxiosParamCreator(configuration).partnerAddCustomFieldDefinitionForEntity(partnerId, entityType, customFieldDefinitionInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Add a product to a partner org
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {InlineObject17} [inlineObject17] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnerAddProduct(partnerId: number, inlineObject17?: InlineObject17, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2011>> {
            const localVarAxiosArgs = await PartnerApiAxiosParamCreator(configuration).partnerAddProduct(partnerId, inlineObject17, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Retrieve the partner orgs customer field definitions
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnerCustomFieldDefinitions(partnerId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomFieldDefinitionByEntityInData>> {
            const localVarAxiosArgs = await PartnerApiAxiosParamCreator(configuration).partnerCustomFieldDefinitions(partnerId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Retrieve the partner orgs customer settings
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnerCustomSettings(partnerId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomSettingsByEntityInData>> {
            const localVarAxiosArgs = await PartnerApiAxiosParamCreator(configuration).partnerCustomSettings(partnerId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Delete an existing custom field definition
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {InlineObject21} [inlineObject21] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnerDeleteCustomFieldDefinition(partnerId: number, inlineObject21?: InlineObject21, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2012>> {
            const localVarAxiosArgs = await PartnerApiAxiosParamCreator(configuration).partnerDeleteCustomFieldDefinition(partnerId, inlineObject21, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Delete an existing custom field definition for entity
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {Entities} entityType Type of entity to return
         * @param {CustomFieldDefinitionInData} [customFieldDefinitionInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnerDeleteCustomFieldDefinitionForEntity(partnerId: number, entityType: Entities, customFieldDefinitionInData?: CustomFieldDefinitionInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomFieldDefinitionByEntityInData>> {
            const localVarAxiosArgs = await PartnerApiAxiosParamCreator(configuration).partnerDeleteCustomFieldDefinitionForEntity(partnerId, entityType, customFieldDefinitionInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Set the comments for an entity
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {Entities} entityType Type of entity to return
         * @param {number} entityId Id of entity to return
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnerEntitySetComments(partnerId: number, entityType: Entities, entityId: number, body?: object, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2014>> {
            const localVarAxiosArgs = await PartnerApiAxiosParamCreator(configuration).partnerEntitySetComments(partnerId, entityType, entityId, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Set the custom field data for an entity
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {Entities} entityType Type of entity to return
         * @param {number} entityId Id of entity to return
         * @param {CustomFieldsInData} [customFieldsInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnerEntitySetCustomFieldData(partnerId: number, entityType: Entities, entityId: number, customFieldsInData?: CustomFieldsInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2014>> {
            const localVarAxiosArgs = await PartnerApiAxiosParamCreator(configuration).partnerEntitySetCustomFieldData(partnerId, entityType, entityId, customFieldsInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Set the custom settings data for an entity
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {Entities} entityType Type of entity to return
         * @param {number} entityId Id of entity to return
         * @param {CustomSettingInData} [customSettingInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnerEntitySetCustomSettingsData(partnerId: number, entityType: Entities, entityId: number, customSettingInData?: CustomSettingInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2014>> {
            const localVarAxiosArgs = await PartnerApiAxiosParamCreator(configuration).partnerEntitySetCustomSettingsData(partnerId, entityType, entityId, customSettingInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Set the custom field data for a product
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {number} productId ID of product to return
         * @param {CustomFieldsInData} [customFieldsInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnerProductSetCustomFieldData(partnerId: number, productId: number, customFieldsInData?: CustomFieldsInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2013>> {
            const localVarAxiosArgs = await PartnerApiAxiosParamCreator(configuration).partnerProductSetCustomFieldData(partnerId, productId, customFieldsInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Remove a product from a partner org
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {InlineObject18} [inlineObject18] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnerRemoveProduct(partnerId: number, inlineObject18?: InlineObject18, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20016>> {
            const localVarAxiosArgs = await PartnerApiAxiosParamCreator(configuration).partnerRemoveProduct(partnerId, inlineObject18, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update an existing custom field definition
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {InlineObject20} [inlineObject20] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnerUpdateCustomFieldDefinition(partnerId: number, inlineObject20?: InlineObject20, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2012>> {
            const localVarAxiosArgs = await PartnerApiAxiosParamCreator(configuration).partnerUpdateCustomFieldDefinition(partnerId, inlineObject20, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update an existing custom field definition for entity
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {Entities} entityType Type of entity to return
         * @param {CustomFieldDefinitionInData} [customFieldDefinitionInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnerUpdateCustomFieldDefinitionForEntity(partnerId: number, entityType: Entities, customFieldDefinitionInData?: CustomFieldDefinitionInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomFieldDefinitionByEntityInData>> {
            const localVarAxiosArgs = await PartnerApiAxiosParamCreator(configuration).partnerUpdateCustomFieldDefinitionForEntity(partnerId, entityType, customFieldDefinitionInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update an custom setting for entity
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {Entities} entityType Type of entity to return
         * @param {CustomSettingInData} [customSettingInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnerUpdateCustomSettingForEntity(partnerId: number, entityType: Entities, customSettingInData?: CustomSettingInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomSettingsByEntityInData>> {
            const localVarAxiosArgs = await PartnerApiAxiosParamCreator(configuration).partnerUpdateCustomSettingForEntity(partnerId, entityType, customSettingInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Set the partner custom settings for a given entity
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {Entities} entityType Type of entity to return
         * @param {number} entityId Id of entity to return
         * @param {InlineObject24} [inlineObject24] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setEntityCustomSettings(partnerId: number, entityType: Entities, entityId: number, inlineObject24?: InlineObject24, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20018>> {
            const localVarAxiosArgs = await PartnerApiAxiosParamCreator(configuration).setEntityCustomSettings(partnerId, entityType, entityId, inlineObject24, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Set the id of the entity as defined by the partner
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {Entities} entityType Type of entity to return
         * @param {number} entityId Id of entity to return
         * @param {InlineObject22} [inlineObject22] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setPartnerDefinedId(partnerId: number, entityType: Entities, entityId: number, inlineObject22?: InlineObject22, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2014>> {
            const localVarAxiosArgs = await PartnerApiAxiosParamCreator(configuration).setPartnerDefinedId(partnerId, entityType, entityId, inlineObject22, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Set the name of the entity as defined by the partner
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {Entities} entityType Type of entity to return
         * @param {number} entityId Id of entity to return
         * @param {InlineObject23} [inlineObject23] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setPartnerDefinedName(partnerId: number, entityType: Entities, entityId: number, inlineObject23?: InlineObject23, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2014>> {
            const localVarAxiosArgs = await PartnerApiAxiosParamCreator(configuration).setPartnerDefinedName(partnerId, entityType, entityId, inlineObject23, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update a partner org user
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {number} userId ID of user to return
         * @param {PartnerUserInData} partnerUserInData User object to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePartnerUser(partnerId: number, userId: number, partnerUserInData: PartnerUserInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserInData>> {
            const localVarAxiosArgs = await PartnerApiAxiosParamCreator(configuration).updatePartnerUser(partnerId, userId, partnerUserInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Signed Verification of User Email Address
         * @param {number} userId userId
         * @param {string} expires Activation code
         * @param {string} signature Signature
         * @param {PartnerUser} [partnerUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyPartnerEmail(userId: number, expires: string, signature: string, partnerUser?: PartnerUser, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenResponsePartner>> {
            const localVarAxiosArgs = await PartnerApiAxiosParamCreator(configuration).verifyPartnerEmail(userId, expires, signature, partnerUser, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * PartnerApi - factory interface
 * @export
 */
export const PartnerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Verify pending email address change
         * @param {string} userId user id
         * @param {string} expires Life of link
         * @param {string} signature Signature
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePartnerEmail(userId: string, expires: string, signature: string, options?: any): AxiosPromise<InlineResponse20017> {
            return PartnerApiFp(configuration).changePartnerEmail(userId, expires, signature, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a partner org user
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {PartnerUserInData} partnerUserInData User object to be created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPartnerUser(partnerId: number, partnerUserInData: PartnerUserInData, options?: any): AxiosPromise<UserInData> {
            return PartnerApiFp(configuration).createPartnerUser(partnerId, partnerUserInData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return pickups for the time period and given list of products
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {number} startTs Start epoch timestamp to consider
         * @param {number} endTs End epoch timestamp to consider
         * @param {ListOfProductIds} [listOfProductIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPartnerCollections(partnerId: number, startTs: number, endTs: number, listOfProductIds?: ListOfProductIds, options?: any): AxiosPromise<Array<Collection>> {
            return PartnerApiFp(configuration).exportPartnerCollections(partnerId, startTs, endTs, listOfProductIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return pickups for the time period and given list of products, grouped by vat
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {number} startTs Start epoch timestamp to consider
         * @param {number} endTs End epoch timestamp to consider
         * @param {ListOfProductIds} [listOfProductIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPartnerCollectionsByVat(partnerId: number, startTs: number, endTs: number, listOfProductIds?: ListOfProductIds, options?: any): AxiosPromise<Array<VatCollection>> {
            return PartnerApiFp(configuration).exportPartnerCollectionsByVat(partnerId, startTs, endTs, listOfProductIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return current state for the given list of products
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {ListOfProductIds} [listOfProductIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPartnerCurrentState(partnerId: number, listOfProductIds?: ListOfProductIds, options?: any): AxiosPromise<Array<CurrentState>> {
            return PartnerApiFp(configuration).exportPartnerCurrentState(partnerId, listOfProductIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return current vat state for the given list of products
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {ListOfProductIds} [listOfProductIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPartnerCurrentStateByVat(partnerId: number, listOfProductIds?: ListOfProductIds, options?: any): AxiosPromise<Array<CurrentStateByVat>> {
            return PartnerApiFp(configuration).exportPartnerCurrentStateByVat(partnerId, listOfProductIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return milkings the given list of products
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {number} startTs Start epoch timestamp to consider
         * @param {number} endTs End epoch timestamp to consider
         * @param {ListOfProductIds} [listOfProductIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPartnerMilkings(partnerId: number, startTs: number, endTs: number, listOfProductIds?: ListOfProductIds, options?: any): AxiosPromise<Array<Milkings>> {
            return PartnerApiFp(configuration).exportPartnerMilkings(partnerId, startTs, endTs, listOfProductIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of partners entities (e.g. vats, tanks) current state data, filtered by body content
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {FilterData} [filterData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterPartnerEntities(partnerId: number, filterData?: FilterData, options?: any): AxiosPromise<EntityCurrentStateInData> {
            return PartnerApiFp(configuration).filterPartnerEntities(partnerId, filterData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of partners products current state data, filtered by body content
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {FilterData} [filterData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterPartnerProducts(partnerId: number, filterData?: FilterData, options?: any): AxiosPromise<ProductCurrentStateInData> {
            return PartnerApiFp(configuration).filterPartnerProducts(partnerId, filterData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the partner custom settings definition for a given product and entity type
         * @param {ProductType} productType Type of product to return
         * @param {Entities} entityType Type of entity to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomSettingsDefinitions(productType: ProductType, entityType: Entities, options?: any): AxiosPromise<InlineResponse20018> {
            return PartnerApiFp(configuration).getCustomSettingsDefinitions(productType, entityType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the partner custom settings for a given entity
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {Entities} entityType Type of entity to return
         * @param {number} entityId Id of entity to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityCustomSettings(partnerId: number, entityType: Entities, entityId: number, options?: any): AxiosPromise<InlineResponse20018> {
            return PartnerApiFp(configuration).getEntityCustomSettings(partnerId, entityType, entityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the billing contribution tiers agreed by the partner
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {ProductType} productType Type of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerContributionTiers(partnerId: number, productType: ProductType, options?: any): AxiosPromise<PartnerContributionTiersInData> {
            return PartnerApiFp(configuration).getPartnerContributionTiers(partnerId, productType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of partners entities (e.g. vats, tanks) current state data
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerEntities(partnerId: number, options?: any): AxiosPromise<EntityCurrentStateInData> {
            return PartnerApiFp(configuration).getPartnerEntities(partnerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the list of products recently live
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {ProductType} productType Type of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerNewSites(partnerId: number, productType: ProductType, options?: any): AxiosPromise<PartnerNewSitesInData> {
            return PartnerApiFp(configuration).getPartnerNewSites(partnerId, productType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the list of products in pending, install and sign-off status
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {ProductType} productType Type of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerPendingSites(partnerId: number, productType: ProductType, options?: any): AxiosPromise<PartnerPendingSitesInData> {
            return PartnerApiFp(configuration).getPartnerPendingSites(partnerId, productType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a single product and entities
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerProduct(partnerId: number, productId: number, options?: any): AxiosPromise<Array<EntityCurrentState>> {
            return PartnerApiFp(configuration).getPartnerProduct(partnerId, productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of partners products current state data
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerProducts(partnerId: number, options?: any): AxiosPromise<ProductCurrentStateInData> {
            return PartnerApiFp(configuration).getPartnerProducts(partnerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all users for a given partner org
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerUsers(partnerId: number, options?: any): AxiosPromise<UsersInData> {
            return PartnerApiFp(configuration).getPartnerUsers(partnerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Logs a partner into the system
         * @param {Login} [login] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginPartner(login?: Login, options?: any): AxiosPromise<TokenResponsePartner> {
            return PartnerApiFp(configuration).loginPartner(login, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Logs out the current logged in partner session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutPartner(options?: any): AxiosPromise<InlineResponse200> {
            return PartnerApiFp(configuration).logoutPartner(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add a new custom field definition
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {InlineObject19} [inlineObject19] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerAddCustomFieldDefinition(partnerId: number, inlineObject19?: InlineObject19, options?: any): AxiosPromise<InlineResponse2012> {
            return PartnerApiFp(configuration).partnerAddCustomFieldDefinition(partnerId, inlineObject19, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add a new custom field definition for entity
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {Entities} entityType Type of entity to return
         * @param {CustomFieldDefinitionInData} [customFieldDefinitionInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerAddCustomFieldDefinitionForEntity(partnerId: number, entityType: Entities, customFieldDefinitionInData?: CustomFieldDefinitionInData, options?: any): AxiosPromise<CustomFieldDefinitionByEntityInData> {
            return PartnerApiFp(configuration).partnerAddCustomFieldDefinitionForEntity(partnerId, entityType, customFieldDefinitionInData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add a product to a partner org
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {InlineObject17} [inlineObject17] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerAddProduct(partnerId: number, inlineObject17?: InlineObject17, options?: any): AxiosPromise<InlineResponse2011> {
            return PartnerApiFp(configuration).partnerAddProduct(partnerId, inlineObject17, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve the partner orgs customer field definitions
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerCustomFieldDefinitions(partnerId: number, options?: any): AxiosPromise<CustomFieldDefinitionByEntityInData> {
            return PartnerApiFp(configuration).partnerCustomFieldDefinitions(partnerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve the partner orgs customer settings
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerCustomSettings(partnerId: number, options?: any): AxiosPromise<CustomSettingsByEntityInData> {
            return PartnerApiFp(configuration).partnerCustomSettings(partnerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an existing custom field definition
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {InlineObject21} [inlineObject21] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerDeleteCustomFieldDefinition(partnerId: number, inlineObject21?: InlineObject21, options?: any): AxiosPromise<InlineResponse2012> {
            return PartnerApiFp(configuration).partnerDeleteCustomFieldDefinition(partnerId, inlineObject21, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an existing custom field definition for entity
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {Entities} entityType Type of entity to return
         * @param {CustomFieldDefinitionInData} [customFieldDefinitionInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerDeleteCustomFieldDefinitionForEntity(partnerId: number, entityType: Entities, customFieldDefinitionInData?: CustomFieldDefinitionInData, options?: any): AxiosPromise<CustomFieldDefinitionByEntityInData> {
            return PartnerApiFp(configuration).partnerDeleteCustomFieldDefinitionForEntity(partnerId, entityType, customFieldDefinitionInData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set the comments for an entity
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {Entities} entityType Type of entity to return
         * @param {number} entityId Id of entity to return
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerEntitySetComments(partnerId: number, entityType: Entities, entityId: number, body?: object, options?: any): AxiosPromise<InlineResponse2014> {
            return PartnerApiFp(configuration).partnerEntitySetComments(partnerId, entityType, entityId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set the custom field data for an entity
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {Entities} entityType Type of entity to return
         * @param {number} entityId Id of entity to return
         * @param {CustomFieldsInData} [customFieldsInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerEntitySetCustomFieldData(partnerId: number, entityType: Entities, entityId: number, customFieldsInData?: CustomFieldsInData, options?: any): AxiosPromise<InlineResponse2014> {
            return PartnerApiFp(configuration).partnerEntitySetCustomFieldData(partnerId, entityType, entityId, customFieldsInData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set the custom settings data for an entity
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {Entities} entityType Type of entity to return
         * @param {number} entityId Id of entity to return
         * @param {CustomSettingInData} [customSettingInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerEntitySetCustomSettingsData(partnerId: number, entityType: Entities, entityId: number, customSettingInData?: CustomSettingInData, options?: any): AxiosPromise<InlineResponse2014> {
            return PartnerApiFp(configuration).partnerEntitySetCustomSettingsData(partnerId, entityType, entityId, customSettingInData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set the custom field data for a product
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {number} productId ID of product to return
         * @param {CustomFieldsInData} [customFieldsInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerProductSetCustomFieldData(partnerId: number, productId: number, customFieldsInData?: CustomFieldsInData, options?: any): AxiosPromise<InlineResponse2013> {
            return PartnerApiFp(configuration).partnerProductSetCustomFieldData(partnerId, productId, customFieldsInData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove a product from a partner org
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {InlineObject18} [inlineObject18] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerRemoveProduct(partnerId: number, inlineObject18?: InlineObject18, options?: any): AxiosPromise<InlineResponse20016> {
            return PartnerApiFp(configuration).partnerRemoveProduct(partnerId, inlineObject18, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an existing custom field definition
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {InlineObject20} [inlineObject20] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerUpdateCustomFieldDefinition(partnerId: number, inlineObject20?: InlineObject20, options?: any): AxiosPromise<InlineResponse2012> {
            return PartnerApiFp(configuration).partnerUpdateCustomFieldDefinition(partnerId, inlineObject20, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an existing custom field definition for entity
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {Entities} entityType Type of entity to return
         * @param {CustomFieldDefinitionInData} [customFieldDefinitionInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerUpdateCustomFieldDefinitionForEntity(partnerId: number, entityType: Entities, customFieldDefinitionInData?: CustomFieldDefinitionInData, options?: any): AxiosPromise<CustomFieldDefinitionByEntityInData> {
            return PartnerApiFp(configuration).partnerUpdateCustomFieldDefinitionForEntity(partnerId, entityType, customFieldDefinitionInData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an custom setting for entity
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {Entities} entityType Type of entity to return
         * @param {CustomSettingInData} [customSettingInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerUpdateCustomSettingForEntity(partnerId: number, entityType: Entities, customSettingInData?: CustomSettingInData, options?: any): AxiosPromise<CustomSettingsByEntityInData> {
            return PartnerApiFp(configuration).partnerUpdateCustomSettingForEntity(partnerId, entityType, customSettingInData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set the partner custom settings for a given entity
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {Entities} entityType Type of entity to return
         * @param {number} entityId Id of entity to return
         * @param {InlineObject24} [inlineObject24] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setEntityCustomSettings(partnerId: number, entityType: Entities, entityId: number, inlineObject24?: InlineObject24, options?: any): AxiosPromise<InlineResponse20018> {
            return PartnerApiFp(configuration).setEntityCustomSettings(partnerId, entityType, entityId, inlineObject24, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set the id of the entity as defined by the partner
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {Entities} entityType Type of entity to return
         * @param {number} entityId Id of entity to return
         * @param {InlineObject22} [inlineObject22] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPartnerDefinedId(partnerId: number, entityType: Entities, entityId: number, inlineObject22?: InlineObject22, options?: any): AxiosPromise<InlineResponse2014> {
            return PartnerApiFp(configuration).setPartnerDefinedId(partnerId, entityType, entityId, inlineObject22, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set the name of the entity as defined by the partner
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {Entities} entityType Type of entity to return
         * @param {number} entityId Id of entity to return
         * @param {InlineObject23} [inlineObject23] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPartnerDefinedName(partnerId: number, entityType: Entities, entityId: number, inlineObject23?: InlineObject23, options?: any): AxiosPromise<InlineResponse2014> {
            return PartnerApiFp(configuration).setPartnerDefinedName(partnerId, entityType, entityId, inlineObject23, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a partner org user
         * @param {number} partnerId Id of partner (orgw) to return
         * @param {number} userId ID of user to return
         * @param {PartnerUserInData} partnerUserInData User object to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePartnerUser(partnerId: number, userId: number, partnerUserInData: PartnerUserInData, options?: any): AxiosPromise<UserInData> {
            return PartnerApiFp(configuration).updatePartnerUser(partnerId, userId, partnerUserInData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Signed Verification of User Email Address
         * @param {number} userId userId
         * @param {string} expires Activation code
         * @param {string} signature Signature
         * @param {PartnerUser} [partnerUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyPartnerEmail(userId: number, expires: string, signature: string, partnerUser?: PartnerUser, options?: any): AxiosPromise<TokenResponsePartner> {
            return PartnerApiFp(configuration).verifyPartnerEmail(userId, expires, signature, partnerUser, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PartnerApi - object-oriented interface
 * @export
 * @class PartnerApi
 * @extends {BaseAPI}
 */
export class PartnerApi extends BaseAPI {
    /**
     * 
     * @summary Verify pending email address change
     * @param {string} userId user id
     * @param {string} expires Life of link
     * @param {string} signature Signature
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApi
     */
    public changePartnerEmail(userId: string, expires: string, signature: string, options?: any) {
        return PartnerApiFp(this.configuration).changePartnerEmail(userId, expires, signature, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a partner org user
     * @param {number} partnerId Id of partner (orgw) to return
     * @param {PartnerUserInData} partnerUserInData User object to be created
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApi
     */
    public createPartnerUser(partnerId: number, partnerUserInData: PartnerUserInData, options?: any) {
        return PartnerApiFp(this.configuration).createPartnerUser(partnerId, partnerUserInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return pickups for the time period and given list of products
     * @param {number} partnerId Id of partner (orgw) to return
     * @param {number} startTs Start epoch timestamp to consider
     * @param {number} endTs End epoch timestamp to consider
     * @param {ListOfProductIds} [listOfProductIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApi
     */
    public exportPartnerCollections(partnerId: number, startTs: number, endTs: number, listOfProductIds?: ListOfProductIds, options?: any) {
        return PartnerApiFp(this.configuration).exportPartnerCollections(partnerId, startTs, endTs, listOfProductIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return pickups for the time period and given list of products, grouped by vat
     * @param {number} partnerId Id of partner (orgw) to return
     * @param {number} startTs Start epoch timestamp to consider
     * @param {number} endTs End epoch timestamp to consider
     * @param {ListOfProductIds} [listOfProductIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApi
     */
    public exportPartnerCollectionsByVat(partnerId: number, startTs: number, endTs: number, listOfProductIds?: ListOfProductIds, options?: any) {
        return PartnerApiFp(this.configuration).exportPartnerCollectionsByVat(partnerId, startTs, endTs, listOfProductIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return current state for the given list of products
     * @param {number} partnerId Id of partner (orgw) to return
     * @param {ListOfProductIds} [listOfProductIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApi
     */
    public exportPartnerCurrentState(partnerId: number, listOfProductIds?: ListOfProductIds, options?: any) {
        return PartnerApiFp(this.configuration).exportPartnerCurrentState(partnerId, listOfProductIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return current vat state for the given list of products
     * @param {number} partnerId Id of partner (orgw) to return
     * @param {ListOfProductIds} [listOfProductIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApi
     */
    public exportPartnerCurrentStateByVat(partnerId: number, listOfProductIds?: ListOfProductIds, options?: any) {
        return PartnerApiFp(this.configuration).exportPartnerCurrentStateByVat(partnerId, listOfProductIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return milkings the given list of products
     * @param {number} partnerId Id of partner (orgw) to return
     * @param {number} startTs Start epoch timestamp to consider
     * @param {number} endTs End epoch timestamp to consider
     * @param {ListOfProductIds} [listOfProductIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApi
     */
    public exportPartnerMilkings(partnerId: number, startTs: number, endTs: number, listOfProductIds?: ListOfProductIds, options?: any) {
        return PartnerApiFp(this.configuration).exportPartnerMilkings(partnerId, startTs, endTs, listOfProductIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of partners entities (e.g. vats, tanks) current state data, filtered by body content
     * @param {number} partnerId Id of partner (orgw) to return
     * @param {FilterData} [filterData] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApi
     */
    public filterPartnerEntities(partnerId: number, filterData?: FilterData, options?: any) {
        return PartnerApiFp(this.configuration).filterPartnerEntities(partnerId, filterData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of partners products current state data, filtered by body content
     * @param {number} partnerId Id of partner (orgw) to return
     * @param {FilterData} [filterData] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApi
     */
    public filterPartnerProducts(partnerId: number, filterData?: FilterData, options?: any) {
        return PartnerApiFp(this.configuration).filterPartnerProducts(partnerId, filterData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the partner custom settings definition for a given product and entity type
     * @param {ProductType} productType Type of product to return
     * @param {Entities} entityType Type of entity to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApi
     */
    public getCustomSettingsDefinitions(productType: ProductType, entityType: Entities, options?: any) {
        return PartnerApiFp(this.configuration).getCustomSettingsDefinitions(productType, entityType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the partner custom settings for a given entity
     * @param {number} partnerId Id of partner (orgw) to return
     * @param {Entities} entityType Type of entity to return
     * @param {number} entityId Id of entity to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApi
     */
    public getEntityCustomSettings(partnerId: number, entityType: Entities, entityId: number, options?: any) {
        return PartnerApiFp(this.configuration).getEntityCustomSettings(partnerId, entityType, entityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the billing contribution tiers agreed by the partner
     * @param {number} partnerId Id of partner (orgw) to return
     * @param {ProductType} productType Type of product to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApi
     */
    public getPartnerContributionTiers(partnerId: number, productType: ProductType, options?: any) {
        return PartnerApiFp(this.configuration).getPartnerContributionTiers(partnerId, productType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of partners entities (e.g. vats, tanks) current state data
     * @param {number} partnerId Id of partner (orgw) to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApi
     */
    public getPartnerEntities(partnerId: number, options?: any) {
        return PartnerApiFp(this.configuration).getPartnerEntities(partnerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the list of products recently live
     * @param {number} partnerId Id of partner (orgw) to return
     * @param {ProductType} productType Type of product to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApi
     */
    public getPartnerNewSites(partnerId: number, productType: ProductType, options?: any) {
        return PartnerApiFp(this.configuration).getPartnerNewSites(partnerId, productType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the list of products in pending, install and sign-off status
     * @param {number} partnerId Id of partner (orgw) to return
     * @param {ProductType} productType Type of product to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApi
     */
    public getPartnerPendingSites(partnerId: number, productType: ProductType, options?: any) {
        return PartnerApiFp(this.configuration).getPartnerPendingSites(partnerId, productType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a single product and entities
     * @param {number} partnerId Id of partner (orgw) to return
     * @param {number} productId ID of product to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApi
     */
    public getPartnerProduct(partnerId: number, productId: number, options?: any) {
        return PartnerApiFp(this.configuration).getPartnerProduct(partnerId, productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of partners products current state data
     * @param {number} partnerId Id of partner (orgw) to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApi
     */
    public getPartnerProducts(partnerId: number, options?: any) {
        return PartnerApiFp(this.configuration).getPartnerProducts(partnerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all users for a given partner org
     * @param {number} partnerId Id of partner (orgw) to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApi
     */
    public getPartnerUsers(partnerId: number, options?: any) {
        return PartnerApiFp(this.configuration).getPartnerUsers(partnerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Logs a partner into the system
     * @param {Login} [login] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApi
     */
    public loginPartner(login?: Login, options?: any) {
        return PartnerApiFp(this.configuration).loginPartner(login, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Logs out the current logged in partner session
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApi
     */
    public logoutPartner(options?: any) {
        return PartnerApiFp(this.configuration).logoutPartner(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add a new custom field definition
     * @param {number} partnerId Id of partner (orgw) to return
     * @param {InlineObject19} [inlineObject19] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApi
     */
    public partnerAddCustomFieldDefinition(partnerId: number, inlineObject19?: InlineObject19, options?: any) {
        return PartnerApiFp(this.configuration).partnerAddCustomFieldDefinition(partnerId, inlineObject19, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add a new custom field definition for entity
     * @param {number} partnerId Id of partner (orgw) to return
     * @param {Entities} entityType Type of entity to return
     * @param {CustomFieldDefinitionInData} [customFieldDefinitionInData] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApi
     */
    public partnerAddCustomFieldDefinitionForEntity(partnerId: number, entityType: Entities, customFieldDefinitionInData?: CustomFieldDefinitionInData, options?: any) {
        return PartnerApiFp(this.configuration).partnerAddCustomFieldDefinitionForEntity(partnerId, entityType, customFieldDefinitionInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add a product to a partner org
     * @param {number} partnerId Id of partner (orgw) to return
     * @param {InlineObject17} [inlineObject17] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApi
     */
    public partnerAddProduct(partnerId: number, inlineObject17?: InlineObject17, options?: any) {
        return PartnerApiFp(this.configuration).partnerAddProduct(partnerId, inlineObject17, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve the partner orgs customer field definitions
     * @param {number} partnerId Id of partner (orgw) to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApi
     */
    public partnerCustomFieldDefinitions(partnerId: number, options?: any) {
        return PartnerApiFp(this.configuration).partnerCustomFieldDefinitions(partnerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve the partner orgs customer settings
     * @param {number} partnerId Id of partner (orgw) to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApi
     */
    public partnerCustomSettings(partnerId: number, options?: any) {
        return PartnerApiFp(this.configuration).partnerCustomSettings(partnerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an existing custom field definition
     * @param {number} partnerId Id of partner (orgw) to return
     * @param {InlineObject21} [inlineObject21] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApi
     */
    public partnerDeleteCustomFieldDefinition(partnerId: number, inlineObject21?: InlineObject21, options?: any) {
        return PartnerApiFp(this.configuration).partnerDeleteCustomFieldDefinition(partnerId, inlineObject21, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an existing custom field definition for entity
     * @param {number} partnerId Id of partner (orgw) to return
     * @param {Entities} entityType Type of entity to return
     * @param {CustomFieldDefinitionInData} [customFieldDefinitionInData] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApi
     */
    public partnerDeleteCustomFieldDefinitionForEntity(partnerId: number, entityType: Entities, customFieldDefinitionInData?: CustomFieldDefinitionInData, options?: any) {
        return PartnerApiFp(this.configuration).partnerDeleteCustomFieldDefinitionForEntity(partnerId, entityType, customFieldDefinitionInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set the comments for an entity
     * @param {number} partnerId Id of partner (orgw) to return
     * @param {Entities} entityType Type of entity to return
     * @param {number} entityId Id of entity to return
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApi
     */
    public partnerEntitySetComments(partnerId: number, entityType: Entities, entityId: number, body?: object, options?: any) {
        return PartnerApiFp(this.configuration).partnerEntitySetComments(partnerId, entityType, entityId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set the custom field data for an entity
     * @param {number} partnerId Id of partner (orgw) to return
     * @param {Entities} entityType Type of entity to return
     * @param {number} entityId Id of entity to return
     * @param {CustomFieldsInData} [customFieldsInData] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApi
     */
    public partnerEntitySetCustomFieldData(partnerId: number, entityType: Entities, entityId: number, customFieldsInData?: CustomFieldsInData, options?: any) {
        return PartnerApiFp(this.configuration).partnerEntitySetCustomFieldData(partnerId, entityType, entityId, customFieldsInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set the custom settings data for an entity
     * @param {number} partnerId Id of partner (orgw) to return
     * @param {Entities} entityType Type of entity to return
     * @param {number} entityId Id of entity to return
     * @param {CustomSettingInData} [customSettingInData] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApi
     */
    public partnerEntitySetCustomSettingsData(partnerId: number, entityType: Entities, entityId: number, customSettingInData?: CustomSettingInData, options?: any) {
        return PartnerApiFp(this.configuration).partnerEntitySetCustomSettingsData(partnerId, entityType, entityId, customSettingInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set the custom field data for a product
     * @param {number} partnerId Id of partner (orgw) to return
     * @param {number} productId ID of product to return
     * @param {CustomFieldsInData} [customFieldsInData] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApi
     */
    public partnerProductSetCustomFieldData(partnerId: number, productId: number, customFieldsInData?: CustomFieldsInData, options?: any) {
        return PartnerApiFp(this.configuration).partnerProductSetCustomFieldData(partnerId, productId, customFieldsInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove a product from a partner org
     * @param {number} partnerId Id of partner (orgw) to return
     * @param {InlineObject18} [inlineObject18] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApi
     */
    public partnerRemoveProduct(partnerId: number, inlineObject18?: InlineObject18, options?: any) {
        return PartnerApiFp(this.configuration).partnerRemoveProduct(partnerId, inlineObject18, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an existing custom field definition
     * @param {number} partnerId Id of partner (orgw) to return
     * @param {InlineObject20} [inlineObject20] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApi
     */
    public partnerUpdateCustomFieldDefinition(partnerId: number, inlineObject20?: InlineObject20, options?: any) {
        return PartnerApiFp(this.configuration).partnerUpdateCustomFieldDefinition(partnerId, inlineObject20, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an existing custom field definition for entity
     * @param {number} partnerId Id of partner (orgw) to return
     * @param {Entities} entityType Type of entity to return
     * @param {CustomFieldDefinitionInData} [customFieldDefinitionInData] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApi
     */
    public partnerUpdateCustomFieldDefinitionForEntity(partnerId: number, entityType: Entities, customFieldDefinitionInData?: CustomFieldDefinitionInData, options?: any) {
        return PartnerApiFp(this.configuration).partnerUpdateCustomFieldDefinitionForEntity(partnerId, entityType, customFieldDefinitionInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an custom setting for entity
     * @param {number} partnerId Id of partner (orgw) to return
     * @param {Entities} entityType Type of entity to return
     * @param {CustomSettingInData} [customSettingInData] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApi
     */
    public partnerUpdateCustomSettingForEntity(partnerId: number, entityType: Entities, customSettingInData?: CustomSettingInData, options?: any) {
        return PartnerApiFp(this.configuration).partnerUpdateCustomSettingForEntity(partnerId, entityType, customSettingInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set the partner custom settings for a given entity
     * @param {number} partnerId Id of partner (orgw) to return
     * @param {Entities} entityType Type of entity to return
     * @param {number} entityId Id of entity to return
     * @param {InlineObject24} [inlineObject24] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApi
     */
    public setEntityCustomSettings(partnerId: number, entityType: Entities, entityId: number, inlineObject24?: InlineObject24, options?: any) {
        return PartnerApiFp(this.configuration).setEntityCustomSettings(partnerId, entityType, entityId, inlineObject24, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set the id of the entity as defined by the partner
     * @param {number} partnerId Id of partner (orgw) to return
     * @param {Entities} entityType Type of entity to return
     * @param {number} entityId Id of entity to return
     * @param {InlineObject22} [inlineObject22] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApi
     */
    public setPartnerDefinedId(partnerId: number, entityType: Entities, entityId: number, inlineObject22?: InlineObject22, options?: any) {
        return PartnerApiFp(this.configuration).setPartnerDefinedId(partnerId, entityType, entityId, inlineObject22, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set the name of the entity as defined by the partner
     * @param {number} partnerId Id of partner (orgw) to return
     * @param {Entities} entityType Type of entity to return
     * @param {number} entityId Id of entity to return
     * @param {InlineObject23} [inlineObject23] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApi
     */
    public setPartnerDefinedName(partnerId: number, entityType: Entities, entityId: number, inlineObject23?: InlineObject23, options?: any) {
        return PartnerApiFp(this.configuration).setPartnerDefinedName(partnerId, entityType, entityId, inlineObject23, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a partner org user
     * @param {number} partnerId Id of partner (orgw) to return
     * @param {number} userId ID of user to return
     * @param {PartnerUserInData} partnerUserInData User object to be updated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApi
     */
    public updatePartnerUser(partnerId: number, userId: number, partnerUserInData: PartnerUserInData, options?: any) {
        return PartnerApiFp(this.configuration).updatePartnerUser(partnerId, userId, partnerUserInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Signed Verification of User Email Address
     * @param {number} userId userId
     * @param {string} expires Activation code
     * @param {string} signature Signature
     * @param {PartnerUser} [partnerUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApi
     */
    public verifyPartnerEmail(userId: number, expires: string, signature: string, partnerUser?: PartnerUser, options?: any) {
        return PartnerApiFp(this.configuration).verifyPartnerEmail(userId, expires, signature, partnerUser, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * PickupsApi - axios parameter creator
 * @export
 */
export const PickupsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a Pickup
         * @param {number} vatId ID of Vat
         * @param {InlineObject34} inlineObject34 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPickup: async (vatId: number, inlineObject34: InlineObject34, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vatId' is not null or undefined
            if (vatId === null || vatId === undefined) {
                throw new RequiredError('vatId','Required parameter vatId was null or undefined when calling createPickup.');
            }
            // verify required parameter 'inlineObject34' is not null or undefined
            if (inlineObject34 === null || inlineObject34 === undefined) {
                throw new RequiredError('inlineObject34','Required parameter inlineObject34 was null or undefined when calling createPickup.');
            }
            const localVarPath = `/vats/{vatId}/pickups`
                .replace(`{${"vatId"}}`, encodeURIComponent(String(vatId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof inlineObject34 !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(inlineObject34 !== undefined ? inlineObject34 : {}) : (inlineObject34 || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns array of pickups
         * @summary Find pickups for a Vat
         * @param {number} vatId ID of Vat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPickups: async (vatId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vatId' is not null or undefined
            if (vatId === null || vatId === undefined) {
                throw new RequiredError('vatId','Required parameter vatId was null or undefined when calling getPickups.');
            }
            const localVarPath = `/vats/{vatId}/pickups`
                .replace(`{${"vatId"}}`, encodeURIComponent(String(vatId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PickupsApi - functional programming interface
 * @export
 */
export const PickupsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a Pickup
         * @param {number} vatId ID of Vat
         * @param {InlineObject34} inlineObject34 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPickup(vatId: number, inlineObject34: InlineObject34, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await PickupsApiAxiosParamCreator(configuration).createPickup(vatId, inlineObject34, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns array of pickups
         * @summary Find pickups for a Vat
         * @param {number} vatId ID of Vat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPickups(vatId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20021>> {
            const localVarAxiosArgs = await PickupsApiAxiosParamCreator(configuration).getPickups(vatId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * PickupsApi - factory interface
 * @export
 */
export const PickupsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Create a Pickup
         * @param {number} vatId ID of Vat
         * @param {InlineObject34} inlineObject34 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPickup(vatId: number, inlineObject34: InlineObject34, options?: any): AxiosPromise<void> {
            return PickupsApiFp(configuration).createPickup(vatId, inlineObject34, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns array of pickups
         * @summary Find pickups for a Vat
         * @param {number} vatId ID of Vat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPickups(vatId: number, options?: any): AxiosPromise<InlineResponse20021> {
            return PickupsApiFp(configuration).getPickups(vatId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PickupsApi - object-oriented interface
 * @export
 * @class PickupsApi
 * @extends {BaseAPI}
 */
export class PickupsApi extends BaseAPI {
    /**
     * 
     * @summary Create a Pickup
     * @param {number} vatId ID of Vat
     * @param {InlineObject34} inlineObject34 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickupsApi
     */
    public createPickup(vatId: number, inlineObject34: InlineObject34, options?: any) {
        return PickupsApiFp(this.configuration).createPickup(vatId, inlineObject34, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns array of pickups
     * @summary Find pickups for a Vat
     * @param {number} vatId ID of Vat
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickupsApi
     */
    public getPickups(vatId: number, options?: any) {
        return PickupsApiFp(this.configuration).getPickups(vatId, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * ProductAccessoriesApi - axios parameter creator
 * @export
 */
export const ProductAccessoriesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Uninstall an accesory on an entity
         * @summary Uninstall an accesory on an entity
         * @param {number} accessoryId Id of accessory to deactivate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateAccessory: async (accessoryId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'accessoryId' is not null or undefined
            if (accessoryId === null || accessoryId === undefined) {
                throw new RequiredError('accessoryId','Required parameter accessoryId was null or undefined when calling deactivateAccessory.');
            }
            const localVarPath = `/productAccessories/{accessoryId}/deactivate`
                .replace(`{${"accessoryId"}}`, encodeURIComponent(String(accessoryId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Decommission a product accessory
         * @summary Decommission a product accessory
         * @param {number} accessoryId Id of accessory to decommission
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        decommissionAccessory: async (accessoryId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'accessoryId' is not null or undefined
            if (accessoryId === null || accessoryId === undefined) {
                throw new RequiredError('accessoryId','Required parameter accessoryId was null or undefined when calling decommissionAccessory.');
            }
            const localVarPath = `/productAccessories/{accessoryId}/decommission`
                .replace(`{${"accessoryId"}}`, encodeURIComponent(String(accessoryId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a list of all product accessories
         * @summary Get a list of all product accessories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessories: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/productAccessories`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a list of the available product accessories
         * @summary Get a list of the available product accessories
         * @param {number} [transceiverId] Return only accessories reported by this transceiver
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableAccessories: async (transceiverId?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/productAccessories/available`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (transceiverId !== undefined) {
                localVarQueryParameter['transceiverId'] = transceiverId;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Install an accesory on an entity
         * @summary Install an accesory on an entity
         * @param {number} accessoryId Id of accessory to install
         * @param {InlineObject33} [inlineObject33] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installAccessory: async (accessoryId: number, inlineObject33?: InlineObject33, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'accessoryId' is not null or undefined
            if (accessoryId === null || accessoryId === undefined) {
                throw new RequiredError('accessoryId','Required parameter accessoryId was null or undefined when calling installAccessory.');
            }
            const localVarPath = `/productAccessories/{accessoryId}/install`
                .replace(`{${"accessoryId"}}`, encodeURIComponent(String(accessoryId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof inlineObject33 !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(inlineObject33 !== undefined ? inlineObject33 : {}) : (inlineObject33 || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductAccessoriesApi - functional programming interface
 * @export
 */
export const ProductAccessoriesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Uninstall an accesory on an entity
         * @summary Uninstall an accesory on an entity
         * @param {number} accessoryId Id of accessory to deactivate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deactivateAccessory(accessoryId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductAccessoryInData>> {
            const localVarAxiosArgs = await ProductAccessoriesApiAxiosParamCreator(configuration).deactivateAccessory(accessoryId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Decommission a product accessory
         * @summary Decommission a product accessory
         * @param {number} accessoryId Id of accessory to decommission
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async decommissionAccessory(accessoryId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductAccessoryInData>> {
            const localVarAxiosArgs = await ProductAccessoriesApiAxiosParamCreator(configuration).decommissionAccessory(accessoryId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get a list of all product accessories
         * @summary Get a list of all product accessories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccessories(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductAccessoriesInData>> {
            const localVarAxiosArgs = await ProductAccessoriesApiAxiosParamCreator(configuration).getAccessories(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get a list of the available product accessories
         * @summary Get a list of the available product accessories
         * @param {number} [transceiverId] Return only accessories reported by this transceiver
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableAccessories(transceiverId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductAccessoriesInData>> {
            const localVarAxiosArgs = await ProductAccessoriesApiAxiosParamCreator(configuration).getAvailableAccessories(transceiverId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Install an accesory on an entity
         * @summary Install an accesory on an entity
         * @param {number} accessoryId Id of accessory to install
         * @param {InlineObject33} [inlineObject33] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async installAccessory(accessoryId: number, inlineObject33?: InlineObject33, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductAccessoryInData>> {
            const localVarAxiosArgs = await ProductAccessoriesApiAxiosParamCreator(configuration).installAccessory(accessoryId, inlineObject33, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ProductAccessoriesApi - factory interface
 * @export
 */
export const ProductAccessoriesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Uninstall an accesory on an entity
         * @summary Uninstall an accesory on an entity
         * @param {number} accessoryId Id of accessory to deactivate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateAccessory(accessoryId: number, options?: any): AxiosPromise<ProductAccessoryInData> {
            return ProductAccessoriesApiFp(configuration).deactivateAccessory(accessoryId, options).then((request) => request(axios, basePath));
        },
        /**
         * Decommission a product accessory
         * @summary Decommission a product accessory
         * @param {number} accessoryId Id of accessory to decommission
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        decommissionAccessory(accessoryId: number, options?: any): AxiosPromise<ProductAccessoryInData> {
            return ProductAccessoriesApiFp(configuration).decommissionAccessory(accessoryId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a list of all product accessories
         * @summary Get a list of all product accessories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessories(options?: any): AxiosPromise<ProductAccessoriesInData> {
            return ProductAccessoriesApiFp(configuration).getAccessories(options).then((request) => request(axios, basePath));
        },
        /**
         * Get a list of the available product accessories
         * @summary Get a list of the available product accessories
         * @param {number} [transceiverId] Return only accessories reported by this transceiver
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableAccessories(transceiverId?: number, options?: any): AxiosPromise<ProductAccessoriesInData> {
            return ProductAccessoriesApiFp(configuration).getAvailableAccessories(transceiverId, options).then((request) => request(axios, basePath));
        },
        /**
         * Install an accesory on an entity
         * @summary Install an accesory on an entity
         * @param {number} accessoryId Id of accessory to install
         * @param {InlineObject33} [inlineObject33] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installAccessory(accessoryId: number, inlineObject33?: InlineObject33, options?: any): AxiosPromise<ProductAccessoryInData> {
            return ProductAccessoriesApiFp(configuration).installAccessory(accessoryId, inlineObject33, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductAccessoriesApi - object-oriented interface
 * @export
 * @class ProductAccessoriesApi
 * @extends {BaseAPI}
 */
export class ProductAccessoriesApi extends BaseAPI {
    /**
     * Uninstall an accesory on an entity
     * @summary Uninstall an accesory on an entity
     * @param {number} accessoryId Id of accessory to deactivate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductAccessoriesApi
     */
    public deactivateAccessory(accessoryId: number, options?: any) {
        return ProductAccessoriesApiFp(this.configuration).deactivateAccessory(accessoryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Decommission a product accessory
     * @summary Decommission a product accessory
     * @param {number} accessoryId Id of accessory to decommission
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductAccessoriesApi
     */
    public decommissionAccessory(accessoryId: number, options?: any) {
        return ProductAccessoriesApiFp(this.configuration).decommissionAccessory(accessoryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a list of all product accessories
     * @summary Get a list of all product accessories
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductAccessoriesApi
     */
    public getAccessories(options?: any) {
        return ProductAccessoriesApiFp(this.configuration).getAccessories(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a list of the available product accessories
     * @summary Get a list of the available product accessories
     * @param {number} [transceiverId] Return only accessories reported by this transceiver
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductAccessoriesApi
     */
    public getAvailableAccessories(transceiverId?: number, options?: any) {
        return ProductAccessoriesApiFp(this.configuration).getAvailableAccessories(transceiverId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Install an accesory on an entity
     * @summary Install an accesory on an entity
     * @param {number} accessoryId Id of accessory to install
     * @param {InlineObject33} [inlineObject33] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductAccessoriesApi
     */
    public installAccessory(accessoryId: number, inlineObject33?: InlineObject33, options?: any) {
        return ProductAccessoriesApiFp(this.configuration).installAccessory(accessoryId, inlineObject33, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * ProductsApi - axios parameter creator
 * @export
 */
export const ProductsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a new product
         * @param {ProductInData} productInData product object to be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProduct: async (productInData: ProductInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productInData' is not null or undefined
            if (productInData === null || productInData === undefined) {
                throw new RequiredError('productInData','Required parameter productInData was null or undefined when calling addProduct.');
            }
            const localVarPath = `/products`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof productInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(productInData !== undefined ? productInData : {}) : (productInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add a new product, site and entities (e.g. vats, tanks)
         * @param {InlineObject25} inlineObject25 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProductOrg: async (inlineObject25: InlineObject25, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'inlineObject25' is not null or undefined
            if (inlineObject25 === null || inlineObject25 === undefined) {
                throw new RequiredError('inlineObject25','Required parameter inlineObject25 was null or undefined when calling addProductOrg.');
            }
            const localVarPath = `/products/orgProduct`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof inlineObject25 !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(inlineObject25 !== undefined ? inlineObject25 : {}) : (inlineObject25 || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cancel a product
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelProduct: async (productId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            if (productId === null || productId === undefined) {
                throw new RequiredError('productId','Required parameter productId was null or undefined when calling cancelProduct.');
            }
            const localVarPath = `/products/{productId}/cancel`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin signs off on a new product
         * @param {number} productId ID of product to return
         * @param {InlineObject28} inlineObject28 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeDevice: async (productId: number, inlineObject28: InlineObject28, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            if (productId === null || productId === undefined) {
                throw new RequiredError('productId','Required parameter productId was null or undefined when calling changeDevice.');
            }
            // verify required parameter 'inlineObject28' is not null or undefined
            if (inlineObject28 === null || inlineObject28 === undefined) {
                throw new RequiredError('inlineObject28','Required parameter inlineObject28 was null or undefined when calling changeDevice.');
            }
            const localVarPath = `/products/{productId}/changeDevice`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof inlineObject28 !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(inlineObject28 !== undefined ? inlineObject28 : {}) : (inlineObject28 || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the entity and product status
         * @param {number} productId ID of product to return
         * @param {Entities} entityType Type of entity to return
         * @param {number} entityId Id of entity to return
         * @param {ProductStatusChange} [productStatusChange] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeProductStatus: async (productId: number, entityType: Entities, entityId: number, productStatusChange?: ProductStatusChange, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            if (productId === null || productId === undefined) {
                throw new RequiredError('productId','Required parameter productId was null or undefined when calling changeProductStatus.');
            }
            // verify required parameter 'entityType' is not null or undefined
            if (entityType === null || entityType === undefined) {
                throw new RequiredError('entityType','Required parameter entityType was null or undefined when calling changeProductStatus.');
            }
            // verify required parameter 'entityId' is not null or undefined
            if (entityId === null || entityId === undefined) {
                throw new RequiredError('entityId','Required parameter entityId was null or undefined when calling changeProductStatus.');
            }
            const localVarPath = `/products/{productId}/changeStatus/{entityType}/{entityId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)))
                .replace(`{${"entityType"}}`, encodeURIComponent(String(entityType)))
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof productStatusChange !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(productStatusChange !== undefined ? productStatusChange : {}) : (productStatusChange || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Construct the simPro job story for the product
         * @param {number} productId ID of product to return
         * @param {ProductSimProJobInData} [productSimProJobInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        constructJobStory: async (productId: number, productSimProJobInData?: ProductSimProJobInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            if (productId === null || productId === undefined) {
                throw new RequiredError('productId','Required parameter productId was null or undefined when calling constructJobStory.');
            }
            const localVarPath = `/products/{productId}/constructJobStory`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof productSimProJobInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(productSimProJobInData !== undefined ? productSimProJobInData : {}) : (productSimProJobInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets the current billing setup
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        currentBilling: async (productId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            if (productId === null || productId === undefined) {
                throw new RequiredError('productId','Required parameter productId was null or undefined when calling currentBilling.');
            }
            const localVarPath = `/products/{productId}/currentBilling`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deactivate a product
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateProduct: async (productId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            if (productId === null || productId === undefined) {
                throw new RequiredError('productId','Required parameter productId was null or undefined when calling deactivateProduct.');
            }
            const localVarPath = `/products/{productId}/deactivate`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes a product
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProduct: async (productId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            if (productId === null || productId === undefined) {
                throw new RequiredError('productId','Required parameter productId was null or undefined when calling deleteProduct.');
            }
            const localVarPath = `/products/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets the available tiers for direct customer tpye based on partner contribution tier
         * @param {ProductType} productType Type of product to return
         * @param {ContributionTierInData} [contributionTierInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableTiers: async (productType: ProductType, contributionTierInData?: ContributionTierInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productType' is not null or undefined
            if (productType === null || productType === undefined) {
                throw new RequiredError('productType','Required parameter productType was null or undefined when calling getAvailableTiers.');
            }
            const localVarPath = `/products/{productType}/availableTiers`
                .replace(`{${"productType"}}`, encodeURIComponent(String(productType)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof contributionTierInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(contributionTierInData !== undefined ? contributionTierInData : {}) : (contributionTierInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets the current “billing period” of un-charged SMS alerts and their status
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentSmsDeliveryLogs: async (productId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            if (productId === null || productId === undefined) {
                throw new RequiredError('productId','Required parameter productId was null or undefined when calling getCurrentSmsDeliveryLogs.');
            }
            const localVarPath = `/products/{productId}/currentSmsDeliveryLogs`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all pending text messages for a product
         * @summary Get product pending texts
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingTexts: async (productId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            if (productId === null || productId === undefined) {
                throw new RequiredError('productId','Required parameter productId was null or undefined when calling getPendingTexts.');
            }
            const localVarPath = `/products/{productId}/pendingTexts`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns product alerts
         * @summary Get product alerts
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductAlerts: async (productId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            if (productId === null || productId === undefined) {
                throw new RequiredError('productId','Required parameter productId was null or undefined when calling getProductAlerts.');
            }
            const localVarPath = `/products/{productId}/alerts`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve list of user id valid with product tier limits
         * @param {number} id ID of entity to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductAllowedUsers: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getProductAllowedUsers.');
            }
            const localVarPath = `/products/{id}/allowedUsers`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a product
         * @summary Find product by productId
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductById: async (productId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            if (productId === null || productId === undefined) {
                throw new RequiredError('productId','Required parameter productId was null or undefined when calling getProductById.');
            }
            const localVarPath = `/products/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a product dashboard
         * @summary Get product dashboard data
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductDash: async (productId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            if (productId === null || productId === undefined) {
                throw new RequiredError('productId','Required parameter productId was null or undefined when calling getProductDash.');
            }
            const localVarPath = `/products/{productId}/dash`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the list of direct plans to be used for billing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductDirectPlans: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/products/directPlans`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a products events
         * @summary Get product events
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductEvents: async (productId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            if (productId === null || productId === undefined) {
                throw new RequiredError('productId','Required parameter productId was null or undefined when calling getProductEvents.');
            }
            const localVarPath = `/products/{productId}/events`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a fuel product dashboard
         * @summary Get a fuel product dashboard data
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductFuelDash: async (productId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            if (productId === null || productId === undefined) {
                throw new RequiredError('productId','Required parameter productId was null or undefined when calling getProductFuelDash.');
            }
            const localVarPath = `/products/{productId}/fuelDash`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a milk product dashboard
         * @summary Get a milk product dashboard data
         * @param {number} productId ID of product to return
         * @param {number} [nDays] return only this many days worth of data. Default &#x3D; 2 usually
         * @param {Array<string>} [include] comma separated list of additional related objects to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductMilkDash: async (productId: number, nDays?: number, include?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            if (productId === null || productId === undefined) {
                throw new RequiredError('productId','Required parameter productId was null or undefined when calling getProductMilkDash.');
            }
            const localVarPath = `/products/{productId}/milkDash`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (nDays !== undefined) {
                localVarQueryParameter['nDays'] = nDays;
            }

            if (include) {
                localVarQueryParameter['include'] = include.join(COLLECTION_FORMATS.csv);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a milk product milking time data
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductMilkingTimeWindow: async (productId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            if (productId === null || productId === undefined) {
                throw new RequiredError('productId','Required parameter productId was null or undefined when calling getProductMilkingTimeWindow.');
            }
            const localVarPath = `/products/{productId}/milkingtime`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve number of users permitted access to the product based on the active tier
         * @param {number} id ID of entity to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductNumUsersAllowed: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getProductNumUsersAllowed.');
            }
            const localVarPath = `/products/{id}/numUsersAllowed`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all orgs with a partner relationship to product
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductPartnerOrgs: async (productId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            if (productId === null || productId === undefined) {
                throw new RequiredError('productId','Required parameter productId was null or undefined when calling getProductPartnerOrgs.');
            }
            const localVarPath = `/products/{productId}/partnerOrgs`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/products`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all sent text messages for a product
         * @summary Get product sent texts
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSentTexts: async (productId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            if (productId === null || productId === undefined) {
                throw new RequiredError('productId','Required parameter productId was null or undefined when calling getSentTexts.');
            }
            const localVarPath = `/products/{productId}/sentTexts`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the history of processed SMS alerts
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSmsProductCharges: async (productId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            if (productId === null || productId === undefined) {
                throw new RequiredError('productId','Required parameter productId was null or undefined when calling getSmsProductCharges.');
            }
            const localVarPath = `/products/{productId}/smsProductCharges`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the detail SMS delivery logs for a given SMS product charge
         * @param {number} productId ID of product to return
         * @param {number} smsProductChargeId ID of SMS product charges record to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSmsProductChargesDetail: async (productId: number, smsProductChargeId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            if (productId === null || productId === undefined) {
                throw new RequiredError('productId','Required parameter productId was null or undefined when calling getSmsProductChargesDetail.');
            }
            // verify required parameter 'smsProductChargeId' is not null or undefined
            if (smsProductChargeId === null || smsProductChargeId === undefined) {
                throw new RequiredError('smsProductChargeId','Required parameter smsProductChargeId was null or undefined when calling getSmsProductChargesDetail.');
            }
            const localVarPath = `/products/{productId}/smsProductCharges/{smsProductChargeId}/detail`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)))
                .replace(`{${"smsProductChargeId"}}`, encodeURIComponent(String(smsProductChargeId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the status of the current SMS billing period
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSmsStatus: async (productId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            if (productId === null || productId === undefined) {
                throw new RequiredError('productId','Required parameter productId was null or undefined when calling getSmsStatus.');
            }
            const localVarPath = `/products/{productId}/smsStatus`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create or Update Alert and Alert Subscribers
         * @param {number} productId ID of product to return
         * @param {AlertInData} alertInData User object to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productAlertSubscribers: async (productId: number, alertInData: AlertInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            if (productId === null || productId === undefined) {
                throw new RequiredError('productId','Required parameter productId was null or undefined when calling productAlertSubscribers.');
            }
            // verify required parameter 'alertInData' is not null or undefined
            if (alertInData === null || alertInData === undefined) {
                throw new RequiredError('alertInData','Required parameter alertInData was null or undefined when calling productAlertSubscribers.');
            }
            const localVarPath = `/products/{productId}/alerts`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof alertInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(alertInData !== undefined ? alertInData : {}) : (alertInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin signs off on a new product
         * @param {number} productId ID of product to return
         * @param {InlineObject27} inlineObject27 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productAssignFuelSensors: async (productId: number, inlineObject27: InlineObject27, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            if (productId === null || productId === undefined) {
                throw new RequiredError('productId','Required parameter productId was null or undefined when calling productAssignFuelSensors.');
            }
            // verify required parameter 'inlineObject27' is not null or undefined
            if (inlineObject27 === null || inlineObject27 === undefined) {
                throw new RequiredError('inlineObject27','Required parameter inlineObject27 was null or undefined when calling productAssignFuelSensors.');
            }
            const localVarPath = `/products/{productId}/assignFuelSensors`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof inlineObject27 !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(inlineObject27 !== undefined ? inlineObject27 : {}) : (inlineObject27 || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin signs off on a new product
         * @param {number} productId ID of product to return
         * @param {InlineObject26} inlineObject26 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productAssignSensors: async (productId: number, inlineObject26: InlineObject26, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            if (productId === null || productId === undefined) {
                throw new RequiredError('productId','Required parameter productId was null or undefined when calling productAssignSensors.');
            }
            // verify required parameter 'inlineObject26' is not null or undefined
            if (inlineObject26 === null || inlineObject26 === undefined) {
                throw new RequiredError('inlineObject26','Required parameter inlineObject26 was null or undefined when calling productAssignSensors.');
            }
            const localVarPath = `/products/{productId}/assignSensors`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof inlineObject26 !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(inlineObject26 !== undefined ? inlineObject26 : {}) : (inlineObject26 || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin signs off on a new product
         * @param {number} productId ID of product to return
         * @param {InlineObject30} inlineObject30 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productFaults: async (productId: number, inlineObject30: InlineObject30, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            if (productId === null || productId === undefined) {
                throw new RequiredError('productId','Required parameter productId was null or undefined when calling productFaults.');
            }
            // verify required parameter 'inlineObject30' is not null or undefined
            if (inlineObject30 === null || inlineObject30 === undefined) {
                throw new RequiredError('inlineObject30','Required parameter inlineObject30 was null or undefined when calling productFaults.');
            }
            const localVarPath = `/products/{productId}/faults`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof inlineObject30 !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(inlineObject30 !== undefined ? inlineObject30 : {}) : (inlineObject30 || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin signs off on a new product
         * @param {number} productId ID of product to return
         * @param {InlineObject31} inlineObject31 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productFaultsActivity: async (productId: number, inlineObject31: InlineObject31, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            if (productId === null || productId === undefined) {
                throw new RequiredError('productId','Required parameter productId was null or undefined when calling productFaultsActivity.');
            }
            // verify required parameter 'inlineObject31' is not null or undefined
            if (inlineObject31 === null || inlineObject31 === undefined) {
                throw new RequiredError('inlineObject31','Required parameter inlineObject31 was null or undefined when calling productFaultsActivity.');
            }
            const localVarPath = `/products/{productId}/faultActivity`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof inlineObject31 !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(inlineObject31 !== undefined ? inlineObject31 : {}) : (inlineObject31 || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a simPro job for the product
         * @param {number} productId ID of product to return
         * @param {InlineObject32} [inlineObject32] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productJob: async (productId: number, inlineObject32?: InlineObject32, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            if (productId === null || productId === undefined) {
                throw new RequiredError('productId','Required parameter productId was null or undefined when calling productJob.');
            }
            const localVarPath = `/products/{productId}/job`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof inlineObject32 !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(inlineObject32 !== undefined ? inlineObject32 : {}) : (inlineObject32 || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a simPro job for the product
         * @param {number} productId ID of product to return
         * @param {'install' | 'repair' | 'remove'} jobType 
         * @param {ProductSimProJob} [productSimProJob] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSimProJob: async (productId: number, jobType: 'install' | 'repair' | 'remove', productSimProJob?: ProductSimProJob, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            if (productId === null || productId === undefined) {
                throw new RequiredError('productId','Required parameter productId was null or undefined when calling productSimProJob.');
            }
            // verify required parameter 'jobType' is not null or undefined
            if (jobType === null || jobType === undefined) {
                throw new RequiredError('jobType','Required parameter jobType was null or undefined when calling productSimProJob.');
            }
            const localVarPath = `/products/{productId}/job/{jobType}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)))
                .replace(`{${"jobType"}}`, encodeURIComponent(String(jobType)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof productSimProJob !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(productSimProJob !== undefined ? productSimProJob : {}) : (productSimProJob || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set or update a product trial
         * @param {number} id ID of entity to return
         * @param {ProductTrialInData} [productTrialInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTrial: async (id: number, productTrialInData?: ProductTrialInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling productTrial.');
            }
            const localVarPath = `/products/{id}/trial`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof productTrialInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(productTrialInData !== undefined ? productTrialInData : {}) : (productTrialInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin update to vat labels
         * @param {number} productId ID of product to return
         * @param {VatLabelsInData} vatLabelsInData Product object to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productVatLabels: async (productId: number, vatLabelsInData: VatLabelsInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            if (productId === null || productId === undefined) {
                throw new RequiredError('productId','Required parameter productId was null or undefined when calling productVatLabels.');
            }
            // verify required parameter 'vatLabelsInData' is not null or undefined
            if (vatLabelsInData === null || vatLabelsInData === undefined) {
                throw new RequiredError('vatLabelsInData','Required parameter vatLabelsInData was null or undefined when calling productVatLabels.');
            }
            const localVarPath = `/products/{productId}/vatLabels`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof vatLabelsInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(vatLabelsInData !== undefined ? vatLabelsInData : {}) : (vatLabelsInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin updates offset for vats
         * @param {number} productId ID of product to return
         * @param {InlineObject29} inlineObject29 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productVatsetup: async (productId: number, inlineObject29: InlineObject29, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            if (productId === null || productId === undefined) {
                throw new RequiredError('productId','Required parameter productId was null or undefined when calling productVatsetup.');
            }
            // verify required parameter 'inlineObject29' is not null or undefined
            if (inlineObject29 === null || inlineObject29 === undefined) {
                throw new RequiredError('inlineObject29','Required parameter inlineObject29 was null or undefined when calling productVatsetup.');
            }
            const localVarPath = `/products/{productId}/vatSetup`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof inlineObject29 !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(inlineObject29 !== undefined ? inlineObject29 : {}) : (inlineObject29 || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the users from Classic that map to the fuel tanks assigned to the product
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsGetClassicUsers: async (productId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            if (productId === null || productId === undefined) {
                throw new RequiredError('productId','Required parameter productId was null or undefined when calling productsGetClassicUsers.');
            }
            const localVarPath = `/products/{productId}/getClassicUsers`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves a list of products with faults
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsGetFaults: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/products/getFaults`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the number of alerts sent out for a product
         * @param {number} productId ID of product to return
         * @param {string} [startDate] Oldest alert date to include, defaults to first of month
         * @param {string} [endDate] Newest alert date to include, defaults to today
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsNumNotifications: async (productId: number, startDate?: string, endDate?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            if (productId === null || productId === undefined) {
                throw new RequiredError('productId','Required parameter productId was null or undefined when calling productsNumNotifications.');
            }
            const localVarPath = `/products/{productId}/numNotifications`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substr(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substr(0,10) :
                    endDate;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new product
         * @param {StoreProductInData} [storeProductInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeProduct: async (storeProductInData?: StoreProductInData, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/products/storeProduct`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof storeProductInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(storeProductInData !== undefined ? storeProductInData : {}) : (storeProductInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set or update the current Ordway subscription plans
         * @param {UpdateBilling} [updateBilling] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBilling: async (updateBilling?: UpdateBilling, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/products/updateBilling`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof updateBilling !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateBilling !== undefined ? updateBilling : {}) : (updateBilling || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set or update the current Ordway subscription plans
         * @param {number} productId ID of product to return
         * @param {OrdwayPlans} [ordwayPlans] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrdwayPlans: async (productId: number, ordwayPlans?: OrdwayPlans, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            if (productId === null || productId === undefined) {
                throw new RequiredError('productId','Required parameter productId was null or undefined when calling updateOrdwayPlans.');
            }
            const localVarPath = `/products/{productId}/updateOrdwayPlans`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof ordwayPlans !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(ordwayPlans !== undefined ? ordwayPlans : {}) : (ordwayPlans || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates a product
         * @param {number} productId ID of product to return
         * @param {ProductInData} productInData Product object to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProduct: async (productId: number, productInData: ProductInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            if (productId === null || productId === undefined) {
                throw new RequiredError('productId','Required parameter productId was null or undefined when calling updateProduct.');
            }
            // verify required parameter 'productInData' is not null or undefined
            if (productInData === null || productInData === undefined) {
                throw new RequiredError('productInData','Required parameter productInData was null or undefined when calling updateProduct.');
            }
            const localVarPath = `/products/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof productInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(productInData !== undefined ? productInData : {}) : (productInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductsApi - functional programming interface
 * @export
 */
export const ProductsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a new product
         * @param {ProductInData} productInData product object to be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addProduct(productInData: ProductInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ProductsApiAxiosParamCreator(configuration).addProduct(productInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Add a new product, site and entities (e.g. vats, tanks)
         * @param {InlineObject25} inlineObject25 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addProductOrg(inlineObject25: InlineObject25, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ProductsApiAxiosParamCreator(configuration).addProductOrg(inlineObject25, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Cancel a product
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelProduct(productId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ProductsApiAxiosParamCreator(configuration).cancelProduct(productId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Admin signs off on a new product
         * @param {number} productId ID of product to return
         * @param {InlineObject28} inlineObject28 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeDevice(productId: number, inlineObject28: InlineObject28, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ProductsApiAxiosParamCreator(configuration).changeDevice(productId, inlineObject28, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Update the entity and product status
         * @param {number} productId ID of product to return
         * @param {Entities} entityType Type of entity to return
         * @param {number} entityId Id of entity to return
         * @param {ProductStatusChange} [productStatusChange] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeProductStatus(productId: number, entityType: Entities, entityId: number, productStatusChange?: ProductStatusChange, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ProductsApiAxiosParamCreator(configuration).changeProductStatus(productId, entityType, entityId, productStatusChange, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Construct the simPro job story for the product
         * @param {number} productId ID of product to return
         * @param {ProductSimProJobInData} [productSimProJobInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async constructJobStory(productId: number, productSimProJobInData?: ProductSimProJobInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SimproJobDescriptionInData>> {
            const localVarAxiosArgs = await ProductsApiAxiosParamCreator(configuration).constructJobStory(productId, productSimProJobInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Gets the current billing setup
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async currentBilling(productId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateBillingInData>> {
            const localVarAxiosArgs = await ProductsApiAxiosParamCreator(configuration).currentBilling(productId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Deactivate a product
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deactivateProduct(productId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ProductsApiAxiosParamCreator(configuration).deactivateProduct(productId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Deletes a product
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProduct(productId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ProductsApiAxiosParamCreator(configuration).deleteProduct(productId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Gets the available tiers for direct customer tpye based on partner contribution tier
         * @param {ProductType} productType Type of product to return
         * @param {ContributionTierInData} [contributionTierInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableTiers(productType: ProductType, contributionTierInData?: ContributionTierInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TiersInData>> {
            const localVarAxiosArgs = await ProductsApiAxiosParamCreator(configuration).getAvailableTiers(productType, contributionTierInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Gets the current “billing period” of un-charged SMS alerts and their status
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentSmsDeliveryLogs(productId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SmsDeliveryLogsInData>> {
            const localVarAxiosArgs = await ProductsApiAxiosParamCreator(configuration).getCurrentSmsDeliveryLogs(productId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns all pending text messages for a product
         * @summary Get product pending texts
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPendingTexts(productId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuditsInData>> {
            const localVarAxiosArgs = await ProductsApiAxiosParamCreator(configuration).getPendingTexts(productId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns product alerts
         * @summary Get product alerts
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductAlerts(productId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AlertsInData>> {
            const localVarAxiosArgs = await ProductsApiAxiosParamCreator(configuration).getProductAlerts(productId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Retrieve list of user id valid with product tier limits
         * @param {number} id ID of entity to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductAllowedUsers(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20019>> {
            const localVarAxiosArgs = await ProductsApiAxiosParamCreator(configuration).getProductAllowedUsers(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns a product
         * @summary Find product by productId
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductById(productId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Product>> {
            const localVarAxiosArgs = await ProductsApiAxiosParamCreator(configuration).getProductById(productId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns a product dashboard
         * @summary Get product dashboard data
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductDash(productId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductDash>> {
            const localVarAxiosArgs = await ProductsApiAxiosParamCreator(configuration).getProductDash(productId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get the list of direct plans to be used for billing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductDirectPlans(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DirectPlansInData>> {
            const localVarAxiosArgs = await ProductsApiAxiosParamCreator(configuration).getProductDirectPlans(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns a products events
         * @summary Get product events
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductEvents(productId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductEventsInData>> {
            const localVarAxiosArgs = await ProductsApiAxiosParamCreator(configuration).getProductEvents(productId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns a fuel product dashboard
         * @summary Get a fuel product dashboard data
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductFuelDash(productId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FuelDash>> {
            const localVarAxiosArgs = await ProductsApiAxiosParamCreator(configuration).getProductFuelDash(productId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns a milk product dashboard
         * @summary Get a milk product dashboard data
         * @param {number} productId ID of product to return
         * @param {number} [nDays] return only this many days worth of data. Default &#x3D; 2 usually
         * @param {Array<string>} [include] comma separated list of additional related objects to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductMilkDash(productId: number, nDays?: number, include?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductMilkDashInData>> {
            const localVarAxiosArgs = await ProductsApiAxiosParamCreator(configuration).getProductMilkDash(productId, nDays, include, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get a milk product milking time data
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductMilkingTimeWindow(productId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TimeSeriesObject>>> {
            const localVarAxiosArgs = await ProductsApiAxiosParamCreator(configuration).getProductMilkingTimeWindow(productId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Retrieve number of users permitted access to the product based on the active tier
         * @param {number} id ID of entity to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductNumUsersAllowed(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20020>> {
            const localVarAxiosArgs = await ProductsApiAxiosParamCreator(configuration).getProductNumUsersAllowed(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns all orgs with a partner relationship to product
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductPartnerOrgs(productId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrgsInData>> {
            const localVarAxiosArgs = await ProductsApiAxiosParamCreator(configuration).getProductPartnerOrgs(productId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns all products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProducts(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductsInData>> {
            const localVarAxiosArgs = await ProductsApiAxiosParamCreator(configuration).getProducts(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns all sent text messages for a product
         * @summary Get product sent texts
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSentTexts(productId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuditsInData>> {
            const localVarAxiosArgs = await ProductsApiAxiosParamCreator(configuration).getSentTexts(productId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get the history of processed SMS alerts
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSmsProductCharges(productId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SmsProductChargesInData>> {
            const localVarAxiosArgs = await ProductsApiAxiosParamCreator(configuration).getSmsProductCharges(productId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get the detail SMS delivery logs for a given SMS product charge
         * @param {number} productId ID of product to return
         * @param {number} smsProductChargeId ID of SMS product charges record to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSmsProductChargesDetail(productId: number, smsProductChargeId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SmsProductChargesDetailInData>> {
            const localVarAxiosArgs = await ProductsApiAxiosParamCreator(configuration).getSmsProductChargesDetail(productId, smsProductChargeId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Retrieve the status of the current SMS billing period
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSmsStatus(productId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SmsStatus>> {
            const localVarAxiosArgs = await ProductsApiAxiosParamCreator(configuration).getSmsStatus(productId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Create or Update Alert and Alert Subscribers
         * @param {number} productId ID of product to return
         * @param {AlertInData} alertInData User object to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productAlertSubscribers(productId: number, alertInData: AlertInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ProductsApiAxiosParamCreator(configuration).productAlertSubscribers(productId, alertInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Admin signs off on a new product
         * @param {number} productId ID of product to return
         * @param {InlineObject27} inlineObject27 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productAssignFuelSensors(productId: number, inlineObject27: InlineObject27, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ProductsApiAxiosParamCreator(configuration).productAssignFuelSensors(productId, inlineObject27, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Admin signs off on a new product
         * @param {number} productId ID of product to return
         * @param {InlineObject26} inlineObject26 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productAssignSensors(productId: number, inlineObject26: InlineObject26, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ProductsApiAxiosParamCreator(configuration).productAssignSensors(productId, inlineObject26, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Admin signs off on a new product
         * @param {number} productId ID of product to return
         * @param {InlineObject30} inlineObject30 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productFaults(productId: number, inlineObject30: InlineObject30, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ProductsApiAxiosParamCreator(configuration).productFaults(productId, inlineObject30, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Admin signs off on a new product
         * @param {number} productId ID of product to return
         * @param {InlineObject31} inlineObject31 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productFaultsActivity(productId: number, inlineObject31: InlineObject31, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ProductsApiAxiosParamCreator(configuration).productFaultsActivity(productId, inlineObject31, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Create a simPro job for the product
         * @param {number} productId ID of product to return
         * @param {InlineObject32} [inlineObject32] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productJob(productId: number, inlineObject32?: InlineObject32, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ProductsApiAxiosParamCreator(configuration).productJob(productId, inlineObject32, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Create a simPro job for the product
         * @param {number} productId ID of product to return
         * @param {'install' | 'repair' | 'remove'} jobType 
         * @param {ProductSimProJob} [productSimProJob] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productSimProJob(productId: number, jobType: 'install' | 'repair' | 'remove', productSimProJob?: ProductSimProJob, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ProductsApiAxiosParamCreator(configuration).productSimProJob(productId, jobType, productSimProJob, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Set or update a product trial
         * @param {number} id ID of entity to return
         * @param {ProductTrialInData} [productTrialInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productTrial(id: number, productTrialInData?: ProductTrialInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscriptionItemInData>> {
            const localVarAxiosArgs = await ProductsApiAxiosParamCreator(configuration).productTrial(id, productTrialInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Admin update to vat labels
         * @param {number} productId ID of product to return
         * @param {VatLabelsInData} vatLabelsInData Product object to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productVatLabels(productId: number, vatLabelsInData: VatLabelsInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductInData>> {
            const localVarAxiosArgs = await ProductsApiAxiosParamCreator(configuration).productVatLabels(productId, vatLabelsInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Admin updates offset for vats
         * @param {number} productId ID of product to return
         * @param {InlineObject29} inlineObject29 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productVatsetup(productId: number, inlineObject29: InlineObject29, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ProductsApiAxiosParamCreator(configuration).productVatsetup(productId, inlineObject29, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get the users from Classic that map to the fuel tanks assigned to the product
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsGetClassicUsers(productId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await ProductsApiAxiosParamCreator(configuration).productsGetClassicUsers(productId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Retrieves a list of products with faults
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsGetFaults(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductFaultStatusInData>> {
            const localVarAxiosArgs = await ProductsApiAxiosParamCreator(configuration).productsGetFaults(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get the number of alerts sent out for a product
         * @param {number} productId ID of product to return
         * @param {string} [startDate] Oldest alert date to include, defaults to first of month
         * @param {string} [endDate] Newest alert date to include, defaults to today
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsNumNotifications(productId: number, startDate?: string, endDate?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NumNotificationsInData>> {
            const localVarAxiosArgs = await ProductsApiAxiosParamCreator(configuration).productsNumNotifications(productId, startDate, endDate, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Creates a new product
         * @param {StoreProductInData} [storeProductInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeProduct(storeProductInData?: StoreProductInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductInData>> {
            const localVarAxiosArgs = await ProductsApiAxiosParamCreator(configuration).storeProduct(storeProductInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Set or update the current Ordway subscription plans
         * @param {UpdateBilling} [updateBilling] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBilling(updateBilling?: UpdateBilling, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ProductsApiAxiosParamCreator(configuration).updateBilling(updateBilling, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Set or update the current Ordway subscription plans
         * @param {number} productId ID of product to return
         * @param {OrdwayPlans} [ordwayPlans] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrdwayPlans(productId: number, ordwayPlans?: OrdwayPlans, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ProductsApiAxiosParamCreator(configuration).updateOrdwayPlans(productId, ordwayPlans, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Updates a product
         * @param {number} productId ID of product to return
         * @param {ProductInData} productInData Product object to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProduct(productId: number, productInData: ProductInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ProductsApiAxiosParamCreator(configuration).updateProduct(productId, productInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ProductsApi - factory interface
 * @export
 */
export const ProductsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Add a new product
         * @param {ProductInData} productInData product object to be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProduct(productInData: ProductInData, options?: any): AxiosPromise<void> {
            return ProductsApiFp(configuration).addProduct(productInData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add a new product, site and entities (e.g. vats, tanks)
         * @param {InlineObject25} inlineObject25 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProductOrg(inlineObject25: InlineObject25, options?: any): AxiosPromise<void> {
            return ProductsApiFp(configuration).addProductOrg(inlineObject25, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cancel a product
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelProduct(productId: number, options?: any): AxiosPromise<void> {
            return ProductsApiFp(configuration).cancelProduct(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin signs off on a new product
         * @param {number} productId ID of product to return
         * @param {InlineObject28} inlineObject28 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeDevice(productId: number, inlineObject28: InlineObject28, options?: any): AxiosPromise<void> {
            return ProductsApiFp(configuration).changeDevice(productId, inlineObject28, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the entity and product status
         * @param {number} productId ID of product to return
         * @param {Entities} entityType Type of entity to return
         * @param {number} entityId Id of entity to return
         * @param {ProductStatusChange} [productStatusChange] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeProductStatus(productId: number, entityType: Entities, entityId: number, productStatusChange?: ProductStatusChange, options?: any): AxiosPromise<void> {
            return ProductsApiFp(configuration).changeProductStatus(productId, entityType, entityId, productStatusChange, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Construct the simPro job story for the product
         * @param {number} productId ID of product to return
         * @param {ProductSimProJobInData} [productSimProJobInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        constructJobStory(productId: number, productSimProJobInData?: ProductSimProJobInData, options?: any): AxiosPromise<SimproJobDescriptionInData> {
            return ProductsApiFp(configuration).constructJobStory(productId, productSimProJobInData, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the current billing setup
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        currentBilling(productId: number, options?: any): AxiosPromise<UpdateBillingInData> {
            return ProductsApiFp(configuration).currentBilling(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deactivate a product
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateProduct(productId: number, options?: any): AxiosPromise<void> {
            return ProductsApiFp(configuration).deactivateProduct(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes a product
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProduct(productId: number, options?: any): AxiosPromise<void> {
            return ProductsApiFp(configuration).deleteProduct(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the available tiers for direct customer tpye based on partner contribution tier
         * @param {ProductType} productType Type of product to return
         * @param {ContributionTierInData} [contributionTierInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableTiers(productType: ProductType, contributionTierInData?: ContributionTierInData, options?: any): AxiosPromise<TiersInData> {
            return ProductsApiFp(configuration).getAvailableTiers(productType, contributionTierInData, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the current “billing period” of un-charged SMS alerts and their status
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentSmsDeliveryLogs(productId: number, options?: any): AxiosPromise<SmsDeliveryLogsInData> {
            return ProductsApiFp(configuration).getCurrentSmsDeliveryLogs(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all pending text messages for a product
         * @summary Get product pending texts
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingTexts(productId: number, options?: any): AxiosPromise<AuditsInData> {
            return ProductsApiFp(configuration).getPendingTexts(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns product alerts
         * @summary Get product alerts
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductAlerts(productId: number, options?: any): AxiosPromise<AlertsInData> {
            return ProductsApiFp(configuration).getProductAlerts(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve list of user id valid with product tier limits
         * @param {number} id ID of entity to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductAllowedUsers(id: number, options?: any): AxiosPromise<InlineResponse20019> {
            return ProductsApiFp(configuration).getProductAllowedUsers(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a product
         * @summary Find product by productId
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductById(productId: number, options?: any): AxiosPromise<Product> {
            return ProductsApiFp(configuration).getProductById(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a product dashboard
         * @summary Get product dashboard data
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductDash(productId: number, options?: any): AxiosPromise<ProductDash> {
            return ProductsApiFp(configuration).getProductDash(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the list of direct plans to be used for billing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductDirectPlans(options?: any): AxiosPromise<DirectPlansInData> {
            return ProductsApiFp(configuration).getProductDirectPlans(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a products events
         * @summary Get product events
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductEvents(productId: number, options?: any): AxiosPromise<ProductEventsInData> {
            return ProductsApiFp(configuration).getProductEvents(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a fuel product dashboard
         * @summary Get a fuel product dashboard data
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductFuelDash(productId: number, options?: any): AxiosPromise<FuelDash> {
            return ProductsApiFp(configuration).getProductFuelDash(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a milk product dashboard
         * @summary Get a milk product dashboard data
         * @param {number} productId ID of product to return
         * @param {number} [nDays] return only this many days worth of data. Default &#x3D; 2 usually
         * @param {Array<string>} [include] comma separated list of additional related objects to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductMilkDash(productId: number, nDays?: number, include?: Array<string>, options?: any): AxiosPromise<ProductMilkDashInData> {
            return ProductsApiFp(configuration).getProductMilkDash(productId, nDays, include, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a milk product milking time data
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductMilkingTimeWindow(productId: number, options?: any): AxiosPromise<Array<TimeSeriesObject>> {
            return ProductsApiFp(configuration).getProductMilkingTimeWindow(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve number of users permitted access to the product based on the active tier
         * @param {number} id ID of entity to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductNumUsersAllowed(id: number, options?: any): AxiosPromise<InlineResponse20020> {
            return ProductsApiFp(configuration).getProductNumUsersAllowed(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all orgs with a partner relationship to product
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductPartnerOrgs(productId: number, options?: any): AxiosPromise<OrgsInData> {
            return ProductsApiFp(configuration).getProductPartnerOrgs(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts(options?: any): AxiosPromise<ProductsInData> {
            return ProductsApiFp(configuration).getProducts(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all sent text messages for a product
         * @summary Get product sent texts
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSentTexts(productId: number, options?: any): AxiosPromise<AuditsInData> {
            return ProductsApiFp(configuration).getSentTexts(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the history of processed SMS alerts
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSmsProductCharges(productId: number, options?: any): AxiosPromise<SmsProductChargesInData> {
            return ProductsApiFp(configuration).getSmsProductCharges(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the detail SMS delivery logs for a given SMS product charge
         * @param {number} productId ID of product to return
         * @param {number} smsProductChargeId ID of SMS product charges record to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSmsProductChargesDetail(productId: number, smsProductChargeId: number, options?: any): AxiosPromise<SmsProductChargesDetailInData> {
            return ProductsApiFp(configuration).getSmsProductChargesDetail(productId, smsProductChargeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the status of the current SMS billing period
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSmsStatus(productId: number, options?: any): AxiosPromise<SmsStatus> {
            return ProductsApiFp(configuration).getSmsStatus(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create or Update Alert and Alert Subscribers
         * @param {number} productId ID of product to return
         * @param {AlertInData} alertInData User object to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productAlertSubscribers(productId: number, alertInData: AlertInData, options?: any): AxiosPromise<void> {
            return ProductsApiFp(configuration).productAlertSubscribers(productId, alertInData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin signs off on a new product
         * @param {number} productId ID of product to return
         * @param {InlineObject27} inlineObject27 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productAssignFuelSensors(productId: number, inlineObject27: InlineObject27, options?: any): AxiosPromise<void> {
            return ProductsApiFp(configuration).productAssignFuelSensors(productId, inlineObject27, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin signs off on a new product
         * @param {number} productId ID of product to return
         * @param {InlineObject26} inlineObject26 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productAssignSensors(productId: number, inlineObject26: InlineObject26, options?: any): AxiosPromise<void> {
            return ProductsApiFp(configuration).productAssignSensors(productId, inlineObject26, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin signs off on a new product
         * @param {number} productId ID of product to return
         * @param {InlineObject30} inlineObject30 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productFaults(productId: number, inlineObject30: InlineObject30, options?: any): AxiosPromise<void> {
            return ProductsApiFp(configuration).productFaults(productId, inlineObject30, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin signs off on a new product
         * @param {number} productId ID of product to return
         * @param {InlineObject31} inlineObject31 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productFaultsActivity(productId: number, inlineObject31: InlineObject31, options?: any): AxiosPromise<void> {
            return ProductsApiFp(configuration).productFaultsActivity(productId, inlineObject31, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a simPro job for the product
         * @param {number} productId ID of product to return
         * @param {InlineObject32} [inlineObject32] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productJob(productId: number, inlineObject32?: InlineObject32, options?: any): AxiosPromise<void> {
            return ProductsApiFp(configuration).productJob(productId, inlineObject32, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a simPro job for the product
         * @param {number} productId ID of product to return
         * @param {'install' | 'repair' | 'remove'} jobType 
         * @param {ProductSimProJob} [productSimProJob] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSimProJob(productId: number, jobType: 'install' | 'repair' | 'remove', productSimProJob?: ProductSimProJob, options?: any): AxiosPromise<void> {
            return ProductsApiFp(configuration).productSimProJob(productId, jobType, productSimProJob, options).then((request) => request(axios, basePath));
        },
        /**
         * Set or update a product trial
         * @param {number} id ID of entity to return
         * @param {ProductTrialInData} [productTrialInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTrial(id: number, productTrialInData?: ProductTrialInData, options?: any): AxiosPromise<SubscriptionItemInData> {
            return ProductsApiFp(configuration).productTrial(id, productTrialInData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin update to vat labels
         * @param {number} productId ID of product to return
         * @param {VatLabelsInData} vatLabelsInData Product object to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productVatLabels(productId: number, vatLabelsInData: VatLabelsInData, options?: any): AxiosPromise<ProductInData> {
            return ProductsApiFp(configuration).productVatLabels(productId, vatLabelsInData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin updates offset for vats
         * @param {number} productId ID of product to return
         * @param {InlineObject29} inlineObject29 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productVatsetup(productId: number, inlineObject29: InlineObject29, options?: any): AxiosPromise<void> {
            return ProductsApiFp(configuration).productVatsetup(productId, inlineObject29, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the users from Classic that map to the fuel tanks assigned to the product
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsGetClassicUsers(productId: number, options?: any): AxiosPromise<Array<object>> {
            return ProductsApiFp(configuration).productsGetClassicUsers(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves a list of products with faults
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsGetFaults(options?: any): AxiosPromise<ProductFaultStatusInData> {
            return ProductsApiFp(configuration).productsGetFaults(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the number of alerts sent out for a product
         * @param {number} productId ID of product to return
         * @param {string} [startDate] Oldest alert date to include, defaults to first of month
         * @param {string} [endDate] Newest alert date to include, defaults to today
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsNumNotifications(productId: number, startDate?: string, endDate?: string, options?: any): AxiosPromise<NumNotificationsInData> {
            return ProductsApiFp(configuration).productsNumNotifications(productId, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new product
         * @param {StoreProductInData} [storeProductInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeProduct(storeProductInData?: StoreProductInData, options?: any): AxiosPromise<ProductInData> {
            return ProductsApiFp(configuration).storeProduct(storeProductInData, options).then((request) => request(axios, basePath));
        },
        /**
         * Set or update the current Ordway subscription plans
         * @param {UpdateBilling} [updateBilling] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBilling(updateBilling?: UpdateBilling, options?: any): AxiosPromise<void> {
            return ProductsApiFp(configuration).updateBilling(updateBilling, options).then((request) => request(axios, basePath));
        },
        /**
         * Set or update the current Ordway subscription plans
         * @param {number} productId ID of product to return
         * @param {OrdwayPlans} [ordwayPlans] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrdwayPlans(productId: number, ordwayPlans?: OrdwayPlans, options?: any): AxiosPromise<void> {
            return ProductsApiFp(configuration).updateOrdwayPlans(productId, ordwayPlans, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates a product
         * @param {number} productId ID of product to return
         * @param {ProductInData} productInData Product object to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProduct(productId: number, productInData: ProductInData, options?: any): AxiosPromise<void> {
            return ProductsApiFp(configuration).updateProduct(productId, productInData, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductsApi - object-oriented interface
 * @export
 * @class ProductsApi
 * @extends {BaseAPI}
 */
export class ProductsApi extends BaseAPI {
    /**
     * 
     * @summary Add a new product
     * @param {ProductInData} productInData product object to be added
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public addProduct(productInData: ProductInData, options?: any) {
        return ProductsApiFp(this.configuration).addProduct(productInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add a new product, site and entities (e.g. vats, tanks)
     * @param {InlineObject25} inlineObject25 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public addProductOrg(inlineObject25: InlineObject25, options?: any) {
        return ProductsApiFp(this.configuration).addProductOrg(inlineObject25, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cancel a product
     * @param {number} productId ID of product to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public cancelProduct(productId: number, options?: any) {
        return ProductsApiFp(this.configuration).cancelProduct(productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin signs off on a new product
     * @param {number} productId ID of product to return
     * @param {InlineObject28} inlineObject28 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public changeDevice(productId: number, inlineObject28: InlineObject28, options?: any) {
        return ProductsApiFp(this.configuration).changeDevice(productId, inlineObject28, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the entity and product status
     * @param {number} productId ID of product to return
     * @param {Entities} entityType Type of entity to return
     * @param {number} entityId Id of entity to return
     * @param {ProductStatusChange} [productStatusChange] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public changeProductStatus(productId: number, entityType: Entities, entityId: number, productStatusChange?: ProductStatusChange, options?: any) {
        return ProductsApiFp(this.configuration).changeProductStatus(productId, entityType, entityId, productStatusChange, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Construct the simPro job story for the product
     * @param {number} productId ID of product to return
     * @param {ProductSimProJobInData} [productSimProJobInData] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public constructJobStory(productId: number, productSimProJobInData?: ProductSimProJobInData, options?: any) {
        return ProductsApiFp(this.configuration).constructJobStory(productId, productSimProJobInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets the current billing setup
     * @param {number} productId ID of product to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public currentBilling(productId: number, options?: any) {
        return ProductsApiFp(this.configuration).currentBilling(productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deactivate a product
     * @param {number} productId ID of product to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public deactivateProduct(productId: number, options?: any) {
        return ProductsApiFp(this.configuration).deactivateProduct(productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes a product
     * @param {number} productId ID of product to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public deleteProduct(productId: number, options?: any) {
        return ProductsApiFp(this.configuration).deleteProduct(productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets the available tiers for direct customer tpye based on partner contribution tier
     * @param {ProductType} productType Type of product to return
     * @param {ContributionTierInData} [contributionTierInData] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getAvailableTiers(productType: ProductType, contributionTierInData?: ContributionTierInData, options?: any) {
        return ProductsApiFp(this.configuration).getAvailableTiers(productType, contributionTierInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets the current “billing period” of un-charged SMS alerts and their status
     * @param {number} productId ID of product to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getCurrentSmsDeliveryLogs(productId: number, options?: any) {
        return ProductsApiFp(this.configuration).getCurrentSmsDeliveryLogs(productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all pending text messages for a product
     * @summary Get product pending texts
     * @param {number} productId ID of product to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getPendingTexts(productId: number, options?: any) {
        return ProductsApiFp(this.configuration).getPendingTexts(productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns product alerts
     * @summary Get product alerts
     * @param {number} productId ID of product to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getProductAlerts(productId: number, options?: any) {
        return ProductsApiFp(this.configuration).getProductAlerts(productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve list of user id valid with product tier limits
     * @param {number} id ID of entity to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getProductAllowedUsers(id: number, options?: any) {
        return ProductsApiFp(this.configuration).getProductAllowedUsers(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a product
     * @summary Find product by productId
     * @param {number} productId ID of product to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getProductById(productId: number, options?: any) {
        return ProductsApiFp(this.configuration).getProductById(productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a product dashboard
     * @summary Get product dashboard data
     * @param {number} productId ID of product to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getProductDash(productId: number, options?: any) {
        return ProductsApiFp(this.configuration).getProductDash(productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the list of direct plans to be used for billing
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getProductDirectPlans(options?: any) {
        return ProductsApiFp(this.configuration).getProductDirectPlans(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a products events
     * @summary Get product events
     * @param {number} productId ID of product to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getProductEvents(productId: number, options?: any) {
        return ProductsApiFp(this.configuration).getProductEvents(productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a fuel product dashboard
     * @summary Get a fuel product dashboard data
     * @param {number} productId ID of product to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getProductFuelDash(productId: number, options?: any) {
        return ProductsApiFp(this.configuration).getProductFuelDash(productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a milk product dashboard
     * @summary Get a milk product dashboard data
     * @param {number} productId ID of product to return
     * @param {number} [nDays] return only this many days worth of data. Default &#x3D; 2 usually
     * @param {Array<string>} [include] comma separated list of additional related objects to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getProductMilkDash(productId: number, nDays?: number, include?: Array<string>, options?: any) {
        return ProductsApiFp(this.configuration).getProductMilkDash(productId, nDays, include, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a milk product milking time data
     * @param {number} productId ID of product to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getProductMilkingTimeWindow(productId: number, options?: any) {
        return ProductsApiFp(this.configuration).getProductMilkingTimeWindow(productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve number of users permitted access to the product based on the active tier
     * @param {number} id ID of entity to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getProductNumUsersAllowed(id: number, options?: any) {
        return ProductsApiFp(this.configuration).getProductNumUsersAllowed(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all orgs with a partner relationship to product
     * @param {number} productId ID of product to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getProductPartnerOrgs(productId: number, options?: any) {
        return ProductsApiFp(this.configuration).getProductPartnerOrgs(productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all products
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getProducts(options?: any) {
        return ProductsApiFp(this.configuration).getProducts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all sent text messages for a product
     * @summary Get product sent texts
     * @param {number} productId ID of product to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getSentTexts(productId: number, options?: any) {
        return ProductsApiFp(this.configuration).getSentTexts(productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the history of processed SMS alerts
     * @param {number} productId ID of product to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getSmsProductCharges(productId: number, options?: any) {
        return ProductsApiFp(this.configuration).getSmsProductCharges(productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the detail SMS delivery logs for a given SMS product charge
     * @param {number} productId ID of product to return
     * @param {number} smsProductChargeId ID of SMS product charges record to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getSmsProductChargesDetail(productId: number, smsProductChargeId: number, options?: any) {
        return ProductsApiFp(this.configuration).getSmsProductChargesDetail(productId, smsProductChargeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the status of the current SMS billing period
     * @param {number} productId ID of product to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getSmsStatus(productId: number, options?: any) {
        return ProductsApiFp(this.configuration).getSmsStatus(productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create or Update Alert and Alert Subscribers
     * @param {number} productId ID of product to return
     * @param {AlertInData} alertInData User object to be updated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public productAlertSubscribers(productId: number, alertInData: AlertInData, options?: any) {
        return ProductsApiFp(this.configuration).productAlertSubscribers(productId, alertInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin signs off on a new product
     * @param {number} productId ID of product to return
     * @param {InlineObject27} inlineObject27 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public productAssignFuelSensors(productId: number, inlineObject27: InlineObject27, options?: any) {
        return ProductsApiFp(this.configuration).productAssignFuelSensors(productId, inlineObject27, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin signs off on a new product
     * @param {number} productId ID of product to return
     * @param {InlineObject26} inlineObject26 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public productAssignSensors(productId: number, inlineObject26: InlineObject26, options?: any) {
        return ProductsApiFp(this.configuration).productAssignSensors(productId, inlineObject26, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin signs off on a new product
     * @param {number} productId ID of product to return
     * @param {InlineObject30} inlineObject30 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public productFaults(productId: number, inlineObject30: InlineObject30, options?: any) {
        return ProductsApiFp(this.configuration).productFaults(productId, inlineObject30, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin signs off on a new product
     * @param {number} productId ID of product to return
     * @param {InlineObject31} inlineObject31 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public productFaultsActivity(productId: number, inlineObject31: InlineObject31, options?: any) {
        return ProductsApiFp(this.configuration).productFaultsActivity(productId, inlineObject31, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a simPro job for the product
     * @param {number} productId ID of product to return
     * @param {InlineObject32} [inlineObject32] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public productJob(productId: number, inlineObject32?: InlineObject32, options?: any) {
        return ProductsApiFp(this.configuration).productJob(productId, inlineObject32, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a simPro job for the product
     * @param {number} productId ID of product to return
     * @param {'install' | 'repair' | 'remove'} jobType 
     * @param {ProductSimProJob} [productSimProJob] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public productSimProJob(productId: number, jobType: 'install' | 'repair' | 'remove', productSimProJob?: ProductSimProJob, options?: any) {
        return ProductsApiFp(this.configuration).productSimProJob(productId, jobType, productSimProJob, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set or update a product trial
     * @param {number} id ID of entity to return
     * @param {ProductTrialInData} [productTrialInData] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public productTrial(id: number, productTrialInData?: ProductTrialInData, options?: any) {
        return ProductsApiFp(this.configuration).productTrial(id, productTrialInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin update to vat labels
     * @param {number} productId ID of product to return
     * @param {VatLabelsInData} vatLabelsInData Product object to be updated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public productVatLabels(productId: number, vatLabelsInData: VatLabelsInData, options?: any) {
        return ProductsApiFp(this.configuration).productVatLabels(productId, vatLabelsInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin updates offset for vats
     * @param {number} productId ID of product to return
     * @param {InlineObject29} inlineObject29 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public productVatsetup(productId: number, inlineObject29: InlineObject29, options?: any) {
        return ProductsApiFp(this.configuration).productVatsetup(productId, inlineObject29, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the users from Classic that map to the fuel tanks assigned to the product
     * @param {number} productId ID of product to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public productsGetClassicUsers(productId: number, options?: any) {
        return ProductsApiFp(this.configuration).productsGetClassicUsers(productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves a list of products with faults
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public productsGetFaults(options?: any) {
        return ProductsApiFp(this.configuration).productsGetFaults(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the number of alerts sent out for a product
     * @param {number} productId ID of product to return
     * @param {string} [startDate] Oldest alert date to include, defaults to first of month
     * @param {string} [endDate] Newest alert date to include, defaults to today
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public productsNumNotifications(productId: number, startDate?: string, endDate?: string, options?: any) {
        return ProductsApiFp(this.configuration).productsNumNotifications(productId, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new product
     * @param {StoreProductInData} [storeProductInData] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public storeProduct(storeProductInData?: StoreProductInData, options?: any) {
        return ProductsApiFp(this.configuration).storeProduct(storeProductInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set or update the current Ordway subscription plans
     * @param {UpdateBilling} [updateBilling] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public updateBilling(updateBilling?: UpdateBilling, options?: any) {
        return ProductsApiFp(this.configuration).updateBilling(updateBilling, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set or update the current Ordway subscription plans
     * @param {number} productId ID of product to return
     * @param {OrdwayPlans} [ordwayPlans] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public updateOrdwayPlans(productId: number, ordwayPlans?: OrdwayPlans, options?: any) {
        return ProductsApiFp(this.configuration).updateOrdwayPlans(productId, ordwayPlans, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates a product
     * @param {number} productId ID of product to return
     * @param {ProductInData} productInData Product object to be updated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public updateProduct(productId: number, productInData: ProductInData, options?: any) {
        return ProductsApiFp(this.configuration).updateProduct(productId, productInData, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * SearchApi - axios parameter creator
 * @export
 */
export const SearchApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Search orgs, sites, users, and products
         * @summary Global Search
         * @param {string} [searchTerm] The search term to use for matching search results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search: async (searchTerm?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/search`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SearchApi - functional programming interface
 * @export
 */
export const SearchApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Search orgs, sites, users, and products
         * @summary Global Search
         * @param {string} [searchTerm] The search term to use for matching search results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async search(searchTerm?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchResults>> {
            const localVarAxiosArgs = await SearchApiAxiosParamCreator(configuration).search(searchTerm, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * SearchApi - factory interface
 * @export
 */
export const SearchApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Search orgs, sites, users, and products
         * @summary Global Search
         * @param {string} [searchTerm] The search term to use for matching search results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search(searchTerm?: string, options?: any): AxiosPromise<SearchResults> {
            return SearchApiFp(configuration).search(searchTerm, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SearchApi - object-oriented interface
 * @export
 * @class SearchApi
 * @extends {BaseAPI}
 */
export class SearchApi extends BaseAPI {
    /**
     * Search orgs, sites, users, and products
     * @summary Global Search
     * @param {string} [searchTerm] The search term to use for matching search results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchApi
     */
    public search(searchTerm?: string, options?: any) {
        return SearchApiFp(this.configuration).search(searchTerm, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * SensorsApi - axios parameter creator
 * @export
 */
export const SensorsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a new sensor to the service
         * @param {SensorInData} sensorInData Sensor object to be added to service
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSensor: async (sensorInData: SensorInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sensorInData' is not null or undefined
            if (sensorInData === null || sensorInData === undefined) {
                throw new RequiredError('sensorInData','Required parameter sensorInData was null or undefined when calling addSensor.');
            }
            const localVarPath = `/sensors`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof sensorInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(sensorInData !== undefined ? sensorInData : {}) : (sensorInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deallocate a sensor
         * @param {number} sensorId ID of sensor to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deallocateSensor: async (sensorId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sensorId' is not null or undefined
            if (sensorId === null || sensorId === undefined) {
                throw new RequiredError('sensorId','Required parameter sensorId was null or undefined when calling deallocateSensor.');
            }
            const localVarPath = `/sensors/{sensorId}/deallocate`
                .replace(`{${"sensorId"}}`, encodeURIComponent(String(sensorId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Decommission a sensor
         * @param {number} sensorId ID of sensor to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        decommissionSensor: async (sensorId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sensorId' is not null or undefined
            if (sensorId === null || sensorId === undefined) {
                throw new RequiredError('sensorId','Required parameter sensorId was null or undefined when calling decommissionSensor.');
            }
            const localVarPath = `/sensors/{sensorId}/decommission`
                .replace(`{${"sensorId"}}`, encodeURIComponent(String(sensorId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes a sensor
         * @param {number} sensorId ID of sensor to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSensor: async (sensorId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sensorId' is not null or undefined
            if (sensorId === null || sensorId === undefined) {
                throw new RequiredError('sensorId','Required parameter sensorId was null or undefined when calling deleteSensor.');
            }
            const localVarPath = `/sensors/{sensorId}`
                .replace(`{${"sensorId"}}`, encodeURIComponent(String(sensorId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a sensor
         * @summary Find sensor by ID
         * @param {number} sensorId ID of sensor to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSensorById: async (sensorId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sensorId' is not null or undefined
            if (sensorId === null || sensorId === undefined) {
                throw new RequiredError('sensorId','Required parameter sensorId was null or undefined when calling getSensorById.');
            }
            const localVarPath = `/sensors/{sensorId}`
                .replace(`{${"sensorId"}}`, encodeURIComponent(String(sensorId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a sensors Dashboard
         * @summary Get sensors Dashboard Data
         * @param {number} sensorId ID of sensor to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSensorDash: async (sensorId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sensorId' is not null or undefined
            if (sensorId === null || sensorId === undefined) {
                throw new RequiredError('sensorId','Required parameter sensorId was null or undefined when calling getSensorDash.');
            }
            const localVarPath = `/sensors/{sensorId}/dash`
                .replace(`{${"sensorId"}}`, encodeURIComponent(String(sensorId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns sensor raw data
         * @summary get Sensor Data
         * @param {number} sensorId ID of sensor to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSensorData: async (sensorId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sensorId' is not null or undefined
            if (sensorId === null || sensorId === undefined) {
                throw new RequiredError('sensorId','Required parameter sensorId was null or undefined when calling getSensorData.');
            }
            const localVarPath = `/sensors/{sensorId}/data`
                .replace(`{${"sensorId"}}`, encodeURIComponent(String(sensorId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns Sensor diagnostic data
         * @summary Get sensor diagnostic data
         * @param {number} sensorId ID of sensor to return
         * @param {number} [nDays] return only this many days worth of data. Default &#x3D; 2 usually
         * @param {string} [series] return one series
         * @param {string} [offset] go back X days
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSensorGraphData: async (sensorId: number, nDays?: number, series?: string, offset?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sensorId' is not null or undefined
            if (sensorId === null || sensorId === undefined) {
                throw new RequiredError('sensorId','Required parameter sensorId was null or undefined when calling getSensorGraphData.');
            }
            const localVarPath = `/sensors/{sensorId}/graphData`
                .replace(`{${"sensorId"}}`, encodeURIComponent(String(sensorId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (nDays !== undefined) {
                localVarQueryParameter['nDays'] = nDays;
            }

            if (series !== undefined) {
                localVarQueryParameter['series'] = series;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get last check in time for a sensor
         * @param {number} sensorId ID of sensor to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSensorLastCheckInTime: async (sensorId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sensorId' is not null or undefined
            if (sensorId === null || sensorId === undefined) {
                throw new RequiredError('sensorId','Required parameter sensorId was null or undefined when calling getSensorLastCheckInTime.');
            }
            const localVarPath = `/sensors/{sensorId}/lastCheckIn`
                .replace(`{${"sensorId"}}`, encodeURIComponent(String(sensorId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves the Dynamo metadata for the sensor
         * @param {number} sensorId ID of sensor to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSensorProperties: async (sensorId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sensorId' is not null or undefined
            if (sensorId === null || sensorId === undefined) {
                throw new RequiredError('sensorId','Required parameter sensorId was null or undefined when calling getSensorProperties.');
            }
            const localVarPath = `/sensors/{sensorId}/properties`
                .replace(`{${"sensorId"}}`, encodeURIComponent(String(sensorId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns raw data
         * @summary Get Dynamo raw data for a given sensor
         * @param {number} sensorId ID of sensor to return
         * @param {number} [limit] Number of items to return
         * @param {string} [exclusiveStartSortKey] Used for pagination, sortKey to start the search, (use sortKey from result)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSensorRawData: async (sensorId: number, limit?: number, exclusiveStartSortKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sensorId' is not null or undefined
            if (sensorId === null || sensorId === undefined) {
                throw new RequiredError('sensorId','Required parameter sensorId was null or undefined when calling getSensorRawData.');
            }
            const localVarPath = `/sensors/{sensorId}/rawData`
                .replace(`{${"sensorId"}}`, encodeURIComponent(String(sensorId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (exclusiveStartSortKey !== undefined) {
                localVarQueryParameter['exclusiveStartSortKey'] = exclusiveStartSortKey;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns sensor data series
         * @summary get Sensor Data
         * @param {number} sensorId ID of sensor to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSensorSeriesData: async (sensorId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sensorId' is not null or undefined
            if (sensorId === null || sensorId === undefined) {
                throw new RequiredError('sensorId','Required parameter sensorId was null or undefined when calling getSensorSeriesData.');
            }
            const localVarPath = `/sensors/{sensorId}/series`
                .replace(`{${"sensorId"}}`, encodeURIComponent(String(sensorId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * returns all sensors
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSensors: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/sensors`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Graph data for an entity
         * @param {'sensor' | 'transceiver' | 'vat'} entity entity to return
         * @param {number} id ID of entity to return
         * @param {number} startTs Start epoch timestamp to consider
         * @param {number} endTs End epoch timestamp to consider
         * @param {string} [series] Return one series
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graph: async (entity: 'sensor' | 'transceiver' | 'vat', id: number, startTs: number, endTs: number, series?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'entity' is not null or undefined
            if (entity === null || entity === undefined) {
                throw new RequiredError('entity','Required parameter entity was null or undefined when calling graph.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling graph.');
            }
            // verify required parameter 'startTs' is not null or undefined
            if (startTs === null || startTs === undefined) {
                throw new RequiredError('startTs','Required parameter startTs was null or undefined when calling graph.');
            }
            // verify required parameter 'endTs' is not null or undefined
            if (endTs === null || endTs === undefined) {
                throw new RequiredError('endTs','Required parameter endTs was null or undefined when calling graph.');
            }
            const localVarPath = `/graphs/{entity}/{id}`
                .replace(`{${"entity"}}`, encodeURIComponent(String(entity)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (startTs !== undefined) {
                localVarQueryParameter['startTs'] = startTs;
            }

            if (endTs !== undefined) {
                localVarQueryParameter['endTs'] = endTs;
            }

            if (series !== undefined) {
                localVarQueryParameter['series'] = series;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Publish Background Model To Transceiver
         * @param {number} sensorId ID of sensor to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishBackgroundModel: async (sensorId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sensorId' is not null or undefined
            if (sensorId === null || sensorId === undefined) {
                throw new RequiredError('sensorId','Required parameter sensorId was null or undefined when calling publishBackgroundModel.');
            }
            const localVarPath = `/sensors/{sensorId}/publishRadarBackgroundModel`
                .replace(`{${"sensorId"}}`, encodeURIComponent(String(sensorId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates a sensor
         * @param {number} sensorId ID of sensor to return
         * @param {SensorInData} sensorInData Sensor object to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSensor: async (sensorId: number, sensorInData: SensorInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sensorId' is not null or undefined
            if (sensorId === null || sensorId === undefined) {
                throw new RequiredError('sensorId','Required parameter sensorId was null or undefined when calling updateSensor.');
            }
            // verify required parameter 'sensorInData' is not null or undefined
            if (sensorInData === null || sensorInData === undefined) {
                throw new RequiredError('sensorInData','Required parameter sensorInData was null or undefined when calling updateSensor.');
            }
            const localVarPath = `/sensors/{sensorId}`
                .replace(`{${"sensorId"}}`, encodeURIComponent(String(sensorId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof sensorInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(sensorInData !== undefined ? sensorInData : {}) : (sensorInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SensorsApi - functional programming interface
 * @export
 */
export const SensorsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a new sensor to the service
         * @param {SensorInData} sensorInData Sensor object to be added to service
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addSensor(sensorInData: SensorInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await SensorsApiAxiosParamCreator(configuration).addSensor(sensorInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Deallocate a sensor
         * @param {number} sensorId ID of sensor to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deallocateSensor(sensorId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Sensor>> {
            const localVarAxiosArgs = await SensorsApiAxiosParamCreator(configuration).deallocateSensor(sensorId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Decommission a sensor
         * @param {number} sensorId ID of sensor to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async decommissionSensor(sensorId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SensorInData>> {
            const localVarAxiosArgs = await SensorsApiAxiosParamCreator(configuration).decommissionSensor(sensorId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Deletes a sensor
         * @param {number} sensorId ID of sensor to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSensor(sensorId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await SensorsApiAxiosParamCreator(configuration).deleteSensor(sensorId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns a sensor
         * @summary Find sensor by ID
         * @param {number} sensorId ID of sensor to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSensorById(sensorId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Sensor>> {
            const localVarAxiosArgs = await SensorsApiAxiosParamCreator(configuration).getSensorById(sensorId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns a sensors Dashboard
         * @summary Get sensors Dashboard Data
         * @param {number} sensorId ID of sensor to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSensorDash(sensorId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SensorDash>> {
            const localVarAxiosArgs = await SensorsApiAxiosParamCreator(configuration).getSensorDash(sensorId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns sensor raw data
         * @summary get Sensor Data
         * @param {number} sensorId ID of sensor to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSensorData(sensorId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RawDataInData>> {
            const localVarAxiosArgs = await SensorsApiAxiosParamCreator(configuration).getSensorData(sensorId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns Sensor diagnostic data
         * @summary Get sensor diagnostic data
         * @param {number} sensorId ID of sensor to return
         * @param {number} [nDays] return only this many days worth of data. Default &#x3D; 2 usually
         * @param {string} [series] return one series
         * @param {string} [offset] go back X days
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSensorGraphData(sensorId: number, nDays?: number, series?: string, offset?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SensorGraphDataInData>> {
            const localVarAxiosArgs = await SensorsApiAxiosParamCreator(configuration).getSensorGraphData(sensorId, nDays, series, offset, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get last check in time for a sensor
         * @param {number} sensorId ID of sensor to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSensorLastCheckInTime(sensorId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LastCheckInTimeInData>> {
            const localVarAxiosArgs = await SensorsApiAxiosParamCreator(configuration).getSensorLastCheckInTime(sensorId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Retrieves the Dynamo metadata for the sensor
         * @param {number} sensorId ID of sensor to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSensorProperties(sensorId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FuelSensorMetaDataInData>> {
            const localVarAxiosArgs = await SensorsApiAxiosParamCreator(configuration).getSensorProperties(sensorId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns raw data
         * @summary Get Dynamo raw data for a given sensor
         * @param {number} sensorId ID of sensor to return
         * @param {number} [limit] Number of items to return
         * @param {string} [exclusiveStartSortKey] Used for pagination, sortKey to start the search, (use sortKey from result)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSensorRawData(sensorId: number, limit?: number, exclusiveStartSortKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await SensorsApiAxiosParamCreator(configuration).getSensorRawData(sensorId, limit, exclusiveStartSortKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns sensor data series
         * @summary get Sensor Data
         * @param {number} sensorId ID of sensor to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSensorSeriesData(sensorId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeSeriesInData>> {
            const localVarAxiosArgs = await SensorsApiAxiosParamCreator(configuration).getSensorSeriesData(sensorId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * returns all sensors
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSensors(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SensorsInData>> {
            const localVarAxiosArgs = await SensorsApiAxiosParamCreator(configuration).getSensors(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Graph data for an entity
         * @param {'sensor' | 'transceiver' | 'vat'} entity entity to return
         * @param {number} id ID of entity to return
         * @param {number} startTs Start epoch timestamp to consider
         * @param {number} endTs End epoch timestamp to consider
         * @param {string} [series] Return one series
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async graph(entity: 'sensor' | 'transceiver' | 'vat', id: number, startTs: number, endTs: number, series?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GraphTimeSeriesInData>> {
            const localVarAxiosArgs = await SensorsApiAxiosParamCreator(configuration).graph(entity, id, startTs, endTs, series, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Publish Background Model To Transceiver
         * @param {number} sensorId ID of sensor to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publishBackgroundModel(sensorId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await SensorsApiAxiosParamCreator(configuration).publishBackgroundModel(sensorId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Updates a sensor
         * @param {number} sensorId ID of sensor to return
         * @param {SensorInData} sensorInData Sensor object to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSensor(sensorId: number, sensorInData: SensorInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await SensorsApiAxiosParamCreator(configuration).updateSensor(sensorId, sensorInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * SensorsApi - factory interface
 * @export
 */
export const SensorsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Add a new sensor to the service
         * @param {SensorInData} sensorInData Sensor object to be added to service
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSensor(sensorInData: SensorInData, options?: any): AxiosPromise<void> {
            return SensorsApiFp(configuration).addSensor(sensorInData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deallocate a sensor
         * @param {number} sensorId ID of sensor to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deallocateSensor(sensorId: number, options?: any): AxiosPromise<Sensor> {
            return SensorsApiFp(configuration).deallocateSensor(sensorId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Decommission a sensor
         * @param {number} sensorId ID of sensor to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        decommissionSensor(sensorId: number, options?: any): AxiosPromise<SensorInData> {
            return SensorsApiFp(configuration).decommissionSensor(sensorId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes a sensor
         * @param {number} sensorId ID of sensor to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSensor(sensorId: number, options?: any): AxiosPromise<void> {
            return SensorsApiFp(configuration).deleteSensor(sensorId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a sensor
         * @summary Find sensor by ID
         * @param {number} sensorId ID of sensor to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSensorById(sensorId: number, options?: any): AxiosPromise<Sensor> {
            return SensorsApiFp(configuration).getSensorById(sensorId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a sensors Dashboard
         * @summary Get sensors Dashboard Data
         * @param {number} sensorId ID of sensor to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSensorDash(sensorId: number, options?: any): AxiosPromise<SensorDash> {
            return SensorsApiFp(configuration).getSensorDash(sensorId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns sensor raw data
         * @summary get Sensor Data
         * @param {number} sensorId ID of sensor to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSensorData(sensorId: number, options?: any): AxiosPromise<RawDataInData> {
            return SensorsApiFp(configuration).getSensorData(sensorId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns Sensor diagnostic data
         * @summary Get sensor diagnostic data
         * @param {number} sensorId ID of sensor to return
         * @param {number} [nDays] return only this many days worth of data. Default &#x3D; 2 usually
         * @param {string} [series] return one series
         * @param {string} [offset] go back X days
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSensorGraphData(sensorId: number, nDays?: number, series?: string, offset?: string, options?: any): AxiosPromise<SensorGraphDataInData> {
            return SensorsApiFp(configuration).getSensorGraphData(sensorId, nDays, series, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get last check in time for a sensor
         * @param {number} sensorId ID of sensor to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSensorLastCheckInTime(sensorId: number, options?: any): AxiosPromise<LastCheckInTimeInData> {
            return SensorsApiFp(configuration).getSensorLastCheckInTime(sensorId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves the Dynamo metadata for the sensor
         * @param {number} sensorId ID of sensor to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSensorProperties(sensorId: number, options?: any): AxiosPromise<FuelSensorMetaDataInData> {
            return SensorsApiFp(configuration).getSensorProperties(sensorId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns raw data
         * @summary Get Dynamo raw data for a given sensor
         * @param {number} sensorId ID of sensor to return
         * @param {number} [limit] Number of items to return
         * @param {string} [exclusiveStartSortKey] Used for pagination, sortKey to start the search, (use sortKey from result)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSensorRawData(sensorId: number, limit?: number, exclusiveStartSortKey?: string, options?: any): AxiosPromise<Array<object>> {
            return SensorsApiFp(configuration).getSensorRawData(sensorId, limit, exclusiveStartSortKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns sensor data series
         * @summary get Sensor Data
         * @param {number} sensorId ID of sensor to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSensorSeriesData(sensorId: number, options?: any): AxiosPromise<TimeSeriesInData> {
            return SensorsApiFp(configuration).getSensorSeriesData(sensorId, options).then((request) => request(axios, basePath));
        },
        /**
         * returns all sensors
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSensors(options?: any): AxiosPromise<SensorsInData> {
            return SensorsApiFp(configuration).getSensors(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Graph data for an entity
         * @param {'sensor' | 'transceiver' | 'vat'} entity entity to return
         * @param {number} id ID of entity to return
         * @param {number} startTs Start epoch timestamp to consider
         * @param {number} endTs End epoch timestamp to consider
         * @param {string} [series] Return one series
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graph(entity: 'sensor' | 'transceiver' | 'vat', id: number, startTs: number, endTs: number, series?: string, options?: any): AxiosPromise<GraphTimeSeriesInData> {
            return SensorsApiFp(configuration).graph(entity, id, startTs, endTs, series, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Publish Background Model To Transceiver
         * @param {number} sensorId ID of sensor to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishBackgroundModel(sensorId: number, options?: any): AxiosPromise<void> {
            return SensorsApiFp(configuration).publishBackgroundModel(sensorId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates a sensor
         * @param {number} sensorId ID of sensor to return
         * @param {SensorInData} sensorInData Sensor object to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSensor(sensorId: number, sensorInData: SensorInData, options?: any): AxiosPromise<void> {
            return SensorsApiFp(configuration).updateSensor(sensorId, sensorInData, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SensorsApi - object-oriented interface
 * @export
 * @class SensorsApi
 * @extends {BaseAPI}
 */
export class SensorsApi extends BaseAPI {
    /**
     * 
     * @summary Add a new sensor to the service
     * @param {SensorInData} sensorInData Sensor object to be added to service
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SensorsApi
     */
    public addSensor(sensorInData: SensorInData, options?: any) {
        return SensorsApiFp(this.configuration).addSensor(sensorInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deallocate a sensor
     * @param {number} sensorId ID of sensor to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SensorsApi
     */
    public deallocateSensor(sensorId: number, options?: any) {
        return SensorsApiFp(this.configuration).deallocateSensor(sensorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Decommission a sensor
     * @param {number} sensorId ID of sensor to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SensorsApi
     */
    public decommissionSensor(sensorId: number, options?: any) {
        return SensorsApiFp(this.configuration).decommissionSensor(sensorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes a sensor
     * @param {number} sensorId ID of sensor to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SensorsApi
     */
    public deleteSensor(sensorId: number, options?: any) {
        return SensorsApiFp(this.configuration).deleteSensor(sensorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a sensor
     * @summary Find sensor by ID
     * @param {number} sensorId ID of sensor to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SensorsApi
     */
    public getSensorById(sensorId: number, options?: any) {
        return SensorsApiFp(this.configuration).getSensorById(sensorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a sensors Dashboard
     * @summary Get sensors Dashboard Data
     * @param {number} sensorId ID of sensor to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SensorsApi
     */
    public getSensorDash(sensorId: number, options?: any) {
        return SensorsApiFp(this.configuration).getSensorDash(sensorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns sensor raw data
     * @summary get Sensor Data
     * @param {number} sensorId ID of sensor to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SensorsApi
     */
    public getSensorData(sensorId: number, options?: any) {
        return SensorsApiFp(this.configuration).getSensorData(sensorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns Sensor diagnostic data
     * @summary Get sensor diagnostic data
     * @param {number} sensorId ID of sensor to return
     * @param {number} [nDays] return only this many days worth of data. Default &#x3D; 2 usually
     * @param {string} [series] return one series
     * @param {string} [offset] go back X days
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SensorsApi
     */
    public getSensorGraphData(sensorId: number, nDays?: number, series?: string, offset?: string, options?: any) {
        return SensorsApiFp(this.configuration).getSensorGraphData(sensorId, nDays, series, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get last check in time for a sensor
     * @param {number} sensorId ID of sensor to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SensorsApi
     */
    public getSensorLastCheckInTime(sensorId: number, options?: any) {
        return SensorsApiFp(this.configuration).getSensorLastCheckInTime(sensorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves the Dynamo metadata for the sensor
     * @param {number} sensorId ID of sensor to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SensorsApi
     */
    public getSensorProperties(sensorId: number, options?: any) {
        return SensorsApiFp(this.configuration).getSensorProperties(sensorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns raw data
     * @summary Get Dynamo raw data for a given sensor
     * @param {number} sensorId ID of sensor to return
     * @param {number} [limit] Number of items to return
     * @param {string} [exclusiveStartSortKey] Used for pagination, sortKey to start the search, (use sortKey from result)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SensorsApi
     */
    public getSensorRawData(sensorId: number, limit?: number, exclusiveStartSortKey?: string, options?: any) {
        return SensorsApiFp(this.configuration).getSensorRawData(sensorId, limit, exclusiveStartSortKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns sensor data series
     * @summary get Sensor Data
     * @param {number} sensorId ID of sensor to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SensorsApi
     */
    public getSensorSeriesData(sensorId: number, options?: any) {
        return SensorsApiFp(this.configuration).getSensorSeriesData(sensorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * returns all sensors
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SensorsApi
     */
    public getSensors(options?: any) {
        return SensorsApiFp(this.configuration).getSensors(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Graph data for an entity
     * @param {'sensor' | 'transceiver' | 'vat'} entity entity to return
     * @param {number} id ID of entity to return
     * @param {number} startTs Start epoch timestamp to consider
     * @param {number} endTs End epoch timestamp to consider
     * @param {string} [series] Return one series
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SensorsApi
     */
    public graph(entity: 'sensor' | 'transceiver' | 'vat', id: number, startTs: number, endTs: number, series?: string, options?: any) {
        return SensorsApiFp(this.configuration).graph(entity, id, startTs, endTs, series, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Publish Background Model To Transceiver
     * @param {number} sensorId ID of sensor to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SensorsApi
     */
    public publishBackgroundModel(sensorId: number, options?: any) {
        return SensorsApiFp(this.configuration).publishBackgroundModel(sensorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates a sensor
     * @param {number} sensorId ID of sensor to return
     * @param {SensorInData} sensorInData Sensor object to be updated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SensorsApi
     */
    public updateSensor(sensorId: number, sensorInData: SensorInData, options?: any) {
        return SensorsApiFp(this.configuration).updateSensor(sensorId, sensorInData, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * SimproApi - axios parameter creator
 * @export
 */
export const SimproApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Deletes a simPRO job
         * @param {number} simproJobId ID of simpro job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSimproJob: async (simproJobId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'simproJobId' is not null or undefined
            if (simproJobId === null || simproJobId === undefined) {
                throw new RequiredError('simproJobId','Required parameter simproJobId was null or undefined when calling deleteSimproJob.');
            }
            const localVarPath = `/simprojobs/{simproJobId}`
                .replace(`{${"simproJobId"}}`, encodeURIComponent(String(simproJobId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sets the job status to Priority and assigns appropriate technician in simPRO
         * @summary Escalate a job to priority
         * @param {number} simproJobId ID of simpro job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        escalateJobToPriority: async (simproJobId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'simproJobId' is not null or undefined
            if (simproJobId === null || simproJobId === undefined) {
                throw new RequiredError('simproJobId','Required parameter simproJobId was null or undefined when calling escalateJobToPriority.');
            }
            const localVarPath = `/simprojobs/{simproJobId}/escalateToPriority`
                .replace(`{${"simproJobId"}}`, encodeURIComponent(String(simproJobId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the job story parameters used to create the job story
         * @summary Get job story parameters
         * @param {number} simproJobId ID of simpro job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobStoryParameters: async (simproJobId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'simproJobId' is not null or undefined
            if (simproJobId === null || simproJobId === undefined) {
                throw new RequiredError('simproJobId','Required parameter simproJobId was null or undefined when calling getJobStoryParameters.');
            }
            const localVarPath = `/simprojobs/{simproJobId}/jobStoryParameters`
                .replace(`{${"simproJobId"}}`, encodeURIComponent(String(simproJobId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a simpro job
         * @summary Get simPRO job by ID
         * @param {number} simproJobId ID of simpro job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimproJob: async (simproJobId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'simproJobId' is not null or undefined
            if (simproJobId === null || simproJobId === undefined) {
                throw new RequiredError('simproJobId','Required parameter simproJobId was null or undefined when calling getSimproJob.');
            }
            const localVarPath = `/simprojobs/{simproJobId}`
                .replace(`{${"simproJobId"}}`, encodeURIComponent(String(simproJobId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a simpro job\'s details
         * @summary Get simPRO job details by ID
         * @param {number} simproJobId ID of simpro job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimproJobDetails: async (simproJobId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'simproJobId' is not null or undefined
            if (simproJobId === null || simproJobId === undefined) {
                throw new RequiredError('simproJobId','Required parameter simproJobId was null or undefined when calling getSimproJobDetails.');
            }
            const localVarPath = `/simprojobs/{simproJobId}/details`
                .replace(`{${"simproJobId"}}`, encodeURIComponent(String(simproJobId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * returns all simpro jobs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimproJobs: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/simprojobs`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all work notes for a simPRO job entered by an installer
         * @summary Get simPRO job notes from installer
         * @param {number} simproJobId ID of simpro job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveSimproWorkNotes: async (simproJobId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'simproJobId' is not null or undefined
            if (simproJobId === null || simproJobId === undefined) {
                throw new RequiredError('simproJobId','Required parameter simproJobId was null or undefined when calling retrieveSimproWorkNotes.');
            }
            const localVarPath = `/simprojobs/{simproJobId}/workNotes`
                .replace(`{${"simproJobId"}}`, encodeURIComponent(String(simproJobId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sets the job status to New Service and assigns appropriate technician in simPRO
         * @summary Set job status to New Service
         * @param {number} simproJobId ID of simpro job
         * @param {SimproJobStatusDataInData} [simproJobStatusDataInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setStatusToNewService: async (simproJobId: number, simproJobStatusDataInData?: SimproJobStatusDataInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'simproJobId' is not null or undefined
            if (simproJobId === null || simproJobId === undefined) {
                throw new RequiredError('simproJobId','Required parameter simproJobId was null or undefined when calling setStatusToNewService.');
            }
            const localVarPath = `/simprojobs/{simproJobId}/setStatusToNewService`
                .replace(`{${"simproJobId"}}`, encodeURIComponent(String(simproJobId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof simproJobStatusDataInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(simproJobStatusDataInData !== undefined ? simproJobStatusDataInData : {}) : (simproJobStatusDataInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates a simPRO job
         * @param {number} simproJobId ID of simpro job
         * @param {SimproJobInData} [simproJobInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSimproJob: async (simproJobId: number, simproJobInData?: SimproJobInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'simproJobId' is not null or undefined
            if (simproJobId === null || simproJobId === undefined) {
                throw new RequiredError('simproJobId','Required parameter simproJobId was null or undefined when calling updateSimproJob.');
            }
            const localVarPath = `/simprojobs/{simproJobId}`
                .replace(`{${"simproJobId"}}`, encodeURIComponent(String(simproJobId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof simproJobInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(simproJobInData !== undefined ? simproJobInData : {}) : (simproJobInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the job story (name and description) of a simPRO job
         * @summary Update the job story of a simPRO job
         * @param {number} simproJobId ID of simpro job
         * @param {SimproJobStory} [simproJobStory] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSimproJobStory: async (simproJobId: number, simproJobStory?: SimproJobStory, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'simproJobId' is not null or undefined
            if (simproJobId === null || simproJobId === undefined) {
                throw new RequiredError('simproJobId','Required parameter simproJobId was null or undefined when calling updateSimproJobStory.');
            }
            const localVarPath = `/simprojobs/{simproJobId}/updateStory`
                .replace(`{${"simproJobId"}}`, encodeURIComponent(String(simproJobId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof simproJobStory !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(simproJobStory !== undefined ? simproJobStory : {}) : (simproJobStory || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SimproApi - functional programming interface
 * @export
 */
export const SimproApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Deletes a simPRO job
         * @param {number} simproJobId ID of simpro job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSimproJob(simproJobId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await SimproApiAxiosParamCreator(configuration).deleteSimproJob(simproJobId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Sets the job status to Priority and assigns appropriate technician in simPRO
         * @summary Escalate a job to priority
         * @param {number} simproJobId ID of simpro job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async escalateJobToPriority(simproJobId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await SimproApiAxiosParamCreator(configuration).escalateJobToPriority(simproJobId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get the job story parameters used to create the job story
         * @summary Get job story parameters
         * @param {number} simproJobId ID of simpro job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJobStoryParameters(simproJobId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SimproJobStoryParametersInData>> {
            const localVarAxiosArgs = await SimproApiAxiosParamCreator(configuration).getJobStoryParameters(simproJobId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns a simpro job
         * @summary Get simPRO job by ID
         * @param {number} simproJobId ID of simpro job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSimproJob(simproJobId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SimproJobInData>> {
            const localVarAxiosArgs = await SimproApiAxiosParamCreator(configuration).getSimproJob(simproJobId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns a simpro job\'s details
         * @summary Get simPRO job details by ID
         * @param {number} simproJobId ID of simpro job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSimproJobDetails(simproJobId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SimproJobDetailsInData>> {
            const localVarAxiosArgs = await SimproApiAxiosParamCreator(configuration).getSimproJobDetails(simproJobId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * returns all simpro jobs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSimproJobs(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SimproJobsInData>> {
            const localVarAxiosArgs = await SimproApiAxiosParamCreator(configuration).getSimproJobs(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns all work notes for a simPRO job entered by an installer
         * @summary Get simPRO job notes from installer
         * @param {number} simproJobId ID of simpro job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveSimproWorkNotes(simproJobId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SimproJobWorkNote>>> {
            const localVarAxiosArgs = await SimproApiAxiosParamCreator(configuration).retrieveSimproWorkNotes(simproJobId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Sets the job status to New Service and assigns appropriate technician in simPRO
         * @summary Set job status to New Service
         * @param {number} simproJobId ID of simpro job
         * @param {SimproJobStatusDataInData} [simproJobStatusDataInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setStatusToNewService(simproJobId: number, simproJobStatusDataInData?: SimproJobStatusDataInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await SimproApiAxiosParamCreator(configuration).setStatusToNewService(simproJobId, simproJobStatusDataInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Updates a simPRO job
         * @param {number} simproJobId ID of simpro job
         * @param {SimproJobInData} [simproJobInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSimproJob(simproJobId: number, simproJobInData?: SimproJobInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await SimproApiAxiosParamCreator(configuration).updateSimproJob(simproJobId, simproJobInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Updates the job story (name and description) of a simPRO job
         * @summary Update the job story of a simPRO job
         * @param {number} simproJobId ID of simpro job
         * @param {SimproJobStory} [simproJobStory] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSimproJobStory(simproJobId: number, simproJobStory?: SimproJobStory, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SimproUpdatedJobStory>> {
            const localVarAxiosArgs = await SimproApiAxiosParamCreator(configuration).updateSimproJobStory(simproJobId, simproJobStory, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * SimproApi - factory interface
 * @export
 */
export const SimproApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Deletes a simPRO job
         * @param {number} simproJobId ID of simpro job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSimproJob(simproJobId: number, options?: any): AxiosPromise<void> {
            return SimproApiFp(configuration).deleteSimproJob(simproJobId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sets the job status to Priority and assigns appropriate technician in simPRO
         * @summary Escalate a job to priority
         * @param {number} simproJobId ID of simpro job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        escalateJobToPriority(simproJobId: number, options?: any): AxiosPromise<void> {
            return SimproApiFp(configuration).escalateJobToPriority(simproJobId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the job story parameters used to create the job story
         * @summary Get job story parameters
         * @param {number} simproJobId ID of simpro job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobStoryParameters(simproJobId: number, options?: any): AxiosPromise<SimproJobStoryParametersInData> {
            return SimproApiFp(configuration).getJobStoryParameters(simproJobId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a simpro job
         * @summary Get simPRO job by ID
         * @param {number} simproJobId ID of simpro job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimproJob(simproJobId: number, options?: any): AxiosPromise<SimproJobInData> {
            return SimproApiFp(configuration).getSimproJob(simproJobId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a simpro job\'s details
         * @summary Get simPRO job details by ID
         * @param {number} simproJobId ID of simpro job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimproJobDetails(simproJobId: number, options?: any): AxiosPromise<SimproJobDetailsInData> {
            return SimproApiFp(configuration).getSimproJobDetails(simproJobId, options).then((request) => request(axios, basePath));
        },
        /**
         * returns all simpro jobs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimproJobs(options?: any): AxiosPromise<SimproJobsInData> {
            return SimproApiFp(configuration).getSimproJobs(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all work notes for a simPRO job entered by an installer
         * @summary Get simPRO job notes from installer
         * @param {number} simproJobId ID of simpro job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveSimproWorkNotes(simproJobId: number, options?: any): AxiosPromise<Array<SimproJobWorkNote>> {
            return SimproApiFp(configuration).retrieveSimproWorkNotes(simproJobId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sets the job status to New Service and assigns appropriate technician in simPRO
         * @summary Set job status to New Service
         * @param {number} simproJobId ID of simpro job
         * @param {SimproJobStatusDataInData} [simproJobStatusDataInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setStatusToNewService(simproJobId: number, simproJobStatusDataInData?: SimproJobStatusDataInData, options?: any): AxiosPromise<void> {
            return SimproApiFp(configuration).setStatusToNewService(simproJobId, simproJobStatusDataInData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates a simPRO job
         * @param {number} simproJobId ID of simpro job
         * @param {SimproJobInData} [simproJobInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSimproJob(simproJobId: number, simproJobInData?: SimproJobInData, options?: any): AxiosPromise<void> {
            return SimproApiFp(configuration).updateSimproJob(simproJobId, simproJobInData, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the job story (name and description) of a simPRO job
         * @summary Update the job story of a simPRO job
         * @param {number} simproJobId ID of simpro job
         * @param {SimproJobStory} [simproJobStory] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSimproJobStory(simproJobId: number, simproJobStory?: SimproJobStory, options?: any): AxiosPromise<SimproUpdatedJobStory> {
            return SimproApiFp(configuration).updateSimproJobStory(simproJobId, simproJobStory, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SimproApi - object-oriented interface
 * @export
 * @class SimproApi
 * @extends {BaseAPI}
 */
export class SimproApi extends BaseAPI {
    /**
     * 
     * @summary Deletes a simPRO job
     * @param {number} simproJobId ID of simpro job
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SimproApi
     */
    public deleteSimproJob(simproJobId: number, options?: any) {
        return SimproApiFp(this.configuration).deleteSimproJob(simproJobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sets the job status to Priority and assigns appropriate technician in simPRO
     * @summary Escalate a job to priority
     * @param {number} simproJobId ID of simpro job
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SimproApi
     */
    public escalateJobToPriority(simproJobId: number, options?: any) {
        return SimproApiFp(this.configuration).escalateJobToPriority(simproJobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the job story parameters used to create the job story
     * @summary Get job story parameters
     * @param {number} simproJobId ID of simpro job
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SimproApi
     */
    public getJobStoryParameters(simproJobId: number, options?: any) {
        return SimproApiFp(this.configuration).getJobStoryParameters(simproJobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a simpro job
     * @summary Get simPRO job by ID
     * @param {number} simproJobId ID of simpro job
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SimproApi
     */
    public getSimproJob(simproJobId: number, options?: any) {
        return SimproApiFp(this.configuration).getSimproJob(simproJobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a simpro job\'s details
     * @summary Get simPRO job details by ID
     * @param {number} simproJobId ID of simpro job
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SimproApi
     */
    public getSimproJobDetails(simproJobId: number, options?: any) {
        return SimproApiFp(this.configuration).getSimproJobDetails(simproJobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * returns all simpro jobs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SimproApi
     */
    public getSimproJobs(options?: any) {
        return SimproApiFp(this.configuration).getSimproJobs(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all work notes for a simPRO job entered by an installer
     * @summary Get simPRO job notes from installer
     * @param {number} simproJobId ID of simpro job
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SimproApi
     */
    public retrieveSimproWorkNotes(simproJobId: number, options?: any) {
        return SimproApiFp(this.configuration).retrieveSimproWorkNotes(simproJobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sets the job status to New Service and assigns appropriate technician in simPRO
     * @summary Set job status to New Service
     * @param {number} simproJobId ID of simpro job
     * @param {SimproJobStatusDataInData} [simproJobStatusDataInData] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SimproApi
     */
    public setStatusToNewService(simproJobId: number, simproJobStatusDataInData?: SimproJobStatusDataInData, options?: any) {
        return SimproApiFp(this.configuration).setStatusToNewService(simproJobId, simproJobStatusDataInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates a simPRO job
     * @param {number} simproJobId ID of simpro job
     * @param {SimproJobInData} [simproJobInData] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SimproApi
     */
    public updateSimproJob(simproJobId: number, simproJobInData?: SimproJobInData, options?: any) {
        return SimproApiFp(this.configuration).updateSimproJob(simproJobId, simproJobInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the job story (name and description) of a simPRO job
     * @summary Update the job story of a simPRO job
     * @param {number} simproJobId ID of simpro job
     * @param {SimproJobStory} [simproJobStory] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SimproApi
     */
    public updateSimproJobStory(simproJobId: number, simproJobStory?: SimproJobStory, options?: any) {
        return SimproApiFp(this.configuration).updateSimproJobStory(simproJobId, simproJobStory, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * SitesApi - axios parameter creator
 * @export
 */
export const SitesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a new simpro job
         * @param {SimproJobInData} [simproJobInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSimproJob: async (simproJobInData?: SimproJobInData, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/simprojobs`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof simproJobInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(simproJobInData !== undefined ? simproJobInData : {}) : (simproJobInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add a new site
         * @param {SiteInData} [siteInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSite: async (siteInData?: SiteInData, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/sites`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof siteInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(siteInData !== undefined ? siteInData : {}) : (siteInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes a site
         * @param {number} siteId ID site to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSite: async (siteId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'siteId' is not null or undefined
            if (siteId === null || siteId === undefined) {
                throw new RequiredError('siteId','Required parameter siteId was null or undefined when calling deleteSite.');
            }
            const localVarPath = `/sites/{siteId}`
                .replace(`{${"siteId"}}`, encodeURIComponent(String(siteId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a stes
         * @summary Find site by ID
         * @param {number} siteId ID site to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiteById: async (siteId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'siteId' is not null or undefined
            if (siteId === null || siteId === undefined) {
                throw new RequiredError('siteId','Required parameter siteId was null or undefined when calling getSiteById.');
            }
            const localVarPath = `/sites/{siteId}`
                .replace(`{${"siteId"}}`, encodeURIComponent(String(siteId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * returns all sites
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSites: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/sites`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates a site
         * @param {number} siteId ID site to return
         * @param {SiteInData} [siteInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSite: async (siteId: number, siteInData?: SiteInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'siteId' is not null or undefined
            if (siteId === null || siteId === undefined) {
                throw new RequiredError('siteId','Required parameter siteId was null or undefined when calling updateSite.');
            }
            const localVarPath = `/sites/{siteId}`
                .replace(`{${"siteId"}}`, encodeURIComponent(String(siteId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof siteInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(siteInData !== undefined ? siteInData : {}) : (siteInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SitesApi - functional programming interface
 * @export
 */
export const SitesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a new simpro job
         * @param {SimproJobInData} [simproJobInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addSimproJob(simproJobInData?: SimproJobInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await SitesApiAxiosParamCreator(configuration).addSimproJob(simproJobInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Add a new site
         * @param {SiteInData} [siteInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addSite(siteInData?: SiteInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await SitesApiAxiosParamCreator(configuration).addSite(siteInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Deletes a site
         * @param {number} siteId ID site to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSite(siteId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await SitesApiAxiosParamCreator(configuration).deleteSite(siteId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns a stes
         * @summary Find site by ID
         * @param {number} siteId ID site to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSiteById(siteId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SiteInData>> {
            const localVarAxiosArgs = await SitesApiAxiosParamCreator(configuration).getSiteById(siteId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * returns all sites
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSites(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SitesInData>> {
            const localVarAxiosArgs = await SitesApiAxiosParamCreator(configuration).getSites(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Updates a site
         * @param {number} siteId ID site to return
         * @param {SiteInData} [siteInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSite(siteId: number, siteInData?: SiteInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await SitesApiAxiosParamCreator(configuration).updateSite(siteId, siteInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * SitesApi - factory interface
 * @export
 */
export const SitesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Add a new simpro job
         * @param {SimproJobInData} [simproJobInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSimproJob(simproJobInData?: SimproJobInData, options?: any): AxiosPromise<void> {
            return SitesApiFp(configuration).addSimproJob(simproJobInData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add a new site
         * @param {SiteInData} [siteInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSite(siteInData?: SiteInData, options?: any): AxiosPromise<void> {
            return SitesApiFp(configuration).addSite(siteInData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes a site
         * @param {number} siteId ID site to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSite(siteId: number, options?: any): AxiosPromise<void> {
            return SitesApiFp(configuration).deleteSite(siteId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a stes
         * @summary Find site by ID
         * @param {number} siteId ID site to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiteById(siteId: number, options?: any): AxiosPromise<SiteInData> {
            return SitesApiFp(configuration).getSiteById(siteId, options).then((request) => request(axios, basePath));
        },
        /**
         * returns all sites
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSites(options?: any): AxiosPromise<SitesInData> {
            return SitesApiFp(configuration).getSites(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates a site
         * @param {number} siteId ID site to return
         * @param {SiteInData} [siteInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSite(siteId: number, siteInData?: SiteInData, options?: any): AxiosPromise<void> {
            return SitesApiFp(configuration).updateSite(siteId, siteInData, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SitesApi - object-oriented interface
 * @export
 * @class SitesApi
 * @extends {BaseAPI}
 */
export class SitesApi extends BaseAPI {
    /**
     * 
     * @summary Add a new simpro job
     * @param {SimproJobInData} [simproJobInData] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitesApi
     */
    public addSimproJob(simproJobInData?: SimproJobInData, options?: any) {
        return SitesApiFp(this.configuration).addSimproJob(simproJobInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add a new site
     * @param {SiteInData} [siteInData] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitesApi
     */
    public addSite(siteInData?: SiteInData, options?: any) {
        return SitesApiFp(this.configuration).addSite(siteInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes a site
     * @param {number} siteId ID site to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitesApi
     */
    public deleteSite(siteId: number, options?: any) {
        return SitesApiFp(this.configuration).deleteSite(siteId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a stes
     * @summary Find site by ID
     * @param {number} siteId ID site to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitesApi
     */
    public getSiteById(siteId: number, options?: any) {
        return SitesApiFp(this.configuration).getSiteById(siteId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * returns all sites
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitesApi
     */
    public getSites(options?: any) {
        return SitesApiFp(this.configuration).getSites(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates a site
     * @param {number} siteId ID site to return
     * @param {SiteInData} [siteInData] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitesApi
     */
    public updateSite(siteId: number, siteInData?: SiteInData, options?: any) {
        return SitesApiFp(this.configuration).updateSite(siteId, siteInData, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * TanksApi - axios parameter creator
 * @export
 */
export const TanksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a new tank to the service
         * @param {InlineObject40} inlineObject40 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTank: async (inlineObject40: InlineObject40, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'inlineObject40' is not null or undefined
            if (inlineObject40 === null || inlineObject40 === undefined) {
                throw new RequiredError('inlineObject40','Required parameter inlineObject40 was null or undefined when calling addTank.');
            }
            const localVarPath = `/tanks`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof inlineObject40 !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(inlineObject40 !== undefined ? inlineObject40 : {}) : (inlineObject40 || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Assign sensors to a fuel tank
         * @param {number} tankId ID of tank to return
         * @param {InlineObject42} inlineObject42 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignTankSensors: async (tankId: number, inlineObject42: InlineObject42, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'tankId' is not null or undefined
            if (tankId === null || tankId === undefined) {
                throw new RequiredError('tankId','Required parameter tankId was null or undefined when calling assignTankSensors.');
            }
            // verify required parameter 'inlineObject42' is not null or undefined
            if (inlineObject42 === null || inlineObject42 === undefined) {
                throw new RequiredError('inlineObject42','Required parameter inlineObject42 was null or undefined when calling assignTankSensors.');
            }
            const localVarPath = `/tanks/{tankId}/assign`
                .replace(`{${"tankId"}}`, encodeURIComponent(String(tankId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof inlineObject42 !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(inlineObject42 !== undefined ? inlineObject42 : {}) : (inlineObject42 || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cancel a tank
         * @param {number} tankId ID of tank to return
         * @param {CancelEntity} [cancelEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelTank: async (tankId: number, cancelEntity?: CancelEntity, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'tankId' is not null or undefined
            if (tankId === null || tankId === undefined) {
                throw new RequiredError('tankId','Required parameter tankId was null or undefined when calling cancelTank.');
            }
            const localVarPath = `/tanks/{tankId}/cancel`
                .replace(`{${"tankId"}}`, encodeURIComponent(String(tankId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof cancelEntity !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(cancelEntity !== undefined ? cancelEntity : {}) : (cancelEntity || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Move a tank from draft to pending
         * @summary Move a tank from draft to pending
         * @param {number} tankId ID of tank to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmDraftTank: async (tankId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'tankId' is not null or undefined
            if (tankId === null || tankId === undefined) {
                throw new RequiredError('tankId','Required parameter tankId was null or undefined when calling confirmDraftTank.');
            }
            const localVarPath = `/tanks/{tankId}/confirmDraft`
                .replace(`{${"tankId"}}`, encodeURIComponent(String(tankId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes a tank
         * @param {number} tankId ID of tank to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTank: async (tankId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'tankId' is not null or undefined
            if (tankId === null || tankId === undefined) {
                throw new RequiredError('tankId','Required parameter tankId was null or undefined when calling deleteTank.');
            }
            const localVarPath = `/tanks/{tankId}`
                .replace(`{${"tankId"}}`, encodeURIComponent(String(tankId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns current Tank readings
         * @summary Find tank by ID
         * @param {number} tankId ID of tank to return
         * @param {number} [nDays] return only this many days worth of data. Default &#x3D; 2 usually
         * @param {string} [series] return one series
         * @param {string} [offset] go back X days
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFuelGraphData: async (tankId: number, nDays?: number, series?: string, offset?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'tankId' is not null or undefined
            if (tankId === null || tankId === undefined) {
                throw new RequiredError('tankId','Required parameter tankId was null or undefined when calling getFuelGraphData.');
            }
            const localVarPath = `/tanks/{tankId}/graphData`
                .replace(`{${"tankId"}}`, encodeURIComponent(String(tankId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (nDays !== undefined) {
                localVarQueryParameter['nDays'] = nDays;
            }

            if (series !== undefined) {
                localVarQueryParameter['series'] = series;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a tank
         * @summary Find tank by ID
         * @param {number} tankId ID of tank to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTankById: async (tankId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'tankId' is not null or undefined
            if (tankId === null || tankId === undefined) {
                throw new RequiredError('tankId','Required parameter tankId was null or undefined when calling getTankById.');
            }
            const localVarPath = `/tanks/{tankId}`
                .replace(`{${"tankId"}}`, encodeURIComponent(String(tankId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns current Tank changes
         * @summary Find tank by ID
         * @param {number} tankId ID of tank to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTankChanges: async (tankId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'tankId' is not null or undefined
            if (tankId === null || tankId === undefined) {
                throw new RequiredError('tankId','Required parameter tankId was null or undefined when calling getTankChanges.');
            }
            const localVarPath = `/tanks/{tankId}/changes`
                .replace(`{${"tankId"}}`, encodeURIComponent(String(tankId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Daily averages
         * @summary Get tank daily readings
         * @param {number} tankId ID of tank to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTankData: async (tankId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'tankId' is not null or undefined
            if (tankId === null || tankId === undefined) {
                throw new RequiredError('tankId','Required parameter tankId was null or undefined when calling getTankData.');
            }
            const localVarPath = `/tanks/{tankId}/data`
                .replace(`{${"tankId"}}`, encodeURIComponent(String(tankId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves the Dynamo metadata for the tank
         * @param {number} tankId ID of tank to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTankProperties: async (tankId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'tankId' is not null or undefined
            if (tankId === null || tankId === undefined) {
                throw new RequiredError('tankId','Required parameter tankId was null or undefined when calling getTankProperties.');
            }
            const localVarPath = `/tanks/{tankId}/properties`
                .replace(`{${"tankId"}}`, encodeURIComponent(String(tankId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves the Dynamo metadata for the sensor allocated to the tank
         * @param {number} tankId ID of tank to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTankSensorProperties: async (tankId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'tankId' is not null or undefined
            if (tankId === null || tankId === undefined) {
                throw new RequiredError('tankId','Required parameter tankId was null or undefined when calling getTankSensorProperties.');
            }
            const localVarPath = `/tanks/{tankId}/sensorProperties`
                .replace(`{${"tankId"}}`, encodeURIComponent(String(tankId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns sensor raw data
         * @summary get Tank Volume Data with Dynamo Paginatiion
         * @param {number} tankId ID of tank to return
         * @param {string} [series] return one series
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTankVolumeData: async (tankId: number, series?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'tankId' is not null or undefined
            if (tankId === null || tankId === undefined) {
                throw new RequiredError('tankId','Required parameter tankId was null or undefined when calling getTankVolumeData.');
            }
            const localVarPath = `/tanks/{tankId}/readingData`
                .replace(`{${"tankId"}}`, encodeURIComponent(String(tankId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (series !== undefined) {
                localVarQueryParameter['series'] = series;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * returns all tanks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTanks: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/tanks`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Allocate transceiver and sensor(s) to a fuel tank
         * @param {number} tankId ID of tank to return
         * @param {TransceiverSensorInData} transceiverSensorInData Assign transceiver and sensor to a fuel tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installTank: async (tankId: number, transceiverSensorInData: TransceiverSensorInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'tankId' is not null or undefined
            if (tankId === null || tankId === undefined) {
                throw new RequiredError('tankId','Required parameter tankId was null or undefined when calling installTank.');
            }
            // verify required parameter 'transceiverSensorInData' is not null or undefined
            if (transceiverSensorInData === null || transceiverSensorInData === undefined) {
                throw new RequiredError('transceiverSensorInData','Required parameter transceiverSensorInData was null or undefined when calling installTank.');
            }
            const localVarPath = `/tanks/{tankId}/install`
                .replace(`{${"tankId"}}`, encodeURIComponent(String(tankId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof transceiverSensorInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(transceiverSensorInData !== undefined ? transceiverSensorInData : {}) : (transceiverSensorInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Edit the properties of a fuel tank
         * @param {number} tankId ID of tank to return
         * @param {TankInputInData} tankInputInData Edit the properties of a fuel tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        provisionTank: async (tankId: number, tankInputInData: TankInputInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'tankId' is not null or undefined
            if (tankId === null || tankId === undefined) {
                throw new RequiredError('tankId','Required parameter tankId was null or undefined when calling provisionTank.');
            }
            // verify required parameter 'tankInputInData' is not null or undefined
            if (tankInputInData === null || tankInputInData === undefined) {
                throw new RequiredError('tankInputInData','Required parameter tankInputInData was null or undefined when calling provisionTank.');
            }
            const localVarPath = `/tanks/{tankId}/provision`
                .replace(`{${"tankId"}}`, encodeURIComponent(String(tankId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof tankInputInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(tankInputInData !== undefined ? tankInputInData : {}) : (tankInputInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove a tank
         * @param {number} tankId ID of tank to return
         * @param {DeactivateEntity} [deactivateEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTank: async (tankId: number, deactivateEntity?: DeactivateEntity, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'tankId' is not null or undefined
            if (tankId === null || tankId === undefined) {
                throw new RequiredError('tankId','Required parameter tankId was null or undefined when calling removeTank.');
            }
            const localVarPath = `/tanks/{tankId}/deactivate`
                .replace(`{${"tankId"}}`, encodeURIComponent(String(tankId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof deactivateEntity !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(deactivateEntity !== undefined ? deactivateEntity : {}) : (deactivateEntity || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin signs off on a tank
         * @param {number} tankId ID of tank to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signoffTank: async (tankId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'tankId' is not null or undefined
            if (tankId === null || tankId === undefined) {
                throw new RequiredError('tankId','Required parameter tankId was null or undefined when calling signoffTank.');
            }
            const localVarPath = `/tanks/{tankId}/signoff`
                .replace(`{${"tankId"}}`, encodeURIComponent(String(tankId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of fuel types for tanks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tanksFuelTypesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/tanks/fuelTypes`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve the current state metrics for the tank
         * @param {number} tankId ID of tank to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tanksTankIdCurrentStateGet: async (tankId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'tankId' is not null or undefined
            if (tankId === null || tankId === undefined) {
                throw new RequiredError('tankId','Required parameter tankId was null or undefined when calling tanksTankIdCurrentStateGet.');
            }
            const localVarPath = `/tanks/{tankId}/currentState`
                .replace(`{${"tankId"}}`, encodeURIComponent(String(tankId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates a tank
         * @param {number} tankId ID of tank to return
         * @param {InlineObject41} inlineObject41 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTank: async (tankId: number, inlineObject41: InlineObject41, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'tankId' is not null or undefined
            if (tankId === null || tankId === undefined) {
                throw new RequiredError('tankId','Required parameter tankId was null or undefined when calling updateTank.');
            }
            // verify required parameter 'inlineObject41' is not null or undefined
            if (inlineObject41 === null || inlineObject41 === undefined) {
                throw new RequiredError('inlineObject41','Required parameter inlineObject41 was null or undefined when calling updateTank.');
            }
            const localVarPath = `/tanks/{tankId}`
                .replace(`{${"tankId"}}`, encodeURIComponent(String(tankId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof inlineObject41 !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(inlineObject41 !== undefined ? inlineObject41 : {}) : (inlineObject41 || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary uploads an image
         * @param {string} [additionalMetadata] Additional data to pass to server
         * @param {any} [file] file to upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFileTank: async (additionalMetadata?: string, file?: any, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/tanks/s3/uploadImage`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


            if (additionalMetadata !== undefined) { 
                localVarFormParams.append('additionalMetadata', additionalMetadata as any);
            }
    
            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TanksApi - functional programming interface
 * @export
 */
export const TanksApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a new tank to the service
         * @param {InlineObject40} inlineObject40 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addTank(inlineObject40: InlineObject40, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await TanksApiAxiosParamCreator(configuration).addTank(inlineObject40, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Assign sensors to a fuel tank
         * @param {number} tankId ID of tank to return
         * @param {InlineObject42} inlineObject42 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignTankSensors(tankId: number, inlineObject42: InlineObject42, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await TanksApiAxiosParamCreator(configuration).assignTankSensors(tankId, inlineObject42, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Cancel a tank
         * @param {number} tankId ID of tank to return
         * @param {CancelEntity} [cancelEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelTank(tankId: number, cancelEntity?: CancelEntity, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await TanksApiAxiosParamCreator(configuration).cancelTank(tankId, cancelEntity, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Move a tank from draft to pending
         * @summary Move a tank from draft to pending
         * @param {number} tankId ID of tank to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmDraftTank(tankId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TankInData>> {
            const localVarAxiosArgs = await TanksApiAxiosParamCreator(configuration).confirmDraftTank(tankId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Deletes a tank
         * @param {number} tankId ID of tank to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTank(tankId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await TanksApiAxiosParamCreator(configuration).deleteTank(tankId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns current Tank readings
         * @summary Find tank by ID
         * @param {number} tankId ID of tank to return
         * @param {number} [nDays] return only this many days worth of data. Default &#x3D; 2 usually
         * @param {string} [series] return one series
         * @param {string} [offset] go back X days
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFuelGraphData(tankId: number, nDays?: number, series?: string, offset?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FuelGraphDataInData>> {
            const localVarAxiosArgs = await TanksApiAxiosParamCreator(configuration).getFuelGraphData(tankId, nDays, series, offset, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns a tank
         * @summary Find tank by ID
         * @param {number} tankId ID of tank to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTankById(tankId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20025>> {
            const localVarAxiosArgs = await TanksApiAxiosParamCreator(configuration).getTankById(tankId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns current Tank changes
         * @summary Find tank by ID
         * @param {number} tankId ID of tank to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTankChanges(tankId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20026>> {
            const localVarAxiosArgs = await TanksApiAxiosParamCreator(configuration).getTankChanges(tankId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get Daily averages
         * @summary Get tank daily readings
         * @param {number} tankId ID of tank to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTankData(tankId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20026>> {
            const localVarAxiosArgs = await TanksApiAxiosParamCreator(configuration).getTankData(tankId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Retrieves the Dynamo metadata for the tank
         * @param {number} tankId ID of tank to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTankProperties(tankId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20028>> {
            const localVarAxiosArgs = await TanksApiAxiosParamCreator(configuration).getTankProperties(tankId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Retrieves the Dynamo metadata for the sensor allocated to the tank
         * @param {number} tankId ID of tank to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTankSensorProperties(tankId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20027>> {
            const localVarAxiosArgs = await TanksApiAxiosParamCreator(configuration).getTankSensorProperties(tankId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns sensor raw data
         * @summary get Tank Volume Data with Dynamo Paginatiion
         * @param {number} tankId ID of tank to return
         * @param {string} [series] return one series
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTankVolumeData(tankId: number, series?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20010>> {
            const localVarAxiosArgs = await TanksApiAxiosParamCreator(configuration).getTankVolumeData(tankId, series, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * returns all tanks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTanks(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20024>> {
            const localVarAxiosArgs = await TanksApiAxiosParamCreator(configuration).getTanks(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Allocate transceiver and sensor(s) to a fuel tank
         * @param {number} tankId ID of tank to return
         * @param {TransceiverSensorInData} transceiverSensorInData Assign transceiver and sensor to a fuel tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async installTank(tankId: number, transceiverSensorInData: TransceiverSensorInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TankInData>> {
            const localVarAxiosArgs = await TanksApiAxiosParamCreator(configuration).installTank(tankId, transceiverSensorInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Edit the properties of a fuel tank
         * @param {number} tankId ID of tank to return
         * @param {TankInputInData} tankInputInData Edit the properties of a fuel tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async provisionTank(tankId: number, tankInputInData: TankInputInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TankInData>> {
            const localVarAxiosArgs = await TanksApiAxiosParamCreator(configuration).provisionTank(tankId, tankInputInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Remove a tank
         * @param {number} tankId ID of tank to return
         * @param {DeactivateEntity} [deactivateEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeTank(tankId: number, deactivateEntity?: DeactivateEntity, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await TanksApiAxiosParamCreator(configuration).removeTank(tankId, deactivateEntity, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Admin signs off on a tank
         * @param {number} tankId ID of tank to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signoffTank(tankId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TankInData>> {
            const localVarAxiosArgs = await TanksApiAxiosParamCreator(configuration).signoffTank(tankId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get list of fuel types for tanks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tanksFuelTypesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FuelTypesInData>> {
            const localVarAxiosArgs = await TanksApiAxiosParamCreator(configuration).tanksFuelTypesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Retrieve the current state metrics for the tank
         * @param {number} tankId ID of tank to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tanksTankIdCurrentStateGet(tankId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2008>> {
            const localVarAxiosArgs = await TanksApiAxiosParamCreator(configuration).tanksTankIdCurrentStateGet(tankId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Updates a tank
         * @param {number} tankId ID of tank to return
         * @param {InlineObject41} inlineObject41 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTank(tankId: number, inlineObject41: InlineObject41, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await TanksApiAxiosParamCreator(configuration).updateTank(tankId, inlineObject41, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary uploads an image
         * @param {string} [additionalMetadata] Additional data to pass to server
         * @param {any} [file] file to upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadFileTank(additionalMetadata?: string, file?: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponse>> {
            const localVarAxiosArgs = await TanksApiAxiosParamCreator(configuration).uploadFileTank(additionalMetadata, file, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * TanksApi - factory interface
 * @export
 */
export const TanksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Add a new tank to the service
         * @param {InlineObject40} inlineObject40 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTank(inlineObject40: InlineObject40, options?: any): AxiosPromise<void> {
            return TanksApiFp(configuration).addTank(inlineObject40, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Assign sensors to a fuel tank
         * @param {number} tankId ID of tank to return
         * @param {InlineObject42} inlineObject42 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignTankSensors(tankId: number, inlineObject42: InlineObject42, options?: any): AxiosPromise<void> {
            return TanksApiFp(configuration).assignTankSensors(tankId, inlineObject42, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cancel a tank
         * @param {number} tankId ID of tank to return
         * @param {CancelEntity} [cancelEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelTank(tankId: number, cancelEntity?: CancelEntity, options?: any): AxiosPromise<void> {
            return TanksApiFp(configuration).cancelTank(tankId, cancelEntity, options).then((request) => request(axios, basePath));
        },
        /**
         * Move a tank from draft to pending
         * @summary Move a tank from draft to pending
         * @param {number} tankId ID of tank to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmDraftTank(tankId: number, options?: any): AxiosPromise<TankInData> {
            return TanksApiFp(configuration).confirmDraftTank(tankId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes a tank
         * @param {number} tankId ID of tank to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTank(tankId: number, options?: any): AxiosPromise<void> {
            return TanksApiFp(configuration).deleteTank(tankId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns current Tank readings
         * @summary Find tank by ID
         * @param {number} tankId ID of tank to return
         * @param {number} [nDays] return only this many days worth of data. Default &#x3D; 2 usually
         * @param {string} [series] return one series
         * @param {string} [offset] go back X days
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFuelGraphData(tankId: number, nDays?: number, series?: string, offset?: string, options?: any): AxiosPromise<FuelGraphDataInData> {
            return TanksApiFp(configuration).getFuelGraphData(tankId, nDays, series, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a tank
         * @summary Find tank by ID
         * @param {number} tankId ID of tank to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTankById(tankId: number, options?: any): AxiosPromise<InlineResponse20025> {
            return TanksApiFp(configuration).getTankById(tankId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns current Tank changes
         * @summary Find tank by ID
         * @param {number} tankId ID of tank to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTankChanges(tankId: number, options?: any): AxiosPromise<InlineResponse20026> {
            return TanksApiFp(configuration).getTankChanges(tankId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Daily averages
         * @summary Get tank daily readings
         * @param {number} tankId ID of tank to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTankData(tankId: number, options?: any): AxiosPromise<InlineResponse20026> {
            return TanksApiFp(configuration).getTankData(tankId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves the Dynamo metadata for the tank
         * @param {number} tankId ID of tank to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTankProperties(tankId: number, options?: any): AxiosPromise<InlineResponse20028> {
            return TanksApiFp(configuration).getTankProperties(tankId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves the Dynamo metadata for the sensor allocated to the tank
         * @param {number} tankId ID of tank to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTankSensorProperties(tankId: number, options?: any): AxiosPromise<InlineResponse20027> {
            return TanksApiFp(configuration).getTankSensorProperties(tankId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns sensor raw data
         * @summary get Tank Volume Data with Dynamo Paginatiion
         * @param {number} tankId ID of tank to return
         * @param {string} [series] return one series
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTankVolumeData(tankId: number, series?: string, options?: any): AxiosPromise<InlineResponse20010> {
            return TanksApiFp(configuration).getTankVolumeData(tankId, series, options).then((request) => request(axios, basePath));
        },
        /**
         * returns all tanks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTanks(options?: any): AxiosPromise<InlineResponse20024> {
            return TanksApiFp(configuration).getTanks(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Allocate transceiver and sensor(s) to a fuel tank
         * @param {number} tankId ID of tank to return
         * @param {TransceiverSensorInData} transceiverSensorInData Assign transceiver and sensor to a fuel tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installTank(tankId: number, transceiverSensorInData: TransceiverSensorInData, options?: any): AxiosPromise<TankInData> {
            return TanksApiFp(configuration).installTank(tankId, transceiverSensorInData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edit the properties of a fuel tank
         * @param {number} tankId ID of tank to return
         * @param {TankInputInData} tankInputInData Edit the properties of a fuel tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        provisionTank(tankId: number, tankInputInData: TankInputInData, options?: any): AxiosPromise<TankInData> {
            return TanksApiFp(configuration).provisionTank(tankId, tankInputInData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove a tank
         * @param {number} tankId ID of tank to return
         * @param {DeactivateEntity} [deactivateEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTank(tankId: number, deactivateEntity?: DeactivateEntity, options?: any): AxiosPromise<void> {
            return TanksApiFp(configuration).removeTank(tankId, deactivateEntity, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin signs off on a tank
         * @param {number} tankId ID of tank to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signoffTank(tankId: number, options?: any): AxiosPromise<TankInData> {
            return TanksApiFp(configuration).signoffTank(tankId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of fuel types for tanks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tanksFuelTypesGet(options?: any): AxiosPromise<FuelTypesInData> {
            return TanksApiFp(configuration).tanksFuelTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve the current state metrics for the tank
         * @param {number} tankId ID of tank to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tanksTankIdCurrentStateGet(tankId: number, options?: any): AxiosPromise<InlineResponse2008> {
            return TanksApiFp(configuration).tanksTankIdCurrentStateGet(tankId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates a tank
         * @param {number} tankId ID of tank to return
         * @param {InlineObject41} inlineObject41 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTank(tankId: number, inlineObject41: InlineObject41, options?: any): AxiosPromise<void> {
            return TanksApiFp(configuration).updateTank(tankId, inlineObject41, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary uploads an image
         * @param {string} [additionalMetadata] Additional data to pass to server
         * @param {any} [file] file to upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFileTank(additionalMetadata?: string, file?: any, options?: any): AxiosPromise<ApiResponse> {
            return TanksApiFp(configuration).uploadFileTank(additionalMetadata, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TanksApi - object-oriented interface
 * @export
 * @class TanksApi
 * @extends {BaseAPI}
 */
export class TanksApi extends BaseAPI {
    /**
     * 
     * @summary Add a new tank to the service
     * @param {InlineObject40} inlineObject40 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TanksApi
     */
    public addTank(inlineObject40: InlineObject40, options?: any) {
        return TanksApiFp(this.configuration).addTank(inlineObject40, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Assign sensors to a fuel tank
     * @param {number} tankId ID of tank to return
     * @param {InlineObject42} inlineObject42 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TanksApi
     */
    public assignTankSensors(tankId: number, inlineObject42: InlineObject42, options?: any) {
        return TanksApiFp(this.configuration).assignTankSensors(tankId, inlineObject42, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cancel a tank
     * @param {number} tankId ID of tank to return
     * @param {CancelEntity} [cancelEntity] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TanksApi
     */
    public cancelTank(tankId: number, cancelEntity?: CancelEntity, options?: any) {
        return TanksApiFp(this.configuration).cancelTank(tankId, cancelEntity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Move a tank from draft to pending
     * @summary Move a tank from draft to pending
     * @param {number} tankId ID of tank to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TanksApi
     */
    public confirmDraftTank(tankId: number, options?: any) {
        return TanksApiFp(this.configuration).confirmDraftTank(tankId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes a tank
     * @param {number} tankId ID of tank to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TanksApi
     */
    public deleteTank(tankId: number, options?: any) {
        return TanksApiFp(this.configuration).deleteTank(tankId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns current Tank readings
     * @summary Find tank by ID
     * @param {number} tankId ID of tank to return
     * @param {number} [nDays] return only this many days worth of data. Default &#x3D; 2 usually
     * @param {string} [series] return one series
     * @param {string} [offset] go back X days
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TanksApi
     */
    public getFuelGraphData(tankId: number, nDays?: number, series?: string, offset?: string, options?: any) {
        return TanksApiFp(this.configuration).getFuelGraphData(tankId, nDays, series, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a tank
     * @summary Find tank by ID
     * @param {number} tankId ID of tank to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TanksApi
     */
    public getTankById(tankId: number, options?: any) {
        return TanksApiFp(this.configuration).getTankById(tankId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns current Tank changes
     * @summary Find tank by ID
     * @param {number} tankId ID of tank to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TanksApi
     */
    public getTankChanges(tankId: number, options?: any) {
        return TanksApiFp(this.configuration).getTankChanges(tankId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Daily averages
     * @summary Get tank daily readings
     * @param {number} tankId ID of tank to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TanksApi
     */
    public getTankData(tankId: number, options?: any) {
        return TanksApiFp(this.configuration).getTankData(tankId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves the Dynamo metadata for the tank
     * @param {number} tankId ID of tank to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TanksApi
     */
    public getTankProperties(tankId: number, options?: any) {
        return TanksApiFp(this.configuration).getTankProperties(tankId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves the Dynamo metadata for the sensor allocated to the tank
     * @param {number} tankId ID of tank to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TanksApi
     */
    public getTankSensorProperties(tankId: number, options?: any) {
        return TanksApiFp(this.configuration).getTankSensorProperties(tankId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns sensor raw data
     * @summary get Tank Volume Data with Dynamo Paginatiion
     * @param {number} tankId ID of tank to return
     * @param {string} [series] return one series
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TanksApi
     */
    public getTankVolumeData(tankId: number, series?: string, options?: any) {
        return TanksApiFp(this.configuration).getTankVolumeData(tankId, series, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * returns all tanks
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TanksApi
     */
    public getTanks(options?: any) {
        return TanksApiFp(this.configuration).getTanks(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Allocate transceiver and sensor(s) to a fuel tank
     * @param {number} tankId ID of tank to return
     * @param {TransceiverSensorInData} transceiverSensorInData Assign transceiver and sensor to a fuel tank
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TanksApi
     */
    public installTank(tankId: number, transceiverSensorInData: TransceiverSensorInData, options?: any) {
        return TanksApiFp(this.configuration).installTank(tankId, transceiverSensorInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edit the properties of a fuel tank
     * @param {number} tankId ID of tank to return
     * @param {TankInputInData} tankInputInData Edit the properties of a fuel tank
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TanksApi
     */
    public provisionTank(tankId: number, tankInputInData: TankInputInData, options?: any) {
        return TanksApiFp(this.configuration).provisionTank(tankId, tankInputInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove a tank
     * @param {number} tankId ID of tank to return
     * @param {DeactivateEntity} [deactivateEntity] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TanksApi
     */
    public removeTank(tankId: number, deactivateEntity?: DeactivateEntity, options?: any) {
        return TanksApiFp(this.configuration).removeTank(tankId, deactivateEntity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin signs off on a tank
     * @param {number} tankId ID of tank to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TanksApi
     */
    public signoffTank(tankId: number, options?: any) {
        return TanksApiFp(this.configuration).signoffTank(tankId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of fuel types for tanks
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TanksApi
     */
    public tanksFuelTypesGet(options?: any) {
        return TanksApiFp(this.configuration).tanksFuelTypesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve the current state metrics for the tank
     * @param {number} tankId ID of tank to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TanksApi
     */
    public tanksTankIdCurrentStateGet(tankId: number, options?: any) {
        return TanksApiFp(this.configuration).tanksTankIdCurrentStateGet(tankId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates a tank
     * @param {number} tankId ID of tank to return
     * @param {InlineObject41} inlineObject41 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TanksApi
     */
    public updateTank(tankId: number, inlineObject41: InlineObject41, options?: any) {
        return TanksApiFp(this.configuration).updateTank(tankId, inlineObject41, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary uploads an image
     * @param {string} [additionalMetadata] Additional data to pass to server
     * @param {any} [file] file to upload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TanksApi
     */
    public uploadFileTank(additionalMetadata?: string, file?: any, options?: any) {
        return TanksApiFp(this.configuration).uploadFileTank(additionalMetadata, file, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * ThingGroupsApi - axios parameter creator
 * @export
 */
export const ThingGroupsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * create thingGroup
         * @summary Create thingGroup
         * @param {ThingGroupInData} thingGroupInData Created thingGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createThingGroup: async (thingGroupInData: ThingGroupInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'thingGroupInData' is not null or undefined
            if (thingGroupInData === null || thingGroupInData === undefined) {
                throw new RequiredError('thingGroupInData','Required parameter thingGroupInData was null or undefined when calling createThingGroup.');
            }
            const localVarPath = `/thingGroups`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof thingGroupInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(thingGroupInData !== undefined ? thingGroupInData : {}) : (thingGroupInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete thingGroup
         * @summary Delete thingGroup
         * @param {string} thingGroupName thingGroupName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteThingGroup: async (thingGroupName: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'thingGroupName' is not null or undefined
            if (thingGroupName === null || thingGroupName === undefined) {
                throw new RequiredError('thingGroupName','Required parameter thingGroupName was null or undefined when calling deleteThingGroup.');
            }
            const localVarPath = `/thingGroups/{thingGroupName}`
                .replace(`{${"thingGroupName"}}`, encodeURIComponent(String(thingGroupName)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get data required by the OTA Manager tool
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOtaManagerData: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/thingGroups/otaManager/get`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get thingGroup
         * @param {string} thingGroupName thingGroupName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThingGroup: async (thingGroupName: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'thingGroupName' is not null or undefined
            if (thingGroupName === null || thingGroupName === undefined) {
                throw new RequiredError('thingGroupName','Required parameter thingGroupName was null or undefined when calling getThingGroup.');
            }
            const localVarPath = `/thingGroups/{thingGroupName}`
                .replace(`{${"thingGroupName"}}`, encodeURIComponent(String(thingGroupName)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * returns all thingGroups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThingGroups: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/thingGroups`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create thingGroup
         * @summary Create thingGroup allocations
         * @param {SiteThingGroupsInData} siteThingGroupsInData Created thingGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        siteThingGroups: async (siteThingGroupsInData: SiteThingGroupsInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'siteThingGroupsInData' is not null or undefined
            if (siteThingGroupsInData === null || siteThingGroupsInData === undefined) {
                throw new RequiredError('siteThingGroupsInData','Required parameter siteThingGroupsInData was null or undefined when calling siteThingGroups.');
            }
            const localVarPath = `/thingGroups/sites`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof siteThingGroupsInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(siteThingGroupsInData !== undefined ? siteThingGroupsInData : {}) : (siteThingGroupsInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * sync thingGroups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncThingGroups: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/thingGroups/sync/get`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create thingGroup
         * @summary Create thingGroup allocations
         * @param {TransceiverThingGroupsInData} transceiverThingGroupsInData Created thingGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transceiverThingGroups: async (transceiverThingGroupsInData: TransceiverThingGroupsInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'transceiverThingGroupsInData' is not null or undefined
            if (transceiverThingGroupsInData === null || transceiverThingGroupsInData === undefined) {
                throw new RequiredError('transceiverThingGroupsInData','Required parameter transceiverThingGroupsInData was null or undefined when calling transceiverThingGroups.');
            }
            const localVarPath = `/thingGroups/transceivers`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof transceiverThingGroupsInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(transceiverThingGroupsInData !== undefined ? transceiverThingGroupsInData : {}) : (transceiverThingGroupsInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update thingGroup
         * @summary Updated thingGroup
         * @param {string} thingGroupName thingGroupName
         * @param {ThingGroupInData} thingGroupInData Updated thingGroup object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateThingGroup: async (thingGroupName: string, thingGroupInData: ThingGroupInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'thingGroupName' is not null or undefined
            if (thingGroupName === null || thingGroupName === undefined) {
                throw new RequiredError('thingGroupName','Required parameter thingGroupName was null or undefined when calling updateThingGroup.');
            }
            // verify required parameter 'thingGroupInData' is not null or undefined
            if (thingGroupInData === null || thingGroupInData === undefined) {
                throw new RequiredError('thingGroupInData','Required parameter thingGroupInData was null or undefined when calling updateThingGroup.');
            }
            const localVarPath = `/thingGroups/{thingGroupName}`
                .replace(`{${"thingGroupName"}}`, encodeURIComponent(String(thingGroupName)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof thingGroupInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(thingGroupInData !== undefined ? thingGroupInData : {}) : (thingGroupInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ThingGroupsApi - functional programming interface
 * @export
 */
export const ThingGroupsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * create thingGroup
         * @summary Create thingGroup
         * @param {ThingGroupInData} thingGroupInData Created thingGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createThingGroup(thingGroupInData: ThingGroupInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ThingGroupsApiAxiosParamCreator(configuration).createThingGroup(thingGroupInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * delete thingGroup
         * @summary Delete thingGroup
         * @param {string} thingGroupName thingGroupName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteThingGroup(thingGroupName: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ThingGroupsApiAxiosParamCreator(configuration).deleteThingGroup(thingGroupName, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get data required by the OTA Manager tool
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOtaManagerData(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await ThingGroupsApiAxiosParamCreator(configuration).getOtaManagerData(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get thingGroup
         * @param {string} thingGroupName thingGroupName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getThingGroup(thingGroupName: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ThingGroupInData>> {
            const localVarAxiosArgs = await ThingGroupsApiAxiosParamCreator(configuration).getThingGroup(thingGroupName, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * returns all thingGroups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getThingGroups(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ThingGroupsInData>> {
            const localVarAxiosArgs = await ThingGroupsApiAxiosParamCreator(configuration).getThingGroups(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * create thingGroup
         * @summary Create thingGroup allocations
         * @param {SiteThingGroupsInData} siteThingGroupsInData Created thingGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async siteThingGroups(siteThingGroupsInData: SiteThingGroupsInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ThingGroupsApiAxiosParamCreator(configuration).siteThingGroups(siteThingGroupsInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * sync thingGroups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncThingGroups(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ThingGroupsInData>> {
            const localVarAxiosArgs = await ThingGroupsApiAxiosParamCreator(configuration).syncThingGroups(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * create thingGroup
         * @summary Create thingGroup allocations
         * @param {TransceiverThingGroupsInData} transceiverThingGroupsInData Created thingGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transceiverThingGroups(transceiverThingGroupsInData: TransceiverThingGroupsInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ThingGroupsApiAxiosParamCreator(configuration).transceiverThingGroups(transceiverThingGroupsInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * update thingGroup
         * @summary Updated thingGroup
         * @param {string} thingGroupName thingGroupName
         * @param {ThingGroupInData} thingGroupInData Updated thingGroup object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateThingGroup(thingGroupName: string, thingGroupInData: ThingGroupInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ThingGroupsApiAxiosParamCreator(configuration).updateThingGroup(thingGroupName, thingGroupInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ThingGroupsApi - factory interface
 * @export
 */
export const ThingGroupsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * create thingGroup
         * @summary Create thingGroup
         * @param {ThingGroupInData} thingGroupInData Created thingGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createThingGroup(thingGroupInData: ThingGroupInData, options?: any): AxiosPromise<void> {
            return ThingGroupsApiFp(configuration).createThingGroup(thingGroupInData, options).then((request) => request(axios, basePath));
        },
        /**
         * delete thingGroup
         * @summary Delete thingGroup
         * @param {string} thingGroupName thingGroupName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteThingGroup(thingGroupName: string, options?: any): AxiosPromise<void> {
            return ThingGroupsApiFp(configuration).deleteThingGroup(thingGroupName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get data required by the OTA Manager tool
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOtaManagerData(options?: any): AxiosPromise<Array<object>> {
            return ThingGroupsApiFp(configuration).getOtaManagerData(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get thingGroup
         * @param {string} thingGroupName thingGroupName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThingGroup(thingGroupName: string, options?: any): AxiosPromise<ThingGroupInData> {
            return ThingGroupsApiFp(configuration).getThingGroup(thingGroupName, options).then((request) => request(axios, basePath));
        },
        /**
         * returns all thingGroups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThingGroups(options?: any): AxiosPromise<ThingGroupsInData> {
            return ThingGroupsApiFp(configuration).getThingGroups(options).then((request) => request(axios, basePath));
        },
        /**
         * create thingGroup
         * @summary Create thingGroup allocations
         * @param {SiteThingGroupsInData} siteThingGroupsInData Created thingGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        siteThingGroups(siteThingGroupsInData: SiteThingGroupsInData, options?: any): AxiosPromise<void> {
            return ThingGroupsApiFp(configuration).siteThingGroups(siteThingGroupsInData, options).then((request) => request(axios, basePath));
        },
        /**
         * sync thingGroups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncThingGroups(options?: any): AxiosPromise<ThingGroupsInData> {
            return ThingGroupsApiFp(configuration).syncThingGroups(options).then((request) => request(axios, basePath));
        },
        /**
         * create thingGroup
         * @summary Create thingGroup allocations
         * @param {TransceiverThingGroupsInData} transceiverThingGroupsInData Created thingGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transceiverThingGroups(transceiverThingGroupsInData: TransceiverThingGroupsInData, options?: any): AxiosPromise<void> {
            return ThingGroupsApiFp(configuration).transceiverThingGroups(transceiverThingGroupsInData, options).then((request) => request(axios, basePath));
        },
        /**
         * update thingGroup
         * @summary Updated thingGroup
         * @param {string} thingGroupName thingGroupName
         * @param {ThingGroupInData} thingGroupInData Updated thingGroup object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateThingGroup(thingGroupName: string, thingGroupInData: ThingGroupInData, options?: any): AxiosPromise<void> {
            return ThingGroupsApiFp(configuration).updateThingGroup(thingGroupName, thingGroupInData, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ThingGroupsApi - object-oriented interface
 * @export
 * @class ThingGroupsApi
 * @extends {BaseAPI}
 */
export class ThingGroupsApi extends BaseAPI {
    /**
     * create thingGroup
     * @summary Create thingGroup
     * @param {ThingGroupInData} thingGroupInData Created thingGroup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThingGroupsApi
     */
    public createThingGroup(thingGroupInData: ThingGroupInData, options?: any) {
        return ThingGroupsApiFp(this.configuration).createThingGroup(thingGroupInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * delete thingGroup
     * @summary Delete thingGroup
     * @param {string} thingGroupName thingGroupName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThingGroupsApi
     */
    public deleteThingGroup(thingGroupName: string, options?: any) {
        return ThingGroupsApiFp(this.configuration).deleteThingGroup(thingGroupName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get data required by the OTA Manager tool
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThingGroupsApi
     */
    public getOtaManagerData(options?: any) {
        return ThingGroupsApiFp(this.configuration).getOtaManagerData(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get thingGroup
     * @param {string} thingGroupName thingGroupName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThingGroupsApi
     */
    public getThingGroup(thingGroupName: string, options?: any) {
        return ThingGroupsApiFp(this.configuration).getThingGroup(thingGroupName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * returns all thingGroups
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThingGroupsApi
     */
    public getThingGroups(options?: any) {
        return ThingGroupsApiFp(this.configuration).getThingGroups(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * create thingGroup
     * @summary Create thingGroup allocations
     * @param {SiteThingGroupsInData} siteThingGroupsInData Created thingGroup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThingGroupsApi
     */
    public siteThingGroups(siteThingGroupsInData: SiteThingGroupsInData, options?: any) {
        return ThingGroupsApiFp(this.configuration).siteThingGroups(siteThingGroupsInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * sync thingGroups
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThingGroupsApi
     */
    public syncThingGroups(options?: any) {
        return ThingGroupsApiFp(this.configuration).syncThingGroups(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * create thingGroup
     * @summary Create thingGroup allocations
     * @param {TransceiverThingGroupsInData} transceiverThingGroupsInData Created thingGroup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThingGroupsApi
     */
    public transceiverThingGroups(transceiverThingGroupsInData: TransceiverThingGroupsInData, options?: any) {
        return ThingGroupsApiFp(this.configuration).transceiverThingGroups(transceiverThingGroupsInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update thingGroup
     * @summary Updated thingGroup
     * @param {string} thingGroupName thingGroupName
     * @param {ThingGroupInData} thingGroupInData Updated thingGroup object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThingGroupsApi
     */
    public updateThingGroup(thingGroupName: string, thingGroupInData: ThingGroupInData, options?: any) {
        return ThingGroupsApiFp(this.configuration).updateThingGroup(thingGroupName, thingGroupInData, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * TransceiversApi - axios parameter creator
 * @export
 */
export const TransceiversApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a new transceivers to the service
         * @param {TransceiverInData} transceiverInData Transceiver object to be added to service
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTransceiver: async (transceiverInData: TransceiverInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'transceiverInData' is not null or undefined
            if (transceiverInData === null || transceiverInData === undefined) {
                throw new RequiredError('transceiverInData','Required parameter transceiverInData was null or undefined when calling addTransceiver.');
            }
            const localVarPath = `/transceivers`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof transceiverInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(transceiverInData !== undefined ? transceiverInData : {}) : (transceiverInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Decommission a transceiver
         * @param {number} transceiverId ID of transceiver to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        decommissionTransceiver: async (transceiverId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'transceiverId' is not null or undefined
            if (transceiverId === null || transceiverId === undefined) {
                throw new RequiredError('transceiverId','Required parameter transceiverId was null or undefined when calling decommissionTransceiver.');
            }
            const localVarPath = `/transceivers/{transceiverId}/decommission`
                .replace(`{${"transceiverId"}}`, encodeURIComponent(String(transceiverId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes a transceiver
         * @param {number} transceiverId ID of transceiver to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTransceiver: async (transceiverId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'transceiverId' is not null or undefined
            if (transceiverId === null || transceiverId === undefined) {
                throw new RequiredError('transceiverId','Required parameter transceiverId was null or undefined when calling deleteTransceiver.');
            }
            const localVarPath = `/transceivers/{transceiverId}`
                .replace(`{${"transceiverId"}}`, encodeURIComponent(String(transceiverId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get data required by the OTA Manager tool
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOtaManagerData: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/thingGroups/otaManager/get`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a transceiver
         * @summary Find transceiver by ID
         * @param {number} transceiverId ID of transceiver to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransceiverById: async (transceiverId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'transceiverId' is not null or undefined
            if (transceiverId === null || transceiverId === undefined) {
                throw new RequiredError('transceiverId','Required parameter transceiverId was null or undefined when calling getTransceiverById.');
            }
            const localVarPath = `/transceivers/{transceiverId}`
                .replace(`{${"transceiverId"}}`, encodeURIComponent(String(transceiverId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a transceivers Dashboard
         * @summary Get transceivers Dashboard Data
         * @param {number} transceiverId ID of transceiver to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransceiverDash: async (transceiverId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'transceiverId' is not null or undefined
            if (transceiverId === null || transceiverId === undefined) {
                throw new RequiredError('transceiverId','Required parameter transceiverId was null or undefined when calling getTransceiverDash.');
            }
            const localVarPath = `/transceivers/{transceiverId}/dash`
                .replace(`{${"transceiverId"}}`, encodeURIComponent(String(transceiverId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns transceiver raw data
         * @summary get Transceiver Data
         * @param {number} transceiverId ID of transceiver to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransceiverData: async (transceiverId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'transceiverId' is not null or undefined
            if (transceiverId === null || transceiverId === undefined) {
                throw new RequiredError('transceiverId','Required parameter transceiverId was null or undefined when calling getTransceiverData.');
            }
            const localVarPath = `/transceivers/{transceiverId}/data`
                .replace(`{${"transceiverId"}}`, encodeURIComponent(String(transceiverId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns Transceiver diagnostic data
         * @summary Get transceiver diagnostic data
         * @param {number} transceiverId ID of transceiver to return
         * @param {number} [nDays] return only this many days worth of data. Default &#x3D; 2 usually
         * @param {string} [series] return one series
         * @param {string} [offset] go back X days
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransceiverGraphData: async (transceiverId: number, nDays?: number, series?: string, offset?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'transceiverId' is not null or undefined
            if (transceiverId === null || transceiverId === undefined) {
                throw new RequiredError('transceiverId','Required parameter transceiverId was null or undefined when calling getTransceiverGraphData.');
            }
            const localVarPath = `/transceivers/{transceiverId}/graphData`
                .replace(`{${"transceiverId"}}`, encodeURIComponent(String(transceiverId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (nDays !== undefined) {
                localVarQueryParameter['nDays'] = nDays;
            }

            if (series !== undefined) {
                localVarQueryParameter['series'] = series;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get last check in time for a transceiver
         * @param {number} transceiverId ID of transceiver to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransceiverLastCheckInTime: async (transceiverId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'transceiverId' is not null or undefined
            if (transceiverId === null || transceiverId === undefined) {
                throw new RequiredError('transceiverId','Required parameter transceiverId was null or undefined when calling getTransceiverLastCheckInTime.');
            }
            const localVarPath = `/transceivers/{transceiverId}/lastCheckIn`
                .replace(`{${"transceiverId"}}`, encodeURIComponent(String(transceiverId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns raw data
         * @summary Get Dynamo raw data for a given transceiver
         * @param {number} transceiverId ID of transceiver to return
         * @param {number} [limit] Number of items to return
         * @param {string} [exclusiveStartSortKey] Used for pagination, sortKey to start the search, (use sortKey from result)
         * @param {string} [exclusiveStartKey] Used for pagination, key to start the search, used by AWS transceivers only (use key from result)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransceiverRawData: async (transceiverId: number, limit?: number, exclusiveStartSortKey?: string, exclusiveStartKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'transceiverId' is not null or undefined
            if (transceiverId === null || transceiverId === undefined) {
                throw new RequiredError('transceiverId','Required parameter transceiverId was null or undefined when calling getTransceiverRawData.');
            }
            const localVarPath = `/transceivers/{transceiverId}/rawData`
                .replace(`{${"transceiverId"}}`, encodeURIComponent(String(transceiverId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (exclusiveStartSortKey !== undefined) {
                localVarQueryParameter['exclusiveStartSortKey'] = exclusiveStartSortKey;
            }

            if (exclusiveStartKey !== undefined) {
                localVarQueryParameter['exclusiveStartKey'] = exclusiveStartKey;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns transceiver raw data
         * @summary get Transceiver Data
         * @param {number} transceiverId ID of transceiver to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransceiverSeriesData: async (transceiverId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'transceiverId' is not null or undefined
            if (transceiverId === null || transceiverId === undefined) {
                throw new RequiredError('transceiverId','Required parameter transceiverId was null or undefined when calling getTransceiverSeriesData.');
            }
            const localVarPath = `/transceivers/{transceiverId}/series`
                .replace(`{${"transceiverId"}}`, encodeURIComponent(String(transceiverId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns time series data
         * @summary Get Dynamo time series data for a given transceiver
         * @param {number} transceiverId ID of transceiver to return
         * @param {string} startDate Start time to consider
         * @param {string} endDate End time to consider
         * @param {string} [sortKeys] Return one or more series (comma separated, valid values are battery-voltage, cell-strengthproduct)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransceiverTimeSeriesData: async (transceiverId: number, startDate: string, endDate: string, sortKeys?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'transceiverId' is not null or undefined
            if (transceiverId === null || transceiverId === undefined) {
                throw new RequiredError('transceiverId','Required parameter transceiverId was null or undefined when calling getTransceiverTimeSeriesData.');
            }
            // verify required parameter 'startDate' is not null or undefined
            if (startDate === null || startDate === undefined) {
                throw new RequiredError('startDate','Required parameter startDate was null or undefined when calling getTransceiverTimeSeriesData.');
            }
            // verify required parameter 'endDate' is not null or undefined
            if (endDate === null || endDate === undefined) {
                throw new RequiredError('endDate','Required parameter endDate was null or undefined when calling getTransceiverTimeSeriesData.');
            }
            const localVarPath = `/transceivers/{transceiverId}/timeSeriesData`
                .replace(`{${"transceiverId"}}`, encodeURIComponent(String(transceiverId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (sortKeys !== undefined) {
                localVarQueryParameter['sortKeys'] = sortKeys;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * returns all transceivers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransceivers: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/transceivers`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Graph data for an entity
         * @param {'sensor' | 'transceiver' | 'vat'} entity entity to return
         * @param {number} id ID of entity to return
         * @param {number} startTs Start epoch timestamp to consider
         * @param {number} endTs End epoch timestamp to consider
         * @param {string} [series] Return one series
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graph: async (entity: 'sensor' | 'transceiver' | 'vat', id: number, startTs: number, endTs: number, series?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'entity' is not null or undefined
            if (entity === null || entity === undefined) {
                throw new RequiredError('entity','Required parameter entity was null or undefined when calling graph.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling graph.');
            }
            // verify required parameter 'startTs' is not null or undefined
            if (startTs === null || startTs === undefined) {
                throw new RequiredError('startTs','Required parameter startTs was null or undefined when calling graph.');
            }
            // verify required parameter 'endTs' is not null or undefined
            if (endTs === null || endTs === undefined) {
                throw new RequiredError('endTs','Required parameter endTs was null or undefined when calling graph.');
            }
            const localVarPath = `/graphs/{entity}/{id}`
                .replace(`{${"entity"}}`, encodeURIComponent(String(entity)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (startTs !== undefined) {
                localVarQueryParameter['startTs'] = startTs;
            }

            if (endTs !== undefined) {
                localVarQueryParameter['endTs'] = endTs;
            }

            if (series !== undefined) {
                localVarQueryParameter['series'] = series;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns transceiver raw data
         * @summary reboot Transceiver
         * @param {number} transceiverId ID of transceiver to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rebootTransceiver: async (transceiverId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'transceiverId' is not null or undefined
            if (transceiverId === null || transceiverId === undefined) {
                throw new RequiredError('transceiverId','Required parameter transceiverId was null or undefined when calling rebootTransceiver.');
            }
            const localVarPath = `/transceivers/{transceiverId}/reboot`
                .replace(`{${"transceiverId"}}`, encodeURIComponent(String(transceiverId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sets a Chimera V1 transceiver mesh mode to deployment
         * @summary Set transceiver mesh mode to deployment
         * @param {number} transceiverId ID of transceiver to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setMeshDeploymentMode: async (transceiverId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'transceiverId' is not null or undefined
            if (transceiverId === null || transceiverId === undefined) {
                throw new RequiredError('transceiverId','Required parameter transceiverId was null or undefined when calling setMeshDeploymentMode.');
            }
            const localVarPath = `/transceivers/{transceiverId}/setMeshDeploymentMode`
                .replace(`{${"transceiverId"}}`, encodeURIComponent(String(transceiverId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unallocate sensors from transceiver
         * @summary reboot Transceiver
         * @param {number} transceiverId ID of transceiver to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unallocateTransceiver: async (transceiverId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'transceiverId' is not null or undefined
            if (transceiverId === null || transceiverId === undefined) {
                throw new RequiredError('transceiverId','Required parameter transceiverId was null or undefined when calling unallocateTransceiver.');
            }
            const localVarPath = `/transceivers/{transceiverId}/unallocate`
                .replace(`{${"transceiverId"}}`, encodeURIComponent(String(transceiverId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns transceiver raw data
         * @summary update Transceiver Metadata
         * @param {number} transceiverId ID of transceiver to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMetadata: async (transceiverId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'transceiverId' is not null or undefined
            if (transceiverId === null || transceiverId === undefined) {
                throw new RequiredError('transceiverId','Required parameter transceiverId was null or undefined when calling updateMetadata.');
            }
            const localVarPath = `/transceivers/{transceiverId}/metadata`
                .replace(`{${"transceiverId"}}`, encodeURIComponent(String(transceiverId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates a transceiver
         * @param {number} transceiverId ID of transceiver to return
         * @param {TransceiverInData} transceiverInData Transceiver object to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTransceiver: async (transceiverId: number, transceiverInData: TransceiverInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'transceiverId' is not null or undefined
            if (transceiverId === null || transceiverId === undefined) {
                throw new RequiredError('transceiverId','Required parameter transceiverId was null or undefined when calling updateTransceiver.');
            }
            // verify required parameter 'transceiverInData' is not null or undefined
            if (transceiverInData === null || transceiverInData === undefined) {
                throw new RequiredError('transceiverInData','Required parameter transceiverInData was null or undefined when calling updateTransceiver.');
            }
            const localVarPath = `/transceivers/{transceiverId}`
                .replace(`{${"transceiverId"}}`, encodeURIComponent(String(transceiverId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof transceiverInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(transceiverInData !== undefined ? transceiverInData : {}) : (transceiverInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TransceiversApi - functional programming interface
 * @export
 */
export const TransceiversApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a new transceivers to the service
         * @param {TransceiverInData} transceiverInData Transceiver object to be added to service
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addTransceiver(transceiverInData: TransceiverInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await TransceiversApiAxiosParamCreator(configuration).addTransceiver(transceiverInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Decommission a transceiver
         * @param {number} transceiverId ID of transceiver to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async decommissionTransceiver(transceiverId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransceiverInData>> {
            const localVarAxiosArgs = await TransceiversApiAxiosParamCreator(configuration).decommissionTransceiver(transceiverId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Deletes a transceiver
         * @param {number} transceiverId ID of transceiver to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTransceiver(transceiverId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await TransceiversApiAxiosParamCreator(configuration).deleteTransceiver(transceiverId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get data required by the OTA Manager tool
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOtaManagerData(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await TransceiversApiAxiosParamCreator(configuration).getOtaManagerData(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns a transceiver
         * @summary Find transceiver by ID
         * @param {number} transceiverId ID of transceiver to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransceiverById(transceiverId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransceiverInData>> {
            const localVarAxiosArgs = await TransceiversApiAxiosParamCreator(configuration).getTransceiverById(transceiverId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns a transceivers Dashboard
         * @summary Get transceivers Dashboard Data
         * @param {number} transceiverId ID of transceiver to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransceiverDash(transceiverId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransceiverDash>> {
            const localVarAxiosArgs = await TransceiversApiAxiosParamCreator(configuration).getTransceiverDash(transceiverId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns transceiver raw data
         * @summary get Transceiver Data
         * @param {number} transceiverId ID of transceiver to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransceiverData(transceiverId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20010>> {
            const localVarAxiosArgs = await TransceiversApiAxiosParamCreator(configuration).getTransceiverData(transceiverId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns Transceiver diagnostic data
         * @summary Get transceiver diagnostic data
         * @param {number} transceiverId ID of transceiver to return
         * @param {number} [nDays] return only this many days worth of data. Default &#x3D; 2 usually
         * @param {string} [series] return one series
         * @param {string} [offset] go back X days
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransceiverGraphData(transceiverId: number, nDays?: number, series?: string, offset?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransceiverGraphDataInData>> {
            const localVarAxiosArgs = await TransceiversApiAxiosParamCreator(configuration).getTransceiverGraphData(transceiverId, nDays, series, offset, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get last check in time for a transceiver
         * @param {number} transceiverId ID of transceiver to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransceiverLastCheckInTime(transceiverId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LastCheckInTimeInData>> {
            const localVarAxiosArgs = await TransceiversApiAxiosParamCreator(configuration).getTransceiverLastCheckInTime(transceiverId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns raw data
         * @summary Get Dynamo raw data for a given transceiver
         * @param {number} transceiverId ID of transceiver to return
         * @param {number} [limit] Number of items to return
         * @param {string} [exclusiveStartSortKey] Used for pagination, sortKey to start the search, (use sortKey from result)
         * @param {string} [exclusiveStartKey] Used for pagination, key to start the search, used by AWS transceivers only (use key from result)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransceiverRawData(transceiverId: number, limit?: number, exclusiveStartSortKey?: string, exclusiveStartKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await TransceiversApiAxiosParamCreator(configuration).getTransceiverRawData(transceiverId, limit, exclusiveStartSortKey, exclusiveStartKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns transceiver raw data
         * @summary get Transceiver Data
         * @param {number} transceiverId ID of transceiver to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransceiverSeriesData(transceiverId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeSeriesInData>> {
            const localVarAxiosArgs = await TransceiversApiAxiosParamCreator(configuration).getTransceiverSeriesData(transceiverId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns time series data
         * @summary Get Dynamo time series data for a given transceiver
         * @param {number} transceiverId ID of transceiver to return
         * @param {string} startDate Start time to consider
         * @param {string} endDate End time to consider
         * @param {string} [sortKeys] Return one or more series (comma separated, valid values are battery-voltage, cell-strengthproduct)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransceiverTimeSeriesData(transceiverId: number, startDate: string, endDate: string, sortKeys?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2008>> {
            const localVarAxiosArgs = await TransceiversApiAxiosParamCreator(configuration).getTransceiverTimeSeriesData(transceiverId, startDate, endDate, sortKeys, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * returns all transceivers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransceivers(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransceiversInData>> {
            const localVarAxiosArgs = await TransceiversApiAxiosParamCreator(configuration).getTransceivers(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Graph data for an entity
         * @param {'sensor' | 'transceiver' | 'vat'} entity entity to return
         * @param {number} id ID of entity to return
         * @param {number} startTs Start epoch timestamp to consider
         * @param {number} endTs End epoch timestamp to consider
         * @param {string} [series] Return one series
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async graph(entity: 'sensor' | 'transceiver' | 'vat', id: number, startTs: number, endTs: number, series?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GraphTimeSeriesInData>> {
            const localVarAxiosArgs = await TransceiversApiAxiosParamCreator(configuration).graph(entity, id, startTs, endTs, series, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns transceiver raw data
         * @summary reboot Transceiver
         * @param {number} transceiverId ID of transceiver to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rebootTransceiver(transceiverId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20022>> {
            const localVarAxiosArgs = await TransceiversApiAxiosParamCreator(configuration).rebootTransceiver(transceiverId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Sets a Chimera V1 transceiver mesh mode to deployment
         * @summary Set transceiver mesh mode to deployment
         * @param {number} transceiverId ID of transceiver to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setMeshDeploymentMode(transceiverId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20023>> {
            const localVarAxiosArgs = await TransceiversApiAxiosParamCreator(configuration).setMeshDeploymentMode(transceiverId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Unallocate sensors from transceiver
         * @summary reboot Transceiver
         * @param {number} transceiverId ID of transceiver to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unallocateTransceiver(transceiverId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20022>> {
            const localVarAxiosArgs = await TransceiversApiAxiosParamCreator(configuration).unallocateTransceiver(transceiverId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns transceiver raw data
         * @summary update Transceiver Metadata
         * @param {number} transceiverId ID of transceiver to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMetadata(transceiverId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransceiverInData>> {
            const localVarAxiosArgs = await TransceiversApiAxiosParamCreator(configuration).updateMetadata(transceiverId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Updates a transceiver
         * @param {number} transceiverId ID of transceiver to return
         * @param {TransceiverInData} transceiverInData Transceiver object to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTransceiver(transceiverId: number, transceiverInData: TransceiverInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await TransceiversApiAxiosParamCreator(configuration).updateTransceiver(transceiverId, transceiverInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * TransceiversApi - factory interface
 * @export
 */
export const TransceiversApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Add a new transceivers to the service
         * @param {TransceiverInData} transceiverInData Transceiver object to be added to service
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTransceiver(transceiverInData: TransceiverInData, options?: any): AxiosPromise<void> {
            return TransceiversApiFp(configuration).addTransceiver(transceiverInData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Decommission a transceiver
         * @param {number} transceiverId ID of transceiver to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        decommissionTransceiver(transceiverId: number, options?: any): AxiosPromise<TransceiverInData> {
            return TransceiversApiFp(configuration).decommissionTransceiver(transceiverId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes a transceiver
         * @param {number} transceiverId ID of transceiver to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTransceiver(transceiverId: number, options?: any): AxiosPromise<void> {
            return TransceiversApiFp(configuration).deleteTransceiver(transceiverId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get data required by the OTA Manager tool
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOtaManagerData(options?: any): AxiosPromise<Array<object>> {
            return TransceiversApiFp(configuration).getOtaManagerData(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a transceiver
         * @summary Find transceiver by ID
         * @param {number} transceiverId ID of transceiver to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransceiverById(transceiverId: number, options?: any): AxiosPromise<TransceiverInData> {
            return TransceiversApiFp(configuration).getTransceiverById(transceiverId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a transceivers Dashboard
         * @summary Get transceivers Dashboard Data
         * @param {number} transceiverId ID of transceiver to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransceiverDash(transceiverId: number, options?: any): AxiosPromise<TransceiverDash> {
            return TransceiversApiFp(configuration).getTransceiverDash(transceiverId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns transceiver raw data
         * @summary get Transceiver Data
         * @param {number} transceiverId ID of transceiver to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransceiverData(transceiverId: number, options?: any): AxiosPromise<InlineResponse20010> {
            return TransceiversApiFp(configuration).getTransceiverData(transceiverId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns Transceiver diagnostic data
         * @summary Get transceiver diagnostic data
         * @param {number} transceiverId ID of transceiver to return
         * @param {number} [nDays] return only this many days worth of data. Default &#x3D; 2 usually
         * @param {string} [series] return one series
         * @param {string} [offset] go back X days
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransceiverGraphData(transceiverId: number, nDays?: number, series?: string, offset?: string, options?: any): AxiosPromise<TransceiverGraphDataInData> {
            return TransceiversApiFp(configuration).getTransceiverGraphData(transceiverId, nDays, series, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get last check in time for a transceiver
         * @param {number} transceiverId ID of transceiver to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransceiverLastCheckInTime(transceiverId: number, options?: any): AxiosPromise<LastCheckInTimeInData> {
            return TransceiversApiFp(configuration).getTransceiverLastCheckInTime(transceiverId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns raw data
         * @summary Get Dynamo raw data for a given transceiver
         * @param {number} transceiverId ID of transceiver to return
         * @param {number} [limit] Number of items to return
         * @param {string} [exclusiveStartSortKey] Used for pagination, sortKey to start the search, (use sortKey from result)
         * @param {string} [exclusiveStartKey] Used for pagination, key to start the search, used by AWS transceivers only (use key from result)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransceiverRawData(transceiverId: number, limit?: number, exclusiveStartSortKey?: string, exclusiveStartKey?: string, options?: any): AxiosPromise<Array<object>> {
            return TransceiversApiFp(configuration).getTransceiverRawData(transceiverId, limit, exclusiveStartSortKey, exclusiveStartKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns transceiver raw data
         * @summary get Transceiver Data
         * @param {number} transceiverId ID of transceiver to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransceiverSeriesData(transceiverId: number, options?: any): AxiosPromise<TimeSeriesInData> {
            return TransceiversApiFp(configuration).getTransceiverSeriesData(transceiverId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns time series data
         * @summary Get Dynamo time series data for a given transceiver
         * @param {number} transceiverId ID of transceiver to return
         * @param {string} startDate Start time to consider
         * @param {string} endDate End time to consider
         * @param {string} [sortKeys] Return one or more series (comma separated, valid values are battery-voltage, cell-strengthproduct)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransceiverTimeSeriesData(transceiverId: number, startDate: string, endDate: string, sortKeys?: string, options?: any): AxiosPromise<InlineResponse2008> {
            return TransceiversApiFp(configuration).getTransceiverTimeSeriesData(transceiverId, startDate, endDate, sortKeys, options).then((request) => request(axios, basePath));
        },
        /**
         * returns all transceivers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransceivers(options?: any): AxiosPromise<TransceiversInData> {
            return TransceiversApiFp(configuration).getTransceivers(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Graph data for an entity
         * @param {'sensor' | 'transceiver' | 'vat'} entity entity to return
         * @param {number} id ID of entity to return
         * @param {number} startTs Start epoch timestamp to consider
         * @param {number} endTs End epoch timestamp to consider
         * @param {string} [series] Return one series
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graph(entity: 'sensor' | 'transceiver' | 'vat', id: number, startTs: number, endTs: number, series?: string, options?: any): AxiosPromise<GraphTimeSeriesInData> {
            return TransceiversApiFp(configuration).graph(entity, id, startTs, endTs, series, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns transceiver raw data
         * @summary reboot Transceiver
         * @param {number} transceiverId ID of transceiver to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rebootTransceiver(transceiverId: number, options?: any): AxiosPromise<InlineResponse20022> {
            return TransceiversApiFp(configuration).rebootTransceiver(transceiverId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sets a Chimera V1 transceiver mesh mode to deployment
         * @summary Set transceiver mesh mode to deployment
         * @param {number} transceiverId ID of transceiver to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setMeshDeploymentMode(transceiverId: number, options?: any): AxiosPromise<InlineResponse20023> {
            return TransceiversApiFp(configuration).setMeshDeploymentMode(transceiverId, options).then((request) => request(axios, basePath));
        },
        /**
         * Unallocate sensors from transceiver
         * @summary reboot Transceiver
         * @param {number} transceiverId ID of transceiver to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unallocateTransceiver(transceiverId: number, options?: any): AxiosPromise<InlineResponse20022> {
            return TransceiversApiFp(configuration).unallocateTransceiver(transceiverId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns transceiver raw data
         * @summary update Transceiver Metadata
         * @param {number} transceiverId ID of transceiver to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMetadata(transceiverId: number, options?: any): AxiosPromise<TransceiverInData> {
            return TransceiversApiFp(configuration).updateMetadata(transceiverId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates a transceiver
         * @param {number} transceiverId ID of transceiver to return
         * @param {TransceiverInData} transceiverInData Transceiver object to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTransceiver(transceiverId: number, transceiverInData: TransceiverInData, options?: any): AxiosPromise<void> {
            return TransceiversApiFp(configuration).updateTransceiver(transceiverId, transceiverInData, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TransceiversApi - object-oriented interface
 * @export
 * @class TransceiversApi
 * @extends {BaseAPI}
 */
export class TransceiversApi extends BaseAPI {
    /**
     * 
     * @summary Add a new transceivers to the service
     * @param {TransceiverInData} transceiverInData Transceiver object to be added to service
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransceiversApi
     */
    public addTransceiver(transceiverInData: TransceiverInData, options?: any) {
        return TransceiversApiFp(this.configuration).addTransceiver(transceiverInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Decommission a transceiver
     * @param {number} transceiverId ID of transceiver to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransceiversApi
     */
    public decommissionTransceiver(transceiverId: number, options?: any) {
        return TransceiversApiFp(this.configuration).decommissionTransceiver(transceiverId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes a transceiver
     * @param {number} transceiverId ID of transceiver to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransceiversApi
     */
    public deleteTransceiver(transceiverId: number, options?: any) {
        return TransceiversApiFp(this.configuration).deleteTransceiver(transceiverId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get data required by the OTA Manager tool
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransceiversApi
     */
    public getOtaManagerData(options?: any) {
        return TransceiversApiFp(this.configuration).getOtaManagerData(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a transceiver
     * @summary Find transceiver by ID
     * @param {number} transceiverId ID of transceiver to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransceiversApi
     */
    public getTransceiverById(transceiverId: number, options?: any) {
        return TransceiversApiFp(this.configuration).getTransceiverById(transceiverId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a transceivers Dashboard
     * @summary Get transceivers Dashboard Data
     * @param {number} transceiverId ID of transceiver to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransceiversApi
     */
    public getTransceiverDash(transceiverId: number, options?: any) {
        return TransceiversApiFp(this.configuration).getTransceiverDash(transceiverId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns transceiver raw data
     * @summary get Transceiver Data
     * @param {number} transceiverId ID of transceiver to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransceiversApi
     */
    public getTransceiverData(transceiverId: number, options?: any) {
        return TransceiversApiFp(this.configuration).getTransceiverData(transceiverId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns Transceiver diagnostic data
     * @summary Get transceiver diagnostic data
     * @param {number} transceiverId ID of transceiver to return
     * @param {number} [nDays] return only this many days worth of data. Default &#x3D; 2 usually
     * @param {string} [series] return one series
     * @param {string} [offset] go back X days
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransceiversApi
     */
    public getTransceiverGraphData(transceiverId: number, nDays?: number, series?: string, offset?: string, options?: any) {
        return TransceiversApiFp(this.configuration).getTransceiverGraphData(transceiverId, nDays, series, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get last check in time for a transceiver
     * @param {number} transceiverId ID of transceiver to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransceiversApi
     */
    public getTransceiverLastCheckInTime(transceiverId: number, options?: any) {
        return TransceiversApiFp(this.configuration).getTransceiverLastCheckInTime(transceiverId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns raw data
     * @summary Get Dynamo raw data for a given transceiver
     * @param {number} transceiverId ID of transceiver to return
     * @param {number} [limit] Number of items to return
     * @param {string} [exclusiveStartSortKey] Used for pagination, sortKey to start the search, (use sortKey from result)
     * @param {string} [exclusiveStartKey] Used for pagination, key to start the search, used by AWS transceivers only (use key from result)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransceiversApi
     */
    public getTransceiverRawData(transceiverId: number, limit?: number, exclusiveStartSortKey?: string, exclusiveStartKey?: string, options?: any) {
        return TransceiversApiFp(this.configuration).getTransceiverRawData(transceiverId, limit, exclusiveStartSortKey, exclusiveStartKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns transceiver raw data
     * @summary get Transceiver Data
     * @param {number} transceiverId ID of transceiver to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransceiversApi
     */
    public getTransceiverSeriesData(transceiverId: number, options?: any) {
        return TransceiversApiFp(this.configuration).getTransceiverSeriesData(transceiverId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns time series data
     * @summary Get Dynamo time series data for a given transceiver
     * @param {number} transceiverId ID of transceiver to return
     * @param {string} startDate Start time to consider
     * @param {string} endDate End time to consider
     * @param {string} [sortKeys] Return one or more series (comma separated, valid values are battery-voltage, cell-strengthproduct)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransceiversApi
     */
    public getTransceiverTimeSeriesData(transceiverId: number, startDate: string, endDate: string, sortKeys?: string, options?: any) {
        return TransceiversApiFp(this.configuration).getTransceiverTimeSeriesData(transceiverId, startDate, endDate, sortKeys, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * returns all transceivers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransceiversApi
     */
    public getTransceivers(options?: any) {
        return TransceiversApiFp(this.configuration).getTransceivers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Graph data for an entity
     * @param {'sensor' | 'transceiver' | 'vat'} entity entity to return
     * @param {number} id ID of entity to return
     * @param {number} startTs Start epoch timestamp to consider
     * @param {number} endTs End epoch timestamp to consider
     * @param {string} [series] Return one series
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransceiversApi
     */
    public graph(entity: 'sensor' | 'transceiver' | 'vat', id: number, startTs: number, endTs: number, series?: string, options?: any) {
        return TransceiversApiFp(this.configuration).graph(entity, id, startTs, endTs, series, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns transceiver raw data
     * @summary reboot Transceiver
     * @param {number} transceiverId ID of transceiver to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransceiversApi
     */
    public rebootTransceiver(transceiverId: number, options?: any) {
        return TransceiversApiFp(this.configuration).rebootTransceiver(transceiverId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sets a Chimera V1 transceiver mesh mode to deployment
     * @summary Set transceiver mesh mode to deployment
     * @param {number} transceiverId ID of transceiver to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransceiversApi
     */
    public setMeshDeploymentMode(transceiverId: number, options?: any) {
        return TransceiversApiFp(this.configuration).setMeshDeploymentMode(transceiverId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unallocate sensors from transceiver
     * @summary reboot Transceiver
     * @param {number} transceiverId ID of transceiver to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransceiversApi
     */
    public unallocateTransceiver(transceiverId: number, options?: any) {
        return TransceiversApiFp(this.configuration).unallocateTransceiver(transceiverId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns transceiver raw data
     * @summary update Transceiver Metadata
     * @param {number} transceiverId ID of transceiver to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransceiversApi
     */
    public updateMetadata(transceiverId: number, options?: any) {
        return TransceiversApiFp(this.configuration).updateMetadata(transceiverId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates a transceiver
     * @param {number} transceiverId ID of transceiver to return
     * @param {TransceiverInData} transceiverInData Transceiver object to be updated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransceiversApi
     */
    public updateTransceiver(transceiverId: number, transceiverInData: TransceiverInData, options?: any) {
        return TransceiversApiFp(this.configuration).updateTransceiver(transceiverId, transceiverInData, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates a User, if passed orgId and role will create role allocations
         * @summary Create user
         * @param {UserInData} userInData Created user object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: async (userInData: UserInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userInData' is not null or undefined
            if (userInData === null || userInData === undefined) {
                throw new RequiredError('userInData','Required parameter userInData was null or undefined when calling createUser.');
            }
            const localVarPath = `/users`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof userInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(userInData !== undefined ? userInData : {}) : (userInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This can only be done by the logged in user.
         * @summary Delete user
         * @param {number} userId ID of user to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser: async (userId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling deleteUser.');
            }
            const localVarPath = `/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user
         * @param {number} userId ID of user to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserId: async (userId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling getUserId.');
            }
            const localVarPath = `/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * returns all users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/users`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This can only be done by the logged in user.
         * @summary Updated user
         * @param {number} userId ID of user to return
         * @param {UserInData} userInData Updated user object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: async (userId: number, userInData: UserInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling updateUser.');
            }
            // verify required parameter 'userInData' is not null or undefined
            if (userInData === null || userInData === undefined) {
                throw new RequiredError('userInData','Required parameter userInData was null or undefined when calling updateUser.');
            }
            const localVarPath = `/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof userInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(userInData !== undefined ? userInData : {}) : (userInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create product permission
         * @summary Create product permission
         * @param {number} userId ID of user to return
         * @param {InlineObject38} inlineObject38 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userPermission: async (userId: number, inlineObject38: InlineObject38, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling userPermission.');
            }
            // verify required parameter 'inlineObject38' is not null or undefined
            if (inlineObject38 === null || inlineObject38 === undefined) {
                throw new RequiredError('inlineObject38','Required parameter inlineObject38 was null or undefined when calling userPermission.');
            }
            const localVarPath = `/users/{userId}/permissions`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof inlineObject38 !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(inlineObject38 !== undefined ? inlineObject38 : {}) : (inlineObject38 || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create product permission
         * @summary Upgrade/downgrade users product permissions
         * @param {number} userId ID of user to return
         * @param {InlineObject39} inlineObject39 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userPermissionChange: async (userId: number, inlineObject39: InlineObject39, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling userPermissionChange.');
            }
            // verify required parameter 'inlineObject39' is not null or undefined
            if (inlineObject39 === null || inlineObject39 === undefined) {
                throw new RequiredError('inlineObject39','Required parameter inlineObject39 was null or undefined when calling userPermissionChange.');
            }
            const localVarPath = `/users/{userId}/permissionsChange`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof inlineObject39 !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(inlineObject39 !== undefined ? inlineObject39 : {}) : (inlineObject39 || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create role allocations
         * @summary Create role allocation
         * @param {number} userId ID of user to return
         * @param {InlineObject37} inlineObject37 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRoles: async (userId: number, inlineObject37: InlineObject37, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling userRoles.');
            }
            // verify required parameter 'inlineObject37' is not null or undefined
            if (inlineObject37 === null || inlineObject37 === undefined) {
                throw new RequiredError('inlineObject37','Required parameter inlineObject37 was null or undefined when calling userRoles.');
            }
            const localVarPath = `/users/{userId}/roles`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof inlineObject37 !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(inlineObject37 !== undefined ? inlineObject37 : {}) : (inlineObject37 || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Creates a User, if passed orgId and role will create role allocations
         * @summary Create user
         * @param {UserInData} userInData Created user object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUser(userInData: UserInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await UsersApiAxiosParamCreator(configuration).createUser(userInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * This can only be done by the logged in user.
         * @summary Delete user
         * @param {number} userId ID of user to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUser(userId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await UsersApiAxiosParamCreator(configuration).deleteUser(userId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get user
         * @param {number} userId ID of user to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserId(userId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserInData>> {
            const localVarAxiosArgs = await UsersApiAxiosParamCreator(configuration).getUserId(userId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * returns all users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsers(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsersInData>> {
            const localVarAxiosArgs = await UsersApiAxiosParamCreator(configuration).getUsers(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * This can only be done by the logged in user.
         * @summary Updated user
         * @param {number} userId ID of user to return
         * @param {UserInData} userInData Updated user object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUser(userId: number, userInData: UserInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await UsersApiAxiosParamCreator(configuration).updateUser(userId, userInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Create product permission
         * @summary Create product permission
         * @param {number} userId ID of user to return
         * @param {InlineObject38} inlineObject38 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userPermission(userId: number, inlineObject38: InlineObject38, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await UsersApiAxiosParamCreator(configuration).userPermission(userId, inlineObject38, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Create product permission
         * @summary Upgrade/downgrade users product permissions
         * @param {number} userId ID of user to return
         * @param {InlineObject39} inlineObject39 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userPermissionChange(userId: number, inlineObject39: InlineObject39, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await UsersApiAxiosParamCreator(configuration).userPermissionChange(userId, inlineObject39, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Create role allocations
         * @summary Create role allocation
         * @param {number} userId ID of user to return
         * @param {InlineObject37} inlineObject37 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userRoles(userId: number, inlineObject37: InlineObject37, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await UsersApiAxiosParamCreator(configuration).userRoles(userId, inlineObject37, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Creates a User, if passed orgId and role will create role allocations
         * @summary Create user
         * @param {UserInData} userInData Created user object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser(userInData: UserInData, options?: any): AxiosPromise<void> {
            return UsersApiFp(configuration).createUser(userInData, options).then((request) => request(axios, basePath));
        },
        /**
         * This can only be done by the logged in user.
         * @summary Delete user
         * @param {number} userId ID of user to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser(userId: number, options?: any): AxiosPromise<void> {
            return UsersApiFp(configuration).deleteUser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user
         * @param {number} userId ID of user to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserId(userId: number, options?: any): AxiosPromise<UserInData> {
            return UsersApiFp(configuration).getUserId(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * returns all users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers(options?: any): AxiosPromise<UsersInData> {
            return UsersApiFp(configuration).getUsers(options).then((request) => request(axios, basePath));
        },
        /**
         * This can only be done by the logged in user.
         * @summary Updated user
         * @param {number} userId ID of user to return
         * @param {UserInData} userInData Updated user object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser(userId: number, userInData: UserInData, options?: any): AxiosPromise<void> {
            return UsersApiFp(configuration).updateUser(userId, userInData, options).then((request) => request(axios, basePath));
        },
        /**
         * Create product permission
         * @summary Create product permission
         * @param {number} userId ID of user to return
         * @param {InlineObject38} inlineObject38 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userPermission(userId: number, inlineObject38: InlineObject38, options?: any): AxiosPromise<void> {
            return UsersApiFp(configuration).userPermission(userId, inlineObject38, options).then((request) => request(axios, basePath));
        },
        /**
         * Create product permission
         * @summary Upgrade/downgrade users product permissions
         * @param {number} userId ID of user to return
         * @param {InlineObject39} inlineObject39 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userPermissionChange(userId: number, inlineObject39: InlineObject39, options?: any): AxiosPromise<void> {
            return UsersApiFp(configuration).userPermissionChange(userId, inlineObject39, options).then((request) => request(axios, basePath));
        },
        /**
         * Create role allocations
         * @summary Create role allocation
         * @param {number} userId ID of user to return
         * @param {InlineObject37} inlineObject37 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRoles(userId: number, inlineObject37: InlineObject37, options?: any): AxiosPromise<void> {
            return UsersApiFp(configuration).userRoles(userId, inlineObject37, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     * Creates a User, if passed orgId and role will create role allocations
     * @summary Create user
     * @param {UserInData} userInData Created user object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public createUser(userInData: UserInData, options?: any) {
        return UsersApiFp(this.configuration).createUser(userInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This can only be done by the logged in user.
     * @summary Delete user
     * @param {number} userId ID of user to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public deleteUser(userId: number, options?: any) {
        return UsersApiFp(this.configuration).deleteUser(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user
     * @param {number} userId ID of user to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getUserId(userId: number, options?: any) {
        return UsersApiFp(this.configuration).getUserId(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * returns all users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getUsers(options?: any) {
        return UsersApiFp(this.configuration).getUsers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This can only be done by the logged in user.
     * @summary Updated user
     * @param {number} userId ID of user to return
     * @param {UserInData} userInData Updated user object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public updateUser(userId: number, userInData: UserInData, options?: any) {
        return UsersApiFp(this.configuration).updateUser(userId, userInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create product permission
     * @summary Create product permission
     * @param {number} userId ID of user to return
     * @param {InlineObject38} inlineObject38 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public userPermission(userId: number, inlineObject38: InlineObject38, options?: any) {
        return UsersApiFp(this.configuration).userPermission(userId, inlineObject38, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create product permission
     * @summary Upgrade/downgrade users product permissions
     * @param {number} userId ID of user to return
     * @param {InlineObject39} inlineObject39 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public userPermissionChange(userId: number, inlineObject39: InlineObject39, options?: any) {
        return UsersApiFp(this.configuration).userPermissionChange(userId, inlineObject39, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create role allocations
     * @summary Create role allocation
     * @param {number} userId ID of user to return
     * @param {InlineObject37} inlineObject37 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public userRoles(userId: number, inlineObject37: InlineObject37, options?: any) {
        return UsersApiFp(this.configuration).userRoles(userId, inlineObject37, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * VatsApi - axios parameter creator
 * @export
 */
export const VatsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a new vat to the service
         * @param {CreateVatInData} createVatInData Vat object to be added to service
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addVat: async (createVatInData: CreateVatInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'createVatInData' is not null or undefined
            if (createVatInData === null || createVatInData === undefined) {
                throw new RequiredError('createVatInData','Required parameter createVatInData was null or undefined when calling addVat.');
            }
            const localVarPath = `/vats`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof createVatInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(createVatInData !== undefined ? createVatInData : {}) : (createVatInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cancel a pending vat install
         * @summary Cancel a vat install
         * @param {number} vatId ID of Vat
         * @param {CancelEntity} [cancelEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelVat: async (vatId: number, cancelEntity?: CancelEntity, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vatId' is not null or undefined
            if (vatId === null || vatId === undefined) {
                throw new RequiredError('vatId','Required parameter vatId was null or undefined when calling cancelVat.');
            }
            const localVarPath = `/vats/{vatId}/cancel`
                .replace(`{${"vatId"}}`, encodeURIComponent(String(vatId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof cancelEntity !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(cancelEntity !== undefined ? cancelEntity : {}) : (cancelEntity || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Move a vat from draft to pending
         * @summary Move a vat from draft to pending
         * @param {number} vatId ID of Vat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmDraftVat: async (vatId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vatId' is not null or undefined
            if (vatId === null || vatId === undefined) {
                throw new RequiredError('vatId','Required parameter vatId was null or undefined when calling confirmDraftVat.');
            }
            const localVarPath = `/vats/{vatId}/confirmDraft`
                .replace(`{${"vatId"}}`, encodeURIComponent(String(vatId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deactivate an existing vat
         * @summary Deactivate a vat
         * @param {number} vatId ID of Vat
         * @param {DeactivateEntity} [deactivateEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateVat: async (vatId: number, deactivateEntity?: DeactivateEntity, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vatId' is not null or undefined
            if (vatId === null || vatId === undefined) {
                throw new RequiredError('vatId','Required parameter vatId was null or undefined when calling deactivateVat.');
            }
            const localVarPath = `/vats/{vatId}/deactivate`
                .replace(`{${"vatId"}}`, encodeURIComponent(String(vatId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof deactivateEntity !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(deactivateEntity !== undefined ? deactivateEntity : {}) : (deactivateEntity || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes a vat
         * @param {number} vatId ID of Vat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVat: async (vatId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vatId' is not null or undefined
            if (vatId === null || vatId === undefined) {
                throw new RequiredError('vatId','Required parameter vatId was null or undefined when calling deleteVat.');
            }
            const localVarPath = `/vats/{vatId}`
                .replace(`{${"vatId"}}`, encodeURIComponent(String(vatId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns signed URL
         * @summary Get signed URL
         * @param {number} vatId ID of Vat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSignedUrl: async (vatId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vatId' is not null or undefined
            if (vatId === null || vatId === undefined) {
                throw new RequiredError('vatId','Required parameter vatId was null or undefined when calling getSignedUrl.');
            }
            const localVarPath = `/vats/sign/url`
                .replace(`{${"vatId"}}`, encodeURIComponent(String(vatId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a vat
         * @summary Find vat by ID
         * @param {number} vatId ID of Vat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVatById: async (vatId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vatId' is not null or undefined
            if (vatId === null || vatId === undefined) {
                throw new RequiredError('vatId','Required parameter vatId was null or undefined when calling getVatById.');
            }
            const localVarPath = `/vats/{vatId}`
                .replace(`{${"vatId"}}`, encodeURIComponent(String(vatId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns current Vat readings
         * @summary Find vat by ID
         * @param {number} vatId ID of Vat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVatCurrentData: async (vatId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vatId' is not null or undefined
            if (vatId === null || vatId === undefined) {
                throw new RequiredError('vatId','Required parameter vatId was null or undefined when calling getVatCurrentData.');
            }
            const localVarPath = `/vats/{vatId}/data`
                .replace(`{${"vatId"}}`, encodeURIComponent(String(vatId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns current Vat readings
         * @summary Find vat by ID
         * @param {number} vatId ID of Vat
         * @param {string} [series] return one series
         * @param {string} [offset] go back X days
         * @param {number} [nDays] return only this many days worth of data. Default &#x3D; 2 usually
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVatGraphData: async (vatId: number, series?: string, offset?: string, nDays?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vatId' is not null or undefined
            if (vatId === null || vatId === undefined) {
                throw new RequiredError('vatId','Required parameter vatId was null or undefined when calling getVatGraphData.');
            }
            const localVarPath = `/vats/{vatId}/graphData`
                .replace(`{${"vatId"}}`, encodeURIComponent(String(vatId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (series !== undefined) {
                localVarQueryParameter['series'] = series;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (nDays !== undefined) {
                localVarQueryParameter['nDays'] = nDays;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns Dynamo Vat/Transceiver/Sensor timeseries data in format suitable for charting
         * @summary Returns Dynamo Vat/Transceiver/Sensor timeseries data in format suitable for charting
         * @param {number} vatId ID of Vat
         * @param {number} startTs Start timestamp to consider
         * @param {number} endTs End timestamp to consider
         * @param {'alert' | 'boot' | 'inletTemp' | 'milkingFinish' | 'milkScore' | 'milkingStart' | 'pickupFinish' | 'pickupStart' | 'plantWashFinish' | 'plantWashStart' | 'power-outage' | 'req/vatSetup' | 'stirrer' | 'stirrerValue' | 'vat-init' | 'vatTemp' | 'vatWashFinish' | 'vatWashStart' | 'volume'} [series] Return one Dynamo timeseries, if not supplied will return all
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVatGraphVatData: async (vatId: number, startTs: number, endTs: number, series?: 'alert' | 'boot' | 'inletTemp' | 'milkingFinish' | 'milkScore' | 'milkingStart' | 'pickupFinish' | 'pickupStart' | 'plantWashFinish' | 'plantWashStart' | 'power-outage' | 'req/vatSetup' | 'stirrer' | 'stirrerValue' | 'vat-init' | 'vatTemp' | 'vatWashFinish' | 'vatWashStart' | 'volume', options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vatId' is not null or undefined
            if (vatId === null || vatId === undefined) {
                throw new RequiredError('vatId','Required parameter vatId was null or undefined when calling getVatGraphVatData.');
            }
            // verify required parameter 'startTs' is not null or undefined
            if (startTs === null || startTs === undefined) {
                throw new RequiredError('startTs','Required parameter startTs was null or undefined when calling getVatGraphVatData.');
            }
            // verify required parameter 'endTs' is not null or undefined
            if (endTs === null || endTs === undefined) {
                throw new RequiredError('endTs','Required parameter endTs was null or undefined when calling getVatGraphVatData.');
            }
            const localVarPath = `/vats/{vatId}/graphVatData`
                .replace(`{${"vatId"}}`, encodeURIComponent(String(vatId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (series !== undefined) {
                localVarQueryParameter['series'] = series;
            }

            if (startTs !== undefined) {
                localVarQueryParameter['startTs'] = startTs;
            }

            if (endTs !== undefined) {
                localVarQueryParameter['endTs'] = endTs;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * returns all vats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVats: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/vats`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sets or updates the transceiver and sensors attached to a vat
         * @param {number} vatId ID of Vat
         * @param {InstallVatInData} [installVatInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installVat: async (vatId: number, installVatInData?: InstallVatInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vatId' is not null or undefined
            if (vatId === null || vatId === undefined) {
                throw new RequiredError('vatId','Required parameter vatId was null or undefined when calling installVat.');
            }
            const localVarPath = `/vats/{vatId}/install`
                .replace(`{${"vatId"}}`, encodeURIComponent(String(vatId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof installVatInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(installVatInData !== undefined ? installVatInData : {}) : (installVatInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sets or updates the properties of a vat
         * @param {number} vatId ID of Vat
         * @param {ProvisionVatInData} [provisionVatInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        provisionVat: async (vatId: number, provisionVatInData?: ProvisionVatInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vatId' is not null or undefined
            if (vatId === null || vatId === undefined) {
                throw new RequiredError('vatId','Required parameter vatId was null or undefined when calling provisionVat.');
            }
            const localVarPath = `/vats/{vatId}/provision`
                .replace(`{${"vatId"}}`, encodeURIComponent(String(vatId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof provisionVatInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(provisionVatInData !== undefined ? provisionVatInData : {}) : (provisionVatInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set the empty distance for a vat
         * @param {number} vatId ID of Vat
         * @param {InlineObject36} [inlineObject36] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setEmptyDistance: async (vatId: number, inlineObject36?: InlineObject36, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vatId' is not null or undefined
            if (vatId === null || vatId === undefined) {
                throw new RequiredError('vatId','Required parameter vatId was null or undefined when calling setEmptyDistance.');
            }
            const localVarPath = `/vats/{vatId}/setEmptyDistance`
                .replace(`{${"vatId"}}`, encodeURIComponent(String(vatId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof inlineObject36 !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(inlineObject36 !== undefined ? inlineObject36 : {}) : (inlineObject36 || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set the temperature offset for a vat
         * @summary Set Vat temperature offset
         * @param {number} vatId ID of Vat
         * @param {VatTemperatureOffset} [vatTemperatureOffset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setTemperatureOffset: async (vatId: number, vatTemperatureOffset?: VatTemperatureOffset, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vatId' is not null or undefined
            if (vatId === null || vatId === undefined) {
                throw new RequiredError('vatId','Required parameter vatId was null or undefined when calling setTemperatureOffset.');
            }
            const localVarPath = `/vats/{vatId}/setTemperatureOffset`
                .replace(`{${"vatId"}}`, encodeURIComponent(String(vatId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof vatTemperatureOffset !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(vatTemperatureOffset !== undefined ? vatTemperatureOffset : {}) : (vatTemperatureOffset || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Confirm that a milk vat is configured correctly
         * @summary Sign-off a milk Vat
         * @param {number} vatId ID of Vat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signoffVat: async (vatId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vatId' is not null or undefined
            if (vatId === null || vatId === undefined) {
                throw new RequiredError('vatId','Required parameter vatId was null or undefined when calling signoffVat.');
            }
            const localVarPath = `/vats/{vatId}/signoff`
                .replace(`{${"vatId"}}`, encodeURIComponent(String(vatId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates a vat
         * @param {number} vatId ID of Vat
         * @param {VatInData} vatInData Vat object to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVat: async (vatId: number, vatInData: VatInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vatId' is not null or undefined
            if (vatId === null || vatId === undefined) {
                throw new RequiredError('vatId','Required parameter vatId was null or undefined when calling updateVat.');
            }
            // verify required parameter 'vatInData' is not null or undefined
            if (vatInData === null || vatInData === undefined) {
                throw new RequiredError('vatInData','Required parameter vatInData was null or undefined when calling updateVat.');
            }
            const localVarPath = `/vats/{vatId}`
                .replace(`{${"vatId"}}`, encodeURIComponent(String(vatId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof vatInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(vatInData !== undefined ? vatInData : {}) : (vatInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary uploads an image
         * @param {string} [additionalMetadata] Additional data to pass to server
         * @param {any} [file] file to upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFileVat: async (additionalMetadata?: string, file?: any, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/vats/uploadImage`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


            if (additionalMetadata !== undefined) { 
                localVarFormParams.append('additionalMetadata', additionalMetadata as any);
            }
    
            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Close the milk score for a given vat
         * @param {number} vatId ID of Vat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vatsVatIdCloseMilkScoreGet: async (vatId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vatId' is not null or undefined
            if (vatId === null || vatId === undefined) {
                throw new RequiredError('vatId','Required parameter vatId was null or undefined when calling vatsVatIdCloseMilkScoreGet.');
            }
            const localVarPath = `/vats/{vatId}/closeMilkScore`
                .replace(`{${"vatId"}}`, encodeURIComponent(String(vatId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve the current state metrics for the vats
         * @param {number} vatId ID of Vat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vatsVatIdCurrentStateGet: async (vatId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vatId' is not null or undefined
            if (vatId === null || vatId === undefined) {
                throw new RequiredError('vatId','Required parameter vatId was null or undefined when calling vatsVatIdCurrentStateGet.');
            }
            const localVarPath = `/vats/{vatId}/currentState`
                .replace(`{${"vatId"}}`, encodeURIComponent(String(vatId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve the milk score history for a given vat
         * @param {number} vatId ID of Vat
         * @param {number} startTs Start epoch timestamp to consider
         * @param {number} endTs End epoch timestamp to consider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vatsVatIdMilkScoreHistoryGet: async (vatId: number, startTs: number, endTs: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vatId' is not null or undefined
            if (vatId === null || vatId === undefined) {
                throw new RequiredError('vatId','Required parameter vatId was null or undefined when calling vatsVatIdMilkScoreHistoryGet.');
            }
            // verify required parameter 'startTs' is not null or undefined
            if (startTs === null || startTs === undefined) {
                throw new RequiredError('startTs','Required parameter startTs was null or undefined when calling vatsVatIdMilkScoreHistoryGet.');
            }
            // verify required parameter 'endTs' is not null or undefined
            if (endTs === null || endTs === undefined) {
                throw new RequiredError('endTs','Required parameter endTs was null or undefined when calling vatsVatIdMilkScoreHistoryGet.');
            }
            const localVarPath = `/vats/{vatId}/milkScoreHistory`
                .replace(`{${"vatId"}}`, encodeURIComponent(String(vatId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (startTs !== undefined) {
                localVarQueryParameter['startTs'] = startTs;
            }

            if (endTs !== undefined) {
                localVarQueryParameter['endTs'] = endTs;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VatsApi - functional programming interface
 * @export
 */
export const VatsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a new vat to the service
         * @param {CreateVatInData} createVatInData Vat object to be added to service
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addVat(createVatInData: CreateVatInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await VatsApiAxiosParamCreator(configuration).addVat(createVatInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Cancel a pending vat install
         * @summary Cancel a vat install
         * @param {number} vatId ID of Vat
         * @param {CancelEntity} [cancelEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelVat(vatId: number, cancelEntity?: CancelEntity, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await VatsApiAxiosParamCreator(configuration).cancelVat(vatId, cancelEntity, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Move a vat from draft to pending
         * @summary Move a vat from draft to pending
         * @param {number} vatId ID of Vat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmDraftVat(vatId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VatInData>> {
            const localVarAxiosArgs = await VatsApiAxiosParamCreator(configuration).confirmDraftVat(vatId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Deactivate an existing vat
         * @summary Deactivate a vat
         * @param {number} vatId ID of Vat
         * @param {DeactivateEntity} [deactivateEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deactivateVat(vatId: number, deactivateEntity?: DeactivateEntity, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await VatsApiAxiosParamCreator(configuration).deactivateVat(vatId, deactivateEntity, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Deletes a vat
         * @param {number} vatId ID of Vat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteVat(vatId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await VatsApiAxiosParamCreator(configuration).deleteVat(vatId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns signed URL
         * @summary Get signed URL
         * @param {number} vatId ID of Vat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSignedUrl(vatId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignedUrl>> {
            const localVarAxiosArgs = await VatsApiAxiosParamCreator(configuration).getSignedUrl(vatId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns a vat
         * @summary Find vat by ID
         * @param {number} vatId ID of Vat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVatById(vatId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VatInData>> {
            const localVarAxiosArgs = await VatsApiAxiosParamCreator(configuration).getVatById(vatId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns current Vat readings
         * @summary Find vat by ID
         * @param {number} vatId ID of Vat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVatCurrentData(vatId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VatDataInData>> {
            const localVarAxiosArgs = await VatsApiAxiosParamCreator(configuration).getVatCurrentData(vatId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns current Vat readings
         * @summary Find vat by ID
         * @param {number} vatId ID of Vat
         * @param {string} [series] return one series
         * @param {string} [offset] go back X days
         * @param {number} [nDays] return only this many days worth of data. Default &#x3D; 2 usually
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVatGraphData(vatId: number, series?: string, offset?: string, nDays?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GraphDataInData>> {
            const localVarAxiosArgs = await VatsApiAxiosParamCreator(configuration).getVatGraphData(vatId, series, offset, nDays, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns Dynamo Vat/Transceiver/Sensor timeseries data in format suitable for charting
         * @summary Returns Dynamo Vat/Transceiver/Sensor timeseries data in format suitable for charting
         * @param {number} vatId ID of Vat
         * @param {number} startTs Start timestamp to consider
         * @param {number} endTs End timestamp to consider
         * @param {'alert' | 'boot' | 'inletTemp' | 'milkingFinish' | 'milkScore' | 'milkingStart' | 'pickupFinish' | 'pickupStart' | 'plantWashFinish' | 'plantWashStart' | 'power-outage' | 'req/vatSetup' | 'stirrer' | 'stirrerValue' | 'vat-init' | 'vatTemp' | 'vatWashFinish' | 'vatWashStart' | 'volume'} [series] Return one Dynamo timeseries, if not supplied will return all
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVatGraphVatData(vatId: number, startTs: number, endTs: number, series?: 'alert' | 'boot' | 'inletTemp' | 'milkingFinish' | 'milkScore' | 'milkingStart' | 'pickupFinish' | 'pickupStart' | 'plantWashFinish' | 'plantWashStart' | 'power-outage' | 'req/vatSetup' | 'stirrer' | 'stirrerValue' | 'vat-init' | 'vatTemp' | 'vatWashFinish' | 'vatWashStart' | 'volume', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await VatsApiAxiosParamCreator(configuration).getVatGraphVatData(vatId, startTs, endTs, series, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * returns all vats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVats(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VatsInData>> {
            const localVarAxiosArgs = await VatsApiAxiosParamCreator(configuration).getVats(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Sets or updates the transceiver and sensors attached to a vat
         * @param {number} vatId ID of Vat
         * @param {InstallVatInData} [installVatInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async installVat(vatId: number, installVatInData?: InstallVatInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VatInData>> {
            const localVarAxiosArgs = await VatsApiAxiosParamCreator(configuration).installVat(vatId, installVatInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Sets or updates the properties of a vat
         * @param {number} vatId ID of Vat
         * @param {ProvisionVatInData} [provisionVatInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async provisionVat(vatId: number, provisionVatInData?: ProvisionVatInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VatInData>> {
            const localVarAxiosArgs = await VatsApiAxiosParamCreator(configuration).provisionVat(vatId, provisionVatInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Set the empty distance for a vat
         * @param {number} vatId ID of Vat
         * @param {InlineObject36} [inlineObject36] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setEmptyDistance(vatId: number, inlineObject36?: InlineObject36, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VatInData>> {
            const localVarAxiosArgs = await VatsApiAxiosParamCreator(configuration).setEmptyDistance(vatId, inlineObject36, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Set the temperature offset for a vat
         * @summary Set Vat temperature offset
         * @param {number} vatId ID of Vat
         * @param {VatTemperatureOffset} [vatTemperatureOffset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setTemperatureOffset(vatId: number, vatTemperatureOffset?: VatTemperatureOffset, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await VatsApiAxiosParamCreator(configuration).setTemperatureOffset(vatId, vatTemperatureOffset, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Confirm that a milk vat is configured correctly
         * @summary Sign-off a milk Vat
         * @param {number} vatId ID of Vat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signoffVat(vatId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await VatsApiAxiosParamCreator(configuration).signoffVat(vatId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Updates a vat
         * @param {number} vatId ID of Vat
         * @param {VatInData} vatInData Vat object to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateVat(vatId: number, vatInData: VatInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await VatsApiAxiosParamCreator(configuration).updateVat(vatId, vatInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary uploads an image
         * @param {string} [additionalMetadata] Additional data to pass to server
         * @param {any} [file] file to upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadFileVat(additionalMetadata?: string, file?: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponse>> {
            const localVarAxiosArgs = await VatsApiAxiosParamCreator(configuration).uploadFileVat(additionalMetadata, file, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Close the milk score for a given vat
         * @param {number} vatId ID of Vat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vatsVatIdCloseMilkScoreGet(vatId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await VatsApiAxiosParamCreator(configuration).vatsVatIdCloseMilkScoreGet(vatId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Retrieve the current state metrics for the vats
         * @param {number} vatId ID of Vat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vatsVatIdCurrentStateGet(vatId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2008>> {
            const localVarAxiosArgs = await VatsApiAxiosParamCreator(configuration).vatsVatIdCurrentStateGet(vatId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Retrieve the milk score history for a given vat
         * @param {number} vatId ID of Vat
         * @param {number} startTs Start epoch timestamp to consider
         * @param {number} endTs End epoch timestamp to consider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vatsVatIdMilkScoreHistoryGet(vatId: number, startTs: number, endTs: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MilkScoreHistoryInData>> {
            const localVarAxiosArgs = await VatsApiAxiosParamCreator(configuration).vatsVatIdMilkScoreHistoryGet(vatId, startTs, endTs, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * VatsApi - factory interface
 * @export
 */
export const VatsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Add a new vat to the service
         * @param {CreateVatInData} createVatInData Vat object to be added to service
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addVat(createVatInData: CreateVatInData, options?: any): AxiosPromise<void> {
            return VatsApiFp(configuration).addVat(createVatInData, options).then((request) => request(axios, basePath));
        },
        /**
         * Cancel a pending vat install
         * @summary Cancel a vat install
         * @param {number} vatId ID of Vat
         * @param {CancelEntity} [cancelEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelVat(vatId: number, cancelEntity?: CancelEntity, options?: any): AxiosPromise<void> {
            return VatsApiFp(configuration).cancelVat(vatId, cancelEntity, options).then((request) => request(axios, basePath));
        },
        /**
         * Move a vat from draft to pending
         * @summary Move a vat from draft to pending
         * @param {number} vatId ID of Vat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmDraftVat(vatId: number, options?: any): AxiosPromise<VatInData> {
            return VatsApiFp(configuration).confirmDraftVat(vatId, options).then((request) => request(axios, basePath));
        },
        /**
         * Deactivate an existing vat
         * @summary Deactivate a vat
         * @param {number} vatId ID of Vat
         * @param {DeactivateEntity} [deactivateEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateVat(vatId: number, deactivateEntity?: DeactivateEntity, options?: any): AxiosPromise<void> {
            return VatsApiFp(configuration).deactivateVat(vatId, deactivateEntity, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes a vat
         * @param {number} vatId ID of Vat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVat(vatId: number, options?: any): AxiosPromise<void> {
            return VatsApiFp(configuration).deleteVat(vatId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns signed URL
         * @summary Get signed URL
         * @param {number} vatId ID of Vat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSignedUrl(vatId: number, options?: any): AxiosPromise<SignedUrl> {
            return VatsApiFp(configuration).getSignedUrl(vatId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a vat
         * @summary Find vat by ID
         * @param {number} vatId ID of Vat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVatById(vatId: number, options?: any): AxiosPromise<VatInData> {
            return VatsApiFp(configuration).getVatById(vatId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns current Vat readings
         * @summary Find vat by ID
         * @param {number} vatId ID of Vat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVatCurrentData(vatId: number, options?: any): AxiosPromise<VatDataInData> {
            return VatsApiFp(configuration).getVatCurrentData(vatId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns current Vat readings
         * @summary Find vat by ID
         * @param {number} vatId ID of Vat
         * @param {string} [series] return one series
         * @param {string} [offset] go back X days
         * @param {number} [nDays] return only this many days worth of data. Default &#x3D; 2 usually
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVatGraphData(vatId: number, series?: string, offset?: string, nDays?: number, options?: any): AxiosPromise<GraphDataInData> {
            return VatsApiFp(configuration).getVatGraphData(vatId, series, offset, nDays, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns Dynamo Vat/Transceiver/Sensor timeseries data in format suitable for charting
         * @summary Returns Dynamo Vat/Transceiver/Sensor timeseries data in format suitable for charting
         * @param {number} vatId ID of Vat
         * @param {number} startTs Start timestamp to consider
         * @param {number} endTs End timestamp to consider
         * @param {'alert' | 'boot' | 'inletTemp' | 'milkingFinish' | 'milkScore' | 'milkingStart' | 'pickupFinish' | 'pickupStart' | 'plantWashFinish' | 'plantWashStart' | 'power-outage' | 'req/vatSetup' | 'stirrer' | 'stirrerValue' | 'vat-init' | 'vatTemp' | 'vatWashFinish' | 'vatWashStart' | 'volume'} [series] Return one Dynamo timeseries, if not supplied will return all
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVatGraphVatData(vatId: number, startTs: number, endTs: number, series?: 'alert' | 'boot' | 'inletTemp' | 'milkingFinish' | 'milkScore' | 'milkingStart' | 'pickupFinish' | 'pickupStart' | 'plantWashFinish' | 'plantWashStart' | 'power-outage' | 'req/vatSetup' | 'stirrer' | 'stirrerValue' | 'vat-init' | 'vatTemp' | 'vatWashFinish' | 'vatWashStart' | 'volume', options?: any): AxiosPromise<Array<object>> {
            return VatsApiFp(configuration).getVatGraphVatData(vatId, startTs, endTs, series, options).then((request) => request(axios, basePath));
        },
        /**
         * returns all vats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVats(options?: any): AxiosPromise<VatsInData> {
            return VatsApiFp(configuration).getVats(options).then((request) => request(axios, basePath));
        },
        /**
         * Sets or updates the transceiver and sensors attached to a vat
         * @param {number} vatId ID of Vat
         * @param {InstallVatInData} [installVatInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installVat(vatId: number, installVatInData?: InstallVatInData, options?: any): AxiosPromise<VatInData> {
            return VatsApiFp(configuration).installVat(vatId, installVatInData, options).then((request) => request(axios, basePath));
        },
        /**
         * Sets or updates the properties of a vat
         * @param {number} vatId ID of Vat
         * @param {ProvisionVatInData} [provisionVatInData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        provisionVat(vatId: number, provisionVatInData?: ProvisionVatInData, options?: any): AxiosPromise<VatInData> {
            return VatsApiFp(configuration).provisionVat(vatId, provisionVatInData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set the empty distance for a vat
         * @param {number} vatId ID of Vat
         * @param {InlineObject36} [inlineObject36] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setEmptyDistance(vatId: number, inlineObject36?: InlineObject36, options?: any): AxiosPromise<VatInData> {
            return VatsApiFp(configuration).setEmptyDistance(vatId, inlineObject36, options).then((request) => request(axios, basePath));
        },
        /**
         * Set the temperature offset for a vat
         * @summary Set Vat temperature offset
         * @param {number} vatId ID of Vat
         * @param {VatTemperatureOffset} [vatTemperatureOffset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setTemperatureOffset(vatId: number, vatTemperatureOffset?: VatTemperatureOffset, options?: any): AxiosPromise<void> {
            return VatsApiFp(configuration).setTemperatureOffset(vatId, vatTemperatureOffset, options).then((request) => request(axios, basePath));
        },
        /**
         * Confirm that a milk vat is configured correctly
         * @summary Sign-off a milk Vat
         * @param {number} vatId ID of Vat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signoffVat(vatId: number, options?: any): AxiosPromise<void> {
            return VatsApiFp(configuration).signoffVat(vatId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates a vat
         * @param {number} vatId ID of Vat
         * @param {VatInData} vatInData Vat object to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVat(vatId: number, vatInData: VatInData, options?: any): AxiosPromise<void> {
            return VatsApiFp(configuration).updateVat(vatId, vatInData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary uploads an image
         * @param {string} [additionalMetadata] Additional data to pass to server
         * @param {any} [file] file to upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFileVat(additionalMetadata?: string, file?: any, options?: any): AxiosPromise<ApiResponse> {
            return VatsApiFp(configuration).uploadFileVat(additionalMetadata, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Close the milk score for a given vat
         * @param {number} vatId ID of Vat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vatsVatIdCloseMilkScoreGet(vatId: number, options?: any): AxiosPromise<void> {
            return VatsApiFp(configuration).vatsVatIdCloseMilkScoreGet(vatId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve the current state metrics for the vats
         * @param {number} vatId ID of Vat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vatsVatIdCurrentStateGet(vatId: number, options?: any): AxiosPromise<InlineResponse2008> {
            return VatsApiFp(configuration).vatsVatIdCurrentStateGet(vatId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve the milk score history for a given vat
         * @param {number} vatId ID of Vat
         * @param {number} startTs Start epoch timestamp to consider
         * @param {number} endTs End epoch timestamp to consider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vatsVatIdMilkScoreHistoryGet(vatId: number, startTs: number, endTs: number, options?: any): AxiosPromise<MilkScoreHistoryInData> {
            return VatsApiFp(configuration).vatsVatIdMilkScoreHistoryGet(vatId, startTs, endTs, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VatsApi - object-oriented interface
 * @export
 * @class VatsApi
 * @extends {BaseAPI}
 */
export class VatsApi extends BaseAPI {
    /**
     * 
     * @summary Add a new vat to the service
     * @param {CreateVatInData} createVatInData Vat object to be added to service
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VatsApi
     */
    public addVat(createVatInData: CreateVatInData, options?: any) {
        return VatsApiFp(this.configuration).addVat(createVatInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cancel a pending vat install
     * @summary Cancel a vat install
     * @param {number} vatId ID of Vat
     * @param {CancelEntity} [cancelEntity] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VatsApi
     */
    public cancelVat(vatId: number, cancelEntity?: CancelEntity, options?: any) {
        return VatsApiFp(this.configuration).cancelVat(vatId, cancelEntity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Move a vat from draft to pending
     * @summary Move a vat from draft to pending
     * @param {number} vatId ID of Vat
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VatsApi
     */
    public confirmDraftVat(vatId: number, options?: any) {
        return VatsApiFp(this.configuration).confirmDraftVat(vatId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deactivate an existing vat
     * @summary Deactivate a vat
     * @param {number} vatId ID of Vat
     * @param {DeactivateEntity} [deactivateEntity] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VatsApi
     */
    public deactivateVat(vatId: number, deactivateEntity?: DeactivateEntity, options?: any) {
        return VatsApiFp(this.configuration).deactivateVat(vatId, deactivateEntity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes a vat
     * @param {number} vatId ID of Vat
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VatsApi
     */
    public deleteVat(vatId: number, options?: any) {
        return VatsApiFp(this.configuration).deleteVat(vatId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns signed URL
     * @summary Get signed URL
     * @param {number} vatId ID of Vat
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VatsApi
     */
    public getSignedUrl(vatId: number, options?: any) {
        return VatsApiFp(this.configuration).getSignedUrl(vatId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a vat
     * @summary Find vat by ID
     * @param {number} vatId ID of Vat
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VatsApi
     */
    public getVatById(vatId: number, options?: any) {
        return VatsApiFp(this.configuration).getVatById(vatId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns current Vat readings
     * @summary Find vat by ID
     * @param {number} vatId ID of Vat
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VatsApi
     */
    public getVatCurrentData(vatId: number, options?: any) {
        return VatsApiFp(this.configuration).getVatCurrentData(vatId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns current Vat readings
     * @summary Find vat by ID
     * @param {number} vatId ID of Vat
     * @param {string} [series] return one series
     * @param {string} [offset] go back X days
     * @param {number} [nDays] return only this many days worth of data. Default &#x3D; 2 usually
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VatsApi
     */
    public getVatGraphData(vatId: number, series?: string, offset?: string, nDays?: number, options?: any) {
        return VatsApiFp(this.configuration).getVatGraphData(vatId, series, offset, nDays, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns Dynamo Vat/Transceiver/Sensor timeseries data in format suitable for charting
     * @summary Returns Dynamo Vat/Transceiver/Sensor timeseries data in format suitable for charting
     * @param {number} vatId ID of Vat
     * @param {number} startTs Start timestamp to consider
     * @param {number} endTs End timestamp to consider
     * @param {'alert' | 'boot' | 'inletTemp' | 'milkingFinish' | 'milkScore' | 'milkingStart' | 'pickupFinish' | 'pickupStart' | 'plantWashFinish' | 'plantWashStart' | 'power-outage' | 'req/vatSetup' | 'stirrer' | 'stirrerValue' | 'vat-init' | 'vatTemp' | 'vatWashFinish' | 'vatWashStart' | 'volume'} [series] Return one Dynamo timeseries, if not supplied will return all
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VatsApi
     */
    public getVatGraphVatData(vatId: number, startTs: number, endTs: number, series?: 'alert' | 'boot' | 'inletTemp' | 'milkingFinish' | 'milkScore' | 'milkingStart' | 'pickupFinish' | 'pickupStart' | 'plantWashFinish' | 'plantWashStart' | 'power-outage' | 'req/vatSetup' | 'stirrer' | 'stirrerValue' | 'vat-init' | 'vatTemp' | 'vatWashFinish' | 'vatWashStart' | 'volume', options?: any) {
        return VatsApiFp(this.configuration).getVatGraphVatData(vatId, startTs, endTs, series, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * returns all vats
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VatsApi
     */
    public getVats(options?: any) {
        return VatsApiFp(this.configuration).getVats(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sets or updates the transceiver and sensors attached to a vat
     * @param {number} vatId ID of Vat
     * @param {InstallVatInData} [installVatInData] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VatsApi
     */
    public installVat(vatId: number, installVatInData?: InstallVatInData, options?: any) {
        return VatsApiFp(this.configuration).installVat(vatId, installVatInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sets or updates the properties of a vat
     * @param {number} vatId ID of Vat
     * @param {ProvisionVatInData} [provisionVatInData] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VatsApi
     */
    public provisionVat(vatId: number, provisionVatInData?: ProvisionVatInData, options?: any) {
        return VatsApiFp(this.configuration).provisionVat(vatId, provisionVatInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set the empty distance for a vat
     * @param {number} vatId ID of Vat
     * @param {InlineObject36} [inlineObject36] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VatsApi
     */
    public setEmptyDistance(vatId: number, inlineObject36?: InlineObject36, options?: any) {
        return VatsApiFp(this.configuration).setEmptyDistance(vatId, inlineObject36, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set the temperature offset for a vat
     * @summary Set Vat temperature offset
     * @param {number} vatId ID of Vat
     * @param {VatTemperatureOffset} [vatTemperatureOffset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VatsApi
     */
    public setTemperatureOffset(vatId: number, vatTemperatureOffset?: VatTemperatureOffset, options?: any) {
        return VatsApiFp(this.configuration).setTemperatureOffset(vatId, vatTemperatureOffset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Confirm that a milk vat is configured correctly
     * @summary Sign-off a milk Vat
     * @param {number} vatId ID of Vat
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VatsApi
     */
    public signoffVat(vatId: number, options?: any) {
        return VatsApiFp(this.configuration).signoffVat(vatId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates a vat
     * @param {number} vatId ID of Vat
     * @param {VatInData} vatInData Vat object to be updated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VatsApi
     */
    public updateVat(vatId: number, vatInData: VatInData, options?: any) {
        return VatsApiFp(this.configuration).updateVat(vatId, vatInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary uploads an image
     * @param {string} [additionalMetadata] Additional data to pass to server
     * @param {any} [file] file to upload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VatsApi
     */
    public uploadFileVat(additionalMetadata?: string, file?: any, options?: any) {
        return VatsApiFp(this.configuration).uploadFileVat(additionalMetadata, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Close the milk score for a given vat
     * @param {number} vatId ID of Vat
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VatsApi
     */
    public vatsVatIdCloseMilkScoreGet(vatId: number, options?: any) {
        return VatsApiFp(this.configuration).vatsVatIdCloseMilkScoreGet(vatId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve the current state metrics for the vats
     * @param {number} vatId ID of Vat
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VatsApi
     */
    public vatsVatIdCurrentStateGet(vatId: number, options?: any) {
        return VatsApiFp(this.configuration).vatsVatIdCurrentStateGet(vatId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve the milk score history for a given vat
     * @param {number} vatId ID of Vat
     * @param {number} startTs Start epoch timestamp to consider
     * @param {number} endTs End epoch timestamp to consider
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VatsApi
     */
    public vatsVatIdMilkScoreHistoryGet(vatId: number, startTs: number, endTs: number, options?: any) {
        return VatsApiFp(this.configuration).vatsVatIdMilkScoreHistoryGet(vatId, startTs, endTs, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * WaterApi - axios parameter creator
 * @export
 */
export const WaterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a water meter to a water product
         * @summary Add a water meter
         * @param {WaterMeterInfoInData} waterMeterInfoInData Water meter to be added to a water product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addWaterMeter: async (waterMeterInfoInData: WaterMeterInfoInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMeterInfoInData' is not null or undefined
            if (waterMeterInfoInData === null || waterMeterInfoInData === undefined) {
                throw new RequiredError('waterMeterInfoInData','Required parameter waterMeterInfoInData was null or undefined when calling addWaterMeter.');
            }
            const localVarPath = `/water/meters`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof waterMeterInfoInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(waterMeterInfoInData !== undefined ? waterMeterInfoInData : {}) : (waterMeterInfoInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a water monitor to a water product
         * @summary Add a water monitor
         * @param {WaterMonitorInfoInData} waterMonitorInfoInData Water monitor to be added to a water product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addWaterMonitor: async (waterMonitorInfoInData: WaterMonitorInfoInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMonitorInfoInData' is not null or undefined
            if (waterMonitorInfoInData === null || waterMonitorInfoInData === undefined) {
                throw new RequiredError('waterMonitorInfoInData','Required parameter waterMonitorInfoInData was null or undefined when calling addWaterMonitor.');
            }
            const localVarPath = `/water/monitors`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof waterMonitorInfoInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(waterMonitorInfoInData !== undefined ? waterMonitorInfoInData : {}) : (waterMonitorInfoInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a water tank to a water product
         * @summary Add a water tank
         * @param {WaterTankInfoInData} waterTankInfoInData Water tank to be added to a water product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addWaterTank: async (waterTankInfoInData: WaterTankInfoInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterTankInfoInData' is not null or undefined
            if (waterTankInfoInData === null || waterTankInfoInData === undefined) {
                throw new RequiredError('waterTankInfoInData','Required parameter waterTankInfoInData was null or undefined when calling addWaterTank.');
            }
            const localVarPath = `/water/tanks`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof waterTankInfoInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(waterTankInfoInData !== undefined ? waterTankInfoInData : {}) : (waterTankInfoInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Applies a totalizer correction to the water meter
         * @summary Apply totalizer correction
         * @param {number} waterMeterId ID of a water meter
         * @param {WaterTotalizerCorrection} waterTotalizerCorrection 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyMeterTotalizerCorrection: async (waterMeterId: number, waterTotalizerCorrection: WaterTotalizerCorrection, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMeterId' is not null or undefined
            if (waterMeterId === null || waterMeterId === undefined) {
                throw new RequiredError('waterMeterId','Required parameter waterMeterId was null or undefined when calling applyMeterTotalizerCorrection.');
            }
            // verify required parameter 'waterTotalizerCorrection' is not null or undefined
            if (waterTotalizerCorrection === null || waterTotalizerCorrection === undefined) {
                throw new RequiredError('waterTotalizerCorrection','Required parameter waterTotalizerCorrection was null or undefined when calling applyMeterTotalizerCorrection.');
            }
            const localVarPath = `/water/meters/{waterMeterId}/applyCorrection`
                .replace(`{${"waterMeterId"}}`, encodeURIComponent(String(waterMeterId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof waterTotalizerCorrection !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(waterTotalizerCorrection !== undefined ? waterTotalizerCorrection : {}) : (waterTotalizerCorrection || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Applies a totalizer correction to the water monitor
         * @summary Apply totalizer correction
         * @param {number} waterMonitorId ID of a water monitor
         * @param {WaterTotalizerCorrection} waterTotalizerCorrection 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyMonitorTotalizerCorrection: async (waterMonitorId: number, waterTotalizerCorrection: WaterTotalizerCorrection, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMonitorId' is not null or undefined
            if (waterMonitorId === null || waterMonitorId === undefined) {
                throw new RequiredError('waterMonitorId','Required parameter waterMonitorId was null or undefined when calling applyMonitorTotalizerCorrection.');
            }
            // verify required parameter 'waterTotalizerCorrection' is not null or undefined
            if (waterTotalizerCorrection === null || waterTotalizerCorrection === undefined) {
                throw new RequiredError('waterTotalizerCorrection','Required parameter waterTotalizerCorrection was null or undefined when calling applyMonitorTotalizerCorrection.');
            }
            const localVarPath = `/water/monitors/{waterMonitorId}/applyCorrection`
                .replace(`{${"waterMonitorId"}}`, encodeURIComponent(String(waterMonitorId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof waterTotalizerCorrection !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(waterTotalizerCorrection !== undefined ? waterTotalizerCorrection : {}) : (waterTotalizerCorrection || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Assign a water meter flow rate sensor with a water meter
         * @summary Assign a water meter sensor
         * @param {number} waterMeterId ID of a water meter
         * @param {WaterMeterSensorsAssignInData} waterMeterSensorsAssignInData Water meter sensor to assign to a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignWaterMeterSensors: async (waterMeterId: number, waterMeterSensorsAssignInData: WaterMeterSensorsAssignInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMeterId' is not null or undefined
            if (waterMeterId === null || waterMeterId === undefined) {
                throw new RequiredError('waterMeterId','Required parameter waterMeterId was null or undefined when calling assignWaterMeterSensors.');
            }
            // verify required parameter 'waterMeterSensorsAssignInData' is not null or undefined
            if (waterMeterSensorsAssignInData === null || waterMeterSensorsAssignInData === undefined) {
                throw new RequiredError('waterMeterSensorsAssignInData','Required parameter waterMeterSensorsAssignInData was null or undefined when calling assignWaterMeterSensors.');
            }
            const localVarPath = `/water/meters/{waterMeterId}/assign`
                .replace(`{${"waterMeterId"}}`, encodeURIComponent(String(waterMeterId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof waterMeterSensorsAssignInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(waterMeterSensorsAssignInData !== undefined ? waterMeterSensorsAssignInData : {}) : (waterMeterSensorsAssignInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Assign a water monitor flow rate sensor with a water monitor
         * @summary Assign a water monitor sensor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {WaterMonitorSensorsAssignInData} waterMonitorSensorsAssignInData Water monitor sensor to assign to a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignWaterMonitorSensors: async (waterMonitorId: number, waterMonitorSensorsAssignInData: WaterMonitorSensorsAssignInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMonitorId' is not null or undefined
            if (waterMonitorId === null || waterMonitorId === undefined) {
                throw new RequiredError('waterMonitorId','Required parameter waterMonitorId was null or undefined when calling assignWaterMonitorSensors.');
            }
            // verify required parameter 'waterMonitorSensorsAssignInData' is not null or undefined
            if (waterMonitorSensorsAssignInData === null || waterMonitorSensorsAssignInData === undefined) {
                throw new RequiredError('waterMonitorSensorsAssignInData','Required parameter waterMonitorSensorsAssignInData was null or undefined when calling assignWaterMonitorSensors.');
            }
            const localVarPath = `/water/monitors/{waterMonitorId}/assign`
                .replace(`{${"waterMonitorId"}}`, encodeURIComponent(String(waterMonitorId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof waterMonitorSensorsAssignInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(waterMonitorSensorsAssignInData !== undefined ? waterMonitorSensorsAssignInData : {}) : (waterMonitorSensorsAssignInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Assign a water tank pressure sensor with a water tank
         * @summary Assign a water tank sensor
         * @param {number} waterTankId ID of a water tank
         * @param {WaterTankSensorsAssignInData} waterTankSensorsAssignInData Water tank sensor to assign to a water tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignWaterTankSensors: async (waterTankId: number, waterTankSensorsAssignInData: WaterTankSensorsAssignInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterTankId' is not null or undefined
            if (waterTankId === null || waterTankId === undefined) {
                throw new RequiredError('waterTankId','Required parameter waterTankId was null or undefined when calling assignWaterTankSensors.');
            }
            // verify required parameter 'waterTankSensorsAssignInData' is not null or undefined
            if (waterTankSensorsAssignInData === null || waterTankSensorsAssignInData === undefined) {
                throw new RequiredError('waterTankSensorsAssignInData','Required parameter waterTankSensorsAssignInData was null or undefined when calling assignWaterTankSensors.');
            }
            const localVarPath = `/water/tanks/{waterTankId}/assign`
                .replace(`{${"waterTankId"}}`, encodeURIComponent(String(waterTankId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof waterTankSensorsAssignInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(waterTankSensorsAssignInData !== undefined ? waterTankSensorsAssignInData : {}) : (waterTankSensorsAssignInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cancel a pending water meter install
         * @summary Cancel a water meter install
         * @param {number} waterMeterId ID of a water meter
         * @param {CancelEntity} [cancelEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelWaterMeter: async (waterMeterId: number, cancelEntity?: CancelEntity, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMeterId' is not null or undefined
            if (waterMeterId === null || waterMeterId === undefined) {
                throw new RequiredError('waterMeterId','Required parameter waterMeterId was null or undefined when calling cancelWaterMeter.');
            }
            const localVarPath = `/water/meters/{waterMeterId}/cancel`
                .replace(`{${"waterMeterId"}}`, encodeURIComponent(String(waterMeterId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof cancelEntity !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(cancelEntity !== undefined ? cancelEntity : {}) : (cancelEntity || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cancel a pending water tank install
         * @summary Cancel a water tank install
         * @param {number} waterTankId ID of a water tank
         * @param {CancelEntity} [cancelEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelWaterTank: async (waterTankId: number, cancelEntity?: CancelEntity, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterTankId' is not null or undefined
            if (waterTankId === null || waterTankId === undefined) {
                throw new RequiredError('waterTankId','Required parameter waterTankId was null or undefined when calling cancelWaterTank.');
            }
            const localVarPath = `/water/tanks/{waterTankId}/cancel`
                .replace(`{${"waterTankId"}}`, encodeURIComponent(String(waterTankId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof cancelEntity !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(cancelEntity !== undefined ? cancelEntity : {}) : (cancelEntity || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Confirm a draft water meter
         * @summary Confirm a draft water meter, move to pending status
         * @param {number} waterMeterId ID of a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmDraftWaterMeter: async (waterMeterId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMeterId' is not null or undefined
            if (waterMeterId === null || waterMeterId === undefined) {
                throw new RequiredError('waterMeterId','Required parameter waterMeterId was null or undefined when calling confirmDraftWaterMeter.');
            }
            const localVarPath = `/water/meters/{waterMeterId}/confirmDraft`
                .replace(`{${"waterMeterId"}}`, encodeURIComponent(String(waterMeterId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Confirm a draft water monitor
         * @summary Confirm a draft water monitor, move to pending status
         * @param {number} waterMonitorId ID of a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmDraftWaterMonitor: async (waterMonitorId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMonitorId' is not null or undefined
            if (waterMonitorId === null || waterMonitorId === undefined) {
                throw new RequiredError('waterMonitorId','Required parameter waterMonitorId was null or undefined when calling confirmDraftWaterMonitor.');
            }
            const localVarPath = `/water/monitors/{waterMonitorId}/confirmDraft`
                .replace(`{${"waterMonitorId"}}`, encodeURIComponent(String(waterMonitorId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Confirm a draft water tank
         * @summary Confirm a draft water tank, move to pending status
         * @param {number} waterTankId ID of a water tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmDraftWaterTank: async (waterTankId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterTankId' is not null or undefined
            if (waterTankId === null || waterTankId === undefined) {
                throw new RequiredError('waterTankId','Required parameter waterTankId was null or undefined when calling confirmDraftWaterTank.');
            }
            const localVarPath = `/water/tanks/{waterTankId}/confirmDraft`
                .replace(`{${"waterTankId"}}`, encodeURIComponent(String(waterTankId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deactivate an existing water meter
         * @summary Deactivate a water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {DeactivateEntity} [deactivateEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateWaterMeter: async (waterMeterId: number, deactivateEntity?: DeactivateEntity, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMeterId' is not null or undefined
            if (waterMeterId === null || waterMeterId === undefined) {
                throw new RequiredError('waterMeterId','Required parameter waterMeterId was null or undefined when calling deactivateWaterMeter.');
            }
            const localVarPath = `/water/meters/{waterMeterId}/deactivate`
                .replace(`{${"waterMeterId"}}`, encodeURIComponent(String(waterMeterId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof deactivateEntity !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(deactivateEntity !== undefined ? deactivateEntity : {}) : (deactivateEntity || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deactivate an existing water monitor
         * @summary Deactivate a water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {DeactivateEntity} [deactivateEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateWaterMonitor: async (waterMonitorId: number, deactivateEntity?: DeactivateEntity, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMonitorId' is not null or undefined
            if (waterMonitorId === null || waterMonitorId === undefined) {
                throw new RequiredError('waterMonitorId','Required parameter waterMonitorId was null or undefined when calling deactivateWaterMonitor.');
            }
            const localVarPath = `/water/monitors/{waterMonitorId}/deactivate`
                .replace(`{${"waterMonitorId"}}`, encodeURIComponent(String(waterMonitorId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof deactivateEntity !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(deactivateEntity !== undefined ? deactivateEntity : {}) : (deactivateEntity || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deactivate an existing water tank
         * @summary Deactivate a water tank
         * @param {number} waterTankId ID of a water tank
         * @param {DeactivateEntity} [deactivateEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateWaterTank: async (waterTankId: number, deactivateEntity?: DeactivateEntity, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterTankId' is not null or undefined
            if (waterTankId === null || waterTankId === undefined) {
                throw new RequiredError('waterTankId','Required parameter waterTankId was null or undefined when calling deactivateWaterTank.');
            }
            const localVarPath = `/water/tanks/{waterTankId}/deactivate`
                .replace(`{${"waterTankId"}}`, encodeURIComponent(String(waterTankId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof deactivateEntity !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(deactivateEntity !== undefined ? deactivateEntity : {}) : (deactivateEntity || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWaterMeter: async (waterMeterId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMeterId' is not null or undefined
            if (waterMeterId === null || waterMeterId === undefined) {
                throw new RequiredError('waterMeterId','Required parameter waterMeterId was null or undefined when calling deleteWaterMeter.');
            }
            const localVarPath = `/water/meters/{waterMeterId}`
                .replace(`{${"waterMeterId"}}`, encodeURIComponent(String(waterMeterId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWaterMonitor: async (waterMonitorId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMonitorId' is not null or undefined
            if (waterMonitorId === null || waterMonitorId === undefined) {
                throw new RequiredError('waterMonitorId','Required parameter waterMonitorId was null or undefined when calling deleteWaterMonitor.');
            }
            const localVarPath = `/water/monitors/{waterMonitorId}`
                .replace(`{${"waterMonitorId"}}`, encodeURIComponent(String(waterMonitorId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a water tank
         * @param {number} waterTankId ID of a water tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWaterTank: async (waterTankId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterTankId' is not null or undefined
            if (waterTankId === null || waterTankId === undefined) {
                throw new RequiredError('waterTankId','Required parameter waterTankId was null or undefined when calling deleteWaterTank.');
            }
            const localVarPath = `/water/tanks/{waterTankId}`
                .replace(`{${"waterTankId"}}`, encodeURIComponent(String(waterTankId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the latest totalizer corrections
         * @summary Get the latest totalizer corrections
         * @param {number} waterMeterId ID of a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeterTotalizerCorrections: async (waterMeterId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMeterId' is not null or undefined
            if (waterMeterId === null || waterMeterId === undefined) {
                throw new RequiredError('waterMeterId','Required parameter waterMeterId was null or undefined when calling getMeterTotalizerCorrections.');
            }
            const localVarPath = `/water/meters/{waterMeterId}/totalizerCorrections`
                .replace(`{${"waterMeterId"}}`, encodeURIComponent(String(waterMeterId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the totalizer readings for the water meter over a time period
         * @summary Get the totalizer readings for the water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {number} startTs Start epoch timestamp to consider
         * @param {number} endTs End epoch timestamp to consider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeterTotalizerReadings: async (waterMeterId: number, startTs: number, endTs: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMeterId' is not null or undefined
            if (waterMeterId === null || waterMeterId === undefined) {
                throw new RequiredError('waterMeterId','Required parameter waterMeterId was null or undefined when calling getMeterTotalizerReadings.');
            }
            // verify required parameter 'startTs' is not null or undefined
            if (startTs === null || startTs === undefined) {
                throw new RequiredError('startTs','Required parameter startTs was null or undefined when calling getMeterTotalizerReadings.');
            }
            // verify required parameter 'endTs' is not null or undefined
            if (endTs === null || endTs === undefined) {
                throw new RequiredError('endTs','Required parameter endTs was null or undefined when calling getMeterTotalizerReadings.');
            }
            const localVarPath = `/water/meters/{waterMeterId}/totalizerReadings`
                .replace(`{${"waterMeterId"}}`, encodeURIComponent(String(waterMeterId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (startTs !== undefined) {
                localVarQueryParameter['startTs'] = startTs;
            }

            if (endTs !== undefined) {
                localVarQueryParameter['endTs'] = endTs;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the latest totalizer corrections
         * @summary Get the latest totalizer corrections
         * @param {number} waterMonitorId ID of a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMonitorTotalizerCorrections: async (waterMonitorId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMonitorId' is not null or undefined
            if (waterMonitorId === null || waterMonitorId === undefined) {
                throw new RequiredError('waterMonitorId','Required parameter waterMonitorId was null or undefined when calling getMonitorTotalizerCorrections.');
            }
            const localVarPath = `/water/monitors/{waterMonitorId}/totalizerCorrections`
                .replace(`{${"waterMonitorId"}}`, encodeURIComponent(String(waterMonitorId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the totalizer readings for the water monitor over a time period
         * @summary Get the totalizer readings for the water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {number} startTs Start epoch timestamp to consider
         * @param {number} endTs End epoch timestamp to consider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMonitorTotalizerReadings: async (waterMonitorId: number, startTs: number, endTs: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMonitorId' is not null or undefined
            if (waterMonitorId === null || waterMonitorId === undefined) {
                throw new RequiredError('waterMonitorId','Required parameter waterMonitorId was null or undefined when calling getMonitorTotalizerReadings.');
            }
            // verify required parameter 'startTs' is not null or undefined
            if (startTs === null || startTs === undefined) {
                throw new RequiredError('startTs','Required parameter startTs was null or undefined when calling getMonitorTotalizerReadings.');
            }
            // verify required parameter 'endTs' is not null or undefined
            if (endTs === null || endTs === undefined) {
                throw new RequiredError('endTs','Required parameter endTs was null or undefined when calling getMonitorTotalizerReadings.');
            }
            const localVarPath = `/water/monitors/{waterMonitorId}/totalizerReadings`
                .replace(`{${"waterMonitorId"}}`, encodeURIComponent(String(waterMonitorId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (startTs !== undefined) {
                localVarQueryParameter['startTs'] = startTs;
            }

            if (endTs !== undefined) {
                localVarQueryParameter['endTs'] = endTs;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns data for a water meter by ID
         * @summary Get a water meter by ID
         * @param {number} waterMeterId ID of a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterMeterById: async (waterMeterId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMeterId' is not null or undefined
            if (waterMeterId === null || waterMeterId === undefined) {
                throw new RequiredError('waterMeterId','Required parameter waterMeterId was null or undefined when calling getWaterMeterById.');
            }
            const localVarPath = `/water/meters/{waterMeterId}`
                .replace(`{${"waterMeterId"}}`, encodeURIComponent(String(waterMeterId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve the current state metrics for the water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterMeterCurrentState: async (waterMeterId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMeterId' is not null or undefined
            if (waterMeterId === null || waterMeterId === undefined) {
                throw new RequiredError('waterMeterId','Required parameter waterMeterId was null or undefined when calling getWaterMeterCurrentState.');
            }
            const localVarPath = `/water/meters/{waterMeterId}/currentState`
                .replace(`{${"waterMeterId"}}`, encodeURIComponent(String(waterMeterId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns raw data for a water meter formatted for a graph display
         * @summary Get graph data for a water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {number} [nDays] return only this many days worth of data. Default &#x3D; 2 usually
         * @param {string} [offset] Go back X days
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterMeterGraphData: async (waterMeterId: number, nDays?: number, offset?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMeterId' is not null or undefined
            if (waterMeterId === null || waterMeterId === undefined) {
                throw new RequiredError('waterMeterId','Required parameter waterMeterId was null or undefined when calling getWaterMeterGraphData.');
            }
            const localVarPath = `/water/meters/{waterMeterId}/graphData`
                .replace(`{${"waterMeterId"}}`, encodeURIComponent(String(waterMeterId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (nDays !== undefined) {
                localVarQueryParameter['nDays'] = nDays;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns data for all water meters
         * @summary Get water meters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterMeters: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/water/meters`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns data for a water monitor by ID
         * @summary Get a water monitor by ID
         * @param {number} waterMonitorId ID of a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterMonitorById: async (waterMonitorId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMonitorId' is not null or undefined
            if (waterMonitorId === null || waterMonitorId === undefined) {
                throw new RequiredError('waterMonitorId','Required parameter waterMonitorId was null or undefined when calling getWaterMonitorById.');
            }
            const localVarPath = `/water/monitors/{waterMonitorId}`
                .replace(`{${"waterMonitorId"}}`, encodeURIComponent(String(waterMonitorId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve the current state metrics for the water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterMonitorCurrentState: async (waterMonitorId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMonitorId' is not null or undefined
            if (waterMonitorId === null || waterMonitorId === undefined) {
                throw new RequiredError('waterMonitorId','Required parameter waterMonitorId was null or undefined when calling getWaterMonitorCurrentState.');
            }
            const localVarPath = `/water/monitors/{waterMonitorId}/currentState`
                .replace(`{${"waterMonitorId"}}`, encodeURIComponent(String(waterMonitorId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns raw data for a water monitor formatted for a graph display
         * @summary Get graph data for a water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {number} [nDays] return only this many days worth of data. Default &#x3D; 2 usually
         * @param {string} [offset] Go back X days
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterMonitorGraphData: async (waterMonitorId: number, nDays?: number, offset?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMonitorId' is not null or undefined
            if (waterMonitorId === null || waterMonitorId === undefined) {
                throw new RequiredError('waterMonitorId','Required parameter waterMonitorId was null or undefined when calling getWaterMonitorGraphData.');
            }
            const localVarPath = `/water/monitors/{waterMonitorId}/graphData`
                .replace(`{${"waterMonitorId"}}`, encodeURIComponent(String(waterMonitorId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (nDays !== undefined) {
                localVarQueryParameter['nDays'] = nDays;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns data for all water monitors
         * @summary Get water monitors
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterMonitors: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/water/monitors`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns data for a water tank by ID
         * @summary Get a water tank by ID
         * @param {number} waterTankId ID of a water tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterTankById: async (waterTankId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterTankId' is not null or undefined
            if (waterTankId === null || waterTankId === undefined) {
                throw new RequiredError('waterTankId','Required parameter waterTankId was null or undefined when calling getWaterTankById.');
            }
            const localVarPath = `/water/tanks/{waterTankId}`
                .replace(`{${"waterTankId"}}`, encodeURIComponent(String(waterTankId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve the current state metrics for the water tank
         * @param {number} waterTankId ID of a water tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterTankCurrentState: async (waterTankId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterTankId' is not null or undefined
            if (waterTankId === null || waterTankId === undefined) {
                throw new RequiredError('waterTankId','Required parameter waterTankId was null or undefined when calling getWaterTankCurrentState.');
            }
            const localVarPath = `/water/tanks/{waterTankId}/currentState`
                .replace(`{${"waterTankId"}}`, encodeURIComponent(String(waterTankId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns raw data for a water tank formatted for a graph display
         * @summary Get graph data for a water tank
         * @param {number} waterTankId ID of a water tank
         * @param {number} [nDays] return only this many days worth of data. Default &#x3D; 2 usually
         * @param {string} [offset] Go back X days
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterTankGraphData: async (waterTankId: number, nDays?: number, offset?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterTankId' is not null or undefined
            if (waterTankId === null || waterTankId === undefined) {
                throw new RequiredError('waterTankId','Required parameter waterTankId was null or undefined when calling getWaterTankGraphData.');
            }
            const localVarPath = `/water/tanks/{waterTankId}/graphData`
                .replace(`{${"waterTankId"}}`, encodeURIComponent(String(waterTankId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (nDays !== undefined) {
                localVarQueryParameter['nDays'] = nDays;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns data for all water tanks
         * @summary Get water tanks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterTanks: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/water/tanks`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Allocate transceiver and sensor(s) to a water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {TransceiverSensorInData} transceiverSensorInData Assign transceiver and sensor to a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installWaterMeter: async (waterMeterId: number, transceiverSensorInData: TransceiverSensorInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMeterId' is not null or undefined
            if (waterMeterId === null || waterMeterId === undefined) {
                throw new RequiredError('waterMeterId','Required parameter waterMeterId was null or undefined when calling installWaterMeter.');
            }
            // verify required parameter 'transceiverSensorInData' is not null or undefined
            if (transceiverSensorInData === null || transceiverSensorInData === undefined) {
                throw new RequiredError('transceiverSensorInData','Required parameter transceiverSensorInData was null or undefined when calling installWaterMeter.');
            }
            const localVarPath = `/water/meters/{waterMeterId}/install`
                .replace(`{${"waterMeterId"}}`, encodeURIComponent(String(waterMeterId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof transceiverSensorInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(transceiverSensorInData !== undefined ? transceiverSensorInData : {}) : (transceiverSensorInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Allocate transceiver and sensor(s) to a water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {TransceiverSensorInData} transceiverSensorInData Assign transceiver and sensor to a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installWaterMonitor: async (waterMonitorId: number, transceiverSensorInData: TransceiverSensorInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMonitorId' is not null or undefined
            if (waterMonitorId === null || waterMonitorId === undefined) {
                throw new RequiredError('waterMonitorId','Required parameter waterMonitorId was null or undefined when calling installWaterMonitor.');
            }
            // verify required parameter 'transceiverSensorInData' is not null or undefined
            if (transceiverSensorInData === null || transceiverSensorInData === undefined) {
                throw new RequiredError('transceiverSensorInData','Required parameter transceiverSensorInData was null or undefined when calling installWaterMonitor.');
            }
            const localVarPath = `/water/monitors/{waterMonitorId}/install`
                .replace(`{${"waterMonitorId"}}`, encodeURIComponent(String(waterMonitorId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof transceiverSensorInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(transceiverSensorInData !== undefined ? transceiverSensorInData : {}) : (transceiverSensorInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Allocate transceiver and sensor(s) to a water tank
         * @param {number} waterTankId ID of a water tank
         * @param {TransceiverSensorInData} transceiverSensorInData Assign transceiver and sensor to a water tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installWaterTank: async (waterTankId: number, transceiverSensorInData: TransceiverSensorInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterTankId' is not null or undefined
            if (waterTankId === null || waterTankId === undefined) {
                throw new RequiredError('waterTankId','Required parameter waterTankId was null or undefined when calling installWaterTank.');
            }
            // verify required parameter 'transceiverSensorInData' is not null or undefined
            if (transceiverSensorInData === null || transceiverSensorInData === undefined) {
                throw new RequiredError('transceiverSensorInData','Required parameter transceiverSensorInData was null or undefined when calling installWaterTank.');
            }
            const localVarPath = `/water/tanks/{waterTankId}/install`
                .replace(`{${"waterTankId"}}`, encodeURIComponent(String(waterTankId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof transceiverSensorInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(transceiverSensorInData !== undefined ? transceiverSensorInData : {}) : (transceiverSensorInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Edit the properties of a water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {WaterEntityInputInData} waterEntityInputInData Edit the properties of a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        provisionWaterMeter: async (waterMeterId: number, waterEntityInputInData: WaterEntityInputInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMeterId' is not null or undefined
            if (waterMeterId === null || waterMeterId === undefined) {
                throw new RequiredError('waterMeterId','Required parameter waterMeterId was null or undefined when calling provisionWaterMeter.');
            }
            // verify required parameter 'waterEntityInputInData' is not null or undefined
            if (waterEntityInputInData === null || waterEntityInputInData === undefined) {
                throw new RequiredError('waterEntityInputInData','Required parameter waterEntityInputInData was null or undefined when calling provisionWaterMeter.');
            }
            const localVarPath = `/water/meters/{waterMeterId}/provision`
                .replace(`{${"waterMeterId"}}`, encodeURIComponent(String(waterMeterId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof waterEntityInputInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(waterEntityInputInData !== undefined ? waterEntityInputInData : {}) : (waterEntityInputInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Edit the properties of a water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {WaterEntityInputInData} waterEntityInputInData Edit the properties of a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        provisionWaterMonitor: async (waterMonitorId: number, waterEntityInputInData: WaterEntityInputInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMonitorId' is not null or undefined
            if (waterMonitorId === null || waterMonitorId === undefined) {
                throw new RequiredError('waterMonitorId','Required parameter waterMonitorId was null or undefined when calling provisionWaterMonitor.');
            }
            // verify required parameter 'waterEntityInputInData' is not null or undefined
            if (waterEntityInputInData === null || waterEntityInputInData === undefined) {
                throw new RequiredError('waterEntityInputInData','Required parameter waterEntityInputInData was null or undefined when calling provisionWaterMonitor.');
            }
            const localVarPath = `/water/monitors/{waterMonitorId}/provision`
                .replace(`{${"waterMonitorId"}}`, encodeURIComponent(String(waterMonitorId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof waterEntityInputInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(waterEntityInputInData !== undefined ? waterEntityInputInData : {}) : (waterEntityInputInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Edit the properties of a water tank
         * @param {number} waterTankId ID of a water tank
         * @param {WaterEntityInputInData} waterEntityInputInData Edit the properties of a water tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        provisionWaterTank: async (waterTankId: number, waterEntityInputInData: WaterEntityInputInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterTankId' is not null or undefined
            if (waterTankId === null || waterTankId === undefined) {
                throw new RequiredError('waterTankId','Required parameter waterTankId was null or undefined when calling provisionWaterTank.');
            }
            // verify required parameter 'waterEntityInputInData' is not null or undefined
            if (waterEntityInputInData === null || waterEntityInputInData === undefined) {
                throw new RequiredError('waterEntityInputInData','Required parameter waterEntityInputInData was null or undefined when calling provisionWaterTank.');
            }
            const localVarPath = `/water/tanks/{waterTankId}/provision`
                .replace(`{${"waterTankId"}}`, encodeURIComponent(String(waterTankId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof waterEntityInputInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(waterEntityInputInData !== undefined ? waterEntityInputInData : {}) : (waterEntityInputInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set a water monitor as the main farm monitor
         * @summary Set the main water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {WaterMonitorInfoInData} waterMonitorInfoInData Water monitor to set as the main farm monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setMainWaterMonitor: async (waterMonitorId: number, waterMonitorInfoInData: WaterMonitorInfoInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMonitorId' is not null or undefined
            if (waterMonitorId === null || waterMonitorId === undefined) {
                throw new RequiredError('waterMonitorId','Required parameter waterMonitorId was null or undefined when calling setMainWaterMonitor.');
            }
            // verify required parameter 'waterMonitorInfoInData' is not null or undefined
            if (waterMonitorInfoInData === null || waterMonitorInfoInData === undefined) {
                throw new RequiredError('waterMonitorInfoInData','Required parameter waterMonitorInfoInData was null or undefined when calling setMainWaterMonitor.');
            }
            const localVarPath = `/water/monitors/{waterMonitorId}/set-main`
                .replace(`{${"waterMonitorId"}}`, encodeURIComponent(String(waterMonitorId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof waterMonitorInfoInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(waterMonitorInfoInData !== undefined ? waterMonitorInfoInData : {}) : (waterMonitorInfoInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Confirm that a water meter flow rate sensor is configured correctly
         * @summary Sign-off a water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signoffWaterMeter: async (waterMeterId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMeterId' is not null or undefined
            if (waterMeterId === null || waterMeterId === undefined) {
                throw new RequiredError('waterMeterId','Required parameter waterMeterId was null or undefined when calling signoffWaterMeter.');
            }
            const localVarPath = `/water/meters/{waterMeterId}/sign-off`
                .replace(`{${"waterMeterId"}}`, encodeURIComponent(String(waterMeterId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Confirm that a water monitor flow rate sensor is configured correctly
         * @summary Sign-off a water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signoffWaterMonitor: async (waterMonitorId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMonitorId' is not null or undefined
            if (waterMonitorId === null || waterMonitorId === undefined) {
                throw new RequiredError('waterMonitorId','Required parameter waterMonitorId was null or undefined when calling signoffWaterMonitor.');
            }
            const localVarPath = `/water/monitors/{waterMonitorId}/sign-off`
                .replace(`{${"waterMonitorId"}}`, encodeURIComponent(String(waterMonitorId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Confirm that a water tank pressure sensor is configured correctly
         * @summary Sign-off a water tank
         * @param {number} waterTankId ID of a water tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signoffWaterTank: async (waterTankId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterTankId' is not null or undefined
            if (waterTankId === null || waterTankId === undefined) {
                throw new RequiredError('waterTankId','Required parameter waterTankId was null or undefined when calling signoffWaterTank.');
            }
            const localVarPath = `/water/tanks/{waterTankId}/sign-off`
                .replace(`{${"waterTankId"}}`, encodeURIComponent(String(waterTankId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {WaterMeterInfoInData} waterMeterInfoInData Water meter to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWaterMeter: async (waterMeterId: number, waterMeterInfoInData: WaterMeterInfoInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMeterId' is not null or undefined
            if (waterMeterId === null || waterMeterId === undefined) {
                throw new RequiredError('waterMeterId','Required parameter waterMeterId was null or undefined when calling updateWaterMeter.');
            }
            // verify required parameter 'waterMeterInfoInData' is not null or undefined
            if (waterMeterInfoInData === null || waterMeterInfoInData === undefined) {
                throw new RequiredError('waterMeterInfoInData','Required parameter waterMeterInfoInData was null or undefined when calling updateWaterMeter.');
            }
            const localVarPath = `/water/meters/{waterMeterId}`
                .replace(`{${"waterMeterId"}}`, encodeURIComponent(String(waterMeterId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof waterMeterInfoInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(waterMeterInfoInData !== undefined ? waterMeterInfoInData : {}) : (waterMeterInfoInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {WaterMonitorInfoInData} waterMonitorInfoInData Water monitor to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWaterMonitor: async (waterMonitorId: number, waterMonitorInfoInData: WaterMonitorInfoInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMonitorId' is not null or undefined
            if (waterMonitorId === null || waterMonitorId === undefined) {
                throw new RequiredError('waterMonitorId','Required parameter waterMonitorId was null or undefined when calling updateWaterMonitor.');
            }
            // verify required parameter 'waterMonitorInfoInData' is not null or undefined
            if (waterMonitorInfoInData === null || waterMonitorInfoInData === undefined) {
                throw new RequiredError('waterMonitorInfoInData','Required parameter waterMonitorInfoInData was null or undefined when calling updateWaterMonitor.');
            }
            const localVarPath = `/water/monitors/{waterMonitorId}`
                .replace(`{${"waterMonitorId"}}`, encodeURIComponent(String(waterMonitorId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof waterMonitorInfoInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(waterMonitorInfoInData !== undefined ? waterMonitorInfoInData : {}) : (waterMonitorInfoInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a water tank
         * @param {number} waterTankId ID of a water tank
         * @param {WaterTankInfoInData} waterTankInfoInData Water tank to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWaterTank: async (waterTankId: number, waterTankInfoInData: WaterTankInfoInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterTankId' is not null or undefined
            if (waterTankId === null || waterTankId === undefined) {
                throw new RequiredError('waterTankId','Required parameter waterTankId was null or undefined when calling updateWaterTank.');
            }
            // verify required parameter 'waterTankInfoInData' is not null or undefined
            if (waterTankInfoInData === null || waterTankInfoInData === undefined) {
                throw new RequiredError('waterTankInfoInData','Required parameter waterTankInfoInData was null or undefined when calling updateWaterTank.');
            }
            const localVarPath = `/water/tanks/{waterTankId}`
                .replace(`{${"waterTankId"}}`, encodeURIComponent(String(waterTankId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof waterTankInfoInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(waterTankInfoInData !== undefined ? waterTankInfoInData : {}) : (waterTankInfoInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WaterApi - functional programming interface
 * @export
 */
export const WaterApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Add a water meter to a water product
         * @summary Add a water meter
         * @param {WaterMeterInfoInData} waterMeterInfoInData Water meter to be added to a water product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addWaterMeter(waterMeterInfoInData: WaterMeterInfoInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await WaterApiAxiosParamCreator(configuration).addWaterMeter(waterMeterInfoInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Add a water monitor to a water product
         * @summary Add a water monitor
         * @param {WaterMonitorInfoInData} waterMonitorInfoInData Water monitor to be added to a water product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addWaterMonitor(waterMonitorInfoInData: WaterMonitorInfoInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await WaterApiAxiosParamCreator(configuration).addWaterMonitor(waterMonitorInfoInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Add a water tank to a water product
         * @summary Add a water tank
         * @param {WaterTankInfoInData} waterTankInfoInData Water tank to be added to a water product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addWaterTank(waterTankInfoInData: WaterTankInfoInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await WaterApiAxiosParamCreator(configuration).addWaterTank(waterTankInfoInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Applies a totalizer correction to the water meter
         * @summary Apply totalizer correction
         * @param {number} waterMeterId ID of a water meter
         * @param {WaterTotalizerCorrection} waterTotalizerCorrection 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applyMeterTotalizerCorrection(waterMeterId: number, waterTotalizerCorrection: WaterTotalizerCorrection, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await WaterApiAxiosParamCreator(configuration).applyMeterTotalizerCorrection(waterMeterId, waterTotalizerCorrection, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Applies a totalizer correction to the water monitor
         * @summary Apply totalizer correction
         * @param {number} waterMonitorId ID of a water monitor
         * @param {WaterTotalizerCorrection} waterTotalizerCorrection 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applyMonitorTotalizerCorrection(waterMonitorId: number, waterTotalizerCorrection: WaterTotalizerCorrection, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await WaterApiAxiosParamCreator(configuration).applyMonitorTotalizerCorrection(waterMonitorId, waterTotalizerCorrection, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Assign a water meter flow rate sensor with a water meter
         * @summary Assign a water meter sensor
         * @param {number} waterMeterId ID of a water meter
         * @param {WaterMeterSensorsAssignInData} waterMeterSensorsAssignInData Water meter sensor to assign to a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignWaterMeterSensors(waterMeterId: number, waterMeterSensorsAssignInData: WaterMeterSensorsAssignInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterMeterInfoInData>> {
            const localVarAxiosArgs = await WaterApiAxiosParamCreator(configuration).assignWaterMeterSensors(waterMeterId, waterMeterSensorsAssignInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Assign a water monitor flow rate sensor with a water monitor
         * @summary Assign a water monitor sensor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {WaterMonitorSensorsAssignInData} waterMonitorSensorsAssignInData Water monitor sensor to assign to a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignWaterMonitorSensors(waterMonitorId: number, waterMonitorSensorsAssignInData: WaterMonitorSensorsAssignInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterMonitorInfoInData>> {
            const localVarAxiosArgs = await WaterApiAxiosParamCreator(configuration).assignWaterMonitorSensors(waterMonitorId, waterMonitorSensorsAssignInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Assign a water tank pressure sensor with a water tank
         * @summary Assign a water tank sensor
         * @param {number} waterTankId ID of a water tank
         * @param {WaterTankSensorsAssignInData} waterTankSensorsAssignInData Water tank sensor to assign to a water tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignWaterTankSensors(waterTankId: number, waterTankSensorsAssignInData: WaterTankSensorsAssignInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterTankInfoInData>> {
            const localVarAxiosArgs = await WaterApiAxiosParamCreator(configuration).assignWaterTankSensors(waterTankId, waterTankSensorsAssignInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Cancel a pending water meter install
         * @summary Cancel a water meter install
         * @param {number} waterMeterId ID of a water meter
         * @param {CancelEntity} [cancelEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelWaterMeter(waterMeterId: number, cancelEntity?: CancelEntity, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await WaterApiAxiosParamCreator(configuration).cancelWaterMeter(waterMeterId, cancelEntity, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Cancel a pending water tank install
         * @summary Cancel a water tank install
         * @param {number} waterTankId ID of a water tank
         * @param {CancelEntity} [cancelEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelWaterTank(waterTankId: number, cancelEntity?: CancelEntity, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await WaterApiAxiosParamCreator(configuration).cancelWaterTank(waterTankId, cancelEntity, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Confirm a draft water meter
         * @summary Confirm a draft water meter, move to pending status
         * @param {number} waterMeterId ID of a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmDraftWaterMeter(waterMeterId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterMeter>> {
            const localVarAxiosArgs = await WaterApiAxiosParamCreator(configuration).confirmDraftWaterMeter(waterMeterId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Confirm a draft water monitor
         * @summary Confirm a draft water monitor, move to pending status
         * @param {number} waterMonitorId ID of a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmDraftWaterMonitor(waterMonitorId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterMonitor>> {
            const localVarAxiosArgs = await WaterApiAxiosParamCreator(configuration).confirmDraftWaterMonitor(waterMonitorId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Confirm a draft water tank
         * @summary Confirm a draft water tank, move to pending status
         * @param {number} waterTankId ID of a water tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmDraftWaterTank(waterTankId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterTank>> {
            const localVarAxiosArgs = await WaterApiAxiosParamCreator(configuration).confirmDraftWaterTank(waterTankId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Deactivate an existing water meter
         * @summary Deactivate a water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {DeactivateEntity} [deactivateEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deactivateWaterMeter(waterMeterId: number, deactivateEntity?: DeactivateEntity, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await WaterApiAxiosParamCreator(configuration).deactivateWaterMeter(waterMeterId, deactivateEntity, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Deactivate an existing water monitor
         * @summary Deactivate a water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {DeactivateEntity} [deactivateEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deactivateWaterMonitor(waterMonitorId: number, deactivateEntity?: DeactivateEntity, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await WaterApiAxiosParamCreator(configuration).deactivateWaterMonitor(waterMonitorId, deactivateEntity, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Deactivate an existing water tank
         * @summary Deactivate a water tank
         * @param {number} waterTankId ID of a water tank
         * @param {DeactivateEntity} [deactivateEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deactivateWaterTank(waterTankId: number, deactivateEntity?: DeactivateEntity, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await WaterApiAxiosParamCreator(configuration).deactivateWaterTank(waterTankId, deactivateEntity, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Delete a water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWaterMeter(waterMeterId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await WaterApiAxiosParamCreator(configuration).deleteWaterMeter(waterMeterId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Delete a water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWaterMonitor(waterMonitorId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await WaterApiAxiosParamCreator(configuration).deleteWaterMonitor(waterMonitorId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Delete a water tank
         * @param {number} waterTankId ID of a water tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWaterTank(waterTankId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await WaterApiAxiosParamCreator(configuration).deleteWaterTank(waterTankId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Retrieves the latest totalizer corrections
         * @summary Get the latest totalizer corrections
         * @param {number} waterMeterId ID of a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeterTotalizerCorrections(waterMeterId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WaterTotalizerCorrectionDynamoItem>>> {
            const localVarAxiosArgs = await WaterApiAxiosParamCreator(configuration).getMeterTotalizerCorrections(waterMeterId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Retrieve the totalizer readings for the water meter over a time period
         * @summary Get the totalizer readings for the water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {number} startTs Start epoch timestamp to consider
         * @param {number} endTs End epoch timestamp to consider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeterTotalizerReadings(waterMeterId: number, startTs: number, endTs: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WaterTotalizerReadingDynamoItem>>> {
            const localVarAxiosArgs = await WaterApiAxiosParamCreator(configuration).getMeterTotalizerReadings(waterMeterId, startTs, endTs, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Retrieves the latest totalizer corrections
         * @summary Get the latest totalizer corrections
         * @param {number} waterMonitorId ID of a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMonitorTotalizerCorrections(waterMonitorId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WaterTotalizerCorrectionDynamoItem>>> {
            const localVarAxiosArgs = await WaterApiAxiosParamCreator(configuration).getMonitorTotalizerCorrections(waterMonitorId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Retrieve the totalizer readings for the water monitor over a time period
         * @summary Get the totalizer readings for the water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {number} startTs Start epoch timestamp to consider
         * @param {number} endTs End epoch timestamp to consider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMonitorTotalizerReadings(waterMonitorId: number, startTs: number, endTs: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WaterTotalizerReadingDynamoItem>>> {
            const localVarAxiosArgs = await WaterApiAxiosParamCreator(configuration).getMonitorTotalizerReadings(waterMonitorId, startTs, endTs, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns data for a water meter by ID
         * @summary Get a water meter by ID
         * @param {number} waterMeterId ID of a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWaterMeterById(waterMeterId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterMeterInfo>> {
            const localVarAxiosArgs = await WaterApiAxiosParamCreator(configuration).getWaterMeterById(waterMeterId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Retrieve the current state metrics for the water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWaterMeterCurrentState(waterMeterId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2008>> {
            const localVarAxiosArgs = await WaterApiAxiosParamCreator(configuration).getWaterMeterCurrentState(waterMeterId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns raw data for a water meter formatted for a graph display
         * @summary Get graph data for a water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {number} [nDays] return only this many days worth of data. Default &#x3D; 2 usually
         * @param {string} [offset] Go back X days
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWaterMeterGraphData(waterMeterId: number, nDays?: number, offset?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterMeterGraphDataInData>> {
            const localVarAxiosArgs = await WaterApiAxiosParamCreator(configuration).getWaterMeterGraphData(waterMeterId, nDays, offset, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns data for all water meters
         * @summary Get water meters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWaterMeters(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterMeterInfosInData>> {
            const localVarAxiosArgs = await WaterApiAxiosParamCreator(configuration).getWaterMeters(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns data for a water monitor by ID
         * @summary Get a water monitor by ID
         * @param {number} waterMonitorId ID of a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWaterMonitorById(waterMonitorId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterMonitorInfo>> {
            const localVarAxiosArgs = await WaterApiAxiosParamCreator(configuration).getWaterMonitorById(waterMonitorId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Retrieve the current state metrics for the water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWaterMonitorCurrentState(waterMonitorId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2008>> {
            const localVarAxiosArgs = await WaterApiAxiosParamCreator(configuration).getWaterMonitorCurrentState(waterMonitorId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns raw data for a water monitor formatted for a graph display
         * @summary Get graph data for a water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {number} [nDays] return only this many days worth of data. Default &#x3D; 2 usually
         * @param {string} [offset] Go back X days
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWaterMonitorGraphData(waterMonitorId: number, nDays?: number, offset?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterMonitorGraphDataInData>> {
            const localVarAxiosArgs = await WaterApiAxiosParamCreator(configuration).getWaterMonitorGraphData(waterMonitorId, nDays, offset, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns data for all water monitors
         * @summary Get water monitors
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWaterMonitors(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterMonitorInfosInData>> {
            const localVarAxiosArgs = await WaterApiAxiosParamCreator(configuration).getWaterMonitors(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns data for a water tank by ID
         * @summary Get a water tank by ID
         * @param {number} waterTankId ID of a water tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWaterTankById(waterTankId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterTankInfo>> {
            const localVarAxiosArgs = await WaterApiAxiosParamCreator(configuration).getWaterTankById(waterTankId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Retrieve the current state metrics for the water tank
         * @param {number} waterTankId ID of a water tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWaterTankCurrentState(waterTankId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2008>> {
            const localVarAxiosArgs = await WaterApiAxiosParamCreator(configuration).getWaterTankCurrentState(waterTankId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns raw data for a water tank formatted for a graph display
         * @summary Get graph data for a water tank
         * @param {number} waterTankId ID of a water tank
         * @param {number} [nDays] return only this many days worth of data. Default &#x3D; 2 usually
         * @param {string} [offset] Go back X days
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWaterTankGraphData(waterTankId: number, nDays?: number, offset?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterTankGraphDataInData>> {
            const localVarAxiosArgs = await WaterApiAxiosParamCreator(configuration).getWaterTankGraphData(waterTankId, nDays, offset, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns data for all water tanks
         * @summary Get water tanks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWaterTanks(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterTankInfosInData>> {
            const localVarAxiosArgs = await WaterApiAxiosParamCreator(configuration).getWaterTanks(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Allocate transceiver and sensor(s) to a water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {TransceiverSensorInData} transceiverSensorInData Assign transceiver and sensor to a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async installWaterMeter(waterMeterId: number, transceiverSensorInData: TransceiverSensorInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterMeterInfoInData>> {
            const localVarAxiosArgs = await WaterApiAxiosParamCreator(configuration).installWaterMeter(waterMeterId, transceiverSensorInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Allocate transceiver and sensor(s) to a water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {TransceiverSensorInData} transceiverSensorInData Assign transceiver and sensor to a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async installWaterMonitor(waterMonitorId: number, transceiverSensorInData: TransceiverSensorInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterMonitorInfoInData>> {
            const localVarAxiosArgs = await WaterApiAxiosParamCreator(configuration).installWaterMonitor(waterMonitorId, transceiverSensorInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Allocate transceiver and sensor(s) to a water tank
         * @param {number} waterTankId ID of a water tank
         * @param {TransceiverSensorInData} transceiverSensorInData Assign transceiver and sensor to a water tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async installWaterTank(waterTankId: number, transceiverSensorInData: TransceiverSensorInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterTankInfoInData>> {
            const localVarAxiosArgs = await WaterApiAxiosParamCreator(configuration).installWaterTank(waterTankId, transceiverSensorInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Edit the properties of a water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {WaterEntityInputInData} waterEntityInputInData Edit the properties of a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async provisionWaterMeter(waterMeterId: number, waterEntityInputInData: WaterEntityInputInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterMeterInfoInData>> {
            const localVarAxiosArgs = await WaterApiAxiosParamCreator(configuration).provisionWaterMeter(waterMeterId, waterEntityInputInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Edit the properties of a water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {WaterEntityInputInData} waterEntityInputInData Edit the properties of a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async provisionWaterMonitor(waterMonitorId: number, waterEntityInputInData: WaterEntityInputInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterMonitorInfoInData>> {
            const localVarAxiosArgs = await WaterApiAxiosParamCreator(configuration).provisionWaterMonitor(waterMonitorId, waterEntityInputInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Edit the properties of a water tank
         * @param {number} waterTankId ID of a water tank
         * @param {WaterEntityInputInData} waterEntityInputInData Edit the properties of a water tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async provisionWaterTank(waterTankId: number, waterEntityInputInData: WaterEntityInputInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterTankInfoInData>> {
            const localVarAxiosArgs = await WaterApiAxiosParamCreator(configuration).provisionWaterTank(waterTankId, waterEntityInputInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Set a water monitor as the main farm monitor
         * @summary Set the main water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {WaterMonitorInfoInData} waterMonitorInfoInData Water monitor to set as the main farm monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setMainWaterMonitor(waterMonitorId: number, waterMonitorInfoInData: WaterMonitorInfoInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await WaterApiAxiosParamCreator(configuration).setMainWaterMonitor(waterMonitorId, waterMonitorInfoInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Confirm that a water meter flow rate sensor is configured correctly
         * @summary Sign-off a water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signoffWaterMeter(waterMeterId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await WaterApiAxiosParamCreator(configuration).signoffWaterMeter(waterMeterId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Confirm that a water monitor flow rate sensor is configured correctly
         * @summary Sign-off a water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signoffWaterMonitor(waterMonitorId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await WaterApiAxiosParamCreator(configuration).signoffWaterMonitor(waterMonitorId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Confirm that a water tank pressure sensor is configured correctly
         * @summary Sign-off a water tank
         * @param {number} waterTankId ID of a water tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signoffWaterTank(waterTankId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await WaterApiAxiosParamCreator(configuration).signoffWaterTank(waterTankId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update a water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {WaterMeterInfoInData} waterMeterInfoInData Water meter to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWaterMeter(waterMeterId: number, waterMeterInfoInData: WaterMeterInfoInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await WaterApiAxiosParamCreator(configuration).updateWaterMeter(waterMeterId, waterMeterInfoInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update a water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {WaterMonitorInfoInData} waterMonitorInfoInData Water monitor to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWaterMonitor(waterMonitorId: number, waterMonitorInfoInData: WaterMonitorInfoInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await WaterApiAxiosParamCreator(configuration).updateWaterMonitor(waterMonitorId, waterMonitorInfoInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update a water tank
         * @param {number} waterTankId ID of a water tank
         * @param {WaterTankInfoInData} waterTankInfoInData Water tank to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWaterTank(waterTankId: number, waterTankInfoInData: WaterTankInfoInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await WaterApiAxiosParamCreator(configuration).updateWaterTank(waterTankId, waterTankInfoInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * WaterApi - factory interface
 * @export
 */
export const WaterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Add a water meter to a water product
         * @summary Add a water meter
         * @param {WaterMeterInfoInData} waterMeterInfoInData Water meter to be added to a water product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addWaterMeter(waterMeterInfoInData: WaterMeterInfoInData, options?: any): AxiosPromise<void> {
            return WaterApiFp(configuration).addWaterMeter(waterMeterInfoInData, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a water monitor to a water product
         * @summary Add a water monitor
         * @param {WaterMonitorInfoInData} waterMonitorInfoInData Water monitor to be added to a water product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addWaterMonitor(waterMonitorInfoInData: WaterMonitorInfoInData, options?: any): AxiosPromise<void> {
            return WaterApiFp(configuration).addWaterMonitor(waterMonitorInfoInData, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a water tank to a water product
         * @summary Add a water tank
         * @param {WaterTankInfoInData} waterTankInfoInData Water tank to be added to a water product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addWaterTank(waterTankInfoInData: WaterTankInfoInData, options?: any): AxiosPromise<void> {
            return WaterApiFp(configuration).addWaterTank(waterTankInfoInData, options).then((request) => request(axios, basePath));
        },
        /**
         * Applies a totalizer correction to the water meter
         * @summary Apply totalizer correction
         * @param {number} waterMeterId ID of a water meter
         * @param {WaterTotalizerCorrection} waterTotalizerCorrection 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyMeterTotalizerCorrection(waterMeterId: number, waterTotalizerCorrection: WaterTotalizerCorrection, options?: any): AxiosPromise<void> {
            return WaterApiFp(configuration).applyMeterTotalizerCorrection(waterMeterId, waterTotalizerCorrection, options).then((request) => request(axios, basePath));
        },
        /**
         * Applies a totalizer correction to the water monitor
         * @summary Apply totalizer correction
         * @param {number} waterMonitorId ID of a water monitor
         * @param {WaterTotalizerCorrection} waterTotalizerCorrection 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyMonitorTotalizerCorrection(waterMonitorId: number, waterTotalizerCorrection: WaterTotalizerCorrection, options?: any): AxiosPromise<void> {
            return WaterApiFp(configuration).applyMonitorTotalizerCorrection(waterMonitorId, waterTotalizerCorrection, options).then((request) => request(axios, basePath));
        },
        /**
         * Assign a water meter flow rate sensor with a water meter
         * @summary Assign a water meter sensor
         * @param {number} waterMeterId ID of a water meter
         * @param {WaterMeterSensorsAssignInData} waterMeterSensorsAssignInData Water meter sensor to assign to a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignWaterMeterSensors(waterMeterId: number, waterMeterSensorsAssignInData: WaterMeterSensorsAssignInData, options?: any): AxiosPromise<WaterMeterInfoInData> {
            return WaterApiFp(configuration).assignWaterMeterSensors(waterMeterId, waterMeterSensorsAssignInData, options).then((request) => request(axios, basePath));
        },
        /**
         * Assign a water monitor flow rate sensor with a water monitor
         * @summary Assign a water monitor sensor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {WaterMonitorSensorsAssignInData} waterMonitorSensorsAssignInData Water monitor sensor to assign to a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignWaterMonitorSensors(waterMonitorId: number, waterMonitorSensorsAssignInData: WaterMonitorSensorsAssignInData, options?: any): AxiosPromise<WaterMonitorInfoInData> {
            return WaterApiFp(configuration).assignWaterMonitorSensors(waterMonitorId, waterMonitorSensorsAssignInData, options).then((request) => request(axios, basePath));
        },
        /**
         * Assign a water tank pressure sensor with a water tank
         * @summary Assign a water tank sensor
         * @param {number} waterTankId ID of a water tank
         * @param {WaterTankSensorsAssignInData} waterTankSensorsAssignInData Water tank sensor to assign to a water tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignWaterTankSensors(waterTankId: number, waterTankSensorsAssignInData: WaterTankSensorsAssignInData, options?: any): AxiosPromise<WaterTankInfoInData> {
            return WaterApiFp(configuration).assignWaterTankSensors(waterTankId, waterTankSensorsAssignInData, options).then((request) => request(axios, basePath));
        },
        /**
         * Cancel a pending water meter install
         * @summary Cancel a water meter install
         * @param {number} waterMeterId ID of a water meter
         * @param {CancelEntity} [cancelEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelWaterMeter(waterMeterId: number, cancelEntity?: CancelEntity, options?: any): AxiosPromise<void> {
            return WaterApiFp(configuration).cancelWaterMeter(waterMeterId, cancelEntity, options).then((request) => request(axios, basePath));
        },
        /**
         * Cancel a pending water tank install
         * @summary Cancel a water tank install
         * @param {number} waterTankId ID of a water tank
         * @param {CancelEntity} [cancelEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelWaterTank(waterTankId: number, cancelEntity?: CancelEntity, options?: any): AxiosPromise<void> {
            return WaterApiFp(configuration).cancelWaterTank(waterTankId, cancelEntity, options).then((request) => request(axios, basePath));
        },
        /**
         * Confirm a draft water meter
         * @summary Confirm a draft water meter, move to pending status
         * @param {number} waterMeterId ID of a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmDraftWaterMeter(waterMeterId: number, options?: any): AxiosPromise<WaterMeter> {
            return WaterApiFp(configuration).confirmDraftWaterMeter(waterMeterId, options).then((request) => request(axios, basePath));
        },
        /**
         * Confirm a draft water monitor
         * @summary Confirm a draft water monitor, move to pending status
         * @param {number} waterMonitorId ID of a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmDraftWaterMonitor(waterMonitorId: number, options?: any): AxiosPromise<WaterMonitor> {
            return WaterApiFp(configuration).confirmDraftWaterMonitor(waterMonitorId, options).then((request) => request(axios, basePath));
        },
        /**
         * Confirm a draft water tank
         * @summary Confirm a draft water tank, move to pending status
         * @param {number} waterTankId ID of a water tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmDraftWaterTank(waterTankId: number, options?: any): AxiosPromise<WaterTank> {
            return WaterApiFp(configuration).confirmDraftWaterTank(waterTankId, options).then((request) => request(axios, basePath));
        },
        /**
         * Deactivate an existing water meter
         * @summary Deactivate a water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {DeactivateEntity} [deactivateEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateWaterMeter(waterMeterId: number, deactivateEntity?: DeactivateEntity, options?: any): AxiosPromise<void> {
            return WaterApiFp(configuration).deactivateWaterMeter(waterMeterId, deactivateEntity, options).then((request) => request(axios, basePath));
        },
        /**
         * Deactivate an existing water monitor
         * @summary Deactivate a water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {DeactivateEntity} [deactivateEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateWaterMonitor(waterMonitorId: number, deactivateEntity?: DeactivateEntity, options?: any): AxiosPromise<void> {
            return WaterApiFp(configuration).deactivateWaterMonitor(waterMonitorId, deactivateEntity, options).then((request) => request(axios, basePath));
        },
        /**
         * Deactivate an existing water tank
         * @summary Deactivate a water tank
         * @param {number} waterTankId ID of a water tank
         * @param {DeactivateEntity} [deactivateEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateWaterTank(waterTankId: number, deactivateEntity?: DeactivateEntity, options?: any): AxiosPromise<void> {
            return WaterApiFp(configuration).deactivateWaterTank(waterTankId, deactivateEntity, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWaterMeter(waterMeterId: number, options?: any): AxiosPromise<void> {
            return WaterApiFp(configuration).deleteWaterMeter(waterMeterId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWaterMonitor(waterMonitorId: number, options?: any): AxiosPromise<void> {
            return WaterApiFp(configuration).deleteWaterMonitor(waterMonitorId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a water tank
         * @param {number} waterTankId ID of a water tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWaterTank(waterTankId: number, options?: any): AxiosPromise<void> {
            return WaterApiFp(configuration).deleteWaterTank(waterTankId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the latest totalizer corrections
         * @summary Get the latest totalizer corrections
         * @param {number} waterMeterId ID of a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeterTotalizerCorrections(waterMeterId: number, options?: any): AxiosPromise<Array<WaterTotalizerCorrectionDynamoItem>> {
            return WaterApiFp(configuration).getMeterTotalizerCorrections(waterMeterId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the totalizer readings for the water meter over a time period
         * @summary Get the totalizer readings for the water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {number} startTs Start epoch timestamp to consider
         * @param {number} endTs End epoch timestamp to consider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeterTotalizerReadings(waterMeterId: number, startTs: number, endTs: number, options?: any): AxiosPromise<Array<WaterTotalizerReadingDynamoItem>> {
            return WaterApiFp(configuration).getMeterTotalizerReadings(waterMeterId, startTs, endTs, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the latest totalizer corrections
         * @summary Get the latest totalizer corrections
         * @param {number} waterMonitorId ID of a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMonitorTotalizerCorrections(waterMonitorId: number, options?: any): AxiosPromise<Array<WaterTotalizerCorrectionDynamoItem>> {
            return WaterApiFp(configuration).getMonitorTotalizerCorrections(waterMonitorId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the totalizer readings for the water monitor over a time period
         * @summary Get the totalizer readings for the water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {number} startTs Start epoch timestamp to consider
         * @param {number} endTs End epoch timestamp to consider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMonitorTotalizerReadings(waterMonitorId: number, startTs: number, endTs: number, options?: any): AxiosPromise<Array<WaterTotalizerReadingDynamoItem>> {
            return WaterApiFp(configuration).getMonitorTotalizerReadings(waterMonitorId, startTs, endTs, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns data for a water meter by ID
         * @summary Get a water meter by ID
         * @param {number} waterMeterId ID of a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterMeterById(waterMeterId: number, options?: any): AxiosPromise<WaterMeterInfo> {
            return WaterApiFp(configuration).getWaterMeterById(waterMeterId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve the current state metrics for the water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterMeterCurrentState(waterMeterId: number, options?: any): AxiosPromise<InlineResponse2008> {
            return WaterApiFp(configuration).getWaterMeterCurrentState(waterMeterId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns raw data for a water meter formatted for a graph display
         * @summary Get graph data for a water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {number} [nDays] return only this many days worth of data. Default &#x3D; 2 usually
         * @param {string} [offset] Go back X days
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterMeterGraphData(waterMeterId: number, nDays?: number, offset?: string, options?: any): AxiosPromise<WaterMeterGraphDataInData> {
            return WaterApiFp(configuration).getWaterMeterGraphData(waterMeterId, nDays, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns data for all water meters
         * @summary Get water meters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterMeters(options?: any): AxiosPromise<WaterMeterInfosInData> {
            return WaterApiFp(configuration).getWaterMeters(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns data for a water monitor by ID
         * @summary Get a water monitor by ID
         * @param {number} waterMonitorId ID of a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterMonitorById(waterMonitorId: number, options?: any): AxiosPromise<WaterMonitorInfo> {
            return WaterApiFp(configuration).getWaterMonitorById(waterMonitorId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve the current state metrics for the water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterMonitorCurrentState(waterMonitorId: number, options?: any): AxiosPromise<InlineResponse2008> {
            return WaterApiFp(configuration).getWaterMonitorCurrentState(waterMonitorId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns raw data for a water monitor formatted for a graph display
         * @summary Get graph data for a water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {number} [nDays] return only this many days worth of data. Default &#x3D; 2 usually
         * @param {string} [offset] Go back X days
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterMonitorGraphData(waterMonitorId: number, nDays?: number, offset?: string, options?: any): AxiosPromise<WaterMonitorGraphDataInData> {
            return WaterApiFp(configuration).getWaterMonitorGraphData(waterMonitorId, nDays, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns data for all water monitors
         * @summary Get water monitors
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterMonitors(options?: any): AxiosPromise<WaterMonitorInfosInData> {
            return WaterApiFp(configuration).getWaterMonitors(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns data for a water tank by ID
         * @summary Get a water tank by ID
         * @param {number} waterTankId ID of a water tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterTankById(waterTankId: number, options?: any): AxiosPromise<WaterTankInfo> {
            return WaterApiFp(configuration).getWaterTankById(waterTankId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve the current state metrics for the water tank
         * @param {number} waterTankId ID of a water tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterTankCurrentState(waterTankId: number, options?: any): AxiosPromise<InlineResponse2008> {
            return WaterApiFp(configuration).getWaterTankCurrentState(waterTankId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns raw data for a water tank formatted for a graph display
         * @summary Get graph data for a water tank
         * @param {number} waterTankId ID of a water tank
         * @param {number} [nDays] return only this many days worth of data. Default &#x3D; 2 usually
         * @param {string} [offset] Go back X days
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterTankGraphData(waterTankId: number, nDays?: number, offset?: string, options?: any): AxiosPromise<WaterTankGraphDataInData> {
            return WaterApiFp(configuration).getWaterTankGraphData(waterTankId, nDays, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns data for all water tanks
         * @summary Get water tanks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterTanks(options?: any): AxiosPromise<WaterTankInfosInData> {
            return WaterApiFp(configuration).getWaterTanks(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Allocate transceiver and sensor(s) to a water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {TransceiverSensorInData} transceiverSensorInData Assign transceiver and sensor to a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installWaterMeter(waterMeterId: number, transceiverSensorInData: TransceiverSensorInData, options?: any): AxiosPromise<WaterMeterInfoInData> {
            return WaterApiFp(configuration).installWaterMeter(waterMeterId, transceiverSensorInData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Allocate transceiver and sensor(s) to a water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {TransceiverSensorInData} transceiverSensorInData Assign transceiver and sensor to a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installWaterMonitor(waterMonitorId: number, transceiverSensorInData: TransceiverSensorInData, options?: any): AxiosPromise<WaterMonitorInfoInData> {
            return WaterApiFp(configuration).installWaterMonitor(waterMonitorId, transceiverSensorInData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Allocate transceiver and sensor(s) to a water tank
         * @param {number} waterTankId ID of a water tank
         * @param {TransceiverSensorInData} transceiverSensorInData Assign transceiver and sensor to a water tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installWaterTank(waterTankId: number, transceiverSensorInData: TransceiverSensorInData, options?: any): AxiosPromise<WaterTankInfoInData> {
            return WaterApiFp(configuration).installWaterTank(waterTankId, transceiverSensorInData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edit the properties of a water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {WaterEntityInputInData} waterEntityInputInData Edit the properties of a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        provisionWaterMeter(waterMeterId: number, waterEntityInputInData: WaterEntityInputInData, options?: any): AxiosPromise<WaterMeterInfoInData> {
            return WaterApiFp(configuration).provisionWaterMeter(waterMeterId, waterEntityInputInData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edit the properties of a water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {WaterEntityInputInData} waterEntityInputInData Edit the properties of a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        provisionWaterMonitor(waterMonitorId: number, waterEntityInputInData: WaterEntityInputInData, options?: any): AxiosPromise<WaterMonitorInfoInData> {
            return WaterApiFp(configuration).provisionWaterMonitor(waterMonitorId, waterEntityInputInData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edit the properties of a water tank
         * @param {number} waterTankId ID of a water tank
         * @param {WaterEntityInputInData} waterEntityInputInData Edit the properties of a water tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        provisionWaterTank(waterTankId: number, waterEntityInputInData: WaterEntityInputInData, options?: any): AxiosPromise<WaterTankInfoInData> {
            return WaterApiFp(configuration).provisionWaterTank(waterTankId, waterEntityInputInData, options).then((request) => request(axios, basePath));
        },
        /**
         * Set a water monitor as the main farm monitor
         * @summary Set the main water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {WaterMonitorInfoInData} waterMonitorInfoInData Water monitor to set as the main farm monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setMainWaterMonitor(waterMonitorId: number, waterMonitorInfoInData: WaterMonitorInfoInData, options?: any): AxiosPromise<void> {
            return WaterApiFp(configuration).setMainWaterMonitor(waterMonitorId, waterMonitorInfoInData, options).then((request) => request(axios, basePath));
        },
        /**
         * Confirm that a water meter flow rate sensor is configured correctly
         * @summary Sign-off a water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signoffWaterMeter(waterMeterId: number, options?: any): AxiosPromise<void> {
            return WaterApiFp(configuration).signoffWaterMeter(waterMeterId, options).then((request) => request(axios, basePath));
        },
        /**
         * Confirm that a water monitor flow rate sensor is configured correctly
         * @summary Sign-off a water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signoffWaterMonitor(waterMonitorId: number, options?: any): AxiosPromise<void> {
            return WaterApiFp(configuration).signoffWaterMonitor(waterMonitorId, options).then((request) => request(axios, basePath));
        },
        /**
         * Confirm that a water tank pressure sensor is configured correctly
         * @summary Sign-off a water tank
         * @param {number} waterTankId ID of a water tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signoffWaterTank(waterTankId: number, options?: any): AxiosPromise<void> {
            return WaterApiFp(configuration).signoffWaterTank(waterTankId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {WaterMeterInfoInData} waterMeterInfoInData Water meter to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWaterMeter(waterMeterId: number, waterMeterInfoInData: WaterMeterInfoInData, options?: any): AxiosPromise<void> {
            return WaterApiFp(configuration).updateWaterMeter(waterMeterId, waterMeterInfoInData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {WaterMonitorInfoInData} waterMonitorInfoInData Water monitor to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWaterMonitor(waterMonitorId: number, waterMonitorInfoInData: WaterMonitorInfoInData, options?: any): AxiosPromise<void> {
            return WaterApiFp(configuration).updateWaterMonitor(waterMonitorId, waterMonitorInfoInData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a water tank
         * @param {number} waterTankId ID of a water tank
         * @param {WaterTankInfoInData} waterTankInfoInData Water tank to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWaterTank(waterTankId: number, waterTankInfoInData: WaterTankInfoInData, options?: any): AxiosPromise<void> {
            return WaterApiFp(configuration).updateWaterTank(waterTankId, waterTankInfoInData, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WaterApi - object-oriented interface
 * @export
 * @class WaterApi
 * @extends {BaseAPI}
 */
export class WaterApi extends BaseAPI {
    /**
     * Add a water meter to a water product
     * @summary Add a water meter
     * @param {WaterMeterInfoInData} waterMeterInfoInData Water meter to be added to a water product
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterApi
     */
    public addWaterMeter(waterMeterInfoInData: WaterMeterInfoInData, options?: any) {
        return WaterApiFp(this.configuration).addWaterMeter(waterMeterInfoInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a water monitor to a water product
     * @summary Add a water monitor
     * @param {WaterMonitorInfoInData} waterMonitorInfoInData Water monitor to be added to a water product
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterApi
     */
    public addWaterMonitor(waterMonitorInfoInData: WaterMonitorInfoInData, options?: any) {
        return WaterApiFp(this.configuration).addWaterMonitor(waterMonitorInfoInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a water tank to a water product
     * @summary Add a water tank
     * @param {WaterTankInfoInData} waterTankInfoInData Water tank to be added to a water product
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterApi
     */
    public addWaterTank(waterTankInfoInData: WaterTankInfoInData, options?: any) {
        return WaterApiFp(this.configuration).addWaterTank(waterTankInfoInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Applies a totalizer correction to the water meter
     * @summary Apply totalizer correction
     * @param {number} waterMeterId ID of a water meter
     * @param {WaterTotalizerCorrection} waterTotalizerCorrection 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterApi
     */
    public applyMeterTotalizerCorrection(waterMeterId: number, waterTotalizerCorrection: WaterTotalizerCorrection, options?: any) {
        return WaterApiFp(this.configuration).applyMeterTotalizerCorrection(waterMeterId, waterTotalizerCorrection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Applies a totalizer correction to the water monitor
     * @summary Apply totalizer correction
     * @param {number} waterMonitorId ID of a water monitor
     * @param {WaterTotalizerCorrection} waterTotalizerCorrection 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterApi
     */
    public applyMonitorTotalizerCorrection(waterMonitorId: number, waterTotalizerCorrection: WaterTotalizerCorrection, options?: any) {
        return WaterApiFp(this.configuration).applyMonitorTotalizerCorrection(waterMonitorId, waterTotalizerCorrection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Assign a water meter flow rate sensor with a water meter
     * @summary Assign a water meter sensor
     * @param {number} waterMeterId ID of a water meter
     * @param {WaterMeterSensorsAssignInData} waterMeterSensorsAssignInData Water meter sensor to assign to a water meter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterApi
     */
    public assignWaterMeterSensors(waterMeterId: number, waterMeterSensorsAssignInData: WaterMeterSensorsAssignInData, options?: any) {
        return WaterApiFp(this.configuration).assignWaterMeterSensors(waterMeterId, waterMeterSensorsAssignInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Assign a water monitor flow rate sensor with a water monitor
     * @summary Assign a water monitor sensor
     * @param {number} waterMonitorId ID of a water monitor
     * @param {WaterMonitorSensorsAssignInData} waterMonitorSensorsAssignInData Water monitor sensor to assign to a water monitor
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterApi
     */
    public assignWaterMonitorSensors(waterMonitorId: number, waterMonitorSensorsAssignInData: WaterMonitorSensorsAssignInData, options?: any) {
        return WaterApiFp(this.configuration).assignWaterMonitorSensors(waterMonitorId, waterMonitorSensorsAssignInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Assign a water tank pressure sensor with a water tank
     * @summary Assign a water tank sensor
     * @param {number} waterTankId ID of a water tank
     * @param {WaterTankSensorsAssignInData} waterTankSensorsAssignInData Water tank sensor to assign to a water tank
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterApi
     */
    public assignWaterTankSensors(waterTankId: number, waterTankSensorsAssignInData: WaterTankSensorsAssignInData, options?: any) {
        return WaterApiFp(this.configuration).assignWaterTankSensors(waterTankId, waterTankSensorsAssignInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cancel a pending water meter install
     * @summary Cancel a water meter install
     * @param {number} waterMeterId ID of a water meter
     * @param {CancelEntity} [cancelEntity] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterApi
     */
    public cancelWaterMeter(waterMeterId: number, cancelEntity?: CancelEntity, options?: any) {
        return WaterApiFp(this.configuration).cancelWaterMeter(waterMeterId, cancelEntity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cancel a pending water tank install
     * @summary Cancel a water tank install
     * @param {number} waterTankId ID of a water tank
     * @param {CancelEntity} [cancelEntity] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterApi
     */
    public cancelWaterTank(waterTankId: number, cancelEntity?: CancelEntity, options?: any) {
        return WaterApiFp(this.configuration).cancelWaterTank(waterTankId, cancelEntity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Confirm a draft water meter
     * @summary Confirm a draft water meter, move to pending status
     * @param {number} waterMeterId ID of a water meter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterApi
     */
    public confirmDraftWaterMeter(waterMeterId: number, options?: any) {
        return WaterApiFp(this.configuration).confirmDraftWaterMeter(waterMeterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Confirm a draft water monitor
     * @summary Confirm a draft water monitor, move to pending status
     * @param {number} waterMonitorId ID of a water monitor
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterApi
     */
    public confirmDraftWaterMonitor(waterMonitorId: number, options?: any) {
        return WaterApiFp(this.configuration).confirmDraftWaterMonitor(waterMonitorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Confirm a draft water tank
     * @summary Confirm a draft water tank, move to pending status
     * @param {number} waterTankId ID of a water tank
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterApi
     */
    public confirmDraftWaterTank(waterTankId: number, options?: any) {
        return WaterApiFp(this.configuration).confirmDraftWaterTank(waterTankId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deactivate an existing water meter
     * @summary Deactivate a water meter
     * @param {number} waterMeterId ID of a water meter
     * @param {DeactivateEntity} [deactivateEntity] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterApi
     */
    public deactivateWaterMeter(waterMeterId: number, deactivateEntity?: DeactivateEntity, options?: any) {
        return WaterApiFp(this.configuration).deactivateWaterMeter(waterMeterId, deactivateEntity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deactivate an existing water monitor
     * @summary Deactivate a water monitor
     * @param {number} waterMonitorId ID of a water monitor
     * @param {DeactivateEntity} [deactivateEntity] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterApi
     */
    public deactivateWaterMonitor(waterMonitorId: number, deactivateEntity?: DeactivateEntity, options?: any) {
        return WaterApiFp(this.configuration).deactivateWaterMonitor(waterMonitorId, deactivateEntity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deactivate an existing water tank
     * @summary Deactivate a water tank
     * @param {number} waterTankId ID of a water tank
     * @param {DeactivateEntity} [deactivateEntity] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterApi
     */
    public deactivateWaterTank(waterTankId: number, deactivateEntity?: DeactivateEntity, options?: any) {
        return WaterApiFp(this.configuration).deactivateWaterTank(waterTankId, deactivateEntity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a water meter
     * @param {number} waterMeterId ID of a water meter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterApi
     */
    public deleteWaterMeter(waterMeterId: number, options?: any) {
        return WaterApiFp(this.configuration).deleteWaterMeter(waterMeterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a water monitor
     * @param {number} waterMonitorId ID of a water monitor
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterApi
     */
    public deleteWaterMonitor(waterMonitorId: number, options?: any) {
        return WaterApiFp(this.configuration).deleteWaterMonitor(waterMonitorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a water tank
     * @param {number} waterTankId ID of a water tank
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterApi
     */
    public deleteWaterTank(waterTankId: number, options?: any) {
        return WaterApiFp(this.configuration).deleteWaterTank(waterTankId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the latest totalizer corrections
     * @summary Get the latest totalizer corrections
     * @param {number} waterMeterId ID of a water meter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterApi
     */
    public getMeterTotalizerCorrections(waterMeterId: number, options?: any) {
        return WaterApiFp(this.configuration).getMeterTotalizerCorrections(waterMeterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the totalizer readings for the water meter over a time period
     * @summary Get the totalizer readings for the water meter
     * @param {number} waterMeterId ID of a water meter
     * @param {number} startTs Start epoch timestamp to consider
     * @param {number} endTs End epoch timestamp to consider
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterApi
     */
    public getMeterTotalizerReadings(waterMeterId: number, startTs: number, endTs: number, options?: any) {
        return WaterApiFp(this.configuration).getMeterTotalizerReadings(waterMeterId, startTs, endTs, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the latest totalizer corrections
     * @summary Get the latest totalizer corrections
     * @param {number} waterMonitorId ID of a water monitor
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterApi
     */
    public getMonitorTotalizerCorrections(waterMonitorId: number, options?: any) {
        return WaterApiFp(this.configuration).getMonitorTotalizerCorrections(waterMonitorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the totalizer readings for the water monitor over a time period
     * @summary Get the totalizer readings for the water monitor
     * @param {number} waterMonitorId ID of a water monitor
     * @param {number} startTs Start epoch timestamp to consider
     * @param {number} endTs End epoch timestamp to consider
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterApi
     */
    public getMonitorTotalizerReadings(waterMonitorId: number, startTs: number, endTs: number, options?: any) {
        return WaterApiFp(this.configuration).getMonitorTotalizerReadings(waterMonitorId, startTs, endTs, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns data for a water meter by ID
     * @summary Get a water meter by ID
     * @param {number} waterMeterId ID of a water meter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterApi
     */
    public getWaterMeterById(waterMeterId: number, options?: any) {
        return WaterApiFp(this.configuration).getWaterMeterById(waterMeterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve the current state metrics for the water meter
     * @param {number} waterMeterId ID of a water meter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterApi
     */
    public getWaterMeterCurrentState(waterMeterId: number, options?: any) {
        return WaterApiFp(this.configuration).getWaterMeterCurrentState(waterMeterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns raw data for a water meter formatted for a graph display
     * @summary Get graph data for a water meter
     * @param {number} waterMeterId ID of a water meter
     * @param {number} [nDays] return only this many days worth of data. Default &#x3D; 2 usually
     * @param {string} [offset] Go back X days
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterApi
     */
    public getWaterMeterGraphData(waterMeterId: number, nDays?: number, offset?: string, options?: any) {
        return WaterApiFp(this.configuration).getWaterMeterGraphData(waterMeterId, nDays, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns data for all water meters
     * @summary Get water meters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterApi
     */
    public getWaterMeters(options?: any) {
        return WaterApiFp(this.configuration).getWaterMeters(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns data for a water monitor by ID
     * @summary Get a water monitor by ID
     * @param {number} waterMonitorId ID of a water monitor
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterApi
     */
    public getWaterMonitorById(waterMonitorId: number, options?: any) {
        return WaterApiFp(this.configuration).getWaterMonitorById(waterMonitorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve the current state metrics for the water monitor
     * @param {number} waterMonitorId ID of a water monitor
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterApi
     */
    public getWaterMonitorCurrentState(waterMonitorId: number, options?: any) {
        return WaterApiFp(this.configuration).getWaterMonitorCurrentState(waterMonitorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns raw data for a water monitor formatted for a graph display
     * @summary Get graph data for a water monitor
     * @param {number} waterMonitorId ID of a water monitor
     * @param {number} [nDays] return only this many days worth of data. Default &#x3D; 2 usually
     * @param {string} [offset] Go back X days
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterApi
     */
    public getWaterMonitorGraphData(waterMonitorId: number, nDays?: number, offset?: string, options?: any) {
        return WaterApiFp(this.configuration).getWaterMonitorGraphData(waterMonitorId, nDays, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns data for all water monitors
     * @summary Get water monitors
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterApi
     */
    public getWaterMonitors(options?: any) {
        return WaterApiFp(this.configuration).getWaterMonitors(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns data for a water tank by ID
     * @summary Get a water tank by ID
     * @param {number} waterTankId ID of a water tank
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterApi
     */
    public getWaterTankById(waterTankId: number, options?: any) {
        return WaterApiFp(this.configuration).getWaterTankById(waterTankId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve the current state metrics for the water tank
     * @param {number} waterTankId ID of a water tank
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterApi
     */
    public getWaterTankCurrentState(waterTankId: number, options?: any) {
        return WaterApiFp(this.configuration).getWaterTankCurrentState(waterTankId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns raw data for a water tank formatted for a graph display
     * @summary Get graph data for a water tank
     * @param {number} waterTankId ID of a water tank
     * @param {number} [nDays] return only this many days worth of data. Default &#x3D; 2 usually
     * @param {string} [offset] Go back X days
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterApi
     */
    public getWaterTankGraphData(waterTankId: number, nDays?: number, offset?: string, options?: any) {
        return WaterApiFp(this.configuration).getWaterTankGraphData(waterTankId, nDays, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns data for all water tanks
     * @summary Get water tanks
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterApi
     */
    public getWaterTanks(options?: any) {
        return WaterApiFp(this.configuration).getWaterTanks(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Allocate transceiver and sensor(s) to a water meter
     * @param {number} waterMeterId ID of a water meter
     * @param {TransceiverSensorInData} transceiverSensorInData Assign transceiver and sensor to a water meter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterApi
     */
    public installWaterMeter(waterMeterId: number, transceiverSensorInData: TransceiverSensorInData, options?: any) {
        return WaterApiFp(this.configuration).installWaterMeter(waterMeterId, transceiverSensorInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Allocate transceiver and sensor(s) to a water monitor
     * @param {number} waterMonitorId ID of a water monitor
     * @param {TransceiverSensorInData} transceiverSensorInData Assign transceiver and sensor to a water monitor
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterApi
     */
    public installWaterMonitor(waterMonitorId: number, transceiverSensorInData: TransceiverSensorInData, options?: any) {
        return WaterApiFp(this.configuration).installWaterMonitor(waterMonitorId, transceiverSensorInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Allocate transceiver and sensor(s) to a water tank
     * @param {number} waterTankId ID of a water tank
     * @param {TransceiverSensorInData} transceiverSensorInData Assign transceiver and sensor to a water tank
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterApi
     */
    public installWaterTank(waterTankId: number, transceiverSensorInData: TransceiverSensorInData, options?: any) {
        return WaterApiFp(this.configuration).installWaterTank(waterTankId, transceiverSensorInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edit the properties of a water meter
     * @param {number} waterMeterId ID of a water meter
     * @param {WaterEntityInputInData} waterEntityInputInData Edit the properties of a water meter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterApi
     */
    public provisionWaterMeter(waterMeterId: number, waterEntityInputInData: WaterEntityInputInData, options?: any) {
        return WaterApiFp(this.configuration).provisionWaterMeter(waterMeterId, waterEntityInputInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edit the properties of a water monitor
     * @param {number} waterMonitorId ID of a water monitor
     * @param {WaterEntityInputInData} waterEntityInputInData Edit the properties of a water monitor
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterApi
     */
    public provisionWaterMonitor(waterMonitorId: number, waterEntityInputInData: WaterEntityInputInData, options?: any) {
        return WaterApiFp(this.configuration).provisionWaterMonitor(waterMonitorId, waterEntityInputInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edit the properties of a water tank
     * @param {number} waterTankId ID of a water tank
     * @param {WaterEntityInputInData} waterEntityInputInData Edit the properties of a water tank
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterApi
     */
    public provisionWaterTank(waterTankId: number, waterEntityInputInData: WaterEntityInputInData, options?: any) {
        return WaterApiFp(this.configuration).provisionWaterTank(waterTankId, waterEntityInputInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set a water monitor as the main farm monitor
     * @summary Set the main water monitor
     * @param {number} waterMonitorId ID of a water monitor
     * @param {WaterMonitorInfoInData} waterMonitorInfoInData Water monitor to set as the main farm monitor
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterApi
     */
    public setMainWaterMonitor(waterMonitorId: number, waterMonitorInfoInData: WaterMonitorInfoInData, options?: any) {
        return WaterApiFp(this.configuration).setMainWaterMonitor(waterMonitorId, waterMonitorInfoInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Confirm that a water meter flow rate sensor is configured correctly
     * @summary Sign-off a water meter
     * @param {number} waterMeterId ID of a water meter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterApi
     */
    public signoffWaterMeter(waterMeterId: number, options?: any) {
        return WaterApiFp(this.configuration).signoffWaterMeter(waterMeterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Confirm that a water monitor flow rate sensor is configured correctly
     * @summary Sign-off a water monitor
     * @param {number} waterMonitorId ID of a water monitor
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterApi
     */
    public signoffWaterMonitor(waterMonitorId: number, options?: any) {
        return WaterApiFp(this.configuration).signoffWaterMonitor(waterMonitorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Confirm that a water tank pressure sensor is configured correctly
     * @summary Sign-off a water tank
     * @param {number} waterTankId ID of a water tank
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterApi
     */
    public signoffWaterTank(waterTankId: number, options?: any) {
        return WaterApiFp(this.configuration).signoffWaterTank(waterTankId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a water meter
     * @param {number} waterMeterId ID of a water meter
     * @param {WaterMeterInfoInData} waterMeterInfoInData Water meter to be updated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterApi
     */
    public updateWaterMeter(waterMeterId: number, waterMeterInfoInData: WaterMeterInfoInData, options?: any) {
        return WaterApiFp(this.configuration).updateWaterMeter(waterMeterId, waterMeterInfoInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a water monitor
     * @param {number} waterMonitorId ID of a water monitor
     * @param {WaterMonitorInfoInData} waterMonitorInfoInData Water monitor to be updated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterApi
     */
    public updateWaterMonitor(waterMonitorId: number, waterMonitorInfoInData: WaterMonitorInfoInData, options?: any) {
        return WaterApiFp(this.configuration).updateWaterMonitor(waterMonitorId, waterMonitorInfoInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a water tank
     * @param {number} waterTankId ID of a water tank
     * @param {WaterTankInfoInData} waterTankInfoInData Water tank to be updated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterApi
     */
    public updateWaterTank(waterTankId: number, waterTankInfoInData: WaterTankInfoInData, options?: any) {
        return WaterApiFp(this.configuration).updateWaterTank(waterTankId, waterTankInfoInData, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * WaterExportsApi - axios parameter creator
 * @export
 */
export const WaterExportsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a water export
         * @param {WaterExport} [waterExport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWaterExport: async (waterExport?: WaterExport, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/water/exports`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof waterExport !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(waterExport !== undefined ? waterExport : {}) : (waterExport || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete selected water export
         * @param {number} waterExportId ID of a water export
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWaterExport: async (waterExportId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterExportId' is not null or undefined
            if (waterExportId === null || waterExportId === undefined) {
                throw new RequiredError('waterExportId','Required parameter waterExportId was null or undefined when calling deleteWaterExport.');
            }
            const localVarPath = `/water/exports/{waterExportId}`
                .replace(`{${"waterExportId"}}`, encodeURIComponent(String(waterExportId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a water export
         * @param {number} waterExportId ID of a water export
         * @param {WaterExport} [waterExport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWaterExport: async (waterExportId: number, waterExport?: WaterExport, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterExportId' is not null or undefined
            if (waterExportId === null || waterExportId === undefined) {
                throw new RequiredError('waterExportId','Required parameter waterExportId was null or undefined when calling updateWaterExport.');
            }
            const localVarPath = `/water/exports/{waterExportId}`
                .replace(`{${"waterExportId"}}`, encodeURIComponent(String(waterExportId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof waterExport !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(waterExport !== undefined ? waterExport : {}) : (waterExport || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a list of water exports
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        waterExportsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/water/exports`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the water meter info
         * @param {number} waterExportId ID of a water export
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        waterExportsWaterExportIdGet: async (waterExportId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterExportId' is not null or undefined
            if (waterExportId === null || waterExportId === undefined) {
                throw new RequiredError('waterExportId','Required parameter waterExportId was null or undefined when calling waterExportsWaterExportIdGet.');
            }
            const localVarPath = `/water/exports/{waterExportId}`
                .replace(`{${"waterExportId"}}`, encodeURIComponent(String(waterExportId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WaterExportsApi - functional programming interface
 * @export
 */
export const WaterExportsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a water export
         * @param {WaterExport} [waterExport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWaterExport(waterExport?: WaterExport, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterExport>> {
            const localVarAxiosArgs = await WaterExportsApiAxiosParamCreator(configuration).createWaterExport(waterExport, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Delete selected water export
         * @param {number} waterExportId ID of a water export
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWaterExport(waterExportId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await WaterExportsApiAxiosParamCreator(configuration).deleteWaterExport(waterExportId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update a water export
         * @param {number} waterExportId ID of a water export
         * @param {WaterExport} [waterExport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWaterExport(waterExportId: number, waterExport?: WaterExport, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterExport>> {
            const localVarAxiosArgs = await WaterExportsApiAxiosParamCreator(configuration).updateWaterExport(waterExportId, waterExport, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get a list of water exports
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async waterExportsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterExportInData>> {
            const localVarAxiosArgs = await WaterExportsApiAxiosParamCreator(configuration).waterExportsGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get the water meter info
         * @param {number} waterExportId ID of a water export
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async waterExportsWaterExportIdGet(waterExportId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterExportInData>> {
            const localVarAxiosArgs = await WaterExportsApiAxiosParamCreator(configuration).waterExportsWaterExportIdGet(waterExportId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * WaterExportsApi - factory interface
 * @export
 */
export const WaterExportsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Create a water export
         * @param {WaterExport} [waterExport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWaterExport(waterExport?: WaterExport, options?: any): AxiosPromise<WaterExport> {
            return WaterExportsApiFp(configuration).createWaterExport(waterExport, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete selected water export
         * @param {number} waterExportId ID of a water export
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWaterExport(waterExportId: number, options?: any): AxiosPromise<void> {
            return WaterExportsApiFp(configuration).deleteWaterExport(waterExportId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a water export
         * @param {number} waterExportId ID of a water export
         * @param {WaterExport} [waterExport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWaterExport(waterExportId: number, waterExport?: WaterExport, options?: any): AxiosPromise<WaterExport> {
            return WaterExportsApiFp(configuration).updateWaterExport(waterExportId, waterExport, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a list of water exports
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        waterExportsGet(options?: any): AxiosPromise<WaterExportInData> {
            return WaterExportsApiFp(configuration).waterExportsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the water meter info
         * @param {number} waterExportId ID of a water export
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        waterExportsWaterExportIdGet(waterExportId: number, options?: any): AxiosPromise<WaterExportInData> {
            return WaterExportsApiFp(configuration).waterExportsWaterExportIdGet(waterExportId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WaterExportsApi - object-oriented interface
 * @export
 * @class WaterExportsApi
 * @extends {BaseAPI}
 */
export class WaterExportsApi extends BaseAPI {
    /**
     * 
     * @summary Create a water export
     * @param {WaterExport} [waterExport] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterExportsApi
     */
    public createWaterExport(waterExport?: WaterExport, options?: any) {
        return WaterExportsApiFp(this.configuration).createWaterExport(waterExport, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete selected water export
     * @param {number} waterExportId ID of a water export
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterExportsApi
     */
    public deleteWaterExport(waterExportId: number, options?: any) {
        return WaterExportsApiFp(this.configuration).deleteWaterExport(waterExportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a water export
     * @param {number} waterExportId ID of a water export
     * @param {WaterExport} [waterExport] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterExportsApi
     */
    public updateWaterExport(waterExportId: number, waterExport?: WaterExport, options?: any) {
        return WaterExportsApiFp(this.configuration).updateWaterExport(waterExportId, waterExport, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a list of water exports
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterExportsApi
     */
    public waterExportsGet(options?: any) {
        return WaterExportsApiFp(this.configuration).waterExportsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the water meter info
     * @param {number} waterExportId ID of a water export
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterExportsApi
     */
    public waterExportsWaterExportIdGet(waterExportId: number, options?: any) {
        return WaterExportsApiFp(this.configuration).waterExportsWaterExportIdGet(waterExportId, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * WaterLinksApi - axios parameter creator
 * @export
 */
export const WaterLinksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Update water ins and outs links
         * @summary Update water ins and outs links
         * @param {WaterLinksInData} waterLinksInData Water ins and outs links
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWaterLinks: async (waterLinksInData: WaterLinksInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterLinksInData' is not null or undefined
            if (waterLinksInData === null || waterLinksInData === undefined) {
                throw new RequiredError('waterLinksInData','Required parameter waterLinksInData was null or undefined when calling updateWaterLinks.');
            }
            const localVarPath = `/water/links`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof waterLinksInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(waterLinksInData !== undefined ? waterLinksInData : {}) : (waterLinksInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WaterLinksApi - functional programming interface
 * @export
 */
export const WaterLinksApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Update water ins and outs links
         * @summary Update water ins and outs links
         * @param {WaterLinksInData} waterLinksInData Water ins and outs links
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWaterLinks(waterLinksInData: WaterLinksInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await WaterLinksApiAxiosParamCreator(configuration).updateWaterLinks(waterLinksInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * WaterLinksApi - factory interface
 * @export
 */
export const WaterLinksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Update water ins and outs links
         * @summary Update water ins and outs links
         * @param {WaterLinksInData} waterLinksInData Water ins and outs links
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWaterLinks(waterLinksInData: WaterLinksInData, options?: any): AxiosPromise<void> {
            return WaterLinksApiFp(configuration).updateWaterLinks(waterLinksInData, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WaterLinksApi - object-oriented interface
 * @export
 * @class WaterLinksApi
 * @extends {BaseAPI}
 */
export class WaterLinksApi extends BaseAPI {
    /**
     * Update water ins and outs links
     * @summary Update water ins and outs links
     * @param {WaterLinksInData} waterLinksInData Water ins and outs links
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterLinksApi
     */
    public updateWaterLinks(waterLinksInData: WaterLinksInData, options?: any) {
        return WaterLinksApiFp(this.configuration).updateWaterLinks(waterLinksInData, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * WaterMetersApi - axios parameter creator
 * @export
 */
export const WaterMetersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a water meter to a water product
         * @summary Add a water meter
         * @param {WaterMeterInfoInData} waterMeterInfoInData Water meter to be added to a water product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addWaterMeter: async (waterMeterInfoInData: WaterMeterInfoInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMeterInfoInData' is not null or undefined
            if (waterMeterInfoInData === null || waterMeterInfoInData === undefined) {
                throw new RequiredError('waterMeterInfoInData','Required parameter waterMeterInfoInData was null or undefined when calling addWaterMeter.');
            }
            const localVarPath = `/water/meters`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof waterMeterInfoInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(waterMeterInfoInData !== undefined ? waterMeterInfoInData : {}) : (waterMeterInfoInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Applies a totalizer correction to the water meter
         * @summary Apply totalizer correction
         * @param {number} waterMeterId ID of a water meter
         * @param {WaterTotalizerCorrection} waterTotalizerCorrection 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyMeterTotalizerCorrection: async (waterMeterId: number, waterTotalizerCorrection: WaterTotalizerCorrection, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMeterId' is not null or undefined
            if (waterMeterId === null || waterMeterId === undefined) {
                throw new RequiredError('waterMeterId','Required parameter waterMeterId was null or undefined when calling applyMeterTotalizerCorrection.');
            }
            // verify required parameter 'waterTotalizerCorrection' is not null or undefined
            if (waterTotalizerCorrection === null || waterTotalizerCorrection === undefined) {
                throw new RequiredError('waterTotalizerCorrection','Required parameter waterTotalizerCorrection was null or undefined when calling applyMeterTotalizerCorrection.');
            }
            const localVarPath = `/water/meters/{waterMeterId}/applyCorrection`
                .replace(`{${"waterMeterId"}}`, encodeURIComponent(String(waterMeterId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof waterTotalizerCorrection !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(waterTotalizerCorrection !== undefined ? waterTotalizerCorrection : {}) : (waterTotalizerCorrection || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Assign a water meter flow rate sensor with a water meter
         * @summary Assign a water meter sensor
         * @param {number} waterMeterId ID of a water meter
         * @param {WaterMeterSensorsAssignInData} waterMeterSensorsAssignInData Water meter sensor to assign to a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignWaterMeterSensors: async (waterMeterId: number, waterMeterSensorsAssignInData: WaterMeterSensorsAssignInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMeterId' is not null or undefined
            if (waterMeterId === null || waterMeterId === undefined) {
                throw new RequiredError('waterMeterId','Required parameter waterMeterId was null or undefined when calling assignWaterMeterSensors.');
            }
            // verify required parameter 'waterMeterSensorsAssignInData' is not null or undefined
            if (waterMeterSensorsAssignInData === null || waterMeterSensorsAssignInData === undefined) {
                throw new RequiredError('waterMeterSensorsAssignInData','Required parameter waterMeterSensorsAssignInData was null or undefined when calling assignWaterMeterSensors.');
            }
            const localVarPath = `/water/meters/{waterMeterId}/assign`
                .replace(`{${"waterMeterId"}}`, encodeURIComponent(String(waterMeterId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof waterMeterSensorsAssignInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(waterMeterSensorsAssignInData !== undefined ? waterMeterSensorsAssignInData : {}) : (waterMeterSensorsAssignInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cancel a pending water meter install
         * @summary Cancel a water meter install
         * @param {number} waterMeterId ID of a water meter
         * @param {CancelEntity} [cancelEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelWaterMeter: async (waterMeterId: number, cancelEntity?: CancelEntity, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMeterId' is not null or undefined
            if (waterMeterId === null || waterMeterId === undefined) {
                throw new RequiredError('waterMeterId','Required parameter waterMeterId was null or undefined when calling cancelWaterMeter.');
            }
            const localVarPath = `/water/meters/{waterMeterId}/cancel`
                .replace(`{${"waterMeterId"}}`, encodeURIComponent(String(waterMeterId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof cancelEntity !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(cancelEntity !== undefined ? cancelEntity : {}) : (cancelEntity || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Confirm a draft water meter
         * @summary Confirm a draft water meter, move to pending status
         * @param {number} waterMeterId ID of a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmDraftWaterMeter: async (waterMeterId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMeterId' is not null or undefined
            if (waterMeterId === null || waterMeterId === undefined) {
                throw new RequiredError('waterMeterId','Required parameter waterMeterId was null or undefined when calling confirmDraftWaterMeter.');
            }
            const localVarPath = `/water/meters/{waterMeterId}/confirmDraft`
                .replace(`{${"waterMeterId"}}`, encodeURIComponent(String(waterMeterId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deactivate an existing water meter
         * @summary Deactivate a water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {DeactivateEntity} [deactivateEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateWaterMeter: async (waterMeterId: number, deactivateEntity?: DeactivateEntity, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMeterId' is not null or undefined
            if (waterMeterId === null || waterMeterId === undefined) {
                throw new RequiredError('waterMeterId','Required parameter waterMeterId was null or undefined when calling deactivateWaterMeter.');
            }
            const localVarPath = `/water/meters/{waterMeterId}/deactivate`
                .replace(`{${"waterMeterId"}}`, encodeURIComponent(String(waterMeterId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof deactivateEntity !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(deactivateEntity !== undefined ? deactivateEntity : {}) : (deactivateEntity || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWaterMeter: async (waterMeterId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMeterId' is not null or undefined
            if (waterMeterId === null || waterMeterId === undefined) {
                throw new RequiredError('waterMeterId','Required parameter waterMeterId was null or undefined when calling deleteWaterMeter.');
            }
            const localVarPath = `/water/meters/{waterMeterId}`
                .replace(`{${"waterMeterId"}}`, encodeURIComponent(String(waterMeterId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the latest totalizer corrections
         * @summary Get the latest totalizer corrections
         * @param {number} waterMeterId ID of a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeterTotalizerCorrections: async (waterMeterId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMeterId' is not null or undefined
            if (waterMeterId === null || waterMeterId === undefined) {
                throw new RequiredError('waterMeterId','Required parameter waterMeterId was null or undefined when calling getMeterTotalizerCorrections.');
            }
            const localVarPath = `/water/meters/{waterMeterId}/totalizerCorrections`
                .replace(`{${"waterMeterId"}}`, encodeURIComponent(String(waterMeterId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the totalizer readings for the water meter over a time period
         * @summary Get the totalizer readings for the water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {number} startTs Start epoch timestamp to consider
         * @param {number} endTs End epoch timestamp to consider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeterTotalizerReadings: async (waterMeterId: number, startTs: number, endTs: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMeterId' is not null or undefined
            if (waterMeterId === null || waterMeterId === undefined) {
                throw new RequiredError('waterMeterId','Required parameter waterMeterId was null or undefined when calling getMeterTotalizerReadings.');
            }
            // verify required parameter 'startTs' is not null or undefined
            if (startTs === null || startTs === undefined) {
                throw new RequiredError('startTs','Required parameter startTs was null or undefined when calling getMeterTotalizerReadings.');
            }
            // verify required parameter 'endTs' is not null or undefined
            if (endTs === null || endTs === undefined) {
                throw new RequiredError('endTs','Required parameter endTs was null or undefined when calling getMeterTotalizerReadings.');
            }
            const localVarPath = `/water/meters/{waterMeterId}/totalizerReadings`
                .replace(`{${"waterMeterId"}}`, encodeURIComponent(String(waterMeterId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (startTs !== undefined) {
                localVarQueryParameter['startTs'] = startTs;
            }

            if (endTs !== undefined) {
                localVarQueryParameter['endTs'] = endTs;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns data for a water meter by ID
         * @summary Get a water meter by ID
         * @param {number} waterMeterId ID of a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterMeterById: async (waterMeterId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMeterId' is not null or undefined
            if (waterMeterId === null || waterMeterId === undefined) {
                throw new RequiredError('waterMeterId','Required parameter waterMeterId was null or undefined when calling getWaterMeterById.');
            }
            const localVarPath = `/water/meters/{waterMeterId}`
                .replace(`{${"waterMeterId"}}`, encodeURIComponent(String(waterMeterId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve the current state metrics for the water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterMeterCurrentState: async (waterMeterId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMeterId' is not null or undefined
            if (waterMeterId === null || waterMeterId === undefined) {
                throw new RequiredError('waterMeterId','Required parameter waterMeterId was null or undefined when calling getWaterMeterCurrentState.');
            }
            const localVarPath = `/water/meters/{waterMeterId}/currentState`
                .replace(`{${"waterMeterId"}}`, encodeURIComponent(String(waterMeterId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns raw data for a water meter formatted for a graph display
         * @summary Get graph data for a water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {number} [nDays] return only this many days worth of data. Default &#x3D; 2 usually
         * @param {string} [offset] Go back X days
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterMeterGraphData: async (waterMeterId: number, nDays?: number, offset?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMeterId' is not null or undefined
            if (waterMeterId === null || waterMeterId === undefined) {
                throw new RequiredError('waterMeterId','Required parameter waterMeterId was null or undefined when calling getWaterMeterGraphData.');
            }
            const localVarPath = `/water/meters/{waterMeterId}/graphData`
                .replace(`{${"waterMeterId"}}`, encodeURIComponent(String(waterMeterId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (nDays !== undefined) {
                localVarQueryParameter['nDays'] = nDays;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns data for all water meters
         * @summary Get water meters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterMeters: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/water/meters`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Allocate transceiver and sensor(s) to a water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {TransceiverSensorInData} transceiverSensorInData Assign transceiver and sensor to a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installWaterMeter: async (waterMeterId: number, transceiverSensorInData: TransceiverSensorInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMeterId' is not null or undefined
            if (waterMeterId === null || waterMeterId === undefined) {
                throw new RequiredError('waterMeterId','Required parameter waterMeterId was null or undefined when calling installWaterMeter.');
            }
            // verify required parameter 'transceiverSensorInData' is not null or undefined
            if (transceiverSensorInData === null || transceiverSensorInData === undefined) {
                throw new RequiredError('transceiverSensorInData','Required parameter transceiverSensorInData was null or undefined when calling installWaterMeter.');
            }
            const localVarPath = `/water/meters/{waterMeterId}/install`
                .replace(`{${"waterMeterId"}}`, encodeURIComponent(String(waterMeterId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof transceiverSensorInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(transceiverSensorInData !== undefined ? transceiverSensorInData : {}) : (transceiverSensorInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Edit the properties of a water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {WaterEntityInputInData} waterEntityInputInData Edit the properties of a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        provisionWaterMeter: async (waterMeterId: number, waterEntityInputInData: WaterEntityInputInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMeterId' is not null or undefined
            if (waterMeterId === null || waterMeterId === undefined) {
                throw new RequiredError('waterMeterId','Required parameter waterMeterId was null or undefined when calling provisionWaterMeter.');
            }
            // verify required parameter 'waterEntityInputInData' is not null or undefined
            if (waterEntityInputInData === null || waterEntityInputInData === undefined) {
                throw new RequiredError('waterEntityInputInData','Required parameter waterEntityInputInData was null or undefined when calling provisionWaterMeter.');
            }
            const localVarPath = `/water/meters/{waterMeterId}/provision`
                .replace(`{${"waterMeterId"}}`, encodeURIComponent(String(waterMeterId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof waterEntityInputInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(waterEntityInputInData !== undefined ? waterEntityInputInData : {}) : (waterEntityInputInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Confirm that a water meter flow rate sensor is configured correctly
         * @summary Sign-off a water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signoffWaterMeter: async (waterMeterId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMeterId' is not null or undefined
            if (waterMeterId === null || waterMeterId === undefined) {
                throw new RequiredError('waterMeterId','Required parameter waterMeterId was null or undefined when calling signoffWaterMeter.');
            }
            const localVarPath = `/water/meters/{waterMeterId}/sign-off`
                .replace(`{${"waterMeterId"}}`, encodeURIComponent(String(waterMeterId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {WaterMeterInfoInData} waterMeterInfoInData Water meter to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWaterMeter: async (waterMeterId: number, waterMeterInfoInData: WaterMeterInfoInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMeterId' is not null or undefined
            if (waterMeterId === null || waterMeterId === undefined) {
                throw new RequiredError('waterMeterId','Required parameter waterMeterId was null or undefined when calling updateWaterMeter.');
            }
            // verify required parameter 'waterMeterInfoInData' is not null or undefined
            if (waterMeterInfoInData === null || waterMeterInfoInData === undefined) {
                throw new RequiredError('waterMeterInfoInData','Required parameter waterMeterInfoInData was null or undefined when calling updateWaterMeter.');
            }
            const localVarPath = `/water/meters/{waterMeterId}`
                .replace(`{${"waterMeterId"}}`, encodeURIComponent(String(waterMeterId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof waterMeterInfoInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(waterMeterInfoInData !== undefined ? waterMeterInfoInData : {}) : (waterMeterInfoInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WaterMetersApi - functional programming interface
 * @export
 */
export const WaterMetersApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Add a water meter to a water product
         * @summary Add a water meter
         * @param {WaterMeterInfoInData} waterMeterInfoInData Water meter to be added to a water product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addWaterMeter(waterMeterInfoInData: WaterMeterInfoInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await WaterMetersApiAxiosParamCreator(configuration).addWaterMeter(waterMeterInfoInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Applies a totalizer correction to the water meter
         * @summary Apply totalizer correction
         * @param {number} waterMeterId ID of a water meter
         * @param {WaterTotalizerCorrection} waterTotalizerCorrection 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applyMeterTotalizerCorrection(waterMeterId: number, waterTotalizerCorrection: WaterTotalizerCorrection, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await WaterMetersApiAxiosParamCreator(configuration).applyMeterTotalizerCorrection(waterMeterId, waterTotalizerCorrection, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Assign a water meter flow rate sensor with a water meter
         * @summary Assign a water meter sensor
         * @param {number} waterMeterId ID of a water meter
         * @param {WaterMeterSensorsAssignInData} waterMeterSensorsAssignInData Water meter sensor to assign to a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignWaterMeterSensors(waterMeterId: number, waterMeterSensorsAssignInData: WaterMeterSensorsAssignInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterMeterInfoInData>> {
            const localVarAxiosArgs = await WaterMetersApiAxiosParamCreator(configuration).assignWaterMeterSensors(waterMeterId, waterMeterSensorsAssignInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Cancel a pending water meter install
         * @summary Cancel a water meter install
         * @param {number} waterMeterId ID of a water meter
         * @param {CancelEntity} [cancelEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelWaterMeter(waterMeterId: number, cancelEntity?: CancelEntity, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await WaterMetersApiAxiosParamCreator(configuration).cancelWaterMeter(waterMeterId, cancelEntity, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Confirm a draft water meter
         * @summary Confirm a draft water meter, move to pending status
         * @param {number} waterMeterId ID of a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmDraftWaterMeter(waterMeterId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterMeter>> {
            const localVarAxiosArgs = await WaterMetersApiAxiosParamCreator(configuration).confirmDraftWaterMeter(waterMeterId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Deactivate an existing water meter
         * @summary Deactivate a water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {DeactivateEntity} [deactivateEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deactivateWaterMeter(waterMeterId: number, deactivateEntity?: DeactivateEntity, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await WaterMetersApiAxiosParamCreator(configuration).deactivateWaterMeter(waterMeterId, deactivateEntity, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Delete a water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWaterMeter(waterMeterId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await WaterMetersApiAxiosParamCreator(configuration).deleteWaterMeter(waterMeterId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Retrieves the latest totalizer corrections
         * @summary Get the latest totalizer corrections
         * @param {number} waterMeterId ID of a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeterTotalizerCorrections(waterMeterId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WaterTotalizerCorrectionDynamoItem>>> {
            const localVarAxiosArgs = await WaterMetersApiAxiosParamCreator(configuration).getMeterTotalizerCorrections(waterMeterId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Retrieve the totalizer readings for the water meter over a time period
         * @summary Get the totalizer readings for the water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {number} startTs Start epoch timestamp to consider
         * @param {number} endTs End epoch timestamp to consider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeterTotalizerReadings(waterMeterId: number, startTs: number, endTs: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WaterTotalizerReadingDynamoItem>>> {
            const localVarAxiosArgs = await WaterMetersApiAxiosParamCreator(configuration).getMeterTotalizerReadings(waterMeterId, startTs, endTs, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns data for a water meter by ID
         * @summary Get a water meter by ID
         * @param {number} waterMeterId ID of a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWaterMeterById(waterMeterId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterMeterInfo>> {
            const localVarAxiosArgs = await WaterMetersApiAxiosParamCreator(configuration).getWaterMeterById(waterMeterId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Retrieve the current state metrics for the water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWaterMeterCurrentState(waterMeterId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2008>> {
            const localVarAxiosArgs = await WaterMetersApiAxiosParamCreator(configuration).getWaterMeterCurrentState(waterMeterId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns raw data for a water meter formatted for a graph display
         * @summary Get graph data for a water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {number} [nDays] return only this many days worth of data. Default &#x3D; 2 usually
         * @param {string} [offset] Go back X days
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWaterMeterGraphData(waterMeterId: number, nDays?: number, offset?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterMeterGraphDataInData>> {
            const localVarAxiosArgs = await WaterMetersApiAxiosParamCreator(configuration).getWaterMeterGraphData(waterMeterId, nDays, offset, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns data for all water meters
         * @summary Get water meters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWaterMeters(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterMeterInfosInData>> {
            const localVarAxiosArgs = await WaterMetersApiAxiosParamCreator(configuration).getWaterMeters(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Allocate transceiver and sensor(s) to a water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {TransceiverSensorInData} transceiverSensorInData Assign transceiver and sensor to a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async installWaterMeter(waterMeterId: number, transceiverSensorInData: TransceiverSensorInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterMeterInfoInData>> {
            const localVarAxiosArgs = await WaterMetersApiAxiosParamCreator(configuration).installWaterMeter(waterMeterId, transceiverSensorInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Edit the properties of a water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {WaterEntityInputInData} waterEntityInputInData Edit the properties of a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async provisionWaterMeter(waterMeterId: number, waterEntityInputInData: WaterEntityInputInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterMeterInfoInData>> {
            const localVarAxiosArgs = await WaterMetersApiAxiosParamCreator(configuration).provisionWaterMeter(waterMeterId, waterEntityInputInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Confirm that a water meter flow rate sensor is configured correctly
         * @summary Sign-off a water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signoffWaterMeter(waterMeterId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await WaterMetersApiAxiosParamCreator(configuration).signoffWaterMeter(waterMeterId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update a water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {WaterMeterInfoInData} waterMeterInfoInData Water meter to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWaterMeter(waterMeterId: number, waterMeterInfoInData: WaterMeterInfoInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await WaterMetersApiAxiosParamCreator(configuration).updateWaterMeter(waterMeterId, waterMeterInfoInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * WaterMetersApi - factory interface
 * @export
 */
export const WaterMetersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Add a water meter to a water product
         * @summary Add a water meter
         * @param {WaterMeterInfoInData} waterMeterInfoInData Water meter to be added to a water product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addWaterMeter(waterMeterInfoInData: WaterMeterInfoInData, options?: any): AxiosPromise<void> {
            return WaterMetersApiFp(configuration).addWaterMeter(waterMeterInfoInData, options).then((request) => request(axios, basePath));
        },
        /**
         * Applies a totalizer correction to the water meter
         * @summary Apply totalizer correction
         * @param {number} waterMeterId ID of a water meter
         * @param {WaterTotalizerCorrection} waterTotalizerCorrection 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyMeterTotalizerCorrection(waterMeterId: number, waterTotalizerCorrection: WaterTotalizerCorrection, options?: any): AxiosPromise<void> {
            return WaterMetersApiFp(configuration).applyMeterTotalizerCorrection(waterMeterId, waterTotalizerCorrection, options).then((request) => request(axios, basePath));
        },
        /**
         * Assign a water meter flow rate sensor with a water meter
         * @summary Assign a water meter sensor
         * @param {number} waterMeterId ID of a water meter
         * @param {WaterMeterSensorsAssignInData} waterMeterSensorsAssignInData Water meter sensor to assign to a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignWaterMeterSensors(waterMeterId: number, waterMeterSensorsAssignInData: WaterMeterSensorsAssignInData, options?: any): AxiosPromise<WaterMeterInfoInData> {
            return WaterMetersApiFp(configuration).assignWaterMeterSensors(waterMeterId, waterMeterSensorsAssignInData, options).then((request) => request(axios, basePath));
        },
        /**
         * Cancel a pending water meter install
         * @summary Cancel a water meter install
         * @param {number} waterMeterId ID of a water meter
         * @param {CancelEntity} [cancelEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelWaterMeter(waterMeterId: number, cancelEntity?: CancelEntity, options?: any): AxiosPromise<void> {
            return WaterMetersApiFp(configuration).cancelWaterMeter(waterMeterId, cancelEntity, options).then((request) => request(axios, basePath));
        },
        /**
         * Confirm a draft water meter
         * @summary Confirm a draft water meter, move to pending status
         * @param {number} waterMeterId ID of a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmDraftWaterMeter(waterMeterId: number, options?: any): AxiosPromise<WaterMeter> {
            return WaterMetersApiFp(configuration).confirmDraftWaterMeter(waterMeterId, options).then((request) => request(axios, basePath));
        },
        /**
         * Deactivate an existing water meter
         * @summary Deactivate a water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {DeactivateEntity} [deactivateEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateWaterMeter(waterMeterId: number, deactivateEntity?: DeactivateEntity, options?: any): AxiosPromise<void> {
            return WaterMetersApiFp(configuration).deactivateWaterMeter(waterMeterId, deactivateEntity, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWaterMeter(waterMeterId: number, options?: any): AxiosPromise<void> {
            return WaterMetersApiFp(configuration).deleteWaterMeter(waterMeterId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the latest totalizer corrections
         * @summary Get the latest totalizer corrections
         * @param {number} waterMeterId ID of a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeterTotalizerCorrections(waterMeterId: number, options?: any): AxiosPromise<Array<WaterTotalizerCorrectionDynamoItem>> {
            return WaterMetersApiFp(configuration).getMeterTotalizerCorrections(waterMeterId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the totalizer readings for the water meter over a time period
         * @summary Get the totalizer readings for the water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {number} startTs Start epoch timestamp to consider
         * @param {number} endTs End epoch timestamp to consider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeterTotalizerReadings(waterMeterId: number, startTs: number, endTs: number, options?: any): AxiosPromise<Array<WaterTotalizerReadingDynamoItem>> {
            return WaterMetersApiFp(configuration).getMeterTotalizerReadings(waterMeterId, startTs, endTs, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns data for a water meter by ID
         * @summary Get a water meter by ID
         * @param {number} waterMeterId ID of a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterMeterById(waterMeterId: number, options?: any): AxiosPromise<WaterMeterInfo> {
            return WaterMetersApiFp(configuration).getWaterMeterById(waterMeterId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve the current state metrics for the water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterMeterCurrentState(waterMeterId: number, options?: any): AxiosPromise<InlineResponse2008> {
            return WaterMetersApiFp(configuration).getWaterMeterCurrentState(waterMeterId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns raw data for a water meter formatted for a graph display
         * @summary Get graph data for a water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {number} [nDays] return only this many days worth of data. Default &#x3D; 2 usually
         * @param {string} [offset] Go back X days
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterMeterGraphData(waterMeterId: number, nDays?: number, offset?: string, options?: any): AxiosPromise<WaterMeterGraphDataInData> {
            return WaterMetersApiFp(configuration).getWaterMeterGraphData(waterMeterId, nDays, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns data for all water meters
         * @summary Get water meters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterMeters(options?: any): AxiosPromise<WaterMeterInfosInData> {
            return WaterMetersApiFp(configuration).getWaterMeters(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Allocate transceiver and sensor(s) to a water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {TransceiverSensorInData} transceiverSensorInData Assign transceiver and sensor to a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installWaterMeter(waterMeterId: number, transceiverSensorInData: TransceiverSensorInData, options?: any): AxiosPromise<WaterMeterInfoInData> {
            return WaterMetersApiFp(configuration).installWaterMeter(waterMeterId, transceiverSensorInData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edit the properties of a water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {WaterEntityInputInData} waterEntityInputInData Edit the properties of a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        provisionWaterMeter(waterMeterId: number, waterEntityInputInData: WaterEntityInputInData, options?: any): AxiosPromise<WaterMeterInfoInData> {
            return WaterMetersApiFp(configuration).provisionWaterMeter(waterMeterId, waterEntityInputInData, options).then((request) => request(axios, basePath));
        },
        /**
         * Confirm that a water meter flow rate sensor is configured correctly
         * @summary Sign-off a water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signoffWaterMeter(waterMeterId: number, options?: any): AxiosPromise<void> {
            return WaterMetersApiFp(configuration).signoffWaterMeter(waterMeterId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a water meter
         * @param {number} waterMeterId ID of a water meter
         * @param {WaterMeterInfoInData} waterMeterInfoInData Water meter to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWaterMeter(waterMeterId: number, waterMeterInfoInData: WaterMeterInfoInData, options?: any): AxiosPromise<void> {
            return WaterMetersApiFp(configuration).updateWaterMeter(waterMeterId, waterMeterInfoInData, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WaterMetersApi - object-oriented interface
 * @export
 * @class WaterMetersApi
 * @extends {BaseAPI}
 */
export class WaterMetersApi extends BaseAPI {
    /**
     * Add a water meter to a water product
     * @summary Add a water meter
     * @param {WaterMeterInfoInData} waterMeterInfoInData Water meter to be added to a water product
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterMetersApi
     */
    public addWaterMeter(waterMeterInfoInData: WaterMeterInfoInData, options?: any) {
        return WaterMetersApiFp(this.configuration).addWaterMeter(waterMeterInfoInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Applies a totalizer correction to the water meter
     * @summary Apply totalizer correction
     * @param {number} waterMeterId ID of a water meter
     * @param {WaterTotalizerCorrection} waterTotalizerCorrection 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterMetersApi
     */
    public applyMeterTotalizerCorrection(waterMeterId: number, waterTotalizerCorrection: WaterTotalizerCorrection, options?: any) {
        return WaterMetersApiFp(this.configuration).applyMeterTotalizerCorrection(waterMeterId, waterTotalizerCorrection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Assign a water meter flow rate sensor with a water meter
     * @summary Assign a water meter sensor
     * @param {number} waterMeterId ID of a water meter
     * @param {WaterMeterSensorsAssignInData} waterMeterSensorsAssignInData Water meter sensor to assign to a water meter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterMetersApi
     */
    public assignWaterMeterSensors(waterMeterId: number, waterMeterSensorsAssignInData: WaterMeterSensorsAssignInData, options?: any) {
        return WaterMetersApiFp(this.configuration).assignWaterMeterSensors(waterMeterId, waterMeterSensorsAssignInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cancel a pending water meter install
     * @summary Cancel a water meter install
     * @param {number} waterMeterId ID of a water meter
     * @param {CancelEntity} [cancelEntity] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterMetersApi
     */
    public cancelWaterMeter(waterMeterId: number, cancelEntity?: CancelEntity, options?: any) {
        return WaterMetersApiFp(this.configuration).cancelWaterMeter(waterMeterId, cancelEntity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Confirm a draft water meter
     * @summary Confirm a draft water meter, move to pending status
     * @param {number} waterMeterId ID of a water meter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterMetersApi
     */
    public confirmDraftWaterMeter(waterMeterId: number, options?: any) {
        return WaterMetersApiFp(this.configuration).confirmDraftWaterMeter(waterMeterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deactivate an existing water meter
     * @summary Deactivate a water meter
     * @param {number} waterMeterId ID of a water meter
     * @param {DeactivateEntity} [deactivateEntity] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterMetersApi
     */
    public deactivateWaterMeter(waterMeterId: number, deactivateEntity?: DeactivateEntity, options?: any) {
        return WaterMetersApiFp(this.configuration).deactivateWaterMeter(waterMeterId, deactivateEntity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a water meter
     * @param {number} waterMeterId ID of a water meter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterMetersApi
     */
    public deleteWaterMeter(waterMeterId: number, options?: any) {
        return WaterMetersApiFp(this.configuration).deleteWaterMeter(waterMeterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the latest totalizer corrections
     * @summary Get the latest totalizer corrections
     * @param {number} waterMeterId ID of a water meter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterMetersApi
     */
    public getMeterTotalizerCorrections(waterMeterId: number, options?: any) {
        return WaterMetersApiFp(this.configuration).getMeterTotalizerCorrections(waterMeterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the totalizer readings for the water meter over a time period
     * @summary Get the totalizer readings for the water meter
     * @param {number} waterMeterId ID of a water meter
     * @param {number} startTs Start epoch timestamp to consider
     * @param {number} endTs End epoch timestamp to consider
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterMetersApi
     */
    public getMeterTotalizerReadings(waterMeterId: number, startTs: number, endTs: number, options?: any) {
        return WaterMetersApiFp(this.configuration).getMeterTotalizerReadings(waterMeterId, startTs, endTs, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns data for a water meter by ID
     * @summary Get a water meter by ID
     * @param {number} waterMeterId ID of a water meter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterMetersApi
     */
    public getWaterMeterById(waterMeterId: number, options?: any) {
        return WaterMetersApiFp(this.configuration).getWaterMeterById(waterMeterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve the current state metrics for the water meter
     * @param {number} waterMeterId ID of a water meter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterMetersApi
     */
    public getWaterMeterCurrentState(waterMeterId: number, options?: any) {
        return WaterMetersApiFp(this.configuration).getWaterMeterCurrentState(waterMeterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns raw data for a water meter formatted for a graph display
     * @summary Get graph data for a water meter
     * @param {number} waterMeterId ID of a water meter
     * @param {number} [nDays] return only this many days worth of data. Default &#x3D; 2 usually
     * @param {string} [offset] Go back X days
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterMetersApi
     */
    public getWaterMeterGraphData(waterMeterId: number, nDays?: number, offset?: string, options?: any) {
        return WaterMetersApiFp(this.configuration).getWaterMeterGraphData(waterMeterId, nDays, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns data for all water meters
     * @summary Get water meters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterMetersApi
     */
    public getWaterMeters(options?: any) {
        return WaterMetersApiFp(this.configuration).getWaterMeters(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Allocate transceiver and sensor(s) to a water meter
     * @param {number} waterMeterId ID of a water meter
     * @param {TransceiverSensorInData} transceiverSensorInData Assign transceiver and sensor to a water meter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterMetersApi
     */
    public installWaterMeter(waterMeterId: number, transceiverSensorInData: TransceiverSensorInData, options?: any) {
        return WaterMetersApiFp(this.configuration).installWaterMeter(waterMeterId, transceiverSensorInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edit the properties of a water meter
     * @param {number} waterMeterId ID of a water meter
     * @param {WaterEntityInputInData} waterEntityInputInData Edit the properties of a water meter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterMetersApi
     */
    public provisionWaterMeter(waterMeterId: number, waterEntityInputInData: WaterEntityInputInData, options?: any) {
        return WaterMetersApiFp(this.configuration).provisionWaterMeter(waterMeterId, waterEntityInputInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Confirm that a water meter flow rate sensor is configured correctly
     * @summary Sign-off a water meter
     * @param {number} waterMeterId ID of a water meter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterMetersApi
     */
    public signoffWaterMeter(waterMeterId: number, options?: any) {
        return WaterMetersApiFp(this.configuration).signoffWaterMeter(waterMeterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a water meter
     * @param {number} waterMeterId ID of a water meter
     * @param {WaterMeterInfoInData} waterMeterInfoInData Water meter to be updated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterMetersApi
     */
    public updateWaterMeter(waterMeterId: number, waterMeterInfoInData: WaterMeterInfoInData, options?: any) {
        return WaterMetersApiFp(this.configuration).updateWaterMeter(waterMeterId, waterMeterInfoInData, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * WaterMonitorsApi - axios parameter creator
 * @export
 */
export const WaterMonitorsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a water monitor to a water product
         * @summary Add a water monitor
         * @param {WaterMonitorInfoInData} waterMonitorInfoInData Water monitor to be added to a water product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addWaterMonitor: async (waterMonitorInfoInData: WaterMonitorInfoInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMonitorInfoInData' is not null or undefined
            if (waterMonitorInfoInData === null || waterMonitorInfoInData === undefined) {
                throw new RequiredError('waterMonitorInfoInData','Required parameter waterMonitorInfoInData was null or undefined when calling addWaterMonitor.');
            }
            const localVarPath = `/water/monitors`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof waterMonitorInfoInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(waterMonitorInfoInData !== undefined ? waterMonitorInfoInData : {}) : (waterMonitorInfoInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Applies a totalizer correction to the water monitor
         * @summary Apply totalizer correction
         * @param {number} waterMonitorId ID of a water monitor
         * @param {WaterTotalizerCorrection} waterTotalizerCorrection 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyMonitorTotalizerCorrection: async (waterMonitorId: number, waterTotalizerCorrection: WaterTotalizerCorrection, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMonitorId' is not null or undefined
            if (waterMonitorId === null || waterMonitorId === undefined) {
                throw new RequiredError('waterMonitorId','Required parameter waterMonitorId was null or undefined when calling applyMonitorTotalizerCorrection.');
            }
            // verify required parameter 'waterTotalizerCorrection' is not null or undefined
            if (waterTotalizerCorrection === null || waterTotalizerCorrection === undefined) {
                throw new RequiredError('waterTotalizerCorrection','Required parameter waterTotalizerCorrection was null or undefined when calling applyMonitorTotalizerCorrection.');
            }
            const localVarPath = `/water/monitors/{waterMonitorId}/applyCorrection`
                .replace(`{${"waterMonitorId"}}`, encodeURIComponent(String(waterMonitorId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof waterTotalizerCorrection !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(waterTotalizerCorrection !== undefined ? waterTotalizerCorrection : {}) : (waterTotalizerCorrection || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Assign a water monitor flow rate sensor with a water monitor
         * @summary Assign a water monitor sensor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {WaterMonitorSensorsAssignInData} waterMonitorSensorsAssignInData Water monitor sensor to assign to a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignWaterMonitorSensors: async (waterMonitorId: number, waterMonitorSensorsAssignInData: WaterMonitorSensorsAssignInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMonitorId' is not null or undefined
            if (waterMonitorId === null || waterMonitorId === undefined) {
                throw new RequiredError('waterMonitorId','Required parameter waterMonitorId was null or undefined when calling assignWaterMonitorSensors.');
            }
            // verify required parameter 'waterMonitorSensorsAssignInData' is not null or undefined
            if (waterMonitorSensorsAssignInData === null || waterMonitorSensorsAssignInData === undefined) {
                throw new RequiredError('waterMonitorSensorsAssignInData','Required parameter waterMonitorSensorsAssignInData was null or undefined when calling assignWaterMonitorSensors.');
            }
            const localVarPath = `/water/monitors/{waterMonitorId}/assign`
                .replace(`{${"waterMonitorId"}}`, encodeURIComponent(String(waterMonitorId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof waterMonitorSensorsAssignInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(waterMonitorSensorsAssignInData !== undefined ? waterMonitorSensorsAssignInData : {}) : (waterMonitorSensorsAssignInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cancel a pending water monitor install
         * @summary Cancel a water monitor install
         * @param {number} waterMonitorId ID of a water monitor
         * @param {CancelEntity} [cancelEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelWaterMonitor: async (waterMonitorId: number, cancelEntity?: CancelEntity, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMonitorId' is not null or undefined
            if (waterMonitorId === null || waterMonitorId === undefined) {
                throw new RequiredError('waterMonitorId','Required parameter waterMonitorId was null or undefined when calling cancelWaterMonitor.');
            }
            const localVarPath = `/water/monitors/{waterMonitorId}/cancel`
                .replace(`{${"waterMonitorId"}}`, encodeURIComponent(String(waterMonitorId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof cancelEntity !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(cancelEntity !== undefined ? cancelEntity : {}) : (cancelEntity || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Confirm a draft water monitor
         * @summary Confirm a draft water monitor, move to pending status
         * @param {number} waterMonitorId ID of a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmDraftWaterMonitor: async (waterMonitorId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMonitorId' is not null or undefined
            if (waterMonitorId === null || waterMonitorId === undefined) {
                throw new RequiredError('waterMonitorId','Required parameter waterMonitorId was null or undefined when calling confirmDraftWaterMonitor.');
            }
            const localVarPath = `/water/monitors/{waterMonitorId}/confirmDraft`
                .replace(`{${"waterMonitorId"}}`, encodeURIComponent(String(waterMonitorId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deactivate an existing water monitor
         * @summary Deactivate a water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {DeactivateEntity} [deactivateEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateWaterMonitor: async (waterMonitorId: number, deactivateEntity?: DeactivateEntity, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMonitorId' is not null or undefined
            if (waterMonitorId === null || waterMonitorId === undefined) {
                throw new RequiredError('waterMonitorId','Required parameter waterMonitorId was null or undefined when calling deactivateWaterMonitor.');
            }
            const localVarPath = `/water/monitors/{waterMonitorId}/deactivate`
                .replace(`{${"waterMonitorId"}}`, encodeURIComponent(String(waterMonitorId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof deactivateEntity !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(deactivateEntity !== undefined ? deactivateEntity : {}) : (deactivateEntity || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWaterMonitor: async (waterMonitorId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMonitorId' is not null or undefined
            if (waterMonitorId === null || waterMonitorId === undefined) {
                throw new RequiredError('waterMonitorId','Required parameter waterMonitorId was null or undefined when calling deleteWaterMonitor.');
            }
            const localVarPath = `/water/monitors/{waterMonitorId}`
                .replace(`{${"waterMonitorId"}}`, encodeURIComponent(String(waterMonitorId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the latest totalizer corrections
         * @summary Get the latest totalizer corrections
         * @param {number} waterMonitorId ID of a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMonitorTotalizerCorrections: async (waterMonitorId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMonitorId' is not null or undefined
            if (waterMonitorId === null || waterMonitorId === undefined) {
                throw new RequiredError('waterMonitorId','Required parameter waterMonitorId was null or undefined when calling getMonitorTotalizerCorrections.');
            }
            const localVarPath = `/water/monitors/{waterMonitorId}/totalizerCorrections`
                .replace(`{${"waterMonitorId"}}`, encodeURIComponent(String(waterMonitorId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the totalizer readings for the water monitor over a time period
         * @summary Get the totalizer readings for the water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {number} startTs Start epoch timestamp to consider
         * @param {number} endTs End epoch timestamp to consider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMonitorTotalizerReadings: async (waterMonitorId: number, startTs: number, endTs: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMonitorId' is not null or undefined
            if (waterMonitorId === null || waterMonitorId === undefined) {
                throw new RequiredError('waterMonitorId','Required parameter waterMonitorId was null or undefined when calling getMonitorTotalizerReadings.');
            }
            // verify required parameter 'startTs' is not null or undefined
            if (startTs === null || startTs === undefined) {
                throw new RequiredError('startTs','Required parameter startTs was null or undefined when calling getMonitorTotalizerReadings.');
            }
            // verify required parameter 'endTs' is not null or undefined
            if (endTs === null || endTs === undefined) {
                throw new RequiredError('endTs','Required parameter endTs was null or undefined when calling getMonitorTotalizerReadings.');
            }
            const localVarPath = `/water/monitors/{waterMonitorId}/totalizerReadings`
                .replace(`{${"waterMonitorId"}}`, encodeURIComponent(String(waterMonitorId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (startTs !== undefined) {
                localVarQueryParameter['startTs'] = startTs;
            }

            if (endTs !== undefined) {
                localVarQueryParameter['endTs'] = endTs;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns data for a water monitor by ID
         * @summary Get a water monitor by ID
         * @param {number} waterMonitorId ID of a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterMonitorById: async (waterMonitorId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMonitorId' is not null or undefined
            if (waterMonitorId === null || waterMonitorId === undefined) {
                throw new RequiredError('waterMonitorId','Required parameter waterMonitorId was null or undefined when calling getWaterMonitorById.');
            }
            const localVarPath = `/water/monitors/{waterMonitorId}`
                .replace(`{${"waterMonitorId"}}`, encodeURIComponent(String(waterMonitorId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve the current state metrics for the water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterMonitorCurrentState: async (waterMonitorId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMonitorId' is not null or undefined
            if (waterMonitorId === null || waterMonitorId === undefined) {
                throw new RequiredError('waterMonitorId','Required parameter waterMonitorId was null or undefined when calling getWaterMonitorCurrentState.');
            }
            const localVarPath = `/water/monitors/{waterMonitorId}/currentState`
                .replace(`{${"waterMonitorId"}}`, encodeURIComponent(String(waterMonitorId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns raw data for a water monitor formatted for a graph display
         * @summary Get graph data for a water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {number} [nDays] return only this many days worth of data. Default &#x3D; 2 usually
         * @param {string} [offset] Go back X days
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterMonitorGraphData: async (waterMonitorId: number, nDays?: number, offset?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMonitorId' is not null or undefined
            if (waterMonitorId === null || waterMonitorId === undefined) {
                throw new RequiredError('waterMonitorId','Required parameter waterMonitorId was null or undefined when calling getWaterMonitorGraphData.');
            }
            const localVarPath = `/water/monitors/{waterMonitorId}/graphData`
                .replace(`{${"waterMonitorId"}}`, encodeURIComponent(String(waterMonitorId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (nDays !== undefined) {
                localVarQueryParameter['nDays'] = nDays;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns data for all water monitors
         * @summary Get water monitors
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterMonitors: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/water/monitors`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Allocate transceiver and sensor(s) to a water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {TransceiverSensorInData} transceiverSensorInData Assign transceiver and sensor to a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installWaterMonitor: async (waterMonitorId: number, transceiverSensorInData: TransceiverSensorInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMonitorId' is not null or undefined
            if (waterMonitorId === null || waterMonitorId === undefined) {
                throw new RequiredError('waterMonitorId','Required parameter waterMonitorId was null or undefined when calling installWaterMonitor.');
            }
            // verify required parameter 'transceiverSensorInData' is not null or undefined
            if (transceiverSensorInData === null || transceiverSensorInData === undefined) {
                throw new RequiredError('transceiverSensorInData','Required parameter transceiverSensorInData was null or undefined when calling installWaterMonitor.');
            }
            const localVarPath = `/water/monitors/{waterMonitorId}/install`
                .replace(`{${"waterMonitorId"}}`, encodeURIComponent(String(waterMonitorId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof transceiverSensorInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(transceiverSensorInData !== undefined ? transceiverSensorInData : {}) : (transceiverSensorInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Edit the properties of a water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {WaterEntityInputInData} waterEntityInputInData Edit the properties of a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        provisionWaterMonitor: async (waterMonitorId: number, waterEntityInputInData: WaterEntityInputInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMonitorId' is not null or undefined
            if (waterMonitorId === null || waterMonitorId === undefined) {
                throw new RequiredError('waterMonitorId','Required parameter waterMonitorId was null or undefined when calling provisionWaterMonitor.');
            }
            // verify required parameter 'waterEntityInputInData' is not null or undefined
            if (waterEntityInputInData === null || waterEntityInputInData === undefined) {
                throw new RequiredError('waterEntityInputInData','Required parameter waterEntityInputInData was null or undefined when calling provisionWaterMonitor.');
            }
            const localVarPath = `/water/monitors/{waterMonitorId}/provision`
                .replace(`{${"waterMonitorId"}}`, encodeURIComponent(String(waterMonitorId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof waterEntityInputInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(waterEntityInputInData !== undefined ? waterEntityInputInData : {}) : (waterEntityInputInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set a water monitor as the main farm monitor
         * @summary Set the main water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {WaterMonitorInfoInData} waterMonitorInfoInData Water monitor to set as the main farm monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setMainWaterMonitor: async (waterMonitorId: number, waterMonitorInfoInData: WaterMonitorInfoInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMonitorId' is not null or undefined
            if (waterMonitorId === null || waterMonitorId === undefined) {
                throw new RequiredError('waterMonitorId','Required parameter waterMonitorId was null or undefined when calling setMainWaterMonitor.');
            }
            // verify required parameter 'waterMonitorInfoInData' is not null or undefined
            if (waterMonitorInfoInData === null || waterMonitorInfoInData === undefined) {
                throw new RequiredError('waterMonitorInfoInData','Required parameter waterMonitorInfoInData was null or undefined when calling setMainWaterMonitor.');
            }
            const localVarPath = `/water/monitors/{waterMonitorId}/set-main`
                .replace(`{${"waterMonitorId"}}`, encodeURIComponent(String(waterMonitorId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof waterMonitorInfoInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(waterMonitorInfoInData !== undefined ? waterMonitorInfoInData : {}) : (waterMonitorInfoInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Confirm that a water monitor flow rate sensor is configured correctly
         * @summary Sign-off a water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signoffWaterMonitor: async (waterMonitorId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMonitorId' is not null or undefined
            if (waterMonitorId === null || waterMonitorId === undefined) {
                throw new RequiredError('waterMonitorId','Required parameter waterMonitorId was null or undefined when calling signoffWaterMonitor.');
            }
            const localVarPath = `/water/monitors/{waterMonitorId}/sign-off`
                .replace(`{${"waterMonitorId"}}`, encodeURIComponent(String(waterMonitorId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {WaterMonitorInfoInData} waterMonitorInfoInData Water monitor to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWaterMonitor: async (waterMonitorId: number, waterMonitorInfoInData: WaterMonitorInfoInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterMonitorId' is not null or undefined
            if (waterMonitorId === null || waterMonitorId === undefined) {
                throw new RequiredError('waterMonitorId','Required parameter waterMonitorId was null or undefined when calling updateWaterMonitor.');
            }
            // verify required parameter 'waterMonitorInfoInData' is not null or undefined
            if (waterMonitorInfoInData === null || waterMonitorInfoInData === undefined) {
                throw new RequiredError('waterMonitorInfoInData','Required parameter waterMonitorInfoInData was null or undefined when calling updateWaterMonitor.');
            }
            const localVarPath = `/water/monitors/{waterMonitorId}`
                .replace(`{${"waterMonitorId"}}`, encodeURIComponent(String(waterMonitorId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof waterMonitorInfoInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(waterMonitorInfoInData !== undefined ? waterMonitorInfoInData : {}) : (waterMonitorInfoInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WaterMonitorsApi - functional programming interface
 * @export
 */
export const WaterMonitorsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Add a water monitor to a water product
         * @summary Add a water monitor
         * @param {WaterMonitorInfoInData} waterMonitorInfoInData Water monitor to be added to a water product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addWaterMonitor(waterMonitorInfoInData: WaterMonitorInfoInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await WaterMonitorsApiAxiosParamCreator(configuration).addWaterMonitor(waterMonitorInfoInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Applies a totalizer correction to the water monitor
         * @summary Apply totalizer correction
         * @param {number} waterMonitorId ID of a water monitor
         * @param {WaterTotalizerCorrection} waterTotalizerCorrection 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applyMonitorTotalizerCorrection(waterMonitorId: number, waterTotalizerCorrection: WaterTotalizerCorrection, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await WaterMonitorsApiAxiosParamCreator(configuration).applyMonitorTotalizerCorrection(waterMonitorId, waterTotalizerCorrection, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Assign a water monitor flow rate sensor with a water monitor
         * @summary Assign a water monitor sensor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {WaterMonitorSensorsAssignInData} waterMonitorSensorsAssignInData Water monitor sensor to assign to a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignWaterMonitorSensors(waterMonitorId: number, waterMonitorSensorsAssignInData: WaterMonitorSensorsAssignInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterMonitorInfoInData>> {
            const localVarAxiosArgs = await WaterMonitorsApiAxiosParamCreator(configuration).assignWaterMonitorSensors(waterMonitorId, waterMonitorSensorsAssignInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Cancel a pending water monitor install
         * @summary Cancel a water monitor install
         * @param {number} waterMonitorId ID of a water monitor
         * @param {CancelEntity} [cancelEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelWaterMonitor(waterMonitorId: number, cancelEntity?: CancelEntity, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await WaterMonitorsApiAxiosParamCreator(configuration).cancelWaterMonitor(waterMonitorId, cancelEntity, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Confirm a draft water monitor
         * @summary Confirm a draft water monitor, move to pending status
         * @param {number} waterMonitorId ID of a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmDraftWaterMonitor(waterMonitorId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterMonitor>> {
            const localVarAxiosArgs = await WaterMonitorsApiAxiosParamCreator(configuration).confirmDraftWaterMonitor(waterMonitorId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Deactivate an existing water monitor
         * @summary Deactivate a water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {DeactivateEntity} [deactivateEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deactivateWaterMonitor(waterMonitorId: number, deactivateEntity?: DeactivateEntity, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await WaterMonitorsApiAxiosParamCreator(configuration).deactivateWaterMonitor(waterMonitorId, deactivateEntity, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Delete a water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWaterMonitor(waterMonitorId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await WaterMonitorsApiAxiosParamCreator(configuration).deleteWaterMonitor(waterMonitorId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Retrieves the latest totalizer corrections
         * @summary Get the latest totalizer corrections
         * @param {number} waterMonitorId ID of a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMonitorTotalizerCorrections(waterMonitorId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WaterTotalizerCorrectionDynamoItem>>> {
            const localVarAxiosArgs = await WaterMonitorsApiAxiosParamCreator(configuration).getMonitorTotalizerCorrections(waterMonitorId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Retrieve the totalizer readings for the water monitor over a time period
         * @summary Get the totalizer readings for the water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {number} startTs Start epoch timestamp to consider
         * @param {number} endTs End epoch timestamp to consider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMonitorTotalizerReadings(waterMonitorId: number, startTs: number, endTs: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WaterTotalizerReadingDynamoItem>>> {
            const localVarAxiosArgs = await WaterMonitorsApiAxiosParamCreator(configuration).getMonitorTotalizerReadings(waterMonitorId, startTs, endTs, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns data for a water monitor by ID
         * @summary Get a water monitor by ID
         * @param {number} waterMonitorId ID of a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWaterMonitorById(waterMonitorId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterMonitorInfo>> {
            const localVarAxiosArgs = await WaterMonitorsApiAxiosParamCreator(configuration).getWaterMonitorById(waterMonitorId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Retrieve the current state metrics for the water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWaterMonitorCurrentState(waterMonitorId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2008>> {
            const localVarAxiosArgs = await WaterMonitorsApiAxiosParamCreator(configuration).getWaterMonitorCurrentState(waterMonitorId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns raw data for a water monitor formatted for a graph display
         * @summary Get graph data for a water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {number} [nDays] return only this many days worth of data. Default &#x3D; 2 usually
         * @param {string} [offset] Go back X days
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWaterMonitorGraphData(waterMonitorId: number, nDays?: number, offset?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterMonitorGraphDataInData>> {
            const localVarAxiosArgs = await WaterMonitorsApiAxiosParamCreator(configuration).getWaterMonitorGraphData(waterMonitorId, nDays, offset, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns data for all water monitors
         * @summary Get water monitors
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWaterMonitors(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterMonitorInfosInData>> {
            const localVarAxiosArgs = await WaterMonitorsApiAxiosParamCreator(configuration).getWaterMonitors(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Allocate transceiver and sensor(s) to a water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {TransceiverSensorInData} transceiverSensorInData Assign transceiver and sensor to a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async installWaterMonitor(waterMonitorId: number, transceiverSensorInData: TransceiverSensorInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterMonitorInfoInData>> {
            const localVarAxiosArgs = await WaterMonitorsApiAxiosParamCreator(configuration).installWaterMonitor(waterMonitorId, transceiverSensorInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Edit the properties of a water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {WaterEntityInputInData} waterEntityInputInData Edit the properties of a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async provisionWaterMonitor(waterMonitorId: number, waterEntityInputInData: WaterEntityInputInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterMonitorInfoInData>> {
            const localVarAxiosArgs = await WaterMonitorsApiAxiosParamCreator(configuration).provisionWaterMonitor(waterMonitorId, waterEntityInputInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Set a water monitor as the main farm monitor
         * @summary Set the main water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {WaterMonitorInfoInData} waterMonitorInfoInData Water monitor to set as the main farm monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setMainWaterMonitor(waterMonitorId: number, waterMonitorInfoInData: WaterMonitorInfoInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await WaterMonitorsApiAxiosParamCreator(configuration).setMainWaterMonitor(waterMonitorId, waterMonitorInfoInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Confirm that a water monitor flow rate sensor is configured correctly
         * @summary Sign-off a water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signoffWaterMonitor(waterMonitorId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await WaterMonitorsApiAxiosParamCreator(configuration).signoffWaterMonitor(waterMonitorId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update a water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {WaterMonitorInfoInData} waterMonitorInfoInData Water monitor to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWaterMonitor(waterMonitorId: number, waterMonitorInfoInData: WaterMonitorInfoInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await WaterMonitorsApiAxiosParamCreator(configuration).updateWaterMonitor(waterMonitorId, waterMonitorInfoInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * WaterMonitorsApi - factory interface
 * @export
 */
export const WaterMonitorsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Add a water monitor to a water product
         * @summary Add a water monitor
         * @param {WaterMonitorInfoInData} waterMonitorInfoInData Water monitor to be added to a water product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addWaterMonitor(waterMonitorInfoInData: WaterMonitorInfoInData, options?: any): AxiosPromise<void> {
            return WaterMonitorsApiFp(configuration).addWaterMonitor(waterMonitorInfoInData, options).then((request) => request(axios, basePath));
        },
        /**
         * Applies a totalizer correction to the water monitor
         * @summary Apply totalizer correction
         * @param {number} waterMonitorId ID of a water monitor
         * @param {WaterTotalizerCorrection} waterTotalizerCorrection 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyMonitorTotalizerCorrection(waterMonitorId: number, waterTotalizerCorrection: WaterTotalizerCorrection, options?: any): AxiosPromise<void> {
            return WaterMonitorsApiFp(configuration).applyMonitorTotalizerCorrection(waterMonitorId, waterTotalizerCorrection, options).then((request) => request(axios, basePath));
        },
        /**
         * Assign a water monitor flow rate sensor with a water monitor
         * @summary Assign a water monitor sensor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {WaterMonitorSensorsAssignInData} waterMonitorSensorsAssignInData Water monitor sensor to assign to a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignWaterMonitorSensors(waterMonitorId: number, waterMonitorSensorsAssignInData: WaterMonitorSensorsAssignInData, options?: any): AxiosPromise<WaterMonitorInfoInData> {
            return WaterMonitorsApiFp(configuration).assignWaterMonitorSensors(waterMonitorId, waterMonitorSensorsAssignInData, options).then((request) => request(axios, basePath));
        },
        /**
         * Cancel a pending water monitor install
         * @summary Cancel a water monitor install
         * @param {number} waterMonitorId ID of a water monitor
         * @param {CancelEntity} [cancelEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelWaterMonitor(waterMonitorId: number, cancelEntity?: CancelEntity, options?: any): AxiosPromise<void> {
            return WaterMonitorsApiFp(configuration).cancelWaterMonitor(waterMonitorId, cancelEntity, options).then((request) => request(axios, basePath));
        },
        /**
         * Confirm a draft water monitor
         * @summary Confirm a draft water monitor, move to pending status
         * @param {number} waterMonitorId ID of a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmDraftWaterMonitor(waterMonitorId: number, options?: any): AxiosPromise<WaterMonitor> {
            return WaterMonitorsApiFp(configuration).confirmDraftWaterMonitor(waterMonitorId, options).then((request) => request(axios, basePath));
        },
        /**
         * Deactivate an existing water monitor
         * @summary Deactivate a water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {DeactivateEntity} [deactivateEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateWaterMonitor(waterMonitorId: number, deactivateEntity?: DeactivateEntity, options?: any): AxiosPromise<void> {
            return WaterMonitorsApiFp(configuration).deactivateWaterMonitor(waterMonitorId, deactivateEntity, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWaterMonitor(waterMonitorId: number, options?: any): AxiosPromise<void> {
            return WaterMonitorsApiFp(configuration).deleteWaterMonitor(waterMonitorId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the latest totalizer corrections
         * @summary Get the latest totalizer corrections
         * @param {number} waterMonitorId ID of a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMonitorTotalizerCorrections(waterMonitorId: number, options?: any): AxiosPromise<Array<WaterTotalizerCorrectionDynamoItem>> {
            return WaterMonitorsApiFp(configuration).getMonitorTotalizerCorrections(waterMonitorId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the totalizer readings for the water monitor over a time period
         * @summary Get the totalizer readings for the water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {number} startTs Start epoch timestamp to consider
         * @param {number} endTs End epoch timestamp to consider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMonitorTotalizerReadings(waterMonitorId: number, startTs: number, endTs: number, options?: any): AxiosPromise<Array<WaterTotalizerReadingDynamoItem>> {
            return WaterMonitorsApiFp(configuration).getMonitorTotalizerReadings(waterMonitorId, startTs, endTs, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns data for a water monitor by ID
         * @summary Get a water monitor by ID
         * @param {number} waterMonitorId ID of a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterMonitorById(waterMonitorId: number, options?: any): AxiosPromise<WaterMonitorInfo> {
            return WaterMonitorsApiFp(configuration).getWaterMonitorById(waterMonitorId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve the current state metrics for the water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterMonitorCurrentState(waterMonitorId: number, options?: any): AxiosPromise<InlineResponse2008> {
            return WaterMonitorsApiFp(configuration).getWaterMonitorCurrentState(waterMonitorId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns raw data for a water monitor formatted for a graph display
         * @summary Get graph data for a water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {number} [nDays] return only this many days worth of data. Default &#x3D; 2 usually
         * @param {string} [offset] Go back X days
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterMonitorGraphData(waterMonitorId: number, nDays?: number, offset?: string, options?: any): AxiosPromise<WaterMonitorGraphDataInData> {
            return WaterMonitorsApiFp(configuration).getWaterMonitorGraphData(waterMonitorId, nDays, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns data for all water monitors
         * @summary Get water monitors
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterMonitors(options?: any): AxiosPromise<WaterMonitorInfosInData> {
            return WaterMonitorsApiFp(configuration).getWaterMonitors(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Allocate transceiver and sensor(s) to a water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {TransceiverSensorInData} transceiverSensorInData Assign transceiver and sensor to a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installWaterMonitor(waterMonitorId: number, transceiverSensorInData: TransceiverSensorInData, options?: any): AxiosPromise<WaterMonitorInfoInData> {
            return WaterMonitorsApiFp(configuration).installWaterMonitor(waterMonitorId, transceiverSensorInData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edit the properties of a water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {WaterEntityInputInData} waterEntityInputInData Edit the properties of a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        provisionWaterMonitor(waterMonitorId: number, waterEntityInputInData: WaterEntityInputInData, options?: any): AxiosPromise<WaterMonitorInfoInData> {
            return WaterMonitorsApiFp(configuration).provisionWaterMonitor(waterMonitorId, waterEntityInputInData, options).then((request) => request(axios, basePath));
        },
        /**
         * Set a water monitor as the main farm monitor
         * @summary Set the main water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {WaterMonitorInfoInData} waterMonitorInfoInData Water monitor to set as the main farm monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setMainWaterMonitor(waterMonitorId: number, waterMonitorInfoInData: WaterMonitorInfoInData, options?: any): AxiosPromise<void> {
            return WaterMonitorsApiFp(configuration).setMainWaterMonitor(waterMonitorId, waterMonitorInfoInData, options).then((request) => request(axios, basePath));
        },
        /**
         * Confirm that a water monitor flow rate sensor is configured correctly
         * @summary Sign-off a water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signoffWaterMonitor(waterMonitorId: number, options?: any): AxiosPromise<void> {
            return WaterMonitorsApiFp(configuration).signoffWaterMonitor(waterMonitorId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a water monitor
         * @param {number} waterMonitorId ID of a water monitor
         * @param {WaterMonitorInfoInData} waterMonitorInfoInData Water monitor to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWaterMonitor(waterMonitorId: number, waterMonitorInfoInData: WaterMonitorInfoInData, options?: any): AxiosPromise<void> {
            return WaterMonitorsApiFp(configuration).updateWaterMonitor(waterMonitorId, waterMonitorInfoInData, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WaterMonitorsApi - object-oriented interface
 * @export
 * @class WaterMonitorsApi
 * @extends {BaseAPI}
 */
export class WaterMonitorsApi extends BaseAPI {
    /**
     * Add a water monitor to a water product
     * @summary Add a water monitor
     * @param {WaterMonitorInfoInData} waterMonitorInfoInData Water monitor to be added to a water product
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterMonitorsApi
     */
    public addWaterMonitor(waterMonitorInfoInData: WaterMonitorInfoInData, options?: any) {
        return WaterMonitorsApiFp(this.configuration).addWaterMonitor(waterMonitorInfoInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Applies a totalizer correction to the water monitor
     * @summary Apply totalizer correction
     * @param {number} waterMonitorId ID of a water monitor
     * @param {WaterTotalizerCorrection} waterTotalizerCorrection 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterMonitorsApi
     */
    public applyMonitorTotalizerCorrection(waterMonitorId: number, waterTotalizerCorrection: WaterTotalizerCorrection, options?: any) {
        return WaterMonitorsApiFp(this.configuration).applyMonitorTotalizerCorrection(waterMonitorId, waterTotalizerCorrection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Assign a water monitor flow rate sensor with a water monitor
     * @summary Assign a water monitor sensor
     * @param {number} waterMonitorId ID of a water monitor
     * @param {WaterMonitorSensorsAssignInData} waterMonitorSensorsAssignInData Water monitor sensor to assign to a water monitor
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterMonitorsApi
     */
    public assignWaterMonitorSensors(waterMonitorId: number, waterMonitorSensorsAssignInData: WaterMonitorSensorsAssignInData, options?: any) {
        return WaterMonitorsApiFp(this.configuration).assignWaterMonitorSensors(waterMonitorId, waterMonitorSensorsAssignInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cancel a pending water monitor install
     * @summary Cancel a water monitor install
     * @param {number} waterMonitorId ID of a water monitor
     * @param {CancelEntity} [cancelEntity] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterMonitorsApi
     */
    public cancelWaterMonitor(waterMonitorId: number, cancelEntity?: CancelEntity, options?: any) {
        return WaterMonitorsApiFp(this.configuration).cancelWaterMonitor(waterMonitorId, cancelEntity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Confirm a draft water monitor
     * @summary Confirm a draft water monitor, move to pending status
     * @param {number} waterMonitorId ID of a water monitor
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterMonitorsApi
     */
    public confirmDraftWaterMonitor(waterMonitorId: number, options?: any) {
        return WaterMonitorsApiFp(this.configuration).confirmDraftWaterMonitor(waterMonitorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deactivate an existing water monitor
     * @summary Deactivate a water monitor
     * @param {number} waterMonitorId ID of a water monitor
     * @param {DeactivateEntity} [deactivateEntity] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterMonitorsApi
     */
    public deactivateWaterMonitor(waterMonitorId: number, deactivateEntity?: DeactivateEntity, options?: any) {
        return WaterMonitorsApiFp(this.configuration).deactivateWaterMonitor(waterMonitorId, deactivateEntity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a water monitor
     * @param {number} waterMonitorId ID of a water monitor
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterMonitorsApi
     */
    public deleteWaterMonitor(waterMonitorId: number, options?: any) {
        return WaterMonitorsApiFp(this.configuration).deleteWaterMonitor(waterMonitorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the latest totalizer corrections
     * @summary Get the latest totalizer corrections
     * @param {number} waterMonitorId ID of a water monitor
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterMonitorsApi
     */
    public getMonitorTotalizerCorrections(waterMonitorId: number, options?: any) {
        return WaterMonitorsApiFp(this.configuration).getMonitorTotalizerCorrections(waterMonitorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the totalizer readings for the water monitor over a time period
     * @summary Get the totalizer readings for the water monitor
     * @param {number} waterMonitorId ID of a water monitor
     * @param {number} startTs Start epoch timestamp to consider
     * @param {number} endTs End epoch timestamp to consider
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterMonitorsApi
     */
    public getMonitorTotalizerReadings(waterMonitorId: number, startTs: number, endTs: number, options?: any) {
        return WaterMonitorsApiFp(this.configuration).getMonitorTotalizerReadings(waterMonitorId, startTs, endTs, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns data for a water monitor by ID
     * @summary Get a water monitor by ID
     * @param {number} waterMonitorId ID of a water monitor
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterMonitorsApi
     */
    public getWaterMonitorById(waterMonitorId: number, options?: any) {
        return WaterMonitorsApiFp(this.configuration).getWaterMonitorById(waterMonitorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve the current state metrics for the water monitor
     * @param {number} waterMonitorId ID of a water monitor
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterMonitorsApi
     */
    public getWaterMonitorCurrentState(waterMonitorId: number, options?: any) {
        return WaterMonitorsApiFp(this.configuration).getWaterMonitorCurrentState(waterMonitorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns raw data for a water monitor formatted for a graph display
     * @summary Get graph data for a water monitor
     * @param {number} waterMonitorId ID of a water monitor
     * @param {number} [nDays] return only this many days worth of data. Default &#x3D; 2 usually
     * @param {string} [offset] Go back X days
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterMonitorsApi
     */
    public getWaterMonitorGraphData(waterMonitorId: number, nDays?: number, offset?: string, options?: any) {
        return WaterMonitorsApiFp(this.configuration).getWaterMonitorGraphData(waterMonitorId, nDays, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns data for all water monitors
     * @summary Get water monitors
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterMonitorsApi
     */
    public getWaterMonitors(options?: any) {
        return WaterMonitorsApiFp(this.configuration).getWaterMonitors(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Allocate transceiver and sensor(s) to a water monitor
     * @param {number} waterMonitorId ID of a water monitor
     * @param {TransceiverSensorInData} transceiverSensorInData Assign transceiver and sensor to a water monitor
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterMonitorsApi
     */
    public installWaterMonitor(waterMonitorId: number, transceiverSensorInData: TransceiverSensorInData, options?: any) {
        return WaterMonitorsApiFp(this.configuration).installWaterMonitor(waterMonitorId, transceiverSensorInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edit the properties of a water monitor
     * @param {number} waterMonitorId ID of a water monitor
     * @param {WaterEntityInputInData} waterEntityInputInData Edit the properties of a water monitor
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterMonitorsApi
     */
    public provisionWaterMonitor(waterMonitorId: number, waterEntityInputInData: WaterEntityInputInData, options?: any) {
        return WaterMonitorsApiFp(this.configuration).provisionWaterMonitor(waterMonitorId, waterEntityInputInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set a water monitor as the main farm monitor
     * @summary Set the main water monitor
     * @param {number} waterMonitorId ID of a water monitor
     * @param {WaterMonitorInfoInData} waterMonitorInfoInData Water monitor to set as the main farm monitor
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterMonitorsApi
     */
    public setMainWaterMonitor(waterMonitorId: number, waterMonitorInfoInData: WaterMonitorInfoInData, options?: any) {
        return WaterMonitorsApiFp(this.configuration).setMainWaterMonitor(waterMonitorId, waterMonitorInfoInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Confirm that a water monitor flow rate sensor is configured correctly
     * @summary Sign-off a water monitor
     * @param {number} waterMonitorId ID of a water monitor
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterMonitorsApi
     */
    public signoffWaterMonitor(waterMonitorId: number, options?: any) {
        return WaterMonitorsApiFp(this.configuration).signoffWaterMonitor(waterMonitorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a water monitor
     * @param {number} waterMonitorId ID of a water monitor
     * @param {WaterMonitorInfoInData} waterMonitorInfoInData Water monitor to be updated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterMonitorsApi
     */
    public updateWaterMonitor(waterMonitorId: number, waterMonitorInfoInData: WaterMonitorInfoInData, options?: any) {
        return WaterMonitorsApiFp(this.configuration).updateWaterMonitor(waterMonitorId, waterMonitorInfoInData, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * WaterTanksApi - axios parameter creator
 * @export
 */
export const WaterTanksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a water tank to a water product
         * @summary Add a water tank
         * @param {WaterTankInfoInData} waterTankInfoInData Water tank to be added to a water product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addWaterTank: async (waterTankInfoInData: WaterTankInfoInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterTankInfoInData' is not null or undefined
            if (waterTankInfoInData === null || waterTankInfoInData === undefined) {
                throw new RequiredError('waterTankInfoInData','Required parameter waterTankInfoInData was null or undefined when calling addWaterTank.');
            }
            const localVarPath = `/water/tanks`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof waterTankInfoInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(waterTankInfoInData !== undefined ? waterTankInfoInData : {}) : (waterTankInfoInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Assign a water tank pressure sensor with a water tank
         * @summary Assign a water tank sensor
         * @param {number} waterTankId ID of a water tank
         * @param {WaterTankSensorsAssignInData} waterTankSensorsAssignInData Water tank sensor to assign to a water tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignWaterTankSensors: async (waterTankId: number, waterTankSensorsAssignInData: WaterTankSensorsAssignInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterTankId' is not null or undefined
            if (waterTankId === null || waterTankId === undefined) {
                throw new RequiredError('waterTankId','Required parameter waterTankId was null or undefined when calling assignWaterTankSensors.');
            }
            // verify required parameter 'waterTankSensorsAssignInData' is not null or undefined
            if (waterTankSensorsAssignInData === null || waterTankSensorsAssignInData === undefined) {
                throw new RequiredError('waterTankSensorsAssignInData','Required parameter waterTankSensorsAssignInData was null or undefined when calling assignWaterTankSensors.');
            }
            const localVarPath = `/water/tanks/{waterTankId}/assign`
                .replace(`{${"waterTankId"}}`, encodeURIComponent(String(waterTankId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof waterTankSensorsAssignInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(waterTankSensorsAssignInData !== undefined ? waterTankSensorsAssignInData : {}) : (waterTankSensorsAssignInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cancel a pending water tank install
         * @summary Cancel a water tank install
         * @param {number} waterTankId ID of a water tank
         * @param {CancelEntity} [cancelEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelWaterTank: async (waterTankId: number, cancelEntity?: CancelEntity, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterTankId' is not null or undefined
            if (waterTankId === null || waterTankId === undefined) {
                throw new RequiredError('waterTankId','Required parameter waterTankId was null or undefined when calling cancelWaterTank.');
            }
            const localVarPath = `/water/tanks/{waterTankId}/cancel`
                .replace(`{${"waterTankId"}}`, encodeURIComponent(String(waterTankId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof cancelEntity !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(cancelEntity !== undefined ? cancelEntity : {}) : (cancelEntity || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Confirm a draft water tank
         * @summary Confirm a draft water tank, move to pending status
         * @param {number} waterTankId ID of a water tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmDraftWaterTank: async (waterTankId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterTankId' is not null or undefined
            if (waterTankId === null || waterTankId === undefined) {
                throw new RequiredError('waterTankId','Required parameter waterTankId was null or undefined when calling confirmDraftWaterTank.');
            }
            const localVarPath = `/water/tanks/{waterTankId}/confirmDraft`
                .replace(`{${"waterTankId"}}`, encodeURIComponent(String(waterTankId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deactivate an existing water tank
         * @summary Deactivate a water tank
         * @param {number} waterTankId ID of a water tank
         * @param {DeactivateEntity} [deactivateEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateWaterTank: async (waterTankId: number, deactivateEntity?: DeactivateEntity, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterTankId' is not null or undefined
            if (waterTankId === null || waterTankId === undefined) {
                throw new RequiredError('waterTankId','Required parameter waterTankId was null or undefined when calling deactivateWaterTank.');
            }
            const localVarPath = `/water/tanks/{waterTankId}/deactivate`
                .replace(`{${"waterTankId"}}`, encodeURIComponent(String(waterTankId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof deactivateEntity !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(deactivateEntity !== undefined ? deactivateEntity : {}) : (deactivateEntity || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a water tank
         * @param {number} waterTankId ID of a water tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWaterTank: async (waterTankId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterTankId' is not null or undefined
            if (waterTankId === null || waterTankId === undefined) {
                throw new RequiredError('waterTankId','Required parameter waterTankId was null or undefined when calling deleteWaterTank.');
            }
            const localVarPath = `/water/tanks/{waterTankId}`
                .replace(`{${"waterTankId"}}`, encodeURIComponent(String(waterTankId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns data for a water tank by ID
         * @summary Get a water tank by ID
         * @param {number} waterTankId ID of a water tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterTankById: async (waterTankId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterTankId' is not null or undefined
            if (waterTankId === null || waterTankId === undefined) {
                throw new RequiredError('waterTankId','Required parameter waterTankId was null or undefined when calling getWaterTankById.');
            }
            const localVarPath = `/water/tanks/{waterTankId}`
                .replace(`{${"waterTankId"}}`, encodeURIComponent(String(waterTankId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve the current state metrics for the water tank
         * @param {number} waterTankId ID of a water tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterTankCurrentState: async (waterTankId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterTankId' is not null or undefined
            if (waterTankId === null || waterTankId === undefined) {
                throw new RequiredError('waterTankId','Required parameter waterTankId was null or undefined when calling getWaterTankCurrentState.');
            }
            const localVarPath = `/water/tanks/{waterTankId}/currentState`
                .replace(`{${"waterTankId"}}`, encodeURIComponent(String(waterTankId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns raw data for a water tank formatted for a graph display
         * @summary Get graph data for a water tank
         * @param {number} waterTankId ID of a water tank
         * @param {number} [nDays] return only this many days worth of data. Default &#x3D; 2 usually
         * @param {string} [offset] Go back X days
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterTankGraphData: async (waterTankId: number, nDays?: number, offset?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterTankId' is not null or undefined
            if (waterTankId === null || waterTankId === undefined) {
                throw new RequiredError('waterTankId','Required parameter waterTankId was null or undefined when calling getWaterTankGraphData.');
            }
            const localVarPath = `/water/tanks/{waterTankId}/graphData`
                .replace(`{${"waterTankId"}}`, encodeURIComponent(String(waterTankId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (nDays !== undefined) {
                localVarQueryParameter['nDays'] = nDays;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns data for all water tanks
         * @summary Get water tanks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterTanks: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/water/tanks`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Allocate transceiver and sensor(s) to a water tank
         * @param {number} waterTankId ID of a water tank
         * @param {TransceiverSensorInData} transceiverSensorInData Assign transceiver and sensor to a water tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installWaterTank: async (waterTankId: number, transceiverSensorInData: TransceiverSensorInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterTankId' is not null or undefined
            if (waterTankId === null || waterTankId === undefined) {
                throw new RequiredError('waterTankId','Required parameter waterTankId was null or undefined when calling installWaterTank.');
            }
            // verify required parameter 'transceiverSensorInData' is not null or undefined
            if (transceiverSensorInData === null || transceiverSensorInData === undefined) {
                throw new RequiredError('transceiverSensorInData','Required parameter transceiverSensorInData was null or undefined when calling installWaterTank.');
            }
            const localVarPath = `/water/tanks/{waterTankId}/install`
                .replace(`{${"waterTankId"}}`, encodeURIComponent(String(waterTankId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof transceiverSensorInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(transceiverSensorInData !== undefined ? transceiverSensorInData : {}) : (transceiverSensorInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Edit the properties of a water tank
         * @param {number} waterTankId ID of a water tank
         * @param {WaterEntityInputInData} waterEntityInputInData Edit the properties of a water tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        provisionWaterTank: async (waterTankId: number, waterEntityInputInData: WaterEntityInputInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterTankId' is not null or undefined
            if (waterTankId === null || waterTankId === undefined) {
                throw new RequiredError('waterTankId','Required parameter waterTankId was null or undefined when calling provisionWaterTank.');
            }
            // verify required parameter 'waterEntityInputInData' is not null or undefined
            if (waterEntityInputInData === null || waterEntityInputInData === undefined) {
                throw new RequiredError('waterEntityInputInData','Required parameter waterEntityInputInData was null or undefined when calling provisionWaterTank.');
            }
            const localVarPath = `/water/tanks/{waterTankId}/provision`
                .replace(`{${"waterTankId"}}`, encodeURIComponent(String(waterTankId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof waterEntityInputInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(waterEntityInputInData !== undefined ? waterEntityInputInData : {}) : (waterEntityInputInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Confirm that a water tank pressure sensor is configured correctly
         * @summary Sign-off a water tank
         * @param {number} waterTankId ID of a water tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signoffWaterTank: async (waterTankId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterTankId' is not null or undefined
            if (waterTankId === null || waterTankId === undefined) {
                throw new RequiredError('waterTankId','Required parameter waterTankId was null or undefined when calling signoffWaterTank.');
            }
            const localVarPath = `/water/tanks/{waterTankId}/sign-off`
                .replace(`{${"waterTankId"}}`, encodeURIComponent(String(waterTankId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a water tank
         * @param {number} waterTankId ID of a water tank
         * @param {WaterTankInfoInData} waterTankInfoInData Water tank to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWaterTank: async (waterTankId: number, waterTankInfoInData: WaterTankInfoInData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterTankId' is not null or undefined
            if (waterTankId === null || waterTankId === undefined) {
                throw new RequiredError('waterTankId','Required parameter waterTankId was null or undefined when calling updateWaterTank.');
            }
            // verify required parameter 'waterTankInfoInData' is not null or undefined
            if (waterTankInfoInData === null || waterTankInfoInData === undefined) {
                throw new RequiredError('waterTankInfoInData','Required parameter waterTankInfoInData was null or undefined when calling updateWaterTank.');
            }
            const localVarPath = `/water/tanks/{waterTankId}`
                .replace(`{${"waterTankId"}}`, encodeURIComponent(String(waterTankId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof waterTankInfoInData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(waterTankInfoInData !== undefined ? waterTankInfoInData : {}) : (waterTankInfoInData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WaterTanksApi - functional programming interface
 * @export
 */
export const WaterTanksApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Add a water tank to a water product
         * @summary Add a water tank
         * @param {WaterTankInfoInData} waterTankInfoInData Water tank to be added to a water product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addWaterTank(waterTankInfoInData: WaterTankInfoInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await WaterTanksApiAxiosParamCreator(configuration).addWaterTank(waterTankInfoInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Assign a water tank pressure sensor with a water tank
         * @summary Assign a water tank sensor
         * @param {number} waterTankId ID of a water tank
         * @param {WaterTankSensorsAssignInData} waterTankSensorsAssignInData Water tank sensor to assign to a water tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignWaterTankSensors(waterTankId: number, waterTankSensorsAssignInData: WaterTankSensorsAssignInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterTankInfoInData>> {
            const localVarAxiosArgs = await WaterTanksApiAxiosParamCreator(configuration).assignWaterTankSensors(waterTankId, waterTankSensorsAssignInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Cancel a pending water tank install
         * @summary Cancel a water tank install
         * @param {number} waterTankId ID of a water tank
         * @param {CancelEntity} [cancelEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelWaterTank(waterTankId: number, cancelEntity?: CancelEntity, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await WaterTanksApiAxiosParamCreator(configuration).cancelWaterTank(waterTankId, cancelEntity, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Confirm a draft water tank
         * @summary Confirm a draft water tank, move to pending status
         * @param {number} waterTankId ID of a water tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmDraftWaterTank(waterTankId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterTank>> {
            const localVarAxiosArgs = await WaterTanksApiAxiosParamCreator(configuration).confirmDraftWaterTank(waterTankId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Deactivate an existing water tank
         * @summary Deactivate a water tank
         * @param {number} waterTankId ID of a water tank
         * @param {DeactivateEntity} [deactivateEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deactivateWaterTank(waterTankId: number, deactivateEntity?: DeactivateEntity, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await WaterTanksApiAxiosParamCreator(configuration).deactivateWaterTank(waterTankId, deactivateEntity, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Delete a water tank
         * @param {number} waterTankId ID of a water tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWaterTank(waterTankId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await WaterTanksApiAxiosParamCreator(configuration).deleteWaterTank(waterTankId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns data for a water tank by ID
         * @summary Get a water tank by ID
         * @param {number} waterTankId ID of a water tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWaterTankById(waterTankId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterTankInfo>> {
            const localVarAxiosArgs = await WaterTanksApiAxiosParamCreator(configuration).getWaterTankById(waterTankId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Retrieve the current state metrics for the water tank
         * @param {number} waterTankId ID of a water tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWaterTankCurrentState(waterTankId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2008>> {
            const localVarAxiosArgs = await WaterTanksApiAxiosParamCreator(configuration).getWaterTankCurrentState(waterTankId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns raw data for a water tank formatted for a graph display
         * @summary Get graph data for a water tank
         * @param {number} waterTankId ID of a water tank
         * @param {number} [nDays] return only this many days worth of data. Default &#x3D; 2 usually
         * @param {string} [offset] Go back X days
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWaterTankGraphData(waterTankId: number, nDays?: number, offset?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterTankGraphDataInData>> {
            const localVarAxiosArgs = await WaterTanksApiAxiosParamCreator(configuration).getWaterTankGraphData(waterTankId, nDays, offset, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns data for all water tanks
         * @summary Get water tanks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWaterTanks(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterTankInfosInData>> {
            const localVarAxiosArgs = await WaterTanksApiAxiosParamCreator(configuration).getWaterTanks(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Allocate transceiver and sensor(s) to a water tank
         * @param {number} waterTankId ID of a water tank
         * @param {TransceiverSensorInData} transceiverSensorInData Assign transceiver and sensor to a water tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async installWaterTank(waterTankId: number, transceiverSensorInData: TransceiverSensorInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterTankInfoInData>> {
            const localVarAxiosArgs = await WaterTanksApiAxiosParamCreator(configuration).installWaterTank(waterTankId, transceiverSensorInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Edit the properties of a water tank
         * @param {number} waterTankId ID of a water tank
         * @param {WaterEntityInputInData} waterEntityInputInData Edit the properties of a water tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async provisionWaterTank(waterTankId: number, waterEntityInputInData: WaterEntityInputInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterTankInfoInData>> {
            const localVarAxiosArgs = await WaterTanksApiAxiosParamCreator(configuration).provisionWaterTank(waterTankId, waterEntityInputInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Confirm that a water tank pressure sensor is configured correctly
         * @summary Sign-off a water tank
         * @param {number} waterTankId ID of a water tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signoffWaterTank(waterTankId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await WaterTanksApiAxiosParamCreator(configuration).signoffWaterTank(waterTankId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update a water tank
         * @param {number} waterTankId ID of a water tank
         * @param {WaterTankInfoInData} waterTankInfoInData Water tank to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWaterTank(waterTankId: number, waterTankInfoInData: WaterTankInfoInData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await WaterTanksApiAxiosParamCreator(configuration).updateWaterTank(waterTankId, waterTankInfoInData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * WaterTanksApi - factory interface
 * @export
 */
export const WaterTanksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Add a water tank to a water product
         * @summary Add a water tank
         * @param {WaterTankInfoInData} waterTankInfoInData Water tank to be added to a water product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addWaterTank(waterTankInfoInData: WaterTankInfoInData, options?: any): AxiosPromise<void> {
            return WaterTanksApiFp(configuration).addWaterTank(waterTankInfoInData, options).then((request) => request(axios, basePath));
        },
        /**
         * Assign a water tank pressure sensor with a water tank
         * @summary Assign a water tank sensor
         * @param {number} waterTankId ID of a water tank
         * @param {WaterTankSensorsAssignInData} waterTankSensorsAssignInData Water tank sensor to assign to a water tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignWaterTankSensors(waterTankId: number, waterTankSensorsAssignInData: WaterTankSensorsAssignInData, options?: any): AxiosPromise<WaterTankInfoInData> {
            return WaterTanksApiFp(configuration).assignWaterTankSensors(waterTankId, waterTankSensorsAssignInData, options).then((request) => request(axios, basePath));
        },
        /**
         * Cancel a pending water tank install
         * @summary Cancel a water tank install
         * @param {number} waterTankId ID of a water tank
         * @param {CancelEntity} [cancelEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelWaterTank(waterTankId: number, cancelEntity?: CancelEntity, options?: any): AxiosPromise<void> {
            return WaterTanksApiFp(configuration).cancelWaterTank(waterTankId, cancelEntity, options).then((request) => request(axios, basePath));
        },
        /**
         * Confirm a draft water tank
         * @summary Confirm a draft water tank, move to pending status
         * @param {number} waterTankId ID of a water tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmDraftWaterTank(waterTankId: number, options?: any): AxiosPromise<WaterTank> {
            return WaterTanksApiFp(configuration).confirmDraftWaterTank(waterTankId, options).then((request) => request(axios, basePath));
        },
        /**
         * Deactivate an existing water tank
         * @summary Deactivate a water tank
         * @param {number} waterTankId ID of a water tank
         * @param {DeactivateEntity} [deactivateEntity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateWaterTank(waterTankId: number, deactivateEntity?: DeactivateEntity, options?: any): AxiosPromise<void> {
            return WaterTanksApiFp(configuration).deactivateWaterTank(waterTankId, deactivateEntity, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a water tank
         * @param {number} waterTankId ID of a water tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWaterTank(waterTankId: number, options?: any): AxiosPromise<void> {
            return WaterTanksApiFp(configuration).deleteWaterTank(waterTankId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns data for a water tank by ID
         * @summary Get a water tank by ID
         * @param {number} waterTankId ID of a water tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterTankById(waterTankId: number, options?: any): AxiosPromise<WaterTankInfo> {
            return WaterTanksApiFp(configuration).getWaterTankById(waterTankId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve the current state metrics for the water tank
         * @param {number} waterTankId ID of a water tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterTankCurrentState(waterTankId: number, options?: any): AxiosPromise<InlineResponse2008> {
            return WaterTanksApiFp(configuration).getWaterTankCurrentState(waterTankId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns raw data for a water tank formatted for a graph display
         * @summary Get graph data for a water tank
         * @param {number} waterTankId ID of a water tank
         * @param {number} [nDays] return only this many days worth of data. Default &#x3D; 2 usually
         * @param {string} [offset] Go back X days
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterTankGraphData(waterTankId: number, nDays?: number, offset?: string, options?: any): AxiosPromise<WaterTankGraphDataInData> {
            return WaterTanksApiFp(configuration).getWaterTankGraphData(waterTankId, nDays, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns data for all water tanks
         * @summary Get water tanks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterTanks(options?: any): AxiosPromise<WaterTankInfosInData> {
            return WaterTanksApiFp(configuration).getWaterTanks(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Allocate transceiver and sensor(s) to a water tank
         * @param {number} waterTankId ID of a water tank
         * @param {TransceiverSensorInData} transceiverSensorInData Assign transceiver and sensor to a water tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installWaterTank(waterTankId: number, transceiverSensorInData: TransceiverSensorInData, options?: any): AxiosPromise<WaterTankInfoInData> {
            return WaterTanksApiFp(configuration).installWaterTank(waterTankId, transceiverSensorInData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edit the properties of a water tank
         * @param {number} waterTankId ID of a water tank
         * @param {WaterEntityInputInData} waterEntityInputInData Edit the properties of a water tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        provisionWaterTank(waterTankId: number, waterEntityInputInData: WaterEntityInputInData, options?: any): AxiosPromise<WaterTankInfoInData> {
            return WaterTanksApiFp(configuration).provisionWaterTank(waterTankId, waterEntityInputInData, options).then((request) => request(axios, basePath));
        },
        /**
         * Confirm that a water tank pressure sensor is configured correctly
         * @summary Sign-off a water tank
         * @param {number} waterTankId ID of a water tank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signoffWaterTank(waterTankId: number, options?: any): AxiosPromise<void> {
            return WaterTanksApiFp(configuration).signoffWaterTank(waterTankId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a water tank
         * @param {number} waterTankId ID of a water tank
         * @param {WaterTankInfoInData} waterTankInfoInData Water tank to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWaterTank(waterTankId: number, waterTankInfoInData: WaterTankInfoInData, options?: any): AxiosPromise<void> {
            return WaterTanksApiFp(configuration).updateWaterTank(waterTankId, waterTankInfoInData, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WaterTanksApi - object-oriented interface
 * @export
 * @class WaterTanksApi
 * @extends {BaseAPI}
 */
export class WaterTanksApi extends BaseAPI {
    /**
     * Add a water tank to a water product
     * @summary Add a water tank
     * @param {WaterTankInfoInData} waterTankInfoInData Water tank to be added to a water product
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterTanksApi
     */
    public addWaterTank(waterTankInfoInData: WaterTankInfoInData, options?: any) {
        return WaterTanksApiFp(this.configuration).addWaterTank(waterTankInfoInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Assign a water tank pressure sensor with a water tank
     * @summary Assign a water tank sensor
     * @param {number} waterTankId ID of a water tank
     * @param {WaterTankSensorsAssignInData} waterTankSensorsAssignInData Water tank sensor to assign to a water tank
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterTanksApi
     */
    public assignWaterTankSensors(waterTankId: number, waterTankSensorsAssignInData: WaterTankSensorsAssignInData, options?: any) {
        return WaterTanksApiFp(this.configuration).assignWaterTankSensors(waterTankId, waterTankSensorsAssignInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cancel a pending water tank install
     * @summary Cancel a water tank install
     * @param {number} waterTankId ID of a water tank
     * @param {CancelEntity} [cancelEntity] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterTanksApi
     */
    public cancelWaterTank(waterTankId: number, cancelEntity?: CancelEntity, options?: any) {
        return WaterTanksApiFp(this.configuration).cancelWaterTank(waterTankId, cancelEntity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Confirm a draft water tank
     * @summary Confirm a draft water tank, move to pending status
     * @param {number} waterTankId ID of a water tank
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterTanksApi
     */
    public confirmDraftWaterTank(waterTankId: number, options?: any) {
        return WaterTanksApiFp(this.configuration).confirmDraftWaterTank(waterTankId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deactivate an existing water tank
     * @summary Deactivate a water tank
     * @param {number} waterTankId ID of a water tank
     * @param {DeactivateEntity} [deactivateEntity] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterTanksApi
     */
    public deactivateWaterTank(waterTankId: number, deactivateEntity?: DeactivateEntity, options?: any) {
        return WaterTanksApiFp(this.configuration).deactivateWaterTank(waterTankId, deactivateEntity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a water tank
     * @param {number} waterTankId ID of a water tank
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterTanksApi
     */
    public deleteWaterTank(waterTankId: number, options?: any) {
        return WaterTanksApiFp(this.configuration).deleteWaterTank(waterTankId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns data for a water tank by ID
     * @summary Get a water tank by ID
     * @param {number} waterTankId ID of a water tank
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterTanksApi
     */
    public getWaterTankById(waterTankId: number, options?: any) {
        return WaterTanksApiFp(this.configuration).getWaterTankById(waterTankId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve the current state metrics for the water tank
     * @param {number} waterTankId ID of a water tank
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterTanksApi
     */
    public getWaterTankCurrentState(waterTankId: number, options?: any) {
        return WaterTanksApiFp(this.configuration).getWaterTankCurrentState(waterTankId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns raw data for a water tank formatted for a graph display
     * @summary Get graph data for a water tank
     * @param {number} waterTankId ID of a water tank
     * @param {number} [nDays] return only this many days worth of data. Default &#x3D; 2 usually
     * @param {string} [offset] Go back X days
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterTanksApi
     */
    public getWaterTankGraphData(waterTankId: number, nDays?: number, offset?: string, options?: any) {
        return WaterTanksApiFp(this.configuration).getWaterTankGraphData(waterTankId, nDays, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns data for all water tanks
     * @summary Get water tanks
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterTanksApi
     */
    public getWaterTanks(options?: any) {
        return WaterTanksApiFp(this.configuration).getWaterTanks(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Allocate transceiver and sensor(s) to a water tank
     * @param {number} waterTankId ID of a water tank
     * @param {TransceiverSensorInData} transceiverSensorInData Assign transceiver and sensor to a water tank
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterTanksApi
     */
    public installWaterTank(waterTankId: number, transceiverSensorInData: TransceiverSensorInData, options?: any) {
        return WaterTanksApiFp(this.configuration).installWaterTank(waterTankId, transceiverSensorInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edit the properties of a water tank
     * @param {number} waterTankId ID of a water tank
     * @param {WaterEntityInputInData} waterEntityInputInData Edit the properties of a water tank
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterTanksApi
     */
    public provisionWaterTank(waterTankId: number, waterEntityInputInData: WaterEntityInputInData, options?: any) {
        return WaterTanksApiFp(this.configuration).provisionWaterTank(waterTankId, waterEntityInputInData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Confirm that a water tank pressure sensor is configured correctly
     * @summary Sign-off a water tank
     * @param {number} waterTankId ID of a water tank
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterTanksApi
     */
    public signoffWaterTank(waterTankId: number, options?: any) {
        return WaterTanksApiFp(this.configuration).signoffWaterTank(waterTankId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a water tank
     * @param {number} waterTankId ID of a water tank
     * @param {WaterTankInfoInData} waterTankInfoInData Water tank to be updated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterTanksApi
     */
    public updateWaterTank(waterTankId: number, waterTankInfoInData: WaterTankInfoInData, options?: any) {
        return WaterTanksApiFp(this.configuration).updateWaterTank(waterTankId, waterTankInfoInData, options).then((request) => request(this.axios, this.basePath));
    }

}


